// @ts-nocheck
/**
 * Generated by orval 🍺
 * Do not edit manually.
 * LUNA PLATFORM 5 API
 * VisionLabs Luna Platform 5 API. The API version is 6.

OpenAPI specification is the only valid document providing up-to-date information about the service API.

The specification can be used:

- By documentation generation tools to visualize the API.
- By code generation tools.

All the documents and code generated using this specification can include inaccuracies and should be carefully checked.

OpenAPI specification can be received using the [/docs/spec](#operation/getSpec) resource. The "Accept" header should be set to "application/x-yaml".

 * Version: v.7.8.0
 */import {
  useInfiniteQuery,
  useMutation,
  useQuery,
  useQueryClient
} from '@tanstack/react-query';
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseInfiniteQueryResult,
  DefinedUseQueryResult,
  InfiniteData,
  MutationFunction,
  MutationFunctionContext,
  QueryClient,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseInfiniteQueryOptions,
  UseInfiniteQueryResult,
  UseMutationOptions,
  UseMutationResult,
  UseQueryOptions,
  UseQueryResult
} from '@tanstack/react-query';

import type {
  AccountCreationResponse,
  AccountForPatch,
  AccountToCreate,
  AccountToReceive,
  AccountsIsDisabledResponse,
  AccountsToReceive,
  AgentNotFoundResponse,
  AgentToBeCreated,
  AgentsStreamsResponse,
  AnalyticNotFoundResponse,
  AnalyticResponse,
  AnalyticToBeCreated,
  AnalyticsToBeDeleted,
  AttributeId,
  AttributeSamples,
  AuthorizationErrorResponse,
  AuthorizationErrorWithoutBodyResponse,
  BodySample,
  CheckAttributeParams,
  CheckEventParams,
  CheckFaceParams,
  CheckISOParams,
  CheckImageInFolderParams,
  CheckImageParams,
  CheckIsoResponse,
  CheckLambdaParams,
  CheckObjectInFolderParams,
  CheckObjectParams,
  CheckStreamParams,
  ClusteringTask,
  ConfigVersionResponse,
  ConfigWithVersion,
  CopyFolderImageParams,
  CopyFolderObjectParams,
  CopyImagesFolderParams,
  CopyObjectsFolderParams,
  CountGroupsParams,
  CountStreams200,
  CountStreamsParams,
  CountVerifiersParams,
  CreateAnalytic201,
  CreateAttributes201,
  CreateAttributesParams,
  CreateClusteringTask202,
  CreateCrossMatchTask202,
  CreateEstimatorTask202,
  CreateExporterTask202,
  CreateFace201,
  CreateGCTask202,
  CreateGeneralEventsParams,
  CreateGroup,
  CreateGroupResponse,
  CreateHandler201,
  CreateImagesFolderParams,
  CreateImagesParams,
  CreateLambdaTask202,
  CreateLinkerTask202,
  CreateList201,
  CreateObjectsFolderParams,
  CreateObjectsParams,
  CreateROCTask202,
  CreateReporterTask202,
  CreateSchedule201,
  CreateStream201,
  CreateStreamParams,
  CreateTokenParams,
  CreateVerifier201,
  CreatedAttribute,
  CreatedAttributeBinary,
  CreatedAttributeXpk,
  CrossMatchTask,
  DeleteAnalyticsParams,
  DeleteFacesParams,
  DeleteGroupParams,
  DeleteImageInFolderParams,
  DeleteLambdaParams,
  DeleteListParams,
  DeleteListsParams,
  DeleteObjectInFolderParams,
  DeleteStreamsLogsParams,
  DeleteStreamsParams,
  DeleteTasksScheduleParams,
  DeletedLists,
  DetectFacesParams,
  DetectJsonRequestBody,
  DetectedImages,
  EmitEventJsonRequestBody,
  Error,
  ErrorCount,
  EstimatorTask,
  Event,
  EventList,
  ExporterTask,
  ExtractAttributesParams,
  ExtractedAttributes,
  FaceAttribute,
  FaceAttributeBinary,
  FaceNotFoundErrorResponse,
  FacesCount,
  FacesToBeDeleted,
  FolderInfo,
  FolderNotFoundResponse,
  FolderObject,
  FolderObjects,
  ForbiddenErrorResponse,
  ForbiddenErrorWithLisResponse,
  ForbiddenErrorWithServicesResponse,
  ForbiddenErrorWithoutBodyResponse,
  ForbiddenEventsErrorResponse,
  ForbiddenFacesErrorResponse,
  ForbiddenLambdaErrorResponse,
  ForbiddenLambdaErrorWithLicenseResponse,
  ForbiddenMatcherErrorResponse,
  ForbiddenMatcherServicesErrorResponse,
  ForbiddenResourceErrorResponse,
  ForbiddenServingServiceResponse,
  ForbiddenTasksErrorResponse,
  ForbiddenTasksErrorWithHandlersResponse,
  GcTask,
  GeneralEvent,
  GeneralEventInput,
  GeneralEvents,
  GenerateEventSuccessResponseResponse,
  GenerateEventsAccessErrorsResponse,
  GenerateEventsBadInputDataResponse,
  GenerateEventsParams,
  GetAccountParams,
  GetAccountsParams,
  GetAnalyticDocParams,
  GetAnalyticParams,
  GetAnalytics200,
  GetAnalyticsIntervalsIntervalsParams,
  GetAnalyticsIntervalsParams,
  GetAnalyticsParams,
  GetAttributeParams,
  GetAttributes200One,
  GetAttributes200Two,
  GetAttributesParams,
  GetConfig200One,
  GetErrorsParams,
  GetEventParams,
  GetEventStats,
  GetEventStats200,
  GetEventsParams,
  GetFaceAttributeCountParams,
  GetFaceAttributesParams,
  GetFaceParams,
  GetFaces,
  GetFacesCountParams,
  GetFacesParams,
  GetFeatures200,
  GetFolderImagesParams,
  GetFolderObjectsParams,
  GetGeneralEventDescriptors200,
  GetGeneralEventDescriptorsParams,
  GetGeneralEventStats,
  GetGeneralEventStats200,
  GetGeneralEventsParams,
  GetGroupOptionsParams,
  GetGroupParams,
  GetGroupStreamsOptionsParams,
  GetGroups200,
  GetGroupsParams,
  GetHandlerCountParams,
  GetHandlersParams,
  GetImageInFolderParams,
  GetImageParams,
  GetLambdaConfigParams,
  GetLambdaImage200,
  GetLambdaImageCreationLogsParams,
  GetLambdaImageStatusParams,
  GetLambdaLogsParams,
  GetLambdaMetricsParams,
  GetLambdaParams,
  GetLambdaSpecParams,
  GetLambdaStatusParams,
  GetLambdas200,
  GetLambdasParams,
  GetLists,
  GetListsCountParams,
  GetListsParams,
  GetObjectInFolderParams,
  GetObjectParams,
  GetScheduleTemplateIntervalsParams,
  GetScheduleTemplateParams,
  GetScheduleTemplatesParams,
  GetServicesParams,
  GetStreamParams,
  GetStreams200,
  GetStreamsLogsParams,
  GetStreamsParams,
  GetSubTasksParams,
  GetTaskErrorParams,
  GetTaskNotificationPolicyParams,
  GetTasksCountParams,
  GetTasksErrorsCountParams,
  GetTasksErrorsParams,
  GetTasksParams,
  GetTasksScheduleParams,
  GetTasksSchedulesParams,
  GetTokensParams,
  GetVerifiersParams,
  GetVersion200,
  GroupResponse,
  GroupsCount,
  HandlerInResponse,
  HandlerNotFoundResponse,
  HandlersCount,
  HandlersValidator,
  HealthErrors,
  HealthOk,
  HealthcheckParams,
  HealthcheckRedirectParams,
  HelpersRequest,
  ImageCreationStatus,
  ImageNotFoundResponse,
  ImagesCreationResponse,
  InternalServerErrorResponse,
  InternalServerErrorWithoutBodyResponse,
  IntervalsNestedResponse,
  IntervalsResponse,
  IsoJsonRequestBody,
  Lambda,
  LambdaAlreadyExistsByNameResponse,
  LambdaFailedImportMultipartResponse,
  LambdaIdResponse,
  LambdaImageLogs,
  LambdaImportJson,
  LambdaLogs,
  LambdaMetrics,
  LambdaMultipartContentArchiveFile,
  LambdaMultipartImport,
  LambdaNoArchiveResponse,
  LambdaNotFoundResponse,
  LambdaNotRunningResponse,
  LambdaOrPageNotFoundResponse,
  LambdaPatch,
  LambdaStatusResponse,
  LambdaSwitch,
  LambdaTask,
  LambdaValidationErrorResponse,
  LambdaVersionResponse,
  Link,
  Linker,
  LinkerTask,
  List,
  ListNotFoundResponse,
  ListsCount,
  LivenessResponse,
  MatchBodiesParams,
  MatchBodiesRequestJson,
  MatchBodiesRequestMsgpack,
  MatchBodiesResult,
  MatchFacesParams,
  MatchFacesRequestJson,
  MatchFacesRequestMsgpack,
  MatchGeneralEventResult,
  MatchGeneralEventsRequestJson,
  MatchGeneralEventsRequestMsgpack,
  MatchResult,
  MatcherRawRequestJson,
  MatcherRawRequestMsgpack,
  MatcherRawResult,
  MessageFromGeneralWs,
  MessageFromWs,
  MethodNotAllowedResponse,
  MultipartImageSchema,
  MultipartRawDataSchemaWithPolicies,
  MultipartSdkImageSchema,
  MultipartVerifierPayload,
  NewFace,
  NewFaceBinary,
  NewGeneralEvent,
  NewHandler,
  NewList,
  NewVerifier,
  NotificationPolicy,
  ObjectNotFoundResponse,
  ObjectsCreationResponse,
  OutputAttributeJson,
  OutputAttributeMsgpack,
  OutputFace,
  OutputFaceAttributeJson,
  OutputFaceAttributeMsgpack,
  PatchGroupParams,
  PatchGroupStreams200,
  PatchGroupStreamsParams,
  PatchStream200,
  PatchStreamParams,
  PatchTasksScheduleParams,
  PayloadToLargeResponse,
  Plugins,
  PostAgentStreamsParams,
  PostStreamsProcessingFeedbackRequest,
  PostVerifierParams,
  PredictLivenessBodyOne,
  PredictLivenessBodyTwo,
  PredictLivenessParams,
  ProxyLambdaOptionsParams,
  PutGroupParams,
  PutImagesInFolderParams,
  PutObjectInFolderParams,
  PutStream200,
  PutStreamParams,
  PutTasksSchedule200,
  PutTokenParams,
  PutVerifier200,
  RawEvent,
  RawVerificationRequestJson,
  RawVerificationRequestMsgpack,
  RawVerificationResponse,
  RegisterAgent201,
  RemoveAgentParams,
  RemoveGroupStreamsParams,
  ReplaceGroupResponse,
  ReporterTask,
  RequestTimeoutResponse,
  RequestTimeoutWithoutBodyResponse,
  ResponseTimeoutResponse,
  ResponseTimeoutWithoutBodyResponse,
  RestreamCreate,
  RetransmissionParams,
  RocTask,
  SampleIds,
  SaveEventParams,
  SaveSampleParams,
  SavedEvent,
  SchCreationResponse,
  SchTemplateResponse,
  SchTemplateResponseArray,
  SchTemplateToCreate,
  Schedule,
  ScheduleReply,
  ScheduleToReplace,
  SchedulesReply,
  SdkDescriptor,
  SdkJsonRequestBody,
  SdkParams,
  SdkResponseJson,
  SdkResponseMsgpack,
  ServerTimeoutErrorResponse,
  ServerTimeoutErrorWithoutBodyResponse,
  ServicesResponse,
  StreamCreationUnprocessableResponse,
  StreamEventRequestBody,
  StreamInfoRequired,
  StreamInvalidTargetsResponse,
  StreamMessageFromWs,
  StreamNoSuitableAgentResponse,
  StreamNotFoundResponse,
  StreamResponse,
  StreamToBeCreated,
  StreamsFeedbackResponse,
  StreamsGroupLinkerParams,
  StreamsLogs,
  StreamsLogsDeletedCount,
  StreamsToBeDeleted,
  SubTasks,
  TaskCount,
  TaskError,
  TaskErrors,
  TaskNotificationPolicyResponse,
  TaskReply,
  TaskResults,
  TasksReply,
  TokenCreationResponse,
  TokenToCreate,
  TokenToReceive,
  TokenWithAllPermissions,
  TokensToReceive,
  UpdateFace,
  UpdateGroup,
  UpdateList,
  UpdatedStreams,
  UserConfigRequest,
  Uuid,
  VerificationResponse,
  VerifierIdVerificationResponse,
  VerifierNotFoundResponse,
  VerifierPostData,
  VerifierResponse,
  VerifiersCount,
  VerifyJsonRequestBody,
  VideoAnalyticsParams,
  VideoAnalyticsResponse,
  VideoAnalyticsResponseMsgpack,
  VideoTaskResponse,
  WsHandshakeForGeneralEventsParams,
  WsHandshakeForStreamsParams,
  WsHandshakeParams,
  XpkFile
} from './model';

import { lp5AxiosClient } from '../axios/lp5-client';


type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1];



const withQueryKey = <T extends object, K>(query: T, queryKey: K): T & { queryKey: K } => {
  const result = { queryKey } as T & { queryKey: K };
  for (const key of Object.keys(query)) {
    // The explicit queryKey always wins, matching the previous
    // `{ ...query, queryKey }` spread where it was set last.
    if (key === 'queryKey') continue;
    Object.defineProperty(result, key, {
      enumerable: true,
      configurable: true,
      get: () => (query as Record<string, unknown>)[key],
    });
  }
  return result;
};

/**
 * Get versions of services.
 * @summary get version
 */
export const getVersion = (

 options?: SecondParameter<typeof lp5AxiosClient>,signal?: AbortSignal
) => {


      return lp5AxiosClient<GetVersion200>(
      {url: `/version`, method: 'GET', signal
    },
      options);
    }




export const getGetVersionQueryKey = () => {
    return [
    `/version`
    ] as const;
    }


export const getGetVersionQueryOptions = <TData = Awaited<ReturnType<typeof getVersion>>, TError = RequestTimeoutResponse | InternalServerErrorResponse | ResponseTimeoutResponse | ServerTimeoutErrorResponse>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getVersion>>, TError, TData>>, request?: SecondParameter<typeof lp5AxiosClient>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetVersionQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getVersion>>> = ({ signal }) => getVersion(requestOptions, signal);





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getVersion>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetVersionQueryResult = NonNullable<Awaited<ReturnType<typeof getVersion>>>
export type GetVersionQueryError = RequestTimeoutResponse | InternalServerErrorResponse | ResponseTimeoutResponse | ServerTimeoutErrorResponse


export function useGetVersion<TData = Awaited<ReturnType<typeof getVersion>>, TError = RequestTimeoutResponse | InternalServerErrorResponse | ResponseTimeoutResponse | ServerTimeoutErrorResponse>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getVersion>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getVersion>>,
          TError,
          Awaited<ReturnType<typeof getVersion>>
        > , 'initialData'
      >, request?: SecondParameter<typeof lp5AxiosClient>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetVersion<TData = Awaited<ReturnType<typeof getVersion>>, TError = RequestTimeoutResponse | InternalServerErrorResponse | ResponseTimeoutResponse | ServerTimeoutErrorResponse>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getVersion>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getVersion>>,
          TError,
          Awaited<ReturnType<typeof getVersion>>
        > , 'initialData'
      >, request?: SecondParameter<typeof lp5AxiosClient>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetVersion<TData = Awaited<ReturnType<typeof getVersion>>, TError = RequestTimeoutResponse | InternalServerErrorResponse | ResponseTimeoutResponse | ServerTimeoutErrorResponse>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getVersion>>, TError, TData>>, request?: SecondParameter<typeof lp5AxiosClient>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary get version
 */

export function useGetVersion<TData = Awaited<ReturnType<typeof getVersion>>, TError = RequestTimeoutResponse | InternalServerErrorResponse | ResponseTimeoutResponse | ServerTimeoutErrorResponse>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getVersion>>, TError, TData>>, request?: SecondParameter<typeof lp5AxiosClient>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetVersionQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}







/**
 * Get options for the resource.
 * @summary version options
 */
export const getVersionOptions = (

 options?: SecondParameter<typeof lp5AxiosClient>,signal?: AbortSignal
) => {


      return lp5AxiosClient<void>(
      {url: `/version`, method: 'OPTIONS', signal
    },
      options);
    }




export const getGetVersionOptionsMutationOptions = <TError = RequestTimeoutResponse | InternalServerErrorResponse | ResponseTimeoutResponse | ServerTimeoutErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof getVersionOptions>>, TError,void, TContext>, request?: SecondParameter<typeof lp5AxiosClient>}
): UseMutationOptions<Awaited<ReturnType<typeof getVersionOptions>>, TError,void, TContext> => {

const mutationKey = ['getVersionOptions'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof getVersionOptions>>, void> = () => {


          return  getVersionOptions(requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type GetVersionOptionsMutationResult = NonNullable<Awaited<ReturnType<typeof getVersionOptions>>>

    export type GetVersionOptionsMutationError = RequestTimeoutResponse | InternalServerErrorResponse | ResponseTimeoutResponse | ServerTimeoutErrorResponse

    /**
 * @summary version options
 */
export const useGetVersionOptions = <TError = RequestTimeoutResponse | InternalServerErrorResponse | ResponseTimeoutResponse | ServerTimeoutErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof getVersionOptions>>, TError,void, TContext>, request?: SecondParameter<typeof lp5AxiosClient>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof getVersionOptions>>,
        TError,
        void,
        TContext
      > => {
      return useMutation(getGetVersionOptionsMutationOptions(options), queryClient);
    }

/**
 * Get accounts.
 * @summary get accounts
 */
export const getAccounts = (
    params?: GetAccountsParams,
 options?: SecondParameter<typeof lp5AxiosClient>,signal?: AbortSignal
) => {


      return lp5AxiosClient<AccountsToReceive>(
      {url: `/6/accounts`, method: 'GET',
        params, signal
    },
      options);
    }




export const getGetAccountsQueryKey = (params?: GetAccountsParams,) => {
    return [
    `/6/accounts`, ...(params ? [params] : [])
    ] as const;
    }


export const getGetAccountsQueryOptions = <TData = Awaited<ReturnType<typeof getAccounts>>, TError = Error | RequestTimeoutResponse | InternalServerErrorResponse | ResponseTimeoutResponse | ServerTimeoutErrorResponse>(params?: GetAccountsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAccounts>>, TError, TData>>, request?: SecondParameter<typeof lp5AxiosClient>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetAccountsQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getAccounts>>> = ({ signal }) => getAccounts(params, requestOptions, signal);





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getAccounts>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetAccountsQueryResult = NonNullable<Awaited<ReturnType<typeof getAccounts>>>
export type GetAccountsQueryError = Error | RequestTimeoutResponse | InternalServerErrorResponse | ResponseTimeoutResponse | ServerTimeoutErrorResponse


export function useGetAccounts<TData = Awaited<ReturnType<typeof getAccounts>>, TError = Error | RequestTimeoutResponse | InternalServerErrorResponse | ResponseTimeoutResponse | ServerTimeoutErrorResponse>(
 params: undefined |  GetAccountsParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAccounts>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getAccounts>>,
          TError,
          Awaited<ReturnType<typeof getAccounts>>
        > , 'initialData'
      >, request?: SecondParameter<typeof lp5AxiosClient>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetAccounts<TData = Awaited<ReturnType<typeof getAccounts>>, TError = Error | RequestTimeoutResponse | InternalServerErrorResponse | ResponseTimeoutResponse | ServerTimeoutErrorResponse>(
 params?: GetAccountsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAccounts>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getAccounts>>,
          TError,
          Awaited<ReturnType<typeof getAccounts>>
        > , 'initialData'
      >, request?: SecondParameter<typeof lp5AxiosClient>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetAccounts<TData = Awaited<ReturnType<typeof getAccounts>>, TError = Error | RequestTimeoutResponse | InternalServerErrorResponse | ResponseTimeoutResponse | ServerTimeoutErrorResponse>(
 params?: GetAccountsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAccounts>>, TError, TData>>, request?: SecondParameter<typeof lp5AxiosClient>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary get accounts
 */

export function useGetAccounts<TData = Awaited<ReturnType<typeof getAccounts>>, TError = Error | RequestTimeoutResponse | InternalServerErrorResponse | ResponseTimeoutResponse | ServerTimeoutErrorResponse>(
 params?: GetAccountsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAccounts>>, TError, TData>>, request?: SecondParameter<typeof lp5AxiosClient>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetAccountsQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}







/**
 * Create an account.
 * @summary create account
 */
export const createAccount = (
    accountToCreate?: AccountToCreate,
 options?: SecondParameter<typeof lp5AxiosClient>,signal?: AbortSignal
) => {


      return lp5AxiosClient<AccountCreationResponse>(
      {url: `/6/accounts`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: accountToCreate, signal
    },
      options);
    }




export const getCreateAccountMutationOptions = <TError = Error | AccountsIsDisabledResponse | RequestTimeoutResponse | PayloadToLargeResponse | InternalServerErrorResponse | ResponseTimeoutResponse | ServerTimeoutErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createAccount>>, TError,{data?: AccountToCreate}, TContext>, request?: SecondParameter<typeof lp5AxiosClient>}
): UseMutationOptions<Awaited<ReturnType<typeof createAccount>>, TError,{data?: AccountToCreate}, TContext> => {

const mutationKey = ['createAccount'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof createAccount>>, {data?: AccountToCreate}> = (props) => {
          const {data} = props ?? {};

          return  createAccount(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type CreateAccountMutationResult = NonNullable<Awaited<ReturnType<typeof createAccount>>>
    export type CreateAccountMutationBody = AccountToCreate | undefined
    export type CreateAccountMutationError = Error | AccountsIsDisabledResponse | RequestTimeoutResponse | PayloadToLargeResponse | InternalServerErrorResponse | ResponseTimeoutResponse | ServerTimeoutErrorResponse

    /**
 * @summary create account
 */
export const useCreateAccount = <TError = Error | AccountsIsDisabledResponse | RequestTimeoutResponse | PayloadToLargeResponse | InternalServerErrorResponse | ResponseTimeoutResponse | ServerTimeoutErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createAccount>>, TError,{data?: AccountToCreate}, TContext>, request?: SecondParameter<typeof lp5AxiosClient>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof createAccount>>,
        TError,
        {data?: AccountToCreate},
        TContext
      > => {
      return useMutation(getCreateAccountMutationOptions(options), queryClient);
    }

/**
 * Get options for the resource.
 * @summary accounts options
 */
export const getAccountsOptions = (

 options?: SecondParameter<typeof lp5AxiosClient>,signal?: AbortSignal
) => {


      return lp5AxiosClient<void>(
      {url: `/6/accounts`, method: 'OPTIONS', signal
    },
      options);
    }




export const getGetAccountsOptionsMutationOptions = <TError = RequestTimeoutResponse | InternalServerErrorResponse | ResponseTimeoutResponse | ServerTimeoutErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof getAccountsOptions>>, TError,void, TContext>, request?: SecondParameter<typeof lp5AxiosClient>}
): UseMutationOptions<Awaited<ReturnType<typeof getAccountsOptions>>, TError,void, TContext> => {

const mutationKey = ['getAccountsOptions'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof getAccountsOptions>>, void> = () => {


          return  getAccountsOptions(requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type GetAccountsOptionsMutationResult = NonNullable<Awaited<ReturnType<typeof getAccountsOptions>>>

    export type GetAccountsOptionsMutationError = RequestTimeoutResponse | InternalServerErrorResponse | ResponseTimeoutResponse | ServerTimeoutErrorResponse

    /**
 * @summary accounts options
 */
export const useGetAccountsOptions = <TError = RequestTimeoutResponse | InternalServerErrorResponse | ResponseTimeoutResponse | ServerTimeoutErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof getAccountsOptions>>, TError,void, TContext>, request?: SecondParameter<typeof lp5AxiosClient>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof getAccountsOptions>>,
        TError,
        void,
        TContext
      > => {
      return useMutation(getGetAccountsOptionsMutationOptions(options), queryClient);
    }

/**
 * Get account.
 * @summary get account
 */
export const getAccount = (
    params?: GetAccountParams,
 options?: SecondParameter<typeof lp5AxiosClient>,signal?: AbortSignal
) => {


      return lp5AxiosClient<AccountToReceive>(
      {url: `/6/account`, method: 'GET',
        params, signal
    },
      options);
    }




export const getGetAccountQueryKey = (params?: GetAccountParams,) => {
    return [
    `/6/account`, ...(params ? [params] : [])
    ] as const;
    }


export const getGetAccountQueryOptions = <TData = Awaited<ReturnType<typeof getAccount>>, TError = AuthorizationErrorResponse | Error | RequestTimeoutResponse | InternalServerErrorResponse | ResponseTimeoutResponse | ServerTimeoutErrorResponse>(params?: GetAccountParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAccount>>, TError, TData>>, request?: SecondParameter<typeof lp5AxiosClient>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetAccountQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getAccount>>> = ({ signal }) => getAccount(params, requestOptions, signal);





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getAccount>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetAccountQueryResult = NonNullable<Awaited<ReturnType<typeof getAccount>>>
export type GetAccountQueryError = AuthorizationErrorResponse | Error | RequestTimeoutResponse | InternalServerErrorResponse | ResponseTimeoutResponse | ServerTimeoutErrorResponse


export function useGetAccount<TData = Awaited<ReturnType<typeof getAccount>>, TError = AuthorizationErrorResponse | Error | RequestTimeoutResponse | InternalServerErrorResponse | ResponseTimeoutResponse | ServerTimeoutErrorResponse>(
 params: undefined |  GetAccountParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAccount>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getAccount>>,
          TError,
          Awaited<ReturnType<typeof getAccount>>
        > , 'initialData'
      >, request?: SecondParameter<typeof lp5AxiosClient>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetAccount<TData = Awaited<ReturnType<typeof getAccount>>, TError = AuthorizationErrorResponse | Error | RequestTimeoutResponse | InternalServerErrorResponse | ResponseTimeoutResponse | ServerTimeoutErrorResponse>(
 params?: GetAccountParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAccount>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getAccount>>,
          TError,
          Awaited<ReturnType<typeof getAccount>>
        > , 'initialData'
      >, request?: SecondParameter<typeof lp5AxiosClient>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetAccount<TData = Awaited<ReturnType<typeof getAccount>>, TError = AuthorizationErrorResponse | Error | RequestTimeoutResponse | InternalServerErrorResponse | ResponseTimeoutResponse | ServerTimeoutErrorResponse>(
 params?: GetAccountParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAccount>>, TError, TData>>, request?: SecondParameter<typeof lp5AxiosClient>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary get account
 */

export function useGetAccount<TData = Awaited<ReturnType<typeof getAccount>>, TError = AuthorizationErrorResponse | Error | RequestTimeoutResponse | InternalServerErrorResponse | ResponseTimeoutResponse | ServerTimeoutErrorResponse>(
 params?: GetAccountParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAccount>>, TError, TData>>, request?: SecondParameter<typeof lp5AxiosClient>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetAccountQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}







/**
 * Patch account. At least one field must be specified.
 * @summary patch account
 */
export const patchAccount = (
    accountForPatch?: AccountForPatch,
 options?: SecondParameter<typeof lp5AxiosClient>,signal?: AbortSignal
) => {


      return lp5AxiosClient<void>(
      {url: `/6/account`, method: 'PATCH',
      headers: {'Content-Type': 'application/json', },
      data: accountForPatch, signal
    },
      options);
    }




export const getPatchAccountMutationOptions = <TError = Error | AuthorizationErrorResponse | RequestTimeoutResponse | PayloadToLargeResponse | InternalServerErrorResponse | ResponseTimeoutResponse | ServerTimeoutErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof patchAccount>>, TError,{data?: AccountForPatch}, TContext>, request?: SecondParameter<typeof lp5AxiosClient>}
): UseMutationOptions<Awaited<ReturnType<typeof patchAccount>>, TError,{data?: AccountForPatch}, TContext> => {

const mutationKey = ['patchAccount'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof patchAccount>>, {data?: AccountForPatch}> = (props) => {
          const {data} = props ?? {};

          return  patchAccount(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type PatchAccountMutationResult = NonNullable<Awaited<ReturnType<typeof patchAccount>>>
    export type PatchAccountMutationBody = AccountForPatch | undefined
    export type PatchAccountMutationError = Error | AuthorizationErrorResponse | RequestTimeoutResponse | PayloadToLargeResponse | InternalServerErrorResponse | ResponseTimeoutResponse | ServerTimeoutErrorResponse

    /**
 * @summary patch account
 */
export const usePatchAccount = <TError = Error | AuthorizationErrorResponse | RequestTimeoutResponse | PayloadToLargeResponse | InternalServerErrorResponse | ResponseTimeoutResponse | ServerTimeoutErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof patchAccount>>, TError,{data?: AccountForPatch}, TContext>, request?: SecondParameter<typeof lp5AxiosClient>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof patchAccount>>,
        TError,
        {data?: AccountForPatch},
        TContext
      > => {
      return useMutation(getPatchAccountMutationOptions(options), queryClient);
    }

/**
 * Get options for the resource.
 * @summary accounts options
 */
export const getAccountOptions = (

 options?: SecondParameter<typeof lp5AxiosClient>,signal?: AbortSignal
) => {


      return lp5AxiosClient<void>(
      {url: `/6/account`, method: 'OPTIONS', signal
    },
      options);
    }




export const getGetAccountOptionsMutationOptions = <TError = RequestTimeoutResponse | InternalServerErrorResponse | ResponseTimeoutResponse | ServerTimeoutErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof getAccountOptions>>, TError,void, TContext>, request?: SecondParameter<typeof lp5AxiosClient>}
): UseMutationOptions<Awaited<ReturnType<typeof getAccountOptions>>, TError,void, TContext> => {

const mutationKey = ['getAccountOptions'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof getAccountOptions>>, void> = () => {


          return  getAccountOptions(requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type GetAccountOptionsMutationResult = NonNullable<Awaited<ReturnType<typeof getAccountOptions>>>

    export type GetAccountOptionsMutationError = RequestTimeoutResponse | InternalServerErrorResponse | ResponseTimeoutResponse | ServerTimeoutErrorResponse

    /**
 * @summary accounts options
 */
export const useGetAccountOptions = <TError = RequestTimeoutResponse | InternalServerErrorResponse | ResponseTimeoutResponse | ServerTimeoutErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof getAccountOptions>>, TError,void, TContext>, request?: SecondParameter<typeof lp5AxiosClient>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof getAccountOptions>>,
        TError,
        void,
        TContext
      > => {
      return useMutation(getGetAccountOptionsMutationOptions(options), queryClient);
    }

/**
 * Create a token.
 * @summary create token
 */
export const createToken = (
    tokenToCreateTokenWithAllPermissions?: TokenToCreate | TokenWithAllPermissions,
    params?: CreateTokenParams,
 options?: SecondParameter<typeof lp5AxiosClient>,signal?: AbortSignal
) => {


      return lp5AxiosClient<TokenCreationResponse>(
      {url: `/6/tokens`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: tokenToCreateTokenWithAllPermissions,
        params, signal
    },
      options);
    }




export const getCreateTokenMutationOptions = <TError = Error | AuthorizationErrorResponse | ForbiddenErrorResponse | RequestTimeoutResponse | PayloadToLargeResponse | InternalServerErrorResponse | ResponseTimeoutResponse | ServerTimeoutErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createToken>>, TError,{data?: TokenToCreate | TokenWithAllPermissions;params?: CreateTokenParams}, TContext>, request?: SecondParameter<typeof lp5AxiosClient>}
): UseMutationOptions<Awaited<ReturnType<typeof createToken>>, TError,{data?: TokenToCreate | TokenWithAllPermissions;params?: CreateTokenParams}, TContext> => {

const mutationKey = ['createToken'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof createToken>>, {data?: TokenToCreate | TokenWithAllPermissions;params?: CreateTokenParams}> = (props) => {
          const {data,params} = props ?? {};

          return  createToken(data,params,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type CreateTokenMutationResult = NonNullable<Awaited<ReturnType<typeof createToken>>>
    export type CreateTokenMutationBody = TokenToCreate | TokenWithAllPermissions | undefined
    export type CreateTokenMutationError = Error | AuthorizationErrorResponse | ForbiddenErrorResponse | RequestTimeoutResponse | PayloadToLargeResponse | InternalServerErrorResponse | ResponseTimeoutResponse | ServerTimeoutErrorResponse

    /**
 * @summary create token
 */
export const useCreateToken = <TError = Error | AuthorizationErrorResponse | ForbiddenErrorResponse | RequestTimeoutResponse | PayloadToLargeResponse | InternalServerErrorResponse | ResponseTimeoutResponse | ServerTimeoutErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createToken>>, TError,{data?: TokenToCreate | TokenWithAllPermissions;params?: CreateTokenParams}, TContext>, request?: SecondParameter<typeof lp5AxiosClient>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof createToken>>,
        TError,
        {data?: TokenToCreate | TokenWithAllPermissions;params?: CreateTokenParams},
        TContext
      > => {
      return useMutation(getCreateTokenMutationOptions(options), queryClient);
    }

/**
 * Get tokens.
 * @summary get tokens
 */
export const getTokens = (
    params?: GetTokensParams,
 options?: SecondParameter<typeof lp5AxiosClient>,signal?: AbortSignal
) => {


      return lp5AxiosClient<TokensToReceive>(
      {url: `/6/tokens`, method: 'GET',
        params, signal
    },
      options);
    }




export const getGetTokensQueryKey = (params?: GetTokensParams,) => {
    return [
    `/6/tokens`, ...(params ? [params] : [])
    ] as const;
    }


export const getGetTokensQueryOptions = <TData = Awaited<ReturnType<typeof getTokens>>, TError = Error | AuthorizationErrorResponse | ForbiddenErrorResponse | RequestTimeoutResponse | InternalServerErrorResponse | ResponseTimeoutResponse | ServerTimeoutErrorResponse>(params?: GetTokensParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getTokens>>, TError, TData>>, request?: SecondParameter<typeof lp5AxiosClient>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetTokensQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getTokens>>> = ({ signal }) => getTokens(params, requestOptions, signal);





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getTokens>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetTokensQueryResult = NonNullable<Awaited<ReturnType<typeof getTokens>>>
export type GetTokensQueryError = Error | AuthorizationErrorResponse | ForbiddenErrorResponse | RequestTimeoutResponse | InternalServerErrorResponse | ResponseTimeoutResponse | ServerTimeoutErrorResponse


export function useGetTokens<TData = Awaited<ReturnType<typeof getTokens>>, TError = Error | AuthorizationErrorResponse | ForbiddenErrorResponse | RequestTimeoutResponse | InternalServerErrorResponse | ResponseTimeoutResponse | ServerTimeoutErrorResponse>(
 params: undefined |  GetTokensParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getTokens>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getTokens>>,
          TError,
          Awaited<ReturnType<typeof getTokens>>
        > , 'initialData'
      >, request?: SecondParameter<typeof lp5AxiosClient>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetTokens<TData = Awaited<ReturnType<typeof getTokens>>, TError = Error | AuthorizationErrorResponse | ForbiddenErrorResponse | RequestTimeoutResponse | InternalServerErrorResponse | ResponseTimeoutResponse | ServerTimeoutErrorResponse>(
 params?: GetTokensParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getTokens>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getTokens>>,
          TError,
          Awaited<ReturnType<typeof getTokens>>
        > , 'initialData'
      >, request?: SecondParameter<typeof lp5AxiosClient>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetTokens<TData = Awaited<ReturnType<typeof getTokens>>, TError = Error | AuthorizationErrorResponse | ForbiddenErrorResponse | RequestTimeoutResponse | InternalServerErrorResponse | ResponseTimeoutResponse | ServerTimeoutErrorResponse>(
 params?: GetTokensParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getTokens>>, TError, TData>>, request?: SecondParameter<typeof lp5AxiosClient>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary get tokens
 */

export function useGetTokens<TData = Awaited<ReturnType<typeof getTokens>>, TError = Error | AuthorizationErrorResponse | ForbiddenErrorResponse | RequestTimeoutResponse | InternalServerErrorResponse | ResponseTimeoutResponse | ServerTimeoutErrorResponse>(
 params?: GetTokensParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getTokens>>, TError, TData>>, request?: SecondParameter<typeof lp5AxiosClient>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetTokensQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}







/**
 * Get options for the resource.
 * @summary tokens options
 */
export const getTokensOptions = (

 options?: SecondParameter<typeof lp5AxiosClient>,signal?: AbortSignal
) => {


      return lp5AxiosClient<void>(
      {url: `/6/tokens`, method: 'OPTIONS', signal
    },
      options);
    }




export const getGetTokensOptionsMutationOptions = <TError = RequestTimeoutResponse | InternalServerErrorResponse | ResponseTimeoutResponse | ServerTimeoutErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof getTokensOptions>>, TError,void, TContext>, request?: SecondParameter<typeof lp5AxiosClient>}
): UseMutationOptions<Awaited<ReturnType<typeof getTokensOptions>>, TError,void, TContext> => {

const mutationKey = ['getTokensOptions'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof getTokensOptions>>, void> = () => {


          return  getTokensOptions(requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type GetTokensOptionsMutationResult = NonNullable<Awaited<ReturnType<typeof getTokensOptions>>>

    export type GetTokensOptionsMutationError = RequestTimeoutResponse | InternalServerErrorResponse | ResponseTimeoutResponse | ServerTimeoutErrorResponse

    /**
 * @summary tokens options
 */
export const useGetTokensOptions = <TError = RequestTimeoutResponse | InternalServerErrorResponse | ResponseTimeoutResponse | ServerTimeoutErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof getTokensOptions>>, TError,void, TContext>, request?: SecondParameter<typeof lp5AxiosClient>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof getTokensOptions>>,
        TError,
        void,
        TContext
      > => {
      return useMutation(getGetTokensOptionsMutationOptions(options), queryClient);
    }

/**
 * Update token. You cannot update a part of the token, so you should specify all the fields for your token.
 * @summary replace token
 */
export const putToken = (
    tokenId: string,
    tokenToCreateTokenWithAllPermissions?: TokenToCreate | TokenWithAllPermissions,
    params?: PutTokenParams,
 options?: SecondParameter<typeof lp5AxiosClient>,signal?: AbortSignal
) => {


      return lp5AxiosClient<TokenCreationResponse>(
      {url: `/6/tokens/${tokenId}`, method: 'PUT',
      headers: {'Content-Type': 'application/json', },
      data: tokenToCreateTokenWithAllPermissions,
        params, signal
    },
      options);
    }




export const getPutTokenMutationOptions = <TError = Error | AuthorizationErrorResponse | ForbiddenErrorResponse | RequestTimeoutResponse | PayloadToLargeResponse | InternalServerErrorResponse | ResponseTimeoutResponse | ServerTimeoutErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof putToken>>, TError,{tokenId: string;data?: TokenToCreate | TokenWithAllPermissions;params?: PutTokenParams}, TContext>, request?: SecondParameter<typeof lp5AxiosClient>}
): UseMutationOptions<Awaited<ReturnType<typeof putToken>>, TError,{tokenId: string;data?: TokenToCreate | TokenWithAllPermissions;params?: PutTokenParams}, TContext> => {

const mutationKey = ['putToken'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof putToken>>, {tokenId: string;data?: TokenToCreate | TokenWithAllPermissions;params?: PutTokenParams}> = (props) => {
          const {tokenId,data,params} = props ?? {};

          return  putToken(tokenId,data,params,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type PutTokenMutationResult = NonNullable<Awaited<ReturnType<typeof putToken>>>
    export type PutTokenMutationBody = TokenToCreate | TokenWithAllPermissions | undefined
    export type PutTokenMutationError = Error | AuthorizationErrorResponse | ForbiddenErrorResponse | RequestTimeoutResponse | PayloadToLargeResponse | InternalServerErrorResponse | ResponseTimeoutResponse | ServerTimeoutErrorResponse

    /**
 * @summary replace token
 */
export const usePutToken = <TError = Error | AuthorizationErrorResponse | ForbiddenErrorResponse | RequestTimeoutResponse | PayloadToLargeResponse | InternalServerErrorResponse | ResponseTimeoutResponse | ServerTimeoutErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof putToken>>, TError,{tokenId: string;data?: TokenToCreate | TokenWithAllPermissions;params?: PutTokenParams}, TContext>, request?: SecondParameter<typeof lp5AxiosClient>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof putToken>>,
        TError,
        {tokenId: string;data?: TokenToCreate | TokenWithAllPermissions;params?: PutTokenParams},
        TContext
      > => {
      return useMutation(getPutTokenMutationOptions(options), queryClient);
    }

/**
 * Get token by ID.
 * @summary get token
 */
export const getToken = (
    tokenId: string,
 options?: SecondParameter<typeof lp5AxiosClient>,signal?: AbortSignal
) => {


      return lp5AxiosClient<TokenToReceive>(
      {url: `/6/tokens/${tokenId}`, method: 'GET', signal
    },
      options);
    }




export const getGetTokenQueryKey = (tokenId: string,) => {
    return [
    `/6/tokens/${tokenId}`
    ] as const;
    }


export const getGetTokenQueryOptions = <TData = Awaited<ReturnType<typeof getToken>>, TError = Error | AuthorizationErrorResponse | ForbiddenErrorResponse | RequestTimeoutResponse | InternalServerErrorResponse | ResponseTimeoutResponse | ServerTimeoutErrorResponse>(tokenId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getToken>>, TError, TData>>, request?: SecondParameter<typeof lp5AxiosClient>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetTokenQueryKey(tokenId);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getToken>>> = ({ signal }) => getToken(tokenId, requestOptions, signal);





   return  { queryKey, queryFn, enabled: tokenId !== null && tokenId !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getToken>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetTokenQueryResult = NonNullable<Awaited<ReturnType<typeof getToken>>>
export type GetTokenQueryError = Error | AuthorizationErrorResponse | ForbiddenErrorResponse | RequestTimeoutResponse | InternalServerErrorResponse | ResponseTimeoutResponse | ServerTimeoutErrorResponse


export function useGetToken<TData = Awaited<ReturnType<typeof getToken>>, TError = Error | AuthorizationErrorResponse | ForbiddenErrorResponse | RequestTimeoutResponse | InternalServerErrorResponse | ResponseTimeoutResponse | ServerTimeoutErrorResponse>(
 tokenId: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getToken>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getToken>>,
          TError,
          Awaited<ReturnType<typeof getToken>>
        > , 'initialData'
      >, request?: SecondParameter<typeof lp5AxiosClient>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetToken<TData = Awaited<ReturnType<typeof getToken>>, TError = Error | AuthorizationErrorResponse | ForbiddenErrorResponse | RequestTimeoutResponse | InternalServerErrorResponse | ResponseTimeoutResponse | ServerTimeoutErrorResponse>(
 tokenId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getToken>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getToken>>,
          TError,
          Awaited<ReturnType<typeof getToken>>
        > , 'initialData'
      >, request?: SecondParameter<typeof lp5AxiosClient>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetToken<TData = Awaited<ReturnType<typeof getToken>>, TError = Error | AuthorizationErrorResponse | ForbiddenErrorResponse | RequestTimeoutResponse | InternalServerErrorResponse | ResponseTimeoutResponse | ServerTimeoutErrorResponse>(
 tokenId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getToken>>, TError, TData>>, request?: SecondParameter<typeof lp5AxiosClient>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary get token
 */

export function useGetToken<TData = Awaited<ReturnType<typeof getToken>>, TError = Error | AuthorizationErrorResponse | ForbiddenErrorResponse | RequestTimeoutResponse | InternalServerErrorResponse | ResponseTimeoutResponse | ServerTimeoutErrorResponse>(
 tokenId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getToken>>, TError, TData>>, request?: SecondParameter<typeof lp5AxiosClient>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetTokenQueryOptions(tokenId,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}







/**
 * Delete token by ID.
 * @summary delete token
 */
export const deleteToken = (
    tokenId: string,
 options?: SecondParameter<typeof lp5AxiosClient>,signal?: AbortSignal
) => {


      return lp5AxiosClient<void>(
      {url: `/6/tokens/${tokenId}`, method: 'DELETE', signal
    },
      options);
    }




export const getDeleteTokenMutationOptions = <TError = Error | AuthorizationErrorResponse | ForbiddenErrorResponse | RequestTimeoutResponse | InternalServerErrorResponse | ResponseTimeoutResponse | ServerTimeoutErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteToken>>, TError,{tokenId: string}, TContext>, request?: SecondParameter<typeof lp5AxiosClient>}
): UseMutationOptions<Awaited<ReturnType<typeof deleteToken>>, TError,{tokenId: string}, TContext> => {

const mutationKey = ['deleteToken'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof deleteToken>>, {tokenId: string}> = (props) => {
          const {tokenId} = props ?? {};

          return  deleteToken(tokenId,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type DeleteTokenMutationResult = NonNullable<Awaited<ReturnType<typeof deleteToken>>>

    export type DeleteTokenMutationError = Error | AuthorizationErrorResponse | ForbiddenErrorResponse | RequestTimeoutResponse | InternalServerErrorResponse | ResponseTimeoutResponse | ServerTimeoutErrorResponse

    /**
 * @summary delete token
 */
export const useDeleteToken = <TError = Error | AuthorizationErrorResponse | ForbiddenErrorResponse | RequestTimeoutResponse | InternalServerErrorResponse | ResponseTimeoutResponse | ServerTimeoutErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteToken>>, TError,{tokenId: string}, TContext>, request?: SecondParameter<typeof lp5AxiosClient>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof deleteToken>>,
        TError,
        {tokenId: string},
        TContext
      > => {
      return useMutation(getDeleteTokenMutationOptions(options), queryClient);
    }

/**
 * Get options for the resource.
 * @summary token options
 */
export const getTokenOptions = (
    tokenId: string,
 options?: SecondParameter<typeof lp5AxiosClient>,signal?: AbortSignal
) => {


      return lp5AxiosClient<void>(
      {url: `/6/tokens/${tokenId}`, method: 'OPTIONS', signal
    },
      options);
    }




export const getGetTokenOptionsMutationOptions = <TError = RequestTimeoutResponse | InternalServerErrorResponse | ResponseTimeoutResponse | ServerTimeoutErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof getTokenOptions>>, TError,{tokenId: string}, TContext>, request?: SecondParameter<typeof lp5AxiosClient>}
): UseMutationOptions<Awaited<ReturnType<typeof getTokenOptions>>, TError,{tokenId: string}, TContext> => {

const mutationKey = ['getTokenOptions'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof getTokenOptions>>, {tokenId: string}> = (props) => {
          const {tokenId} = props ?? {};

          return  getTokenOptions(tokenId,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type GetTokenOptionsMutationResult = NonNullable<Awaited<ReturnType<typeof getTokenOptions>>>

    export type GetTokenOptionsMutationError = RequestTimeoutResponse | InternalServerErrorResponse | ResponseTimeoutResponse | ServerTimeoutErrorResponse

    /**
 * @summary token options
 */
export const useGetTokenOptions = <TError = RequestTimeoutResponse | InternalServerErrorResponse | ResponseTimeoutResponse | ServerTimeoutErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof getTokenOptions>>, TError,{tokenId: string}, TContext>, request?: SecondParameter<typeof lp5AxiosClient>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof getTokenOptions>>,
        TError,
        {tokenId: string},
        TContext
      > => {
      return useMutation(getGetTokenOptionsMutationOptions(options), queryClient);
    }

/**
 * Verify account or login with password or token.
 * * In the case of success `account id` verification, `account_type` will be returned
 * * In the case of success `login`/`password` verification, `account_id` and `account_type` will be returned
 * * In the case of success `token` verification, `account_type` and token `permissions` will be returned
 * * In the case of failure verification, error will be returned
 * @summary verify credentials
 */
export const verifyCredentials = (
    verifierPostData?: VerifierPostData,
 options?: SecondParameter<typeof lp5AxiosClient>,signal?: AbortSignal
) => {


      return lp5AxiosClient<VerificationResponse>(
      {url: `/6/credentials_verifier`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: verifierPostData, signal
    },
      options);
    }




export const getVerifyCredentialsMutationOptions = <TError = Error | AccountsIsDisabledResponse | RequestTimeoutResponse | PayloadToLargeResponse | InternalServerErrorResponse | ResponseTimeoutResponse | ServerTimeoutErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof verifyCredentials>>, TError,{data?: VerifierPostData}, TContext>, request?: SecondParameter<typeof lp5AxiosClient>}
): UseMutationOptions<Awaited<ReturnType<typeof verifyCredentials>>, TError,{data?: VerifierPostData}, TContext> => {

const mutationKey = ['verifyCredentials'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof verifyCredentials>>, {data?: VerifierPostData}> = (props) => {
          const {data} = props ?? {};

          return  verifyCredentials(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type VerifyCredentialsMutationResult = NonNullable<Awaited<ReturnType<typeof verifyCredentials>>>
    export type VerifyCredentialsMutationBody = VerifierPostData | undefined
    export type VerifyCredentialsMutationError = Error | AccountsIsDisabledResponse | RequestTimeoutResponse | PayloadToLargeResponse | InternalServerErrorResponse | ResponseTimeoutResponse | ServerTimeoutErrorResponse

    /**
 * @summary verify credentials
 */
export const useVerifyCredentials = <TError = Error | AccountsIsDisabledResponse | RequestTimeoutResponse | PayloadToLargeResponse | InternalServerErrorResponse | ResponseTimeoutResponse | ServerTimeoutErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof verifyCredentials>>, TError,{data?: VerifierPostData}, TContext>, request?: SecondParameter<typeof lp5AxiosClient>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof verifyCredentials>>,
        TError,
        {data?: VerifierPostData},
        TContext
      > => {
      return useMutation(getVerifyCredentialsMutationOptions(options), queryClient);
    }

/**
 * Get options for the resource.
 * @summary credentials verifier options
 */
export const verifyCredentialsOptions = (

 options?: SecondParameter<typeof lp5AxiosClient>,signal?: AbortSignal
) => {


      return lp5AxiosClient<void>(
      {url: `/6/credentials_verifier`, method: 'OPTIONS', signal
    },
      options);
    }




export const getVerifyCredentialsOptionsMutationOptions = <TError = RequestTimeoutResponse | InternalServerErrorResponse | ResponseTimeoutResponse | ServerTimeoutErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof verifyCredentialsOptions>>, TError,void, TContext>, request?: SecondParameter<typeof lp5AxiosClient>}
): UseMutationOptions<Awaited<ReturnType<typeof verifyCredentialsOptions>>, TError,void, TContext> => {

const mutationKey = ['verifyCredentialsOptions'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof verifyCredentialsOptions>>, void> = () => {


          return  verifyCredentialsOptions(requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type VerifyCredentialsOptionsMutationResult = NonNullable<Awaited<ReturnType<typeof verifyCredentialsOptions>>>

    export type VerifyCredentialsOptionsMutationError = RequestTimeoutResponse | InternalServerErrorResponse | ResponseTimeoutResponse | ServerTimeoutErrorResponse

    /**
 * @summary credentials verifier options
 */
export const useVerifyCredentialsOptions = <TError = RequestTimeoutResponse | InternalServerErrorResponse | ResponseTimeoutResponse | ServerTimeoutErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof verifyCredentialsOptions>>, TError,void, TContext>, request?: SecondParameter<typeof lp5AxiosClient>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof verifyCredentialsOptions>>,
        TError,
        void,
        TContext
      > => {
      return useMutation(getVerifyCredentialsOptionsMutationOptions(options), queryClient);
    }

/**
 * Detect faces and/or human bodies and estimate attributes on the input images. After the request is performed, the received data is not saved to the database or Image Store, it is only returned in the response.
 *
 * The order of input images corresponds to the order of the elements in the output JSON.
 *
 * If an input image is corrupted, an error is returned for the image. The processing of the other images continues in normal mode.
 *
 * Notes for incoming data:
 *   - face or body *bounding boxes* passed with face or body warped image will be ignored.
 * @summary sdk resource
 */
export const sdk = (
    sdkBody: Blob | MultipartSdkImageSchema | SdkJsonRequestBody,
    params?: SdkParams,
 options?: SecondParameter<typeof lp5AxiosClient>,signal?: AbortSignal
) => {


      return lp5AxiosClient<SdkResponseJson | SdkResponseMsgpack>(
      {url: `/6/sdk`, method: 'POST',
      data: sdkBody,
        params, signal
    },
      options);
    }




export const getSdkMutationOptions = <TError = Error | AuthorizationErrorResponse | RequestTimeoutResponse | PayloadToLargeResponse | InternalServerErrorResponse | ResponseTimeoutResponse | ServerTimeoutErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof sdk>>, TError,{data: Blob | MultipartSdkImageSchema | SdkJsonRequestBody;params?: SdkParams}, TContext>, request?: SecondParameter<typeof lp5AxiosClient>}
): UseMutationOptions<Awaited<ReturnType<typeof sdk>>, TError,{data: Blob | MultipartSdkImageSchema | SdkJsonRequestBody;params?: SdkParams}, TContext> => {

const mutationKey = ['sdk'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof sdk>>, {data: Blob | MultipartSdkImageSchema | SdkJsonRequestBody;params?: SdkParams}> = (props) => {
          const {data,params} = props ?? {};

          return  sdk(data,params,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type SdkMutationResult = NonNullable<Awaited<ReturnType<typeof sdk>>>
    export type SdkMutationBody = Blob | MultipartSdkImageSchema | SdkJsonRequestBody
    export type SdkMutationError = Error | AuthorizationErrorResponse | RequestTimeoutResponse | PayloadToLargeResponse | InternalServerErrorResponse | ResponseTimeoutResponse | ServerTimeoutErrorResponse

    /**
 * @summary sdk resource
 */
export const useSdk = <TError = Error | AuthorizationErrorResponse | RequestTimeoutResponse | PayloadToLargeResponse | InternalServerErrorResponse | ResponseTimeoutResponse | ServerTimeoutErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof sdk>>, TError,{data: Blob | MultipartSdkImageSchema | SdkJsonRequestBody;params?: SdkParams}, TContext>, request?: SecondParameter<typeof lp5AxiosClient>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof sdk>>,
        TError,
        {data: Blob | MultipartSdkImageSchema | SdkJsonRequestBody;params?: SdkParams},
        TContext
      > => {
      return useMutation(getSdkMutationOptions(options), queryClient);
    }

/**
 * Get options for the resource.
 * @summary sdk options
 */
export const getSdkOptions = (

 options?: SecondParameter<typeof lp5AxiosClient>,signal?: AbortSignal
) => {


      return lp5AxiosClient<void>(
      {url: `/6/sdk`, method: 'OPTIONS', signal
    },
      options);
    }




export const getGetSdkOptionsMutationOptions = <TError = RequestTimeoutResponse | InternalServerErrorResponse | ResponseTimeoutResponse | ServerTimeoutErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof getSdkOptions>>, TError,void, TContext>, request?: SecondParameter<typeof lp5AxiosClient>}
): UseMutationOptions<Awaited<ReturnType<typeof getSdkOptions>>, TError,void, TContext> => {

const mutationKey = ['getSdkOptions'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof getSdkOptions>>, void> = () => {


          return  getSdkOptions(requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type GetSdkOptionsMutationResult = NonNullable<Awaited<ReturnType<typeof getSdkOptions>>>

    export type GetSdkOptionsMutationError = RequestTimeoutResponse | InternalServerErrorResponse | ResponseTimeoutResponse | ServerTimeoutErrorResponse

    /**
 * @summary sdk options
 */
export const useGetSdkOptions = <TError = RequestTimeoutResponse | InternalServerErrorResponse | ResponseTimeoutResponse | ServerTimeoutErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof getSdkOptions>>, TError,void, TContext>, request?: SecondParameter<typeof lp5AxiosClient>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof getSdkOptions>>,
        TError,
        void,
        TContext
      > => {
      return useMutation(getGetSdkOptionsMutationOptions(options), queryClient);
    }

/**
 * Request for video analysis based on the specified analytics parameters eg facial estimations.
 * @summary video analytics
 */
export const videosdk = (
    videoAnalyticsParams: VideoAnalyticsParams,
 options?: SecondParameter<typeof lp5AxiosClient>,signal?: AbortSignal
) => {


      return lp5AxiosClient<VideoAnalyticsResponse | VideoAnalyticsResponseMsgpack>(
      {url: `/6/videosdk`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: videoAnalyticsParams, signal
    },
      options);
    }




export const getVideosdkMutationOptions = <TError = Error | RequestTimeoutResponse | PayloadToLargeResponse | InternalServerErrorResponse | ResponseTimeoutResponse | ServerTimeoutErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof videosdk>>, TError,{data: VideoAnalyticsParams}, TContext>, request?: SecondParameter<typeof lp5AxiosClient>}
): UseMutationOptions<Awaited<ReturnType<typeof videosdk>>, TError,{data: VideoAnalyticsParams}, TContext> => {

const mutationKey = ['videosdk'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof videosdk>>, {data: VideoAnalyticsParams}> = (props) => {
          const {data} = props ?? {};

          return  videosdk(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type VideosdkMutationResult = NonNullable<Awaited<ReturnType<typeof videosdk>>>
    export type VideosdkMutationBody = VideoAnalyticsParams
    export type VideosdkMutationError = Error | RequestTimeoutResponse | PayloadToLargeResponse | InternalServerErrorResponse | ResponseTimeoutResponse | ServerTimeoutErrorResponse

    /**
 * @summary video analytics
 */
export const useVideosdk = <TError = Error | RequestTimeoutResponse | PayloadToLargeResponse | InternalServerErrorResponse | ResponseTimeoutResponse | ServerTimeoutErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof videosdk>>, TError,{data: VideoAnalyticsParams}, TContext>, request?: SecondParameter<typeof lp5AxiosClient>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof videosdk>>,
        TError,
        {data: VideoAnalyticsParams},
        TContext
      > => {
      return useMutation(getVideosdkMutationOptions(options), queryClient);
    }

/**
 * Get options for the resource.
 * @summary videosdk options
 */
export const getVideosdkOptions = (

 options?: SecondParameter<typeof lp5AxiosClient>,signal?: AbortSignal
) => {


      return lp5AxiosClient<void>(
      {url: `/6/videosdk`, method: 'OPTIONS', signal
    },
      options);
    }




export const getGetVideosdkOptionsMutationOptions = <TError = RequestTimeoutResponse | InternalServerErrorResponse | ResponseTimeoutResponse | ServerTimeoutErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof getVideosdkOptions>>, TError,void, TContext>, request?: SecondParameter<typeof lp5AxiosClient>}
): UseMutationOptions<Awaited<ReturnType<typeof getVideosdkOptions>>, TError,void, TContext> => {

const mutationKey = ['getVideosdkOptions'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof getVideosdkOptions>>, void> = () => {


          return  getVideosdkOptions(requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type GetVideosdkOptionsMutationResult = NonNullable<Awaited<ReturnType<typeof getVideosdkOptions>>>

    export type GetVideosdkOptionsMutationError = RequestTimeoutResponse | InternalServerErrorResponse | ResponseTimeoutResponse | ServerTimeoutErrorResponse

    /**
 * @summary videosdk options
 */
export const useGetVideosdkOptions = <TError = RequestTimeoutResponse | InternalServerErrorResponse | ResponseTimeoutResponse | ServerTimeoutErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof getVideosdkOptions>>, TError,void, TContext>, request?: SecondParameter<typeof lp5AxiosClient>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof getVideosdkOptions>>,
        TError,
        void,
        TContext
      > => {
      return useMutation(getGetVideosdkOptionsMutationOptions(options), queryClient);
    }

/**
 * Get video task by ID.
 * @summary get task
 */
export const getVideoTask = (
    taskId: Uuid,
 options?: SecondParameter<typeof lp5AxiosClient>,signal?: AbortSignal
) => {


      return lp5AxiosClient<VideoTaskResponse>(
      {url: `/6/video/tasks/${taskId}`, method: 'GET', signal
    },
      options);
    }




export const getGetVideoTaskQueryKey = (taskId: Uuid,) => {
    return [
    `/6/video/tasks/${taskId}`
    ] as const;
    }


export const getGetVideoTaskQueryOptions = <TData = Awaited<ReturnType<typeof getVideoTask>>, TError = Error | RequestTimeoutResponse | InternalServerErrorResponse | ResponseTimeoutResponse | ServerTimeoutErrorResponse>(taskId: Uuid, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getVideoTask>>, TError, TData>>, request?: SecondParameter<typeof lp5AxiosClient>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetVideoTaskQueryKey(taskId);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getVideoTask>>> = ({ signal }) => getVideoTask(taskId, requestOptions, signal);





   return  { queryKey, queryFn, enabled: taskId !== null && taskId !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getVideoTask>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetVideoTaskQueryResult = NonNullable<Awaited<ReturnType<typeof getVideoTask>>>
export type GetVideoTaskQueryError = Error | RequestTimeoutResponse | InternalServerErrorResponse | ResponseTimeoutResponse | ServerTimeoutErrorResponse


export function useGetVideoTask<TData = Awaited<ReturnType<typeof getVideoTask>>, TError = Error | RequestTimeoutResponse | InternalServerErrorResponse | ResponseTimeoutResponse | ServerTimeoutErrorResponse>(
 taskId: Uuid, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getVideoTask>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getVideoTask>>,
          TError,
          Awaited<ReturnType<typeof getVideoTask>>
        > , 'initialData'
      >, request?: SecondParameter<typeof lp5AxiosClient>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetVideoTask<TData = Awaited<ReturnType<typeof getVideoTask>>, TError = Error | RequestTimeoutResponse | InternalServerErrorResponse | ResponseTimeoutResponse | ServerTimeoutErrorResponse>(
 taskId: Uuid, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getVideoTask>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getVideoTask>>,
          TError,
          Awaited<ReturnType<typeof getVideoTask>>
        > , 'initialData'
      >, request?: SecondParameter<typeof lp5AxiosClient>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetVideoTask<TData = Awaited<ReturnType<typeof getVideoTask>>, TError = Error | RequestTimeoutResponse | InternalServerErrorResponse | ResponseTimeoutResponse | ServerTimeoutErrorResponse>(
 taskId: Uuid, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getVideoTask>>, TError, TData>>, request?: SecondParameter<typeof lp5AxiosClient>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary get task
 */

export function useGetVideoTask<TData = Awaited<ReturnType<typeof getVideoTask>>, TError = Error | RequestTimeoutResponse | InternalServerErrorResponse | ResponseTimeoutResponse | ServerTimeoutErrorResponse>(
 taskId: Uuid, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getVideoTask>>, TError, TData>>, request?: SecondParameter<typeof lp5AxiosClient>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetVideoTaskQueryOptions(taskId,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}







/**
 * Get options for the resource.
 * @summary video task options
 */
export const getVideoTaskOptions = (
    taskId: Uuid,
 options?: SecondParameter<typeof lp5AxiosClient>,signal?: AbortSignal
) => {


      return lp5AxiosClient<void>(
      {url: `/6/video/tasks/${taskId}`, method: 'OPTIONS', signal
    },
      options);
    }




export const getGetVideoTaskOptionsMutationOptions = <TError = RequestTimeoutResponse | InternalServerErrorResponse | ResponseTimeoutResponse | ServerTimeoutErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof getVideoTaskOptions>>, TError,{taskId: Uuid}, TContext>, request?: SecondParameter<typeof lp5AxiosClient>}
): UseMutationOptions<Awaited<ReturnType<typeof getVideoTaskOptions>>, TError,{taskId: Uuid}, TContext> => {

const mutationKey = ['getVideoTaskOptions'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof getVideoTaskOptions>>, {taskId: Uuid}> = (props) => {
          const {taskId} = props ?? {};

          return  getVideoTaskOptions(taskId,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type GetVideoTaskOptionsMutationResult = NonNullable<Awaited<ReturnType<typeof getVideoTaskOptions>>>

    export type GetVideoTaskOptionsMutationError = RequestTimeoutResponse | InternalServerErrorResponse | ResponseTimeoutResponse | ServerTimeoutErrorResponse

    /**
 * @summary video task options
 */
export const useGetVideoTaskOptions = <TError = RequestTimeoutResponse | InternalServerErrorResponse | ResponseTimeoutResponse | ServerTimeoutErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof getVideoTaskOptions>>, TError,{taskId: Uuid}, TContext>, request?: SecondParameter<typeof lp5AxiosClient>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof getVideoTaskOptions>>,
        TError,
        {taskId: Uuid},
        TContext
      > => {
      return useMutation(getGetVideoTaskOptionsMutationOptions(options), queryClient);
    }

/**
 * The resource performs a visual examination of frontal type images based on ISO/IEC 19794-5 standard.
 * This means that the images that have passed the validation are standardized and attributes of the person's face meet the established requirements.
 * For more information on the requirements for face attributes in the image, see [ISO/IEC 19794-5 Clauses 7-10](https://www.iso.org/obp/ui/#iso:std:iso-iec:19794:-5:en).
 *
 * The output JSON contains the result of the check for each estimator.
 * The image check is considered successful if the set of these results complies with the ISO standard.
 *
 * The order of input images is corresponding to elements order in output JSON. If an image is broken, the resource will
 * return an error for this image and other images will be correctly processed.
 *
 * Notes for incoming data:
 *   - face or body *bounding boxes* passed with face or body warped image will be ignored.
 * @summary iso resource
 */
export const checkISO = (
    checkISOBody: Blob | MultipartImageSchema | IsoJsonRequestBody,
    params?: CheckISOParams,
 options?: SecondParameter<typeof lp5AxiosClient>,signal?: AbortSignal
) => {


      return lp5AxiosClient<CheckIsoResponse>(
      {url: `/6/iso`, method: 'POST',
      data: checkISOBody,
        params, signal
    },
      options);
    }




export const getCheckISOMutationOptions = <TError = Error | AuthorizationErrorResponse | ImageNotFoundResponse | RequestTimeoutResponse | PayloadToLargeResponse | InternalServerErrorResponse | ResponseTimeoutResponse | ServerTimeoutErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof checkISO>>, TError,{data: Blob | MultipartImageSchema | IsoJsonRequestBody;params?: CheckISOParams}, TContext>, request?: SecondParameter<typeof lp5AxiosClient>}
): UseMutationOptions<Awaited<ReturnType<typeof checkISO>>, TError,{data: Blob | MultipartImageSchema | IsoJsonRequestBody;params?: CheckISOParams}, TContext> => {

const mutationKey = ['checkISO'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof checkISO>>, {data: Blob | MultipartImageSchema | IsoJsonRequestBody;params?: CheckISOParams}> = (props) => {
          const {data,params} = props ?? {};

          return  checkISO(data,params,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type CheckISOMutationResult = NonNullable<Awaited<ReturnType<typeof checkISO>>>
    export type CheckISOMutationBody = Blob | MultipartImageSchema | IsoJsonRequestBody
    export type CheckISOMutationError = Error | AuthorizationErrorResponse | ImageNotFoundResponse | RequestTimeoutResponse | PayloadToLargeResponse | InternalServerErrorResponse | ResponseTimeoutResponse | ServerTimeoutErrorResponse

    /**
 * @summary iso resource
 */
export const useCheckISO = <TError = Error | AuthorizationErrorResponse | ImageNotFoundResponse | RequestTimeoutResponse | PayloadToLargeResponse | InternalServerErrorResponse | ResponseTimeoutResponse | ServerTimeoutErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof checkISO>>, TError,{data: Blob | MultipartImageSchema | IsoJsonRequestBody;params?: CheckISOParams}, TContext>, request?: SecondParameter<typeof lp5AxiosClient>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof checkISO>>,
        TError,
        {data: Blob | MultipartImageSchema | IsoJsonRequestBody;params?: CheckISOParams},
        TContext
      > => {
      return useMutation(getCheckISOMutationOptions(options), queryClient);
    }

/**
 * Get options for the resource.
 * @summary iso options
 */
export const getIsoOptions = (

 options?: SecondParameter<typeof lp5AxiosClient>,signal?: AbortSignal
) => {


      return lp5AxiosClient<void>(
      {url: `/6/iso`, method: 'OPTIONS', signal
    },
      options);
    }




export const getGetIsoOptionsMutationOptions = <TError = RequestTimeoutResponse | InternalServerErrorResponse | ResponseTimeoutResponse | ServerTimeoutErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof getIsoOptions>>, TError,void, TContext>, request?: SecondParameter<typeof lp5AxiosClient>}
): UseMutationOptions<Awaited<ReturnType<typeof getIsoOptions>>, TError,void, TContext> => {

const mutationKey = ['getIsoOptions'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof getIsoOptions>>, void> = () => {


          return  getIsoOptions(requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type GetIsoOptionsMutationResult = NonNullable<Awaited<ReturnType<typeof getIsoOptions>>>

    export type GetIsoOptionsMutationError = RequestTimeoutResponse | InternalServerErrorResponse | ResponseTimeoutResponse | ServerTimeoutErrorResponse

    /**
 * @summary iso options
 */
export const useGetIsoOptions = <TError = RequestTimeoutResponse | InternalServerErrorResponse | ResponseTimeoutResponse | ServerTimeoutErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof getIsoOptions>>, TError,void, TContext>, request?: SecondParameter<typeof lp5AxiosClient>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof getIsoOptions>>,
        TError,
        void,
        TContext
      > => {
      return useMutation(getGetIsoOptionsMutationOptions(options), queryClient);
    }

/**
 * Detect faces in input images, create samples, and estimate face properties.
 *
 * Detections can be filtered out by head pose. The pose is defined by yaw, pitch and roll angles.
 * To specify a filtering threshold per-angle, use corresponding query parameters
 * (`yaw_threshold`, `pitch_threshold` and `roll_threshold`). By default no filtering is applied.
 *
 * > The estimated face properties are not saved to the Faces database. They are only returned in the response.
 *
 * > Samples are saved in the storage without the ability to disable saving. You can disable the saving of
 * > samples only using the handlers.
 *
 * Notes for incoming data:
 *   - face or body *bounding boxes* passed with face or body warped image will be ignored.
 * @summary detect faces
 */
export const detectFaces = (
    detectFacesBody: Blob | MultipartImageSchema | DetectJsonRequestBody,
    params?: DetectFacesParams,
 options?: SecondParameter<typeof lp5AxiosClient>,signal?: AbortSignal
) => {


      return lp5AxiosClient<DetectedImages>(
      {url: `/6/detector`, method: 'POST',
      data: detectFacesBody,
        params, signal
    },
      options);
    }




export const getDetectFacesMutationOptions = <TError = Error | AuthorizationErrorResponse | ForbiddenErrorWithServicesResponse | RequestTimeoutResponse | PayloadToLargeResponse | InternalServerErrorResponse | ResponseTimeoutResponse | ServerTimeoutErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof detectFaces>>, TError,{data: Blob | MultipartImageSchema | DetectJsonRequestBody;params?: DetectFacesParams}, TContext>, request?: SecondParameter<typeof lp5AxiosClient>}
): UseMutationOptions<Awaited<ReturnType<typeof detectFaces>>, TError,{data: Blob | MultipartImageSchema | DetectJsonRequestBody;params?: DetectFacesParams}, TContext> => {

const mutationKey = ['detectFaces'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof detectFaces>>, {data: Blob | MultipartImageSchema | DetectJsonRequestBody;params?: DetectFacesParams}> = (props) => {
          const {data,params} = props ?? {};

          return  detectFaces(data,params,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type DetectFacesMutationResult = NonNullable<Awaited<ReturnType<typeof detectFaces>>>
    export type DetectFacesMutationBody = Blob | MultipartImageSchema | DetectJsonRequestBody
    export type DetectFacesMutationError = Error | AuthorizationErrorResponse | ForbiddenErrorWithServicesResponse | RequestTimeoutResponse | PayloadToLargeResponse | InternalServerErrorResponse | ResponseTimeoutResponse | ServerTimeoutErrorResponse

    /**
 * @summary detect faces
 */
export const useDetectFaces = <TError = Error | AuthorizationErrorResponse | ForbiddenErrorWithServicesResponse | RequestTimeoutResponse | PayloadToLargeResponse | InternalServerErrorResponse | ResponseTimeoutResponse | ServerTimeoutErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof detectFaces>>, TError,{data: Blob | MultipartImageSchema | DetectJsonRequestBody;params?: DetectFacesParams}, TContext>, request?: SecondParameter<typeof lp5AxiosClient>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof detectFaces>>,
        TError,
        {data: Blob | MultipartImageSchema | DetectJsonRequestBody;params?: DetectFacesParams},
        TContext
      > => {
      return useMutation(getDetectFacesMutationOptions(options), queryClient);
    }

/**
 * Get options for the resource.
 * @summary detector options
 */
export const geteDetectorOptions = (

 options?: SecondParameter<typeof lp5AxiosClient>,signal?: AbortSignal
) => {


      return lp5AxiosClient<void>(
      {url: `/6/detector`, method: 'OPTIONS', signal
    },
      options);
    }




export const getGeteDetectorOptionsMutationOptions = <TError = RequestTimeoutResponse | InternalServerErrorResponse | ResponseTimeoutResponse | ServerTimeoutErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof geteDetectorOptions>>, TError,void, TContext>, request?: SecondParameter<typeof lp5AxiosClient>}
): UseMutationOptions<Awaited<ReturnType<typeof geteDetectorOptions>>, TError,void, TContext> => {

const mutationKey = ['geteDetectorOptions'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof geteDetectorOptions>>, void> = () => {


          return  geteDetectorOptions(requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type GeteDetectorOptionsMutationResult = NonNullable<Awaited<ReturnType<typeof geteDetectorOptions>>>

    export type GeteDetectorOptionsMutationError = RequestTimeoutResponse | InternalServerErrorResponse | ResponseTimeoutResponse | ServerTimeoutErrorResponse

    /**
 * @summary detector options
 */
export const useGeteDetectorOptions = <TError = RequestTimeoutResponse | InternalServerErrorResponse | ResponseTimeoutResponse | ServerTimeoutErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof geteDetectorOptions>>, TError,void, TContext>, request?: SecondParameter<typeof lp5AxiosClient>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof geteDetectorOptions>>,
        TError,
        void,
        TContext
      > => {
      return useMutation(getGeteDetectorOptionsMutationOptions(options), queryClient);
    }

/**
 * Save face or body sample to the storage.
 * @summary save face/body sample
 */
export const saveSample = (
    samplesType: 'faces' | 'bodies',
    saveSampleBody: Blob,
    params?: SaveSampleParams,
 options?: SecondParameter<typeof lp5AxiosClient>,signal?: AbortSignal
) => {


      return lp5AxiosClient<BodySample>(
      {url: `/6/samples/${samplesType}`, method: 'POST',
      headers: {'Content-Type': 'image/jpeg', },
      data: saveSampleBody,
        params, signal
    },
      options);
    }




export const getSaveSampleMutationOptions = <TError = Error | AuthorizationErrorResponse | ForbiddenErrorWithLisResponse | RequestTimeoutResponse | PayloadToLargeResponse | InternalServerErrorResponse | ResponseTimeoutResponse | ServerTimeoutErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof saveSample>>, TError,{samplesType: 'faces' | 'bodies';data: Blob;params?: SaveSampleParams}, TContext>, request?: SecondParameter<typeof lp5AxiosClient>}
): UseMutationOptions<Awaited<ReturnType<typeof saveSample>>, TError,{samplesType: 'faces' | 'bodies';data: Blob;params?: SaveSampleParams}, TContext> => {

const mutationKey = ['saveSample'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof saveSample>>, {samplesType: 'faces' | 'bodies';data: Blob;params?: SaveSampleParams}> = (props) => {
          const {samplesType,data,params} = props ?? {};

          return  saveSample(samplesType,data,params,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type SaveSampleMutationResult = NonNullable<Awaited<ReturnType<typeof saveSample>>>
    export type SaveSampleMutationBody = Blob
    export type SaveSampleMutationError = Error | AuthorizationErrorResponse | ForbiddenErrorWithLisResponse | RequestTimeoutResponse | PayloadToLargeResponse | InternalServerErrorResponse | ResponseTimeoutResponse | ServerTimeoutErrorResponse

    /**
 * @summary save face/body sample
 */
export const useSaveSample = <TError = Error | AuthorizationErrorResponse | ForbiddenErrorWithLisResponse | RequestTimeoutResponse | PayloadToLargeResponse | InternalServerErrorResponse | ResponseTimeoutResponse | ServerTimeoutErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof saveSample>>, TError,{samplesType: 'faces' | 'bodies';data: Blob;params?: SaveSampleParams}, TContext>, request?: SecondParameter<typeof lp5AxiosClient>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof saveSample>>,
        TError,
        {samplesType: 'faces' | 'bodies';data: Blob;params?: SaveSampleParams},
        TContext
      > => {
      return useMutation(getSaveSampleMutationOptions(options), queryClient);
    }

/**
 * Get options for the resource.
 * @summary face/body samples options
 */
export const getSamplesOptions = (
    samplesType: 'faces' | 'bodies',
 options?: SecondParameter<typeof lp5AxiosClient>,signal?: AbortSignal
) => {


      return lp5AxiosClient<void>(
      {url: `/6/samples/${samplesType}`, method: 'OPTIONS', signal
    },
      options);
    }




export const getGetSamplesOptionsMutationOptions = <TError = RequestTimeoutResponse | InternalServerErrorResponse | ResponseTimeoutResponse | ServerTimeoutErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof getSamplesOptions>>, TError,{samplesType: 'faces' | 'bodies'}, TContext>, request?: SecondParameter<typeof lp5AxiosClient>}
): UseMutationOptions<Awaited<ReturnType<typeof getSamplesOptions>>, TError,{samplesType: 'faces' | 'bodies'}, TContext> => {

const mutationKey = ['getSamplesOptions'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof getSamplesOptions>>, {samplesType: 'faces' | 'bodies'}> = (props) => {
          const {samplesType} = props ?? {};

          return  getSamplesOptions(samplesType,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type GetSamplesOptionsMutationResult = NonNullable<Awaited<ReturnType<typeof getSamplesOptions>>>

    export type GetSamplesOptionsMutationError = RequestTimeoutResponse | InternalServerErrorResponse | ResponseTimeoutResponse | ServerTimeoutErrorResponse

    /**
 * @summary face/body samples options
 */
export const useGetSamplesOptions = <TError = RequestTimeoutResponse | InternalServerErrorResponse | ResponseTimeoutResponse | ServerTimeoutErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof getSamplesOptions>>, TError,{samplesType: 'faces' | 'bodies'}, TContext>, request?: SecondParameter<typeof lp5AxiosClient>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof getSamplesOptions>>,
        TError,
        {samplesType: 'faces' | 'bodies'},
        TContext
      > => {
      return useMutation(getGetSamplesOptionsMutationOptions(options), queryClient);
    }

/**
 * Get face or body sample by ID.
 * Returns its lifetime in `X-Luna-Expiry-Date` header.
 * @summary get face/body sample
 */
export const getSample = (
    samplesType: 'faces' | 'bodies',
    sampleId: Uuid,
 options?: SecondParameter<typeof lp5AxiosClient>,signal?: AbortSignal
) => {


      return lp5AxiosClient<Blob>(
      {url: `/6/samples/${samplesType}/${sampleId}`, method: 'GET',
        responseType: 'blob', signal
    },
      options);
    }




export const getGetSampleQueryKey = (samplesType: 'faces' | 'bodies',
    sampleId: Uuid,) => {
    return [
    `/6/samples/${samplesType}/${sampleId}`
    ] as const;
    }


export const getGetSampleQueryOptions = <TData = Awaited<ReturnType<typeof getSample>>, TError = AuthorizationErrorResponse | ForbiddenErrorWithLisResponse | Error | RequestTimeoutResponse | InternalServerErrorResponse | ResponseTimeoutResponse | ServerTimeoutErrorResponse>(samplesType: 'faces' | 'bodies',
    sampleId: Uuid, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getSample>>, TError, TData>>, request?: SecondParameter<typeof lp5AxiosClient>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetSampleQueryKey(samplesType,sampleId);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getSample>>> = ({ signal }) => getSample(samplesType,sampleId, requestOptions, signal);





   return  { queryKey, queryFn, enabled: samplesType !== null && samplesType !== undefined && sampleId !== null && sampleId !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getSample>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetSampleQueryResult = NonNullable<Awaited<ReturnType<typeof getSample>>>
export type GetSampleQueryError = AuthorizationErrorResponse | ForbiddenErrorWithLisResponse | Error | RequestTimeoutResponse | InternalServerErrorResponse | ResponseTimeoutResponse | ServerTimeoutErrorResponse


export function useGetSample<TData = Awaited<ReturnType<typeof getSample>>, TError = AuthorizationErrorResponse | ForbiddenErrorWithLisResponse | Error | RequestTimeoutResponse | InternalServerErrorResponse | ResponseTimeoutResponse | ServerTimeoutErrorResponse>(
 samplesType: 'faces' | 'bodies',
    sampleId: Uuid, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getSample>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getSample>>,
          TError,
          Awaited<ReturnType<typeof getSample>>
        > , 'initialData'
      >, request?: SecondParameter<typeof lp5AxiosClient>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetSample<TData = Awaited<ReturnType<typeof getSample>>, TError = AuthorizationErrorResponse | ForbiddenErrorWithLisResponse | Error | RequestTimeoutResponse | InternalServerErrorResponse | ResponseTimeoutResponse | ServerTimeoutErrorResponse>(
 samplesType: 'faces' | 'bodies',
    sampleId: Uuid, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getSample>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getSample>>,
          TError,
          Awaited<ReturnType<typeof getSample>>
        > , 'initialData'
      >, request?: SecondParameter<typeof lp5AxiosClient>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetSample<TData = Awaited<ReturnType<typeof getSample>>, TError = AuthorizationErrorResponse | ForbiddenErrorWithLisResponse | Error | RequestTimeoutResponse | InternalServerErrorResponse | ResponseTimeoutResponse | ServerTimeoutErrorResponse>(
 samplesType: 'faces' | 'bodies',
    sampleId: Uuid, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getSample>>, TError, TData>>, request?: SecondParameter<typeof lp5AxiosClient>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary get face/body sample
 */

export function useGetSample<TData = Awaited<ReturnType<typeof getSample>>, TError = AuthorizationErrorResponse | ForbiddenErrorWithLisResponse | Error | RequestTimeoutResponse | InternalServerErrorResponse | ResponseTimeoutResponse | ServerTimeoutErrorResponse>(
 samplesType: 'faces' | 'bodies',
    sampleId: Uuid, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getSample>>, TError, TData>>, request?: SecondParameter<typeof lp5AxiosClient>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetSampleQueryOptions(samplesType,sampleId,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}







/**
 * Check if face or body sample with `sample_id` exists.
 * Returns its lifetime in `X-Luna-Expiry-Date` header.
 * @summary check if face/body sample exists
 */
export const checkSample = (
    samplesType: 'faces' | 'bodies',
    sampleId: Uuid,
 options?: SecondParameter<typeof lp5AxiosClient>,signal?: AbortSignal
) => {


      return lp5AxiosClient<void>(
      {url: `/6/samples/${samplesType}/${sampleId}`, method: 'HEAD', signal
    },
      options);
    }




export const getCheckSampleMutationOptions = <TError = AuthorizationErrorWithoutBodyResponse | ForbiddenErrorWithoutBodyResponse | void | RequestTimeoutWithoutBodyResponse | InternalServerErrorWithoutBodyResponse | ResponseTimeoutWithoutBodyResponse | ServerTimeoutErrorWithoutBodyResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof checkSample>>, TError,{samplesType: 'faces' | 'bodies';sampleId: Uuid}, TContext>, request?: SecondParameter<typeof lp5AxiosClient>}
): UseMutationOptions<Awaited<ReturnType<typeof checkSample>>, TError,{samplesType: 'faces' | 'bodies';sampleId: Uuid}, TContext> => {

const mutationKey = ['checkSample'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof checkSample>>, {samplesType: 'faces' | 'bodies';sampleId: Uuid}> = (props) => {
          const {samplesType,sampleId} = props ?? {};

          return  checkSample(samplesType,sampleId,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type CheckSampleMutationResult = NonNullable<Awaited<ReturnType<typeof checkSample>>>

    export type CheckSampleMutationError = AuthorizationErrorWithoutBodyResponse | ForbiddenErrorWithoutBodyResponse | void | RequestTimeoutWithoutBodyResponse | InternalServerErrorWithoutBodyResponse | ResponseTimeoutWithoutBodyResponse | ServerTimeoutErrorWithoutBodyResponse

    /**
 * @summary check if face/body sample exists
 */
export const useCheckSample = <TError = AuthorizationErrorWithoutBodyResponse | ForbiddenErrorWithoutBodyResponse | void | RequestTimeoutWithoutBodyResponse | InternalServerErrorWithoutBodyResponse | ResponseTimeoutWithoutBodyResponse | ServerTimeoutErrorWithoutBodyResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof checkSample>>, TError,{samplesType: 'faces' | 'bodies';sampleId: Uuid}, TContext>, request?: SecondParameter<typeof lp5AxiosClient>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof checkSample>>,
        TError,
        {samplesType: 'faces' | 'bodies';sampleId: Uuid},
        TContext
      > => {
      return useMutation(getCheckSampleMutationOptions(options), queryClient);
    }

/**
 * Remove face or body sample by ID.
 * @summary remove face/body sample
 */
export const deleteSample = (
    samplesType: 'faces' | 'bodies',
    sampleId: Uuid,
 options?: SecondParameter<typeof lp5AxiosClient>,signal?: AbortSignal
) => {


      return lp5AxiosClient<void>(
      {url: `/6/samples/${samplesType}/${sampleId}`, method: 'DELETE', signal
    },
      options);
    }




export const getDeleteSampleMutationOptions = <TError = AuthorizationErrorResponse | ForbiddenErrorWithLisResponse | Error | RequestTimeoutResponse | InternalServerErrorResponse | ResponseTimeoutResponse | ServerTimeoutErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteSample>>, TError,{samplesType: 'faces' | 'bodies';sampleId: Uuid}, TContext>, request?: SecondParameter<typeof lp5AxiosClient>}
): UseMutationOptions<Awaited<ReturnType<typeof deleteSample>>, TError,{samplesType: 'faces' | 'bodies';sampleId: Uuid}, TContext> => {

const mutationKey = ['deleteSample'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof deleteSample>>, {samplesType: 'faces' | 'bodies';sampleId: Uuid}> = (props) => {
          const {samplesType,sampleId} = props ?? {};

          return  deleteSample(samplesType,sampleId,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type DeleteSampleMutationResult = NonNullable<Awaited<ReturnType<typeof deleteSample>>>

    export type DeleteSampleMutationError = AuthorizationErrorResponse | ForbiddenErrorWithLisResponse | Error | RequestTimeoutResponse | InternalServerErrorResponse | ResponseTimeoutResponse | ServerTimeoutErrorResponse

    /**
 * @summary remove face/body sample
 */
export const useDeleteSample = <TError = AuthorizationErrorResponse | ForbiddenErrorWithLisResponse | Error | RequestTimeoutResponse | InternalServerErrorResponse | ResponseTimeoutResponse | ServerTimeoutErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteSample>>, TError,{samplesType: 'faces' | 'bodies';sampleId: Uuid}, TContext>, request?: SecondParameter<typeof lp5AxiosClient>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof deleteSample>>,
        TError,
        {samplesType: 'faces' | 'bodies';sampleId: Uuid},
        TContext
      > => {
      return useMutation(getDeleteSampleMutationOptions(options), queryClient);
    }

/**
 * Get options for the resource.
 * @summary face/body sample options
 */
export const getSampleOptions = (
    samplesType: 'faces' | 'bodies',
    sampleId: Uuid,
 options?: SecondParameter<typeof lp5AxiosClient>,signal?: AbortSignal
) => {


      return lp5AxiosClient<void>(
      {url: `/6/samples/${samplesType}/${sampleId}`, method: 'OPTIONS', signal
    },
      options);
    }




export const getGetSampleOptionsMutationOptions = <TError = Error | RequestTimeoutResponse | InternalServerErrorResponse | ResponseTimeoutResponse | ServerTimeoutErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof getSampleOptions>>, TError,{samplesType: 'faces' | 'bodies';sampleId: Uuid}, TContext>, request?: SecondParameter<typeof lp5AxiosClient>}
): UseMutationOptions<Awaited<ReturnType<typeof getSampleOptions>>, TError,{samplesType: 'faces' | 'bodies';sampleId: Uuid}, TContext> => {

const mutationKey = ['getSampleOptions'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof getSampleOptions>>, {samplesType: 'faces' | 'bodies';sampleId: Uuid}> = (props) => {
          const {samplesType,sampleId} = props ?? {};

          return  getSampleOptions(samplesType,sampleId,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type GetSampleOptionsMutationResult = NonNullable<Awaited<ReturnType<typeof getSampleOptions>>>

    export type GetSampleOptionsMutationError = Error | RequestTimeoutResponse | InternalServerErrorResponse | ResponseTimeoutResponse | ServerTimeoutErrorResponse

    /**
 * @summary face/body sample options
 */
export const useGetSampleOptions = <TError = Error | RequestTimeoutResponse | InternalServerErrorResponse | ResponseTimeoutResponse | ServerTimeoutErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof getSampleOptions>>, TError,{samplesType: 'faces' | 'bodies';sampleId: Uuid}, TContext>, request?: SecondParameter<typeof lp5AxiosClient>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof getSampleOptions>>,
        TError,
        {samplesType: 'faces' | 'bodies';sampleId: Uuid},
        TContext
      > => {
      return useMutation(getGetSampleOptionsMutationOptions(options), queryClient);
    }

/**
 * Get sample by ID using previous API version.
 * Returns its lifetime in `X-Luna-Expiry-Date` header.
 * @deprecated
 * @summary get sample | previous version
 */
export const getSamplePrevious = (
    sampleId: Uuid,
 options?: SecondParameter<typeof lp5AxiosClient>,signal?: AbortSignal
) => {


      return lp5AxiosClient<Blob>(
      {url: `/5/samples/${sampleId}`, method: 'GET',
        responseType: 'blob', signal
    },
      options);
    }




export const getGetSamplePreviousQueryKey = (sampleId: Uuid,) => {
    return [
    `/5/samples/${sampleId}`
    ] as const;
    }


export const getGetSamplePreviousQueryOptions = <TData = Awaited<ReturnType<typeof getSamplePrevious>>, TError = AuthorizationErrorResponse | ForbiddenTasksErrorResponse | Error | RequestTimeoutResponse | InternalServerErrorResponse | ResponseTimeoutResponse | ServerTimeoutErrorResponse>(sampleId: Uuid, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getSamplePrevious>>, TError, TData>>, request?: SecondParameter<typeof lp5AxiosClient>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetSamplePreviousQueryKey(sampleId);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getSamplePrevious>>> = ({ signal }) => getSamplePrevious(sampleId, requestOptions, signal);





   return  { queryKey, queryFn, enabled: sampleId !== null && sampleId !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getSamplePrevious>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetSamplePreviousQueryResult = NonNullable<Awaited<ReturnType<typeof getSamplePrevious>>>
export type GetSamplePreviousQueryError = AuthorizationErrorResponse | ForbiddenTasksErrorResponse | Error | RequestTimeoutResponse | InternalServerErrorResponse | ResponseTimeoutResponse | ServerTimeoutErrorResponse


export function useGetSamplePrevious<TData = Awaited<ReturnType<typeof getSamplePrevious>>, TError = AuthorizationErrorResponse | ForbiddenTasksErrorResponse | Error | RequestTimeoutResponse | InternalServerErrorResponse | ResponseTimeoutResponse | ServerTimeoutErrorResponse>(
 sampleId: Uuid, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getSamplePrevious>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getSamplePrevious>>,
          TError,
          Awaited<ReturnType<typeof getSamplePrevious>>
        > , 'initialData'
      >, request?: SecondParameter<typeof lp5AxiosClient>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetSamplePrevious<TData = Awaited<ReturnType<typeof getSamplePrevious>>, TError = AuthorizationErrorResponse | ForbiddenTasksErrorResponse | Error | RequestTimeoutResponse | InternalServerErrorResponse | ResponseTimeoutResponse | ServerTimeoutErrorResponse>(
 sampleId: Uuid, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getSamplePrevious>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getSamplePrevious>>,
          TError,
          Awaited<ReturnType<typeof getSamplePrevious>>
        > , 'initialData'
      >, request?: SecondParameter<typeof lp5AxiosClient>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetSamplePrevious<TData = Awaited<ReturnType<typeof getSamplePrevious>>, TError = AuthorizationErrorResponse | ForbiddenTasksErrorResponse | Error | RequestTimeoutResponse | InternalServerErrorResponse | ResponseTimeoutResponse | ServerTimeoutErrorResponse>(
 sampleId: Uuid, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getSamplePrevious>>, TError, TData>>, request?: SecondParameter<typeof lp5AxiosClient>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @deprecated
 * @summary get sample | previous version
 */

export function useGetSamplePrevious<TData = Awaited<ReturnType<typeof getSamplePrevious>>, TError = AuthorizationErrorResponse | ForbiddenTasksErrorResponse | Error | RequestTimeoutResponse | InternalServerErrorResponse | ResponseTimeoutResponse | ServerTimeoutErrorResponse>(
 sampleId: Uuid, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getSamplePrevious>>, TError, TData>>, request?: SecondParameter<typeof lp5AxiosClient>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetSamplePreviousQueryOptions(sampleId,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}







/**
 * Check if face or body sample with `sample_id` exists using previous API version.
 * Returns its lifetime in `X-Luna-Expiry-Date` header.
 * @deprecated
 * @summary check if sample exists | previous version
 */
export const checkSamplePrevious = (
    sampleId: Uuid,
 options?: SecondParameter<typeof lp5AxiosClient>,signal?: AbortSignal
) => {


      return lp5AxiosClient<void>(
      {url: `/5/samples/${sampleId}`, method: 'HEAD', signal
    },
      options);
    }




export const getCheckSamplePreviousMutationOptions = <TError = AuthorizationErrorWithoutBodyResponse | ForbiddenErrorWithoutBodyResponse | void | RequestTimeoutWithoutBodyResponse | InternalServerErrorWithoutBodyResponse | ResponseTimeoutWithoutBodyResponse | ServerTimeoutErrorWithoutBodyResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof checkSamplePrevious>>, TError,{sampleId: Uuid}, TContext>, request?: SecondParameter<typeof lp5AxiosClient>}
): UseMutationOptions<Awaited<ReturnType<typeof checkSamplePrevious>>, TError,{sampleId: Uuid}, TContext> => {

const mutationKey = ['checkSamplePrevious'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof checkSamplePrevious>>, {sampleId: Uuid}> = (props) => {
          const {sampleId} = props ?? {};

          return  checkSamplePrevious(sampleId,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type CheckSamplePreviousMutationResult = NonNullable<Awaited<ReturnType<typeof checkSamplePrevious>>>

    export type CheckSamplePreviousMutationError = AuthorizationErrorWithoutBodyResponse | ForbiddenErrorWithoutBodyResponse | void | RequestTimeoutWithoutBodyResponse | InternalServerErrorWithoutBodyResponse | ResponseTimeoutWithoutBodyResponse | ServerTimeoutErrorWithoutBodyResponse

    /**
 * @deprecated
 * @summary check if sample exists | previous version
 */
export const useCheckSamplePrevious = <TError = AuthorizationErrorWithoutBodyResponse | ForbiddenErrorWithoutBodyResponse | void | RequestTimeoutWithoutBodyResponse | InternalServerErrorWithoutBodyResponse | ResponseTimeoutWithoutBodyResponse | ServerTimeoutErrorWithoutBodyResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof checkSamplePrevious>>, TError,{sampleId: Uuid}, TContext>, request?: SecondParameter<typeof lp5AxiosClient>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof checkSamplePrevious>>,
        TError,
        {sampleId: Uuid},
        TContext
      > => {
      return useMutation(getCheckSamplePreviousMutationOptions(options), queryClient);
    }

/**
 * Remove sample by ID using previous API version.
 * @deprecated
 * @summary remove sample | previous version
 */
export const deleteSamplePrevious = (
    sampleId: Uuid,
 options?: SecondParameter<typeof lp5AxiosClient>,signal?: AbortSignal
) => {


      return lp5AxiosClient<void>(
      {url: `/5/samples/${sampleId}`, method: 'DELETE', signal
    },
      options);
    }




export const getDeleteSamplePreviousMutationOptions = <TError = AuthorizationErrorResponse | ForbiddenErrorWithLisResponse | Error | RequestTimeoutResponse | InternalServerErrorResponse | ResponseTimeoutResponse | ServerTimeoutErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteSamplePrevious>>, TError,{sampleId: Uuid}, TContext>, request?: SecondParameter<typeof lp5AxiosClient>}
): UseMutationOptions<Awaited<ReturnType<typeof deleteSamplePrevious>>, TError,{sampleId: Uuid}, TContext> => {

const mutationKey = ['deleteSamplePrevious'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof deleteSamplePrevious>>, {sampleId: Uuid}> = (props) => {
          const {sampleId} = props ?? {};

          return  deleteSamplePrevious(sampleId,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type DeleteSamplePreviousMutationResult = NonNullable<Awaited<ReturnType<typeof deleteSamplePrevious>>>

    export type DeleteSamplePreviousMutationError = AuthorizationErrorResponse | ForbiddenErrorWithLisResponse | Error | RequestTimeoutResponse | InternalServerErrorResponse | ResponseTimeoutResponse | ServerTimeoutErrorResponse

    /**
 * @deprecated
 * @summary remove sample | previous version
 */
export const useDeleteSamplePrevious = <TError = AuthorizationErrorResponse | ForbiddenErrorWithLisResponse | Error | RequestTimeoutResponse | InternalServerErrorResponse | ResponseTimeoutResponse | ServerTimeoutErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteSamplePrevious>>, TError,{sampleId: Uuid}, TContext>, request?: SecondParameter<typeof lp5AxiosClient>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof deleteSamplePrevious>>,
        TError,
        {sampleId: Uuid},
        TContext
      > => {
      return useMutation(getDeleteSamplePreviousMutationOptions(options), queryClient);
    }

/**
 * Get options for the resource using previous API version.
 * @deprecated
 * @summary sample options | previous version
 */
export const getSamplePreviousOptions = (
    sampleId: Uuid,
 options?: SecondParameter<typeof lp5AxiosClient>,signal?: AbortSignal
) => {


      return lp5AxiosClient<void>(
      {url: `/5/samples/${sampleId}`, method: 'OPTIONS', signal
    },
      options);
    }




export const getGetSamplePreviousOptionsMutationOptions = <TError = Error | RequestTimeoutResponse | InternalServerErrorResponse | ResponseTimeoutResponse | ServerTimeoutErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof getSamplePreviousOptions>>, TError,{sampleId: Uuid}, TContext>, request?: SecondParameter<typeof lp5AxiosClient>}
): UseMutationOptions<Awaited<ReturnType<typeof getSamplePreviousOptions>>, TError,{sampleId: Uuid}, TContext> => {

const mutationKey = ['getSamplePreviousOptions'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof getSamplePreviousOptions>>, {sampleId: Uuid}> = (props) => {
          const {sampleId} = props ?? {};

          return  getSamplePreviousOptions(sampleId,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type GetSamplePreviousOptionsMutationResult = NonNullable<Awaited<ReturnType<typeof getSamplePreviousOptions>>>

    export type GetSamplePreviousOptionsMutationError = Error | RequestTimeoutResponse | InternalServerErrorResponse | ResponseTimeoutResponse | ServerTimeoutErrorResponse

    /**
 * @deprecated
 * @summary sample options | previous version
 */
export const useGetSamplePreviousOptions = <TError = Error | RequestTimeoutResponse | InternalServerErrorResponse | ResponseTimeoutResponse | ServerTimeoutErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof getSamplePreviousOptions>>, TError,{sampleId: Uuid}, TContext>, request?: SecondParameter<typeof lp5AxiosClient>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof getSamplePreviousOptions>>,
        TError,
        {sampleId: Uuid},
        TContext
      > => {
      return useMutation(getGetSamplePreviousOptionsMutationOptions(options), queryClient);
    }

/**
 * Get a face sample by ID.
 * Returns its lifetime in `X-Luna-Expiry-Date` header.
 * @deprecated
 * @summary get sample | legacy
 */
export const getSampleLegacy = (
    sampleId: Uuid,
 options?: SecondParameter<typeof lp5AxiosClient>,signal?: AbortSignal
) => {


      return lp5AxiosClient<Blob>(
      {url: `/6/samples/${sampleId}`, method: 'GET',
        responseType: 'blob', signal
    },
      options);
    }




export const getGetSampleLegacyQueryKey = (sampleId: Uuid,) => {
    return [
    `/6/samples/${sampleId}`
    ] as const;
    }


export const getGetSampleLegacyQueryOptions = <TData = Awaited<ReturnType<typeof getSampleLegacy>>, TError = AuthorizationErrorResponse | ForbiddenErrorWithLisResponse | Error | RequestTimeoutResponse | InternalServerErrorResponse | ResponseTimeoutResponse | ServerTimeoutErrorResponse>(sampleId: Uuid, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getSampleLegacy>>, TError, TData>>, request?: SecondParameter<typeof lp5AxiosClient>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetSampleLegacyQueryKey(sampleId);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getSampleLegacy>>> = ({ signal }) => getSampleLegacy(sampleId, requestOptions, signal);





   return  { queryKey, queryFn, enabled: sampleId !== null && sampleId !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getSampleLegacy>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetSampleLegacyQueryResult = NonNullable<Awaited<ReturnType<typeof getSampleLegacy>>>
export type GetSampleLegacyQueryError = AuthorizationErrorResponse | ForbiddenErrorWithLisResponse | Error | RequestTimeoutResponse | InternalServerErrorResponse | ResponseTimeoutResponse | ServerTimeoutErrorResponse


export function useGetSampleLegacy<TData = Awaited<ReturnType<typeof getSampleLegacy>>, TError = AuthorizationErrorResponse | ForbiddenErrorWithLisResponse | Error | RequestTimeoutResponse | InternalServerErrorResponse | ResponseTimeoutResponse | ServerTimeoutErrorResponse>(
 sampleId: Uuid, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getSampleLegacy>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getSampleLegacy>>,
          TError,
          Awaited<ReturnType<typeof getSampleLegacy>>
        > , 'initialData'
      >, request?: SecondParameter<typeof lp5AxiosClient>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetSampleLegacy<TData = Awaited<ReturnType<typeof getSampleLegacy>>, TError = AuthorizationErrorResponse | ForbiddenErrorWithLisResponse | Error | RequestTimeoutResponse | InternalServerErrorResponse | ResponseTimeoutResponse | ServerTimeoutErrorResponse>(
 sampleId: Uuid, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getSampleLegacy>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getSampleLegacy>>,
          TError,
          Awaited<ReturnType<typeof getSampleLegacy>>
        > , 'initialData'
      >, request?: SecondParameter<typeof lp5AxiosClient>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetSampleLegacy<TData = Awaited<ReturnType<typeof getSampleLegacy>>, TError = AuthorizationErrorResponse | ForbiddenErrorWithLisResponse | Error | RequestTimeoutResponse | InternalServerErrorResponse | ResponseTimeoutResponse | ServerTimeoutErrorResponse>(
 sampleId: Uuid, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getSampleLegacy>>, TError, TData>>, request?: SecondParameter<typeof lp5AxiosClient>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @deprecated
 * @summary get sample | legacy
 */

export function useGetSampleLegacy<TData = Awaited<ReturnType<typeof getSampleLegacy>>, TError = AuthorizationErrorResponse | ForbiddenErrorWithLisResponse | Error | RequestTimeoutResponse | InternalServerErrorResponse | ResponseTimeoutResponse | ServerTimeoutErrorResponse>(
 sampleId: Uuid, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getSampleLegacy>>, TError, TData>>, request?: SecondParameter<typeof lp5AxiosClient>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetSampleLegacyQueryOptions(sampleId,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}







/**
 * Check if face sample with `sample_id` exists.
 * Returns its lifetime in `X-Luna-Expiry-Date` header.
 * @deprecated
 * @summary check if face sample exists | legacy
 */
export const checkSampleLegacy = (
    sampleId: Uuid,
 options?: SecondParameter<typeof lp5AxiosClient>,signal?: AbortSignal
) => {


      return lp5AxiosClient<void>(
      {url: `/6/samples/${sampleId}`, method: 'HEAD', signal
    },
      options);
    }




export const getCheckSampleLegacyMutationOptions = <TError = AuthorizationErrorWithoutBodyResponse | ForbiddenErrorWithoutBodyResponse | void | RequestTimeoutWithoutBodyResponse | InternalServerErrorWithoutBodyResponse | ResponseTimeoutWithoutBodyResponse | ServerTimeoutErrorWithoutBodyResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof checkSampleLegacy>>, TError,{sampleId: Uuid}, TContext>, request?: SecondParameter<typeof lp5AxiosClient>}
): UseMutationOptions<Awaited<ReturnType<typeof checkSampleLegacy>>, TError,{sampleId: Uuid}, TContext> => {

const mutationKey = ['checkSampleLegacy'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof checkSampleLegacy>>, {sampleId: Uuid}> = (props) => {
          const {sampleId} = props ?? {};

          return  checkSampleLegacy(sampleId,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type CheckSampleLegacyMutationResult = NonNullable<Awaited<ReturnType<typeof checkSampleLegacy>>>

    export type CheckSampleLegacyMutationError = AuthorizationErrorWithoutBodyResponse | ForbiddenErrorWithoutBodyResponse | void | RequestTimeoutWithoutBodyResponse | InternalServerErrorWithoutBodyResponse | ResponseTimeoutWithoutBodyResponse | ServerTimeoutErrorWithoutBodyResponse

    /**
 * @deprecated
 * @summary check if face sample exists | legacy
 */
export const useCheckSampleLegacy = <TError = AuthorizationErrorWithoutBodyResponse | ForbiddenErrorWithoutBodyResponse | void | RequestTimeoutWithoutBodyResponse | InternalServerErrorWithoutBodyResponse | ResponseTimeoutWithoutBodyResponse | ServerTimeoutErrorWithoutBodyResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof checkSampleLegacy>>, TError,{sampleId: Uuid}, TContext>, request?: SecondParameter<typeof lp5AxiosClient>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof checkSampleLegacy>>,
        TError,
        {sampleId: Uuid},
        TContext
      > => {
      return useMutation(getCheckSampleLegacyMutationOptions(options), queryClient);
    }

/**
 * Remove sample by ID.
 * @deprecated
 * @summary remove face sample | legacy
 */
export const deleteSampleLegacy = (
    sampleId: Uuid,
 options?: SecondParameter<typeof lp5AxiosClient>,signal?: AbortSignal
) => {


      return lp5AxiosClient<void>(
      {url: `/6/samples/${sampleId}`, method: 'DELETE', signal
    },
      options);
    }




export const getDeleteSampleLegacyMutationOptions = <TError = AuthorizationErrorResponse | ForbiddenErrorWithLisResponse | Error | RequestTimeoutResponse | InternalServerErrorResponse | ResponseTimeoutResponse | ServerTimeoutErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteSampleLegacy>>, TError,{sampleId: Uuid}, TContext>, request?: SecondParameter<typeof lp5AxiosClient>}
): UseMutationOptions<Awaited<ReturnType<typeof deleteSampleLegacy>>, TError,{sampleId: Uuid}, TContext> => {

const mutationKey = ['deleteSampleLegacy'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof deleteSampleLegacy>>, {sampleId: Uuid}> = (props) => {
          const {sampleId} = props ?? {};

          return  deleteSampleLegacy(sampleId,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type DeleteSampleLegacyMutationResult = NonNullable<Awaited<ReturnType<typeof deleteSampleLegacy>>>

    export type DeleteSampleLegacyMutationError = AuthorizationErrorResponse | ForbiddenErrorWithLisResponse | Error | RequestTimeoutResponse | InternalServerErrorResponse | ResponseTimeoutResponse | ServerTimeoutErrorResponse

    /**
 * @deprecated
 * @summary remove face sample | legacy
 */
export const useDeleteSampleLegacy = <TError = AuthorizationErrorResponse | ForbiddenErrorWithLisResponse | Error | RequestTimeoutResponse | InternalServerErrorResponse | ResponseTimeoutResponse | ServerTimeoutErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteSampleLegacy>>, TError,{sampleId: Uuid}, TContext>, request?: SecondParameter<typeof lp5AxiosClient>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof deleteSampleLegacy>>,
        TError,
        {sampleId: Uuid},
        TContext
      > => {
      return useMutation(getDeleteSampleLegacyMutationOptions(options), queryClient);
    }

/**
 * Get options for the resource.
 * @deprecated
 * @summary face sample options  | legacy
 */
export const getSampleOptionsLegacy = (
    sampleId: Uuid,
 options?: SecondParameter<typeof lp5AxiosClient>,signal?: AbortSignal
) => {


      return lp5AxiosClient<void>(
      {url: `/6/samples/${sampleId}`, method: 'OPTIONS', signal
    },
      options);
    }




export const getGetSampleOptionsLegacyMutationOptions = <TError = Error | RequestTimeoutResponse | InternalServerErrorResponse | ResponseTimeoutResponse | ServerTimeoutErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof getSampleOptionsLegacy>>, TError,{sampleId: Uuid}, TContext>, request?: SecondParameter<typeof lp5AxiosClient>}
): UseMutationOptions<Awaited<ReturnType<typeof getSampleOptionsLegacy>>, TError,{sampleId: Uuid}, TContext> => {

const mutationKey = ['getSampleOptionsLegacy'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof getSampleOptionsLegacy>>, {sampleId: Uuid}> = (props) => {
          const {sampleId} = props ?? {};

          return  getSampleOptionsLegacy(sampleId,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type GetSampleOptionsLegacyMutationResult = NonNullable<Awaited<ReturnType<typeof getSampleOptionsLegacy>>>

    export type GetSampleOptionsLegacyMutationError = Error | RequestTimeoutResponse | InternalServerErrorResponse | ResponseTimeoutResponse | ServerTimeoutErrorResponse

    /**
 * @deprecated
 * @summary face sample options  | legacy
 */
export const useGetSampleOptionsLegacy = <TError = Error | RequestTimeoutResponse | InternalServerErrorResponse | ResponseTimeoutResponse | ServerTimeoutErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof getSampleOptionsLegacy>>, TError,{sampleId: Uuid}, TContext>, request?: SecondParameter<typeof lp5AxiosClient>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof getSampleOptionsLegacy>>,
        TError,
        {sampleId: Uuid},
        TContext
      > => {
      return useMutation(getGetSampleOptionsLegacyMutationOptions(options), queryClient);
    }

/**
 * Save images with unique ID.
 * @summary create images
 */
export const createImages = (
    createImagesBody?: Blob,
    params?: CreateImagesParams,
 options?: SecondParameter<typeof lp5AxiosClient>,signal?: AbortSignal
) => {


      return lp5AxiosClient<ImagesCreationResponse>(
      {url: `/6/images`, method: 'POST',
      headers: {'Content-Type': 'image/jpeg', },
      data: createImagesBody,
        params, signal
    },
      options);
    }




export const getCreateImagesMutationOptions = <TError = Error | AuthorizationErrorResponse | ForbiddenErrorWithLisResponse | RequestTimeoutResponse | PayloadToLargeResponse | InternalServerErrorResponse | ResponseTimeoutResponse | ServerTimeoutErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createImages>>, TError,{data?: Blob;params?: CreateImagesParams}, TContext>, request?: SecondParameter<typeof lp5AxiosClient>}
): UseMutationOptions<Awaited<ReturnType<typeof createImages>>, TError,{data?: Blob;params?: CreateImagesParams}, TContext> => {

const mutationKey = ['createImages'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof createImages>>, {data?: Blob;params?: CreateImagesParams}> = (props) => {
          const {data,params} = props ?? {};

          return  createImages(data,params,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type CreateImagesMutationResult = NonNullable<Awaited<ReturnType<typeof createImages>>>
    export type CreateImagesMutationBody = Blob | undefined
    export type CreateImagesMutationError = Error | AuthorizationErrorResponse | ForbiddenErrorWithLisResponse | RequestTimeoutResponse | PayloadToLargeResponse | InternalServerErrorResponse | ResponseTimeoutResponse | ServerTimeoutErrorResponse

    /**
 * @summary create images
 */
export const useCreateImages = <TError = Error | AuthorizationErrorResponse | ForbiddenErrorWithLisResponse | RequestTimeoutResponse | PayloadToLargeResponse | InternalServerErrorResponse | ResponseTimeoutResponse | ServerTimeoutErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createImages>>, TError,{data?: Blob;params?: CreateImagesParams}, TContext>, request?: SecondParameter<typeof lp5AxiosClient>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof createImages>>,
        TError,
        {data?: Blob;params?: CreateImagesParams},
        TContext
      > => {
      return useMutation(getCreateImagesMutationOptions(options), queryClient);
    }

/**
 * Get options for the resource.
 * @summary images options
 */
export const getImagesOptions = (

 options?: SecondParameter<typeof lp5AxiosClient>,signal?: AbortSignal
) => {


      return lp5AxiosClient<void>(
      {url: `/6/images`, method: 'OPTIONS', signal
    },
      options);
    }




export const getGetImagesOptionsMutationOptions = <TError = RequestTimeoutResponse | InternalServerErrorResponse | ResponseTimeoutResponse | ServerTimeoutErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof getImagesOptions>>, TError,void, TContext>, request?: SecondParameter<typeof lp5AxiosClient>}
): UseMutationOptions<Awaited<ReturnType<typeof getImagesOptions>>, TError,void, TContext> => {

const mutationKey = ['getImagesOptions'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof getImagesOptions>>, void> = () => {


          return  getImagesOptions(requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type GetImagesOptionsMutationResult = NonNullable<Awaited<ReturnType<typeof getImagesOptions>>>

    export type GetImagesOptionsMutationError = RequestTimeoutResponse | InternalServerErrorResponse | ResponseTimeoutResponse | ServerTimeoutErrorResponse

    /**
 * @summary images options
 */
export const useGetImagesOptions = <TError = RequestTimeoutResponse | InternalServerErrorResponse | ResponseTimeoutResponse | ServerTimeoutErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof getImagesOptions>>, TError,void, TContext>, request?: SecondParameter<typeof lp5AxiosClient>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof getImagesOptions>>,
        TError,
        void,
        TContext
      > => {
      return useMutation(getGetImagesOptionsMutationOptions(options), queryClient);
    }

/**
 * Check if image with `image_id` exists.
 * Returns its lifetime in `X-Luna-Expiry-Date` header.
 * @summary check if image exists
 */
export const checkImage = (
    imageId: Uuid & unknown,
    params?: CheckImageParams,
 options?: SecondParameter<typeof lp5AxiosClient>,signal?: AbortSignal
) => {


      return lp5AxiosClient<void>(
      {url: `/6/images/${imageId}`, method: 'HEAD',
        params, signal
    },
      options);
    }




export const getCheckImageMutationOptions = <TError = AuthorizationErrorWithoutBodyResponse | ForbiddenErrorWithoutBodyResponse | void | RequestTimeoutWithoutBodyResponse | InternalServerErrorWithoutBodyResponse | ResponseTimeoutWithoutBodyResponse | ServerTimeoutErrorWithoutBodyResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof checkImage>>, TError,{imageId: Uuid & unknown;params?: CheckImageParams}, TContext>, request?: SecondParameter<typeof lp5AxiosClient>}
): UseMutationOptions<Awaited<ReturnType<typeof checkImage>>, TError,{imageId: Uuid & unknown;params?: CheckImageParams}, TContext> => {

const mutationKey = ['checkImage'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof checkImage>>, {imageId: Uuid & unknown;params?: CheckImageParams}> = (props) => {
          const {imageId,params} = props ?? {};

          return  checkImage(imageId,params,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type CheckImageMutationResult = NonNullable<Awaited<ReturnType<typeof checkImage>>>

    export type CheckImageMutationError = AuthorizationErrorWithoutBodyResponse | ForbiddenErrorWithoutBodyResponse | void | RequestTimeoutWithoutBodyResponse | InternalServerErrorWithoutBodyResponse | ResponseTimeoutWithoutBodyResponse | ServerTimeoutErrorWithoutBodyResponse

    /**
 * @summary check if image exists
 */
export const useCheckImage = <TError = AuthorizationErrorWithoutBodyResponse | ForbiddenErrorWithoutBodyResponse | void | RequestTimeoutWithoutBodyResponse | InternalServerErrorWithoutBodyResponse | ResponseTimeoutWithoutBodyResponse | ServerTimeoutErrorWithoutBodyResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof checkImage>>, TError,{imageId: Uuid & unknown;params?: CheckImageParams}, TContext>, request?: SecondParameter<typeof lp5AxiosClient>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof checkImage>>,
        TError,
        {imageId: Uuid & unknown;params?: CheckImageParams},
        TContext
      > => {
      return useMutation(getCheckImageMutationOptions(options), queryClient);
    }

/**
 * Delete an image.
 * @summary delete image
 */
export const deleteImage = (
    imageId: Uuid & unknown,
 options?: SecondParameter<typeof lp5AxiosClient>,signal?: AbortSignal
) => {


      return lp5AxiosClient<void>(
      {url: `/6/images/${imageId}`, method: 'DELETE', signal
    },
      options);
    }




export const getDeleteImageMutationOptions = <TError = AuthorizationErrorResponse | ForbiddenErrorWithLisResponse | ImageNotFoundResponse | RequestTimeoutResponse | InternalServerErrorResponse | ResponseTimeoutResponse | ServerTimeoutErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteImage>>, TError,{imageId: Uuid & unknown}, TContext>, request?: SecondParameter<typeof lp5AxiosClient>}
): UseMutationOptions<Awaited<ReturnType<typeof deleteImage>>, TError,{imageId: Uuid & unknown}, TContext> => {

const mutationKey = ['deleteImage'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof deleteImage>>, {imageId: Uuid & unknown}> = (props) => {
          const {imageId} = props ?? {};

          return  deleteImage(imageId,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type DeleteImageMutationResult = NonNullable<Awaited<ReturnType<typeof deleteImage>>>

    export type DeleteImageMutationError = AuthorizationErrorResponse | ForbiddenErrorWithLisResponse | ImageNotFoundResponse | RequestTimeoutResponse | InternalServerErrorResponse | ResponseTimeoutResponse | ServerTimeoutErrorResponse

    /**
 * @summary delete image
 */
export const useDeleteImage = <TError = AuthorizationErrorResponse | ForbiddenErrorWithLisResponse | ImageNotFoundResponse | RequestTimeoutResponse | InternalServerErrorResponse | ResponseTimeoutResponse | ServerTimeoutErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteImage>>, TError,{imageId: Uuid & unknown}, TContext>, request?: SecondParameter<typeof lp5AxiosClient>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof deleteImage>>,
        TError,
        {imageId: Uuid & unknown},
        TContext
      > => {
      return useMutation(getDeleteImageMutationOptions(options), queryClient);
    }

/**
 * Receive an origin image.
 * Returns its lifetime in `X-Luna-Expiry-Date` header.
 * @summary get image
 */
export const getImage = (
    imageId: Uuid & unknown,
    params?: GetImageParams,
 options?: SecondParameter<typeof lp5AxiosClient>,signal?: AbortSignal
) => {


      return lp5AxiosClient<Blob>(
      {url: `/6/images/${imageId}`, method: 'GET',
        params,
        responseType: 'blob', signal
    },
      options);
    }




export const getGetImageQueryKey = (imageId: Uuid & unknown,
    params?: GetImageParams,) => {
    return [
    `/6/images/${imageId}`, ...(params ? [params] : [])
    ] as const;
    }


export const getGetImageQueryOptions = <TData = Awaited<ReturnType<typeof getImage>>, TError = AuthorizationErrorResponse | ForbiddenErrorWithLisResponse | ImageNotFoundResponse | RequestTimeoutResponse | InternalServerErrorResponse | ResponseTimeoutResponse | ServerTimeoutErrorResponse>(imageId: Uuid & unknown,
    params?: GetImageParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getImage>>, TError, TData>>, request?: SecondParameter<typeof lp5AxiosClient>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetImageQueryKey(imageId,params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getImage>>> = ({ signal }) => getImage(imageId,params, requestOptions, signal);





   return  { queryKey, queryFn, enabled: imageId !== null && imageId !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getImage>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetImageQueryResult = NonNullable<Awaited<ReturnType<typeof getImage>>>
export type GetImageQueryError = AuthorizationErrorResponse | ForbiddenErrorWithLisResponse | ImageNotFoundResponse | RequestTimeoutResponse | InternalServerErrorResponse | ResponseTimeoutResponse | ServerTimeoutErrorResponse


export function useGetImage<TData = Awaited<ReturnType<typeof getImage>>, TError = AuthorizationErrorResponse | ForbiddenErrorWithLisResponse | ImageNotFoundResponse | RequestTimeoutResponse | InternalServerErrorResponse | ResponseTimeoutResponse | ServerTimeoutErrorResponse>(
 imageId: Uuid & unknown,
    params: undefined |  GetImageParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getImage>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getImage>>,
          TError,
          Awaited<ReturnType<typeof getImage>>
        > , 'initialData'
      >, request?: SecondParameter<typeof lp5AxiosClient>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetImage<TData = Awaited<ReturnType<typeof getImage>>, TError = AuthorizationErrorResponse | ForbiddenErrorWithLisResponse | ImageNotFoundResponse | RequestTimeoutResponse | InternalServerErrorResponse | ResponseTimeoutResponse | ServerTimeoutErrorResponse>(
 imageId: Uuid & unknown,
    params?: GetImageParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getImage>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getImage>>,
          TError,
          Awaited<ReturnType<typeof getImage>>
        > , 'initialData'
      >, request?: SecondParameter<typeof lp5AxiosClient>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetImage<TData = Awaited<ReturnType<typeof getImage>>, TError = AuthorizationErrorResponse | ForbiddenErrorWithLisResponse | ImageNotFoundResponse | RequestTimeoutResponse | InternalServerErrorResponse | ResponseTimeoutResponse | ServerTimeoutErrorResponse>(
 imageId: Uuid & unknown,
    params?: GetImageParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getImage>>, TError, TData>>, request?: SecondParameter<typeof lp5AxiosClient>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary get image
 */

export function useGetImage<TData = Awaited<ReturnType<typeof getImage>>, TError = AuthorizationErrorResponse | ForbiddenErrorWithLisResponse | ImageNotFoundResponse | RequestTimeoutResponse | InternalServerErrorResponse | ResponseTimeoutResponse | ServerTimeoutErrorResponse>(
 imageId: Uuid & unknown,
    params?: GetImageParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getImage>>, TError, TData>>, request?: SecondParameter<typeof lp5AxiosClient>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetImageQueryOptions(imageId,params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}







/**
 * Get options for the resource.
 * @summary image options
 */
export const getImageOptions = (
    imageId: Uuid & unknown,
 options?: SecondParameter<typeof lp5AxiosClient>,signal?: AbortSignal
) => {


      return lp5AxiosClient<void>(
      {url: `/6/images/${imageId}`, method: 'OPTIONS', signal
    },
      options);
    }




export const getGetImageOptionsMutationOptions = <TError = RequestTimeoutResponse | InternalServerErrorResponse | ResponseTimeoutResponse | ServerTimeoutErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof getImageOptions>>, TError,{imageId: Uuid & unknown}, TContext>, request?: SecondParameter<typeof lp5AxiosClient>}
): UseMutationOptions<Awaited<ReturnType<typeof getImageOptions>>, TError,{imageId: Uuid & unknown}, TContext> => {

const mutationKey = ['getImageOptions'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof getImageOptions>>, {imageId: Uuid & unknown}> = (props) => {
          const {imageId} = props ?? {};

          return  getImageOptions(imageId,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type GetImageOptionsMutationResult = NonNullable<Awaited<ReturnType<typeof getImageOptions>>>

    export type GetImageOptionsMutationError = RequestTimeoutResponse | InternalServerErrorResponse | ResponseTimeoutResponse | ServerTimeoutErrorResponse

    /**
 * @summary image options
 */
export const useGetImageOptions = <TError = RequestTimeoutResponse | InternalServerErrorResponse | ResponseTimeoutResponse | ServerTimeoutErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof getImageOptions>>, TError,{imageId: Uuid & unknown}, TContext>, request?: SecondParameter<typeof lp5AxiosClient>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof getImageOptions>>,
        TError,
        {imageId: Uuid & unknown},
        TContext
      > => {
      return useMutation(getGetImageOptionsMutationOptions(options), queryClient);
    }

/**
 * The platform supports folder creation both in the local file system and in S3-compatible storage systems.
 *
 * Folder Name Restrictions
 *
 *   - The folder name must match the following regular expression:
 *     `[a-zA-Z0-9-_.,;]{1,1024}`
 *     Allowed characters: Latin letters (a-z, A-Z), digits (0-9), hyphen (-), underscore (_), period (.), comma (,), semicolon (;).
 *     Name length: from 1 to 1024 characters.
 *
 *   - System limitations:
 *     The maximum folder name length may be restricted by the operating system or storage type:
 *       - On most Linux systems, the maximum length for a file or folder name is 255 bytes.
 *       - In S3-compatible storage, the maximum object name length is typically 1024 bytes.
 *       - If the system or storage limitation is lower, it takes precedence over the regular expression.
 *
 *   - Example:
 *     If the name matches the regular expression but exceeds the system limitation, folder creation will fail with an error.
 *
 *   **Note**: The folder is physically saved in the storage with `luna_folder_` prefix. So the folder created upon making POST request to the
 *     route /images/folders/test_folder will appear in the storage as luna_folder_test_folder folder. Meanwhile you still
 *     have to use its original name for accessing it, so calling /images/folders/luna_folder_test_folder in order to access test_folder
 *     is incorrect and will lead to 404 error.
 *
 *   **Warning**: Please be aware that creating a folder for images won't automatically guarantee that there only be
 *     images inside the folder, nevertheless the standard check of content-type will be applied upon putting images
 *     into the folder through `images/folders/{folder_name}/{object_path}` route.
 * @summary create images folder
 */
export const createImagesFolder = (
    folderName: string,
    params?: CreateImagesFolderParams,
 options?: SecondParameter<typeof lp5AxiosClient>,signal?: AbortSignal
) => {


      return lp5AxiosClient<void>(
      {url: `/6/images/folders/${folderName}`, method: 'POST',
        params, signal
    },
      options);
    }




export const getCreateImagesFolderMutationOptions = <TError = Error | AuthorizationErrorResponse | ForbiddenErrorWithLisResponse | RequestTimeoutResponse | InternalServerErrorResponse | ResponseTimeoutResponse | ServerTimeoutErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createImagesFolder>>, TError,{folderName: string;params?: CreateImagesFolderParams}, TContext>, request?: SecondParameter<typeof lp5AxiosClient>}
): UseMutationOptions<Awaited<ReturnType<typeof createImagesFolder>>, TError,{folderName: string;params?: CreateImagesFolderParams}, TContext> => {

const mutationKey = ['createImagesFolder'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof createImagesFolder>>, {folderName: string;params?: CreateImagesFolderParams}> = (props) => {
          const {folderName,params} = props ?? {};

          return  createImagesFolder(folderName,params,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type CreateImagesFolderMutationResult = NonNullable<Awaited<ReturnType<typeof createImagesFolder>>>

    export type CreateImagesFolderMutationError = Error | AuthorizationErrorResponse | ForbiddenErrorWithLisResponse | RequestTimeoutResponse | InternalServerErrorResponse | ResponseTimeoutResponse | ServerTimeoutErrorResponse

    /**
 * @summary create images folder
 */
export const useCreateImagesFolder = <TError = Error | AuthorizationErrorResponse | ForbiddenErrorWithLisResponse | RequestTimeoutResponse | InternalServerErrorResponse | ResponseTimeoutResponse | ServerTimeoutErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createImagesFolder>>, TError,{folderName: string;params?: CreateImagesFolderParams}, TContext>, request?: SecondParameter<typeof lp5AxiosClient>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof createImagesFolder>>,
        TError,
        {folderName: string;params?: CreateImagesFolderParams},
        TContext
      > => {
      return useMutation(getCreateImagesFolderMutationOptions(options), queryClient);
    }

/**
 * OK response is returned if a folder with the specified name exists in the system.
 * @summary check if images folder exists
 */
export const checkImagesFolder = (
    folderName: string,
 options?: SecondParameter<typeof lp5AxiosClient>,signal?: AbortSignal
) => {


      return lp5AxiosClient<void>(
      {url: `/6/images/folders/${folderName}`, method: 'HEAD', signal
    },
      options);
    }




export const getCheckImagesFolderMutationOptions = <TError = void | AuthorizationErrorWithoutBodyResponse | ForbiddenErrorWithoutBodyResponse | FolderNotFoundResponse | RequestTimeoutWithoutBodyResponse | InternalServerErrorWithoutBodyResponse | ResponseTimeoutWithoutBodyResponse | ServerTimeoutErrorWithoutBodyResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof checkImagesFolder>>, TError,{folderName: string}, TContext>, request?: SecondParameter<typeof lp5AxiosClient>}
): UseMutationOptions<Awaited<ReturnType<typeof checkImagesFolder>>, TError,{folderName: string}, TContext> => {

const mutationKey = ['checkImagesFolder'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof checkImagesFolder>>, {folderName: string}> = (props) => {
          const {folderName} = props ?? {};

          return  checkImagesFolder(folderName,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type CheckImagesFolderMutationResult = NonNullable<Awaited<ReturnType<typeof checkImagesFolder>>>

    export type CheckImagesFolderMutationError = void | AuthorizationErrorWithoutBodyResponse | ForbiddenErrorWithoutBodyResponse | FolderNotFoundResponse | RequestTimeoutWithoutBodyResponse | InternalServerErrorWithoutBodyResponse | ResponseTimeoutWithoutBodyResponse | ServerTimeoutErrorWithoutBodyResponse

    /**
 * @summary check if images folder exists
 */
export const useCheckImagesFolder = <TError = void | AuthorizationErrorWithoutBodyResponse | ForbiddenErrorWithoutBodyResponse | FolderNotFoundResponse | RequestTimeoutWithoutBodyResponse | InternalServerErrorWithoutBodyResponse | ResponseTimeoutWithoutBodyResponse | ServerTimeoutErrorWithoutBodyResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof checkImagesFolder>>, TError,{folderName: string}, TContext>, request?: SecondParameter<typeof lp5AxiosClient>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof checkImagesFolder>>,
        TError,
        {folderName: string},
        TContext
      > => {
      return useMutation(getCheckImagesFolderMutationOptions(options), queryClient);
    }

/**
 * If a folder with the specified name exists in the system, OK response is returned along with the folder’s metadata.
 * @summary get images folder
 */
export const getImagesFolder = (
    folderName: string,
 options?: SecondParameter<typeof lp5AxiosClient>,signal?: AbortSignal
) => {


      return lp5AxiosClient<FolderInfo>(
      {url: `/6/images/folders/${folderName}`, method: 'GET', signal
    },
      options);
    }




export const getGetImagesFolderQueryKey = (folderName: string,) => {
    return [
    `/6/images/folders/${folderName}`
    ] as const;
    }


export const getGetImagesFolderQueryOptions = <TData = Awaited<ReturnType<typeof getImagesFolder>>, TError = Error | AuthorizationErrorResponse | ForbiddenErrorWithLisResponse | FolderNotFoundResponse | RequestTimeoutResponse | InternalServerErrorResponse | ResponseTimeoutResponse | ServerTimeoutErrorResponse>(folderName: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getImagesFolder>>, TError, TData>>, request?: SecondParameter<typeof lp5AxiosClient>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetImagesFolderQueryKey(folderName);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getImagesFolder>>> = ({ signal }) => getImagesFolder(folderName, requestOptions, signal);





   return  { queryKey, queryFn, enabled: folderName !== null && folderName !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getImagesFolder>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetImagesFolderQueryResult = NonNullable<Awaited<ReturnType<typeof getImagesFolder>>>
export type GetImagesFolderQueryError = Error | AuthorizationErrorResponse | ForbiddenErrorWithLisResponse | FolderNotFoundResponse | RequestTimeoutResponse | InternalServerErrorResponse | ResponseTimeoutResponse | ServerTimeoutErrorResponse


export function useGetImagesFolder<TData = Awaited<ReturnType<typeof getImagesFolder>>, TError = Error | AuthorizationErrorResponse | ForbiddenErrorWithLisResponse | FolderNotFoundResponse | RequestTimeoutResponse | InternalServerErrorResponse | ResponseTimeoutResponse | ServerTimeoutErrorResponse>(
 folderName: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getImagesFolder>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getImagesFolder>>,
          TError,
          Awaited<ReturnType<typeof getImagesFolder>>
        > , 'initialData'
      >, request?: SecondParameter<typeof lp5AxiosClient>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetImagesFolder<TData = Awaited<ReturnType<typeof getImagesFolder>>, TError = Error | AuthorizationErrorResponse | ForbiddenErrorWithLisResponse | FolderNotFoundResponse | RequestTimeoutResponse | InternalServerErrorResponse | ResponseTimeoutResponse | ServerTimeoutErrorResponse>(
 folderName: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getImagesFolder>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getImagesFolder>>,
          TError,
          Awaited<ReturnType<typeof getImagesFolder>>
        > , 'initialData'
      >, request?: SecondParameter<typeof lp5AxiosClient>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetImagesFolder<TData = Awaited<ReturnType<typeof getImagesFolder>>, TError = Error | AuthorizationErrorResponse | ForbiddenErrorWithLisResponse | FolderNotFoundResponse | RequestTimeoutResponse | InternalServerErrorResponse | ResponseTimeoutResponse | ServerTimeoutErrorResponse>(
 folderName: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getImagesFolder>>, TError, TData>>, request?: SecondParameter<typeof lp5AxiosClient>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary get images folder
 */

export function useGetImagesFolder<TData = Awaited<ReturnType<typeof getImagesFolder>>, TError = Error | AuthorizationErrorResponse | ForbiddenErrorWithLisResponse | FolderNotFoundResponse | RequestTimeoutResponse | InternalServerErrorResponse | ResponseTimeoutResponse | ServerTimeoutErrorResponse>(
 folderName: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getImagesFolder>>, TError, TData>>, request?: SecondParameter<typeof lp5AxiosClient>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetImagesFolderQueryOptions(folderName,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}







/**
 * Removes root folders along with all their contents and associated metadata.
 * Direct deletion of subfolders is not supported—this operation is allowed only for root folders.
 *
 * If the optional account_id query parameter is provided, the system will first check that the folder
 * belongs to the specified account_id. If the folder does not exist or does not belong to this account,
 * a 404 error will be returned.
 * @summary delete images folder
 */
export const deleteImagesFolder = (
    folderName: string,
 options?: SecondParameter<typeof lp5AxiosClient>,signal?: AbortSignal
) => {


      return lp5AxiosClient<void>(
      {url: `/6/images/folders/${folderName}`, method: 'DELETE', signal
    },
      options);
    }




export const getDeleteImagesFolderMutationOptions = <TError = Error | AuthorizationErrorResponse | ForbiddenErrorWithLisResponse | RequestTimeoutResponse | InternalServerErrorResponse | ResponseTimeoutResponse | ServerTimeoutErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteImagesFolder>>, TError,{folderName: string}, TContext>, request?: SecondParameter<typeof lp5AxiosClient>}
): UseMutationOptions<Awaited<ReturnType<typeof deleteImagesFolder>>, TError,{folderName: string}, TContext> => {

const mutationKey = ['deleteImagesFolder'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof deleteImagesFolder>>, {folderName: string}> = (props) => {
          const {folderName} = props ?? {};

          return  deleteImagesFolder(folderName,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type DeleteImagesFolderMutationResult = NonNullable<Awaited<ReturnType<typeof deleteImagesFolder>>>

    export type DeleteImagesFolderMutationError = Error | AuthorizationErrorResponse | ForbiddenErrorWithLisResponse | RequestTimeoutResponse | InternalServerErrorResponse | ResponseTimeoutResponse | ServerTimeoutErrorResponse

    /**
 * @summary delete images folder
 */
export const useDeleteImagesFolder = <TError = Error | AuthorizationErrorResponse | ForbiddenErrorWithLisResponse | RequestTimeoutResponse | InternalServerErrorResponse | ResponseTimeoutResponse | ServerTimeoutErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteImagesFolder>>, TError,{folderName: string}, TContext>, request?: SecondParameter<typeof lp5AxiosClient>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof deleteImagesFolder>>,
        TError,
        {folderName: string},
        TContext
      > => {
      return useMutation(getDeleteImagesFolderMutationOptions(options), queryClient);
    }

/**
 * Get options for the resource.
 * @summary images folders options
 */
export const imagesFolderOptions = (
    folderName: string,
 options?: SecondParameter<typeof lp5AxiosClient>,signal?: AbortSignal
) => {


      return lp5AxiosClient<void>(
      {url: `/6/images/folders/${folderName}`, method: 'OPTIONS', signal
    },
      options);
    }




export const getImagesFolderOptionsMutationOptions = <TError = RequestTimeoutResponse | InternalServerErrorResponse | ResponseTimeoutResponse | ServerTimeoutErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof imagesFolderOptions>>, TError,{folderName: string}, TContext>, request?: SecondParameter<typeof lp5AxiosClient>}
): UseMutationOptions<Awaited<ReturnType<typeof imagesFolderOptions>>, TError,{folderName: string}, TContext> => {

const mutationKey = ['imagesFolderOptions'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof imagesFolderOptions>>, {folderName: string}> = (props) => {
          const {folderName} = props ?? {};

          return  imagesFolderOptions(folderName,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type ImagesFolderOptionsMutationResult = NonNullable<Awaited<ReturnType<typeof imagesFolderOptions>>>

    export type ImagesFolderOptionsMutationError = RequestTimeoutResponse | InternalServerErrorResponse | ResponseTimeoutResponse | ServerTimeoutErrorResponse

    /**
 * @summary images folders options
 */
export const useImagesFolderOptions = <TError = RequestTimeoutResponse | InternalServerErrorResponse | ResponseTimeoutResponse | ServerTimeoutErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof imagesFolderOptions>>, TError,{folderName: string}, TContext>, request?: SecondParameter<typeof lp5AxiosClient>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof imagesFolderOptions>>,
        TError,
        {folderName: string},
        TContext
      > => {
      return useMutation(getImagesFolderOptionsMutationOptions(options), queryClient);
    }

/**
 * URI example: /6/images/folder/{subfolder}/{subfolder2}/.../{subfolderN}/{filename}
 * This endpoint is used to create a file by a specified path within a pre-created folder.
 * The main folder (folder in the uri example) must be created in advance using a POST request to the /folders endpoint.
 * All subsequent subfolders ({subfolder}, {subfolder2}, …, {subfolderN}) will be automatically created during file upload if they do not already exist.
 *
 * **Note**: Creating subfolders without a file is not allowed — this endpoint cannot be used to create empty directories.
 *
 * Rules and behavior:
 *
 * - The account_id of the user making the request must match the account_id of the folder owner.
 *
 * - If the Content-Type header is not provided, the system will try to infer the content type from the file extension ({filename}).
 *
 * - If both a Content-Type header and a file extension are provided, the header value takes precedence.
 *
 * - If neither a file extension nor a Content-Type header is provided, the request will fail with a 400 Bad Request error.
 * @summary put images within images folder
 */
export const putImagesInFolder = (
    folderName: string,
    objectPath: string,
    putImagesInFolderBody?: Blob,
    params?: PutImagesInFolderParams,
 options?: SecondParameter<typeof lp5AxiosClient>,signal?: AbortSignal
) => {


      return lp5AxiosClient<FolderObject>(
      {url: `/6/images/folders/${folderName}/${objectPath}`, method: 'PUT',
      headers: {'Content-Type': '*/*', },
      data: putImagesInFolderBody,
        params, signal
    },
      options);
    }




export const getPutImagesInFolderMutationOptions = <TError = Error | AuthorizationErrorResponse | ForbiddenErrorWithLisResponse | RequestTimeoutResponse | PayloadToLargeResponse | InternalServerErrorResponse | ResponseTimeoutResponse | ServerTimeoutErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof putImagesInFolder>>, TError,{folderName: string;objectPath: string;data?: Blob;params?: PutImagesInFolderParams}, TContext>, request?: SecondParameter<typeof lp5AxiosClient>}
): UseMutationOptions<Awaited<ReturnType<typeof putImagesInFolder>>, TError,{folderName: string;objectPath: string;data?: Blob;params?: PutImagesInFolderParams}, TContext> => {

const mutationKey = ['putImagesInFolder'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof putImagesInFolder>>, {folderName: string;objectPath: string;data?: Blob;params?: PutImagesInFolderParams}> = (props) => {
          const {folderName,objectPath,data,params} = props ?? {};

          return  putImagesInFolder(folderName,objectPath,data,params,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type PutImagesInFolderMutationResult = NonNullable<Awaited<ReturnType<typeof putImagesInFolder>>>
    export type PutImagesInFolderMutationBody = Blob | undefined
    export type PutImagesInFolderMutationError = Error | AuthorizationErrorResponse | ForbiddenErrorWithLisResponse | RequestTimeoutResponse | PayloadToLargeResponse | InternalServerErrorResponse | ResponseTimeoutResponse | ServerTimeoutErrorResponse

    /**
 * @summary put images within images folder
 */
export const usePutImagesInFolder = <TError = Error | AuthorizationErrorResponse | ForbiddenErrorWithLisResponse | RequestTimeoutResponse | PayloadToLargeResponse | InternalServerErrorResponse | ResponseTimeoutResponse | ServerTimeoutErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof putImagesInFolder>>, TError,{folderName: string;objectPath: string;data?: Blob;params?: PutImagesInFolderParams}, TContext>, request?: SecondParameter<typeof lp5AxiosClient>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof putImagesInFolder>>,
        TError,
        {folderName: string;objectPath: string;data?: Blob;params?: PutImagesInFolderParams},
        TContext
      > => {
      return useMutation(getPutImagesInFolderMutationOptions(options), queryClient);
    }

/**
 * Check image exists in folder.
 *
 * # ⚠️ Important: Account ID Requirements
 *
 * **Warning:** The folder must belong to the account ID passed in the query parameter.
 * The folder must have been created through the `/folders` endpoint using the same
 * account ID.
 *
 * If the account ID doesn't match the folder owner, you will receive a **404 error**
 * because no folder with that name exists under your account.
 *
 * ## Error Scenarios
 *
 * - **404 Not Found**: The folder does not exist or does not belong to the specified account ID
 * - Ensure the account ID in the query matches the account that created the folder
 * @summary check if image within folder exist
 */
export const checkImageInFolder = (
    folderName: string,
    objectPath: string,
    params?: CheckImageInFolderParams,
 options?: SecondParameter<typeof lp5AxiosClient>,signal?: AbortSignal
) => {


      return lp5AxiosClient<void>(
      {url: `/6/images/folders/${folderName}/${objectPath}`, method: 'HEAD',
        params, signal
    },
      options);
    }




export const getCheckImageInFolderMutationOptions = <TError = void | AuthorizationErrorWithoutBodyResponse | ForbiddenErrorWithoutBodyResponse | FolderNotFoundResponse | RequestTimeoutWithoutBodyResponse | InternalServerErrorWithoutBodyResponse | ResponseTimeoutWithoutBodyResponse | ServerTimeoutErrorWithoutBodyResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof checkImageInFolder>>, TError,{folderName: string;objectPath: string;params?: CheckImageInFolderParams}, TContext>, request?: SecondParameter<typeof lp5AxiosClient>}
): UseMutationOptions<Awaited<ReturnType<typeof checkImageInFolder>>, TError,{folderName: string;objectPath: string;params?: CheckImageInFolderParams}, TContext> => {

const mutationKey = ['checkImageInFolder'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof checkImageInFolder>>, {folderName: string;objectPath: string;params?: CheckImageInFolderParams}> = (props) => {
          const {folderName,objectPath,params} = props ?? {};

          return  checkImageInFolder(folderName,objectPath,params,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type CheckImageInFolderMutationResult = NonNullable<Awaited<ReturnType<typeof checkImageInFolder>>>

    export type CheckImageInFolderMutationError = void | AuthorizationErrorWithoutBodyResponse | ForbiddenErrorWithoutBodyResponse | FolderNotFoundResponse | RequestTimeoutWithoutBodyResponse | InternalServerErrorWithoutBodyResponse | ResponseTimeoutWithoutBodyResponse | ServerTimeoutErrorWithoutBodyResponse

    /**
 * @summary check if image within folder exist
 */
export const useCheckImageInFolder = <TError = void | AuthorizationErrorWithoutBodyResponse | ForbiddenErrorWithoutBodyResponse | FolderNotFoundResponse | RequestTimeoutWithoutBodyResponse | InternalServerErrorWithoutBodyResponse | ResponseTimeoutWithoutBodyResponse | ServerTimeoutErrorWithoutBodyResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof checkImageInFolder>>, TError,{folderName: string;objectPath: string;params?: CheckImageInFolderParams}, TContext>, request?: SecondParameter<typeof lp5AxiosClient>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof checkImageInFolder>>,
        TError,
        {folderName: string;objectPath: string;params?: CheckImageInFolderParams},
        TContext
      > => {
      return useMutation(getCheckImageInFolderMutationOptions(options), queryClient);
    }

/**
 * Receiving image from specified folder.
 *
 * # ⚠️ Important: Account ID Requirements
 *
 * **Warning:** The folder must belong to the account ID passed in headers.
 * The folder must have been created through the `/folders` endpoint using the same
 * account ID.
 *
 * If the account ID doesn't match the folder owner, you will receive a **404 error**
 * because no folder with that name exists under your account.
 *
 * ## Error Scenarios
 *
 * - **404 Not Found**: The folder does not exist or does not belong to the specified account ID
 * - Ensure the account ID matches the account that created the folder
 * @summary get image from folder
 */
export const getImageInFolder = (
    folderName: string,
    objectPath: string,
    params?: GetImageInFolderParams,
 options?: SecondParameter<typeof lp5AxiosClient>,signal?: AbortSignal
) => {


      return lp5AxiosClient<Blob>(
      {url: `/6/images/folders/${folderName}/${objectPath}`, method: 'GET',
        params,
        responseType: 'blob', signal
    },
      options);
    }




export const getGetImageInFolderQueryKey = (folderName: string,
    objectPath: string,
    params?: GetImageInFolderParams,) => {
    return [
    `/6/images/folders/${folderName}/${objectPath}`, ...(params ? [params] : [])
    ] as const;
    }


export const getGetImageInFolderQueryOptions = <TData = Awaited<ReturnType<typeof getImageInFolder>>, TError = Error | AuthorizationErrorResponse | ForbiddenErrorWithLisResponse | FolderNotFoundResponse | RequestTimeoutResponse | InternalServerErrorResponse | ResponseTimeoutResponse | ServerTimeoutErrorResponse>(folderName: string,
    objectPath: string,
    params?: GetImageInFolderParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getImageInFolder>>, TError, TData>>, request?: SecondParameter<typeof lp5AxiosClient>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetImageInFolderQueryKey(folderName,objectPath,params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getImageInFolder>>> = ({ signal }) => getImageInFolder(folderName,objectPath,params, requestOptions, signal);





   return  { queryKey, queryFn, enabled: folderName !== null && folderName !== undefined && objectPath !== null && objectPath !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getImageInFolder>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetImageInFolderQueryResult = NonNullable<Awaited<ReturnType<typeof getImageInFolder>>>
export type GetImageInFolderQueryError = Error | AuthorizationErrorResponse | ForbiddenErrorWithLisResponse | FolderNotFoundResponse | RequestTimeoutResponse | InternalServerErrorResponse | ResponseTimeoutResponse | ServerTimeoutErrorResponse


export function useGetImageInFolder<TData = Awaited<ReturnType<typeof getImageInFolder>>, TError = Error | AuthorizationErrorResponse | ForbiddenErrorWithLisResponse | FolderNotFoundResponse | RequestTimeoutResponse | InternalServerErrorResponse | ResponseTimeoutResponse | ServerTimeoutErrorResponse>(
 folderName: string,
    objectPath: string,
    params: undefined |  GetImageInFolderParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getImageInFolder>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getImageInFolder>>,
          TError,
          Awaited<ReturnType<typeof getImageInFolder>>
        > , 'initialData'
      >, request?: SecondParameter<typeof lp5AxiosClient>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetImageInFolder<TData = Awaited<ReturnType<typeof getImageInFolder>>, TError = Error | AuthorizationErrorResponse | ForbiddenErrorWithLisResponse | FolderNotFoundResponse | RequestTimeoutResponse | InternalServerErrorResponse | ResponseTimeoutResponse | ServerTimeoutErrorResponse>(
 folderName: string,
    objectPath: string,
    params?: GetImageInFolderParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getImageInFolder>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getImageInFolder>>,
          TError,
          Awaited<ReturnType<typeof getImageInFolder>>
        > , 'initialData'
      >, request?: SecondParameter<typeof lp5AxiosClient>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetImageInFolder<TData = Awaited<ReturnType<typeof getImageInFolder>>, TError = Error | AuthorizationErrorResponse | ForbiddenErrorWithLisResponse | FolderNotFoundResponse | RequestTimeoutResponse | InternalServerErrorResponse | ResponseTimeoutResponse | ServerTimeoutErrorResponse>(
 folderName: string,
    objectPath: string,
    params?: GetImageInFolderParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getImageInFolder>>, TError, TData>>, request?: SecondParameter<typeof lp5AxiosClient>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary get image from folder
 */

export function useGetImageInFolder<TData = Awaited<ReturnType<typeof getImageInFolder>>, TError = Error | AuthorizationErrorResponse | ForbiddenErrorWithLisResponse | FolderNotFoundResponse | RequestTimeoutResponse | InternalServerErrorResponse | ResponseTimeoutResponse | ServerTimeoutErrorResponse>(
 folderName: string,
    objectPath: string,
    params?: GetImageInFolderParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getImageInFolder>>, TError, TData>>, request?: SecondParameter<typeof lp5AxiosClient>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetImageInFolderQueryOptions(folderName,objectPath,params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}







/**
 * Removes subfolders along with all their contents and associated metadata.
 *
 * If a file path passed to the endpoint it will be the only one that deleted.
 *
 * If the optional account_id query parameter is provided, the system will first check that the subfolder
 * belongs to the specified account_id. If the subfolder does not exist or does not belong to this account,
 * a 404 error will be returned.
 *
 * > **WARNING** If no `recursive=1` flag passed in query, trying to delete non-empty folder will lead to 400 Error response.
 *
 * > **Note**: In S3-compatible storage, there is no direct concept of folders. Folders are represented by object key
 * prefixes. When the last object with a given subfolder path is deleted, that subfolder
 * (and any parent folders in the path) will no longer be accessible. The same applies to nested parent
 * folders—once all objects within them are deleted, those folders effectively cease to exist.
 * However, the root folder always remains present until it is explicitly deleted.
 * @summary delete image subfolders and images
 */
export const deleteImageInFolder = (
    folderName: string,
    objectPath: string,
    params?: DeleteImageInFolderParams,
 options?: SecondParameter<typeof lp5AxiosClient>,signal?: AbortSignal
) => {


      return lp5AxiosClient<void>(
      {url: `/6/images/folders/${folderName}/${objectPath}`, method: 'DELETE',
        params, signal
    },
      options);
    }




export const getDeleteImageInFolderMutationOptions = <TError = Error | AuthorizationErrorResponse | ForbiddenErrorWithLisResponse | FolderNotFoundResponse | RequestTimeoutResponse | InternalServerErrorResponse | ResponseTimeoutResponse | ServerTimeoutErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteImageInFolder>>, TError,{folderName: string;objectPath: string;params?: DeleteImageInFolderParams}, TContext>, request?: SecondParameter<typeof lp5AxiosClient>}
): UseMutationOptions<Awaited<ReturnType<typeof deleteImageInFolder>>, TError,{folderName: string;objectPath: string;params?: DeleteImageInFolderParams}, TContext> => {

const mutationKey = ['deleteImageInFolder'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof deleteImageInFolder>>, {folderName: string;objectPath: string;params?: DeleteImageInFolderParams}> = (props) => {
          const {folderName,objectPath,params} = props ?? {};

          return  deleteImageInFolder(folderName,objectPath,params,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type DeleteImageInFolderMutationResult = NonNullable<Awaited<ReturnType<typeof deleteImageInFolder>>>

    export type DeleteImageInFolderMutationError = Error | AuthorizationErrorResponse | ForbiddenErrorWithLisResponse | FolderNotFoundResponse | RequestTimeoutResponse | InternalServerErrorResponse | ResponseTimeoutResponse | ServerTimeoutErrorResponse

    /**
 * @summary delete image subfolders and images
 */
export const useDeleteImageInFolder = <TError = Error | AuthorizationErrorResponse | ForbiddenErrorWithLisResponse | FolderNotFoundResponse | RequestTimeoutResponse | InternalServerErrorResponse | ResponseTimeoutResponse | ServerTimeoutErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteImageInFolder>>, TError,{folderName: string;objectPath: string;params?: DeleteImageInFolderParams}, TContext>, request?: SecondParameter<typeof lp5AxiosClient>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof deleteImageInFolder>>,
        TError,
        {folderName: string;objectPath: string;params?: DeleteImageInFolderParams},
        TContext
      > => {
      return useMutation(getDeleteImageInFolderMutationOptions(options), queryClient);
    }

/**
 * Get options for the resource.
 * @summary image in folder options
 */
export const imageInFolderOptions = (
    folderName: string,
    objectPath: string,
 options?: SecondParameter<typeof lp5AxiosClient>,signal?: AbortSignal
) => {


      return lp5AxiosClient<void>(
      {url: `/6/images/folders/${folderName}/${objectPath}`, method: 'OPTIONS', signal
    },
      options);
    }




export const getImageInFolderOptionsMutationOptions = <TError = RequestTimeoutResponse | InternalServerErrorResponse | ResponseTimeoutResponse | ServerTimeoutErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof imageInFolderOptions>>, TError,{folderName: string;objectPath: string}, TContext>, request?: SecondParameter<typeof lp5AxiosClient>}
): UseMutationOptions<Awaited<ReturnType<typeof imageInFolderOptions>>, TError,{folderName: string;objectPath: string}, TContext> => {

const mutationKey = ['imageInFolderOptions'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof imageInFolderOptions>>, {folderName: string;objectPath: string}> = (props) => {
          const {folderName,objectPath} = props ?? {};

          return  imageInFolderOptions(folderName,objectPath,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type ImageInFolderOptionsMutationResult = NonNullable<Awaited<ReturnType<typeof imageInFolderOptions>>>

    export type ImageInFolderOptionsMutationError = RequestTimeoutResponse | InternalServerErrorResponse | ResponseTimeoutResponse | ServerTimeoutErrorResponse

    /**
 * @summary image in folder options
 */
export const useImageInFolderOptions = <TError = RequestTimeoutResponse | InternalServerErrorResponse | ResponseTimeoutResponse | ServerTimeoutErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof imageInFolderOptions>>, TError,{folderName: string;objectPath: string}, TContext>, request?: SecondParameter<typeof lp5AxiosClient>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof imageInFolderOptions>>,
        TError,
        {folderName: string;objectPath: string},
        TContext
      > => {
      return useMutation(getImageInFolderOptionsMutationOptions(options), queryClient);
    }

/**
 * Receiving a list of images in specified folder.
 * @summary get list of folder images
 */
export const getFolderImages = (
    folderName: string,
    params?: GetFolderImagesParams,
 options?: SecondParameter<typeof lp5AxiosClient>,signal?: AbortSignal
) => {


      return lp5AxiosClient<FolderObjects>(
      {url: `/6/images/folder_objects/${folderName}`, method: 'GET',
        params, signal
    },
      options);
    }




export const getGetFolderImagesQueryKey = (folderName: string,
    params?: GetFolderImagesParams,) => {
    return [
    `/6/images/folder_objects/${folderName}`, ...(params ? [params] : [])
    ] as const;
    }


export const getGetFolderImagesQueryOptions = <TData = Awaited<ReturnType<typeof getFolderImages>>, TError = Error | AuthorizationErrorResponse | ForbiddenErrorWithLisResponse | FolderNotFoundResponse | RequestTimeoutResponse | InternalServerErrorResponse | ResponseTimeoutResponse | ServerTimeoutErrorResponse>(folderName: string,
    params?: GetFolderImagesParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getFolderImages>>, TError, TData>>, request?: SecondParameter<typeof lp5AxiosClient>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetFolderImagesQueryKey(folderName,params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getFolderImages>>> = ({ signal }) => getFolderImages(folderName,params, requestOptions, signal);





   return  { queryKey, queryFn, enabled: folderName !== null && folderName !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getFolderImages>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetFolderImagesQueryResult = NonNullable<Awaited<ReturnType<typeof getFolderImages>>>
export type GetFolderImagesQueryError = Error | AuthorizationErrorResponse | ForbiddenErrorWithLisResponse | FolderNotFoundResponse | RequestTimeoutResponse | InternalServerErrorResponse | ResponseTimeoutResponse | ServerTimeoutErrorResponse


export function useGetFolderImages<TData = Awaited<ReturnType<typeof getFolderImages>>, TError = Error | AuthorizationErrorResponse | ForbiddenErrorWithLisResponse | FolderNotFoundResponse | RequestTimeoutResponse | InternalServerErrorResponse | ResponseTimeoutResponse | ServerTimeoutErrorResponse>(
 folderName: string,
    params: undefined |  GetFolderImagesParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getFolderImages>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getFolderImages>>,
          TError,
          Awaited<ReturnType<typeof getFolderImages>>
        > , 'initialData'
      >, request?: SecondParameter<typeof lp5AxiosClient>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetFolderImages<TData = Awaited<ReturnType<typeof getFolderImages>>, TError = Error | AuthorizationErrorResponse | ForbiddenErrorWithLisResponse | FolderNotFoundResponse | RequestTimeoutResponse | InternalServerErrorResponse | ResponseTimeoutResponse | ServerTimeoutErrorResponse>(
 folderName: string,
    params?: GetFolderImagesParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getFolderImages>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getFolderImages>>,
          TError,
          Awaited<ReturnType<typeof getFolderImages>>
        > , 'initialData'
      >, request?: SecondParameter<typeof lp5AxiosClient>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetFolderImages<TData = Awaited<ReturnType<typeof getFolderImages>>, TError = Error | AuthorizationErrorResponse | ForbiddenErrorWithLisResponse | FolderNotFoundResponse | RequestTimeoutResponse | InternalServerErrorResponse | ResponseTimeoutResponse | ServerTimeoutErrorResponse>(
 folderName: string,
    params?: GetFolderImagesParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getFolderImages>>, TError, TData>>, request?: SecondParameter<typeof lp5AxiosClient>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary get list of folder images
 */

export function useGetFolderImages<TData = Awaited<ReturnType<typeof getFolderImages>>, TError = Error | AuthorizationErrorResponse | ForbiddenErrorWithLisResponse | FolderNotFoundResponse | RequestTimeoutResponse | InternalServerErrorResponse | ResponseTimeoutResponse | ServerTimeoutErrorResponse>(
 folderName: string,
    params?: GetFolderImagesParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getFolderImages>>, TError, TData>>, request?: SecondParameter<typeof lp5AxiosClient>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetFolderImagesQueryOptions(folderName,params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}







/**
 * Get options for the resource.
 * @summary images within folder options
 */
export const imagesInFolderOptions = (
    folderName: string,
 options?: SecondParameter<typeof lp5AxiosClient>,signal?: AbortSignal
) => {


      return lp5AxiosClient<void>(
      {url: `/6/images/folder_objects/${folderName}`, method: 'OPTIONS', signal
    },
      options);
    }




export const getImagesInFolderOptionsMutationOptions = <TError = RequestTimeoutResponse | InternalServerErrorResponse | ResponseTimeoutResponse | ServerTimeoutErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof imagesInFolderOptions>>, TError,{folderName: string}, TContext>, request?: SecondParameter<typeof lp5AxiosClient>}
): UseMutationOptions<Awaited<ReturnType<typeof imagesInFolderOptions>>, TError,{folderName: string}, TContext> => {

const mutationKey = ['imagesInFolderOptions'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof imagesInFolderOptions>>, {folderName: string}> = (props) => {
          const {folderName} = props ?? {};

          return  imagesInFolderOptions(folderName,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type ImagesInFolderOptionsMutationResult = NonNullable<Awaited<ReturnType<typeof imagesInFolderOptions>>>

    export type ImagesInFolderOptionsMutationError = RequestTimeoutResponse | InternalServerErrorResponse | ResponseTimeoutResponse | ServerTimeoutErrorResponse

    /**
 * @summary images within folder options
 */
export const useImagesInFolderOptions = <TError = RequestTimeoutResponse | InternalServerErrorResponse | ResponseTimeoutResponse | ServerTimeoutErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof imagesInFolderOptions>>, TError,{folderName: string}, TContext>, request?: SecondParameter<typeof lp5AxiosClient>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof imagesInFolderOptions>>,
        TError,
        {folderName: string},
        TContext
      > => {
      return useMutation(getImagesInFolderOptionsMutationOptions(options), queryClient);
    }

/**
 * Copy images folder.
 * @summary copy images folder
 */
export const copyImagesFolder = (
    params: CopyImagesFolderParams,
 options?: SecondParameter<typeof lp5AxiosClient>,signal?: AbortSignal
) => {


      return lp5AxiosClient<void>(
      {url: `/6/images/folder_objects/copy`, method: 'POST',
        params, signal
    },
      options);
    }




export const getCopyImagesFolderMutationOptions = <TError = Error | AuthorizationErrorResponse | ForbiddenErrorWithLisResponse | RequestTimeoutResponse | InternalServerErrorResponse | ResponseTimeoutResponse | ServerTimeoutErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof copyImagesFolder>>, TError,{params: CopyImagesFolderParams}, TContext>, request?: SecondParameter<typeof lp5AxiosClient>}
): UseMutationOptions<Awaited<ReturnType<typeof copyImagesFolder>>, TError,{params: CopyImagesFolderParams}, TContext> => {

const mutationKey = ['copyImagesFolder'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof copyImagesFolder>>, {params: CopyImagesFolderParams}> = (props) => {
          const {params} = props ?? {};

          return  copyImagesFolder(params,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type CopyImagesFolderMutationResult = NonNullable<Awaited<ReturnType<typeof copyImagesFolder>>>

    export type CopyImagesFolderMutationError = Error | AuthorizationErrorResponse | ForbiddenErrorWithLisResponse | RequestTimeoutResponse | InternalServerErrorResponse | ResponseTimeoutResponse | ServerTimeoutErrorResponse

    /**
 * @summary copy images folder
 */
export const useCopyImagesFolder = <TError = Error | AuthorizationErrorResponse | ForbiddenErrorWithLisResponse | RequestTimeoutResponse | InternalServerErrorResponse | ResponseTimeoutResponse | ServerTimeoutErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof copyImagesFolder>>, TError,{params: CopyImagesFolderParams}, TContext>, request?: SecondParameter<typeof lp5AxiosClient>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof copyImagesFolder>>,
        TError,
        {params: CopyImagesFolderParams},
        TContext
      > => {
      return useMutation(getCopyImagesFolderMutationOptions(options), queryClient);
    }

/**
 * Get options for the resource.
 * @summary copy images folder options
 */
export const copyImagesFolderOptions = (

 options?: SecondParameter<typeof lp5AxiosClient>,signal?: AbortSignal
) => {


      return lp5AxiosClient<void>(
      {url: `/6/images/folder_objects/copy`, method: 'OPTIONS', signal
    },
      options);
    }




export const getCopyImagesFolderOptionsMutationOptions = <TError = RequestTimeoutResponse | InternalServerErrorResponse | ResponseTimeoutResponse | ServerTimeoutErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof copyImagesFolderOptions>>, TError,void, TContext>, request?: SecondParameter<typeof lp5AxiosClient>}
): UseMutationOptions<Awaited<ReturnType<typeof copyImagesFolderOptions>>, TError,void, TContext> => {

const mutationKey = ['copyImagesFolderOptions'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof copyImagesFolderOptions>>, void> = () => {


          return  copyImagesFolderOptions(requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type CopyImagesFolderOptionsMutationResult = NonNullable<Awaited<ReturnType<typeof copyImagesFolderOptions>>>

    export type CopyImagesFolderOptionsMutationError = RequestTimeoutResponse | InternalServerErrorResponse | ResponseTimeoutResponse | ServerTimeoutErrorResponse

    /**
 * @summary copy images folder options
 */
export const useCopyImagesFolderOptions = <TError = RequestTimeoutResponse | InternalServerErrorResponse | ResponseTimeoutResponse | ServerTimeoutErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof copyImagesFolderOptions>>, TError,void, TContext>, request?: SecondParameter<typeof lp5AxiosClient>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof copyImagesFolderOptions>>,
        TError,
        void,
        TContext
      > => {
      return useMutation(getCopyImagesFolderOptionsMutationOptions(options), queryClient);
    }

/**
 * Copy folder image.
 * @summary copy folder image
 */
export const copyFolderImage = (
    params: CopyFolderImageParams,
 options?: SecondParameter<typeof lp5AxiosClient>,signal?: AbortSignal
) => {


      return lp5AxiosClient<void>(
      {url: `/6/images/folder_objects/object/copy`, method: 'POST',
        params, signal
    },
      options);
    }




export const getCopyFolderImageMutationOptions = <TError = Error | AuthorizationErrorResponse | ForbiddenErrorWithLisResponse | FolderNotFoundResponse | RequestTimeoutResponse | InternalServerErrorResponse | ResponseTimeoutResponse | ServerTimeoutErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof copyFolderImage>>, TError,{params: CopyFolderImageParams}, TContext>, request?: SecondParameter<typeof lp5AxiosClient>}
): UseMutationOptions<Awaited<ReturnType<typeof copyFolderImage>>, TError,{params: CopyFolderImageParams}, TContext> => {

const mutationKey = ['copyFolderImage'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof copyFolderImage>>, {params: CopyFolderImageParams}> = (props) => {
          const {params} = props ?? {};

          return  copyFolderImage(params,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type CopyFolderImageMutationResult = NonNullable<Awaited<ReturnType<typeof copyFolderImage>>>

    export type CopyFolderImageMutationError = Error | AuthorizationErrorResponse | ForbiddenErrorWithLisResponse | FolderNotFoundResponse | RequestTimeoutResponse | InternalServerErrorResponse | ResponseTimeoutResponse | ServerTimeoutErrorResponse

    /**
 * @summary copy folder image
 */
export const useCopyFolderImage = <TError = Error | AuthorizationErrorResponse | ForbiddenErrorWithLisResponse | FolderNotFoundResponse | RequestTimeoutResponse | InternalServerErrorResponse | ResponseTimeoutResponse | ServerTimeoutErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof copyFolderImage>>, TError,{params: CopyFolderImageParams}, TContext>, request?: SecondParameter<typeof lp5AxiosClient>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof copyFolderImage>>,
        TError,
        {params: CopyFolderImageParams},
        TContext
      > => {
      return useMutation(getCopyFolderImageMutationOptions(options), queryClient);
    }

/**
 * Get options for the resource.
 * @summary copy image in folder options
 */
export const copyImageInFolderOptions = (

 options?: SecondParameter<typeof lp5AxiosClient>,signal?: AbortSignal
) => {


      return lp5AxiosClient<void>(
      {url: `/6/images/folder_objects/object/copy`, method: 'OPTIONS', signal
    },
      options);
    }




export const getCopyImageInFolderOptionsMutationOptions = <TError = RequestTimeoutResponse | InternalServerErrorResponse | ResponseTimeoutResponse | ServerTimeoutErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof copyImageInFolderOptions>>, TError,void, TContext>, request?: SecondParameter<typeof lp5AxiosClient>}
): UseMutationOptions<Awaited<ReturnType<typeof copyImageInFolderOptions>>, TError,void, TContext> => {

const mutationKey = ['copyImageInFolderOptions'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof copyImageInFolderOptions>>, void> = () => {


          return  copyImageInFolderOptions(requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type CopyImageInFolderOptionsMutationResult = NonNullable<Awaited<ReturnType<typeof copyImageInFolderOptions>>>

    export type CopyImageInFolderOptionsMutationError = RequestTimeoutResponse | InternalServerErrorResponse | ResponseTimeoutResponse | ServerTimeoutErrorResponse

    /**
 * @summary copy image in folder options
 */
export const useCopyImageInFolderOptions = <TError = RequestTimeoutResponse | InternalServerErrorResponse | ResponseTimeoutResponse | ServerTimeoutErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof copyImageInFolderOptions>>, TError,void, TContext>, request?: SecondParameter<typeof lp5AxiosClient>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof copyImageInFolderOptions>>,
        TError,
        void,
        TContext
      > => {
      return useMutation(getCopyImageInFolderOptionsMutationOptions(options), queryClient);
    }

/**
 * Save object with unique ID.
 * @summary create objects
 */
export const createObjects = (
    createObjectsBody?: Blob,
    params?: CreateObjectsParams,
 options?: SecondParameter<typeof lp5AxiosClient>,signal?: AbortSignal
) => {


      return lp5AxiosClient<ObjectsCreationResponse>(
      {url: `/6/objects`, method: 'POST',
      headers: {'Content-Type': '*/*', },
      data: createObjectsBody,
        params, signal
    },
      options);
    }




export const getCreateObjectsMutationOptions = <TError = Error | AuthorizationErrorResponse | ForbiddenErrorWithLisResponse | RequestTimeoutResponse | PayloadToLargeResponse | InternalServerErrorResponse | ResponseTimeoutResponse | ServerTimeoutErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createObjects>>, TError,{data?: Blob;params?: CreateObjectsParams}, TContext>, request?: SecondParameter<typeof lp5AxiosClient>}
): UseMutationOptions<Awaited<ReturnType<typeof createObjects>>, TError,{data?: Blob;params?: CreateObjectsParams}, TContext> => {

const mutationKey = ['createObjects'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof createObjects>>, {data?: Blob;params?: CreateObjectsParams}> = (props) => {
          const {data,params} = props ?? {};

          return  createObjects(data,params,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type CreateObjectsMutationResult = NonNullable<Awaited<ReturnType<typeof createObjects>>>
    export type CreateObjectsMutationBody = Blob | undefined
    export type CreateObjectsMutationError = Error | AuthorizationErrorResponse | ForbiddenErrorWithLisResponse | RequestTimeoutResponse | PayloadToLargeResponse | InternalServerErrorResponse | ResponseTimeoutResponse | ServerTimeoutErrorResponse

    /**
 * @summary create objects
 */
export const useCreateObjects = <TError = Error | AuthorizationErrorResponse | ForbiddenErrorWithLisResponse | RequestTimeoutResponse | PayloadToLargeResponse | InternalServerErrorResponse | ResponseTimeoutResponse | ServerTimeoutErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createObjects>>, TError,{data?: Blob;params?: CreateObjectsParams}, TContext>, request?: SecondParameter<typeof lp5AxiosClient>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof createObjects>>,
        TError,
        {data?: Blob;params?: CreateObjectsParams},
        TContext
      > => {
      return useMutation(getCreateObjectsMutationOptions(options), queryClient);
    }

/**
 * Get options for the resource.
 * @summary objects options
 */
export const getObjectsOptions = (

 options?: SecondParameter<typeof lp5AxiosClient>,signal?: AbortSignal
) => {


      return lp5AxiosClient<void>(
      {url: `/6/objects`, method: 'OPTIONS', signal
    },
      options);
    }




export const getGetObjectsOptionsMutationOptions = <TError = RequestTimeoutResponse | InternalServerErrorResponse | ResponseTimeoutResponse | ServerTimeoutErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof getObjectsOptions>>, TError,void, TContext>, request?: SecondParameter<typeof lp5AxiosClient>}
): UseMutationOptions<Awaited<ReturnType<typeof getObjectsOptions>>, TError,void, TContext> => {

const mutationKey = ['getObjectsOptions'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof getObjectsOptions>>, void> = () => {


          return  getObjectsOptions(requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type GetObjectsOptionsMutationResult = NonNullable<Awaited<ReturnType<typeof getObjectsOptions>>>

    export type GetObjectsOptionsMutationError = RequestTimeoutResponse | InternalServerErrorResponse | ResponseTimeoutResponse | ServerTimeoutErrorResponse

    /**
 * @summary objects options
 */
export const useGetObjectsOptions = <TError = RequestTimeoutResponse | InternalServerErrorResponse | ResponseTimeoutResponse | ServerTimeoutErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof getObjectsOptions>>, TError,void, TContext>, request?: SecondParameter<typeof lp5AxiosClient>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof getObjectsOptions>>,
        TError,
        void,
        TContext
      > => {
      return useMutation(getGetObjectsOptionsMutationOptions(options), queryClient);
    }

/**
 * Receiving objects.
 * Returns its lifetime in `X-Luna-Expiry-Date` header.
 * @summary get object
 */
export const getObject = (
    objectId: Uuid & unknown,
    params?: GetObjectParams,
 options?: SecondParameter<typeof lp5AxiosClient>,signal?: AbortSignal
) => {


      return lp5AxiosClient<Blob>(
      {url: `/6/objects/${objectId}`, method: 'GET',
        params,
        responseType: 'blob', signal
    },
      options);
    }




export const getGetObjectQueryKey = (objectId: Uuid & unknown,
    params?: GetObjectParams,) => {
    return [
    `/6/objects/${objectId}`, ...(params ? [params] : [])
    ] as const;
    }


export const getGetObjectQueryOptions = <TData = Awaited<ReturnType<typeof getObject>>, TError = Error | AuthorizationErrorResponse | ForbiddenErrorWithLisResponse | ObjectNotFoundResponse | RequestTimeoutResponse | InternalServerErrorResponse | ResponseTimeoutResponse | ServerTimeoutErrorResponse>(objectId: Uuid & unknown,
    params?: GetObjectParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getObject>>, TError, TData>>, request?: SecondParameter<typeof lp5AxiosClient>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetObjectQueryKey(objectId,params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getObject>>> = ({ signal }) => getObject(objectId,params, requestOptions, signal);





   return  { queryKey, queryFn, enabled: objectId !== null && objectId !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getObject>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetObjectQueryResult = NonNullable<Awaited<ReturnType<typeof getObject>>>
export type GetObjectQueryError = Error | AuthorizationErrorResponse | ForbiddenErrorWithLisResponse | ObjectNotFoundResponse | RequestTimeoutResponse | InternalServerErrorResponse | ResponseTimeoutResponse | ServerTimeoutErrorResponse


export function useGetObject<TData = Awaited<ReturnType<typeof getObject>>, TError = Error | AuthorizationErrorResponse | ForbiddenErrorWithLisResponse | ObjectNotFoundResponse | RequestTimeoutResponse | InternalServerErrorResponse | ResponseTimeoutResponse | ServerTimeoutErrorResponse>(
 objectId: Uuid & unknown,
    params: undefined |  GetObjectParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getObject>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getObject>>,
          TError,
          Awaited<ReturnType<typeof getObject>>
        > , 'initialData'
      >, request?: SecondParameter<typeof lp5AxiosClient>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetObject<TData = Awaited<ReturnType<typeof getObject>>, TError = Error | AuthorizationErrorResponse | ForbiddenErrorWithLisResponse | ObjectNotFoundResponse | RequestTimeoutResponse | InternalServerErrorResponse | ResponseTimeoutResponse | ServerTimeoutErrorResponse>(
 objectId: Uuid & unknown,
    params?: GetObjectParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getObject>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getObject>>,
          TError,
          Awaited<ReturnType<typeof getObject>>
        > , 'initialData'
      >, request?: SecondParameter<typeof lp5AxiosClient>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetObject<TData = Awaited<ReturnType<typeof getObject>>, TError = Error | AuthorizationErrorResponse | ForbiddenErrorWithLisResponse | ObjectNotFoundResponse | RequestTimeoutResponse | InternalServerErrorResponse | ResponseTimeoutResponse | ServerTimeoutErrorResponse>(
 objectId: Uuid & unknown,
    params?: GetObjectParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getObject>>, TError, TData>>, request?: SecondParameter<typeof lp5AxiosClient>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary get object
 */

export function useGetObject<TData = Awaited<ReturnType<typeof getObject>>, TError = Error | AuthorizationErrorResponse | ForbiddenErrorWithLisResponse | ObjectNotFoundResponse | RequestTimeoutResponse | InternalServerErrorResponse | ResponseTimeoutResponse | ServerTimeoutErrorResponse>(
 objectId: Uuid & unknown,
    params?: GetObjectParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getObject>>, TError, TData>>, request?: SecondParameter<typeof lp5AxiosClient>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetObjectQueryOptions(objectId,params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}







/**
 * Check if object with `object_id` exists.
 * Returns its lifetime in `X-Luna-Expiry-Date` header.
 * @summary check if object exists
 */
export const checkObject = (
    objectId: Uuid & unknown,
    params?: CheckObjectParams,
 options?: SecondParameter<typeof lp5AxiosClient>,signal?: AbortSignal
) => {


      return lp5AxiosClient<void>(
      {url: `/6/objects/${objectId}`, method: 'HEAD',
        params, signal
    },
      options);
    }




export const getCheckObjectMutationOptions = <TError = AuthorizationErrorWithoutBodyResponse | ForbiddenErrorWithoutBodyResponse | void | RequestTimeoutWithoutBodyResponse | InternalServerErrorWithoutBodyResponse | ResponseTimeoutWithoutBodyResponse | ServerTimeoutErrorWithoutBodyResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof checkObject>>, TError,{objectId: Uuid & unknown;params?: CheckObjectParams}, TContext>, request?: SecondParameter<typeof lp5AxiosClient>}
): UseMutationOptions<Awaited<ReturnType<typeof checkObject>>, TError,{objectId: Uuid & unknown;params?: CheckObjectParams}, TContext> => {

const mutationKey = ['checkObject'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof checkObject>>, {objectId: Uuid & unknown;params?: CheckObjectParams}> = (props) => {
          const {objectId,params} = props ?? {};

          return  checkObject(objectId,params,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type CheckObjectMutationResult = NonNullable<Awaited<ReturnType<typeof checkObject>>>

    export type CheckObjectMutationError = AuthorizationErrorWithoutBodyResponse | ForbiddenErrorWithoutBodyResponse | void | RequestTimeoutWithoutBodyResponse | InternalServerErrorWithoutBodyResponse | ResponseTimeoutWithoutBodyResponse | ServerTimeoutErrorWithoutBodyResponse

    /**
 * @summary check if object exists
 */
export const useCheckObject = <TError = AuthorizationErrorWithoutBodyResponse | ForbiddenErrorWithoutBodyResponse | void | RequestTimeoutWithoutBodyResponse | InternalServerErrorWithoutBodyResponse | ResponseTimeoutWithoutBodyResponse | ServerTimeoutErrorWithoutBodyResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof checkObject>>, TError,{objectId: Uuid & unknown;params?: CheckObjectParams}, TContext>, request?: SecondParameter<typeof lp5AxiosClient>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof checkObject>>,
        TError,
        {objectId: Uuid & unknown;params?: CheckObjectParams},
        TContext
      > => {
      return useMutation(getCheckObjectMutationOptions(options), queryClient);
    }

/**
 * Delete object
 * @summary delete object
 */
export const deleteObject = (
    objectId: Uuid & unknown,
 options?: SecondParameter<typeof lp5AxiosClient>,signal?: AbortSignal
) => {


      return lp5AxiosClient<void>(
      {url: `/6/objects/${objectId}`, method: 'DELETE', signal
    },
      options);
    }




export const getDeleteObjectMutationOptions = <TError = AuthorizationErrorResponse | ForbiddenErrorWithLisResponse | ObjectNotFoundResponse | RequestTimeoutResponse | InternalServerErrorResponse | ResponseTimeoutResponse | ServerTimeoutErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteObject>>, TError,{objectId: Uuid & unknown}, TContext>, request?: SecondParameter<typeof lp5AxiosClient>}
): UseMutationOptions<Awaited<ReturnType<typeof deleteObject>>, TError,{objectId: Uuid & unknown}, TContext> => {

const mutationKey = ['deleteObject'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof deleteObject>>, {objectId: Uuid & unknown}> = (props) => {
          const {objectId} = props ?? {};

          return  deleteObject(objectId,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type DeleteObjectMutationResult = NonNullable<Awaited<ReturnType<typeof deleteObject>>>

    export type DeleteObjectMutationError = AuthorizationErrorResponse | ForbiddenErrorWithLisResponse | ObjectNotFoundResponse | RequestTimeoutResponse | InternalServerErrorResponse | ResponseTimeoutResponse | ServerTimeoutErrorResponse

    /**
 * @summary delete object
 */
export const useDeleteObject = <TError = AuthorizationErrorResponse | ForbiddenErrorWithLisResponse | ObjectNotFoundResponse | RequestTimeoutResponse | InternalServerErrorResponse | ResponseTimeoutResponse | ServerTimeoutErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteObject>>, TError,{objectId: Uuid & unknown}, TContext>, request?: SecondParameter<typeof lp5AxiosClient>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof deleteObject>>,
        TError,
        {objectId: Uuid & unknown},
        TContext
      > => {
      return useMutation(getDeleteObjectMutationOptions(options), queryClient);
    }

/**
 * Get options for the resource.
 * @summary object options
 */
export const getObjectOptions = (
    objectId: Uuid & unknown,
 options?: SecondParameter<typeof lp5AxiosClient>,signal?: AbortSignal
) => {


      return lp5AxiosClient<void>(
      {url: `/6/objects/${objectId}`, method: 'OPTIONS', signal
    },
      options);
    }




export const getGetObjectOptionsMutationOptions = <TError = RequestTimeoutResponse | InternalServerErrorResponse | ResponseTimeoutResponse | ServerTimeoutErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof getObjectOptions>>, TError,{objectId: Uuid & unknown}, TContext>, request?: SecondParameter<typeof lp5AxiosClient>}
): UseMutationOptions<Awaited<ReturnType<typeof getObjectOptions>>, TError,{objectId: Uuid & unknown}, TContext> => {

const mutationKey = ['getObjectOptions'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof getObjectOptions>>, {objectId: Uuid & unknown}> = (props) => {
          const {objectId} = props ?? {};

          return  getObjectOptions(objectId,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type GetObjectOptionsMutationResult = NonNullable<Awaited<ReturnType<typeof getObjectOptions>>>

    export type GetObjectOptionsMutationError = RequestTimeoutResponse | InternalServerErrorResponse | ResponseTimeoutResponse | ServerTimeoutErrorResponse

    /**
 * @summary object options
 */
export const useGetObjectOptions = <TError = RequestTimeoutResponse | InternalServerErrorResponse | ResponseTimeoutResponse | ServerTimeoutErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof getObjectOptions>>, TError,{objectId: Uuid & unknown}, TContext>, request?: SecondParameter<typeof lp5AxiosClient>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof getObjectOptions>>,
        TError,
        {objectId: Uuid & unknown},
        TContext
      > => {
      return useMutation(getGetObjectOptionsMutationOptions(options), queryClient);
    }

/**
 * The platform supports folder creation both in the local file system and in S3-compatible storage systems.
 *
 * Folder Name Restrictions
 *
 *   - The folder name must match the following regular expression:
 *     `[a-zA-Z0-9-_.,;]{1,1024}`
 *     Allowed characters: Latin letters (a-z, A-Z), digits (0-9), hyphen (-), underscore (_), period (.), comma (,), semicolon (;).
 *     Name length: from 1 to 1024 characters.
 *
 *   - System limitations:
 *     The maximum folder name length may be restricted by the operating system or storage type:
 *       - On most Linux systems, the maximum length for a file or folder name is 255 bytes.
 *       - In S3-compatible storage, the maximum object name length is typically 1024 bytes.
 *       - If the system or storage limitation is lower, it takes precedence over the regular expression.
 *
 *   - Example:
 *     If the name matches the regular expression but exceeds the system limitation, folder creation will fail with an error.
 *
 *   **Note**: The folder is physically saved in the storage with `luna_folder_` prefix. So the folder created upon making POST request to the
 *     route /objects/folders/test_folder will appear in the storage as luna_folder_test_folder folder. Meanwhile you still
 *     have to use its original name for accessing it, so calling /objects/folders/luna_folder_test_folder in order to access test_folder
 *     is incorrect and will lead to 404 error.
 * @summary create objects folder
 */
export const createObjectsFolder = (
    folderName: string,
    params?: CreateObjectsFolderParams,
 options?: SecondParameter<typeof lp5AxiosClient>,signal?: AbortSignal
) => {


      return lp5AxiosClient<void>(
      {url: `/6/objects/folders/${folderName}`, method: 'POST',
        params, signal
    },
      options);
    }




export const getCreateObjectsFolderMutationOptions = <TError = Error | AuthorizationErrorResponse | ForbiddenErrorWithLisResponse | RequestTimeoutResponse | InternalServerErrorResponse | ResponseTimeoutResponse | ServerTimeoutErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createObjectsFolder>>, TError,{folderName: string;params?: CreateObjectsFolderParams}, TContext>, request?: SecondParameter<typeof lp5AxiosClient>}
): UseMutationOptions<Awaited<ReturnType<typeof createObjectsFolder>>, TError,{folderName: string;params?: CreateObjectsFolderParams}, TContext> => {

const mutationKey = ['createObjectsFolder'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof createObjectsFolder>>, {folderName: string;params?: CreateObjectsFolderParams}> = (props) => {
          const {folderName,params} = props ?? {};

          return  createObjectsFolder(folderName,params,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type CreateObjectsFolderMutationResult = NonNullable<Awaited<ReturnType<typeof createObjectsFolder>>>

    export type CreateObjectsFolderMutationError = Error | AuthorizationErrorResponse | ForbiddenErrorWithLisResponse | RequestTimeoutResponse | InternalServerErrorResponse | ResponseTimeoutResponse | ServerTimeoutErrorResponse

    /**
 * @summary create objects folder
 */
export const useCreateObjectsFolder = <TError = Error | AuthorizationErrorResponse | ForbiddenErrorWithLisResponse | RequestTimeoutResponse | InternalServerErrorResponse | ResponseTimeoutResponse | ServerTimeoutErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createObjectsFolder>>, TError,{folderName: string;params?: CreateObjectsFolderParams}, TContext>, request?: SecondParameter<typeof lp5AxiosClient>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof createObjectsFolder>>,
        TError,
        {folderName: string;params?: CreateObjectsFolderParams},
        TContext
      > => {
      return useMutation(getCreateObjectsFolderMutationOptions(options), queryClient);
    }

/**
 * OK response is returned if a folder with the specified name exists in the system.
 * @summary check if objects folder exists
 */
export const checkObjectsFolder = (
    folderName: string,
 options?: SecondParameter<typeof lp5AxiosClient>,signal?: AbortSignal
) => {


      return lp5AxiosClient<void>(
      {url: `/6/objects/folders/${folderName}`, method: 'HEAD', signal
    },
      options);
    }




export const getCheckObjectsFolderMutationOptions = <TError = void | AuthorizationErrorWithoutBodyResponse | ForbiddenErrorWithoutBodyResponse | FolderNotFoundResponse | RequestTimeoutWithoutBodyResponse | InternalServerErrorWithoutBodyResponse | ResponseTimeoutWithoutBodyResponse | ServerTimeoutErrorWithoutBodyResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof checkObjectsFolder>>, TError,{folderName: string}, TContext>, request?: SecondParameter<typeof lp5AxiosClient>}
): UseMutationOptions<Awaited<ReturnType<typeof checkObjectsFolder>>, TError,{folderName: string}, TContext> => {

const mutationKey = ['checkObjectsFolder'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof checkObjectsFolder>>, {folderName: string}> = (props) => {
          const {folderName} = props ?? {};

          return  checkObjectsFolder(folderName,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type CheckObjectsFolderMutationResult = NonNullable<Awaited<ReturnType<typeof checkObjectsFolder>>>

    export type CheckObjectsFolderMutationError = void | AuthorizationErrorWithoutBodyResponse | ForbiddenErrorWithoutBodyResponse | FolderNotFoundResponse | RequestTimeoutWithoutBodyResponse | InternalServerErrorWithoutBodyResponse | ResponseTimeoutWithoutBodyResponse | ServerTimeoutErrorWithoutBodyResponse

    /**
 * @summary check if objects folder exists
 */
export const useCheckObjectsFolder = <TError = void | AuthorizationErrorWithoutBodyResponse | ForbiddenErrorWithoutBodyResponse | FolderNotFoundResponse | RequestTimeoutWithoutBodyResponse | InternalServerErrorWithoutBodyResponse | ResponseTimeoutWithoutBodyResponse | ServerTimeoutErrorWithoutBodyResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof checkObjectsFolder>>, TError,{folderName: string}, TContext>, request?: SecondParameter<typeof lp5AxiosClient>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof checkObjectsFolder>>,
        TError,
        {folderName: string},
        TContext
      > => {
      return useMutation(getCheckObjectsFolderMutationOptions(options), queryClient);
    }

/**
 * If a folder with the specified name exists in the system, OK response is returned along with the folder’s metadata.
 * @summary get objects folder
 */
export const getObjectsFolder = (
    folderName: string,
 options?: SecondParameter<typeof lp5AxiosClient>,signal?: AbortSignal
) => {


      return lp5AxiosClient<FolderInfo>(
      {url: `/6/objects/folders/${folderName}`, method: 'GET', signal
    },
      options);
    }




export const getGetObjectsFolderQueryKey = (folderName: string,) => {
    return [
    `/6/objects/folders/${folderName}`
    ] as const;
    }


export const getGetObjectsFolderQueryOptions = <TData = Awaited<ReturnType<typeof getObjectsFolder>>, TError = AuthorizationErrorResponse | ForbiddenErrorWithLisResponse | FolderNotFoundResponse | RequestTimeoutResponse | InternalServerErrorResponse | ResponseTimeoutResponse | ServerTimeoutErrorResponse>(folderName: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getObjectsFolder>>, TError, TData>>, request?: SecondParameter<typeof lp5AxiosClient>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetObjectsFolderQueryKey(folderName);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getObjectsFolder>>> = ({ signal }) => getObjectsFolder(folderName, requestOptions, signal);





   return  { queryKey, queryFn, enabled: folderName !== null && folderName !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getObjectsFolder>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetObjectsFolderQueryResult = NonNullable<Awaited<ReturnType<typeof getObjectsFolder>>>
export type GetObjectsFolderQueryError = AuthorizationErrorResponse | ForbiddenErrorWithLisResponse | FolderNotFoundResponse | RequestTimeoutResponse | InternalServerErrorResponse | ResponseTimeoutResponse | ServerTimeoutErrorResponse


export function useGetObjectsFolder<TData = Awaited<ReturnType<typeof getObjectsFolder>>, TError = AuthorizationErrorResponse | ForbiddenErrorWithLisResponse | FolderNotFoundResponse | RequestTimeoutResponse | InternalServerErrorResponse | ResponseTimeoutResponse | ServerTimeoutErrorResponse>(
 folderName: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getObjectsFolder>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getObjectsFolder>>,
          TError,
          Awaited<ReturnType<typeof getObjectsFolder>>
        > , 'initialData'
      >, request?: SecondParameter<typeof lp5AxiosClient>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetObjectsFolder<TData = Awaited<ReturnType<typeof getObjectsFolder>>, TError = AuthorizationErrorResponse | ForbiddenErrorWithLisResponse | FolderNotFoundResponse | RequestTimeoutResponse | InternalServerErrorResponse | ResponseTimeoutResponse | ServerTimeoutErrorResponse>(
 folderName: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getObjectsFolder>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getObjectsFolder>>,
          TError,
          Awaited<ReturnType<typeof getObjectsFolder>>
        > , 'initialData'
      >, request?: SecondParameter<typeof lp5AxiosClient>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetObjectsFolder<TData = Awaited<ReturnType<typeof getObjectsFolder>>, TError = AuthorizationErrorResponse | ForbiddenErrorWithLisResponse | FolderNotFoundResponse | RequestTimeoutResponse | InternalServerErrorResponse | ResponseTimeoutResponse | ServerTimeoutErrorResponse>(
 folderName: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getObjectsFolder>>, TError, TData>>, request?: SecondParameter<typeof lp5AxiosClient>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary get objects folder
 */

export function useGetObjectsFolder<TData = Awaited<ReturnType<typeof getObjectsFolder>>, TError = AuthorizationErrorResponse | ForbiddenErrorWithLisResponse | FolderNotFoundResponse | RequestTimeoutResponse | InternalServerErrorResponse | ResponseTimeoutResponse | ServerTimeoutErrorResponse>(
 folderName: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getObjectsFolder>>, TError, TData>>, request?: SecondParameter<typeof lp5AxiosClient>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetObjectsFolderQueryOptions(folderName,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}







/**
 * Delete objects folder.
 * @summary delete objects folder
 */
export const deleteObjectsFolder = (
    folderName: string,
 options?: SecondParameter<typeof lp5AxiosClient>,signal?: AbortSignal
) => {


      return lp5AxiosClient<void>(
      {url: `/6/objects/folders/${folderName}`, method: 'DELETE', signal
    },
      options);
    }




export const getDeleteObjectsFolderMutationOptions = <TError = AuthorizationErrorResponse | ForbiddenErrorWithLisResponse | FolderNotFoundResponse | RequestTimeoutResponse | InternalServerErrorResponse | ResponseTimeoutResponse | ServerTimeoutErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteObjectsFolder>>, TError,{folderName: string}, TContext>, request?: SecondParameter<typeof lp5AxiosClient>}
): UseMutationOptions<Awaited<ReturnType<typeof deleteObjectsFolder>>, TError,{folderName: string}, TContext> => {

const mutationKey = ['deleteObjectsFolder'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof deleteObjectsFolder>>, {folderName: string}> = (props) => {
          const {folderName} = props ?? {};

          return  deleteObjectsFolder(folderName,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type DeleteObjectsFolderMutationResult = NonNullable<Awaited<ReturnType<typeof deleteObjectsFolder>>>

    export type DeleteObjectsFolderMutationError = AuthorizationErrorResponse | ForbiddenErrorWithLisResponse | FolderNotFoundResponse | RequestTimeoutResponse | InternalServerErrorResponse | ResponseTimeoutResponse | ServerTimeoutErrorResponse

    /**
 * @summary delete objects folder
 */
export const useDeleteObjectsFolder = <TError = AuthorizationErrorResponse | ForbiddenErrorWithLisResponse | FolderNotFoundResponse | RequestTimeoutResponse | InternalServerErrorResponse | ResponseTimeoutResponse | ServerTimeoutErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteObjectsFolder>>, TError,{folderName: string}, TContext>, request?: SecondParameter<typeof lp5AxiosClient>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof deleteObjectsFolder>>,
        TError,
        {folderName: string},
        TContext
      > => {
      return useMutation(getDeleteObjectsFolderMutationOptions(options), queryClient);
    }

/**
 * Get objects for the resource.
 * @summary objects options
 */
export const objectsFolderOptions = (
    folderName: string,
 options?: SecondParameter<typeof lp5AxiosClient>,signal?: AbortSignal
) => {


      return lp5AxiosClient<void>(
      {url: `/6/objects/folders/${folderName}`, method: 'OPTIONS', signal
    },
      options);
    }




export const getObjectsFolderOptionsMutationOptions = <TError = RequestTimeoutResponse | InternalServerErrorResponse | ResponseTimeoutResponse | ServerTimeoutErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof objectsFolderOptions>>, TError,{folderName: string}, TContext>, request?: SecondParameter<typeof lp5AxiosClient>}
): UseMutationOptions<Awaited<ReturnType<typeof objectsFolderOptions>>, TError,{folderName: string}, TContext> => {

const mutationKey = ['objectsFolderOptions'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof objectsFolderOptions>>, {folderName: string}> = (props) => {
          const {folderName} = props ?? {};

          return  objectsFolderOptions(folderName,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type ObjectsFolderOptionsMutationResult = NonNullable<Awaited<ReturnType<typeof objectsFolderOptions>>>

    export type ObjectsFolderOptionsMutationError = RequestTimeoutResponse | InternalServerErrorResponse | ResponseTimeoutResponse | ServerTimeoutErrorResponse

    /**
 * @summary objects options
 */
export const useObjectsFolderOptions = <TError = RequestTimeoutResponse | InternalServerErrorResponse | ResponseTimeoutResponse | ServerTimeoutErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof objectsFolderOptions>>, TError,{folderName: string}, TContext>, request?: SecondParameter<typeof lp5AxiosClient>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof objectsFolderOptions>>,
        TError,
        {folderName: string},
        TContext
      > => {
      return useMutation(getObjectsFolderOptionsMutationOptions(options), queryClient);
    }

/**
 * URI example: /6/objects/folder/{subfolder}/{subfolder2}/.../{subfolderN}/{filename}
 * This endpoint is used to create a file by a specified path within a pre-created folder.
 * The main folder (folder in the uri example) must be created in advance using a POST request to the /folders endpoint.
 * All subsequent subfolders ({subfolder}, {subfolder2}, …, {subfolderN}) will be automatically created during file upload if they do not already exist.
 *
 * **Note**: Creating subfolders without a file is not allowed — this endpoint cannot be used to create empty directories.
 *
 * Rules and behavior:
 *
 * - The account_id of the user making the request must match the account_id of the folder owner.
 *
 * - If the Content-Type header is not provided, the system will try to infer the content type from the file extension ({filename}).
 *
 * - If both a Content-Type header and a file extension are provided, the header value takes precedence.
 *
 * - If neither a file extension nor a Content-Type header is provided, the request will fail with a 400 Bad Request error.
 * @summary put object in folder
 */
export const putObjectInFolder = (
    folderName: string,
    objectPath: string,
    putObjectInFolderBody?: Blob,
    params?: PutObjectInFolderParams,
 options?: SecondParameter<typeof lp5AxiosClient>,signal?: AbortSignal
) => {


      return lp5AxiosClient<FolderObject>(
      {url: `/6/objects/folders/${folderName}/${objectPath}`, method: 'PUT',
      headers: {'Content-Type': '*/*', },
      data: putObjectInFolderBody,
        params, signal
    },
      options);
    }




export const getPutObjectInFolderMutationOptions = <TError = Error | AuthorizationErrorResponse | ForbiddenErrorWithLisResponse | RequestTimeoutResponse | PayloadToLargeResponse | InternalServerErrorResponse | ResponseTimeoutResponse | ServerTimeoutErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof putObjectInFolder>>, TError,{folderName: string;objectPath: string;data?: Blob;params?: PutObjectInFolderParams}, TContext>, request?: SecondParameter<typeof lp5AxiosClient>}
): UseMutationOptions<Awaited<ReturnType<typeof putObjectInFolder>>, TError,{folderName: string;objectPath: string;data?: Blob;params?: PutObjectInFolderParams}, TContext> => {

const mutationKey = ['putObjectInFolder'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof putObjectInFolder>>, {folderName: string;objectPath: string;data?: Blob;params?: PutObjectInFolderParams}> = (props) => {
          const {folderName,objectPath,data,params} = props ?? {};

          return  putObjectInFolder(folderName,objectPath,data,params,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type PutObjectInFolderMutationResult = NonNullable<Awaited<ReturnType<typeof putObjectInFolder>>>
    export type PutObjectInFolderMutationBody = Blob | undefined
    export type PutObjectInFolderMutationError = Error | AuthorizationErrorResponse | ForbiddenErrorWithLisResponse | RequestTimeoutResponse | PayloadToLargeResponse | InternalServerErrorResponse | ResponseTimeoutResponse | ServerTimeoutErrorResponse

    /**
 * @summary put object in folder
 */
export const usePutObjectInFolder = <TError = Error | AuthorizationErrorResponse | ForbiddenErrorWithLisResponse | RequestTimeoutResponse | PayloadToLargeResponse | InternalServerErrorResponse | ResponseTimeoutResponse | ServerTimeoutErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof putObjectInFolder>>, TError,{folderName: string;objectPath: string;data?: Blob;params?: PutObjectInFolderParams}, TContext>, request?: SecondParameter<typeof lp5AxiosClient>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof putObjectInFolder>>,
        TError,
        {folderName: string;objectPath: string;data?: Blob;params?: PutObjectInFolderParams},
        TContext
      > => {
      return useMutation(getPutObjectInFolderMutationOptions(options), queryClient);
    }

/**
 * Check object exists in folder.
 *
 * # ⚠️ Important: Account ID Requirements
 *
 * **Warning:** The folder must belong to the account ID passed in headers.
 * The folder must have been created through the `/folders` endpoint using the same
 * account ID.
 *
 * If the account ID doesn't match the folder owner, you will receive a **404 error**
 * because no folder with that name exists under your account.
 *
 * ## Error Scenarios
 *
 * - **404 Not Found**: The folder does not exist or does not belong to the specified account ID
 * - Ensure the account ID matches the account that created the folder
 * @summary check if object exists in folder
 */
export const checkObjectInFolder = (
    folderName: string,
    objectPath: string,
    params?: CheckObjectInFolderParams,
 options?: SecondParameter<typeof lp5AxiosClient>,signal?: AbortSignal
) => {


      return lp5AxiosClient<void>(
      {url: `/6/objects/folders/${folderName}/${objectPath}`, method: 'HEAD',
        params, signal
    },
      options);
    }




export const getCheckObjectInFolderMutationOptions = <TError = void | AuthorizationErrorWithoutBodyResponse | ForbiddenErrorWithoutBodyResponse | FolderNotFoundResponse | RequestTimeoutWithoutBodyResponse | InternalServerErrorWithoutBodyResponse | ResponseTimeoutWithoutBodyResponse | ServerTimeoutErrorWithoutBodyResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof checkObjectInFolder>>, TError,{folderName: string;objectPath: string;params?: CheckObjectInFolderParams}, TContext>, request?: SecondParameter<typeof lp5AxiosClient>}
): UseMutationOptions<Awaited<ReturnType<typeof checkObjectInFolder>>, TError,{folderName: string;objectPath: string;params?: CheckObjectInFolderParams}, TContext> => {

const mutationKey = ['checkObjectInFolder'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof checkObjectInFolder>>, {folderName: string;objectPath: string;params?: CheckObjectInFolderParams}> = (props) => {
          const {folderName,objectPath,params} = props ?? {};

          return  checkObjectInFolder(folderName,objectPath,params,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type CheckObjectInFolderMutationResult = NonNullable<Awaited<ReturnType<typeof checkObjectInFolder>>>

    export type CheckObjectInFolderMutationError = void | AuthorizationErrorWithoutBodyResponse | ForbiddenErrorWithoutBodyResponse | FolderNotFoundResponse | RequestTimeoutWithoutBodyResponse | InternalServerErrorWithoutBodyResponse | ResponseTimeoutWithoutBodyResponse | ServerTimeoutErrorWithoutBodyResponse

    /**
 * @summary check if object exists in folder
 */
export const useCheckObjectInFolder = <TError = void | AuthorizationErrorWithoutBodyResponse | ForbiddenErrorWithoutBodyResponse | FolderNotFoundResponse | RequestTimeoutWithoutBodyResponse | InternalServerErrorWithoutBodyResponse | ResponseTimeoutWithoutBodyResponse | ServerTimeoutErrorWithoutBodyResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof checkObjectInFolder>>, TError,{folderName: string;objectPath: string;params?: CheckObjectInFolderParams}, TContext>, request?: SecondParameter<typeof lp5AxiosClient>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof checkObjectInFolder>>,
        TError,
        {folderName: string;objectPath: string;params?: CheckObjectInFolderParams},
        TContext
      > => {
      return useMutation(getCheckObjectInFolderMutationOptions(options), queryClient);
    }

/**
 * Receiving object from specified folder.
 *
 * # ⚠️ Important: Account ID Requirements
 *
 * **Warning:** The folder must belong to the account ID passed in headers.
 * The folder must have been created through the `/folders` endpoint using the same
 * account ID.
 *
 * If the account ID doesn't match the folder owner, you will receive a **404 error**
 * because no folder with that name exists under your account.
 *
 * ## Error Scenarios
 *
 * - **404 Not Found**: The folder does not exist or does not belong to the specified account ID
 * - Ensure the account ID matches the account that created the folder
 * @summary get object from objects folder
 */
export const getObjectInFolder = (
    folderName: string,
    objectPath: string,
    params?: GetObjectInFolderParams,
 options?: SecondParameter<typeof lp5AxiosClient>,signal?: AbortSignal
) => {


      return lp5AxiosClient<Blob>(
      {url: `/6/objects/folders/${folderName}/${objectPath}`, method: 'GET',
        params,
        responseType: 'blob', signal
    },
      options);
    }




export const getGetObjectInFolderQueryKey = (folderName: string,
    objectPath: string,
    params?: GetObjectInFolderParams,) => {
    return [
    `/6/objects/folders/${folderName}/${objectPath}`, ...(params ? [params] : [])
    ] as const;
    }


export const getGetObjectInFolderQueryOptions = <TData = Awaited<ReturnType<typeof getObjectInFolder>>, TError = Error | AuthorizationErrorResponse | ForbiddenErrorWithLisResponse | FolderNotFoundResponse | RequestTimeoutResponse | InternalServerErrorResponse | ResponseTimeoutResponse | ServerTimeoutErrorResponse>(folderName: string,
    objectPath: string,
    params?: GetObjectInFolderParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getObjectInFolder>>, TError, TData>>, request?: SecondParameter<typeof lp5AxiosClient>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetObjectInFolderQueryKey(folderName,objectPath,params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getObjectInFolder>>> = ({ signal }) => getObjectInFolder(folderName,objectPath,params, requestOptions, signal);





   return  { queryKey, queryFn, enabled: folderName !== null && folderName !== undefined && objectPath !== null && objectPath !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getObjectInFolder>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetObjectInFolderQueryResult = NonNullable<Awaited<ReturnType<typeof getObjectInFolder>>>
export type GetObjectInFolderQueryError = Error | AuthorizationErrorResponse | ForbiddenErrorWithLisResponse | FolderNotFoundResponse | RequestTimeoutResponse | InternalServerErrorResponse | ResponseTimeoutResponse | ServerTimeoutErrorResponse


export function useGetObjectInFolder<TData = Awaited<ReturnType<typeof getObjectInFolder>>, TError = Error | AuthorizationErrorResponse | ForbiddenErrorWithLisResponse | FolderNotFoundResponse | RequestTimeoutResponse | InternalServerErrorResponse | ResponseTimeoutResponse | ServerTimeoutErrorResponse>(
 folderName: string,
    objectPath: string,
    params: undefined |  GetObjectInFolderParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getObjectInFolder>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getObjectInFolder>>,
          TError,
          Awaited<ReturnType<typeof getObjectInFolder>>
        > , 'initialData'
      >, request?: SecondParameter<typeof lp5AxiosClient>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetObjectInFolder<TData = Awaited<ReturnType<typeof getObjectInFolder>>, TError = Error | AuthorizationErrorResponse | ForbiddenErrorWithLisResponse | FolderNotFoundResponse | RequestTimeoutResponse | InternalServerErrorResponse | ResponseTimeoutResponse | ServerTimeoutErrorResponse>(
 folderName: string,
    objectPath: string,
    params?: GetObjectInFolderParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getObjectInFolder>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getObjectInFolder>>,
          TError,
          Awaited<ReturnType<typeof getObjectInFolder>>
        > , 'initialData'
      >, request?: SecondParameter<typeof lp5AxiosClient>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetObjectInFolder<TData = Awaited<ReturnType<typeof getObjectInFolder>>, TError = Error | AuthorizationErrorResponse | ForbiddenErrorWithLisResponse | FolderNotFoundResponse | RequestTimeoutResponse | InternalServerErrorResponse | ResponseTimeoutResponse | ServerTimeoutErrorResponse>(
 folderName: string,
    objectPath: string,
    params?: GetObjectInFolderParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getObjectInFolder>>, TError, TData>>, request?: SecondParameter<typeof lp5AxiosClient>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary get object from objects folder
 */

export function useGetObjectInFolder<TData = Awaited<ReturnType<typeof getObjectInFolder>>, TError = Error | AuthorizationErrorResponse | ForbiddenErrorWithLisResponse | FolderNotFoundResponse | RequestTimeoutResponse | InternalServerErrorResponse | ResponseTimeoutResponse | ServerTimeoutErrorResponse>(
 folderName: string,
    objectPath: string,
    params?: GetObjectInFolderParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getObjectInFolder>>, TError, TData>>, request?: SecondParameter<typeof lp5AxiosClient>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetObjectInFolderQueryOptions(folderName,objectPath,params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}







/**
 * Removes subfolders along with all their contents and associated metadata.
 *
 * If a file path passed to the endpoint it will be the only one that deleted.
 *
 * If the optional account_id query parameter is provided, the system will first check that the subfolder
 * belongs to the specified account_id. If the subfolder does not exist or does not belong to this account,
 * a 404 error will be returned.
 *
 * > **WARNING** If no `recursive=1` flag passed in query, trying to delete non-empty folder will lead to 400 Error response.
 *
 * > **Note**: In S3-compatible storage, there is no direct concept of folders. Folders are represented by object key
 * prefixes. When the last object with a given subfolder path is deleted, that subfolder
 * (and any parent folders in the path) will no longer be accessible. The same applies to nested parent
 * folders—once all objects within them are deleted, those folders effectively cease to exist.
 * However, the root folder always remains present until it is explicitly deleted.
 * @summary delete objects subfolders and objects
 */
export const deleteObjectInFolder = (
    folderName: string,
    objectPath: string,
    params?: DeleteObjectInFolderParams,
 options?: SecondParameter<typeof lp5AxiosClient>,signal?: AbortSignal
) => {


      return lp5AxiosClient<void>(
      {url: `/6/objects/folders/${folderName}/${objectPath}`, method: 'DELETE',
        params, signal
    },
      options);
    }




export const getDeleteObjectInFolderMutationOptions = <TError = Error | AuthorizationErrorResponse | ForbiddenErrorWithLisResponse | FolderNotFoundResponse | RequestTimeoutResponse | InternalServerErrorResponse | ResponseTimeoutResponse | ServerTimeoutErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteObjectInFolder>>, TError,{folderName: string;objectPath: string;params?: DeleteObjectInFolderParams}, TContext>, request?: SecondParameter<typeof lp5AxiosClient>}
): UseMutationOptions<Awaited<ReturnType<typeof deleteObjectInFolder>>, TError,{folderName: string;objectPath: string;params?: DeleteObjectInFolderParams}, TContext> => {

const mutationKey = ['deleteObjectInFolder'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof deleteObjectInFolder>>, {folderName: string;objectPath: string;params?: DeleteObjectInFolderParams}> = (props) => {
          const {folderName,objectPath,params} = props ?? {};

          return  deleteObjectInFolder(folderName,objectPath,params,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type DeleteObjectInFolderMutationResult = NonNullable<Awaited<ReturnType<typeof deleteObjectInFolder>>>

    export type DeleteObjectInFolderMutationError = Error | AuthorizationErrorResponse | ForbiddenErrorWithLisResponse | FolderNotFoundResponse | RequestTimeoutResponse | InternalServerErrorResponse | ResponseTimeoutResponse | ServerTimeoutErrorResponse

    /**
 * @summary delete objects subfolders and objects
 */
export const useDeleteObjectInFolder = <TError = Error | AuthorizationErrorResponse | ForbiddenErrorWithLisResponse | FolderNotFoundResponse | RequestTimeoutResponse | InternalServerErrorResponse | ResponseTimeoutResponse | ServerTimeoutErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteObjectInFolder>>, TError,{folderName: string;objectPath: string;params?: DeleteObjectInFolderParams}, TContext>, request?: SecondParameter<typeof lp5AxiosClient>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof deleteObjectInFolder>>,
        TError,
        {folderName: string;objectPath: string;params?: DeleteObjectInFolderParams},
        TContext
      > => {
      return useMutation(getDeleteObjectInFolderMutationOptions(options), queryClient);
    }

/**
 * Get options for the resource.
 * @summary object in folder options
 */
export const objectInFolderOptions = (
    folderName: string,
    objectPath: string,
 options?: SecondParameter<typeof lp5AxiosClient>,signal?: AbortSignal
) => {


      return lp5AxiosClient<void>(
      {url: `/6/objects/folders/${folderName}/${objectPath}`, method: 'OPTIONS', signal
    },
      options);
    }




export const getObjectInFolderOptionsMutationOptions = <TError = RequestTimeoutResponse | InternalServerErrorResponse | ResponseTimeoutResponse | ServerTimeoutErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof objectInFolderOptions>>, TError,{folderName: string;objectPath: string}, TContext>, request?: SecondParameter<typeof lp5AxiosClient>}
): UseMutationOptions<Awaited<ReturnType<typeof objectInFolderOptions>>, TError,{folderName: string;objectPath: string}, TContext> => {

const mutationKey = ['objectInFolderOptions'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof objectInFolderOptions>>, {folderName: string;objectPath: string}> = (props) => {
          const {folderName,objectPath} = props ?? {};

          return  objectInFolderOptions(folderName,objectPath,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type ObjectInFolderOptionsMutationResult = NonNullable<Awaited<ReturnType<typeof objectInFolderOptions>>>

    export type ObjectInFolderOptionsMutationError = RequestTimeoutResponse | InternalServerErrorResponse | ResponseTimeoutResponse | ServerTimeoutErrorResponse

    /**
 * @summary object in folder options
 */
export const useObjectInFolderOptions = <TError = RequestTimeoutResponse | InternalServerErrorResponse | ResponseTimeoutResponse | ServerTimeoutErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof objectInFolderOptions>>, TError,{folderName: string;objectPath: string}, TContext>, request?: SecondParameter<typeof lp5AxiosClient>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof objectInFolderOptions>>,
        TError,
        {folderName: string;objectPath: string},
        TContext
      > => {
      return useMutation(getObjectInFolderOptionsMutationOptions(options), queryClient);
    }

/**
 * Receiving a list of objects in specified folder.
 * @summary get list of folder objects
 */
export const getFolderObjects = (
    folderName: string,
    params?: GetFolderObjectsParams,
 options?: SecondParameter<typeof lp5AxiosClient>,signal?: AbortSignal
) => {


      return lp5AxiosClient<FolderObjects>(
      {url: `/6/objects/folder_objects/${folderName}`, method: 'GET',
        params, signal
    },
      options);
    }




export const getGetFolderObjectsQueryKey = (folderName: string,
    params?: GetFolderObjectsParams,) => {
    return [
    `/6/objects/folder_objects/${folderName}`, ...(params ? [params] : [])
    ] as const;
    }


export const getGetFolderObjectsQueryOptions = <TData = Awaited<ReturnType<typeof getFolderObjects>>, TError = Error | AuthorizationErrorResponse | ForbiddenErrorWithLisResponse | FolderNotFoundResponse | RequestTimeoutResponse | InternalServerErrorResponse | ResponseTimeoutResponse | ServerTimeoutErrorResponse>(folderName: string,
    params?: GetFolderObjectsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getFolderObjects>>, TError, TData>>, request?: SecondParameter<typeof lp5AxiosClient>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetFolderObjectsQueryKey(folderName,params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getFolderObjects>>> = ({ signal }) => getFolderObjects(folderName,params, requestOptions, signal);





   return  { queryKey, queryFn, enabled: folderName !== null && folderName !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getFolderObjects>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetFolderObjectsQueryResult = NonNullable<Awaited<ReturnType<typeof getFolderObjects>>>
export type GetFolderObjectsQueryError = Error | AuthorizationErrorResponse | ForbiddenErrorWithLisResponse | FolderNotFoundResponse | RequestTimeoutResponse | InternalServerErrorResponse | ResponseTimeoutResponse | ServerTimeoutErrorResponse


export function useGetFolderObjects<TData = Awaited<ReturnType<typeof getFolderObjects>>, TError = Error | AuthorizationErrorResponse | ForbiddenErrorWithLisResponse | FolderNotFoundResponse | RequestTimeoutResponse | InternalServerErrorResponse | ResponseTimeoutResponse | ServerTimeoutErrorResponse>(
 folderName: string,
    params: undefined |  GetFolderObjectsParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getFolderObjects>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getFolderObjects>>,
          TError,
          Awaited<ReturnType<typeof getFolderObjects>>
        > , 'initialData'
      >, request?: SecondParameter<typeof lp5AxiosClient>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetFolderObjects<TData = Awaited<ReturnType<typeof getFolderObjects>>, TError = Error | AuthorizationErrorResponse | ForbiddenErrorWithLisResponse | FolderNotFoundResponse | RequestTimeoutResponse | InternalServerErrorResponse | ResponseTimeoutResponse | ServerTimeoutErrorResponse>(
 folderName: string,
    params?: GetFolderObjectsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getFolderObjects>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getFolderObjects>>,
          TError,
          Awaited<ReturnType<typeof getFolderObjects>>
        > , 'initialData'
      >, request?: SecondParameter<typeof lp5AxiosClient>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetFolderObjects<TData = Awaited<ReturnType<typeof getFolderObjects>>, TError = Error | AuthorizationErrorResponse | ForbiddenErrorWithLisResponse | FolderNotFoundResponse | RequestTimeoutResponse | InternalServerErrorResponse | ResponseTimeoutResponse | ServerTimeoutErrorResponse>(
 folderName: string,
    params?: GetFolderObjectsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getFolderObjects>>, TError, TData>>, request?: SecondParameter<typeof lp5AxiosClient>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary get list of folder objects
 */

export function useGetFolderObjects<TData = Awaited<ReturnType<typeof getFolderObjects>>, TError = Error | AuthorizationErrorResponse | ForbiddenErrorWithLisResponse | FolderNotFoundResponse | RequestTimeoutResponse | InternalServerErrorResponse | ResponseTimeoutResponse | ServerTimeoutErrorResponse>(
 folderName: string,
    params?: GetFolderObjectsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getFolderObjects>>, TError, TData>>, request?: SecondParameter<typeof lp5AxiosClient>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetFolderObjectsQueryOptions(folderName,params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}







/**
 * Get options for the resource.
 * @summary objects in folder options
 */
export const objectsInFolderOptions = (
    folderName: string,
 options?: SecondParameter<typeof lp5AxiosClient>,signal?: AbortSignal
) => {


      return lp5AxiosClient<void>(
      {url: `/6/objects/folder_objects/${folderName}`, method: 'OPTIONS', signal
    },
      options);
    }




export const getObjectsInFolderOptionsMutationOptions = <TError = RequestTimeoutResponse | InternalServerErrorResponse | ResponseTimeoutResponse | ServerTimeoutErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof objectsInFolderOptions>>, TError,{folderName: string}, TContext>, request?: SecondParameter<typeof lp5AxiosClient>}
): UseMutationOptions<Awaited<ReturnType<typeof objectsInFolderOptions>>, TError,{folderName: string}, TContext> => {

const mutationKey = ['objectsInFolderOptions'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof objectsInFolderOptions>>, {folderName: string}> = (props) => {
          const {folderName} = props ?? {};

          return  objectsInFolderOptions(folderName,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type ObjectsInFolderOptionsMutationResult = NonNullable<Awaited<ReturnType<typeof objectsInFolderOptions>>>

    export type ObjectsInFolderOptionsMutationError = RequestTimeoutResponse | InternalServerErrorResponse | ResponseTimeoutResponse | ServerTimeoutErrorResponse

    /**
 * @summary objects in folder options
 */
export const useObjectsInFolderOptions = <TError = RequestTimeoutResponse | InternalServerErrorResponse | ResponseTimeoutResponse | ServerTimeoutErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof objectsInFolderOptions>>, TError,{folderName: string}, TContext>, request?: SecondParameter<typeof lp5AxiosClient>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof objectsInFolderOptions>>,
        TError,
        {folderName: string},
        TContext
      > => {
      return useMutation(getObjectsInFolderOptionsMutationOptions(options), queryClient);
    }

/**
 * Copy objects folder.
 * @summary copy objects folder
 */
export const copyObjectsFolder = (
    params: CopyObjectsFolderParams,
 options?: SecondParameter<typeof lp5AxiosClient>,signal?: AbortSignal
) => {


      return lp5AxiosClient<void>(
      {url: `/6/objects/folder_objects/copy`, method: 'POST',
        params, signal
    },
      options);
    }




export const getCopyObjectsFolderMutationOptions = <TError = Error | AuthorizationErrorResponse | ForbiddenErrorWithLisResponse | RequestTimeoutResponse | InternalServerErrorResponse | ResponseTimeoutResponse | ServerTimeoutErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof copyObjectsFolder>>, TError,{params: CopyObjectsFolderParams}, TContext>, request?: SecondParameter<typeof lp5AxiosClient>}
): UseMutationOptions<Awaited<ReturnType<typeof copyObjectsFolder>>, TError,{params: CopyObjectsFolderParams}, TContext> => {

const mutationKey = ['copyObjectsFolder'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof copyObjectsFolder>>, {params: CopyObjectsFolderParams}> = (props) => {
          const {params} = props ?? {};

          return  copyObjectsFolder(params,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type CopyObjectsFolderMutationResult = NonNullable<Awaited<ReturnType<typeof copyObjectsFolder>>>

    export type CopyObjectsFolderMutationError = Error | AuthorizationErrorResponse | ForbiddenErrorWithLisResponse | RequestTimeoutResponse | InternalServerErrorResponse | ResponseTimeoutResponse | ServerTimeoutErrorResponse

    /**
 * @summary copy objects folder
 */
export const useCopyObjectsFolder = <TError = Error | AuthorizationErrorResponse | ForbiddenErrorWithLisResponse | RequestTimeoutResponse | InternalServerErrorResponse | ResponseTimeoutResponse | ServerTimeoutErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof copyObjectsFolder>>, TError,{params: CopyObjectsFolderParams}, TContext>, request?: SecondParameter<typeof lp5AxiosClient>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof copyObjectsFolder>>,
        TError,
        {params: CopyObjectsFolderParams},
        TContext
      > => {
      return useMutation(getCopyObjectsFolderMutationOptions(options), queryClient);
    }

/**
 * Get options for the resource.
 * @summary copy objects folder options
 */
export const copyObjectsFolderOptions = (

 options?: SecondParameter<typeof lp5AxiosClient>,signal?: AbortSignal
) => {


      return lp5AxiosClient<void>(
      {url: `/6/objects/folder_objects/copy`, method: 'OPTIONS', signal
    },
      options);
    }




export const getCopyObjectsFolderOptionsMutationOptions = <TError = RequestTimeoutResponse | InternalServerErrorResponse | ResponseTimeoutResponse | ServerTimeoutErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof copyObjectsFolderOptions>>, TError,void, TContext>, request?: SecondParameter<typeof lp5AxiosClient>}
): UseMutationOptions<Awaited<ReturnType<typeof copyObjectsFolderOptions>>, TError,void, TContext> => {

const mutationKey = ['copyObjectsFolderOptions'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof copyObjectsFolderOptions>>, void> = () => {


          return  copyObjectsFolderOptions(requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type CopyObjectsFolderOptionsMutationResult = NonNullable<Awaited<ReturnType<typeof copyObjectsFolderOptions>>>

    export type CopyObjectsFolderOptionsMutationError = RequestTimeoutResponse | InternalServerErrorResponse | ResponseTimeoutResponse | ServerTimeoutErrorResponse

    /**
 * @summary copy objects folder options
 */
export const useCopyObjectsFolderOptions = <TError = RequestTimeoutResponse | InternalServerErrorResponse | ResponseTimeoutResponse | ServerTimeoutErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof copyObjectsFolderOptions>>, TError,void, TContext>, request?: SecondParameter<typeof lp5AxiosClient>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof copyObjectsFolderOptions>>,
        TError,
        void,
        TContext
      > => {
      return useMutation(getCopyObjectsFolderOptionsMutationOptions(options), queryClient);
    }

/**
 * Copy folder object.
 * @summary copy folder object
 */
export const copyFolderObject = (
    params: CopyFolderObjectParams,
 options?: SecondParameter<typeof lp5AxiosClient>,signal?: AbortSignal
) => {


      return lp5AxiosClient<void>(
      {url: `/6/objects/folder_objects/object/copy`, method: 'POST',
        params, signal
    },
      options);
    }




export const getCopyFolderObjectMutationOptions = <TError = Error | AuthorizationErrorResponse | ForbiddenErrorWithLisResponse | FolderNotFoundResponse | RequestTimeoutResponse | InternalServerErrorResponse | ResponseTimeoutResponse | ServerTimeoutErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof copyFolderObject>>, TError,{params: CopyFolderObjectParams}, TContext>, request?: SecondParameter<typeof lp5AxiosClient>}
): UseMutationOptions<Awaited<ReturnType<typeof copyFolderObject>>, TError,{params: CopyFolderObjectParams}, TContext> => {

const mutationKey = ['copyFolderObject'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof copyFolderObject>>, {params: CopyFolderObjectParams}> = (props) => {
          const {params} = props ?? {};

          return  copyFolderObject(params,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type CopyFolderObjectMutationResult = NonNullable<Awaited<ReturnType<typeof copyFolderObject>>>

    export type CopyFolderObjectMutationError = Error | AuthorizationErrorResponse | ForbiddenErrorWithLisResponse | FolderNotFoundResponse | RequestTimeoutResponse | InternalServerErrorResponse | ResponseTimeoutResponse | ServerTimeoutErrorResponse

    /**
 * @summary copy folder object
 */
export const useCopyFolderObject = <TError = Error | AuthorizationErrorResponse | ForbiddenErrorWithLisResponse | FolderNotFoundResponse | RequestTimeoutResponse | InternalServerErrorResponse | ResponseTimeoutResponse | ServerTimeoutErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof copyFolderObject>>, TError,{params: CopyFolderObjectParams}, TContext>, request?: SecondParameter<typeof lp5AxiosClient>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof copyFolderObject>>,
        TError,
        {params: CopyFolderObjectParams},
        TContext
      > => {
      return useMutation(getCopyFolderObjectMutationOptions(options), queryClient);
    }

/**
 * Get options for the resource.
 * @summary copy object in folder options
 */
export const getCopyObjectInFolderOptions = (

 options?: SecondParameter<typeof lp5AxiosClient>,signal?: AbortSignal
) => {


      return lp5AxiosClient<void>(
      {url: `/6/objects/folder_objects/object/copy`, method: 'OPTIONS', signal
    },
      options);
    }




export const getGetCopyObjectInFolderOptionsMutationOptions = <TError = RequestTimeoutResponse | InternalServerErrorResponse | ResponseTimeoutResponse | ServerTimeoutErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof getCopyObjectInFolderOptions>>, TError,void, TContext>, request?: SecondParameter<typeof lp5AxiosClient>}
): UseMutationOptions<Awaited<ReturnType<typeof getCopyObjectInFolderOptions>>, TError,void, TContext> => {

const mutationKey = ['getCopyObjectInFolderOptions'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof getCopyObjectInFolderOptions>>, void> = () => {


          return  getCopyObjectInFolderOptions(requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type GetCopyObjectInFolderOptionsMutationResult = NonNullable<Awaited<ReturnType<typeof getCopyObjectInFolderOptions>>>

    export type GetCopyObjectInFolderOptionsMutationError = RequestTimeoutResponse | InternalServerErrorResponse | ResponseTimeoutResponse | ServerTimeoutErrorResponse

    /**
 * @summary copy object in folder options
 */
export const useGetCopyObjectInFolderOptions = <TError = RequestTimeoutResponse | InternalServerErrorResponse | ResponseTimeoutResponse | ServerTimeoutErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof getCopyObjectInFolderOptions>>, TError,void, TContext>, request?: SecondParameter<typeof lp5AxiosClient>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof getCopyObjectInFolderOptions>>,
        TError,
        void,
        TContext
      > => {
      return useMutation(getGetCopyObjectInFolderOptionsMutationOptions(options), queryClient);
    }

/**
 * Extract descriptors and basic attributes from samples.
 *
 * All the extracted attributes are temporary.
 *
 * Temporary attributes have a TTL (time to live) and will be removed from the database after the specified period.
 * @summary extract attributes
 */
export const extractAttributes = (
    sampleIds: SampleIds,
    params?: ExtractAttributesParams,
 options?: SecondParameter<typeof lp5AxiosClient>,signal?: AbortSignal
) => {


      return lp5AxiosClient<ExtractedAttributes>(
      {url: `/6/extractor`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: sampleIds,
        params, signal
    },
      options);
    }




export const getExtractAttributesMutationOptions = <TError = Error | AuthorizationErrorResponse | ForbiddenErrorWithServicesResponse | ImageNotFoundResponse | RequestTimeoutResponse | PayloadToLargeResponse | InternalServerErrorResponse | ResponseTimeoutResponse | ServerTimeoutErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof extractAttributes>>, TError,{data: SampleIds;params?: ExtractAttributesParams}, TContext>, request?: SecondParameter<typeof lp5AxiosClient>}
): UseMutationOptions<Awaited<ReturnType<typeof extractAttributes>>, TError,{data: SampleIds;params?: ExtractAttributesParams}, TContext> => {

const mutationKey = ['extractAttributes'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof extractAttributes>>, {data: SampleIds;params?: ExtractAttributesParams}> = (props) => {
          const {data,params} = props ?? {};

          return  extractAttributes(data,params,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type ExtractAttributesMutationResult = NonNullable<Awaited<ReturnType<typeof extractAttributes>>>
    export type ExtractAttributesMutationBody = SampleIds
    export type ExtractAttributesMutationError = Error | AuthorizationErrorResponse | ForbiddenErrorWithServicesResponse | ImageNotFoundResponse | RequestTimeoutResponse | PayloadToLargeResponse | InternalServerErrorResponse | ResponseTimeoutResponse | ServerTimeoutErrorResponse

    /**
 * @summary extract attributes
 */
export const useExtractAttributes = <TError = Error | AuthorizationErrorResponse | ForbiddenErrorWithServicesResponse | ImageNotFoundResponse | RequestTimeoutResponse | PayloadToLargeResponse | InternalServerErrorResponse | ResponseTimeoutResponse | ServerTimeoutErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof extractAttributes>>, TError,{data: SampleIds;params?: ExtractAttributesParams}, TContext>, request?: SecondParameter<typeof lp5AxiosClient>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof extractAttributes>>,
        TError,
        {data: SampleIds;params?: ExtractAttributesParams},
        TContext
      > => {
      return useMutation(getExtractAttributesMutationOptions(options), queryClient);
    }

/**
 * Get options for the resource.
 * @summary extractor options
 */
export const geteEtractorOptions = (

 options?: SecondParameter<typeof lp5AxiosClient>,signal?: AbortSignal
) => {


      return lp5AxiosClient<void>(
      {url: `/6/extractor`, method: 'OPTIONS', signal
    },
      options);
    }




export const getGeteEtractorOptionsMutationOptions = <TError = RequestTimeoutResponse | InternalServerErrorResponse | ResponseTimeoutResponse | ServerTimeoutErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof geteEtractorOptions>>, TError,void, TContext>, request?: SecondParameter<typeof lp5AxiosClient>}
): UseMutationOptions<Awaited<ReturnType<typeof geteEtractorOptions>>, TError,void, TContext> => {

const mutationKey = ['geteEtractorOptions'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof geteEtractorOptions>>, void> = () => {


          return  geteEtractorOptions(requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type GeteEtractorOptionsMutationResult = NonNullable<Awaited<ReturnType<typeof geteEtractorOptions>>>

    export type GeteEtractorOptionsMutationError = RequestTimeoutResponse | InternalServerErrorResponse | ResponseTimeoutResponse | ServerTimeoutErrorResponse

    /**
 * @summary extractor options
 */
export const useGeteEtractorOptions = <TError = RequestTimeoutResponse | InternalServerErrorResponse | ResponseTimeoutResponse | ServerTimeoutErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof geteEtractorOptions>>, TError,void, TContext>, request?: SecondParameter<typeof lp5AxiosClient>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof geteEtractorOptions>>,
        TError,
        void,
        TContext
      > => {
      return useMutation(getGeteEtractorOptionsMutationOptions(options), queryClient);
    }

/**
 * New temporary attributes creation.
 *
 * **Note.** Use this request when you need to add basic attributes or descriptors from
 * external storage. Otherwise, use the extract attributes request.
 *
 * All the extracted attributes are temporary.
 *
 * Temporary attributes have a TTL (time to live) and will be removed from the database
 * after the specified period.
 * @summary create temporary attribute
 */
export const createAttributes = (
    createAttributesBody: CreatedAttribute | CreatedAttributeBinary | CreatedAttributeXpk,
    params?: CreateAttributesParams,
 options?: SecondParameter<typeof lp5AxiosClient>,signal?: AbortSignal
) => {


      return lp5AxiosClient<CreateAttributes201>(
      {url: `/6/attributes`, method: 'POST',
      data: createAttributesBody,
        params, signal
    },
      options);
    }




export const getCreateAttributesMutationOptions = <TError = Error | AuthorizationErrorResponse | ForbiddenFacesErrorResponse | RequestTimeoutResponse | PayloadToLargeResponse | InternalServerErrorResponse | ResponseTimeoutResponse | ServerTimeoutErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createAttributes>>, TError,{data: CreatedAttribute | CreatedAttributeBinary | CreatedAttributeXpk;params?: CreateAttributesParams}, TContext>, request?: SecondParameter<typeof lp5AxiosClient>}
): UseMutationOptions<Awaited<ReturnType<typeof createAttributes>>, TError,{data: CreatedAttribute | CreatedAttributeBinary | CreatedAttributeXpk;params?: CreateAttributesParams}, TContext> => {

const mutationKey = ['createAttributes'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof createAttributes>>, {data: CreatedAttribute | CreatedAttributeBinary | CreatedAttributeXpk;params?: CreateAttributesParams}> = (props) => {
          const {data,params} = props ?? {};

          return  createAttributes(data,params,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type CreateAttributesMutationResult = NonNullable<Awaited<ReturnType<typeof createAttributes>>>
    export type CreateAttributesMutationBody = CreatedAttribute | CreatedAttributeBinary | CreatedAttributeXpk
    export type CreateAttributesMutationError = Error | AuthorizationErrorResponse | ForbiddenFacesErrorResponse | RequestTimeoutResponse | PayloadToLargeResponse | InternalServerErrorResponse | ResponseTimeoutResponse | ServerTimeoutErrorResponse

    /**
 * @summary create temporary attribute
 */
export const useCreateAttributes = <TError = Error | AuthorizationErrorResponse | ForbiddenFacesErrorResponse | RequestTimeoutResponse | PayloadToLargeResponse | InternalServerErrorResponse | ResponseTimeoutResponse | ServerTimeoutErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createAttributes>>, TError,{data: CreatedAttribute | CreatedAttributeBinary | CreatedAttributeXpk;params?: CreateAttributesParams}, TContext>, request?: SecondParameter<typeof lp5AxiosClient>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof createAttributes>>,
        TError,
        {data: CreatedAttribute | CreatedAttributeBinary | CreatedAttributeXpk;params?: CreateAttributesParams},
        TContext
      > => {
      return useMutation(getCreateAttributesMutationOptions(options), queryClient);
    }

/**
 * Get temporary attributes by IDs.
 *
 * For each attribute:
 *
 * - If the attribute TTL has not expired, the attribute data is returned.
 *
 * - If the TTL has expired, no data is returned for this attribute in the response.
 * @summary get temporary attributes
 */
export const getAttributes = (
    params: GetAttributesParams,
 options?: SecondParameter<typeof lp5AxiosClient>,signal?: AbortSignal
) => {


      return lp5AxiosClient<GetAttributes200One | GetAttributes200Two>(
      {url: `/6/attributes`, method: 'GET',
        params, signal
    },
      options);
    }




export const getGetAttributesQueryKey = (params?: GetAttributesParams,) => {
    return [
    `/6/attributes`, ...(params ? [params] : [])
    ] as const;
    }


export const getGetAttributesQueryOptions = <TData = Awaited<ReturnType<typeof getAttributes>>, TError = Error | AuthorizationErrorResponse | ForbiddenFacesErrorResponse | RequestTimeoutResponse | InternalServerErrorResponse | ResponseTimeoutResponse | ServerTimeoutErrorResponse>(params: GetAttributesParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAttributes>>, TError, TData>>, request?: SecondParameter<typeof lp5AxiosClient>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetAttributesQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getAttributes>>> = ({ signal }) => getAttributes(params, requestOptions, signal);





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getAttributes>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetAttributesQueryResult = NonNullable<Awaited<ReturnType<typeof getAttributes>>>
export type GetAttributesQueryError = Error | AuthorizationErrorResponse | ForbiddenFacesErrorResponse | RequestTimeoutResponse | InternalServerErrorResponse | ResponseTimeoutResponse | ServerTimeoutErrorResponse


export function useGetAttributes<TData = Awaited<ReturnType<typeof getAttributes>>, TError = Error | AuthorizationErrorResponse | ForbiddenFacesErrorResponse | RequestTimeoutResponse | InternalServerErrorResponse | ResponseTimeoutResponse | ServerTimeoutErrorResponse>(
 params: GetAttributesParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAttributes>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getAttributes>>,
          TError,
          Awaited<ReturnType<typeof getAttributes>>
        > , 'initialData'
      >, request?: SecondParameter<typeof lp5AxiosClient>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetAttributes<TData = Awaited<ReturnType<typeof getAttributes>>, TError = Error | AuthorizationErrorResponse | ForbiddenFacesErrorResponse | RequestTimeoutResponse | InternalServerErrorResponse | ResponseTimeoutResponse | ServerTimeoutErrorResponse>(
 params: GetAttributesParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAttributes>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getAttributes>>,
          TError,
          Awaited<ReturnType<typeof getAttributes>>
        > , 'initialData'
      >, request?: SecondParameter<typeof lp5AxiosClient>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetAttributes<TData = Awaited<ReturnType<typeof getAttributes>>, TError = Error | AuthorizationErrorResponse | ForbiddenFacesErrorResponse | RequestTimeoutResponse | InternalServerErrorResponse | ResponseTimeoutResponse | ServerTimeoutErrorResponse>(
 params: GetAttributesParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAttributes>>, TError, TData>>, request?: SecondParameter<typeof lp5AxiosClient>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary get temporary attributes
 */

export function useGetAttributes<TData = Awaited<ReturnType<typeof getAttributes>>, TError = Error | AuthorizationErrorResponse | ForbiddenFacesErrorResponse | RequestTimeoutResponse | InternalServerErrorResponse | ResponseTimeoutResponse | ServerTimeoutErrorResponse>(
 params: GetAttributesParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAttributes>>, TError, TData>>, request?: SecondParameter<typeof lp5AxiosClient>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetAttributesQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}







/**
 * Get options for the resource.
 * @summary temporary attributes options
 */
export const getAttributesOptions = (

 options?: SecondParameter<typeof lp5AxiosClient>,signal?: AbortSignal
) => {


      return lp5AxiosClient<void>(
      {url: `/6/attributes`, method: 'OPTIONS', signal
    },
      options);
    }




export const getGetAttributesOptionsMutationOptions = <TError = RequestTimeoutResponse | InternalServerErrorResponse | ResponseTimeoutResponse | ServerTimeoutErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof getAttributesOptions>>, TError,void, TContext>, request?: SecondParameter<typeof lp5AxiosClient>}
): UseMutationOptions<Awaited<ReturnType<typeof getAttributesOptions>>, TError,void, TContext> => {

const mutationKey = ['getAttributesOptions'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof getAttributesOptions>>, void> = () => {


          return  getAttributesOptions(requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type GetAttributesOptionsMutationResult = NonNullable<Awaited<ReturnType<typeof getAttributesOptions>>>

    export type GetAttributesOptionsMutationError = RequestTimeoutResponse | InternalServerErrorResponse | ResponseTimeoutResponse | ServerTimeoutErrorResponse

    /**
 * @summary temporary attributes options
 */
export const useGetAttributesOptions = <TError = RequestTimeoutResponse | InternalServerErrorResponse | ResponseTimeoutResponse | ServerTimeoutErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof getAttributesOptions>>, TError,void, TContext>, request?: SecondParameter<typeof lp5AxiosClient>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof getAttributesOptions>>,
        TError,
        void,
        TContext
      > => {
      return useMutation(getGetAttributesOptionsMutationOptions(options), queryClient);
    }

/**
 * Get temporary attribute by ID.
 *
 * If the attribute TTL has not expired, the attribute data is returned.
 *
 * Otherwise, the "Attributes not found" error is returned.
 * @summary get temporary attribute
 */
export const getAttribute = (
    attributeId: AttributeId,
    params?: GetAttributeParams,
 options?: SecondParameter<typeof lp5AxiosClient>,signal?: AbortSignal
) => {


      return lp5AxiosClient<OutputAttributeJson | OutputAttributeMsgpack>(
      {url: `/6/attributes/${attributeId}`, method: 'GET',
        params, signal
    },
      options);
    }




export const getGetAttributeQueryKey = (attributeId: AttributeId,
    params?: GetAttributeParams,) => {
    return [
    `/6/attributes/${attributeId}`, ...(params ? [params] : [])
    ] as const;
    }


export const getGetAttributeQueryOptions = <TData = Awaited<ReturnType<typeof getAttribute>>, TError = Error | AuthorizationErrorResponse | ForbiddenFacesErrorResponse | RequestTimeoutResponse | InternalServerErrorResponse | ResponseTimeoutResponse | ServerTimeoutErrorResponse>(attributeId: AttributeId,
    params?: GetAttributeParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAttribute>>, TError, TData>>, request?: SecondParameter<typeof lp5AxiosClient>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetAttributeQueryKey(attributeId,params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getAttribute>>> = ({ signal }) => getAttribute(attributeId,params, requestOptions, signal);





   return  { queryKey, queryFn, enabled: attributeId !== null && attributeId !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getAttribute>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetAttributeQueryResult = NonNullable<Awaited<ReturnType<typeof getAttribute>>>
export type GetAttributeQueryError = Error | AuthorizationErrorResponse | ForbiddenFacesErrorResponse | RequestTimeoutResponse | InternalServerErrorResponse | ResponseTimeoutResponse | ServerTimeoutErrorResponse


export function useGetAttribute<TData = Awaited<ReturnType<typeof getAttribute>>, TError = Error | AuthorizationErrorResponse | ForbiddenFacesErrorResponse | RequestTimeoutResponse | InternalServerErrorResponse | ResponseTimeoutResponse | ServerTimeoutErrorResponse>(
 attributeId: AttributeId,
    params: undefined |  GetAttributeParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAttribute>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getAttribute>>,
          TError,
          Awaited<ReturnType<typeof getAttribute>>
        > , 'initialData'
      >, request?: SecondParameter<typeof lp5AxiosClient>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetAttribute<TData = Awaited<ReturnType<typeof getAttribute>>, TError = Error | AuthorizationErrorResponse | ForbiddenFacesErrorResponse | RequestTimeoutResponse | InternalServerErrorResponse | ResponseTimeoutResponse | ServerTimeoutErrorResponse>(
 attributeId: AttributeId,
    params?: GetAttributeParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAttribute>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getAttribute>>,
          TError,
          Awaited<ReturnType<typeof getAttribute>>
        > , 'initialData'
      >, request?: SecondParameter<typeof lp5AxiosClient>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetAttribute<TData = Awaited<ReturnType<typeof getAttribute>>, TError = Error | AuthorizationErrorResponse | ForbiddenFacesErrorResponse | RequestTimeoutResponse | InternalServerErrorResponse | ResponseTimeoutResponse | ServerTimeoutErrorResponse>(
 attributeId: AttributeId,
    params?: GetAttributeParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAttribute>>, TError, TData>>, request?: SecondParameter<typeof lp5AxiosClient>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary get temporary attribute
 */

export function useGetAttribute<TData = Awaited<ReturnType<typeof getAttribute>>, TError = Error | AuthorizationErrorResponse | ForbiddenFacesErrorResponse | RequestTimeoutResponse | InternalServerErrorResponse | ResponseTimeoutResponse | ServerTimeoutErrorResponse>(
 attributeId: AttributeId,
    params?: GetAttributeParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAttribute>>, TError, TData>>, request?: SecondParameter<typeof lp5AxiosClient>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetAttributeQueryOptions(attributeId,params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}







/**
 * Check if temporary attribute with `attribute_id` exists.
 * @summary check temporary attribute
 */
export const checkAttribute = (
    attributeId: AttributeId,
    params?: CheckAttributeParams,
 options?: SecondParameter<typeof lp5AxiosClient>,signal?: AbortSignal
) => {


      return lp5AxiosClient<void>(
      {url: `/6/attributes/${attributeId}`, method: 'HEAD',
        params, signal
    },
      options);
    }




export const getCheckAttributeMutationOptions = <TError = void | AuthorizationErrorWithoutBodyResponse | ForbiddenErrorWithoutBodyResponse | RequestTimeoutWithoutBodyResponse | InternalServerErrorWithoutBodyResponse | ResponseTimeoutWithoutBodyResponse | ServerTimeoutErrorWithoutBodyResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof checkAttribute>>, TError,{attributeId: AttributeId;params?: CheckAttributeParams}, TContext>, request?: SecondParameter<typeof lp5AxiosClient>}
): UseMutationOptions<Awaited<ReturnType<typeof checkAttribute>>, TError,{attributeId: AttributeId;params?: CheckAttributeParams}, TContext> => {

const mutationKey = ['checkAttribute'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof checkAttribute>>, {attributeId: AttributeId;params?: CheckAttributeParams}> = (props) => {
          const {attributeId,params} = props ?? {};

          return  checkAttribute(attributeId,params,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type CheckAttributeMutationResult = NonNullable<Awaited<ReturnType<typeof checkAttribute>>>

    export type CheckAttributeMutationError = void | AuthorizationErrorWithoutBodyResponse | ForbiddenErrorWithoutBodyResponse | RequestTimeoutWithoutBodyResponse | InternalServerErrorWithoutBodyResponse | ResponseTimeoutWithoutBodyResponse | ServerTimeoutErrorWithoutBodyResponse

    /**
 * @summary check temporary attribute
 */
export const useCheckAttribute = <TError = void | AuthorizationErrorWithoutBodyResponse | ForbiddenErrorWithoutBodyResponse | RequestTimeoutWithoutBodyResponse | InternalServerErrorWithoutBodyResponse | ResponseTimeoutWithoutBodyResponse | ServerTimeoutErrorWithoutBodyResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof checkAttribute>>, TError,{attributeId: AttributeId;params?: CheckAttributeParams}, TContext>, request?: SecondParameter<typeof lp5AxiosClient>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof checkAttribute>>,
        TError,
        {attributeId: AttributeId;params?: CheckAttributeParams},
        TContext
      > => {
      return useMutation(getCheckAttributeMutationOptions(options), queryClient);
    }

/**
 * Delete the attribute by its ID.
 * @summary delete attribute
 */
export const deleteAttribute = (
    attributeId: AttributeId,
 options?: SecondParameter<typeof lp5AxiosClient>,signal?: AbortSignal
) => {


      return lp5AxiosClient<void>(
      {url: `/6/attributes/${attributeId}`, method: 'DELETE', signal
    },
      options);
    }




export const getDeleteAttributeMutationOptions = <TError = AuthorizationErrorResponse | ForbiddenFacesErrorResponse | RequestTimeoutResponse | InternalServerErrorResponse | ResponseTimeoutResponse | ServerTimeoutErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteAttribute>>, TError,{attributeId: AttributeId}, TContext>, request?: SecondParameter<typeof lp5AxiosClient>}
): UseMutationOptions<Awaited<ReturnType<typeof deleteAttribute>>, TError,{attributeId: AttributeId}, TContext> => {

const mutationKey = ['deleteAttribute'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof deleteAttribute>>, {attributeId: AttributeId}> = (props) => {
          const {attributeId} = props ?? {};

          return  deleteAttribute(attributeId,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type DeleteAttributeMutationResult = NonNullable<Awaited<ReturnType<typeof deleteAttribute>>>

    export type DeleteAttributeMutationError = AuthorizationErrorResponse | ForbiddenFacesErrorResponse | RequestTimeoutResponse | InternalServerErrorResponse | ResponseTimeoutResponse | ServerTimeoutErrorResponse

    /**
 * @summary delete attribute
 */
export const useDeleteAttribute = <TError = AuthorizationErrorResponse | ForbiddenFacesErrorResponse | RequestTimeoutResponse | InternalServerErrorResponse | ResponseTimeoutResponse | ServerTimeoutErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteAttribute>>, TError,{attributeId: AttributeId}, TContext>, request?: SecondParameter<typeof lp5AxiosClient>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof deleteAttribute>>,
        TError,
        {attributeId: AttributeId},
        TContext
      > => {
      return useMutation(getDeleteAttributeMutationOptions(options), queryClient);
    }

/**
 * Get options for the resource.
 * @summary temporary attributes attribute options
 */
export const getAttributesAttributeOptions = (
    attributeId: AttributeId,
 options?: SecondParameter<typeof lp5AxiosClient>,signal?: AbortSignal
) => {


      return lp5AxiosClient<void>(
      {url: `/6/attributes/${attributeId}`, method: 'OPTIONS', signal
    },
      options);
    }




export const getGetAttributesAttributeOptionsMutationOptions = <TError = RequestTimeoutResponse | InternalServerErrorResponse | ResponseTimeoutResponse | ServerTimeoutErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof getAttributesAttributeOptions>>, TError,{attributeId: AttributeId}, TContext>, request?: SecondParameter<typeof lp5AxiosClient>}
): UseMutationOptions<Awaited<ReturnType<typeof getAttributesAttributeOptions>>, TError,{attributeId: AttributeId}, TContext> => {

const mutationKey = ['getAttributesAttributeOptions'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof getAttributesAttributeOptions>>, {attributeId: AttributeId}> = (props) => {
          const {attributeId} = props ?? {};

          return  getAttributesAttributeOptions(attributeId,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type GetAttributesAttributeOptionsMutationResult = NonNullable<Awaited<ReturnType<typeof getAttributesAttributeOptions>>>

    export type GetAttributesAttributeOptionsMutationError = RequestTimeoutResponse | InternalServerErrorResponse | ResponseTimeoutResponse | ServerTimeoutErrorResponse

    /**
 * @summary temporary attributes attribute options
 */
export const useGetAttributesAttributeOptions = <TError = RequestTimeoutResponse | InternalServerErrorResponse | ResponseTimeoutResponse | ServerTimeoutErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof getAttributesAttributeOptions>>, TError,{attributeId: AttributeId}, TContext>, request?: SecondParameter<typeof lp5AxiosClient>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof getAttributesAttributeOptions>>,
        TError,
        {attributeId: AttributeId},
        TContext
      > => {
      return useMutation(getGetAttributesAttributeOptionsMutationOptions(options), queryClient);
    }

/**
 * Get all the temporary attribute samples by the attribute ID.
 *
 * If the attribute TTL has not expired, the attribute data is returned.
 *
 * Otherwise, the "Attributes not found" error is returned.
 * @summary get temporary attribute samples
 */
export const getAttributeSamples = (
    attributeId: AttributeId,
 options?: SecondParameter<typeof lp5AxiosClient>,signal?: AbortSignal
) => {


      return lp5AxiosClient<AttributeSamples>(
      {url: `/6/attributes/${attributeId}/samples`, method: 'GET', signal
    },
      options);
    }




export const getGetAttributeSamplesQueryKey = (attributeId: AttributeId,) => {
    return [
    `/6/attributes/${attributeId}/samples`
    ] as const;
    }


export const getGetAttributeSamplesQueryOptions = <TData = Awaited<ReturnType<typeof getAttributeSamples>>, TError = Error | AuthorizationErrorResponse | ForbiddenFacesErrorResponse | RequestTimeoutResponse | InternalServerErrorResponse | ResponseTimeoutResponse | ServerTimeoutErrorResponse>(attributeId: AttributeId, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAttributeSamples>>, TError, TData>>, request?: SecondParameter<typeof lp5AxiosClient>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetAttributeSamplesQueryKey(attributeId);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getAttributeSamples>>> = ({ signal }) => getAttributeSamples(attributeId, requestOptions, signal);





   return  { queryKey, queryFn, enabled: attributeId !== null && attributeId !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getAttributeSamples>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetAttributeSamplesQueryResult = NonNullable<Awaited<ReturnType<typeof getAttributeSamples>>>
export type GetAttributeSamplesQueryError = Error | AuthorizationErrorResponse | ForbiddenFacesErrorResponse | RequestTimeoutResponse | InternalServerErrorResponse | ResponseTimeoutResponse | ServerTimeoutErrorResponse


export function useGetAttributeSamples<TData = Awaited<ReturnType<typeof getAttributeSamples>>, TError = Error | AuthorizationErrorResponse | ForbiddenFacesErrorResponse | RequestTimeoutResponse | InternalServerErrorResponse | ResponseTimeoutResponse | ServerTimeoutErrorResponse>(
 attributeId: AttributeId, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAttributeSamples>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getAttributeSamples>>,
          TError,
          Awaited<ReturnType<typeof getAttributeSamples>>
        > , 'initialData'
      >, request?: SecondParameter<typeof lp5AxiosClient>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetAttributeSamples<TData = Awaited<ReturnType<typeof getAttributeSamples>>, TError = Error | AuthorizationErrorResponse | ForbiddenFacesErrorResponse | RequestTimeoutResponse | InternalServerErrorResponse | ResponseTimeoutResponse | ServerTimeoutErrorResponse>(
 attributeId: AttributeId, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAttributeSamples>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getAttributeSamples>>,
          TError,
          Awaited<ReturnType<typeof getAttributeSamples>>
        > , 'initialData'
      >, request?: SecondParameter<typeof lp5AxiosClient>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetAttributeSamples<TData = Awaited<ReturnType<typeof getAttributeSamples>>, TError = Error | AuthorizationErrorResponse | ForbiddenFacesErrorResponse | RequestTimeoutResponse | InternalServerErrorResponse | ResponseTimeoutResponse | ServerTimeoutErrorResponse>(
 attributeId: AttributeId, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAttributeSamples>>, TError, TData>>, request?: SecondParameter<typeof lp5AxiosClient>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary get temporary attribute samples
 */

export function useGetAttributeSamples<TData = Awaited<ReturnType<typeof getAttributeSamples>>, TError = Error | AuthorizationErrorResponse | ForbiddenFacesErrorResponse | RequestTimeoutResponse | InternalServerErrorResponse | ResponseTimeoutResponse | ServerTimeoutErrorResponse>(
 attributeId: AttributeId, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAttributeSamples>>, TError, TData>>, request?: SecondParameter<typeof lp5AxiosClient>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetAttributeSamplesQueryOptions(attributeId,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}







/**
 * Get options for the resource.
 * @summary temporary attribute samples options
 */
export const getTemporaryAttributesOptions = (
    attributeId: AttributeId,
 options?: SecondParameter<typeof lp5AxiosClient>,signal?: AbortSignal
) => {


      return lp5AxiosClient<void>(
      {url: `/6/attributes/${attributeId}/samples`, method: 'OPTIONS', signal
    },
      options);
    }




export const getGetTemporaryAttributesOptionsMutationOptions = <TError = RequestTimeoutResponse | InternalServerErrorResponse | ResponseTimeoutResponse | ServerTimeoutErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof getTemporaryAttributesOptions>>, TError,{attributeId: AttributeId}, TContext>, request?: SecondParameter<typeof lp5AxiosClient>}
): UseMutationOptions<Awaited<ReturnType<typeof getTemporaryAttributesOptions>>, TError,{attributeId: AttributeId}, TContext> => {

const mutationKey = ['getTemporaryAttributesOptions'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof getTemporaryAttributesOptions>>, {attributeId: AttributeId}> = (props) => {
          const {attributeId} = props ?? {};

          return  getTemporaryAttributesOptions(attributeId,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type GetTemporaryAttributesOptionsMutationResult = NonNullable<Awaited<ReturnType<typeof getTemporaryAttributesOptions>>>

    export type GetTemporaryAttributesOptionsMutationError = RequestTimeoutResponse | InternalServerErrorResponse | ResponseTimeoutResponse | ServerTimeoutErrorResponse

    /**
 * @summary temporary attribute samples options
 */
export const useGetTemporaryAttributesOptions = <TError = RequestTimeoutResponse | InternalServerErrorResponse | ResponseTimeoutResponse | ServerTimeoutErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof getTemporaryAttributesOptions>>, TError,{attributeId: AttributeId}, TContext>, request?: SecondParameter<typeof lp5AxiosClient>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof getTemporaryAttributesOptions>>,
        TError,
        {attributeId: AttributeId},
        TContext
      > => {
      return useMutation(getGetTemporaryAttributesOptionsMutationOptions(options), queryClient);
    }

/**
 * Create a face.
 *
 * The face can be attached to one or several lists.
 *
 * You can create new face using a temporary attribute ID or using external attribute data (descriptors and/or basic attributes).
 *
 * You can also create the face without any attributes specified.
 * @summary create face
 */
export const createFace = (
    createFaceBody: NewFace | NewFaceBinary,
 options?: SecondParameter<typeof lp5AxiosClient>,signal?: AbortSignal
) => {


      return lp5AxiosClient<CreateFace201>(
      {url: `/6/faces`, method: 'POST',
      data: createFaceBody, signal
    },
      options);
    }




export const getCreateFaceMutationOptions = <TError = Error | AuthorizationErrorResponse | ForbiddenFacesErrorResponse | RequestTimeoutResponse | PayloadToLargeResponse | InternalServerErrorResponse | ResponseTimeoutResponse | ServerTimeoutErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createFace>>, TError,{data: NewFace | NewFaceBinary}, TContext>, request?: SecondParameter<typeof lp5AxiosClient>}
): UseMutationOptions<Awaited<ReturnType<typeof createFace>>, TError,{data: NewFace | NewFaceBinary}, TContext> => {

const mutationKey = ['createFace'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof createFace>>, {data: NewFace | NewFaceBinary}> = (props) => {
          const {data} = props ?? {};

          return  createFace(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type CreateFaceMutationResult = NonNullable<Awaited<ReturnType<typeof createFace>>>
    export type CreateFaceMutationBody = NewFace | NewFaceBinary
    export type CreateFaceMutationError = Error | AuthorizationErrorResponse | ForbiddenFacesErrorResponse | RequestTimeoutResponse | PayloadToLargeResponse | InternalServerErrorResponse | ResponseTimeoutResponse | ServerTimeoutErrorResponse

    /**
 * @summary create face
 */
export const useCreateFace = <TError = Error | AuthorizationErrorResponse | ForbiddenFacesErrorResponse | RequestTimeoutResponse | PayloadToLargeResponse | InternalServerErrorResponse | ResponseTimeoutResponse | ServerTimeoutErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createFace>>, TError,{data: NewFace | NewFaceBinary}, TContext>, request?: SecondParameter<typeof lp5AxiosClient>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof createFace>>,
        TError,
        {data: NewFace | NewFaceBinary},
        TContext
      > => {
      return useMutation(getCreateFaceMutationOptions(options), queryClient);
    }

/**
 * Get faces according to filters.
 * @summary get faces
 */
export const getFaces = (
    params?: GetFacesParams,
 options?: SecondParameter<typeof lp5AxiosClient>,signal?: AbortSignal
) => {


      return lp5AxiosClient<GetFaces>(
      {url: `/6/faces`, method: 'GET',
        params, signal
    },
      options);
    }




export const getGetFacesQueryKey = (params?: GetFacesParams,) => {
    return [
    `/6/faces`, ...(params ? [params] : [])
    ] as const;
    }


export const getGetFacesQueryOptions = <TData = Awaited<ReturnType<typeof getFaces>>, TError = Error | AuthorizationErrorResponse | ForbiddenFacesErrorResponse | RequestTimeoutResponse | InternalServerErrorResponse | ResponseTimeoutResponse | ServerTimeoutErrorResponse>(params?: GetFacesParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getFaces>>, TError, TData>>, request?: SecondParameter<typeof lp5AxiosClient>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetFacesQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getFaces>>> = ({ signal }) => getFaces(params, requestOptions, signal);





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getFaces>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetFacesQueryResult = NonNullable<Awaited<ReturnType<typeof getFaces>>>
export type GetFacesQueryError = Error | AuthorizationErrorResponse | ForbiddenFacesErrorResponse | RequestTimeoutResponse | InternalServerErrorResponse | ResponseTimeoutResponse | ServerTimeoutErrorResponse


export function useGetFaces<TData = Awaited<ReturnType<typeof getFaces>>, TError = Error | AuthorizationErrorResponse | ForbiddenFacesErrorResponse | RequestTimeoutResponse | InternalServerErrorResponse | ResponseTimeoutResponse | ServerTimeoutErrorResponse>(
 params: undefined |  GetFacesParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getFaces>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getFaces>>,
          TError,
          Awaited<ReturnType<typeof getFaces>>
        > , 'initialData'
      >, request?: SecondParameter<typeof lp5AxiosClient>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetFaces<TData = Awaited<ReturnType<typeof getFaces>>, TError = Error | AuthorizationErrorResponse | ForbiddenFacesErrorResponse | RequestTimeoutResponse | InternalServerErrorResponse | ResponseTimeoutResponse | ServerTimeoutErrorResponse>(
 params?: GetFacesParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getFaces>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getFaces>>,
          TError,
          Awaited<ReturnType<typeof getFaces>>
        > , 'initialData'
      >, request?: SecondParameter<typeof lp5AxiosClient>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetFaces<TData = Awaited<ReturnType<typeof getFaces>>, TError = Error | AuthorizationErrorResponse | ForbiddenFacesErrorResponse | RequestTimeoutResponse | InternalServerErrorResponse | ResponseTimeoutResponse | ServerTimeoutErrorResponse>(
 params?: GetFacesParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getFaces>>, TError, TData>>, request?: SecondParameter<typeof lp5AxiosClient>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary get faces
 */

export function useGetFaces<TData = Awaited<ReturnType<typeof getFaces>>, TError = Error | AuthorizationErrorResponse | ForbiddenFacesErrorResponse | RequestTimeoutResponse | InternalServerErrorResponse | ResponseTimeoutResponse | ServerTimeoutErrorResponse>(
 params?: GetFacesParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getFaces>>, TError, TData>>, request?: SecondParameter<typeof lp5AxiosClient>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetFacesQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}







/**
 * Delete several faces by IDs.
 *
 * When the faces are removed, attributes (descriptors and basic attributes) linked to the faces are deleted.
 * Samples linked to the faces are not deleted.
 *
 * If you need to delete faces according to some filters and with all samples,
 * you can use the ["garbage collection task"](operation/createGCTask) with `target = faces` and `remove_samples` flag enabled.
 * @summary delete faces
 */
export const deleteFaces = (
    facesToBeDeleted?: FacesToBeDeleted,
    params?: DeleteFacesParams,
 options?: SecondParameter<typeof lp5AxiosClient>,signal?: AbortSignal
) => {


      return lp5AxiosClient<void>(
      {url: `/6/faces`, method: 'DELETE',
      headers: {'Content-Type': 'application/json', },
      data: facesToBeDeleted,
        params, signal
    },
      options);
    }




export const getDeleteFacesMutationOptions = <TError = Error | AuthorizationErrorResponse | ForbiddenFacesErrorResponse | FaceNotFoundErrorResponse | RequestTimeoutResponse | PayloadToLargeResponse | InternalServerErrorResponse | ResponseTimeoutResponse | ServerTimeoutErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteFaces>>, TError,{data?: FacesToBeDeleted;params?: DeleteFacesParams}, TContext>, request?: SecondParameter<typeof lp5AxiosClient>}
): UseMutationOptions<Awaited<ReturnType<typeof deleteFaces>>, TError,{data?: FacesToBeDeleted;params?: DeleteFacesParams}, TContext> => {

const mutationKey = ['deleteFaces'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof deleteFaces>>, {data?: FacesToBeDeleted;params?: DeleteFacesParams}> = (props) => {
          const {data,params} = props ?? {};

          return  deleteFaces(data,params,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type DeleteFacesMutationResult = NonNullable<Awaited<ReturnType<typeof deleteFaces>>>
    export type DeleteFacesMutationBody = FacesToBeDeleted | undefined
    export type DeleteFacesMutationError = Error | AuthorizationErrorResponse | ForbiddenFacesErrorResponse | FaceNotFoundErrorResponse | RequestTimeoutResponse | PayloadToLargeResponse | InternalServerErrorResponse | ResponseTimeoutResponse | ServerTimeoutErrorResponse

    /**
 * @summary delete faces
 */
export const useDeleteFaces = <TError = Error | AuthorizationErrorResponse | ForbiddenFacesErrorResponse | FaceNotFoundErrorResponse | RequestTimeoutResponse | PayloadToLargeResponse | InternalServerErrorResponse | ResponseTimeoutResponse | ServerTimeoutErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteFaces>>, TError,{data?: FacesToBeDeleted;params?: DeleteFacesParams}, TContext>, request?: SecondParameter<typeof lp5AxiosClient>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof deleteFaces>>,
        TError,
        {data?: FacesToBeDeleted;params?: DeleteFacesParams},
        TContext
      > => {
      return useMutation(getDeleteFacesMutationOptions(options), queryClient);
    }

/**
 * Get options for the resource.
 * @summary faces options
 */
export const getFacesOptions = (

 options?: SecondParameter<typeof lp5AxiosClient>,signal?: AbortSignal
) => {


      return lp5AxiosClient<void>(
      {url: `/6/faces`, method: 'OPTIONS', signal
    },
      options);
    }




export const getGetFacesOptionsMutationOptions = <TError = RequestTimeoutResponse | InternalServerErrorResponse | ResponseTimeoutResponse | ServerTimeoutErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof getFacesOptions>>, TError,void, TContext>, request?: SecondParameter<typeof lp5AxiosClient>}
): UseMutationOptions<Awaited<ReturnType<typeof getFacesOptions>>, TError,void, TContext> => {

const mutationKey = ['getFacesOptions'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof getFacesOptions>>, void> = () => {


          return  getFacesOptions(requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type GetFacesOptionsMutationResult = NonNullable<Awaited<ReturnType<typeof getFacesOptions>>>

    export type GetFacesOptionsMutationError = RequestTimeoutResponse | InternalServerErrorResponse | ResponseTimeoutResponse | ServerTimeoutErrorResponse

    /**
 * @summary faces options
 */
export const useGetFacesOptions = <TError = RequestTimeoutResponse | InternalServerErrorResponse | ResponseTimeoutResponse | ServerTimeoutErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof getFacesOptions>>, TError,void, TContext>, request?: SecondParameter<typeof lp5AxiosClient>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof getFacesOptions>>,
        TError,
        void,
        TContext
      > => {
      return useMutation(getGetFacesOptionsMutationOptions(options), queryClient);
    }

/**
 * Count faces according to the filters.
 * @summary get face count
 */
export const getFacesCount = (
    params?: GetFacesCountParams,
 options?: SecondParameter<typeof lp5AxiosClient>,signal?: AbortSignal
) => {


      return lp5AxiosClient<FacesCount>(
      {url: `/6/faces/count`, method: 'GET',
        params, signal
    },
      options);
    }




export const getGetFacesCountQueryKey = (params?: GetFacesCountParams,) => {
    return [
    `/6/faces/count`, ...(params ? [params] : [])
    ] as const;
    }


export const getGetFacesCountQueryOptions = <TData = Awaited<ReturnType<typeof getFacesCount>>, TError = Error | AuthorizationErrorResponse | ForbiddenFacesErrorResponse | RequestTimeoutResponse | InternalServerErrorResponse | ResponseTimeoutResponse | ServerTimeoutErrorResponse>(params?: GetFacesCountParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getFacesCount>>, TError, TData>>, request?: SecondParameter<typeof lp5AxiosClient>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetFacesCountQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getFacesCount>>> = ({ signal }) => getFacesCount(params, requestOptions, signal);





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getFacesCount>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetFacesCountQueryResult = NonNullable<Awaited<ReturnType<typeof getFacesCount>>>
export type GetFacesCountQueryError = Error | AuthorizationErrorResponse | ForbiddenFacesErrorResponse | RequestTimeoutResponse | InternalServerErrorResponse | ResponseTimeoutResponse | ServerTimeoutErrorResponse


export function useGetFacesCount<TData = Awaited<ReturnType<typeof getFacesCount>>, TError = Error | AuthorizationErrorResponse | ForbiddenFacesErrorResponse | RequestTimeoutResponse | InternalServerErrorResponse | ResponseTimeoutResponse | ServerTimeoutErrorResponse>(
 params: undefined |  GetFacesCountParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getFacesCount>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getFacesCount>>,
          TError,
          Awaited<ReturnType<typeof getFacesCount>>
        > , 'initialData'
      >, request?: SecondParameter<typeof lp5AxiosClient>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetFacesCount<TData = Awaited<ReturnType<typeof getFacesCount>>, TError = Error | AuthorizationErrorResponse | ForbiddenFacesErrorResponse | RequestTimeoutResponse | InternalServerErrorResponse | ResponseTimeoutResponse | ServerTimeoutErrorResponse>(
 params?: GetFacesCountParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getFacesCount>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getFacesCount>>,
          TError,
          Awaited<ReturnType<typeof getFacesCount>>
        > , 'initialData'
      >, request?: SecondParameter<typeof lp5AxiosClient>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetFacesCount<TData = Awaited<ReturnType<typeof getFacesCount>>, TError = Error | AuthorizationErrorResponse | ForbiddenFacesErrorResponse | RequestTimeoutResponse | InternalServerErrorResponse | ResponseTimeoutResponse | ServerTimeoutErrorResponse>(
 params?: GetFacesCountParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getFacesCount>>, TError, TData>>, request?: SecondParameter<typeof lp5AxiosClient>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary get face count
 */

export function useGetFacesCount<TData = Awaited<ReturnType<typeof getFacesCount>>, TError = Error | AuthorizationErrorResponse | ForbiddenFacesErrorResponse | RequestTimeoutResponse | InternalServerErrorResponse | ResponseTimeoutResponse | ServerTimeoutErrorResponse>(
 params?: GetFacesCountParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getFacesCount>>, TError, TData>>, request?: SecondParameter<typeof lp5AxiosClient>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetFacesCountQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}







/**
 * Get options for the resource.
 * @summary faces count options
 */
export const getFacesCountOptions = (

 options?: SecondParameter<typeof lp5AxiosClient>,signal?: AbortSignal
) => {


      return lp5AxiosClient<void>(
      {url: `/6/faces/count`, method: 'OPTIONS', signal
    },
      options);
    }




export const getGetFacesCountOptionsMutationOptions = <TError = RequestTimeoutResponse | InternalServerErrorResponse | ResponseTimeoutResponse | ServerTimeoutErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof getFacesCountOptions>>, TError,void, TContext>, request?: SecondParameter<typeof lp5AxiosClient>}
): UseMutationOptions<Awaited<ReturnType<typeof getFacesCountOptions>>, TError,void, TContext> => {

const mutationKey = ['getFacesCountOptions'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof getFacesCountOptions>>, void> = () => {


          return  getFacesCountOptions(requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type GetFacesCountOptionsMutationResult = NonNullable<Awaited<ReturnType<typeof getFacesCountOptions>>>

    export type GetFacesCountOptionsMutationError = RequestTimeoutResponse | InternalServerErrorResponse | ResponseTimeoutResponse | ServerTimeoutErrorResponse

    /**
 * @summary faces count options
 */
export const useGetFacesCountOptions = <TError = RequestTimeoutResponse | InternalServerErrorResponse | ResponseTimeoutResponse | ServerTimeoutErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof getFacesCountOptions>>, TError,void, TContext>, request?: SecondParameter<typeof lp5AxiosClient>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof getFacesCountOptions>>,
        TError,
        void,
        TContext
      > => {
      return useMutation(getGetFacesCountOptionsMutationOptions(options), queryClient);
    }

/**
 * Count faces with attributes.
 * @summary get count of faces with attributes
 */
export const getFaceAttributeCount = (
    params?: GetFaceAttributeCountParams,
 options?: SecondParameter<typeof lp5AxiosClient>,signal?: AbortSignal
) => {


      return lp5AxiosClient<FacesCount>(
      {url: `/6/faces/attributes/count`, method: 'GET',
        params, signal
    },
      options);
    }




export const getGetFaceAttributeCountQueryKey = (params?: GetFaceAttributeCountParams,) => {
    return [
    `/6/faces/attributes/count`, ...(params ? [params] : [])
    ] as const;
    }


export const getGetFaceAttributeCountQueryOptions = <TData = Awaited<ReturnType<typeof getFaceAttributeCount>>, TError = Error | AuthorizationErrorResponse | ForbiddenFacesErrorResponse | RequestTimeoutResponse | InternalServerErrorResponse | ResponseTimeoutResponse | ServerTimeoutErrorResponse>(params?: GetFaceAttributeCountParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getFaceAttributeCount>>, TError, TData>>, request?: SecondParameter<typeof lp5AxiosClient>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetFaceAttributeCountQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getFaceAttributeCount>>> = ({ signal }) => getFaceAttributeCount(params, requestOptions, signal);





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getFaceAttributeCount>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetFaceAttributeCountQueryResult = NonNullable<Awaited<ReturnType<typeof getFaceAttributeCount>>>
export type GetFaceAttributeCountQueryError = Error | AuthorizationErrorResponse | ForbiddenFacesErrorResponse | RequestTimeoutResponse | InternalServerErrorResponse | ResponseTimeoutResponse | ServerTimeoutErrorResponse


export function useGetFaceAttributeCount<TData = Awaited<ReturnType<typeof getFaceAttributeCount>>, TError = Error | AuthorizationErrorResponse | ForbiddenFacesErrorResponse | RequestTimeoutResponse | InternalServerErrorResponse | ResponseTimeoutResponse | ServerTimeoutErrorResponse>(
 params: undefined |  GetFaceAttributeCountParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getFaceAttributeCount>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getFaceAttributeCount>>,
          TError,
          Awaited<ReturnType<typeof getFaceAttributeCount>>
        > , 'initialData'
      >, request?: SecondParameter<typeof lp5AxiosClient>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetFaceAttributeCount<TData = Awaited<ReturnType<typeof getFaceAttributeCount>>, TError = Error | AuthorizationErrorResponse | ForbiddenFacesErrorResponse | RequestTimeoutResponse | InternalServerErrorResponse | ResponseTimeoutResponse | ServerTimeoutErrorResponse>(
 params?: GetFaceAttributeCountParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getFaceAttributeCount>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getFaceAttributeCount>>,
          TError,
          Awaited<ReturnType<typeof getFaceAttributeCount>>
        > , 'initialData'
      >, request?: SecondParameter<typeof lp5AxiosClient>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetFaceAttributeCount<TData = Awaited<ReturnType<typeof getFaceAttributeCount>>, TError = Error | AuthorizationErrorResponse | ForbiddenFacesErrorResponse | RequestTimeoutResponse | InternalServerErrorResponse | ResponseTimeoutResponse | ServerTimeoutErrorResponse>(
 params?: GetFaceAttributeCountParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getFaceAttributeCount>>, TError, TData>>, request?: SecondParameter<typeof lp5AxiosClient>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary get count of faces with attributes
 */

export function useGetFaceAttributeCount<TData = Awaited<ReturnType<typeof getFaceAttributeCount>>, TError = Error | AuthorizationErrorResponse | ForbiddenFacesErrorResponse | RequestTimeoutResponse | InternalServerErrorResponse | ResponseTimeoutResponse | ServerTimeoutErrorResponse>(
 params?: GetFaceAttributeCountParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getFaceAttributeCount>>, TError, TData>>, request?: SecondParameter<typeof lp5AxiosClient>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetFaceAttributeCountQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}







/**
 * Get options for the resource.
 * @summary get count of faces with attributes options
 */
export const getFaceAttributesCountOptions = (

 options?: SecondParameter<typeof lp5AxiosClient>,signal?: AbortSignal
) => {


      return lp5AxiosClient<void>(
      {url: `/6/faces/attributes/count`, method: 'OPTIONS', signal
    },
      options);
    }




export const getGetFaceAttributesCountOptionsMutationOptions = <TError = RequestTimeoutResponse | InternalServerErrorResponse | ResponseTimeoutResponse | ServerTimeoutErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof getFaceAttributesCountOptions>>, TError,void, TContext>, request?: SecondParameter<typeof lp5AxiosClient>}
): UseMutationOptions<Awaited<ReturnType<typeof getFaceAttributesCountOptions>>, TError,void, TContext> => {

const mutationKey = ['getFaceAttributesCountOptions'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof getFaceAttributesCountOptions>>, void> = () => {


          return  getFaceAttributesCountOptions(requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type GetFaceAttributesCountOptionsMutationResult = NonNullable<Awaited<ReturnType<typeof getFaceAttributesCountOptions>>>

    export type GetFaceAttributesCountOptionsMutationError = RequestTimeoutResponse | InternalServerErrorResponse | ResponseTimeoutResponse | ServerTimeoutErrorResponse

    /**
 * @summary get count of faces with attributes options
 */
export const useGetFaceAttributesCountOptions = <TError = RequestTimeoutResponse | InternalServerErrorResponse | ResponseTimeoutResponse | ServerTimeoutErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof getFaceAttributesCountOptions>>, TError,void, TContext>, request?: SecondParameter<typeof lp5AxiosClient>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof getFaceAttributesCountOptions>>,
        TError,
        void,
        TContext
      > => {
      return useMutation(getGetFaceAttributesCountOptionsMutationOptions(options), queryClient);
    }

/**
 * Get face by ID.
 * @summary get face
 */
export const getFace = (
    faceId: Uuid,
    params?: GetFaceParams,
 options?: SecondParameter<typeof lp5AxiosClient>,signal?: AbortSignal
) => {


      return lp5AxiosClient<OutputFace>(
      {url: `/6/faces/${faceId}`, method: 'GET',
        params, signal
    },
      options);
    }




export const getGetFaceQueryKey = (faceId: Uuid,
    params?: GetFaceParams,) => {
    return [
    `/6/faces/${faceId}`, ...(params ? [params] : [])
    ] as const;
    }


export const getGetFaceQueryOptions = <TData = Awaited<ReturnType<typeof getFace>>, TError = Error | AuthorizationErrorResponse | ForbiddenFacesErrorResponse | RequestTimeoutResponse | InternalServerErrorResponse | ResponseTimeoutResponse | ServerTimeoutErrorResponse>(faceId: Uuid,
    params?: GetFaceParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getFace>>, TError, TData>>, request?: SecondParameter<typeof lp5AxiosClient>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetFaceQueryKey(faceId,params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getFace>>> = ({ signal }) => getFace(faceId,params, requestOptions, signal);





   return  { queryKey, queryFn, enabled: faceId !== null && faceId !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getFace>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetFaceQueryResult = NonNullable<Awaited<ReturnType<typeof getFace>>>
export type GetFaceQueryError = Error | AuthorizationErrorResponse | ForbiddenFacesErrorResponse | RequestTimeoutResponse | InternalServerErrorResponse | ResponseTimeoutResponse | ServerTimeoutErrorResponse


export function useGetFace<TData = Awaited<ReturnType<typeof getFace>>, TError = Error | AuthorizationErrorResponse | ForbiddenFacesErrorResponse | RequestTimeoutResponse | InternalServerErrorResponse | ResponseTimeoutResponse | ServerTimeoutErrorResponse>(
 faceId: Uuid,
    params: undefined |  GetFaceParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getFace>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getFace>>,
          TError,
          Awaited<ReturnType<typeof getFace>>
        > , 'initialData'
      >, request?: SecondParameter<typeof lp5AxiosClient>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetFace<TData = Awaited<ReturnType<typeof getFace>>, TError = Error | AuthorizationErrorResponse | ForbiddenFacesErrorResponse | RequestTimeoutResponse | InternalServerErrorResponse | ResponseTimeoutResponse | ServerTimeoutErrorResponse>(
 faceId: Uuid,
    params?: GetFaceParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getFace>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getFace>>,
          TError,
          Awaited<ReturnType<typeof getFace>>
        > , 'initialData'
      >, request?: SecondParameter<typeof lp5AxiosClient>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetFace<TData = Awaited<ReturnType<typeof getFace>>, TError = Error | AuthorizationErrorResponse | ForbiddenFacesErrorResponse | RequestTimeoutResponse | InternalServerErrorResponse | ResponseTimeoutResponse | ServerTimeoutErrorResponse>(
 faceId: Uuid,
    params?: GetFaceParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getFace>>, TError, TData>>, request?: SecondParameter<typeof lp5AxiosClient>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary get face
 */

export function useGetFace<TData = Awaited<ReturnType<typeof getFace>>, TError = Error | AuthorizationErrorResponse | ForbiddenFacesErrorResponse | RequestTimeoutResponse | InternalServerErrorResponse | ResponseTimeoutResponse | ServerTimeoutErrorResponse>(
 faceId: Uuid,
    params?: GetFaceParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getFace>>, TError, TData>>, request?: SecondParameter<typeof lp5AxiosClient>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetFaceQueryOptions(faceId,params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}







/**
 * Update face fields: `user_data`, `external_id`, `event_id`, `avatar`.
 * @summary patch face
 */
export const patchFace = (
    faceId: Uuid,
    updateFace: UpdateFace,
 options?: SecondParameter<typeof lp5AxiosClient>,signal?: AbortSignal
) => {


      return lp5AxiosClient<void>(
      {url: `/6/faces/${faceId}`, method: 'PATCH',
      headers: {'Content-Type': 'application/json', },
      data: updateFace, signal
    },
      options);
    }




export const getPatchFaceMutationOptions = <TError = Error | AuthorizationErrorResponse | ForbiddenFacesErrorResponse | FaceNotFoundErrorResponse | RequestTimeoutResponse | PayloadToLargeResponse | InternalServerErrorResponse | ResponseTimeoutResponse | ServerTimeoutErrorResponse,
    TContext = unknown>(queryClient: QueryClient, options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof patchFace>>, TError,{faceId: Uuid;data: UpdateFace}, TContext>, skipInvalidation?: boolean, request?: SecondParameter<typeof lp5AxiosClient>}
): UseMutationOptions<Awaited<ReturnType<typeof patchFace>>, TError,{faceId: Uuid;data: UpdateFace}, TContext> => {

const mutationKey = ['patchFace'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof patchFace>>, {faceId: Uuid;data: UpdateFace}> = (props) => {
          const {faceId,data} = props ?? {};

          return  patchFace(faceId,data,requestOptions)
        }

  const onSuccess = (data: Awaited<ReturnType<typeof patchFace>>, variables: {faceId: Uuid;data: UpdateFace}, onMutateResult: TContext, context: MutationFunctionContext) => {
        if (!options?.skipInvalidation) {
        queryClient.invalidateQueries({ queryKey: getGetFacesQueryKey() });
    queryClient.invalidateQueries({ queryKey: getGetFaceQueryKey(variables.faceId) });
        }
        mutationOptions?.onSuccess?.(data, variables, onMutateResult, context);
      };




  return  { ...mutationOptions, mutationFn, onSuccess }}

    export type PatchFaceMutationResult = NonNullable<Awaited<ReturnType<typeof patchFace>>>
    export type PatchFaceMutationBody = UpdateFace
    export type PatchFaceMutationError = Error | AuthorizationErrorResponse | ForbiddenFacesErrorResponse | FaceNotFoundErrorResponse | RequestTimeoutResponse | PayloadToLargeResponse | InternalServerErrorResponse | ResponseTimeoutResponse | ServerTimeoutErrorResponse

    /**
 * @summary patch face
 */
export const usePatchFace = <TError = Error | AuthorizationErrorResponse | ForbiddenFacesErrorResponse | FaceNotFoundErrorResponse | RequestTimeoutResponse | PayloadToLargeResponse | InternalServerErrorResponse | ResponseTimeoutResponse | ServerTimeoutErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof patchFace>>, TError,{faceId: Uuid;data: UpdateFace}, TContext>, skipInvalidation?: boolean, request?: SecondParameter<typeof lp5AxiosClient>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof patchFace>>,
        TError,
        {faceId: Uuid;data: UpdateFace},
        TContext
      > => {
      const backupQueryClient = useQueryClient();
      return useMutation(getPatchFaceMutationOptions(queryClient ?? backupQueryClient, options), queryClient);
    }

/**
 * Remove face by ID.
 *
 *   When the face is removed, attributes (descriptors and basic attributes) linked to the face are deleted.
 *   Samples linked to the face are not deleted. If there are a small number of samples for face, then you can use the resources
 *   ["get face attribute samples"](#operation/getFaceAttributesOptions) >
 *   ["remove face/body sample"](operation/deleteSample) > "delete face" (this resource). If you need to delete faces according to some filters and with all samples,
 *   you can use the ["garbage collection task"](operation/createGCTask) with `target = faces` and `remove_samples` flag enabled.
 * @summary remove face
 */
export const deleteFace = (
    faceId: Uuid,
 options?: SecondParameter<typeof lp5AxiosClient>,signal?: AbortSignal
) => {


      return lp5AxiosClient<void>(
      {url: `/6/faces/${faceId}`, method: 'DELETE', signal
    },
      options);
    }




export const getDeleteFaceMutationOptions = <TError = AuthorizationErrorResponse | ForbiddenFacesErrorResponse | FaceNotFoundErrorResponse | RequestTimeoutResponse | InternalServerErrorResponse | ResponseTimeoutResponse | ServerTimeoutErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteFace>>, TError,{faceId: Uuid}, TContext>, request?: SecondParameter<typeof lp5AxiosClient>}
): UseMutationOptions<Awaited<ReturnType<typeof deleteFace>>, TError,{faceId: Uuid}, TContext> => {

const mutationKey = ['deleteFace'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof deleteFace>>, {faceId: Uuid}> = (props) => {
          const {faceId} = props ?? {};

          return  deleteFace(faceId,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type DeleteFaceMutationResult = NonNullable<Awaited<ReturnType<typeof deleteFace>>>

    export type DeleteFaceMutationError = AuthorizationErrorResponse | ForbiddenFacesErrorResponse | FaceNotFoundErrorResponse | RequestTimeoutResponse | InternalServerErrorResponse | ResponseTimeoutResponse | ServerTimeoutErrorResponse

    /**
 * @summary remove face
 */
export const useDeleteFace = <TError = AuthorizationErrorResponse | ForbiddenFacesErrorResponse | FaceNotFoundErrorResponse | RequestTimeoutResponse | InternalServerErrorResponse | ResponseTimeoutResponse | ServerTimeoutErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteFace>>, TError,{faceId: Uuid}, TContext>, request?: SecondParameter<typeof lp5AxiosClient>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof deleteFace>>,
        TError,
        {faceId: Uuid},
        TContext
      > => {
      return useMutation(getDeleteFaceMutationOptions(options), queryClient);
    }

/**
 * Check if face with `face_id` exists.
 * @summary check if face exists
 */
export const checkFace = (
    faceId: Uuid,
    params?: CheckFaceParams,
 options?: SecondParameter<typeof lp5AxiosClient>,signal?: AbortSignal
) => {


      return lp5AxiosClient<void>(
      {url: `/6/faces/${faceId}`, method: 'HEAD',
        params, signal
    },
      options);
    }




export const getCheckFaceMutationOptions = <TError = AuthorizationErrorWithoutBodyResponse | ForbiddenErrorWithoutBodyResponse | void | RequestTimeoutWithoutBodyResponse | InternalServerErrorWithoutBodyResponse | ResponseTimeoutWithoutBodyResponse | ServerTimeoutErrorWithoutBodyResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof checkFace>>, TError,{faceId: Uuid;params?: CheckFaceParams}, TContext>, request?: SecondParameter<typeof lp5AxiosClient>}
): UseMutationOptions<Awaited<ReturnType<typeof checkFace>>, TError,{faceId: Uuid;params?: CheckFaceParams}, TContext> => {

const mutationKey = ['checkFace'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof checkFace>>, {faceId: Uuid;params?: CheckFaceParams}> = (props) => {
          const {faceId,params} = props ?? {};

          return  checkFace(faceId,params,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type CheckFaceMutationResult = NonNullable<Awaited<ReturnType<typeof checkFace>>>

    export type CheckFaceMutationError = AuthorizationErrorWithoutBodyResponse | ForbiddenErrorWithoutBodyResponse | void | RequestTimeoutWithoutBodyResponse | InternalServerErrorWithoutBodyResponse | ResponseTimeoutWithoutBodyResponse | ServerTimeoutErrorWithoutBodyResponse

    /**
 * @summary check if face exists
 */
export const useCheckFace = <TError = AuthorizationErrorWithoutBodyResponse | ForbiddenErrorWithoutBodyResponse | void | RequestTimeoutWithoutBodyResponse | InternalServerErrorWithoutBodyResponse | ResponseTimeoutWithoutBodyResponse | ServerTimeoutErrorWithoutBodyResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof checkFace>>, TError,{faceId: Uuid;params?: CheckFaceParams}, TContext>, request?: SecondParameter<typeof lp5AxiosClient>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof checkFace>>,
        TError,
        {faceId: Uuid;params?: CheckFaceParams},
        TContext
      > => {
      return useMutation(getCheckFaceMutationOptions(options), queryClient);
    }

/**
 * Get options for the resource.
 * @summary face options
 */
export const getFaceOptions = (
    faceId: Uuid,
 options?: SecondParameter<typeof lp5AxiosClient>,signal?: AbortSignal
) => {


      return lp5AxiosClient<void>(
      {url: `/6/faces/${faceId}`, method: 'OPTIONS', signal
    },
      options);
    }




export const getGetFaceOptionsMutationOptions = <TError = RequestTimeoutResponse | InternalServerErrorResponse | ResponseTimeoutResponse | ServerTimeoutErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof getFaceOptions>>, TError,{faceId: Uuid}, TContext>, request?: SecondParameter<typeof lp5AxiosClient>}
): UseMutationOptions<Awaited<ReturnType<typeof getFaceOptions>>, TError,{faceId: Uuid}, TContext> => {

const mutationKey = ['getFaceOptions'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof getFaceOptions>>, {faceId: Uuid}> = (props) => {
          const {faceId} = props ?? {};

          return  getFaceOptions(faceId,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type GetFaceOptionsMutationResult = NonNullable<Awaited<ReturnType<typeof getFaceOptions>>>

    export type GetFaceOptionsMutationError = RequestTimeoutResponse | InternalServerErrorResponse | ResponseTimeoutResponse | ServerTimeoutErrorResponse

    /**
 * @summary face options
 */
export const useGetFaceOptions = <TError = RequestTimeoutResponse | InternalServerErrorResponse | ResponseTimeoutResponse | ServerTimeoutErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof getFaceOptions>>, TError,{faceId: Uuid}, TContext>, request?: SecondParameter<typeof lp5AxiosClient>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof getFaceOptions>>,
        TError,
        {faceId: Uuid},
        TContext
      > => {
      return useMutation(getGetFaceOptionsMutationOptions(options), queryClient);
    }

/**
 * Put face attribute.
 *
 * This request changes all the attribute data corresponding to the specified face.
 *
 * The attribute can be specified by temporary attribute ID or using external attribute data (descriptors and/or basic attributes).
 * @summary put face attribute
 */
export const putFaceAttributes = (
    faceId: Uuid,
    putFaceAttributesBody: FaceAttribute | FaceAttributeBinary,
 options?: SecondParameter<typeof lp5AxiosClient>,signal?: AbortSignal
) => {


      return lp5AxiosClient<void>(
      {url: `/6/faces/${faceId}/attributes`, method: 'PUT',
      data: putFaceAttributesBody, signal
    },
      options);
    }




export const getPutFaceAttributesMutationOptions = <TError = Error | AuthorizationErrorResponse | ForbiddenFacesErrorResponse | FaceNotFoundErrorResponse | RequestTimeoutResponse | PayloadToLargeResponse | InternalServerErrorResponse | ResponseTimeoutResponse | ServerTimeoutErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof putFaceAttributes>>, TError,{faceId: Uuid;data: FaceAttribute | FaceAttributeBinary}, TContext>, request?: SecondParameter<typeof lp5AxiosClient>}
): UseMutationOptions<Awaited<ReturnType<typeof putFaceAttributes>>, TError,{faceId: Uuid;data: FaceAttribute | FaceAttributeBinary}, TContext> => {

const mutationKey = ['putFaceAttributes'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof putFaceAttributes>>, {faceId: Uuid;data: FaceAttribute | FaceAttributeBinary}> = (props) => {
          const {faceId,data} = props ?? {};

          return  putFaceAttributes(faceId,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type PutFaceAttributesMutationResult = NonNullable<Awaited<ReturnType<typeof putFaceAttributes>>>
    export type PutFaceAttributesMutationBody = FaceAttribute | FaceAttributeBinary
    export type PutFaceAttributesMutationError = Error | AuthorizationErrorResponse | ForbiddenFacesErrorResponse | FaceNotFoundErrorResponse | RequestTimeoutResponse | PayloadToLargeResponse | InternalServerErrorResponse | ResponseTimeoutResponse | ServerTimeoutErrorResponse

    /**
 * @summary put face attribute
 */
export const usePutFaceAttributes = <TError = Error | AuthorizationErrorResponse | ForbiddenFacesErrorResponse | FaceNotFoundErrorResponse | RequestTimeoutResponse | PayloadToLargeResponse | InternalServerErrorResponse | ResponseTimeoutResponse | ServerTimeoutErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof putFaceAttributes>>, TError,{faceId: Uuid;data: FaceAttribute | FaceAttributeBinary}, TContext>, request?: SecondParameter<typeof lp5AxiosClient>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof putFaceAttributes>>,
        TError,
        {faceId: Uuid;data: FaceAttribute | FaceAttributeBinary},
        TContext
      > => {
      return useMutation(getPutFaceAttributesMutationOptions(options), queryClient);
    }

/**
 * Get face attribute by ID.
 * @summary get face attribute
 */
export const getFaceAttributes = (
    faceId: Uuid,
    params?: GetFaceAttributesParams,
 options?: SecondParameter<typeof lp5AxiosClient>,signal?: AbortSignal
) => {


      return lp5AxiosClient<OutputFaceAttributeJson | OutputFaceAttributeMsgpack>(
      {url: `/6/faces/${faceId}/attributes`, method: 'GET',
        params, signal
    },
      options);
    }




export const getGetFaceAttributesQueryKey = (faceId: Uuid,
    params?: GetFaceAttributesParams,) => {
    return [
    `/6/faces/${faceId}/attributes`, ...(params ? [params] : [])
    ] as const;
    }


export const getGetFaceAttributesQueryOptions = <TData = Awaited<ReturnType<typeof getFaceAttributes>>, TError = Error | AuthorizationErrorResponse | ForbiddenFacesErrorResponse | FaceNotFoundErrorResponse | RequestTimeoutResponse | InternalServerErrorResponse | ResponseTimeoutResponse | ServerTimeoutErrorResponse>(faceId: Uuid,
    params?: GetFaceAttributesParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getFaceAttributes>>, TError, TData>>, request?: SecondParameter<typeof lp5AxiosClient>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetFaceAttributesQueryKey(faceId,params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getFaceAttributes>>> = ({ signal }) => getFaceAttributes(faceId,params, requestOptions, signal);





   return  { queryKey, queryFn, enabled: faceId !== null && faceId !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getFaceAttributes>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetFaceAttributesQueryResult = NonNullable<Awaited<ReturnType<typeof getFaceAttributes>>>
export type GetFaceAttributesQueryError = Error | AuthorizationErrorResponse | ForbiddenFacesErrorResponse | FaceNotFoundErrorResponse | RequestTimeoutResponse | InternalServerErrorResponse | ResponseTimeoutResponse | ServerTimeoutErrorResponse


export function useGetFaceAttributes<TData = Awaited<ReturnType<typeof getFaceAttributes>>, TError = Error | AuthorizationErrorResponse | ForbiddenFacesErrorResponse | FaceNotFoundErrorResponse | RequestTimeoutResponse | InternalServerErrorResponse | ResponseTimeoutResponse | ServerTimeoutErrorResponse>(
 faceId: Uuid,
    params: undefined |  GetFaceAttributesParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getFaceAttributes>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getFaceAttributes>>,
          TError,
          Awaited<ReturnType<typeof getFaceAttributes>>
        > , 'initialData'
      >, request?: SecondParameter<typeof lp5AxiosClient>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetFaceAttributes<TData = Awaited<ReturnType<typeof getFaceAttributes>>, TError = Error | AuthorizationErrorResponse | ForbiddenFacesErrorResponse | FaceNotFoundErrorResponse | RequestTimeoutResponse | InternalServerErrorResponse | ResponseTimeoutResponse | ServerTimeoutErrorResponse>(
 faceId: Uuid,
    params?: GetFaceAttributesParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getFaceAttributes>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getFaceAttributes>>,
          TError,
          Awaited<ReturnType<typeof getFaceAttributes>>
        > , 'initialData'
      >, request?: SecondParameter<typeof lp5AxiosClient>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetFaceAttributes<TData = Awaited<ReturnType<typeof getFaceAttributes>>, TError = Error | AuthorizationErrorResponse | ForbiddenFacesErrorResponse | FaceNotFoundErrorResponse | RequestTimeoutResponse | InternalServerErrorResponse | ResponseTimeoutResponse | ServerTimeoutErrorResponse>(
 faceId: Uuid,
    params?: GetFaceAttributesParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getFaceAttributes>>, TError, TData>>, request?: SecondParameter<typeof lp5AxiosClient>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary get face attribute
 */

export function useGetFaceAttributes<TData = Awaited<ReturnType<typeof getFaceAttributes>>, TError = Error | AuthorizationErrorResponse | ForbiddenFacesErrorResponse | FaceNotFoundErrorResponse | RequestTimeoutResponse | InternalServerErrorResponse | ResponseTimeoutResponse | ServerTimeoutErrorResponse>(
 faceId: Uuid,
    params?: GetFaceAttributesParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getFaceAttributes>>, TError, TData>>, request?: SecondParameter<typeof lp5AxiosClient>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetFaceAttributesQueryOptions(faceId,params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}







/**
 * Remove face attribute by ID.
 * @summary delete face attribute
 */
export const deleteFaceAttributes = (
    faceId: Uuid,
 options?: SecondParameter<typeof lp5AxiosClient>,signal?: AbortSignal
) => {


      return lp5AxiosClient<void>(
      {url: `/6/faces/${faceId}/attributes`, method: 'DELETE', signal
    },
      options);
    }




export const getDeleteFaceAttributesMutationOptions = <TError = Error | AuthorizationErrorResponse | ForbiddenFacesErrorResponse | RequestTimeoutResponse | InternalServerErrorResponse | ResponseTimeoutResponse | ServerTimeoutErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteFaceAttributes>>, TError,{faceId: Uuid}, TContext>, request?: SecondParameter<typeof lp5AxiosClient>}
): UseMutationOptions<Awaited<ReturnType<typeof deleteFaceAttributes>>, TError,{faceId: Uuid}, TContext> => {

const mutationKey = ['deleteFaceAttributes'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof deleteFaceAttributes>>, {faceId: Uuid}> = (props) => {
          const {faceId} = props ?? {};

          return  deleteFaceAttributes(faceId,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type DeleteFaceAttributesMutationResult = NonNullable<Awaited<ReturnType<typeof deleteFaceAttributes>>>

    export type DeleteFaceAttributesMutationError = Error | AuthorizationErrorResponse | ForbiddenFacesErrorResponse | RequestTimeoutResponse | InternalServerErrorResponse | ResponseTimeoutResponse | ServerTimeoutErrorResponse

    /**
 * @summary delete face attribute
 */
export const useDeleteFaceAttributes = <TError = Error | AuthorizationErrorResponse | ForbiddenFacesErrorResponse | RequestTimeoutResponse | InternalServerErrorResponse | ResponseTimeoutResponse | ServerTimeoutErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteFaceAttributes>>, TError,{faceId: Uuid}, TContext>, request?: SecondParameter<typeof lp5AxiosClient>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof deleteFaceAttributes>>,
        TError,
        {faceId: Uuid},
        TContext
      > => {
      return useMutation(getDeleteFaceAttributesMutationOptions(options), queryClient);
    }

/**
 * Get options for the resource.
 * @summary faces attributes options
 */
export const getFaceAttributesOptions = (
    faceId: Uuid,
 options?: SecondParameter<typeof lp5AxiosClient>,signal?: AbortSignal
) => {


      return lp5AxiosClient<void>(
      {url: `/6/faces/${faceId}/attributes`, method: 'OPTIONS', signal
    },
      options);
    }




export const getGetFaceAttributesOptionsMutationOptions = <TError = RequestTimeoutResponse | InternalServerErrorResponse | ResponseTimeoutResponse | ServerTimeoutErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof getFaceAttributesOptions>>, TError,{faceId: Uuid}, TContext>, request?: SecondParameter<typeof lp5AxiosClient>}
): UseMutationOptions<Awaited<ReturnType<typeof getFaceAttributesOptions>>, TError,{faceId: Uuid}, TContext> => {

const mutationKey = ['getFaceAttributesOptions'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof getFaceAttributesOptions>>, {faceId: Uuid}> = (props) => {
          const {faceId} = props ?? {};

          return  getFaceAttributesOptions(faceId,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type GetFaceAttributesOptionsMutationResult = NonNullable<Awaited<ReturnType<typeof getFaceAttributesOptions>>>

    export type GetFaceAttributesOptionsMutationError = RequestTimeoutResponse | InternalServerErrorResponse | ResponseTimeoutResponse | ServerTimeoutErrorResponse

    /**
 * @summary faces attributes options
 */
export const useGetFaceAttributesOptions = <TError = RequestTimeoutResponse | InternalServerErrorResponse | ResponseTimeoutResponse | ServerTimeoutErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof getFaceAttributesOptions>>, TError,{faceId: Uuid}, TContext>, request?: SecondParameter<typeof lp5AxiosClient>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof getFaceAttributesOptions>>,
        TError,
        {faceId: Uuid},
        TContext
      > => {
      return useMutation(getGetFaceAttributesOptionsMutationOptions(options), queryClient);
    }

/**
 * Get face attribute samples by face ID.
 * @summary get face attribute samples
 */
export const getFaceAttributeSamples = (
    faceId: Uuid,
 options?: SecondParameter<typeof lp5AxiosClient>,signal?: AbortSignal
) => {


      return lp5AxiosClient<AttributeSamples>(
      {url: `/6/faces/${faceId}/attributes/samples`, method: 'GET', signal
    },
      options);
    }




export const getGetFaceAttributeSamplesQueryKey = (faceId: Uuid,) => {
    return [
    `/6/faces/${faceId}/attributes/samples`
    ] as const;
    }


export const getGetFaceAttributeSamplesQueryOptions = <TData = Awaited<ReturnType<typeof getFaceAttributeSamples>>, TError = Error | AuthorizationErrorResponse | ForbiddenFacesErrorResponse | FaceNotFoundErrorResponse | RequestTimeoutResponse | InternalServerErrorResponse | ResponseTimeoutResponse | ServerTimeoutErrorResponse>(faceId: Uuid, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getFaceAttributeSamples>>, TError, TData>>, request?: SecondParameter<typeof lp5AxiosClient>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetFaceAttributeSamplesQueryKey(faceId);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getFaceAttributeSamples>>> = ({ signal }) => getFaceAttributeSamples(faceId, requestOptions, signal);





   return  { queryKey, queryFn, enabled: faceId !== null && faceId !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getFaceAttributeSamples>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetFaceAttributeSamplesQueryResult = NonNullable<Awaited<ReturnType<typeof getFaceAttributeSamples>>>
export type GetFaceAttributeSamplesQueryError = Error | AuthorizationErrorResponse | ForbiddenFacesErrorResponse | FaceNotFoundErrorResponse | RequestTimeoutResponse | InternalServerErrorResponse | ResponseTimeoutResponse | ServerTimeoutErrorResponse


export function useGetFaceAttributeSamples<TData = Awaited<ReturnType<typeof getFaceAttributeSamples>>, TError = Error | AuthorizationErrorResponse | ForbiddenFacesErrorResponse | FaceNotFoundErrorResponse | RequestTimeoutResponse | InternalServerErrorResponse | ResponseTimeoutResponse | ServerTimeoutErrorResponse>(
 faceId: Uuid, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getFaceAttributeSamples>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getFaceAttributeSamples>>,
          TError,
          Awaited<ReturnType<typeof getFaceAttributeSamples>>
        > , 'initialData'
      >, request?: SecondParameter<typeof lp5AxiosClient>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetFaceAttributeSamples<TData = Awaited<ReturnType<typeof getFaceAttributeSamples>>, TError = Error | AuthorizationErrorResponse | ForbiddenFacesErrorResponse | FaceNotFoundErrorResponse | RequestTimeoutResponse | InternalServerErrorResponse | ResponseTimeoutResponse | ServerTimeoutErrorResponse>(
 faceId: Uuid, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getFaceAttributeSamples>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getFaceAttributeSamples>>,
          TError,
          Awaited<ReturnType<typeof getFaceAttributeSamples>>
        > , 'initialData'
      >, request?: SecondParameter<typeof lp5AxiosClient>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetFaceAttributeSamples<TData = Awaited<ReturnType<typeof getFaceAttributeSamples>>, TError = Error | AuthorizationErrorResponse | ForbiddenFacesErrorResponse | FaceNotFoundErrorResponse | RequestTimeoutResponse | InternalServerErrorResponse | ResponseTimeoutResponse | ServerTimeoutErrorResponse>(
 faceId: Uuid, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getFaceAttributeSamples>>, TError, TData>>, request?: SecondParameter<typeof lp5AxiosClient>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary get face attribute samples
 */

export function useGetFaceAttributeSamples<TData = Awaited<ReturnType<typeof getFaceAttributeSamples>>, TError = Error | AuthorizationErrorResponse | ForbiddenFacesErrorResponse | FaceNotFoundErrorResponse | RequestTimeoutResponse | InternalServerErrorResponse | ResponseTimeoutResponse | ServerTimeoutErrorResponse>(
 faceId: Uuid, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getFaceAttributeSamples>>, TError, TData>>, request?: SecondParameter<typeof lp5AxiosClient>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetFaceAttributeSamplesQueryOptions(faceId,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}







/**
 * Get options for the resource.
 * @summary faces attributes samples options
 */
export const getFaceAttributesSamplesOptions = (
    faceId: Uuid,
 options?: SecondParameter<typeof lp5AxiosClient>,signal?: AbortSignal
) => {


      return lp5AxiosClient<void>(
      {url: `/6/faces/${faceId}/attributes/samples`, method: 'OPTIONS', signal
    },
      options);
    }




export const getGetFaceAttributesSamplesOptionsMutationOptions = <TError = RequestTimeoutResponse | InternalServerErrorResponse | ResponseTimeoutResponse | ServerTimeoutErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof getFaceAttributesSamplesOptions>>, TError,{faceId: Uuid}, TContext>, request?: SecondParameter<typeof lp5AxiosClient>}
): UseMutationOptions<Awaited<ReturnType<typeof getFaceAttributesSamplesOptions>>, TError,{faceId: Uuid}, TContext> => {

const mutationKey = ['getFaceAttributesSamplesOptions'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof getFaceAttributesSamplesOptions>>, {faceId: Uuid}> = (props) => {
          const {faceId} = props ?? {};

          return  getFaceAttributesSamplesOptions(faceId,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type GetFaceAttributesSamplesOptionsMutationResult = NonNullable<Awaited<ReturnType<typeof getFaceAttributesSamplesOptions>>>

    export type GetFaceAttributesSamplesOptionsMutationError = RequestTimeoutResponse | InternalServerErrorResponse | ResponseTimeoutResponse | ServerTimeoutErrorResponse

    /**
 * @summary faces attributes samples options
 */
export const useGetFaceAttributesSamplesOptions = <TError = RequestTimeoutResponse | InternalServerErrorResponse | ResponseTimeoutResponse | ServerTimeoutErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof getFaceAttributesSamplesOptions>>, TError,{faceId: Uuid}, TContext>, request?: SecondParameter<typeof lp5AxiosClient>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof getFaceAttributesSamplesOptions>>,
        TError,
        {faceId: Uuid},
        TContext
      > => {
      return useMutation(getGetFaceAttributesSamplesOptionsMutationOptions(options), queryClient);
    }

/**
 * Create a list.
 * @summary create list
 */
export const createList = (
    newList?: NewList,
 options?: SecondParameter<typeof lp5AxiosClient>,signal?: AbortSignal
) => {


      return lp5AxiosClient<CreateList201>(
      {url: `/6/lists`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: newList, signal
    },
      options);
    }




export const getCreateListMutationOptions = <TError = Error | AuthorizationErrorResponse | ForbiddenFacesErrorResponse | RequestTimeoutResponse | PayloadToLargeResponse | InternalServerErrorResponse | ResponseTimeoutResponse | ServerTimeoutErrorResponse,
    TContext = unknown>(queryClient: QueryClient, options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createList>>, TError,{data?: NewList}, TContext>, skipInvalidation?: boolean, request?: SecondParameter<typeof lp5AxiosClient>}
): UseMutationOptions<Awaited<ReturnType<typeof createList>>, TError,{data?: NewList}, TContext> => {

const mutationKey = ['createList'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof createList>>, {data?: NewList}> = (props) => {
          const {data} = props ?? {};

          return  createList(data,requestOptions)
        }

  const onSuccess = (data: Awaited<ReturnType<typeof createList>>, variables: {data?: NewList}, onMutateResult: TContext, context: MutationFunctionContext) => {
        if (!options?.skipInvalidation) {
        queryClient.invalidateQueries({ queryKey: getGetListsQueryKey() });
        }
        mutationOptions?.onSuccess?.(data, variables, onMutateResult, context);
      };




  return  { ...mutationOptions, mutationFn, onSuccess }}

    export type CreateListMutationResult = NonNullable<Awaited<ReturnType<typeof createList>>>
    export type CreateListMutationBody = NewList | undefined
    export type CreateListMutationError = Error | AuthorizationErrorResponse | ForbiddenFacesErrorResponse | RequestTimeoutResponse | PayloadToLargeResponse | InternalServerErrorResponse | ResponseTimeoutResponse | ServerTimeoutErrorResponse

    /**
 * @summary create list
 */
export const useCreateList = <TError = Error | AuthorizationErrorResponse | ForbiddenFacesErrorResponse | RequestTimeoutResponse | PayloadToLargeResponse | InternalServerErrorResponse | ResponseTimeoutResponse | ServerTimeoutErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createList>>, TError,{data?: NewList}, TContext>, skipInvalidation?: boolean, request?: SecondParameter<typeof lp5AxiosClient>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof createList>>,
        TError,
        {data?: NewList},
        TContext
      > => {
      const backupQueryClient = useQueryClient();
      return useMutation(getCreateListMutationOptions(queryClient ?? backupQueryClient, options), queryClient);
    }

/**
 * Get lists according to the filters.
 * @summary get lists
 */
export const getLists = (
    params?: GetListsParams,
 options?: SecondParameter<typeof lp5AxiosClient>,signal?: AbortSignal
) => {


      return lp5AxiosClient<GetLists>(
      {url: `/6/lists`, method: 'GET',
        params, signal
    },
      options);
    }




export const getGetListsQueryKey = (params?: GetListsParams,) => {
    return [
    `/6/lists`, ...(params ? [params] : [])
    ] as const;
    }


export const getGetListsQueryOptions = <TData = Awaited<ReturnType<typeof getLists>>, TError = Error | AuthorizationErrorResponse | ForbiddenFacesErrorResponse | RequestTimeoutResponse | InternalServerErrorResponse | ResponseTimeoutResponse | ServerTimeoutErrorResponse>(params?: GetListsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getLists>>, TError, TData>>, request?: SecondParameter<typeof lp5AxiosClient>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetListsQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getLists>>> = ({ signal }) => getLists(params, requestOptions, signal);





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getLists>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetListsQueryResult = NonNullable<Awaited<ReturnType<typeof getLists>>>
export type GetListsQueryError = Error | AuthorizationErrorResponse | ForbiddenFacesErrorResponse | RequestTimeoutResponse | InternalServerErrorResponse | ResponseTimeoutResponse | ServerTimeoutErrorResponse


export function useGetLists<TData = Awaited<ReturnType<typeof getLists>>, TError = Error | AuthorizationErrorResponse | ForbiddenFacesErrorResponse | RequestTimeoutResponse | InternalServerErrorResponse | ResponseTimeoutResponse | ServerTimeoutErrorResponse>(
 params: undefined |  GetListsParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getLists>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getLists>>,
          TError,
          Awaited<ReturnType<typeof getLists>>
        > , 'initialData'
      >, request?: SecondParameter<typeof lp5AxiosClient>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetLists<TData = Awaited<ReturnType<typeof getLists>>, TError = Error | AuthorizationErrorResponse | ForbiddenFacesErrorResponse | RequestTimeoutResponse | InternalServerErrorResponse | ResponseTimeoutResponse | ServerTimeoutErrorResponse>(
 params?: GetListsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getLists>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getLists>>,
          TError,
          Awaited<ReturnType<typeof getLists>>
        > , 'initialData'
      >, request?: SecondParameter<typeof lp5AxiosClient>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetLists<TData = Awaited<ReturnType<typeof getLists>>, TError = Error | AuthorizationErrorResponse | ForbiddenFacesErrorResponse | RequestTimeoutResponse | InternalServerErrorResponse | ResponseTimeoutResponse | ServerTimeoutErrorResponse>(
 params?: GetListsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getLists>>, TError, TData>>, request?: SecondParameter<typeof lp5AxiosClient>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary get lists
 */

export function useGetLists<TData = Awaited<ReturnType<typeof getLists>>, TError = Error | AuthorizationErrorResponse | ForbiddenFacesErrorResponse | RequestTimeoutResponse | InternalServerErrorResponse | ResponseTimeoutResponse | ServerTimeoutErrorResponse>(
 params?: GetListsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getLists>>, TError, TData>>, request?: SecondParameter<typeof lp5AxiosClient>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetListsQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}







/**
 * Delete several lists.
 * @summary delete lists
 */
export const deleteLists = (
    deletedLists?: DeletedLists,
    params?: DeleteListsParams,
 options?: SecondParameter<typeof lp5AxiosClient>,signal?: AbortSignal
) => {


      return lp5AxiosClient<void>(
      {url: `/6/lists`, method: 'DELETE',
      headers: {'Content-Type': 'application/json', },
      data: deletedLists,
        params, signal
    },
      options);
    }




export const getDeleteListsMutationOptions = <TError = Error | AuthorizationErrorResponse | ForbiddenFacesErrorResponse | RequestTimeoutResponse | PayloadToLargeResponse | InternalServerErrorResponse | ResponseTimeoutResponse | ServerTimeoutErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteLists>>, TError,{data?: DeletedLists;params?: DeleteListsParams}, TContext>, request?: SecondParameter<typeof lp5AxiosClient>}
): UseMutationOptions<Awaited<ReturnType<typeof deleteLists>>, TError,{data?: DeletedLists;params?: DeleteListsParams}, TContext> => {

const mutationKey = ['deleteLists'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof deleteLists>>, {data?: DeletedLists;params?: DeleteListsParams}> = (props) => {
          const {data,params} = props ?? {};

          return  deleteLists(data,params,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type DeleteListsMutationResult = NonNullable<Awaited<ReturnType<typeof deleteLists>>>
    export type DeleteListsMutationBody = DeletedLists | undefined
    export type DeleteListsMutationError = Error | AuthorizationErrorResponse | ForbiddenFacesErrorResponse | RequestTimeoutResponse | PayloadToLargeResponse | InternalServerErrorResponse | ResponseTimeoutResponse | ServerTimeoutErrorResponse

    /**
 * @summary delete lists
 */
export const useDeleteLists = <TError = Error | AuthorizationErrorResponse | ForbiddenFacesErrorResponse | RequestTimeoutResponse | PayloadToLargeResponse | InternalServerErrorResponse | ResponseTimeoutResponse | ServerTimeoutErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteLists>>, TError,{data?: DeletedLists;params?: DeleteListsParams}, TContext>, request?: SecondParameter<typeof lp5AxiosClient>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof deleteLists>>,
        TError,
        {data?: DeletedLists;params?: DeleteListsParams},
        TContext
      > => {
      return useMutation(getDeleteListsMutationOptions(options), queryClient);
    }

/**
 * Get options for the resource.
 * @summary lists options
 */
export const getListsOptions = (

 options?: SecondParameter<typeof lp5AxiosClient>,signal?: AbortSignal
) => {


      return lp5AxiosClient<void>(
      {url: `/6/lists`, method: 'OPTIONS', signal
    },
      options);
    }




export const getGetListsOptionsMutationOptions = <TError = RequestTimeoutResponse | InternalServerErrorResponse | ResponseTimeoutResponse | ServerTimeoutErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof getListsOptions>>, TError,void, TContext>, request?: SecondParameter<typeof lp5AxiosClient>}
): UseMutationOptions<Awaited<ReturnType<typeof getListsOptions>>, TError,void, TContext> => {

const mutationKey = ['getListsOptions'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof getListsOptions>>, void> = () => {


          return  getListsOptions(requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type GetListsOptionsMutationResult = NonNullable<Awaited<ReturnType<typeof getListsOptions>>>

    export type GetListsOptionsMutationError = RequestTimeoutResponse | InternalServerErrorResponse | ResponseTimeoutResponse | ServerTimeoutErrorResponse

    /**
 * @summary lists options
 */
export const useGetListsOptions = <TError = RequestTimeoutResponse | InternalServerErrorResponse | ResponseTimeoutResponse | ServerTimeoutErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof getListsOptions>>, TError,void, TContext>, request?: SecondParameter<typeof lp5AxiosClient>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof getListsOptions>>,
        TError,
        void,
        TContext
      > => {
      return useMutation(getGetListsOptionsMutationOptions(options), queryClient);
    }

/**
 * Count lists according to the filters.
 * @summary get list count
 */
export const getListsCount = (
    params?: GetListsCountParams,
 options?: SecondParameter<typeof lp5AxiosClient>,signal?: AbortSignal
) => {


      return lp5AxiosClient<ListsCount>(
      {url: `/6/lists/count`, method: 'GET',
        params, signal
    },
      options);
    }




export const getGetListsCountQueryKey = (params?: GetListsCountParams,) => {
    return [
    `/6/lists/count`, ...(params ? [params] : [])
    ] as const;
    }


export const getGetListsCountQueryOptions = <TData = Awaited<ReturnType<typeof getListsCount>>, TError = Error | AuthorizationErrorResponse | ForbiddenFacesErrorResponse | RequestTimeoutResponse | InternalServerErrorResponse | ResponseTimeoutResponse | ServerTimeoutErrorResponse>(params?: GetListsCountParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getListsCount>>, TError, TData>>, request?: SecondParameter<typeof lp5AxiosClient>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetListsCountQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getListsCount>>> = ({ signal }) => getListsCount(params, requestOptions, signal);





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getListsCount>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetListsCountQueryResult = NonNullable<Awaited<ReturnType<typeof getListsCount>>>
export type GetListsCountQueryError = Error | AuthorizationErrorResponse | ForbiddenFacesErrorResponse | RequestTimeoutResponse | InternalServerErrorResponse | ResponseTimeoutResponse | ServerTimeoutErrorResponse


export function useGetListsCount<TData = Awaited<ReturnType<typeof getListsCount>>, TError = Error | AuthorizationErrorResponse | ForbiddenFacesErrorResponse | RequestTimeoutResponse | InternalServerErrorResponse | ResponseTimeoutResponse | ServerTimeoutErrorResponse>(
 params: undefined |  GetListsCountParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getListsCount>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getListsCount>>,
          TError,
          Awaited<ReturnType<typeof getListsCount>>
        > , 'initialData'
      >, request?: SecondParameter<typeof lp5AxiosClient>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetListsCount<TData = Awaited<ReturnType<typeof getListsCount>>, TError = Error | AuthorizationErrorResponse | ForbiddenFacesErrorResponse | RequestTimeoutResponse | InternalServerErrorResponse | ResponseTimeoutResponse | ServerTimeoutErrorResponse>(
 params?: GetListsCountParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getListsCount>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getListsCount>>,
          TError,
          Awaited<ReturnType<typeof getListsCount>>
        > , 'initialData'
      >, request?: SecondParameter<typeof lp5AxiosClient>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetListsCount<TData = Awaited<ReturnType<typeof getListsCount>>, TError = Error | AuthorizationErrorResponse | ForbiddenFacesErrorResponse | RequestTimeoutResponse | InternalServerErrorResponse | ResponseTimeoutResponse | ServerTimeoutErrorResponse>(
 params?: GetListsCountParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getListsCount>>, TError, TData>>, request?: SecondParameter<typeof lp5AxiosClient>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary get list count
 */

export function useGetListsCount<TData = Awaited<ReturnType<typeof getListsCount>>, TError = Error | AuthorizationErrorResponse | ForbiddenFacesErrorResponse | RequestTimeoutResponse | InternalServerErrorResponse | ResponseTimeoutResponse | ServerTimeoutErrorResponse>(
 params?: GetListsCountParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getListsCount>>, TError, TData>>, request?: SecondParameter<typeof lp5AxiosClient>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetListsCountQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}







/**
 * Get options for the resource.
 * @summary lists count options
 */
export const getListsCountOptions = (

 options?: SecondParameter<typeof lp5AxiosClient>,signal?: AbortSignal
) => {


      return lp5AxiosClient<void>(
      {url: `/6/lists/count`, method: 'OPTIONS', signal
    },
      options);
    }




export const getGetListsCountOptionsMutationOptions = <TError = RequestTimeoutResponse | InternalServerErrorResponse | ResponseTimeoutResponse | ServerTimeoutErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof getListsCountOptions>>, TError,void, TContext>, request?: SecondParameter<typeof lp5AxiosClient>}
): UseMutationOptions<Awaited<ReturnType<typeof getListsCountOptions>>, TError,void, TContext> => {

const mutationKey = ['getListsCountOptions'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof getListsCountOptions>>, void> = () => {


          return  getListsCountOptions(requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type GetListsCountOptionsMutationResult = NonNullable<Awaited<ReturnType<typeof getListsCountOptions>>>

    export type GetListsCountOptionsMutationError = RequestTimeoutResponse | InternalServerErrorResponse | ResponseTimeoutResponse | ServerTimeoutErrorResponse

    /**
 * @summary lists count options
 */
export const useGetListsCountOptions = <TError = RequestTimeoutResponse | InternalServerErrorResponse | ResponseTimeoutResponse | ServerTimeoutErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof getListsCountOptions>>, TError,void, TContext>, request?: SecondParameter<typeof lp5AxiosClient>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof getListsCountOptions>>,
        TError,
        void,
        TContext
      > => {
      return useMutation(getGetListsCountOptionsMutationOptions(options), queryClient);
    }

/**
 * Get list by ID.
 * @summary get list
 */
export const getList = (
    listId: Uuid,
 options?: SecondParameter<typeof lp5AxiosClient>,signal?: AbortSignal
) => {


      return lp5AxiosClient<List>(
      {url: `/6/lists/${listId}`, method: 'GET', signal
    },
      options);
    }




export const getGetListQueryKey = (listId: Uuid,) => {
    return [
    `/6/lists/${listId}`
    ] as const;
    }


export const getGetListQueryOptions = <TData = Awaited<ReturnType<typeof getList>>, TError = AuthorizationErrorResponse | ForbiddenFacesErrorResponse | ListNotFoundResponse | RequestTimeoutResponse | InternalServerErrorResponse | ResponseTimeoutResponse | ServerTimeoutErrorResponse>(listId: Uuid, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getList>>, TError, TData>>, request?: SecondParameter<typeof lp5AxiosClient>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetListQueryKey(listId);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getList>>> = ({ signal }) => getList(listId, requestOptions, signal);





   return  { queryKey, queryFn, enabled: listId !== null && listId !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getList>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetListQueryResult = NonNullable<Awaited<ReturnType<typeof getList>>>
export type GetListQueryError = AuthorizationErrorResponse | ForbiddenFacesErrorResponse | ListNotFoundResponse | RequestTimeoutResponse | InternalServerErrorResponse | ResponseTimeoutResponse | ServerTimeoutErrorResponse


export function useGetList<TData = Awaited<ReturnType<typeof getList>>, TError = AuthorizationErrorResponse | ForbiddenFacesErrorResponse | ListNotFoundResponse | RequestTimeoutResponse | InternalServerErrorResponse | ResponseTimeoutResponse | ServerTimeoutErrorResponse>(
 listId: Uuid, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getList>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getList>>,
          TError,
          Awaited<ReturnType<typeof getList>>
        > , 'initialData'
      >, request?: SecondParameter<typeof lp5AxiosClient>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetList<TData = Awaited<ReturnType<typeof getList>>, TError = AuthorizationErrorResponse | ForbiddenFacesErrorResponse | ListNotFoundResponse | RequestTimeoutResponse | InternalServerErrorResponse | ResponseTimeoutResponse | ServerTimeoutErrorResponse>(
 listId: Uuid, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getList>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getList>>,
          TError,
          Awaited<ReturnType<typeof getList>>
        > , 'initialData'
      >, request?: SecondParameter<typeof lp5AxiosClient>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetList<TData = Awaited<ReturnType<typeof getList>>, TError = AuthorizationErrorResponse | ForbiddenFacesErrorResponse | ListNotFoundResponse | RequestTimeoutResponse | InternalServerErrorResponse | ResponseTimeoutResponse | ServerTimeoutErrorResponse>(
 listId: Uuid, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getList>>, TError, TData>>, request?: SecondParameter<typeof lp5AxiosClient>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary get list
 */

export function useGetList<TData = Awaited<ReturnType<typeof getList>>, TError = AuthorizationErrorResponse | ForbiddenFacesErrorResponse | ListNotFoundResponse | RequestTimeoutResponse | InternalServerErrorResponse | ResponseTimeoutResponse | ServerTimeoutErrorResponse>(
 listId: Uuid, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getList>>, TError, TData>>, request?: SecondParameter<typeof lp5AxiosClient>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetListQueryOptions(listId,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}







/**
 * Check if list with `list_id` exists.
 * @summary check if list exists
 */
export const checkList = (
    listId: Uuid,
 options?: SecondParameter<typeof lp5AxiosClient>,signal?: AbortSignal
) => {


      return lp5AxiosClient<void>(
      {url: `/6/lists/${listId}`, method: 'HEAD', signal
    },
      options);
    }




export const getCheckListMutationOptions = <TError = AuthorizationErrorWithoutBodyResponse | ForbiddenErrorWithoutBodyResponse | void | RequestTimeoutWithoutBodyResponse | InternalServerErrorWithoutBodyResponse | ResponseTimeoutWithoutBodyResponse | ServerTimeoutErrorWithoutBodyResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof checkList>>, TError,{listId: Uuid}, TContext>, request?: SecondParameter<typeof lp5AxiosClient>}
): UseMutationOptions<Awaited<ReturnType<typeof checkList>>, TError,{listId: Uuid}, TContext> => {

const mutationKey = ['checkList'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof checkList>>, {listId: Uuid}> = (props) => {
          const {listId} = props ?? {};

          return  checkList(listId,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type CheckListMutationResult = NonNullable<Awaited<ReturnType<typeof checkList>>>

    export type CheckListMutationError = AuthorizationErrorWithoutBodyResponse | ForbiddenErrorWithoutBodyResponse | void | RequestTimeoutWithoutBodyResponse | InternalServerErrorWithoutBodyResponse | ResponseTimeoutWithoutBodyResponse | ServerTimeoutErrorWithoutBodyResponse

    /**
 * @summary check if list exists
 */
export const useCheckList = <TError = AuthorizationErrorWithoutBodyResponse | ForbiddenErrorWithoutBodyResponse | void | RequestTimeoutWithoutBodyResponse | InternalServerErrorWithoutBodyResponse | ResponseTimeoutWithoutBodyResponse | ServerTimeoutErrorWithoutBodyResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof checkList>>, TError,{listId: Uuid}, TContext>, request?: SecondParameter<typeof lp5AxiosClient>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof checkList>>,
        TError,
        {listId: Uuid},
        TContext
      > => {
      return useMutation(getCheckListMutationOptions(options), queryClient);
    }

/**
 * Update the *user_data* field of the list.
 * @summary update list
 */
export const patchList = (
    listId: Uuid,
    updateList: UpdateList,
 options?: SecondParameter<typeof lp5AxiosClient>,signal?: AbortSignal
) => {


      return lp5AxiosClient<void>(
      {url: `/6/lists/${listId}`, method: 'PATCH',
      headers: {'Content-Type': 'application/json', },
      data: updateList, signal
    },
      options);
    }




export const getPatchListMutationOptions = <TError = Error | AuthorizationErrorResponse | ForbiddenFacesErrorResponse | ListNotFoundResponse | RequestTimeoutResponse | PayloadToLargeResponse | InternalServerErrorResponse | ResponseTimeoutResponse | ServerTimeoutErrorResponse,
    TContext = unknown>(queryClient: QueryClient, options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof patchList>>, TError,{listId: Uuid;data: UpdateList}, TContext>, skipInvalidation?: boolean, request?: SecondParameter<typeof lp5AxiosClient>}
): UseMutationOptions<Awaited<ReturnType<typeof patchList>>, TError,{listId: Uuid;data: UpdateList}, TContext> => {

const mutationKey = ['patchList'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof patchList>>, {listId: Uuid;data: UpdateList}> = (props) => {
          const {listId,data} = props ?? {};

          return  patchList(listId,data,requestOptions)
        }

  const onSuccess = (data: Awaited<ReturnType<typeof patchList>>, variables: {listId: Uuid;data: UpdateList}, onMutateResult: TContext, context: MutationFunctionContext) => {
        if (!options?.skipInvalidation) {
        queryClient.invalidateQueries({ queryKey: getGetListsQueryKey() });
    queryClient.invalidateQueries({ queryKey: getGetListQueryKey(variables.listId) });
        }
        mutationOptions?.onSuccess?.(data, variables, onMutateResult, context);
      };




  return  { ...mutationOptions, mutationFn, onSuccess }}

    export type PatchListMutationResult = NonNullable<Awaited<ReturnType<typeof patchList>>>
    export type PatchListMutationBody = UpdateList
    export type PatchListMutationError = Error | AuthorizationErrorResponse | ForbiddenFacesErrorResponse | ListNotFoundResponse | RequestTimeoutResponse | PayloadToLargeResponse | InternalServerErrorResponse | ResponseTimeoutResponse | ServerTimeoutErrorResponse

    /**
 * @summary update list
 */
export const usePatchList = <TError = Error | AuthorizationErrorResponse | ForbiddenFacesErrorResponse | ListNotFoundResponse | RequestTimeoutResponse | PayloadToLargeResponse | InternalServerErrorResponse | ResponseTimeoutResponse | ServerTimeoutErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof patchList>>, TError,{listId: Uuid;data: UpdateList}, TContext>, skipInvalidation?: boolean, request?: SecondParameter<typeof lp5AxiosClient>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof patchList>>,
        TError,
        {listId: Uuid;data: UpdateList},
        TContext
      > => {
      const backupQueryClient = useQueryClient();
      return useMutation(getPatchListMutationOptions(queryClient ?? backupQueryClient, options), queryClient);
    }

/**
 * Delete list by ID.
 * @summary delete list
 */
export const deleteList = (
    listId: Uuid,
    params?: DeleteListParams,
 options?: SecondParameter<typeof lp5AxiosClient>,signal?: AbortSignal
) => {


      return lp5AxiosClient<void>(
      {url: `/6/lists/${listId}`, method: 'DELETE',
        params, signal
    },
      options);
    }




export const getDeleteListMutationOptions = <TError = AuthorizationErrorResponse | ForbiddenFacesErrorResponse | Error | RequestTimeoutResponse | InternalServerErrorResponse | ResponseTimeoutResponse | ServerTimeoutErrorResponse,
    TContext = unknown>(queryClient: QueryClient, options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteList>>, TError,{listId: Uuid;params?: DeleteListParams}, TContext>, skipInvalidation?: boolean, request?: SecondParameter<typeof lp5AxiosClient>}
): UseMutationOptions<Awaited<ReturnType<typeof deleteList>>, TError,{listId: Uuid;params?: DeleteListParams}, TContext> => {

const mutationKey = ['deleteList'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof deleteList>>, {listId: Uuid;params?: DeleteListParams}> = (props) => {
          const {listId,params} = props ?? {};

          return  deleteList(listId,params,requestOptions)
        }

  const onSuccess = (data: Awaited<ReturnType<typeof deleteList>>, variables: {listId: Uuid;params?: DeleteListParams}, onMutateResult: TContext, context: MutationFunctionContext) => {
        if (!options?.skipInvalidation) {
        queryClient.invalidateQueries({ queryKey: getGetListsQueryKey() });
        }
        mutationOptions?.onSuccess?.(data, variables, onMutateResult, context);
      };




  return  { ...mutationOptions, mutationFn, onSuccess }}

    export type DeleteListMutationResult = NonNullable<Awaited<ReturnType<typeof deleteList>>>

    export type DeleteListMutationError = AuthorizationErrorResponse | ForbiddenFacesErrorResponse | Error | RequestTimeoutResponse | InternalServerErrorResponse | ResponseTimeoutResponse | ServerTimeoutErrorResponse

    /**
 * @summary delete list
 */
export const useDeleteList = <TError = AuthorizationErrorResponse | ForbiddenFacesErrorResponse | Error | RequestTimeoutResponse | InternalServerErrorResponse | ResponseTimeoutResponse | ServerTimeoutErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteList>>, TError,{listId: Uuid;params?: DeleteListParams}, TContext>, skipInvalidation?: boolean, request?: SecondParameter<typeof lp5AxiosClient>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof deleteList>>,
        TError,
        {listId: Uuid;params?: DeleteListParams},
        TContext
      > => {
      const backupQueryClient = useQueryClient();
      return useMutation(getDeleteListMutationOptions(queryClient ?? backupQueryClient, options), queryClient);
    }

/**
 * Get options for the resource.
 * @summary list options
 */
export const getListOptions = (
    listId: Uuid,
 options?: SecondParameter<typeof lp5AxiosClient>,signal?: AbortSignal
) => {


      return lp5AxiosClient<void>(
      {url: `/6/lists/${listId}`, method: 'OPTIONS', signal
    },
      options);
    }




export const getGetListOptionsMutationOptions = <TError = RequestTimeoutResponse | InternalServerErrorResponse | ResponseTimeoutResponse | ServerTimeoutErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof getListOptions>>, TError,{listId: Uuid}, TContext>, request?: SecondParameter<typeof lp5AxiosClient>}
): UseMutationOptions<Awaited<ReturnType<typeof getListOptions>>, TError,{listId: Uuid}, TContext> => {

const mutationKey = ['getListOptions'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof getListOptions>>, {listId: Uuid}> = (props) => {
          const {listId} = props ?? {};

          return  getListOptions(listId,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type GetListOptionsMutationResult = NonNullable<Awaited<ReturnType<typeof getListOptions>>>

    export type GetListOptionsMutationError = RequestTimeoutResponse | InternalServerErrorResponse | ResponseTimeoutResponse | ServerTimeoutErrorResponse

    /**
 * @summary list options
 */
export const useGetListOptions = <TError = RequestTimeoutResponse | InternalServerErrorResponse | ResponseTimeoutResponse | ServerTimeoutErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof getListOptions>>, TError,{listId: Uuid}, TContext>, request?: SecondParameter<typeof lp5AxiosClient>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof getListOptions>>,
        TError,
        {listId: Uuid},
        TContext
      > => {
      return useMutation(getGetListOptionsMutationOptions(options), queryClient);
    }

/**
 * Attach or detach faces to the list.
 * @summary attach/detach faces to the list
 */
export const linkFaces = (
    listId: Uuid,
    link: Link,
 options?: SecondParameter<typeof lp5AxiosClient>,signal?: AbortSignal
) => {


      return lp5AxiosClient<void>(
      {url: `/6/lists/${listId}/faces`, method: 'PATCH',
      headers: {'Content-Type': 'application/json', },
      data: link, signal
    },
      options);
    }




export const getLinkFacesMutationOptions = <TError = Error | AuthorizationErrorResponse | ForbiddenFacesErrorResponse | ListNotFoundResponse | RequestTimeoutResponse | PayloadToLargeResponse | InternalServerErrorResponse | ResponseTimeoutResponse | ServerTimeoutErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof linkFaces>>, TError,{listId: Uuid;data: Link}, TContext>, request?: SecondParameter<typeof lp5AxiosClient>}
): UseMutationOptions<Awaited<ReturnType<typeof linkFaces>>, TError,{listId: Uuid;data: Link}, TContext> => {

const mutationKey = ['linkFaces'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof linkFaces>>, {listId: Uuid;data: Link}> = (props) => {
          const {listId,data} = props ?? {};

          return  linkFaces(listId,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type LinkFacesMutationResult = NonNullable<Awaited<ReturnType<typeof linkFaces>>>
    export type LinkFacesMutationBody = Link
    export type LinkFacesMutationError = Error | AuthorizationErrorResponse | ForbiddenFacesErrorResponse | ListNotFoundResponse | RequestTimeoutResponse | PayloadToLargeResponse | InternalServerErrorResponse | ResponseTimeoutResponse | ServerTimeoutErrorResponse

    /**
 * @summary attach/detach faces to the list
 */
export const useLinkFaces = <TError = Error | AuthorizationErrorResponse | ForbiddenFacesErrorResponse | ListNotFoundResponse | RequestTimeoutResponse | PayloadToLargeResponse | InternalServerErrorResponse | ResponseTimeoutResponse | ServerTimeoutErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof linkFaces>>, TError,{listId: Uuid;data: Link}, TContext>, request?: SecondParameter<typeof lp5AxiosClient>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof linkFaces>>,
        TError,
        {listId: Uuid;data: Link},
        TContext
      > => {
      return useMutation(getLinkFacesMutationOptions(options), queryClient);
    }

/**
 * Get options for the resource.
 * @summary link options
 */
export const getLinkerOptions = (
    listId: Uuid,
 options?: SecondParameter<typeof lp5AxiosClient>,signal?: AbortSignal
) => {


      return lp5AxiosClient<void>(
      {url: `/6/lists/${listId}/faces`, method: 'OPTIONS', signal
    },
      options);
    }




export const getGetLinkerOptionsMutationOptions = <TError = RequestTimeoutResponse | InternalServerErrorResponse | ResponseTimeoutResponse | ServerTimeoutErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof getLinkerOptions>>, TError,{listId: Uuid}, TContext>, request?: SecondParameter<typeof lp5AxiosClient>}
): UseMutationOptions<Awaited<ReturnType<typeof getLinkerOptions>>, TError,{listId: Uuid}, TContext> => {

const mutationKey = ['getLinkerOptions'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof getLinkerOptions>>, {listId: Uuid}> = (props) => {
          const {listId} = props ?? {};

          return  getLinkerOptions(listId,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type GetLinkerOptionsMutationResult = NonNullable<Awaited<ReturnType<typeof getLinkerOptions>>>

    export type GetLinkerOptionsMutationError = RequestTimeoutResponse | InternalServerErrorResponse | ResponseTimeoutResponse | ServerTimeoutErrorResponse

    /**
 * @summary link options
 */
export const useGetLinkerOptions = <TError = RequestTimeoutResponse | InternalServerErrorResponse | ResponseTimeoutResponse | ServerTimeoutErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof getLinkerOptions>>, TError,{listId: Uuid}, TContext>, request?: SecondParameter<typeof lp5AxiosClient>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof getLinkerOptions>>,
        TError,
        {listId: Uuid},
        TContext
      > => {
      return useMutation(getGetLinkerOptionsMutationOptions(options), queryClient);
    }

/**
 * Performs matching of given references with given candidates.
 *
 * >**Note!** *Descriptors must be extracted for reference(s) and
 * candidate(s). Objects without descriptors cannot be matched.*
 *
 * The sources for candidates are faces, attributes and events. See the "compare two faces using their IDs",
 * "compare two events using their IDs", and "compare events using filters" examples.
 *
 * You can specify the "list_id" filter of the "faces" candidate to perform matching by the specified list.
 * See the "search by list and creation time" examples.
 *
 * The sources for references are faces, events, attributes, external IDs of faces,
 * or descriptors (raw, SDK format, or binary XPK format).
 *
 * Matching results are returned for the candidates that correspond to the specified filters.
 * If none of the candidates corresponds to the filters (for example, a non-existent ID is set in the
 * "event_ids" field or the "face_ids" field), there will be no matching result and no error returned.
 * The result field will be empty. See the "nonexistent references errors" examples.
 *
 * If a non-existent reference is set (for example, a non-existent ID is set in the "event_id" field or
 * the "face_id" field), the corresponding error is returned. See the "no ID for reference
 * face found" response example.
 * @summary matching faces
 */
export const matchFaces = (
    matchFacesBody: MatchFacesRequestJson | MatchFacesRequestMsgpack,
    params?: MatchFacesParams,
 options?: SecondParameter<typeof lp5AxiosClient>,signal?: AbortSignal
) => {


      return lp5AxiosClient<MatchResult>(
      {url: `/6/matcher/faces`, method: 'POST',
      data: matchFacesBody,
        params, signal
    },
      options);
    }




export const getMatchFacesMutationOptions = <TError = Error | AuthorizationErrorResponse | ForbiddenMatcherServicesErrorResponse | RequestTimeoutResponse | PayloadToLargeResponse | InternalServerErrorResponse | ResponseTimeoutResponse | ServerTimeoutErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof matchFaces>>, TError,{data: MatchFacesRequestJson | MatchFacesRequestMsgpack;params?: MatchFacesParams}, TContext>, request?: SecondParameter<typeof lp5AxiosClient>}
): UseMutationOptions<Awaited<ReturnType<typeof matchFaces>>, TError,{data: MatchFacesRequestJson | MatchFacesRequestMsgpack;params?: MatchFacesParams}, TContext> => {

const mutationKey = ['matchFaces'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof matchFaces>>, {data: MatchFacesRequestJson | MatchFacesRequestMsgpack;params?: MatchFacesParams}> = (props) => {
          const {data,params} = props ?? {};

          return  matchFaces(data,params,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type MatchFacesMutationResult = NonNullable<Awaited<ReturnType<typeof matchFaces>>>
    export type MatchFacesMutationBody = MatchFacesRequestJson | MatchFacesRequestMsgpack
    export type MatchFacesMutationError = Error | AuthorizationErrorResponse | ForbiddenMatcherServicesErrorResponse | RequestTimeoutResponse | PayloadToLargeResponse | InternalServerErrorResponse | ResponseTimeoutResponse | ServerTimeoutErrorResponse

    /**
 * @summary matching faces
 */
export const useMatchFaces = <TError = Error | AuthorizationErrorResponse | ForbiddenMatcherServicesErrorResponse | RequestTimeoutResponse | PayloadToLargeResponse | InternalServerErrorResponse | ResponseTimeoutResponse | ServerTimeoutErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof matchFaces>>, TError,{data: MatchFacesRequestJson | MatchFacesRequestMsgpack;params?: MatchFacesParams}, TContext>, request?: SecondParameter<typeof lp5AxiosClient>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof matchFaces>>,
        TError,
        {data: MatchFacesRequestJson | MatchFacesRequestMsgpack;params?: MatchFacesParams},
        TContext
      > => {
      return useMutation(getMatchFacesMutationOptions(options), queryClient);
    }

/**
 * Get options for the resource.
 * @summary matcher options
 */
export const getMatcherOptions = (

 options?: SecondParameter<typeof lp5AxiosClient>,signal?: AbortSignal
) => {


      return lp5AxiosClient<void>(
      {url: `/6/matcher/faces`, method: 'OPTIONS', signal
    },
      options);
    }




export const getGetMatcherOptionsMutationOptions = <TError = ForbiddenMatcherErrorResponse | RequestTimeoutResponse | InternalServerErrorResponse | ResponseTimeoutResponse | ServerTimeoutErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof getMatcherOptions>>, TError,void, TContext>, request?: SecondParameter<typeof lp5AxiosClient>}
): UseMutationOptions<Awaited<ReturnType<typeof getMatcherOptions>>, TError,void, TContext> => {

const mutationKey = ['getMatcherOptions'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof getMatcherOptions>>, void> = () => {


          return  getMatcherOptions(requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type GetMatcherOptionsMutationResult = NonNullable<Awaited<ReturnType<typeof getMatcherOptions>>>

    export type GetMatcherOptionsMutationError = ForbiddenMatcherErrorResponse | RequestTimeoutResponse | InternalServerErrorResponse | ResponseTimeoutResponse | ServerTimeoutErrorResponse

    /**
 * @summary matcher options
 */
export const useGetMatcherOptions = <TError = ForbiddenMatcherErrorResponse | RequestTimeoutResponse | InternalServerErrorResponse | ResponseTimeoutResponse | ServerTimeoutErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof getMatcherOptions>>, TError,void, TContext>, request?: SecondParameter<typeof lp5AxiosClient>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof getMatcherOptions>>,
        TError,
        void,
        TContext
      > => {
      return useMutation(getGetMatcherOptionsMutationOptions(options), queryClient);
    }

/**
 * Matcher API allows to submit tasks to a service that searches for human bodies similar to a given reference(s) by
 * matching them. A body attribute descriptor should be extracted for reference(s) and candidate(s).
 *
 * The sources for references are events or binary descriptor. The sources for candidates is events.
 * @summary human body matching
 */
export const matchBodies = (
    matchBodiesBody: MatchBodiesRequestJson | MatchBodiesRequestMsgpack,
    params?: MatchBodiesParams,
 options?: SecondParameter<typeof lp5AxiosClient>,signal?: AbortSignal
) => {


      return lp5AxiosClient<MatchBodiesResult | MatchResult>(
      {url: `/6/matcher/bodies`, method: 'POST',
      data: matchBodiesBody,
        params, signal
    },
      options);
    }




export const getMatchBodiesMutationOptions = <TError = Error | AuthorizationErrorResponse | ForbiddenMatcherServicesErrorResponse | RequestTimeoutResponse | PayloadToLargeResponse | InternalServerErrorResponse | ResponseTimeoutResponse | ServerTimeoutErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof matchBodies>>, TError,{data: MatchBodiesRequestJson | MatchBodiesRequestMsgpack;params?: MatchBodiesParams}, TContext>, request?: SecondParameter<typeof lp5AxiosClient>}
): UseMutationOptions<Awaited<ReturnType<typeof matchBodies>>, TError,{data: MatchBodiesRequestJson | MatchBodiesRequestMsgpack;params?: MatchBodiesParams}, TContext> => {

const mutationKey = ['matchBodies'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof matchBodies>>, {data: MatchBodiesRequestJson | MatchBodiesRequestMsgpack;params?: MatchBodiesParams}> = (props) => {
          const {data,params} = props ?? {};

          return  matchBodies(data,params,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type MatchBodiesMutationResult = NonNullable<Awaited<ReturnType<typeof matchBodies>>>
    export type MatchBodiesMutationBody = MatchBodiesRequestJson | MatchBodiesRequestMsgpack
    export type MatchBodiesMutationError = Error | AuthorizationErrorResponse | ForbiddenMatcherServicesErrorResponse | RequestTimeoutResponse | PayloadToLargeResponse | InternalServerErrorResponse | ResponseTimeoutResponse | ServerTimeoutErrorResponse

    /**
 * @summary human body matching
 */
export const useMatchBodies = <TError = Error | AuthorizationErrorResponse | ForbiddenMatcherServicesErrorResponse | RequestTimeoutResponse | PayloadToLargeResponse | InternalServerErrorResponse | ResponseTimeoutResponse | ServerTimeoutErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof matchBodies>>, TError,{data: MatchBodiesRequestJson | MatchBodiesRequestMsgpack;params?: MatchBodiesParams}, TContext>, request?: SecondParameter<typeof lp5AxiosClient>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof matchBodies>>,
        TError,
        {data: MatchBodiesRequestJson | MatchBodiesRequestMsgpack;params?: MatchBodiesParams},
        TContext
      > => {
      return useMutation(getMatchBodiesMutationOptions(options), queryClient);
    }

/**
 * Get options for the resource.
 * @summary matcher options
 */
export const getBodiesMatcherOptions = (

 options?: SecondParameter<typeof lp5AxiosClient>,signal?: AbortSignal
) => {


      return lp5AxiosClient<void>(
      {url: `/6/matcher/bodies`, method: 'OPTIONS', signal
    },
      options);
    }




export const getGetBodiesMatcherOptionsMutationOptions = <TError = ForbiddenMatcherErrorResponse | RequestTimeoutResponse | InternalServerErrorResponse | ResponseTimeoutResponse | ServerTimeoutErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof getBodiesMatcherOptions>>, TError,void, TContext>, request?: SecondParameter<typeof lp5AxiosClient>}
): UseMutationOptions<Awaited<ReturnType<typeof getBodiesMatcherOptions>>, TError,void, TContext> => {

const mutationKey = ['getBodiesMatcherOptions'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof getBodiesMatcherOptions>>, void> = () => {


          return  getBodiesMatcherOptions(requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type GetBodiesMatcherOptionsMutationResult = NonNullable<Awaited<ReturnType<typeof getBodiesMatcherOptions>>>

    export type GetBodiesMatcherOptionsMutationError = ForbiddenMatcherErrorResponse | RequestTimeoutResponse | InternalServerErrorResponse | ResponseTimeoutResponse | ServerTimeoutErrorResponse

    /**
 * @summary matcher options
 */
export const useGetBodiesMatcherOptions = <TError = ForbiddenMatcherErrorResponse | RequestTimeoutResponse | InternalServerErrorResponse | ResponseTimeoutResponse | ServerTimeoutErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof getBodiesMatcherOptions>>, TError,void, TContext>, request?: SecondParameter<typeof lp5AxiosClient>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof getBodiesMatcherOptions>>,
        TError,
        void,
        TContext
      > => {
      return useMutation(getGetBodiesMatcherOptionsMutationOptions(options), queryClient);
    }

/**
 * Matcher raw API allows to do similarity calculations for input descriptors.
 * @summary raw matching
 */
export const matchingRaw = (
    matchingRawBody: MatcherRawRequestJson | MatcherRawRequestMsgpack,
 options?: SecondParameter<typeof lp5AxiosClient>,signal?: AbortSignal
) => {


      return lp5AxiosClient<MatcherRawResult>(
      {url: `/6/matcher/raw`, method: 'POST',
      data: matchingRawBody, signal
    },
      options);
    }




export const getMatchingRawMutationOptions = <TError = Error | AuthorizationErrorResponse | ForbiddenMatcherServicesErrorResponse | RequestTimeoutResponse | PayloadToLargeResponse | InternalServerErrorResponse | ResponseTimeoutResponse | ServerTimeoutErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof matchingRaw>>, TError,{data: MatcherRawRequestJson | MatcherRawRequestMsgpack}, TContext>, request?: SecondParameter<typeof lp5AxiosClient>}
): UseMutationOptions<Awaited<ReturnType<typeof matchingRaw>>, TError,{data: MatcherRawRequestJson | MatcherRawRequestMsgpack}, TContext> => {

const mutationKey = ['matchingRaw'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof matchingRaw>>, {data: MatcherRawRequestJson | MatcherRawRequestMsgpack}> = (props) => {
          const {data} = props ?? {};

          return  matchingRaw(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type MatchingRawMutationResult = NonNullable<Awaited<ReturnType<typeof matchingRaw>>>
    export type MatchingRawMutationBody = MatcherRawRequestJson | MatcherRawRequestMsgpack
    export type MatchingRawMutationError = Error | AuthorizationErrorResponse | ForbiddenMatcherServicesErrorResponse | RequestTimeoutResponse | PayloadToLargeResponse | InternalServerErrorResponse | ResponseTimeoutResponse | ServerTimeoutErrorResponse

    /**
 * @summary raw matching
 */
export const useMatchingRaw = <TError = Error | AuthorizationErrorResponse | ForbiddenMatcherServicesErrorResponse | RequestTimeoutResponse | PayloadToLargeResponse | InternalServerErrorResponse | ResponseTimeoutResponse | ServerTimeoutErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof matchingRaw>>, TError,{data: MatcherRawRequestJson | MatcherRawRequestMsgpack}, TContext>, request?: SecondParameter<typeof lp5AxiosClient>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof matchingRaw>>,
        TError,
        {data: MatcherRawRequestJson | MatcherRawRequestMsgpack},
        TContext
      > => {
      return useMutation(getMatchingRawMutationOptions(options), queryClient);
    }

/**
 * Get options for the resource.
 * @summary matcher raw options
 */
export const getMatcherRawOptions = (

 options?: SecondParameter<typeof lp5AxiosClient>,signal?: AbortSignal
) => {


      return lp5AxiosClient<void>(
      {url: `/6/matcher/raw`, method: 'OPTIONS', signal
    },
      options);
    }




export const getGetMatcherRawOptionsMutationOptions = <TError = ForbiddenMatcherErrorResponse | RequestTimeoutResponse | InternalServerErrorResponse | ResponseTimeoutResponse | ServerTimeoutErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof getMatcherRawOptions>>, TError,void, TContext>, request?: SecondParameter<typeof lp5AxiosClient>}
): UseMutationOptions<Awaited<ReturnType<typeof getMatcherRawOptions>>, TError,void, TContext> => {

const mutationKey = ['getMatcherRawOptions'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof getMatcherRawOptions>>, void> = () => {


          return  getMatcherRawOptions(requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type GetMatcherRawOptionsMutationResult = NonNullable<Awaited<ReturnType<typeof getMatcherRawOptions>>>

    export type GetMatcherRawOptionsMutationError = ForbiddenMatcherErrorResponse | RequestTimeoutResponse | InternalServerErrorResponse | ResponseTimeoutResponse | ServerTimeoutErrorResponse

    /**
 * @summary matcher raw options
 */
export const useGetMatcherRawOptions = <TError = ForbiddenMatcherErrorResponse | RequestTimeoutResponse | InternalServerErrorResponse | ResponseTimeoutResponse | ServerTimeoutErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof getMatcherRawOptions>>, TError,void, TContext>, request?: SecondParameter<typeof lp5AxiosClient>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof getMatcherRawOptions>>,
        TError,
        void,
        TContext
      > => {
      return useMutation(getGetMatcherRawOptionsMutationOptions(options), queryClient);
    }

/**
 * Matching by general events.
 *
 * The sources of references are general events and binary descriptors. Candidate sources - general events.
 * @summary general events matching
 */
export const matchGeneralEvents = (
    matchGeneralEventsBody: MatchGeneralEventsRequestJson | MatchGeneralEventsRequestMsgpack,
 options?: SecondParameter<typeof lp5AxiosClient>,signal?: AbortSignal
) => {


      return lp5AxiosClient<MatchGeneralEventResult>(
      {url: `/6/matcher/general_events`, method: 'POST',
      data: matchGeneralEventsBody, signal
    },
      options);
    }




export const getMatchGeneralEventsMutationOptions = <TError = Error | AuthorizationErrorResponse | ForbiddenMatcherServicesErrorResponse | RequestTimeoutResponse | PayloadToLargeResponse | InternalServerErrorResponse | ResponseTimeoutResponse | ServerTimeoutErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof matchGeneralEvents>>, TError,{data: MatchGeneralEventsRequestJson | MatchGeneralEventsRequestMsgpack}, TContext>, request?: SecondParameter<typeof lp5AxiosClient>}
): UseMutationOptions<Awaited<ReturnType<typeof matchGeneralEvents>>, TError,{data: MatchGeneralEventsRequestJson | MatchGeneralEventsRequestMsgpack}, TContext> => {

const mutationKey = ['matchGeneralEvents'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof matchGeneralEvents>>, {data: MatchGeneralEventsRequestJson | MatchGeneralEventsRequestMsgpack}> = (props) => {
          const {data} = props ?? {};

          return  matchGeneralEvents(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type MatchGeneralEventsMutationResult = NonNullable<Awaited<ReturnType<typeof matchGeneralEvents>>>
    export type MatchGeneralEventsMutationBody = MatchGeneralEventsRequestJson | MatchGeneralEventsRequestMsgpack
    export type MatchGeneralEventsMutationError = Error | AuthorizationErrorResponse | ForbiddenMatcherServicesErrorResponse | RequestTimeoutResponse | PayloadToLargeResponse | InternalServerErrorResponse | ResponseTimeoutResponse | ServerTimeoutErrorResponse

    /**
 * @summary general events matching
 */
export const useMatchGeneralEvents = <TError = Error | AuthorizationErrorResponse | ForbiddenMatcherServicesErrorResponse | RequestTimeoutResponse | PayloadToLargeResponse | InternalServerErrorResponse | ResponseTimeoutResponse | ServerTimeoutErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof matchGeneralEvents>>, TError,{data: MatchGeneralEventsRequestJson | MatchGeneralEventsRequestMsgpack}, TContext>, request?: SecondParameter<typeof lp5AxiosClient>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof matchGeneralEvents>>,
        TError,
        {data: MatchGeneralEventsRequestJson | MatchGeneralEventsRequestMsgpack},
        TContext
      > => {
      return useMutation(getMatchGeneralEventsMutationOptions(options), queryClient);
    }

/**
 * Get options for the resource.
 * @summary matcher options
 */
export const getGeneralEventMatcherOptions = (

 options?: SecondParameter<typeof lp5AxiosClient>,signal?: AbortSignal
) => {


      return lp5AxiosClient<void>(
      {url: `/6/matcher/general_events`, method: 'OPTIONS', signal
    },
      options);
    }




export const getGetGeneralEventMatcherOptionsMutationOptions = <TError = ForbiddenMatcherErrorResponse | RequestTimeoutResponse | InternalServerErrorResponse | ResponseTimeoutResponse | ServerTimeoutErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof getGeneralEventMatcherOptions>>, TError,void, TContext>, request?: SecondParameter<typeof lp5AxiosClient>}
): UseMutationOptions<Awaited<ReturnType<typeof getGeneralEventMatcherOptions>>, TError,void, TContext> => {

const mutationKey = ['getGeneralEventMatcherOptions'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof getGeneralEventMatcherOptions>>, void> = () => {


          return  getGeneralEventMatcherOptions(requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type GetGeneralEventMatcherOptionsMutationResult = NonNullable<Awaited<ReturnType<typeof getGeneralEventMatcherOptions>>>

    export type GetGeneralEventMatcherOptionsMutationError = ForbiddenMatcherErrorResponse | RequestTimeoutResponse | InternalServerErrorResponse | ResponseTimeoutResponse | ServerTimeoutErrorResponse

    /**
 * @summary matcher options
 */
export const useGetGeneralEventMatcherOptions = <TError = ForbiddenMatcherErrorResponse | RequestTimeoutResponse | InternalServerErrorResponse | ResponseTimeoutResponse | ServerTimeoutErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof getGeneralEventMatcherOptions>>, TError,void, TContext>, request?: SecondParameter<typeof lp5AxiosClient>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof getGeneralEventMatcherOptions>>,
        TError,
        void,
        TContext
      > => {
      return useMutation(getGetGeneralEventMatcherOptionsMutationOptions(options), queryClient);
    }

/**
 * Create a handler.
 *
 * The handler determines the list of rules (policies) for processing of input images.
 *
 * Handlers can be static, dynamic or lambda.
 *
 * When the handler is static, you specify its policies and then you specify the created handler ID during the [event creation](#operation/generateEvents).
 *
 * When the handler is dynamic, you create it without predefined policies and then you specify
 * them during [event creation](#operation/generateEvents).
 * You can create the dynamic handler by setting "handler_type" field to 1.
 *
 * > Some parameters from the `storage_policy` are enabled by default (for example, `face_sample_policy > store_sample`). Don't forget to disable saving
 * the necessary objects to avoid overflowing the storage.
 * @summary create handler
 */
export const createHandler = (
    newHandler?: NewHandler,
 options?: SecondParameter<typeof lp5AxiosClient>,signal?: AbortSignal
) => {


      return lp5AxiosClient<CreateHandler201>(
      {url: `/6/handlers`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: newHandler, signal
    },
      options);
    }




export const getCreateHandlerMutationOptions = <TError = Error | AuthorizationErrorResponse | ForbiddenErrorWithServicesResponse | RequestTimeoutResponse | PayloadToLargeResponse | InternalServerErrorResponse | ResponseTimeoutResponse | ServerTimeoutErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createHandler>>, TError,{data?: NewHandler}, TContext>, request?: SecondParameter<typeof lp5AxiosClient>}
): UseMutationOptions<Awaited<ReturnType<typeof createHandler>>, TError,{data?: NewHandler}, TContext> => {

const mutationKey = ['createHandler'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof createHandler>>, {data?: NewHandler}> = (props) => {
          const {data} = props ?? {};

          return  createHandler(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type CreateHandlerMutationResult = NonNullable<Awaited<ReturnType<typeof createHandler>>>
    export type CreateHandlerMutationBody = NewHandler | undefined
    export type CreateHandlerMutationError = Error | AuthorizationErrorResponse | ForbiddenErrorWithServicesResponse | RequestTimeoutResponse | PayloadToLargeResponse | InternalServerErrorResponse | ResponseTimeoutResponse | ServerTimeoutErrorResponse

    /**
 * @summary create handler
 */
export const useCreateHandler = <TError = Error | AuthorizationErrorResponse | ForbiddenErrorWithServicesResponse | RequestTimeoutResponse | PayloadToLargeResponse | InternalServerErrorResponse | ResponseTimeoutResponse | ServerTimeoutErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createHandler>>, TError,{data?: NewHandler}, TContext>, request?: SecondParameter<typeof lp5AxiosClient>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof createHandler>>,
        TError,
        {data?: NewHandler},
        TContext
      > => {
      return useMutation(getCreateHandlerMutationOptions(options), queryClient);
    }

/**
 * Get handlers by filters.
 * @summary get handlers
 */
export const getHandlers = (
    params?: GetHandlersParams,
 options?: SecondParameter<typeof lp5AxiosClient>,signal?: AbortSignal
) => {


      return lp5AxiosClient<HandlerInResponse[]>(
      {url: `/6/handlers`, method: 'GET',
        params, signal
    },
      options);
    }




export const getGetHandlersQueryKey = (params?: GetHandlersParams,) => {
    return [
    `/6/handlers`, ...(params ? [params] : [])
    ] as const;
    }


export const getGetHandlersQueryOptions = <TData = Awaited<ReturnType<typeof getHandlers>>, TError = Error | AuthorizationErrorResponse | ForbiddenErrorWithServicesResponse | RequestTimeoutResponse | InternalServerErrorResponse | ResponseTimeoutResponse | ServerTimeoutErrorResponse>(params?: GetHandlersParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getHandlers>>, TError, TData>>, request?: SecondParameter<typeof lp5AxiosClient>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetHandlersQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getHandlers>>> = ({ signal }) => getHandlers(params, requestOptions, signal);





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getHandlers>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetHandlersQueryResult = NonNullable<Awaited<ReturnType<typeof getHandlers>>>
export type GetHandlersQueryError = Error | AuthorizationErrorResponse | ForbiddenErrorWithServicesResponse | RequestTimeoutResponse | InternalServerErrorResponse | ResponseTimeoutResponse | ServerTimeoutErrorResponse


export function useGetHandlers<TData = Awaited<ReturnType<typeof getHandlers>>, TError = Error | AuthorizationErrorResponse | ForbiddenErrorWithServicesResponse | RequestTimeoutResponse | InternalServerErrorResponse | ResponseTimeoutResponse | ServerTimeoutErrorResponse>(
 params: undefined |  GetHandlersParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getHandlers>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getHandlers>>,
          TError,
          Awaited<ReturnType<typeof getHandlers>>
        > , 'initialData'
      >, request?: SecondParameter<typeof lp5AxiosClient>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetHandlers<TData = Awaited<ReturnType<typeof getHandlers>>, TError = Error | AuthorizationErrorResponse | ForbiddenErrorWithServicesResponse | RequestTimeoutResponse | InternalServerErrorResponse | ResponseTimeoutResponse | ServerTimeoutErrorResponse>(
 params?: GetHandlersParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getHandlers>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getHandlers>>,
          TError,
          Awaited<ReturnType<typeof getHandlers>>
        > , 'initialData'
      >, request?: SecondParameter<typeof lp5AxiosClient>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetHandlers<TData = Awaited<ReturnType<typeof getHandlers>>, TError = Error | AuthorizationErrorResponse | ForbiddenErrorWithServicesResponse | RequestTimeoutResponse | InternalServerErrorResponse | ResponseTimeoutResponse | ServerTimeoutErrorResponse>(
 params?: GetHandlersParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getHandlers>>, TError, TData>>, request?: SecondParameter<typeof lp5AxiosClient>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary get handlers
 */

export function useGetHandlers<TData = Awaited<ReturnType<typeof getHandlers>>, TError = Error | AuthorizationErrorResponse | ForbiddenErrorWithServicesResponse | RequestTimeoutResponse | InternalServerErrorResponse | ResponseTimeoutResponse | ServerTimeoutErrorResponse>(
 params?: GetHandlersParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getHandlers>>, TError, TData>>, request?: SecondParameter<typeof lp5AxiosClient>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetHandlersQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}







/**
 * Get options for the resource.
 * @summary handlers options
 */
export const getHandlersOptions = (

 options?: SecondParameter<typeof lp5AxiosClient>,signal?: AbortSignal
) => {


      return lp5AxiosClient<void>(
      {url: `/6/handlers`, method: 'OPTIONS', signal
    },
      options);
    }




export const getGetHandlersOptionsMutationOptions = <TError = RequestTimeoutResponse | InternalServerErrorResponse | ResponseTimeoutResponse | ServerTimeoutErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof getHandlersOptions>>, TError,void, TContext>, request?: SecondParameter<typeof lp5AxiosClient>}
): UseMutationOptions<Awaited<ReturnType<typeof getHandlersOptions>>, TError,void, TContext> => {

const mutationKey = ['getHandlersOptions'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof getHandlersOptions>>, void> = () => {


          return  getHandlersOptions(requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type GetHandlersOptionsMutationResult = NonNullable<Awaited<ReturnType<typeof getHandlersOptions>>>

    export type GetHandlersOptionsMutationError = RequestTimeoutResponse | InternalServerErrorResponse | ResponseTimeoutResponse | ServerTimeoutErrorResponse

    /**
 * @summary handlers options
 */
export const useGetHandlersOptions = <TError = RequestTimeoutResponse | InternalServerErrorResponse | ResponseTimeoutResponse | ServerTimeoutErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof getHandlersOptions>>, TError,void, TContext>, request?: SecondParameter<typeof lp5AxiosClient>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof getHandlersOptions>>,
        TError,
        void,
        TContext
      > => {
      return useMutation(getGetHandlersOptionsMutationOptions(options), queryClient);
    }

/**
 * Count handlers.
 * @summary get handler count
 */
export const getHandlerCount = (
    params?: GetHandlerCountParams,
 options?: SecondParameter<typeof lp5AxiosClient>,signal?: AbortSignal
) => {


      return lp5AxiosClient<HandlersCount>(
      {url: `/6/handlers/count`, method: 'GET',
        params, signal
    },
      options);
    }




export const getGetHandlerCountQueryKey = (params?: GetHandlerCountParams,) => {
    return [
    `/6/handlers/count`, ...(params ? [params] : [])
    ] as const;
    }


export const getGetHandlerCountQueryOptions = <TData = Awaited<ReturnType<typeof getHandlerCount>>, TError = Error | AuthorizationErrorResponse | ForbiddenErrorWithServicesResponse | RequestTimeoutResponse | InternalServerErrorResponse | ResponseTimeoutResponse | ServerTimeoutErrorResponse>(params?: GetHandlerCountParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getHandlerCount>>, TError, TData>>, request?: SecondParameter<typeof lp5AxiosClient>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetHandlerCountQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getHandlerCount>>> = ({ signal }) => getHandlerCount(params, requestOptions, signal);





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getHandlerCount>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetHandlerCountQueryResult = NonNullable<Awaited<ReturnType<typeof getHandlerCount>>>
export type GetHandlerCountQueryError = Error | AuthorizationErrorResponse | ForbiddenErrorWithServicesResponse | RequestTimeoutResponse | InternalServerErrorResponse | ResponseTimeoutResponse | ServerTimeoutErrorResponse


export function useGetHandlerCount<TData = Awaited<ReturnType<typeof getHandlerCount>>, TError = Error | AuthorizationErrorResponse | ForbiddenErrorWithServicesResponse | RequestTimeoutResponse | InternalServerErrorResponse | ResponseTimeoutResponse | ServerTimeoutErrorResponse>(
 params: undefined |  GetHandlerCountParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getHandlerCount>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getHandlerCount>>,
          TError,
          Awaited<ReturnType<typeof getHandlerCount>>
        > , 'initialData'
      >, request?: SecondParameter<typeof lp5AxiosClient>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetHandlerCount<TData = Awaited<ReturnType<typeof getHandlerCount>>, TError = Error | AuthorizationErrorResponse | ForbiddenErrorWithServicesResponse | RequestTimeoutResponse | InternalServerErrorResponse | ResponseTimeoutResponse | ServerTimeoutErrorResponse>(
 params?: GetHandlerCountParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getHandlerCount>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getHandlerCount>>,
          TError,
          Awaited<ReturnType<typeof getHandlerCount>>
        > , 'initialData'
      >, request?: SecondParameter<typeof lp5AxiosClient>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetHandlerCount<TData = Awaited<ReturnType<typeof getHandlerCount>>, TError = Error | AuthorizationErrorResponse | ForbiddenErrorWithServicesResponse | RequestTimeoutResponse | InternalServerErrorResponse | ResponseTimeoutResponse | ServerTimeoutErrorResponse>(
 params?: GetHandlerCountParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getHandlerCount>>, TError, TData>>, request?: SecondParameter<typeof lp5AxiosClient>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary get handler count
 */

export function useGetHandlerCount<TData = Awaited<ReturnType<typeof getHandlerCount>>, TError = Error | AuthorizationErrorResponse | ForbiddenErrorWithServicesResponse | RequestTimeoutResponse | InternalServerErrorResponse | ResponseTimeoutResponse | ServerTimeoutErrorResponse>(
 params?: GetHandlerCountParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getHandlerCount>>, TError, TData>>, request?: SecondParameter<typeof lp5AxiosClient>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetHandlerCountQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}







/**
 * Get options for the resource.
 * @summary handler count options
 */
export const getHandlersCountOptions = (

 options?: SecondParameter<typeof lp5AxiosClient>,signal?: AbortSignal
) => {


      return lp5AxiosClient<void>(
      {url: `/6/handlers/count`, method: 'OPTIONS', signal
    },
      options);
    }




export const getGetHandlersCountOptionsMutationOptions = <TError = RequestTimeoutResponse | InternalServerErrorResponse | ResponseTimeoutResponse | ServerTimeoutErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof getHandlersCountOptions>>, TError,void, TContext>, request?: SecondParameter<typeof lp5AxiosClient>}
): UseMutationOptions<Awaited<ReturnType<typeof getHandlersCountOptions>>, TError,void, TContext> => {

const mutationKey = ['getHandlersCountOptions'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof getHandlersCountOptions>>, void> = () => {


          return  getHandlersCountOptions(requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type GetHandlersCountOptionsMutationResult = NonNullable<Awaited<ReturnType<typeof getHandlersCountOptions>>>

    export type GetHandlersCountOptionsMutationError = RequestTimeoutResponse | InternalServerErrorResponse | ResponseTimeoutResponse | ServerTimeoutErrorResponse

    /**
 * @summary handler count options
 */
export const useGetHandlersCountOptions = <TError = RequestTimeoutResponse | InternalServerErrorResponse | ResponseTimeoutResponse | ServerTimeoutErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof getHandlersCountOptions>>, TError,void, TContext>, request?: SecondParameter<typeof lp5AxiosClient>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof getHandlersCountOptions>>,
        TError,
        void,
        TContext
      > => {
      return useMutation(getGetHandlersCountOptionsMutationOptions(options), queryClient);
    }

/**
 * Validate handler policies before using them to create or update a handler.
 * @summary validate handler policies
 */
export const validatePolicies = (
    handlersValidator: HandlersValidator,
 options?: SecondParameter<typeof lp5AxiosClient>,signal?: AbortSignal
) => {


      return lp5AxiosClient<void>(
      {url: `/6/handlers/validator`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: handlersValidator, signal
    },
      options);
    }




export const getValidatePoliciesMutationOptions = <TError = Error | AuthorizationErrorResponse | ForbiddenErrorWithServicesResponse | RequestTimeoutResponse | PayloadToLargeResponse | InternalServerErrorResponse | ResponseTimeoutResponse | ServerTimeoutErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof validatePolicies>>, TError,{data: HandlersValidator}, TContext>, request?: SecondParameter<typeof lp5AxiosClient>}
): UseMutationOptions<Awaited<ReturnType<typeof validatePolicies>>, TError,{data: HandlersValidator}, TContext> => {

const mutationKey = ['validatePolicies'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof validatePolicies>>, {data: HandlersValidator}> = (props) => {
          const {data} = props ?? {};

          return  validatePolicies(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type ValidatePoliciesMutationResult = NonNullable<Awaited<ReturnType<typeof validatePolicies>>>
    export type ValidatePoliciesMutationBody = HandlersValidator
    export type ValidatePoliciesMutationError = Error | AuthorizationErrorResponse | ForbiddenErrorWithServicesResponse | RequestTimeoutResponse | PayloadToLargeResponse | InternalServerErrorResponse | ResponseTimeoutResponse | ServerTimeoutErrorResponse

    /**
 * @summary validate handler policies
 */
export const useValidatePolicies = <TError = Error | AuthorizationErrorResponse | ForbiddenErrorWithServicesResponse | RequestTimeoutResponse | PayloadToLargeResponse | InternalServerErrorResponse | ResponseTimeoutResponse | ServerTimeoutErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof validatePolicies>>, TError,{data: HandlersValidator}, TContext>, request?: SecondParameter<typeof lp5AxiosClient>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof validatePolicies>>,
        TError,
        {data: HandlersValidator},
        TContext
      > => {
      return useMutation(getValidatePoliciesMutationOptions(options), queryClient);
    }

/**
 * Get options for the resource.
 * @summary handler policies validator options
 */
export const getHandlersPoliciesValidatorOptions = (

 options?: SecondParameter<typeof lp5AxiosClient>,signal?: AbortSignal
) => {


      return lp5AxiosClient<void>(
      {url: `/6/handlers/validator`, method: 'OPTIONS', signal
    },
      options);
    }




export const getGetHandlersPoliciesValidatorOptionsMutationOptions = <TError = RequestTimeoutResponse | InternalServerErrorResponse | ResponseTimeoutResponse | ServerTimeoutErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof getHandlersPoliciesValidatorOptions>>, TError,void, TContext>, request?: SecondParameter<typeof lp5AxiosClient>}
): UseMutationOptions<Awaited<ReturnType<typeof getHandlersPoliciesValidatorOptions>>, TError,void, TContext> => {

const mutationKey = ['getHandlersPoliciesValidatorOptions'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof getHandlersPoliciesValidatorOptions>>, void> = () => {


          return  getHandlersPoliciesValidatorOptions(requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type GetHandlersPoliciesValidatorOptionsMutationResult = NonNullable<Awaited<ReturnType<typeof getHandlersPoliciesValidatorOptions>>>

    export type GetHandlersPoliciesValidatorOptionsMutationError = RequestTimeoutResponse | InternalServerErrorResponse | ResponseTimeoutResponse | ServerTimeoutErrorResponse

    /**
 * @summary handler policies validator options
 */
export const useGetHandlersPoliciesValidatorOptions = <TError = RequestTimeoutResponse | InternalServerErrorResponse | ResponseTimeoutResponse | ServerTimeoutErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof getHandlersPoliciesValidatorOptions>>, TError,void, TContext>, request?: SecondParameter<typeof lp5AxiosClient>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof getHandlersPoliciesValidatorOptions>>,
        TError,
        void,
        TContext
      > => {
      return useMutation(getGetHandlersPoliciesValidatorOptionsMutationOptions(options), queryClient);
    }

/**
 * Get handler by ID.
 * @summary get handler
 */
export const getHandler = (
    handlerId: Uuid,
 options?: SecondParameter<typeof lp5AxiosClient>,signal?: AbortSignal
) => {


      return lp5AxiosClient<HandlerInResponse>(
      {url: `/6/handlers/${handlerId}`, method: 'GET', signal
    },
      options);
    }




export const getGetHandlerQueryKey = (handlerId: Uuid,) => {
    return [
    `/6/handlers/${handlerId}`
    ] as const;
    }


export const getGetHandlerQueryOptions = <TData = Awaited<ReturnType<typeof getHandler>>, TError = AuthorizationErrorResponse | ForbiddenErrorWithServicesResponse | HandlerNotFoundResponse | RequestTimeoutResponse | InternalServerErrorResponse | ResponseTimeoutResponse | ServerTimeoutErrorResponse>(handlerId: Uuid, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getHandler>>, TError, TData>>, request?: SecondParameter<typeof lp5AxiosClient>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetHandlerQueryKey(handlerId);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getHandler>>> = ({ signal }) => getHandler(handlerId, requestOptions, signal);





   return  { queryKey, queryFn, enabled: handlerId !== null && handlerId !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getHandler>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetHandlerQueryResult = NonNullable<Awaited<ReturnType<typeof getHandler>>>
export type GetHandlerQueryError = AuthorizationErrorResponse | ForbiddenErrorWithServicesResponse | HandlerNotFoundResponse | RequestTimeoutResponse | InternalServerErrorResponse | ResponseTimeoutResponse | ServerTimeoutErrorResponse


export function useGetHandler<TData = Awaited<ReturnType<typeof getHandler>>, TError = AuthorizationErrorResponse | ForbiddenErrorWithServicesResponse | HandlerNotFoundResponse | RequestTimeoutResponse | InternalServerErrorResponse | ResponseTimeoutResponse | ServerTimeoutErrorResponse>(
 handlerId: Uuid, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getHandler>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getHandler>>,
          TError,
          Awaited<ReturnType<typeof getHandler>>
        > , 'initialData'
      >, request?: SecondParameter<typeof lp5AxiosClient>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetHandler<TData = Awaited<ReturnType<typeof getHandler>>, TError = AuthorizationErrorResponse | ForbiddenErrorWithServicesResponse | HandlerNotFoundResponse | RequestTimeoutResponse | InternalServerErrorResponse | ResponseTimeoutResponse | ServerTimeoutErrorResponse>(
 handlerId: Uuid, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getHandler>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getHandler>>,
          TError,
          Awaited<ReturnType<typeof getHandler>>
        > , 'initialData'
      >, request?: SecondParameter<typeof lp5AxiosClient>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetHandler<TData = Awaited<ReturnType<typeof getHandler>>, TError = AuthorizationErrorResponse | ForbiddenErrorWithServicesResponse | HandlerNotFoundResponse | RequestTimeoutResponse | InternalServerErrorResponse | ResponseTimeoutResponse | ServerTimeoutErrorResponse>(
 handlerId: Uuid, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getHandler>>, TError, TData>>, request?: SecondParameter<typeof lp5AxiosClient>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary get handler
 */

export function useGetHandler<TData = Awaited<ReturnType<typeof getHandler>>, TError = AuthorizationErrorResponse | ForbiddenErrorWithServicesResponse | HandlerNotFoundResponse | RequestTimeoutResponse | InternalServerErrorResponse | ResponseTimeoutResponse | ServerTimeoutErrorResponse>(
 handlerId: Uuid, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getHandler>>, TError, TData>>, request?: SecondParameter<typeof lp5AxiosClient>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetHandlerQueryOptions(handlerId,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}







/**
 * Update handler. You cannot update a part of the handler, so you should specify all the fields for your handler.
 * @summary replace handler
 */
export const putHandler = (
    handlerId: Uuid,
    newHandler: NewHandler,
 options?: SecondParameter<typeof lp5AxiosClient>,signal?: AbortSignal
) => {


      return lp5AxiosClient<void>(
      {url: `/6/handlers/${handlerId}`, method: 'PUT',
      headers: {'Content-Type': 'application/json', },
      data: newHandler, signal
    },
      options);
    }




export const getPutHandlerMutationOptions = <TError = Error | AuthorizationErrorResponse | ForbiddenErrorWithServicesResponse | HandlerNotFoundResponse | RequestTimeoutResponse | PayloadToLargeResponse | InternalServerErrorResponse | ResponseTimeoutResponse | ServerTimeoutErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof putHandler>>, TError,{handlerId: Uuid;data: NewHandler}, TContext>, request?: SecondParameter<typeof lp5AxiosClient>}
): UseMutationOptions<Awaited<ReturnType<typeof putHandler>>, TError,{handlerId: Uuid;data: NewHandler}, TContext> => {

const mutationKey = ['putHandler'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof putHandler>>, {handlerId: Uuid;data: NewHandler}> = (props) => {
          const {handlerId,data} = props ?? {};

          return  putHandler(handlerId,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type PutHandlerMutationResult = NonNullable<Awaited<ReturnType<typeof putHandler>>>
    export type PutHandlerMutationBody = NewHandler
    export type PutHandlerMutationError = Error | AuthorizationErrorResponse | ForbiddenErrorWithServicesResponse | HandlerNotFoundResponse | RequestTimeoutResponse | PayloadToLargeResponse | InternalServerErrorResponse | ResponseTimeoutResponse | ServerTimeoutErrorResponse

    /**
 * @summary replace handler
 */
export const usePutHandler = <TError = Error | AuthorizationErrorResponse | ForbiddenErrorWithServicesResponse | HandlerNotFoundResponse | RequestTimeoutResponse | PayloadToLargeResponse | InternalServerErrorResponse | ResponseTimeoutResponse | ServerTimeoutErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof putHandler>>, TError,{handlerId: Uuid;data: NewHandler}, TContext>, request?: SecondParameter<typeof lp5AxiosClient>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof putHandler>>,
        TError,
        {handlerId: Uuid;data: NewHandler},
        TContext
      > => {
      return useMutation(getPutHandlerMutationOptions(options), queryClient);
    }

/**
 * Check if handler with `handler_id` exists.
 * @summary check if handler exists
 */
export const checkHandler = (
    handlerId: Uuid,
 options?: SecondParameter<typeof lp5AxiosClient>,signal?: AbortSignal
) => {


      return lp5AxiosClient<void>(
      {url: `/6/handlers/${handlerId}`, method: 'HEAD', signal
    },
      options);
    }




export const getCheckHandlerMutationOptions = <TError = AuthorizationErrorWithoutBodyResponse | ForbiddenErrorWithoutBodyResponse | void | RequestTimeoutWithoutBodyResponse | InternalServerErrorWithoutBodyResponse | ResponseTimeoutWithoutBodyResponse | ServerTimeoutErrorWithoutBodyResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof checkHandler>>, TError,{handlerId: Uuid}, TContext>, request?: SecondParameter<typeof lp5AxiosClient>}
): UseMutationOptions<Awaited<ReturnType<typeof checkHandler>>, TError,{handlerId: Uuid}, TContext> => {

const mutationKey = ['checkHandler'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof checkHandler>>, {handlerId: Uuid}> = (props) => {
          const {handlerId} = props ?? {};

          return  checkHandler(handlerId,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type CheckHandlerMutationResult = NonNullable<Awaited<ReturnType<typeof checkHandler>>>

    export type CheckHandlerMutationError = AuthorizationErrorWithoutBodyResponse | ForbiddenErrorWithoutBodyResponse | void | RequestTimeoutWithoutBodyResponse | InternalServerErrorWithoutBodyResponse | ResponseTimeoutWithoutBodyResponse | ServerTimeoutErrorWithoutBodyResponse

    /**
 * @summary check if handler exists
 */
export const useCheckHandler = <TError = AuthorizationErrorWithoutBodyResponse | ForbiddenErrorWithoutBodyResponse | void | RequestTimeoutWithoutBodyResponse | InternalServerErrorWithoutBodyResponse | ResponseTimeoutWithoutBodyResponse | ServerTimeoutErrorWithoutBodyResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof checkHandler>>, TError,{handlerId: Uuid}, TContext>, request?: SecondParameter<typeof lp5AxiosClient>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof checkHandler>>,
        TError,
        {handlerId: Uuid},
        TContext
      > => {
      return useMutation(getCheckHandlerMutationOptions(options), queryClient);
    }

/**
 * Remove handler by ID.
 * @summary remove handler
 */
export const removeHandler = (
    handlerId: Uuid,
 options?: SecondParameter<typeof lp5AxiosClient>,signal?: AbortSignal
) => {


      return lp5AxiosClient<void>(
      {url: `/6/handlers/${handlerId}`, method: 'DELETE', signal
    },
      options);
    }




export const getRemoveHandlerMutationOptions = <TError = AuthorizationErrorResponse | ForbiddenErrorWithServicesResponse | Error | RequestTimeoutResponse | InternalServerErrorResponse | ResponseTimeoutResponse | ServerTimeoutErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof removeHandler>>, TError,{handlerId: Uuid}, TContext>, request?: SecondParameter<typeof lp5AxiosClient>}
): UseMutationOptions<Awaited<ReturnType<typeof removeHandler>>, TError,{handlerId: Uuid}, TContext> => {

const mutationKey = ['removeHandler'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof removeHandler>>, {handlerId: Uuid}> = (props) => {
          const {handlerId} = props ?? {};

          return  removeHandler(handlerId,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type RemoveHandlerMutationResult = NonNullable<Awaited<ReturnType<typeof removeHandler>>>

    export type RemoveHandlerMutationError = AuthorizationErrorResponse | ForbiddenErrorWithServicesResponse | Error | RequestTimeoutResponse | InternalServerErrorResponse | ResponseTimeoutResponse | ServerTimeoutErrorResponse

    /**
 * @summary remove handler
 */
export const useRemoveHandler = <TError = AuthorizationErrorResponse | ForbiddenErrorWithServicesResponse | Error | RequestTimeoutResponse | InternalServerErrorResponse | ResponseTimeoutResponse | ServerTimeoutErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof removeHandler>>, TError,{handlerId: Uuid}, TContext>, request?: SecondParameter<typeof lp5AxiosClient>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof removeHandler>>,
        TError,
        {handlerId: Uuid},
        TContext
      > => {
      return useMutation(getRemoveHandlerMutationOptions(options), queryClient);
    }

/**
 * Get options for the resource.
 * @summary handler options
 */
export const getHandlerOptions = (
    handlerId: Uuid,
 options?: SecondParameter<typeof lp5AxiosClient>,signal?: AbortSignal
) => {


      return lp5AxiosClient<void>(
      {url: `/6/handlers/${handlerId}`, method: 'OPTIONS', signal
    },
      options);
    }




export const getGetHandlerOptionsMutationOptions = <TError = RequestTimeoutResponse | InternalServerErrorResponse | ResponseTimeoutResponse | ServerTimeoutErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof getHandlerOptions>>, TError,{handlerId: Uuid}, TContext>, request?: SecondParameter<typeof lp5AxiosClient>}
): UseMutationOptions<Awaited<ReturnType<typeof getHandlerOptions>>, TError,{handlerId: Uuid}, TContext> => {

const mutationKey = ['getHandlerOptions'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof getHandlerOptions>>, {handlerId: Uuid}> = (props) => {
          const {handlerId} = props ?? {};

          return  getHandlerOptions(handlerId,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type GetHandlerOptionsMutationResult = NonNullable<Awaited<ReturnType<typeof getHandlerOptions>>>

    export type GetHandlerOptionsMutationError = RequestTimeoutResponse | InternalServerErrorResponse | ResponseTimeoutResponse | ServerTimeoutErrorResponse

    /**
 * @summary handler options
 */
export const useGetHandlerOptions = <TError = RequestTimeoutResponse | InternalServerErrorResponse | ResponseTimeoutResponse | ServerTimeoutErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof getHandlerOptions>>, TError,{handlerId: Uuid}, TContext>, request?: SecondParameter<typeof lp5AxiosClient>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof getHandlerOptions>>,
        TError,
        {handlerId: Uuid},
        TContext
      > => {
      return useMutation(getGetHandlerOptionsMutationOptions(options), queryClient);
    }

/**
 * Process images and/or raw descriptors using the specified handler and generate events.
 *
 * Specify the `multipart/form-data` schema if you need to specify the dynamic handler policies.
 *
 * If the Events service support is disabled on the server, events will not be saved to the database.
 *
 * Notes for incoming data:
 *   - set the image detection time, if necessary, otherwise it will be equal to the request time.
 *   - face or body *bounding boxes* passed with face or body warped image will presented as sample detection rect
 *     in generated event.
 *
 * Objects to be processed must belong to the user account making the request.
 * @summary generate events
 */
export const generateEvents = (
    handlerId: Uuid,
    generateEventsBody: Blob | string | MultipartRawDataSchemaWithPolicies | EmitEventJsonRequestBody,
    params?: GenerateEventsParams,
 options?: SecondParameter<typeof lp5AxiosClient>,signal?: AbortSignal
) => {


      return lp5AxiosClient<GenerateEventSuccessResponseResponse>(
      {url: `/6/handlers/${handlerId}/events`, method: 'POST',
      data: generateEventsBody,
        params, signal
    },
      options);
    }




export const getGenerateEventsMutationOptions = <TError = GenerateEventsBadInputDataResponse | AuthorizationErrorResponse | GenerateEventsAccessErrorsResponse | Error | RequestTimeoutResponse | PayloadToLargeResponse | InternalServerErrorResponse | ResponseTimeoutResponse | ServerTimeoutErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof generateEvents>>, TError,{handlerId: Uuid;data: Blob | string | MultipartRawDataSchemaWithPolicies | EmitEventJsonRequestBody;params?: GenerateEventsParams}, TContext>, request?: SecondParameter<typeof lp5AxiosClient>}
): UseMutationOptions<Awaited<ReturnType<typeof generateEvents>>, TError,{handlerId: Uuid;data: Blob | string | MultipartRawDataSchemaWithPolicies | EmitEventJsonRequestBody;params?: GenerateEventsParams}, TContext> => {

const mutationKey = ['generateEvents'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof generateEvents>>, {handlerId: Uuid;data: Blob | string | MultipartRawDataSchemaWithPolicies | EmitEventJsonRequestBody;params?: GenerateEventsParams}> = (props) => {
          const {handlerId,data,params} = props ?? {};

          return  generateEvents(handlerId,data,params,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type GenerateEventsMutationResult = NonNullable<Awaited<ReturnType<typeof generateEvents>>>
    export type GenerateEventsMutationBody = Blob | string | MultipartRawDataSchemaWithPolicies | EmitEventJsonRequestBody
    export type GenerateEventsMutationError = GenerateEventsBadInputDataResponse | AuthorizationErrorResponse | GenerateEventsAccessErrorsResponse | Error | RequestTimeoutResponse | PayloadToLargeResponse | InternalServerErrorResponse | ResponseTimeoutResponse | ServerTimeoutErrorResponse

    /**
 * @summary generate events
 */
export const useGenerateEvents = <TError = GenerateEventsBadInputDataResponse | AuthorizationErrorResponse | GenerateEventsAccessErrorsResponse | Error | RequestTimeoutResponse | PayloadToLargeResponse | InternalServerErrorResponse | ResponseTimeoutResponse | ServerTimeoutErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof generateEvents>>, TError,{handlerId: Uuid;data: Blob | string | MultipartRawDataSchemaWithPolicies | EmitEventJsonRequestBody;params?: GenerateEventsParams}, TContext>, request?: SecondParameter<typeof lp5AxiosClient>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof generateEvents>>,
        TError,
        {handlerId: Uuid;data: Blob | string | MultipartRawDataSchemaWithPolicies | EmitEventJsonRequestBody;params?: GenerateEventsParams},
        TContext
      > => {
      return useMutation(getGenerateEventsMutationOptions(options), queryClient);
    }

/**
 * Get options for the resource.
 * @summary generate events options
 */
export const generateEventsOptions = (
    handlerId: Uuid,
 options?: SecondParameter<typeof lp5AxiosClient>,signal?: AbortSignal
) => {


      return lp5AxiosClient<void>(
      {url: `/6/handlers/${handlerId}/events`, method: 'OPTIONS', signal
    },
      options);
    }




export const getGenerateEventsOptionsMutationOptions = <TError = RequestTimeoutResponse | InternalServerErrorResponse | ResponseTimeoutResponse | ServerTimeoutErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof generateEventsOptions>>, TError,{handlerId: Uuid}, TContext>, request?: SecondParameter<typeof lp5AxiosClient>}
): UseMutationOptions<Awaited<ReturnType<typeof generateEventsOptions>>, TError,{handlerId: Uuid}, TContext> => {

const mutationKey = ['generateEventsOptions'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof generateEventsOptions>>, {handlerId: Uuid}> = (props) => {
          const {handlerId} = props ?? {};

          return  generateEventsOptions(handlerId,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type GenerateEventsOptionsMutationResult = NonNullable<Awaited<ReturnType<typeof generateEventsOptions>>>

    export type GenerateEventsOptionsMutationError = RequestTimeoutResponse | InternalServerErrorResponse | ResponseTimeoutResponse | ServerTimeoutErrorResponse

    /**
 * @summary generate events options
 */
export const useGenerateEventsOptions = <TError = RequestTimeoutResponse | InternalServerErrorResponse | ResponseTimeoutResponse | ServerTimeoutErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof generateEventsOptions>>, TError,{handlerId: Uuid}, TContext>, request?: SecondParameter<typeof lp5AxiosClient>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof generateEventsOptions>>,
        TError,
        {handlerId: Uuid},
        TContext
      > => {
      return useMutation(getGenerateEventsOptionsMutationOptions(options), queryClient);
    }

/**
 * **WARNING** Experimental resource. Backwards compatibility is not guaranteed.
 *
 * Process images using the specified handler and generate stream events.
 *
 * If the Events service support is disabled on the server, events will not be saved to the database.
 *
 * Notes for incoming data:
 *   - set the image detection time, if necessary, otherwise it will be equal to the request time.
 *   - face or body *bounding boxes* passed with face or body warped image will presented as sample detection rect
 *     in generated event.
 *
 * Objects to be processed must belong to the user account making the request.
 * @summary generate stream events (beta)
 */
export const generateStreamEvents = (
    handlerId: Uuid,
    streamEventRequestBody: StreamEventRequestBody,
 options?: SecondParameter<typeof lp5AxiosClient>,signal?: AbortSignal
) => {


      return lp5AxiosClient<GenerateEventSuccessResponseResponse>(
      {url: `/6/handlers/${handlerId}/stream_events`, method: 'POST',
      headers: {'Content-Type': 'application/msgpack', },
      data: streamEventRequestBody, signal
    },
      options);
    }




export const getGenerateStreamEventsMutationOptions = <TError = GenerateEventsBadInputDataResponse | AuthorizationErrorResponse | GenerateEventsAccessErrorsResponse | Error | RequestTimeoutResponse | PayloadToLargeResponse | InternalServerErrorResponse | ResponseTimeoutResponse | ServerTimeoutErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof generateStreamEvents>>, TError,{handlerId: Uuid;data: StreamEventRequestBody}, TContext>, request?: SecondParameter<typeof lp5AxiosClient>}
): UseMutationOptions<Awaited<ReturnType<typeof generateStreamEvents>>, TError,{handlerId: Uuid;data: StreamEventRequestBody}, TContext> => {

const mutationKey = ['generateStreamEvents'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof generateStreamEvents>>, {handlerId: Uuid;data: StreamEventRequestBody}> = (props) => {
          const {handlerId,data} = props ?? {};

          return  generateStreamEvents(handlerId,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type GenerateStreamEventsMutationResult = NonNullable<Awaited<ReturnType<typeof generateStreamEvents>>>
    export type GenerateStreamEventsMutationBody = StreamEventRequestBody
    export type GenerateStreamEventsMutationError = GenerateEventsBadInputDataResponse | AuthorizationErrorResponse | GenerateEventsAccessErrorsResponse | Error | RequestTimeoutResponse | PayloadToLargeResponse | InternalServerErrorResponse | ResponseTimeoutResponse | ServerTimeoutErrorResponse

    /**
 * @summary generate stream events (beta)
 */
export const useGenerateStreamEvents = <TError = GenerateEventsBadInputDataResponse | AuthorizationErrorResponse | GenerateEventsAccessErrorsResponse | Error | RequestTimeoutResponse | PayloadToLargeResponse | InternalServerErrorResponse | ResponseTimeoutResponse | ServerTimeoutErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof generateStreamEvents>>, TError,{handlerId: Uuid;data: StreamEventRequestBody}, TContext>, request?: SecondParameter<typeof lp5AxiosClient>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof generateStreamEvents>>,
        TError,
        {handlerId: Uuid;data: StreamEventRequestBody},
        TContext
      > => {
      return useMutation(getGenerateStreamEventsMutationOptions(options), queryClient);
    }

/**
 * Get options for the resource.
 * @summary generate stream events options
 */
export const generateStreamEventsOptions = (
    handlerId: Uuid,
 options?: SecondParameter<typeof lp5AxiosClient>,signal?: AbortSignal
) => {


      return lp5AxiosClient<void>(
      {url: `/6/handlers/${handlerId}/stream_events`, method: 'OPTIONS', signal
    },
      options);
    }




export const getGenerateStreamEventsOptionsMutationOptions = <TError = RequestTimeoutResponse | InternalServerErrorResponse | ResponseTimeoutResponse | ServerTimeoutErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof generateStreamEventsOptions>>, TError,{handlerId: Uuid}, TContext>, request?: SecondParameter<typeof lp5AxiosClient>}
): UseMutationOptions<Awaited<ReturnType<typeof generateStreamEventsOptions>>, TError,{handlerId: Uuid}, TContext> => {

const mutationKey = ['generateStreamEventsOptions'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof generateStreamEventsOptions>>, {handlerId: Uuid}> = (props) => {
          const {handlerId} = props ?? {};

          return  generateStreamEventsOptions(handlerId,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type GenerateStreamEventsOptionsMutationResult = NonNullable<Awaited<ReturnType<typeof generateStreamEventsOptions>>>

    export type GenerateStreamEventsOptionsMutationError = RequestTimeoutResponse | InternalServerErrorResponse | ResponseTimeoutResponse | ServerTimeoutErrorResponse

    /**
 * @summary generate stream events options
 */
export const useGenerateStreamEventsOptions = <TError = RequestTimeoutResponse | InternalServerErrorResponse | ResponseTimeoutResponse | ServerTimeoutErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof generateStreamEventsOptions>>, TError,{handlerId: Uuid}, TContext>, request?: SecondParameter<typeof lp5AxiosClient>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof generateStreamEventsOptions>>,
        TError,
        {handlerId: Uuid},
        TContext
      > => {
      return useMutation(getGenerateStreamEventsOptionsMutationOptions(options), queryClient);
    }

/**
 * Save event which was generated by the user. The event structure is similar to an event from handler response. Input events
 * will send to the Sender also and to plugins. Therefore, these events are the same events except that events were
 * generated an `external handler`. Handler ID must belong to a dynamic handler.
 * @summary save event
 */
export const saveEvent = (
    handlerId: Uuid,
    rawEvent: RawEvent,
    params?: SaveEventParams,
 options?: SecondParameter<typeof lp5AxiosClient>,signal?: AbortSignal
) => {


      return lp5AxiosClient<SavedEvent>(
      {url: `/6/handlers/${handlerId}/events/raw`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: rawEvent,
        params, signal
    },
      options);
    }




export const getSaveEventMutationOptions = <TError = Error | AuthorizationErrorResponse | ForbiddenErrorWithServicesResponse | RequestTimeoutResponse | PayloadToLargeResponse | InternalServerErrorResponse | ResponseTimeoutResponse | ServerTimeoutErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof saveEvent>>, TError,{handlerId: Uuid;data: RawEvent;params?: SaveEventParams}, TContext>, request?: SecondParameter<typeof lp5AxiosClient>}
): UseMutationOptions<Awaited<ReturnType<typeof saveEvent>>, TError,{handlerId: Uuid;data: RawEvent;params?: SaveEventParams}, TContext> => {

const mutationKey = ['saveEvent'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof saveEvent>>, {handlerId: Uuid;data: RawEvent;params?: SaveEventParams}> = (props) => {
          const {handlerId,data,params} = props ?? {};

          return  saveEvent(handlerId,data,params,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type SaveEventMutationResult = NonNullable<Awaited<ReturnType<typeof saveEvent>>>
    export type SaveEventMutationBody = RawEvent
    export type SaveEventMutationError = Error | AuthorizationErrorResponse | ForbiddenErrorWithServicesResponse | RequestTimeoutResponse | PayloadToLargeResponse | InternalServerErrorResponse | ResponseTimeoutResponse | ServerTimeoutErrorResponse

    /**
 * @summary save event
 */
export const useSaveEvent = <TError = Error | AuthorizationErrorResponse | ForbiddenErrorWithServicesResponse | RequestTimeoutResponse | PayloadToLargeResponse | InternalServerErrorResponse | ResponseTimeoutResponse | ServerTimeoutErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof saveEvent>>, TError,{handlerId: Uuid;data: RawEvent;params?: SaveEventParams}, TContext>, request?: SecondParameter<typeof lp5AxiosClient>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof saveEvent>>,
        TError,
        {handlerId: Uuid;data: RawEvent;params?: SaveEventParams},
        TContext
      > => {
      return useMutation(getSaveEventMutationOptions(options), queryClient);
    }

/**
 * Get options for the resource.
 * @summary save event options
 */
export const getHandlerEventsOptions = (
    handlerId: Uuid,
 options?: SecondParameter<typeof lp5AxiosClient>,signal?: AbortSignal
) => {


      return lp5AxiosClient<void>(
      {url: `/6/handlers/${handlerId}/events/raw`, method: 'OPTIONS', signal
    },
      options);
    }




export const getGetHandlerEventsOptionsMutationOptions = <TError = RequestTimeoutResponse | InternalServerErrorResponse | ResponseTimeoutResponse | ServerTimeoutErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof getHandlerEventsOptions>>, TError,{handlerId: Uuid}, TContext>, request?: SecondParameter<typeof lp5AxiosClient>}
): UseMutationOptions<Awaited<ReturnType<typeof getHandlerEventsOptions>>, TError,{handlerId: Uuid}, TContext> => {

const mutationKey = ['getHandlerEventsOptions'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof getHandlerEventsOptions>>, {handlerId: Uuid}> = (props) => {
          const {handlerId} = props ?? {};

          return  getHandlerEventsOptions(handlerId,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type GetHandlerEventsOptionsMutationResult = NonNullable<Awaited<ReturnType<typeof getHandlerEventsOptions>>>

    export type GetHandlerEventsOptionsMutationError = RequestTimeoutResponse | InternalServerErrorResponse | ResponseTimeoutResponse | ServerTimeoutErrorResponse

    /**
 * @summary save event options
 */
export const useGetHandlerEventsOptions = <TError = RequestTimeoutResponse | InternalServerErrorResponse | ResponseTimeoutResponse | ServerTimeoutErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof getHandlerEventsOptions>>, TError,{handlerId: Uuid}, TContext>, request?: SecondParameter<typeof lp5AxiosClient>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof getHandlerEventsOptions>>,
        TError,
        {handlerId: Uuid},
        TContext
      > => {
      return useMutation(getGetHandlerEventsOptionsMutationOptions(options), queryClient);
    }

/**
 * Get event statistics by target(s) with applied filters.
 *
 * Event fields and/or functions (count, min, etc.) can be set as targets for aggregation of events.
 *
 * Grouping by frequency or grouping by time intervals is available.
 * @summary get statistics on events
 */
export const getEventStats = (
    getEventStats: GetEventStats,
 options?: SecondParameter<typeof lp5AxiosClient>,signal?: AbortSignal
) => {


      return lp5AxiosClient<GetEventStats200>(
      {url: `/6/events/statistic`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: getEventStats, signal
    },
      options);
    }




export const getGetEventStatsMutationOptions = <TError = Error | AuthorizationErrorResponse | ForbiddenEventsErrorResponse | RequestTimeoutResponse | PayloadToLargeResponse | InternalServerErrorResponse | ResponseTimeoutResponse | ServerTimeoutErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof getEventStats>>, TError,{data: GetEventStats}, TContext>, request?: SecondParameter<typeof lp5AxiosClient>}
): UseMutationOptions<Awaited<ReturnType<typeof getEventStats>>, TError,{data: GetEventStats}, TContext> => {

const mutationKey = ['getEventStats'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof getEventStats>>, {data: GetEventStats}> = (props) => {
          const {data} = props ?? {};

          return  getEventStats(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type GetEventStatsMutationResult = NonNullable<Awaited<ReturnType<typeof getEventStats>>>
    export type GetEventStatsMutationBody = GetEventStats
    export type GetEventStatsMutationError = Error | AuthorizationErrorResponse | ForbiddenEventsErrorResponse | RequestTimeoutResponse | PayloadToLargeResponse | InternalServerErrorResponse | ResponseTimeoutResponse | ServerTimeoutErrorResponse

    /**
 * @summary get statistics on events
 */
export const useGetEventStats = <TError = Error | AuthorizationErrorResponse | ForbiddenEventsErrorResponse | RequestTimeoutResponse | PayloadToLargeResponse | InternalServerErrorResponse | ResponseTimeoutResponse | ServerTimeoutErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof getEventStats>>, TError,{data: GetEventStats}, TContext>, request?: SecondParameter<typeof lp5AxiosClient>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof getEventStats>>,
        TError,
        {data: GetEventStats},
        TContext
      > => {
      return useMutation(getGetEventStatsMutationOptions(options), queryClient);
    }

/**
 * Get options for the resource.
 * @summary events statistics options
 */
export const geteEventsStatisticsOptions = (

 options?: SecondParameter<typeof lp5AxiosClient>,signal?: AbortSignal
) => {


      return lp5AxiosClient<void>(
      {url: `/6/events/statistic`, method: 'OPTIONS', signal
    },
      options);
    }




export const getGeteEventsStatisticsOptionsMutationOptions = <TError = RequestTimeoutResponse | InternalServerErrorResponse | ResponseTimeoutResponse | ServerTimeoutErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof geteEventsStatisticsOptions>>, TError,void, TContext>, request?: SecondParameter<typeof lp5AxiosClient>}
): UseMutationOptions<Awaited<ReturnType<typeof geteEventsStatisticsOptions>>, TError,void, TContext> => {

const mutationKey = ['geteEventsStatisticsOptions'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof geteEventsStatisticsOptions>>, void> = () => {


          return  geteEventsStatisticsOptions(requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type GeteEventsStatisticsOptionsMutationResult = NonNullable<Awaited<ReturnType<typeof geteEventsStatisticsOptions>>>

    export type GeteEventsStatisticsOptionsMutationError = RequestTimeoutResponse | InternalServerErrorResponse | ResponseTimeoutResponse | ServerTimeoutErrorResponse

    /**
 * @summary events statistics options
 */
export const useGeteEventsStatisticsOptions = <TError = RequestTimeoutResponse | InternalServerErrorResponse | ResponseTimeoutResponse | ServerTimeoutErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof geteEventsStatisticsOptions>>, TError,void, TContext>, request?: SecondParameter<typeof lp5AxiosClient>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof geteEventsStatisticsOptions>>,
        TError,
        void,
        TContext
      > => {
      return useMutation(getGeteEventsStatisticsOptionsMutationOptions(options), queryClient);
    }

/**
 * Get events that satisfy filters.
 *
 * Default filters for events:
 *
 *   - `create_time__lt` - current date and time
 *   - `create_time__gte` - current date and time minus month
 *
 *   > **Default filters are not used if any of the following parameters are defined**:
 *
 *     - list of event IDs (`event_ids`)
 *     - lower event ID boundary (`event_id__gte`)
 *     - upper event ID boundary (`event_id__lt`)
 *     - lower create time boundary (`create_time__gte`)
 *     - upper create time boundary (`create_time__lt`)
 *
 * The `target` parameter determines field that will be shown for each event. If target is not set, the response will contain all the fields.
 * @summary get events
 */
export const getEvents = (
    params?: GetEventsParams,
 options?: SecondParameter<typeof lp5AxiosClient>,signal?: AbortSignal
) => {


      return lp5AxiosClient<EventList>(
      {url: `/6/events`, method: 'GET',
        params, signal
    },
      options);
    }




export const getGetEventsInfiniteQueryKey = (params?: GetEventsParams,) => {
    return [
    'infinite', `/6/events`, ...(params ? [params] : [])
    ] as const;
    }

export const getGetEventsQueryKey = (params?: GetEventsParams,) => {
    return [
    `/6/events`, ...(params ? [params] : [])
    ] as const;
    }


export const getGetEventsInfiniteQueryOptions = <TData = InfiniteData<Awaited<ReturnType<typeof getEvents>>, GetEventsParams['page']>, TError = Error | AuthorizationErrorResponse | ForbiddenEventsErrorResponse | RequestTimeoutResponse | InternalServerErrorResponse | ResponseTimeoutResponse | ServerTimeoutErrorResponse>(params?: GetEventsParams, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getEvents>>, TError, TData, QueryKey, GetEventsParams['page']>>, request?: SecondParameter<typeof lp5AxiosClient>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetEventsInfiniteQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getEvents>>, QueryKey, GetEventsParams['page']> = ({ signal, pageParam }) => getEvents({...params, 'page': pageParam ?? params?.['page']}, requestOptions, signal);





   return  { queryKey, queryFn, ...queryOptions} as UseInfiniteQueryOptions<Awaited<ReturnType<typeof getEvents>>, TError, TData, QueryKey, GetEventsParams['page']> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetEventsInfiniteQueryResult = NonNullable<Awaited<ReturnType<typeof getEvents>>>
export type GetEventsInfiniteQueryError = Error | AuthorizationErrorResponse | ForbiddenEventsErrorResponse | RequestTimeoutResponse | InternalServerErrorResponse | ResponseTimeoutResponse | ServerTimeoutErrorResponse


export function useGetEventsInfinite<TData = InfiniteData<Awaited<ReturnType<typeof getEvents>>, GetEventsParams['page']>, TError = Error | AuthorizationErrorResponse | ForbiddenEventsErrorResponse | RequestTimeoutResponse | InternalServerErrorResponse | ResponseTimeoutResponse | ServerTimeoutErrorResponse>(
 params: undefined |  GetEventsParams, options: { query:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getEvents>>, TError, TData, QueryKey, GetEventsParams['page']>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getEvents>>,
          TError,
          Awaited<ReturnType<typeof getEvents>>, QueryKey
        > , 'initialData'
      >, request?: SecondParameter<typeof lp5AxiosClient>}
 , queryClient?: QueryClient
  ):  DefinedUseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetEventsInfinite<TData = InfiniteData<Awaited<ReturnType<typeof getEvents>>, GetEventsParams['page']>, TError = Error | AuthorizationErrorResponse | ForbiddenEventsErrorResponse | RequestTimeoutResponse | InternalServerErrorResponse | ResponseTimeoutResponse | ServerTimeoutErrorResponse>(
 params?: GetEventsParams, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getEvents>>, TError, TData, QueryKey, GetEventsParams['page']>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getEvents>>,
          TError,
          Awaited<ReturnType<typeof getEvents>>, QueryKey
        > , 'initialData'
      >, request?: SecondParameter<typeof lp5AxiosClient>}
 , queryClient?: QueryClient
  ):  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetEventsInfinite<TData = InfiniteData<Awaited<ReturnType<typeof getEvents>>, GetEventsParams['page']>, TError = Error | AuthorizationErrorResponse | ForbiddenEventsErrorResponse | RequestTimeoutResponse | InternalServerErrorResponse | ResponseTimeoutResponse | ServerTimeoutErrorResponse>(
 params?: GetEventsParams, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getEvents>>, TError, TData, QueryKey, GetEventsParams['page']>>, request?: SecondParameter<typeof lp5AxiosClient>}
 , queryClient?: QueryClient
  ):  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary get events
 */

export function useGetEventsInfinite<TData = InfiniteData<Awaited<ReturnType<typeof getEvents>>, GetEventsParams['page']>, TError = Error | AuthorizationErrorResponse | ForbiddenEventsErrorResponse | RequestTimeoutResponse | InternalServerErrorResponse | ResponseTimeoutResponse | ServerTimeoutErrorResponse>(
 params?: GetEventsParams, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getEvents>>, TError, TData, QueryKey, GetEventsParams['page']>>, request?: SecondParameter<typeof lp5AxiosClient>}
 , queryClient?: QueryClient
 ):  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetEventsInfiniteQueryOptions(params,options)

  const query = useInfiniteQuery(queryOptions, queryClient) as  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getGetEventsQueryOptions = <TData = Awaited<ReturnType<typeof getEvents>>, TError = Error | AuthorizationErrorResponse | ForbiddenEventsErrorResponse | RequestTimeoutResponse | InternalServerErrorResponse | ResponseTimeoutResponse | ServerTimeoutErrorResponse>(params?: GetEventsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getEvents>>, TError, TData>>, request?: SecondParameter<typeof lp5AxiosClient>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetEventsQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getEvents>>> = ({ signal }) => getEvents(params, requestOptions, signal);





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getEvents>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetEventsQueryResult = NonNullable<Awaited<ReturnType<typeof getEvents>>>
export type GetEventsQueryError = Error | AuthorizationErrorResponse | ForbiddenEventsErrorResponse | RequestTimeoutResponse | InternalServerErrorResponse | ResponseTimeoutResponse | ServerTimeoutErrorResponse


export function useGetEvents<TData = Awaited<ReturnType<typeof getEvents>>, TError = Error | AuthorizationErrorResponse | ForbiddenEventsErrorResponse | RequestTimeoutResponse | InternalServerErrorResponse | ResponseTimeoutResponse | ServerTimeoutErrorResponse>(
 params: undefined |  GetEventsParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getEvents>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getEvents>>,
          TError,
          Awaited<ReturnType<typeof getEvents>>
        > , 'initialData'
      >, request?: SecondParameter<typeof lp5AxiosClient>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetEvents<TData = Awaited<ReturnType<typeof getEvents>>, TError = Error | AuthorizationErrorResponse | ForbiddenEventsErrorResponse | RequestTimeoutResponse | InternalServerErrorResponse | ResponseTimeoutResponse | ServerTimeoutErrorResponse>(
 params?: GetEventsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getEvents>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getEvents>>,
          TError,
          Awaited<ReturnType<typeof getEvents>>
        > , 'initialData'
      >, request?: SecondParameter<typeof lp5AxiosClient>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetEvents<TData = Awaited<ReturnType<typeof getEvents>>, TError = Error | AuthorizationErrorResponse | ForbiddenEventsErrorResponse | RequestTimeoutResponse | InternalServerErrorResponse | ResponseTimeoutResponse | ServerTimeoutErrorResponse>(
 params?: GetEventsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getEvents>>, TError, TData>>, request?: SecondParameter<typeof lp5AxiosClient>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary get events
 */

export function useGetEvents<TData = Awaited<ReturnType<typeof getEvents>>, TError = Error | AuthorizationErrorResponse | ForbiddenEventsErrorResponse | RequestTimeoutResponse | InternalServerErrorResponse | ResponseTimeoutResponse | ServerTimeoutErrorResponse>(
 params?: GetEventsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getEvents>>, TError, TData>>, request?: SecondParameter<typeof lp5AxiosClient>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetEventsQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}







/**
 * Get options for the resource.
 * @summary events options
 */
export const geteEventsOptions = (

 options?: SecondParameter<typeof lp5AxiosClient>,signal?: AbortSignal
) => {


      return lp5AxiosClient<void>(
      {url: `/6/events`, method: 'OPTIONS', signal
    },
      options);
    }




export const getGeteEventsOptionsMutationOptions = <TError = RequestTimeoutResponse | InternalServerErrorResponse | ResponseTimeoutResponse | ServerTimeoutErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof geteEventsOptions>>, TError,void, TContext>, request?: SecondParameter<typeof lp5AxiosClient>}
): UseMutationOptions<Awaited<ReturnType<typeof geteEventsOptions>>, TError,void, TContext> => {

const mutationKey = ['geteEventsOptions'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof geteEventsOptions>>, void> = () => {


          return  geteEventsOptions(requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type GeteEventsOptionsMutationResult = NonNullable<Awaited<ReturnType<typeof geteEventsOptions>>>

    export type GeteEventsOptionsMutationError = RequestTimeoutResponse | InternalServerErrorResponse | ResponseTimeoutResponse | ServerTimeoutErrorResponse

    /**
 * @summary events options
 */
export const useGeteEventsOptions = <TError = RequestTimeoutResponse | InternalServerErrorResponse | ResponseTimeoutResponse | ServerTimeoutErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof geteEventsOptions>>, TError,void, TContext>, request?: SecondParameter<typeof lp5AxiosClient>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof geteEventsOptions>>,
        TError,
        void,
        TContext
      > => {
      return useMutation(getGeteEventsOptionsMutationOptions(options), queryClient);
    }

/**
 * Get event by ID.
 *
 * The `target` parameter determines field that will be shown for specified event. If target is not set, the response will contain all the fields.
 * @summary get event
 */
export const getEvent = (
    eventId: Uuid,
    params?: GetEventParams,
 options?: SecondParameter<typeof lp5AxiosClient>,signal?: AbortSignal
) => {


      return lp5AxiosClient<Event>(
      {url: `/6/events/${eventId}`, method: 'GET',
        params, signal
    },
      options);
    }




export const getGetEventQueryKey = (eventId: Uuid,
    params?: GetEventParams,) => {
    return [
    `/6/events/${eventId}`, ...(params ? [params] : [])
    ] as const;
    }


export const getGetEventQueryOptions = <TData = Awaited<ReturnType<typeof getEvent>>, TError = AuthorizationErrorResponse | ForbiddenEventsErrorResponse | Error | RequestTimeoutResponse | InternalServerErrorResponse | ResponseTimeoutResponse | ServerTimeoutErrorResponse>(eventId: Uuid,
    params?: GetEventParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getEvent>>, TError, TData>>, request?: SecondParameter<typeof lp5AxiosClient>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetEventQueryKey(eventId,params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getEvent>>> = ({ signal }) => getEvent(eventId,params, requestOptions, signal);





   return  { queryKey, queryFn, enabled: eventId !== null && eventId !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getEvent>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetEventQueryResult = NonNullable<Awaited<ReturnType<typeof getEvent>>>
export type GetEventQueryError = AuthorizationErrorResponse | ForbiddenEventsErrorResponse | Error | RequestTimeoutResponse | InternalServerErrorResponse | ResponseTimeoutResponse | ServerTimeoutErrorResponse


export function useGetEvent<TData = Awaited<ReturnType<typeof getEvent>>, TError = AuthorizationErrorResponse | ForbiddenEventsErrorResponse | Error | RequestTimeoutResponse | InternalServerErrorResponse | ResponseTimeoutResponse | ServerTimeoutErrorResponse>(
 eventId: Uuid,
    params: undefined |  GetEventParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getEvent>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getEvent>>,
          TError,
          Awaited<ReturnType<typeof getEvent>>
        > , 'initialData'
      >, request?: SecondParameter<typeof lp5AxiosClient>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetEvent<TData = Awaited<ReturnType<typeof getEvent>>, TError = AuthorizationErrorResponse | ForbiddenEventsErrorResponse | Error | RequestTimeoutResponse | InternalServerErrorResponse | ResponseTimeoutResponse | ServerTimeoutErrorResponse>(
 eventId: Uuid,
    params?: GetEventParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getEvent>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getEvent>>,
          TError,
          Awaited<ReturnType<typeof getEvent>>
        > , 'initialData'
      >, request?: SecondParameter<typeof lp5AxiosClient>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetEvent<TData = Awaited<ReturnType<typeof getEvent>>, TError = AuthorizationErrorResponse | ForbiddenEventsErrorResponse | Error | RequestTimeoutResponse | InternalServerErrorResponse | ResponseTimeoutResponse | ServerTimeoutErrorResponse>(
 eventId: Uuid,
    params?: GetEventParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getEvent>>, TError, TData>>, request?: SecondParameter<typeof lp5AxiosClient>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary get event
 */

export function useGetEvent<TData = Awaited<ReturnType<typeof getEvent>>, TError = AuthorizationErrorResponse | ForbiddenEventsErrorResponse | Error | RequestTimeoutResponse | InternalServerErrorResponse | ResponseTimeoutResponse | ServerTimeoutErrorResponse>(
 eventId: Uuid,
    params?: GetEventParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getEvent>>, TError, TData>>, request?: SecondParameter<typeof lp5AxiosClient>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetEventQueryOptions(eventId,params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}







/**
 * Check if event with `event_id` exists.
 * @summary check if event exists
 */
export const checkEvent = (
    eventId: Uuid,
    params?: CheckEventParams,
 options?: SecondParameter<typeof lp5AxiosClient>,signal?: AbortSignal
) => {


      return lp5AxiosClient<void>(
      {url: `/6/events/${eventId}`, method: 'HEAD',
        params, signal
    },
      options);
    }




export const getCheckEventMutationOptions = <TError = AuthorizationErrorWithoutBodyResponse | ForbiddenErrorWithoutBodyResponse | void | RequestTimeoutWithoutBodyResponse | InternalServerErrorWithoutBodyResponse | ResponseTimeoutWithoutBodyResponse | ServerTimeoutErrorWithoutBodyResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof checkEvent>>, TError,{eventId: Uuid;params?: CheckEventParams}, TContext>, request?: SecondParameter<typeof lp5AxiosClient>}
): UseMutationOptions<Awaited<ReturnType<typeof checkEvent>>, TError,{eventId: Uuid;params?: CheckEventParams}, TContext> => {

const mutationKey = ['checkEvent'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof checkEvent>>, {eventId: Uuid;params?: CheckEventParams}> = (props) => {
          const {eventId,params} = props ?? {};

          return  checkEvent(eventId,params,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type CheckEventMutationResult = NonNullable<Awaited<ReturnType<typeof checkEvent>>>

    export type CheckEventMutationError = AuthorizationErrorWithoutBodyResponse | ForbiddenErrorWithoutBodyResponse | void | RequestTimeoutWithoutBodyResponse | InternalServerErrorWithoutBodyResponse | ResponseTimeoutWithoutBodyResponse | ServerTimeoutErrorWithoutBodyResponse

    /**
 * @summary check if event exists
 */
export const useCheckEvent = <TError = AuthorizationErrorWithoutBodyResponse | ForbiddenErrorWithoutBodyResponse | void | RequestTimeoutWithoutBodyResponse | InternalServerErrorWithoutBodyResponse | ResponseTimeoutWithoutBodyResponse | ServerTimeoutErrorWithoutBodyResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof checkEvent>>, TError,{eventId: Uuid;params?: CheckEventParams}, TContext>, request?: SecondParameter<typeof lp5AxiosClient>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof checkEvent>>,
        TError,
        {eventId: Uuid;params?: CheckEventParams},
        TContext
      > => {
      return useMutation(getCheckEventMutationOptions(options), queryClient);
    }

/**
 * Delete event by ID and optional account_id.
 * @summary delete event
 */
export const deleteEvent = (
    eventId: Uuid,
 options?: SecondParameter<typeof lp5AxiosClient>,signal?: AbortSignal
) => {


      return lp5AxiosClient<void>(
      {url: `/6/events/${eventId}`, method: 'DELETE', signal
    },
      options);
    }




export const getDeleteEventMutationOptions = <TError = Error | AuthorizationErrorResponse | ForbiddenEventsErrorResponse | RequestTimeoutResponse | InternalServerErrorResponse | ResponseTimeoutResponse | ServerTimeoutErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteEvent>>, TError,{eventId: Uuid}, TContext>, request?: SecondParameter<typeof lp5AxiosClient>}
): UseMutationOptions<Awaited<ReturnType<typeof deleteEvent>>, TError,{eventId: Uuid}, TContext> => {

const mutationKey = ['deleteEvent'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof deleteEvent>>, {eventId: Uuid}> = (props) => {
          const {eventId} = props ?? {};

          return  deleteEvent(eventId,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type DeleteEventMutationResult = NonNullable<Awaited<ReturnType<typeof deleteEvent>>>

    export type DeleteEventMutationError = Error | AuthorizationErrorResponse | ForbiddenEventsErrorResponse | RequestTimeoutResponse | InternalServerErrorResponse | ResponseTimeoutResponse | ServerTimeoutErrorResponse

    /**
 * @summary delete event
 */
export const useDeleteEvent = <TError = Error | AuthorizationErrorResponse | ForbiddenEventsErrorResponse | RequestTimeoutResponse | InternalServerErrorResponse | ResponseTimeoutResponse | ServerTimeoutErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteEvent>>, TError,{eventId: Uuid}, TContext>, request?: SecondParameter<typeof lp5AxiosClient>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof deleteEvent>>,
        TError,
        {eventId: Uuid},
        TContext
      > => {
      return useMutation(getDeleteEventMutationOptions(options), queryClient);
    }

/**
 * Get options for the resource.
 * @summary event options
 */
export const geteEventOptions = (
    eventId: Uuid,
 options?: SecondParameter<typeof lp5AxiosClient>,signal?: AbortSignal
) => {


      return lp5AxiosClient<void>(
      {url: `/6/events/${eventId}`, method: 'OPTIONS', signal
    },
      options);
    }




export const getGeteEventOptionsMutationOptions = <TError = RequestTimeoutResponse | InternalServerErrorResponse | ResponseTimeoutResponse | ServerTimeoutErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof geteEventOptions>>, TError,{eventId: Uuid}, TContext>, request?: SecondParameter<typeof lp5AxiosClient>}
): UseMutationOptions<Awaited<ReturnType<typeof geteEventOptions>>, TError,{eventId: Uuid}, TContext> => {

const mutationKey = ['geteEventOptions'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof geteEventOptions>>, {eventId: Uuid}> = (props) => {
          const {eventId} = props ?? {};

          return  geteEventOptions(eventId,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type GeteEventOptionsMutationResult = NonNullable<Awaited<ReturnType<typeof geteEventOptions>>>

    export type GeteEventOptionsMutationError = RequestTimeoutResponse | InternalServerErrorResponse | ResponseTimeoutResponse | ServerTimeoutErrorResponse

    /**
 * @summary event options
 */
export const useGeteEventOptions = <TError = RequestTimeoutResponse | InternalServerErrorResponse | ResponseTimeoutResponse | ServerTimeoutErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof geteEventOptions>>, TError,{eventId: Uuid}, TContext>, request?: SecondParameter<typeof lp5AxiosClient>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof geteEventOptions>>,
        TError,
        {eventId: Uuid},
        TContext
      > => {
      return useMutation(getGeteEventOptionsMutationOptions(options), queryClient);
    }

/**
 * Get general event statistics by target(s) with applied filters.
 *
 * Event fields and/or functions (count, min, etc.) can be set as targets for aggregation of general events.
 *
 * Grouping by frequency or grouping by time intervals is available.
 * @summary get statistics on general events
 */
export const getGeneralEventStats = (
    getGeneralEventStats: GetGeneralEventStats,
 options?: SecondParameter<typeof lp5AxiosClient>,signal?: AbortSignal
) => {


      return lp5AxiosClient<GetGeneralEventStats200>(
      {url: `/6/general/events/statistic`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: getGeneralEventStats, signal
    },
      options);
    }




export const getGetGeneralEventStatsMutationOptions = <TError = Error | AuthorizationErrorResponse | ForbiddenEventsErrorResponse | RequestTimeoutResponse | PayloadToLargeResponse | InternalServerErrorResponse | ResponseTimeoutResponse | ServerTimeoutErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof getGeneralEventStats>>, TError,{data: GetGeneralEventStats}, TContext>, request?: SecondParameter<typeof lp5AxiosClient>}
): UseMutationOptions<Awaited<ReturnType<typeof getGeneralEventStats>>, TError,{data: GetGeneralEventStats}, TContext> => {

const mutationKey = ['getGeneralEventStats'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof getGeneralEventStats>>, {data: GetGeneralEventStats}> = (props) => {
          const {data} = props ?? {};

          return  getGeneralEventStats(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type GetGeneralEventStatsMutationResult = NonNullable<Awaited<ReturnType<typeof getGeneralEventStats>>>
    export type GetGeneralEventStatsMutationBody = GetGeneralEventStats
    export type GetGeneralEventStatsMutationError = Error | AuthorizationErrorResponse | ForbiddenEventsErrorResponse | RequestTimeoutResponse | PayloadToLargeResponse | InternalServerErrorResponse | ResponseTimeoutResponse | ServerTimeoutErrorResponse

    /**
 * @summary get statistics on general events
 */
export const useGetGeneralEventStats = <TError = Error | AuthorizationErrorResponse | ForbiddenEventsErrorResponse | RequestTimeoutResponse | PayloadToLargeResponse | InternalServerErrorResponse | ResponseTimeoutResponse | ServerTimeoutErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof getGeneralEventStats>>, TError,{data: GetGeneralEventStats}, TContext>, request?: SecondParameter<typeof lp5AxiosClient>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof getGeneralEventStats>>,
        TError,
        {data: GetGeneralEventStats},
        TContext
      > => {
      return useMutation(getGetGeneralEventStatsMutationOptions(options), queryClient);
    }

/**
 * Get options for the resource.
 * @summary general events statistics options
 */
export const getGeneralEventsStatisticsOptions = (

 options?: SecondParameter<typeof lp5AxiosClient>,signal?: AbortSignal
) => {


      return lp5AxiosClient<void>(
      {url: `/6/general/events/statistic`, method: 'OPTIONS', signal
    },
      options);
    }




export const getGetGeneralEventsStatisticsOptionsMutationOptions = <TError = RequestTimeoutResponse | InternalServerErrorResponse | ResponseTimeoutResponse | ServerTimeoutErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof getGeneralEventsStatisticsOptions>>, TError,void, TContext>, request?: SecondParameter<typeof lp5AxiosClient>}
): UseMutationOptions<Awaited<ReturnType<typeof getGeneralEventsStatisticsOptions>>, TError,void, TContext> => {

const mutationKey = ['getGeneralEventsStatisticsOptions'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof getGeneralEventsStatisticsOptions>>, void> = () => {


          return  getGeneralEventsStatisticsOptions(requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type GetGeneralEventsStatisticsOptionsMutationResult = NonNullable<Awaited<ReturnType<typeof getGeneralEventsStatisticsOptions>>>

    export type GetGeneralEventsStatisticsOptionsMutationError = RequestTimeoutResponse | InternalServerErrorResponse | ResponseTimeoutResponse | ServerTimeoutErrorResponse

    /**
 * @summary general events statistics options
 */
export const useGetGeneralEventsStatisticsOptions = <TError = RequestTimeoutResponse | InternalServerErrorResponse | ResponseTimeoutResponse | ServerTimeoutErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof getGeneralEventsStatisticsOptions>>, TError,void, TContext>, request?: SecondParameter<typeof lp5AxiosClient>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof getGeneralEventsStatisticsOptions>>,
        TError,
        void,
        TContext
      > => {
      return useMutation(getGetGeneralEventsStatisticsOptionsMutationOptions(options), queryClient);
    }

/**
 * Get general events that satisfy filters.
 *
 * Default filters for events:
 *
 *   - `event_create_time__lt` - current date and time
 *   - `event_create_time__gte` - current date and time minus month
 *
 *   > **Default filters are not used if any of the following parameters are defined**:
 *
 *     - list of event IDs (`event_ids`)
 *     - lower event ID boundary (`event_id__gte`)
 *     - upper event ID boundary (`event_id__lt`)
 *     - lower create time boundary (`event_create_time__gte`)
 *     - upper create time boundary (`event_create_time__lt`)
 * @summary get general events
 */
export const getGeneralEvents = (
    params?: GetGeneralEventsParams,
 options?: SecondParameter<typeof lp5AxiosClient>,signal?: AbortSignal
) => {


      return lp5AxiosClient<GeneralEvents>(
      {url: `/6/general/events`, method: 'GET',
        params, signal
    },
      options);
    }




export const getGetGeneralEventsQueryKey = (params?: GetGeneralEventsParams,) => {
    return [
    `/6/general/events`, ...(params ? [params] : [])
    ] as const;
    }


export const getGetGeneralEventsQueryOptions = <TData = Awaited<ReturnType<typeof getGeneralEvents>>, TError = Error | AuthorizationErrorResponse | ForbiddenEventsErrorResponse | RequestTimeoutResponse | InternalServerErrorResponse | ResponseTimeoutResponse | ServerTimeoutErrorResponse>(params?: GetGeneralEventsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getGeneralEvents>>, TError, TData>>, request?: SecondParameter<typeof lp5AxiosClient>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetGeneralEventsQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getGeneralEvents>>> = ({ signal }) => getGeneralEvents(params, requestOptions, signal);





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getGeneralEvents>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetGeneralEventsQueryResult = NonNullable<Awaited<ReturnType<typeof getGeneralEvents>>>
export type GetGeneralEventsQueryError = Error | AuthorizationErrorResponse | ForbiddenEventsErrorResponse | RequestTimeoutResponse | InternalServerErrorResponse | ResponseTimeoutResponse | ServerTimeoutErrorResponse


export function useGetGeneralEvents<TData = Awaited<ReturnType<typeof getGeneralEvents>>, TError = Error | AuthorizationErrorResponse | ForbiddenEventsErrorResponse | RequestTimeoutResponse | InternalServerErrorResponse | ResponseTimeoutResponse | ServerTimeoutErrorResponse>(
 params: undefined |  GetGeneralEventsParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getGeneralEvents>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getGeneralEvents>>,
          TError,
          Awaited<ReturnType<typeof getGeneralEvents>>
        > , 'initialData'
      >, request?: SecondParameter<typeof lp5AxiosClient>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetGeneralEvents<TData = Awaited<ReturnType<typeof getGeneralEvents>>, TError = Error | AuthorizationErrorResponse | ForbiddenEventsErrorResponse | RequestTimeoutResponse | InternalServerErrorResponse | ResponseTimeoutResponse | ServerTimeoutErrorResponse>(
 params?: GetGeneralEventsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getGeneralEvents>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getGeneralEvents>>,
          TError,
          Awaited<ReturnType<typeof getGeneralEvents>>
        > , 'initialData'
      >, request?: SecondParameter<typeof lp5AxiosClient>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetGeneralEvents<TData = Awaited<ReturnType<typeof getGeneralEvents>>, TError = Error | AuthorizationErrorResponse | ForbiddenEventsErrorResponse | RequestTimeoutResponse | InternalServerErrorResponse | ResponseTimeoutResponse | ServerTimeoutErrorResponse>(
 params?: GetGeneralEventsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getGeneralEvents>>, TError, TData>>, request?: SecondParameter<typeof lp5AxiosClient>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary get general events
 */

export function useGetGeneralEvents<TData = Awaited<ReturnType<typeof getGeneralEvents>>, TError = Error | AuthorizationErrorResponse | ForbiddenEventsErrorResponse | RequestTimeoutResponse | InternalServerErrorResponse | ResponseTimeoutResponse | ServerTimeoutErrorResponse>(
 params?: GetGeneralEventsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getGeneralEvents>>, TError, TData>>, request?: SecondParameter<typeof lp5AxiosClient>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetGeneralEventsQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}







/**
 * Creates new events.
 * @summary create new general events
 */
export const createGeneralEvents = (
    newGeneralEvent: NewGeneralEvent[],
    params?: CreateGeneralEventsParams,
 options?: SecondParameter<typeof lp5AxiosClient>,signal?: AbortSignal
) => {


      return lp5AxiosClient<void>(
      {url: `/6/general/events`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: newGeneralEvent,
        params, signal
    },
      options);
    }




export const getCreateGeneralEventsMutationOptions = <TError = Error | AuthorizationErrorResponse | ForbiddenEventsErrorResponse | RequestTimeoutResponse | PayloadToLargeResponse | ResponseTimeoutResponse | ServerTimeoutErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createGeneralEvents>>, TError,{data: NewGeneralEvent[];params?: CreateGeneralEventsParams}, TContext>, request?: SecondParameter<typeof lp5AxiosClient>}
): UseMutationOptions<Awaited<ReturnType<typeof createGeneralEvents>>, TError,{data: NewGeneralEvent[];params?: CreateGeneralEventsParams}, TContext> => {

const mutationKey = ['createGeneralEvents'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof createGeneralEvents>>, {data: NewGeneralEvent[];params?: CreateGeneralEventsParams}> = (props) => {
          const {data,params} = props ?? {};

          return  createGeneralEvents(data,params,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type CreateGeneralEventsMutationResult = NonNullable<Awaited<ReturnType<typeof createGeneralEvents>>>
    export type CreateGeneralEventsMutationBody = NewGeneralEvent[]
    export type CreateGeneralEventsMutationError = Error | AuthorizationErrorResponse | ForbiddenEventsErrorResponse | RequestTimeoutResponse | PayloadToLargeResponse | ResponseTimeoutResponse | ServerTimeoutErrorResponse

    /**
 * @summary create new general events
 */
export const useCreateGeneralEvents = <TError = Error | AuthorizationErrorResponse | ForbiddenEventsErrorResponse | RequestTimeoutResponse | PayloadToLargeResponse | ResponseTimeoutResponse | ServerTimeoutErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createGeneralEvents>>, TError,{data: NewGeneralEvent[];params?: CreateGeneralEventsParams}, TContext>, request?: SecondParameter<typeof lp5AxiosClient>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof createGeneralEvents>>,
        TError,
        {data: NewGeneralEvent[];params?: CreateGeneralEventsParams},
        TContext
      > => {
      return useMutation(getCreateGeneralEventsMutationOptions(options), queryClient);
    }

/**
 * Get options for the resource.
 * @summary general events options
 */
export const getGeneralEventsOptions = (

 options?: SecondParameter<typeof lp5AxiosClient>,signal?: AbortSignal
) => {


      return lp5AxiosClient<void>(
      {url: `/6/general/events`, method: 'OPTIONS', signal
    },
      options);
    }




export const getGetGeneralEventsOptionsMutationOptions = <TError = RequestTimeoutResponse | InternalServerErrorResponse | ResponseTimeoutResponse | ServerTimeoutErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof getGeneralEventsOptions>>, TError,void, TContext>, request?: SecondParameter<typeof lp5AxiosClient>}
): UseMutationOptions<Awaited<ReturnType<typeof getGeneralEventsOptions>>, TError,void, TContext> => {

const mutationKey = ['getGeneralEventsOptions'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof getGeneralEventsOptions>>, void> = () => {


          return  getGeneralEventsOptions(requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type GetGeneralEventsOptionsMutationResult = NonNullable<Awaited<ReturnType<typeof getGeneralEventsOptions>>>

    export type GetGeneralEventsOptionsMutationError = RequestTimeoutResponse | InternalServerErrorResponse | ResponseTimeoutResponse | ServerTimeoutErrorResponse

    /**
 * @summary general events options
 */
export const useGetGeneralEventsOptions = <TError = RequestTimeoutResponse | InternalServerErrorResponse | ResponseTimeoutResponse | ServerTimeoutErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof getGeneralEventsOptions>>, TError,void, TContext>, request?: SecondParameter<typeof lp5AxiosClient>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof getGeneralEventsOptions>>,
        TError,
        void,
        TContext
      > => {
      return useMutation(getGetGeneralEventsOptionsMutationOptions(options), queryClient);
    }

/**
 * Get event descriptors that satisfy filters.
 * @summary get general event descriptors
 */
export const getGeneralEventDescriptors = (
    params?: GetGeneralEventDescriptorsParams,
 options?: SecondParameter<typeof lp5AxiosClient>,signal?: AbortSignal
) => {


      return lp5AxiosClient<GetGeneralEventDescriptors200>(
      {url: `/6/general/events/descriptors`, method: 'GET',
        params, signal
    },
      options);
    }




export const getGetGeneralEventDescriptorsQueryKey = (params?: GetGeneralEventDescriptorsParams,) => {
    return [
    `/6/general/events/descriptors`, ...(params ? [params] : [])
    ] as const;
    }


export const getGetGeneralEventDescriptorsQueryOptions = <TData = Awaited<ReturnType<typeof getGeneralEventDescriptors>>, TError = AuthorizationErrorResponse | ForbiddenEventsErrorResponse | RequestTimeoutResponse | InternalServerErrorResponse | ResponseTimeoutResponse | ServerTimeoutErrorResponse>(params?: GetGeneralEventDescriptorsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getGeneralEventDescriptors>>, TError, TData>>, request?: SecondParameter<typeof lp5AxiosClient>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetGeneralEventDescriptorsQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getGeneralEventDescriptors>>> = ({ signal }) => getGeneralEventDescriptors(params, requestOptions, signal);





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getGeneralEventDescriptors>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetGeneralEventDescriptorsQueryResult = NonNullable<Awaited<ReturnType<typeof getGeneralEventDescriptors>>>
export type GetGeneralEventDescriptorsQueryError = AuthorizationErrorResponse | ForbiddenEventsErrorResponse | RequestTimeoutResponse | InternalServerErrorResponse | ResponseTimeoutResponse | ServerTimeoutErrorResponse


export function useGetGeneralEventDescriptors<TData = Awaited<ReturnType<typeof getGeneralEventDescriptors>>, TError = AuthorizationErrorResponse | ForbiddenEventsErrorResponse | RequestTimeoutResponse | InternalServerErrorResponse | ResponseTimeoutResponse | ServerTimeoutErrorResponse>(
 params: undefined |  GetGeneralEventDescriptorsParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getGeneralEventDescriptors>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getGeneralEventDescriptors>>,
          TError,
          Awaited<ReturnType<typeof getGeneralEventDescriptors>>
        > , 'initialData'
      >, request?: SecondParameter<typeof lp5AxiosClient>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetGeneralEventDescriptors<TData = Awaited<ReturnType<typeof getGeneralEventDescriptors>>, TError = AuthorizationErrorResponse | ForbiddenEventsErrorResponse | RequestTimeoutResponse | InternalServerErrorResponse | ResponseTimeoutResponse | ServerTimeoutErrorResponse>(
 params?: GetGeneralEventDescriptorsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getGeneralEventDescriptors>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getGeneralEventDescriptors>>,
          TError,
          Awaited<ReturnType<typeof getGeneralEventDescriptors>>
        > , 'initialData'
      >, request?: SecondParameter<typeof lp5AxiosClient>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetGeneralEventDescriptors<TData = Awaited<ReturnType<typeof getGeneralEventDescriptors>>, TError = AuthorizationErrorResponse | ForbiddenEventsErrorResponse | RequestTimeoutResponse | InternalServerErrorResponse | ResponseTimeoutResponse | ServerTimeoutErrorResponse>(
 params?: GetGeneralEventDescriptorsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getGeneralEventDescriptors>>, TError, TData>>, request?: SecondParameter<typeof lp5AxiosClient>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary get general event descriptors
 */

export function useGetGeneralEventDescriptors<TData = Awaited<ReturnType<typeof getGeneralEventDescriptors>>, TError = AuthorizationErrorResponse | ForbiddenEventsErrorResponse | RequestTimeoutResponse | InternalServerErrorResponse | ResponseTimeoutResponse | ServerTimeoutErrorResponse>(
 params?: GetGeneralEventDescriptorsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getGeneralEventDescriptors>>, TError, TData>>, request?: SecondParameter<typeof lp5AxiosClient>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetGeneralEventDescriptorsQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}







/**
 * Get options for the resource.
 * @summary general event descriptors options
 */
export const getGeneralEventDescriptorsOptions = (

 options?: SecondParameter<typeof lp5AxiosClient>,signal?: AbortSignal
) => {


      return lp5AxiosClient<void>(
      {url: `/6/general/events/descriptors`, method: 'OPTIONS', signal
    },
      options);
    }




export const getGetGeneralEventDescriptorsOptionsMutationOptions = <TError = RequestTimeoutResponse | InternalServerErrorResponse | ResponseTimeoutResponse | ServerTimeoutErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof getGeneralEventDescriptorsOptions>>, TError,void, TContext>, request?: SecondParameter<typeof lp5AxiosClient>}
): UseMutationOptions<Awaited<ReturnType<typeof getGeneralEventDescriptorsOptions>>, TError,void, TContext> => {

const mutationKey = ['getGeneralEventDescriptorsOptions'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof getGeneralEventDescriptorsOptions>>, void> = () => {


          return  getGeneralEventDescriptorsOptions(requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type GetGeneralEventDescriptorsOptionsMutationResult = NonNullable<Awaited<ReturnType<typeof getGeneralEventDescriptorsOptions>>>

    export type GetGeneralEventDescriptorsOptionsMutationError = RequestTimeoutResponse | InternalServerErrorResponse | ResponseTimeoutResponse | ServerTimeoutErrorResponse

    /**
 * @summary general event descriptors options
 */
export const useGetGeneralEventDescriptorsOptions = <TError = RequestTimeoutResponse | InternalServerErrorResponse | ResponseTimeoutResponse | ServerTimeoutErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof getGeneralEventDescriptorsOptions>>, TError,void, TContext>, request?: SecondParameter<typeof lp5AxiosClient>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof getGeneralEventDescriptorsOptions>>,
        TError,
        void,
        TContext
      > => {
      return useMutation(getGetGeneralEventDescriptorsOptionsMutationOptions(options), queryClient);
    }

/**
 * Get general event by ID.
 * @summary get general event
 */
export const getGeneralEvent = (
    eventId: Uuid,
 options?: SecondParameter<typeof lp5AxiosClient>,signal?: AbortSignal
) => {


      return lp5AxiosClient<GeneralEvent>(
      {url: `/6/general/events/${eventId}`, method: 'GET', signal
    },
      options);
    }




export const getGetGeneralEventQueryKey = (eventId: Uuid,) => {
    return [
    `/6/general/events/${eventId}`
    ] as const;
    }


export const getGetGeneralEventQueryOptions = <TData = Awaited<ReturnType<typeof getGeneralEvent>>, TError = AuthorizationErrorResponse | ForbiddenEventsErrorResponse | Error | RequestTimeoutResponse | InternalServerErrorResponse | ResponseTimeoutResponse | ServerTimeoutErrorResponse>(eventId: Uuid, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getGeneralEvent>>, TError, TData>>, request?: SecondParameter<typeof lp5AxiosClient>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetGeneralEventQueryKey(eventId);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getGeneralEvent>>> = ({ signal }) => getGeneralEvent(eventId, requestOptions, signal);





   return  { queryKey, queryFn, enabled: eventId !== null && eventId !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getGeneralEvent>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetGeneralEventQueryResult = NonNullable<Awaited<ReturnType<typeof getGeneralEvent>>>
export type GetGeneralEventQueryError = AuthorizationErrorResponse | ForbiddenEventsErrorResponse | Error | RequestTimeoutResponse | InternalServerErrorResponse | ResponseTimeoutResponse | ServerTimeoutErrorResponse


export function useGetGeneralEvent<TData = Awaited<ReturnType<typeof getGeneralEvent>>, TError = AuthorizationErrorResponse | ForbiddenEventsErrorResponse | Error | RequestTimeoutResponse | InternalServerErrorResponse | ResponseTimeoutResponse | ServerTimeoutErrorResponse>(
 eventId: Uuid, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getGeneralEvent>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getGeneralEvent>>,
          TError,
          Awaited<ReturnType<typeof getGeneralEvent>>
        > , 'initialData'
      >, request?: SecondParameter<typeof lp5AxiosClient>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetGeneralEvent<TData = Awaited<ReturnType<typeof getGeneralEvent>>, TError = AuthorizationErrorResponse | ForbiddenEventsErrorResponse | Error | RequestTimeoutResponse | InternalServerErrorResponse | ResponseTimeoutResponse | ServerTimeoutErrorResponse>(
 eventId: Uuid, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getGeneralEvent>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getGeneralEvent>>,
          TError,
          Awaited<ReturnType<typeof getGeneralEvent>>
        > , 'initialData'
      >, request?: SecondParameter<typeof lp5AxiosClient>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetGeneralEvent<TData = Awaited<ReturnType<typeof getGeneralEvent>>, TError = AuthorizationErrorResponse | ForbiddenEventsErrorResponse | Error | RequestTimeoutResponse | InternalServerErrorResponse | ResponseTimeoutResponse | ServerTimeoutErrorResponse>(
 eventId: Uuid, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getGeneralEvent>>, TError, TData>>, request?: SecondParameter<typeof lp5AxiosClient>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary get general event
 */

export function useGetGeneralEvent<TData = Awaited<ReturnType<typeof getGeneralEvent>>, TError = AuthorizationErrorResponse | ForbiddenEventsErrorResponse | Error | RequestTimeoutResponse | InternalServerErrorResponse | ResponseTimeoutResponse | ServerTimeoutErrorResponse>(
 eventId: Uuid, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getGeneralEvent>>, TError, TData>>, request?: SecondParameter<typeof lp5AxiosClient>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetGeneralEventQueryOptions(eventId,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}







/**
 * Check if general event exists.
 * @summary check if event exists
 */
export const checkGeneralEvent = (
    eventId: Uuid,
 options?: SecondParameter<typeof lp5AxiosClient>,signal?: AbortSignal
) => {


      return lp5AxiosClient<void>(
      {url: `/6/general/events/${eventId}`, method: 'HEAD', signal
    },
      options);
    }




export const getCheckGeneralEventMutationOptions = <TError = AuthorizationErrorWithoutBodyResponse | ForbiddenErrorWithoutBodyResponse | void | RequestTimeoutWithoutBodyResponse | InternalServerErrorWithoutBodyResponse | ResponseTimeoutWithoutBodyResponse | ServerTimeoutErrorWithoutBodyResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof checkGeneralEvent>>, TError,{eventId: Uuid}, TContext>, request?: SecondParameter<typeof lp5AxiosClient>}
): UseMutationOptions<Awaited<ReturnType<typeof checkGeneralEvent>>, TError,{eventId: Uuid}, TContext> => {

const mutationKey = ['checkGeneralEvent'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof checkGeneralEvent>>, {eventId: Uuid}> = (props) => {
          const {eventId} = props ?? {};

          return  checkGeneralEvent(eventId,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type CheckGeneralEventMutationResult = NonNullable<Awaited<ReturnType<typeof checkGeneralEvent>>>

    export type CheckGeneralEventMutationError = AuthorizationErrorWithoutBodyResponse | ForbiddenErrorWithoutBodyResponse | void | RequestTimeoutWithoutBodyResponse | InternalServerErrorWithoutBodyResponse | ResponseTimeoutWithoutBodyResponse | ServerTimeoutErrorWithoutBodyResponse

    /**
 * @summary check if event exists
 */
export const useCheckGeneralEvent = <TError = AuthorizationErrorWithoutBodyResponse | ForbiddenErrorWithoutBodyResponse | void | RequestTimeoutWithoutBodyResponse | InternalServerErrorWithoutBodyResponse | ResponseTimeoutWithoutBodyResponse | ServerTimeoutErrorWithoutBodyResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof checkGeneralEvent>>, TError,{eventId: Uuid}, TContext>, request?: SecondParameter<typeof lp5AxiosClient>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof checkGeneralEvent>>,
        TError,
        {eventId: Uuid},
        TContext
      > => {
      return useMutation(getCheckGeneralEventMutationOptions(options), queryClient);
    }

/**
 * Delete event by ID and optional account_id.
 * @summary delete general event
 */
export const deleteGeneralEvent = (
    eventId: Uuid,
 options?: SecondParameter<typeof lp5AxiosClient>,signal?: AbortSignal
) => {


      return lp5AxiosClient<void>(
      {url: `/6/general/events/${eventId}`, method: 'DELETE', signal
    },
      options);
    }




export const getDeleteGeneralEventMutationOptions = <TError = Error | AuthorizationErrorResponse | ForbiddenEventsErrorResponse | RequestTimeoutResponse | InternalServerErrorResponse | ResponseTimeoutResponse | ServerTimeoutErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteGeneralEvent>>, TError,{eventId: Uuid}, TContext>, request?: SecondParameter<typeof lp5AxiosClient>}
): UseMutationOptions<Awaited<ReturnType<typeof deleteGeneralEvent>>, TError,{eventId: Uuid}, TContext> => {

const mutationKey = ['deleteGeneralEvent'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof deleteGeneralEvent>>, {eventId: Uuid}> = (props) => {
          const {eventId} = props ?? {};

          return  deleteGeneralEvent(eventId,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type DeleteGeneralEventMutationResult = NonNullable<Awaited<ReturnType<typeof deleteGeneralEvent>>>

    export type DeleteGeneralEventMutationError = Error | AuthorizationErrorResponse | ForbiddenEventsErrorResponse | RequestTimeoutResponse | InternalServerErrorResponse | ResponseTimeoutResponse | ServerTimeoutErrorResponse

    /**
 * @summary delete general event
 */
export const useDeleteGeneralEvent = <TError = Error | AuthorizationErrorResponse | ForbiddenEventsErrorResponse | RequestTimeoutResponse | InternalServerErrorResponse | ResponseTimeoutResponse | ServerTimeoutErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteGeneralEvent>>, TError,{eventId: Uuid}, TContext>, request?: SecondParameter<typeof lp5AxiosClient>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof deleteGeneralEvent>>,
        TError,
        {eventId: Uuid},
        TContext
      > => {
      return useMutation(getDeleteGeneralEventMutationOptions(options), queryClient);
    }

/**
 * Get options for the resource.
 * @summary general event options
 */
export const getGeneralEventOptions = (
    eventId: Uuid,
 options?: SecondParameter<typeof lp5AxiosClient>,signal?: AbortSignal
) => {


      return lp5AxiosClient<void>(
      {url: `/6/general/events/${eventId}`, method: 'OPTIONS', signal
    },
      options);
    }




export const getGetGeneralEventOptionsMutationOptions = <TError = RequestTimeoutResponse | InternalServerErrorResponse | ResponseTimeoutResponse | ServerTimeoutErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof getGeneralEventOptions>>, TError,{eventId: Uuid}, TContext>, request?: SecondParameter<typeof lp5AxiosClient>}
): UseMutationOptions<Awaited<ReturnType<typeof getGeneralEventOptions>>, TError,{eventId: Uuid}, TContext> => {

const mutationKey = ['getGeneralEventOptions'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof getGeneralEventOptions>>, {eventId: Uuid}> = (props) => {
          const {eventId} = props ?? {};

          return  getGeneralEventOptions(eventId,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type GetGeneralEventOptionsMutationResult = NonNullable<Awaited<ReturnType<typeof getGeneralEventOptions>>>

    export type GetGeneralEventOptionsMutationError = RequestTimeoutResponse | InternalServerErrorResponse | ResponseTimeoutResponse | ServerTimeoutErrorResponse

    /**
 * @summary general event options
 */
export const useGetGeneralEventOptions = <TError = RequestTimeoutResponse | InternalServerErrorResponse | ResponseTimeoutResponse | ServerTimeoutErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof getGeneralEventOptions>>, TError,{eventId: Uuid}, TContext>, request?: SecondParameter<typeof lp5AxiosClient>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof getGeneralEventOptions>>,
        TError,
        {eventId: Uuid},
        TContext
      > => {
      return useMutation(getGetGeneralEventOptionsMutationOptions(options), queryClient);
    }

/**
 * Create a clustering task.
 *
 * The Filters section specifies which faces (or events) should be added to the cluster. The filters are combined with logical AND.
 *
 * Available filters depend on the object type: events or faces.
 *
 * You can receive a report about the finished clustering task using the reporter task.
 *
 * Use the GET request on resource ["/6/tasks/{task_id}/result"](#operation/getTaskResult) to receive the task results.
 *
 * If there are no results of the created task and error "Object not found" is returned,
 * use the GET request on resource ["/6/tasks/errors/{error_id}"](#operation/getTaskError) to receive the task errors.
 *
 * Objects to be processed must belong to the user account making the request.
 * @summary clustering task
 */
export const createClusteringTask = (
    clusteringTask: ClusteringTask,
 options?: SecondParameter<typeof lp5AxiosClient>,signal?: AbortSignal
) => {


      return lp5AxiosClient<CreateClusteringTask202>(
      {url: `/6/tasks/clustering`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: clusteringTask, signal
    },
      options);
    }




export const getCreateClusteringTaskMutationOptions = <TError = Error | AuthorizationErrorResponse | ForbiddenTasksErrorResponse | RequestTimeoutResponse | PayloadToLargeResponse | InternalServerErrorResponse | ResponseTimeoutResponse | ServerTimeoutErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createClusteringTask>>, TError,{data: ClusteringTask}, TContext>, request?: SecondParameter<typeof lp5AxiosClient>}
): UseMutationOptions<Awaited<ReturnType<typeof createClusteringTask>>, TError,{data: ClusteringTask}, TContext> => {

const mutationKey = ['createClusteringTask'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof createClusteringTask>>, {data: ClusteringTask}> = (props) => {
          const {data} = props ?? {};

          return  createClusteringTask(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type CreateClusteringTaskMutationResult = NonNullable<Awaited<ReturnType<typeof createClusteringTask>>>
    export type CreateClusteringTaskMutationBody = ClusteringTask
    export type CreateClusteringTaskMutationError = Error | AuthorizationErrorResponse | ForbiddenTasksErrorResponse | RequestTimeoutResponse | PayloadToLargeResponse | InternalServerErrorResponse | ResponseTimeoutResponse | ServerTimeoutErrorResponse

    /**
 * @summary clustering task
 */
export const useCreateClusteringTask = <TError = Error | AuthorizationErrorResponse | ForbiddenTasksErrorResponse | RequestTimeoutResponse | PayloadToLargeResponse | InternalServerErrorResponse | ResponseTimeoutResponse | ServerTimeoutErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createClusteringTask>>, TError,{data: ClusteringTask}, TContext>, request?: SecondParameter<typeof lp5AxiosClient>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof createClusteringTask>>,
        TError,
        {data: ClusteringTask},
        TContext
      > => {
      return useMutation(getCreateClusteringTaskMutationOptions(options), queryClient);
    }

/**
 * Get options for the resource.
 * @summary clustering options
 */
export const getClusteringOptions = (

 options?: SecondParameter<typeof lp5AxiosClient>,signal?: AbortSignal
) => {


      return lp5AxiosClient<void>(
      {url: `/6/tasks/clustering`, method: 'OPTIONS', signal
    },
      options);
    }




export const getGetClusteringOptionsMutationOptions = <TError = RequestTimeoutResponse | InternalServerErrorResponse | ResponseTimeoutResponse | ServerTimeoutErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof getClusteringOptions>>, TError,void, TContext>, request?: SecondParameter<typeof lp5AxiosClient>}
): UseMutationOptions<Awaited<ReturnType<typeof getClusteringOptions>>, TError,void, TContext> => {

const mutationKey = ['getClusteringOptions'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof getClusteringOptions>>, void> = () => {


          return  getClusteringOptions(requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type GetClusteringOptionsMutationResult = NonNullable<Awaited<ReturnType<typeof getClusteringOptions>>>

    export type GetClusteringOptionsMutationError = RequestTimeoutResponse | InternalServerErrorResponse | ResponseTimeoutResponse | ServerTimeoutErrorResponse

    /**
 * @summary clustering options
 */
export const useGetClusteringOptions = <TError = RequestTimeoutResponse | InternalServerErrorResponse | ResponseTimeoutResponse | ServerTimeoutErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof getClusteringOptions>>, TError,void, TContext>, request?: SecondParameter<typeof lp5AxiosClient>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof getClusteringOptions>>,
        TError,
        void,
        TContext
      > => {
      return useMutation(getGetClusteringOptionsMutationOptions(options), queryClient);
    }

/**
 * Create a task report in CSV format.
 *
 * Now the report is only created for clustering tasks.
 *
 * The report contains additional information about clustering objects (faces or events). You can specify additional information that will be added to the report.
 * The first and the second columns in the report always correspond to a cluster number and an object ID.
 *
 * Use the GET request on resource ["/6/tasks/{task_id}/result"](#operation/getTaskResult) to receive the task results. The result is returned in ZIP archive, which contains a CSV file. If you set the `save_images` parameter, then the ZIP archive will also contain a folder with images.
 *
 * If there are no results of the created task and error "Object not found" is returned,
 * use the GET request on resource ["/6/tasks/errors/{error_id}"](#operation/getTaskError) to receive the task errors.
 *
 * Objects to be processed must belong to the user account making the request.
 * @summary reporter task
 */
export const createReporterTask = (
    reporterTask: ReporterTask,
 options?: SecondParameter<typeof lp5AxiosClient>,signal?: AbortSignal
) => {


      return lp5AxiosClient<CreateReporterTask202>(
      {url: `/6/tasks/reporter`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: reporterTask, signal
    },
      options);
    }




export const getCreateReporterTaskMutationOptions = <TError = Error | AuthorizationErrorResponse | ForbiddenTasksErrorResponse | RequestTimeoutResponse | PayloadToLargeResponse | InternalServerErrorResponse | ResponseTimeoutResponse | ServerTimeoutErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createReporterTask>>, TError,{data: ReporterTask}, TContext>, request?: SecondParameter<typeof lp5AxiosClient>}
): UseMutationOptions<Awaited<ReturnType<typeof createReporterTask>>, TError,{data: ReporterTask}, TContext> => {

const mutationKey = ['createReporterTask'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof createReporterTask>>, {data: ReporterTask}> = (props) => {
          const {data} = props ?? {};

          return  createReporterTask(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type CreateReporterTaskMutationResult = NonNullable<Awaited<ReturnType<typeof createReporterTask>>>
    export type CreateReporterTaskMutationBody = ReporterTask
    export type CreateReporterTaskMutationError = Error | AuthorizationErrorResponse | ForbiddenTasksErrorResponse | RequestTimeoutResponse | PayloadToLargeResponse | InternalServerErrorResponse | ResponseTimeoutResponse | ServerTimeoutErrorResponse

    /**
 * @summary reporter task
 */
export const useCreateReporterTask = <TError = Error | AuthorizationErrorResponse | ForbiddenTasksErrorResponse | RequestTimeoutResponse | PayloadToLargeResponse | InternalServerErrorResponse | ResponseTimeoutResponse | ServerTimeoutErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createReporterTask>>, TError,{data: ReporterTask}, TContext>, request?: SecondParameter<typeof lp5AxiosClient>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof createReporterTask>>,
        TError,
        {data: ReporterTask},
        TContext
      > => {
      return useMutation(getCreateReporterTaskMutationOptions(options), queryClient);
    }

/**
 * Get options for the resource.
 * @summary reporter options
 */
export const getReporterOptions = (

 options?: SecondParameter<typeof lp5AxiosClient>,signal?: AbortSignal
) => {


      return lp5AxiosClient<void>(
      {url: `/6/tasks/reporter`, method: 'OPTIONS', signal
    },
      options);
    }




export const getGetReporterOptionsMutationOptions = <TError = RequestTimeoutResponse | InternalServerErrorResponse | ResponseTimeoutResponse | ServerTimeoutErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof getReporterOptions>>, TError,void, TContext>, request?: SecondParameter<typeof lp5AxiosClient>}
): UseMutationOptions<Awaited<ReturnType<typeof getReporterOptions>>, TError,void, TContext> => {

const mutationKey = ['getReporterOptions'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof getReporterOptions>>, void> = () => {


          return  getReporterOptions(requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type GetReporterOptionsMutationResult = NonNullable<Awaited<ReturnType<typeof getReporterOptions>>>

    export type GetReporterOptionsMutationError = RequestTimeoutResponse | InternalServerErrorResponse | ResponseTimeoutResponse | ServerTimeoutErrorResponse

    /**
 * @summary reporter options
 */
export const useGetReporterOptions = <TError = RequestTimeoutResponse | InternalServerErrorResponse | ResponseTimeoutResponse | ServerTimeoutErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof getReporterOptions>>, TError,void, TContext>, request?: SecondParameter<typeof lp5AxiosClient>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof getReporterOptions>>,
        TError,
        void,
        TContext
      > => {
      return useMutation(getGetReporterOptionsMutationOptions(options), queryClient);
    }

/**
 * Collect event and/or face data and export them from LP to a CSV file. The file rows represent requested objects. Corresponding samples (if they were requested) are also returned.
 *
 * Use the GET request on resource ["/6/tasks/{task_id}/result"](#operation/getTaskResult) to receive the task results. The result is returned in ZIP archive, which contains a CSV file. If you set the `save_images` parameter, then the ZIP archive will also contain a folder with images.
 *
 * If there are no results of the created task and error "Object not found" is returned,
 * use the GET request on resource ["/6/tasks/errors/{error_id}"](#operation/getTaskError) to receive the task errors.
 *
 * Objects to be processed must belong to the user account making the request.
 * @summary exporter task
 */
export const createExporterTask = (
    exporterTask: ExporterTask,
 options?: SecondParameter<typeof lp5AxiosClient>,signal?: AbortSignal
) => {


      return lp5AxiosClient<CreateExporterTask202>(
      {url: `/6/tasks/exporter`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: exporterTask, signal
    },
      options);
    }




export const getCreateExporterTaskMutationOptions = <TError = Error | AuthorizationErrorResponse | ForbiddenTasksErrorResponse | RequestTimeoutResponse | PayloadToLargeResponse | InternalServerErrorResponse | ResponseTimeoutResponse | ServerTimeoutErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createExporterTask>>, TError,{data: ExporterTask}, TContext>, request?: SecondParameter<typeof lp5AxiosClient>}
): UseMutationOptions<Awaited<ReturnType<typeof createExporterTask>>, TError,{data: ExporterTask}, TContext> => {

const mutationKey = ['createExporterTask'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof createExporterTask>>, {data: ExporterTask}> = (props) => {
          const {data} = props ?? {};

          return  createExporterTask(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type CreateExporterTaskMutationResult = NonNullable<Awaited<ReturnType<typeof createExporterTask>>>
    export type CreateExporterTaskMutationBody = ExporterTask
    export type CreateExporterTaskMutationError = Error | AuthorizationErrorResponse | ForbiddenTasksErrorResponse | RequestTimeoutResponse | PayloadToLargeResponse | InternalServerErrorResponse | ResponseTimeoutResponse | ServerTimeoutErrorResponse

    /**
 * @summary exporter task
 */
export const useCreateExporterTask = <TError = Error | AuthorizationErrorResponse | ForbiddenTasksErrorResponse | RequestTimeoutResponse | PayloadToLargeResponse | InternalServerErrorResponse | ResponseTimeoutResponse | ServerTimeoutErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createExporterTask>>, TError,{data: ExporterTask}, TContext>, request?: SecondParameter<typeof lp5AxiosClient>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof createExporterTask>>,
        TError,
        {data: ExporterTask},
        TContext
      > => {
      return useMutation(getCreateExporterTaskMutationOptions(options), queryClient);
    }

/**
 * Get options for the resource.
 * @summary exporter options
 */
export const getExporterOptions = (

 options?: SecondParameter<typeof lp5AxiosClient>,signal?: AbortSignal
) => {


      return lp5AxiosClient<void>(
      {url: `/6/tasks/exporter`, method: 'OPTIONS', signal
    },
      options);
    }




export const getGetExporterOptionsMutationOptions = <TError = RequestTimeoutResponse | InternalServerErrorResponse | ResponseTimeoutResponse | ServerTimeoutErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof getExporterOptions>>, TError,void, TContext>, request?: SecondParameter<typeof lp5AxiosClient>}
): UseMutationOptions<Awaited<ReturnType<typeof getExporterOptions>>, TError,void, TContext> => {

const mutationKey = ['getExporterOptions'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof getExporterOptions>>, void> = () => {


          return  getExporterOptions(requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type GetExporterOptionsMutationResult = NonNullable<Awaited<ReturnType<typeof getExporterOptions>>>

    export type GetExporterOptionsMutationError = RequestTimeoutResponse | InternalServerErrorResponse | ResponseTimeoutResponse | ServerTimeoutErrorResponse

    /**
 * @summary exporter options
 */
export const useGetExporterOptions = <TError = RequestTimeoutResponse | InternalServerErrorResponse | ResponseTimeoutResponse | ServerTimeoutErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof getExporterOptions>>, TError,void, TContext>, request?: SecondParameter<typeof lp5AxiosClient>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof getExporterOptions>>,
        TError,
        void,
        TContext
      > => {
      return useMutation(getGetExporterOptionsMutationOptions(options), queryClient);
    }

/**
 * Create a linker task.
 *
 * The task enables you to attach faces to the specified list according to the filters.
 *
 * You can use faces or events as objects for the task. When events are used, new face is created for each of the events.
 *
 * A list is required for the task processing:
 * - If you specified a list, the Tasks service checks its existence and displays an error if the list is not found.
 * - If you set new list creation using *create_list = 1*, new list is created.
 *
 * Use the GET request on resource ["/6/tasks/{task_id}/result"](#operation/getTaskResult) to receive the task results.
 *
 * If there are no results of the created task and error "Object not found" is returned,
 * use the GET request on resource ["/6/tasks/errors/{error_id}"](#operation/getTaskError) to receive the task errors.
 *
 * Objects to be processed must belong to the user account making the request.
 *
 * If luna-image-store is disabled no subtask/task result will be stored.
 * @summary linker task
 */
export const createLinkerTask = (
    linkerTask: LinkerTask,
 options?: SecondParameter<typeof lp5AxiosClient>,signal?: AbortSignal
) => {


      return lp5AxiosClient<CreateLinkerTask202>(
      {url: `/6/tasks/linker`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: linkerTask, signal
    },
      options);
    }




export const getCreateLinkerTaskMutationOptions = <TError = Error | AuthorizationErrorResponse | ForbiddenTasksErrorResponse | RequestTimeoutResponse | PayloadToLargeResponse | InternalServerErrorResponse | ResponseTimeoutResponse | ServerTimeoutErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createLinkerTask>>, TError,{data: LinkerTask}, TContext>, request?: SecondParameter<typeof lp5AxiosClient>}
): UseMutationOptions<Awaited<ReturnType<typeof createLinkerTask>>, TError,{data: LinkerTask}, TContext> => {

const mutationKey = ['createLinkerTask'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof createLinkerTask>>, {data: LinkerTask}> = (props) => {
          const {data} = props ?? {};

          return  createLinkerTask(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type CreateLinkerTaskMutationResult = NonNullable<Awaited<ReturnType<typeof createLinkerTask>>>
    export type CreateLinkerTaskMutationBody = LinkerTask
    export type CreateLinkerTaskMutationError = Error | AuthorizationErrorResponse | ForbiddenTasksErrorResponse | RequestTimeoutResponse | PayloadToLargeResponse | InternalServerErrorResponse | ResponseTimeoutResponse | ServerTimeoutErrorResponse

    /**
 * @summary linker task
 */
export const useCreateLinkerTask = <TError = Error | AuthorizationErrorResponse | ForbiddenTasksErrorResponse | RequestTimeoutResponse | PayloadToLargeResponse | InternalServerErrorResponse | ResponseTimeoutResponse | ServerTimeoutErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createLinkerTask>>, TError,{data: LinkerTask}, TContext>, request?: SecondParameter<typeof lp5AxiosClient>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof createLinkerTask>>,
        TError,
        {data: LinkerTask},
        TContext
      > => {
      return useMutation(getCreateLinkerTaskMutationOptions(options), queryClient);
    }

/**
 * Get options for the resource.
 * @summary linker options
 */
export const getTaskLinkerOptions = (

 options?: SecondParameter<typeof lp5AxiosClient>,signal?: AbortSignal
) => {


      return lp5AxiosClient<void>(
      {url: `/6/tasks/linker`, method: 'OPTIONS', signal
    },
      options);
    }




export const getGetTaskLinkerOptionsMutationOptions = <TError = RequestTimeoutResponse | InternalServerErrorResponse | ResponseTimeoutResponse | ServerTimeoutErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof getTaskLinkerOptions>>, TError,void, TContext>, request?: SecondParameter<typeof lp5AxiosClient>}
): UseMutationOptions<Awaited<ReturnType<typeof getTaskLinkerOptions>>, TError,void, TContext> => {

const mutationKey = ['getTaskLinkerOptions'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof getTaskLinkerOptions>>, void> = () => {


          return  getTaskLinkerOptions(requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type GetTaskLinkerOptionsMutationResult = NonNullable<Awaited<ReturnType<typeof getTaskLinkerOptions>>>

    export type GetTaskLinkerOptionsMutationError = RequestTimeoutResponse | InternalServerErrorResponse | ResponseTimeoutResponse | ServerTimeoutErrorResponse

    /**
 * @summary linker options
 */
export const useGetTaskLinkerOptions = <TError = RequestTimeoutResponse | InternalServerErrorResponse | ResponseTimeoutResponse | ServerTimeoutErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof getTaskLinkerOptions>>, TError,void, TContext>, request?: SecondParameter<typeof lp5AxiosClient>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof getTaskLinkerOptions>>,
        TError,
        void,
        TContext
      > => {
      return useMutation(getGetTaskLinkerOptionsMutationOptions(options), queryClient);
    }

/**
 * Create a garbage collection task.
 *
 * Use the GET request on resource ["/6/tasks/{task_id}/result"](#operation/getTaskResult) to receive the task results.
 *
 * If there are no results of the created task and error "Object not found" is returned,
 * use the GET request on resource ["/6/tasks/errors/{error_id}"](#operation/getTaskError) to receive the task errors.
 *
 * Objects to be processed must belong to the user account making the request.
 *
 * > **WARNING**: If you perform the task for faces with the `remove_samples` flag disabled, then the only way to delete samples
 * is to execute the ["remove face/body sample"](operation/deleteSample) resource.
 *
 * If luna-image-store is disabled no subtask/task result will be stored.
 * @summary garbage collection task
 */
export const createGCTask = (
    gcTask: GcTask,
 options?: SecondParameter<typeof lp5AxiosClient>,signal?: AbortSignal
) => {


      return lp5AxiosClient<CreateGCTask202>(
      {url: `/6/tasks/gc`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: gcTask, signal
    },
      options);
    }




export const getCreateGCTaskMutationOptions = <TError = Error | AuthorizationErrorResponse | ForbiddenTasksErrorResponse | RequestTimeoutResponse | PayloadToLargeResponse | InternalServerErrorResponse | ResponseTimeoutResponse | ServerTimeoutErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createGCTask>>, TError,{data: GcTask}, TContext>, request?: SecondParameter<typeof lp5AxiosClient>}
): UseMutationOptions<Awaited<ReturnType<typeof createGCTask>>, TError,{data: GcTask}, TContext> => {

const mutationKey = ['createGCTask'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof createGCTask>>, {data: GcTask}> = (props) => {
          const {data} = props ?? {};

          return  createGCTask(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type CreateGCTaskMutationResult = NonNullable<Awaited<ReturnType<typeof createGCTask>>>
    export type CreateGCTaskMutationBody = GcTask
    export type CreateGCTaskMutationError = Error | AuthorizationErrorResponse | ForbiddenTasksErrorResponse | RequestTimeoutResponse | PayloadToLargeResponse | InternalServerErrorResponse | ResponseTimeoutResponse | ServerTimeoutErrorResponse

    /**
 * @summary garbage collection task
 */
export const useCreateGCTask = <TError = Error | AuthorizationErrorResponse | ForbiddenTasksErrorResponse | RequestTimeoutResponse | PayloadToLargeResponse | InternalServerErrorResponse | ResponseTimeoutResponse | ServerTimeoutErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createGCTask>>, TError,{data: GcTask}, TContext>, request?: SecondParameter<typeof lp5AxiosClient>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof createGCTask>>,
        TError,
        {data: GcTask},
        TContext
      > => {
      return useMutation(getCreateGCTaskMutationOptions(options), queryClient);
    }

/**
 * Get options for the resource.
 * @summary gc options
 */
export const getGCOptions = (

 options?: SecondParameter<typeof lp5AxiosClient>,signal?: AbortSignal
) => {


      return lp5AxiosClient<void>(
      {url: `/6/tasks/gc`, method: 'OPTIONS', signal
    },
      options);
    }




export const getGetGCOptionsMutationOptions = <TError = RequestTimeoutResponse | InternalServerErrorResponse | ResponseTimeoutResponse | ServerTimeoutErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof getGCOptions>>, TError,void, TContext>, request?: SecondParameter<typeof lp5AxiosClient>}
): UseMutationOptions<Awaited<ReturnType<typeof getGCOptions>>, TError,void, TContext> => {

const mutationKey = ['getGCOptions'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof getGCOptions>>, void> = () => {


          return  getGCOptions(requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type GetGCOptionsMutationResult = NonNullable<Awaited<ReturnType<typeof getGCOptions>>>

    export type GetGCOptionsMutationError = RequestTimeoutResponse | InternalServerErrorResponse | ResponseTimeoutResponse | ServerTimeoutErrorResponse

    /**
 * @summary gc options
 */
export const useGetGCOptions = <TError = RequestTimeoutResponse | InternalServerErrorResponse | ResponseTimeoutResponse | ServerTimeoutErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof getGCOptions>>, TError,void, TContext>, request?: SecondParameter<typeof lp5AxiosClient>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof getGCOptions>>,
        TError,
        void,
        TContext
      > => {
      return useMutation(getGetGCOptionsMutationOptions(options), queryClient);
    }

/**
 * Create a cross-matching task.
 *
 * The cross-matching task enables you to compare references (faces, attributes or events) with candidates (faces, attributes or events) according to the specified filters.
 *
 * All the references are matched with all the candidates.
 *
 * You can limit the number of candidates returned in matching results and set the minimum acceptable similarity threshold.
 *
 * Use the GET request on resource ["/6/tasks/{task_id}/result"](#operation/getTaskResult) to receive the task results.
 *
 * If there are no results of the created task and error "Object not found" is returned,
 * use the GET request on resource ["/6/tasks/errors/{error_id}"](#operation/getTaskError) to receive the task errors.
 *
 * Objects to be processed must belong to the user account making the request.
 * @summary cross-matching task
 */
export const createCrossMatchTask = (
    crossMatchTask: CrossMatchTask,
 options?: SecondParameter<typeof lp5AxiosClient>,signal?: AbortSignal
) => {


      return lp5AxiosClient<CreateCrossMatchTask202>(
      {url: `/6/tasks/cross_match`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: crossMatchTask, signal
    },
      options);
    }




export const getCreateCrossMatchTaskMutationOptions = <TError = Error | AuthorizationErrorResponse | ForbiddenTasksErrorResponse | RequestTimeoutResponse | PayloadToLargeResponse | InternalServerErrorResponse | ResponseTimeoutResponse | ServerTimeoutErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createCrossMatchTask>>, TError,{data: CrossMatchTask}, TContext>, request?: SecondParameter<typeof lp5AxiosClient>}
): UseMutationOptions<Awaited<ReturnType<typeof createCrossMatchTask>>, TError,{data: CrossMatchTask}, TContext> => {

const mutationKey = ['createCrossMatchTask'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof createCrossMatchTask>>, {data: CrossMatchTask}> = (props) => {
          const {data} = props ?? {};

          return  createCrossMatchTask(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type CreateCrossMatchTaskMutationResult = NonNullable<Awaited<ReturnType<typeof createCrossMatchTask>>>
    export type CreateCrossMatchTaskMutationBody = CrossMatchTask
    export type CreateCrossMatchTaskMutationError = Error | AuthorizationErrorResponse | ForbiddenTasksErrorResponse | RequestTimeoutResponse | PayloadToLargeResponse | InternalServerErrorResponse | ResponseTimeoutResponse | ServerTimeoutErrorResponse

    /**
 * @summary cross-matching task
 */
export const useCreateCrossMatchTask = <TError = Error | AuthorizationErrorResponse | ForbiddenTasksErrorResponse | RequestTimeoutResponse | PayloadToLargeResponse | InternalServerErrorResponse | ResponseTimeoutResponse | ServerTimeoutErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createCrossMatchTask>>, TError,{data: CrossMatchTask}, TContext>, request?: SecondParameter<typeof lp5AxiosClient>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof createCrossMatchTask>>,
        TError,
        {data: CrossMatchTask},
        TContext
      > => {
      return useMutation(getCreateCrossMatchTaskMutationOptions(options), queryClient);
    }

/**
 * Get options for the resource.
 * @summary cross match options
 */
export const getCrossMatchOptions = (

 options?: SecondParameter<typeof lp5AxiosClient>,signal?: AbortSignal
) => {


      return lp5AxiosClient<void>(
      {url: `/6/tasks/cross_match`, method: 'OPTIONS', signal
    },
      options);
    }




export const getGetCrossMatchOptionsMutationOptions = <TError = RequestTimeoutResponse | InternalServerErrorResponse | ResponseTimeoutResponse | ServerTimeoutErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof getCrossMatchOptions>>, TError,void, TContext>, request?: SecondParameter<typeof lp5AxiosClient>}
): UseMutationOptions<Awaited<ReturnType<typeof getCrossMatchOptions>>, TError,void, TContext> => {

const mutationKey = ['getCrossMatchOptions'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof getCrossMatchOptions>>, void> = () => {


          return  getCrossMatchOptions(requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type GetCrossMatchOptionsMutationResult = NonNullable<Awaited<ReturnType<typeof getCrossMatchOptions>>>

    export type GetCrossMatchOptionsMutationError = RequestTimeoutResponse | InternalServerErrorResponse | ResponseTimeoutResponse | ServerTimeoutErrorResponse

    /**
 * @summary cross match options
 */
export const useGetCrossMatchOptions = <TError = RequestTimeoutResponse | InternalServerErrorResponse | ResponseTimeoutResponse | ServerTimeoutErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof getCrossMatchOptions>>, TError,void, TContext>, request?: SecondParameter<typeof lp5AxiosClient>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof getCrossMatchOptions>>,
        TError,
        void,
        TContext
      > => {
      return useMutation(getGetCrossMatchOptionsMutationOptions(options), queryClient);
    }

/**
 * Create a ROC-curve calculating task.
 *
 * ROC (or Receiver Operating Characteristic) is a performance measurement for the classification problem at various threshold settings. The ROC-curve is plotted with TPR (True Positive Rate) against the FPR (False Positive Rate).
 *
 * TPR is a true positive match pair count divided by a count of total expected positive match pairs, and FPR is a false positive match pair count divided by a count of total expected negative match pairs. Each point (FPR, TPR) of the ROC-cure corresponds to a certain similarity threshold.
 *
 * The model performance is determined by looking at the area under the ROC-curve (or AUC), the ROC-curve and the secondary main diagonal intersection point, where type I and type II error rates are equal. The model performance is also determined by getting into the top-N probability, i.e. probability of getting a positive match pair into the top-N for any match result group sorted by similarity.
 *
 * Use the GET request on resource ["/6/tasks/{task_id}/result"](#operation/getTaskResult) to receive the task results.
 *
 * If there are no results of the created task and error "Object not found" is returned,
 * use the GET request on resource ["/6/tasks/errors/{error_id}"](#operation/getTaskError) to receive the task errors.
 *
 * Objects to be processed must belong to the user account making the request.
 * @summary ROC-curve calculating task
 */
export const createROCTask = (
    rocTask: RocTask,
 options?: SecondParameter<typeof lp5AxiosClient>,signal?: AbortSignal
) => {


      return lp5AxiosClient<CreateROCTask202>(
      {url: `/6/tasks/roc`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: rocTask, signal
    },
      options);
    }




export const getCreateROCTaskMutationOptions = <TError = Error | AuthorizationErrorResponse | ForbiddenTasksErrorResponse | RequestTimeoutResponse | PayloadToLargeResponse | InternalServerErrorResponse | ResponseTimeoutResponse | ServerTimeoutErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createROCTask>>, TError,{data: RocTask}, TContext>, request?: SecondParameter<typeof lp5AxiosClient>}
): UseMutationOptions<Awaited<ReturnType<typeof createROCTask>>, TError,{data: RocTask}, TContext> => {

const mutationKey = ['createROCTask'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof createROCTask>>, {data: RocTask}> = (props) => {
          const {data} = props ?? {};

          return  createROCTask(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type CreateROCTaskMutationResult = NonNullable<Awaited<ReturnType<typeof createROCTask>>>
    export type CreateROCTaskMutationBody = RocTask
    export type CreateROCTaskMutationError = Error | AuthorizationErrorResponse | ForbiddenTasksErrorResponse | RequestTimeoutResponse | PayloadToLargeResponse | InternalServerErrorResponse | ResponseTimeoutResponse | ServerTimeoutErrorResponse

    /**
 * @summary ROC-curve calculating task
 */
export const useCreateROCTask = <TError = Error | AuthorizationErrorResponse | ForbiddenTasksErrorResponse | RequestTimeoutResponse | PayloadToLargeResponse | InternalServerErrorResponse | ResponseTimeoutResponse | ServerTimeoutErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createROCTask>>, TError,{data: RocTask}, TContext>, request?: SecondParameter<typeof lp5AxiosClient>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof createROCTask>>,
        TError,
        {data: RocTask},
        TContext
      > => {
      return useMutation(getCreateROCTaskMutationOptions(options), queryClient);
    }

/**
 * Get options for the resource.
 * @summary roc options
 */
export const getRocOptions = (

 options?: SecondParameter<typeof lp5AxiosClient>,signal?: AbortSignal
) => {


      return lp5AxiosClient<void>(
      {url: `/6/tasks/roc`, method: 'OPTIONS', signal
    },
      options);
    }




export const getGetRocOptionsMutationOptions = <TError = RequestTimeoutResponse | InternalServerErrorResponse | ResponseTimeoutResponse | ServerTimeoutErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof getRocOptions>>, TError,void, TContext>, request?: SecondParameter<typeof lp5AxiosClient>}
): UseMutationOptions<Awaited<ReturnType<typeof getRocOptions>>, TError,void, TContext> => {

const mutationKey = ['getRocOptions'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof getRocOptions>>, void> = () => {


          return  getRocOptions(requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type GetRocOptionsMutationResult = NonNullable<Awaited<ReturnType<typeof getRocOptions>>>

    export type GetRocOptionsMutationError = RequestTimeoutResponse | InternalServerErrorResponse | ResponseTimeoutResponse | ServerTimeoutErrorResponse

    /**
 * @summary roc options
 */
export const useGetRocOptions = <TError = RequestTimeoutResponse | InternalServerErrorResponse | ResponseTimeoutResponse | ServerTimeoutErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof getRocOptions>>, TError,void, TContext>, request?: SecondParameter<typeof lp5AxiosClient>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof getRocOptions>>,
        TError,
        void,
        TContext
      > => {
      return useMutation(getGetRocOptionsMutationOptions(options), queryClient);
    }

/**
 * Create an estimator task.
 *
 *
 * Task allows to process images using established policies. Policies can be specified in the request or use
 * saved ones by passing the handler ID.
 *
 * The resource can accept three types of sources with images for processing:
 *
 * - ZIP archive
 * - S3-like storage
 * - Network disk
 * - FTP server
 * - Samba
 *
 * Use the GET request on resource ["/6/tasks/{task_id}/result"](#operation/getTaskResult) to receive the task results.
 *
 * If there are no results of the created task and error "Object not found" is returned,
 * use the GET request on resource ["/6/tasks/errors/{error_id}"](#operation/getTaskError) to receive the task errors.
 *
 *  > **WARNING**: Check handler `storage_policy` before a task start, `notification_policy` and `event_policy`
 * enable by default.
 *
 * Objects to be processed must belong to the user account making the request.
 *
 * If luna-image-store is disabled no subtask/task result will be stored.
 * @summary estimator task
 */
export const createEstimatorTask = (
    estimatorTask: EstimatorTask,
 options?: SecondParameter<typeof lp5AxiosClient>,signal?: AbortSignal
) => {


      return lp5AxiosClient<CreateEstimatorTask202>(
      {url: `/6/tasks/estimator`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: estimatorTask, signal
    },
      options);
    }




export const getCreateEstimatorTaskMutationOptions = <TError = Error | AuthorizationErrorResponse | ForbiddenTasksErrorWithHandlersResponse | RequestTimeoutResponse | PayloadToLargeResponse | InternalServerErrorResponse | ResponseTimeoutResponse | ServerTimeoutErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createEstimatorTask>>, TError,{data: EstimatorTask}, TContext>, request?: SecondParameter<typeof lp5AxiosClient>}
): UseMutationOptions<Awaited<ReturnType<typeof createEstimatorTask>>, TError,{data: EstimatorTask}, TContext> => {

const mutationKey = ['createEstimatorTask'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof createEstimatorTask>>, {data: EstimatorTask}> = (props) => {
          const {data} = props ?? {};

          return  createEstimatorTask(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type CreateEstimatorTaskMutationResult = NonNullable<Awaited<ReturnType<typeof createEstimatorTask>>>
    export type CreateEstimatorTaskMutationBody = EstimatorTask
    export type CreateEstimatorTaskMutationError = Error | AuthorizationErrorResponse | ForbiddenTasksErrorWithHandlersResponse | RequestTimeoutResponse | PayloadToLargeResponse | InternalServerErrorResponse | ResponseTimeoutResponse | ServerTimeoutErrorResponse

    /**
 * @summary estimator task
 */
export const useCreateEstimatorTask = <TError = Error | AuthorizationErrorResponse | ForbiddenTasksErrorWithHandlersResponse | RequestTimeoutResponse | PayloadToLargeResponse | InternalServerErrorResponse | ResponseTimeoutResponse | ServerTimeoutErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createEstimatorTask>>, TError,{data: EstimatorTask}, TContext>, request?: SecondParameter<typeof lp5AxiosClient>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof createEstimatorTask>>,
        TError,
        {data: EstimatorTask},
        TContext
      > => {
      return useMutation(getCreateEstimatorTaskMutationOptions(options), queryClient);
    }

/**
 * Get options for the resource.
 * @summary estimator options
 */
export const getEstimatorOptions = (

 options?: SecondParameter<typeof lp5AxiosClient>,signal?: AbortSignal
) => {


      return lp5AxiosClient<void>(
      {url: `/6/tasks/estimator`, method: 'OPTIONS', signal
    },
      options);
    }




export const getGetEstimatorOptionsMutationOptions = <TError = RequestTimeoutResponse | InternalServerErrorResponse | ResponseTimeoutResponse | ServerTimeoutErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof getEstimatorOptions>>, TError,void, TContext>, request?: SecondParameter<typeof lp5AxiosClient>}
): UseMutationOptions<Awaited<ReturnType<typeof getEstimatorOptions>>, TError,void, TContext> => {

const mutationKey = ['getEstimatorOptions'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof getEstimatorOptions>>, void> = () => {


          return  getEstimatorOptions(requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type GetEstimatorOptionsMutationResult = NonNullable<Awaited<ReturnType<typeof getEstimatorOptions>>>

    export type GetEstimatorOptionsMutationError = RequestTimeoutResponse | InternalServerErrorResponse | ResponseTimeoutResponse | ServerTimeoutErrorResponse

    /**
 * @summary estimator options
 */
export const useGetEstimatorOptions = <TError = RequestTimeoutResponse | InternalServerErrorResponse | ResponseTimeoutResponse | ServerTimeoutErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof getEstimatorOptions>>, TError,void, TContext>, request?: SecondParameter<typeof lp5AxiosClient>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof getEstimatorOptions>>,
        TError,
        void,
        TContext
      > => {
      return useMutation(getGetEstimatorOptionsMutationOptions(options), queryClient);
    }

/**
 * Create new lambda task.
 * @summary lambda task
 */
export const createLambdaTask = (
    lambdaTask: LambdaTask,
 options?: SecondParameter<typeof lp5AxiosClient>,signal?: AbortSignal
) => {


      return lp5AxiosClient<CreateLambdaTask202>(
      {url: `/6/tasks/lambda`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: lambdaTask, signal
    },
      options);
    }




export const getCreateLambdaTaskMutationOptions = <TError = Error | AuthorizationErrorResponse | ForbiddenTasksErrorResponse | RequestTimeoutResponse | PayloadToLargeResponse | InternalServerErrorResponse | ResponseTimeoutResponse | ServerTimeoutErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createLambdaTask>>, TError,{data: LambdaTask}, TContext>, request?: SecondParameter<typeof lp5AxiosClient>}
): UseMutationOptions<Awaited<ReturnType<typeof createLambdaTask>>, TError,{data: LambdaTask}, TContext> => {

const mutationKey = ['createLambdaTask'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof createLambdaTask>>, {data: LambdaTask}> = (props) => {
          const {data} = props ?? {};

          return  createLambdaTask(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type CreateLambdaTaskMutationResult = NonNullable<Awaited<ReturnType<typeof createLambdaTask>>>
    export type CreateLambdaTaskMutationBody = LambdaTask
    export type CreateLambdaTaskMutationError = Error | AuthorizationErrorResponse | ForbiddenTasksErrorResponse | RequestTimeoutResponse | PayloadToLargeResponse | InternalServerErrorResponse | ResponseTimeoutResponse | ServerTimeoutErrorResponse

    /**
 * @summary lambda task
 */
export const useCreateLambdaTask = <TError = Error | AuthorizationErrorResponse | ForbiddenTasksErrorResponse | RequestTimeoutResponse | PayloadToLargeResponse | InternalServerErrorResponse | ResponseTimeoutResponse | ServerTimeoutErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createLambdaTask>>, TError,{data: LambdaTask}, TContext>, request?: SecondParameter<typeof lp5AxiosClient>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof createLambdaTask>>,
        TError,
        {data: LambdaTask},
        TContext
      > => {
      return useMutation(getCreateLambdaTaskMutationOptions(options), queryClient);
    }

/**
 * Get options for the resource.
 * @summary lambda task options
 */
export const getTaskLambdaOptions = (

 options?: SecondParameter<typeof lp5AxiosClient>,signal?: AbortSignal
) => {


      return lp5AxiosClient<void>(
      {url: `/6/tasks/lambda`, method: 'OPTIONS', signal
    },
      options);
    }




export const getGetTaskLambdaOptionsMutationOptions = <TError = RequestTimeoutResponse | InternalServerErrorResponse | ResponseTimeoutResponse | ServerTimeoutErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof getTaskLambdaOptions>>, TError,void, TContext>, request?: SecondParameter<typeof lp5AxiosClient>}
): UseMutationOptions<Awaited<ReturnType<typeof getTaskLambdaOptions>>, TError,void, TContext> => {

const mutationKey = ['getTaskLambdaOptions'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof getTaskLambdaOptions>>, void> = () => {


          return  getTaskLambdaOptions(requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type GetTaskLambdaOptionsMutationResult = NonNullable<Awaited<ReturnType<typeof getTaskLambdaOptions>>>

    export type GetTaskLambdaOptionsMutationError = RequestTimeoutResponse | InternalServerErrorResponse | ResponseTimeoutResponse | ServerTimeoutErrorResponse

    /**
 * @summary lambda task options
 */
export const useGetTaskLambdaOptions = <TError = RequestTimeoutResponse | InternalServerErrorResponse | ResponseTimeoutResponse | ServerTimeoutErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof getTaskLambdaOptions>>, TError,void, TContext>, request?: SecondParameter<typeof lp5AxiosClient>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof getTaskLambdaOptions>>,
        TError,
        void,
        TContext
      > => {
      return useMutation(getGetTaskLambdaOptionsMutationOptions(options), queryClient);
    }

/**
 * Get tasks according to the filters.
 * @summary get tasks
 */
export const getTasks = (
    params?: GetTasksParams,
 options?: SecondParameter<typeof lp5AxiosClient>,signal?: AbortSignal
) => {


      return lp5AxiosClient<TasksReply>(
      {url: `/6/tasks`, method: 'GET',
        params, signal
    },
      options);
    }




export const getGetTasksQueryKey = (params?: GetTasksParams,) => {
    return [
    `/6/tasks`, ...(params ? [params] : [])
    ] as const;
    }


export const getGetTasksQueryOptions = <TData = Awaited<ReturnType<typeof getTasks>>, TError = Error | AuthorizationErrorResponse | ForbiddenTasksErrorResponse | RequestTimeoutResponse | InternalServerErrorResponse | ResponseTimeoutResponse | ServerTimeoutErrorResponse>(params?: GetTasksParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getTasks>>, TError, TData>>, request?: SecondParameter<typeof lp5AxiosClient>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetTasksQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getTasks>>> = ({ signal }) => getTasks(params, requestOptions, signal);





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getTasks>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetTasksQueryResult = NonNullable<Awaited<ReturnType<typeof getTasks>>>
export type GetTasksQueryError = Error | AuthorizationErrorResponse | ForbiddenTasksErrorResponse | RequestTimeoutResponse | InternalServerErrorResponse | ResponseTimeoutResponse | ServerTimeoutErrorResponse


export function useGetTasks<TData = Awaited<ReturnType<typeof getTasks>>, TError = Error | AuthorizationErrorResponse | ForbiddenTasksErrorResponse | RequestTimeoutResponse | InternalServerErrorResponse | ResponseTimeoutResponse | ServerTimeoutErrorResponse>(
 params: undefined |  GetTasksParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getTasks>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getTasks>>,
          TError,
          Awaited<ReturnType<typeof getTasks>>
        > , 'initialData'
      >, request?: SecondParameter<typeof lp5AxiosClient>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetTasks<TData = Awaited<ReturnType<typeof getTasks>>, TError = Error | AuthorizationErrorResponse | ForbiddenTasksErrorResponse | RequestTimeoutResponse | InternalServerErrorResponse | ResponseTimeoutResponse | ServerTimeoutErrorResponse>(
 params?: GetTasksParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getTasks>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getTasks>>,
          TError,
          Awaited<ReturnType<typeof getTasks>>
        > , 'initialData'
      >, request?: SecondParameter<typeof lp5AxiosClient>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetTasks<TData = Awaited<ReturnType<typeof getTasks>>, TError = Error | AuthorizationErrorResponse | ForbiddenTasksErrorResponse | RequestTimeoutResponse | InternalServerErrorResponse | ResponseTimeoutResponse | ServerTimeoutErrorResponse>(
 params?: GetTasksParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getTasks>>, TError, TData>>, request?: SecondParameter<typeof lp5AxiosClient>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary get tasks
 */

export function useGetTasks<TData = Awaited<ReturnType<typeof getTasks>>, TError = Error | AuthorizationErrorResponse | ForbiddenTasksErrorResponse | RequestTimeoutResponse | InternalServerErrorResponse | ResponseTimeoutResponse | ServerTimeoutErrorResponse>(
 params?: GetTasksParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getTasks>>, TError, TData>>, request?: SecondParameter<typeof lp5AxiosClient>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetTasksQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}







/**
 * Get options for the resource.
 * @summary tasks options
 */
export const getTasksOptions = (

 options?: SecondParameter<typeof lp5AxiosClient>,signal?: AbortSignal
) => {


      return lp5AxiosClient<void>(
      {url: `/6/tasks`, method: 'OPTIONS', signal
    },
      options);
    }




export const getGetTasksOptionsMutationOptions = <TError = RequestTimeoutResponse | InternalServerErrorResponse | ResponseTimeoutResponse | ServerTimeoutErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof getTasksOptions>>, TError,void, TContext>, request?: SecondParameter<typeof lp5AxiosClient>}
): UseMutationOptions<Awaited<ReturnType<typeof getTasksOptions>>, TError,void, TContext> => {

const mutationKey = ['getTasksOptions'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof getTasksOptions>>, void> = () => {


          return  getTasksOptions(requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type GetTasksOptionsMutationResult = NonNullable<Awaited<ReturnType<typeof getTasksOptions>>>

    export type GetTasksOptionsMutationError = RequestTimeoutResponse | InternalServerErrorResponse | ResponseTimeoutResponse | ServerTimeoutErrorResponse

    /**
 * @summary tasks options
 */
export const useGetTasksOptions = <TError = RequestTimeoutResponse | InternalServerErrorResponse | ResponseTimeoutResponse | ServerTimeoutErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof getTasksOptions>>, TError,void, TContext>, request?: SecondParameter<typeof lp5AxiosClient>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof getTasksOptions>>,
        TError,
        void,
        TContext
      > => {
      return useMutation(getGetTasksOptionsMutationOptions(options), queryClient);
    }

/**
 * Count tasks according to the filters.
 * @summary get tasks count
 */
export const getTasksCount = (
    params?: GetTasksCountParams,
 options?: SecondParameter<typeof lp5AxiosClient>,signal?: AbortSignal
) => {


      return lp5AxiosClient<TaskCount>(
      {url: `/6/tasks/count`, method: 'GET',
        params, signal
    },
      options);
    }




export const getGetTasksCountQueryKey = (params?: GetTasksCountParams,) => {
    return [
    `/6/tasks/count`, ...(params ? [params] : [])
    ] as const;
    }


export const getGetTasksCountQueryOptions = <TData = Awaited<ReturnType<typeof getTasksCount>>, TError = Error | AuthorizationErrorResponse | ForbiddenTasksErrorResponse | RequestTimeoutResponse | InternalServerErrorResponse | ResponseTimeoutResponse | ServerTimeoutErrorResponse>(params?: GetTasksCountParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getTasksCount>>, TError, TData>>, request?: SecondParameter<typeof lp5AxiosClient>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetTasksCountQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getTasksCount>>> = ({ signal }) => getTasksCount(params, requestOptions, signal);





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getTasksCount>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetTasksCountQueryResult = NonNullable<Awaited<ReturnType<typeof getTasksCount>>>
export type GetTasksCountQueryError = Error | AuthorizationErrorResponse | ForbiddenTasksErrorResponse | RequestTimeoutResponse | InternalServerErrorResponse | ResponseTimeoutResponse | ServerTimeoutErrorResponse


export function useGetTasksCount<TData = Awaited<ReturnType<typeof getTasksCount>>, TError = Error | AuthorizationErrorResponse | ForbiddenTasksErrorResponse | RequestTimeoutResponse | InternalServerErrorResponse | ResponseTimeoutResponse | ServerTimeoutErrorResponse>(
 params: undefined |  GetTasksCountParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getTasksCount>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getTasksCount>>,
          TError,
          Awaited<ReturnType<typeof getTasksCount>>
        > , 'initialData'
      >, request?: SecondParameter<typeof lp5AxiosClient>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetTasksCount<TData = Awaited<ReturnType<typeof getTasksCount>>, TError = Error | AuthorizationErrorResponse | ForbiddenTasksErrorResponse | RequestTimeoutResponse | InternalServerErrorResponse | ResponseTimeoutResponse | ServerTimeoutErrorResponse>(
 params?: GetTasksCountParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getTasksCount>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getTasksCount>>,
          TError,
          Awaited<ReturnType<typeof getTasksCount>>
        > , 'initialData'
      >, request?: SecondParameter<typeof lp5AxiosClient>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetTasksCount<TData = Awaited<ReturnType<typeof getTasksCount>>, TError = Error | AuthorizationErrorResponse | ForbiddenTasksErrorResponse | RequestTimeoutResponse | InternalServerErrorResponse | ResponseTimeoutResponse | ServerTimeoutErrorResponse>(
 params?: GetTasksCountParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getTasksCount>>, TError, TData>>, request?: SecondParameter<typeof lp5AxiosClient>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary get tasks count
 */

export function useGetTasksCount<TData = Awaited<ReturnType<typeof getTasksCount>>, TError = Error | AuthorizationErrorResponse | ForbiddenTasksErrorResponse | RequestTimeoutResponse | InternalServerErrorResponse | ResponseTimeoutResponse | ServerTimeoutErrorResponse>(
 params?: GetTasksCountParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getTasksCount>>, TError, TData>>, request?: SecondParameter<typeof lp5AxiosClient>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetTasksCountQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}







/**
 * Get options for the resource.
 * @summary tasks count options
 */
export const getTasksCountOptions = (

 options?: SecondParameter<typeof lp5AxiosClient>,signal?: AbortSignal
) => {


      return lp5AxiosClient<void>(
      {url: `/6/tasks/count`, method: 'OPTIONS', signal
    },
      options);
    }




export const getGetTasksCountOptionsMutationOptions = <TError = RequestTimeoutResponse | InternalServerErrorResponse | ResponseTimeoutResponse | ServerTimeoutErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof getTasksCountOptions>>, TError,void, TContext>, request?: SecondParameter<typeof lp5AxiosClient>}
): UseMutationOptions<Awaited<ReturnType<typeof getTasksCountOptions>>, TError,void, TContext> => {

const mutationKey = ['getTasksCountOptions'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof getTasksCountOptions>>, void> = () => {


          return  getTasksCountOptions(requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type GetTasksCountOptionsMutationResult = NonNullable<Awaited<ReturnType<typeof getTasksCountOptions>>>

    export type GetTasksCountOptionsMutationError = RequestTimeoutResponse | InternalServerErrorResponse | ResponseTimeoutResponse | ServerTimeoutErrorResponse

    /**
 * @summary tasks count options
 */
export const useGetTasksCountOptions = <TError = RequestTimeoutResponse | InternalServerErrorResponse | ResponseTimeoutResponse | ServerTimeoutErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof getTasksCountOptions>>, TError,void, TContext>, request?: SecondParameter<typeof lp5AxiosClient>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof getTasksCountOptions>>,
        TError,
        void,
        TContext
      > => {
      return useMutation(getGetTasksCountOptionsMutationOptions(options), queryClient);
    }

/**
 * Get task by ID.
 * @summary get task
 */
export const getTask = (
    taskId: number,
 options?: SecondParameter<typeof lp5AxiosClient>,signal?: AbortSignal
) => {


      return lp5AxiosClient<TaskReply>(
      {url: `/6/tasks/${taskId}`, method: 'GET', signal
    },
      options);
    }




export const getGetTaskQueryKey = (taskId: number,) => {
    return [
    `/6/tasks/${taskId}`
    ] as const;
    }


export const getGetTaskQueryOptions = <TData = Awaited<ReturnType<typeof getTask>>, TError = Error | AuthorizationErrorResponse | ForbiddenTasksErrorResponse | RequestTimeoutResponse | InternalServerErrorResponse | ResponseTimeoutResponse | ServerTimeoutErrorResponse>(taskId: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getTask>>, TError, TData>>, request?: SecondParameter<typeof lp5AxiosClient>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetTaskQueryKey(taskId);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getTask>>> = ({ signal }) => getTask(taskId, requestOptions, signal);





   return  { queryKey, queryFn, enabled: taskId !== null && taskId !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getTask>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetTaskQueryResult = NonNullable<Awaited<ReturnType<typeof getTask>>>
export type GetTaskQueryError = Error | AuthorizationErrorResponse | ForbiddenTasksErrorResponse | RequestTimeoutResponse | InternalServerErrorResponse | ResponseTimeoutResponse | ServerTimeoutErrorResponse


export function useGetTask<TData = Awaited<ReturnType<typeof getTask>>, TError = Error | AuthorizationErrorResponse | ForbiddenTasksErrorResponse | RequestTimeoutResponse | InternalServerErrorResponse | ResponseTimeoutResponse | ServerTimeoutErrorResponse>(
 taskId: number, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getTask>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getTask>>,
          TError,
          Awaited<ReturnType<typeof getTask>>
        > , 'initialData'
      >, request?: SecondParameter<typeof lp5AxiosClient>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetTask<TData = Awaited<ReturnType<typeof getTask>>, TError = Error | AuthorizationErrorResponse | ForbiddenTasksErrorResponse | RequestTimeoutResponse | InternalServerErrorResponse | ResponseTimeoutResponse | ServerTimeoutErrorResponse>(
 taskId: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getTask>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getTask>>,
          TError,
          Awaited<ReturnType<typeof getTask>>
        > , 'initialData'
      >, request?: SecondParameter<typeof lp5AxiosClient>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetTask<TData = Awaited<ReturnType<typeof getTask>>, TError = Error | AuthorizationErrorResponse | ForbiddenTasksErrorResponse | RequestTimeoutResponse | InternalServerErrorResponse | ResponseTimeoutResponse | ServerTimeoutErrorResponse>(
 taskId: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getTask>>, TError, TData>>, request?: SecondParameter<typeof lp5AxiosClient>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary get task
 */

export function useGetTask<TData = Awaited<ReturnType<typeof getTask>>, TError = Error | AuthorizationErrorResponse | ForbiddenTasksErrorResponse | RequestTimeoutResponse | InternalServerErrorResponse | ResponseTimeoutResponse | ServerTimeoutErrorResponse>(
 taskId: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getTask>>, TError, TData>>, request?: SecondParameter<typeof lp5AxiosClient>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetTaskQueryOptions(taskId,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}







/**
 * Cancel task by ID.
 * @summary cancel task
 */
export const cancelTask = (
    taskId: number,
 options?: SecondParameter<typeof lp5AxiosClient>,signal?: AbortSignal
) => {


      return lp5AxiosClient<void>(
      {url: `/6/tasks/${taskId}`, method: 'PATCH', signal
    },
      options);
    }




export const getCancelTaskMutationOptions = <TError = Error | AuthorizationErrorResponse | ForbiddenErrorResponse | RequestTimeoutResponse | InternalServerErrorResponse | ResponseTimeoutResponse | ServerTimeoutErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof cancelTask>>, TError,{taskId: number}, TContext>, request?: SecondParameter<typeof lp5AxiosClient>}
): UseMutationOptions<Awaited<ReturnType<typeof cancelTask>>, TError,{taskId: number}, TContext> => {

const mutationKey = ['cancelTask'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof cancelTask>>, {taskId: number}> = (props) => {
          const {taskId} = props ?? {};

          return  cancelTask(taskId,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type CancelTaskMutationResult = NonNullable<Awaited<ReturnType<typeof cancelTask>>>

    export type CancelTaskMutationError = Error | AuthorizationErrorResponse | ForbiddenErrorResponse | RequestTimeoutResponse | InternalServerErrorResponse | ResponseTimeoutResponse | ServerTimeoutErrorResponse

    /**
 * @summary cancel task
 */
export const useCancelTask = <TError = Error | AuthorizationErrorResponse | ForbiddenErrorResponse | RequestTimeoutResponse | InternalServerErrorResponse | ResponseTimeoutResponse | ServerTimeoutErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof cancelTask>>, TError,{taskId: number}, TContext>, request?: SecondParameter<typeof lp5AxiosClient>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof cancelTask>>,
        TError,
        {taskId: number},
        TContext
      > => {
      return useMutation(getCancelTaskMutationOptions(options), queryClient);
    }

/**
 * Delete a task and the task results by the task ID.
 * @summary delete task
 */
export const deleteTask = (
    taskId: number,
 options?: SecondParameter<typeof lp5AxiosClient>,signal?: AbortSignal
) => {


      return lp5AxiosClient<void>(
      {url: `/6/tasks/${taskId}`, method: 'DELETE', signal
    },
      options);
    }




export const getDeleteTaskMutationOptions = <TError = Error | AuthorizationErrorResponse | ForbiddenErrorResponse | RequestTimeoutResponse | InternalServerErrorResponse | ResponseTimeoutResponse | ServerTimeoutErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteTask>>, TError,{taskId: number}, TContext>, request?: SecondParameter<typeof lp5AxiosClient>}
): UseMutationOptions<Awaited<ReturnType<typeof deleteTask>>, TError,{taskId: number}, TContext> => {

const mutationKey = ['deleteTask'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof deleteTask>>, {taskId: number}> = (props) => {
          const {taskId} = props ?? {};

          return  deleteTask(taskId,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type DeleteTaskMutationResult = NonNullable<Awaited<ReturnType<typeof deleteTask>>>

    export type DeleteTaskMutationError = Error | AuthorizationErrorResponse | ForbiddenErrorResponse | RequestTimeoutResponse | InternalServerErrorResponse | ResponseTimeoutResponse | ServerTimeoutErrorResponse

    /**
 * @summary delete task
 */
export const useDeleteTask = <TError = Error | AuthorizationErrorResponse | ForbiddenErrorResponse | RequestTimeoutResponse | InternalServerErrorResponse | ResponseTimeoutResponse | ServerTimeoutErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteTask>>, TError,{taskId: number}, TContext>, request?: SecondParameter<typeof lp5AxiosClient>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof deleteTask>>,
        TError,
        {taskId: number},
        TContext
      > => {
      return useMutation(getDeleteTaskMutationOptions(options), queryClient);
    }

/**
 * Get options for the resource.
 * @summary task options
 */
export const getTaskOptions = (
    taskId: number,
 options?: SecondParameter<typeof lp5AxiosClient>,signal?: AbortSignal
) => {


      return lp5AxiosClient<void>(
      {url: `/6/tasks/${taskId}`, method: 'OPTIONS', signal
    },
      options);
    }




export const getGetTaskOptionsMutationOptions = <TError = RequestTimeoutResponse | InternalServerErrorResponse | ResponseTimeoutResponse | ServerTimeoutErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof getTaskOptions>>, TError,{taskId: number}, TContext>, request?: SecondParameter<typeof lp5AxiosClient>}
): UseMutationOptions<Awaited<ReturnType<typeof getTaskOptions>>, TError,{taskId: number}, TContext> => {

const mutationKey = ['getTaskOptions'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof getTaskOptions>>, {taskId: number}> = (props) => {
          const {taskId} = props ?? {};

          return  getTaskOptions(taskId,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type GetTaskOptionsMutationResult = NonNullable<Awaited<ReturnType<typeof getTaskOptions>>>

    export type GetTaskOptionsMutationError = RequestTimeoutResponse | InternalServerErrorResponse | ResponseTimeoutResponse | ServerTimeoutErrorResponse

    /**
 * @summary task options
 */
export const useGetTaskOptions = <TError = RequestTimeoutResponse | InternalServerErrorResponse | ResponseTimeoutResponse | ServerTimeoutErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof getTaskOptions>>, TError,{taskId: number}, TContext>, request?: SecondParameter<typeof lp5AxiosClient>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof getTaskOptions>>,
        TError,
        {taskId: number},
        TContext
      > => {
      return useMutation(getGetTaskOptionsMutationOptions(options), queryClient);
    }

/**
 * Get task notification policy by task ID.
 * @summary get task notification policy
 */
export const getTaskNotificationPolicy = (
    taskId: number,
    params?: GetTaskNotificationPolicyParams,
 options?: SecondParameter<typeof lp5AxiosClient>,signal?: AbortSignal
) => {


      return lp5AxiosClient<TaskNotificationPolicyResponse>(
      {url: `/6/tasks/${taskId}/notification_policy`, method: 'GET',
        params, signal
    },
      options);
    }




export const getGetTaskNotificationPolicyQueryKey = (taskId: number,
    params?: GetTaskNotificationPolicyParams,) => {
    return [
    `/6/tasks/${taskId}/notification_policy`, ...(params ? [params] : [])
    ] as const;
    }


export const getGetTaskNotificationPolicyQueryOptions = <TData = Awaited<ReturnType<typeof getTaskNotificationPolicy>>, TError = Error | AuthorizationErrorResponse | ForbiddenErrorResponse | RequestTimeoutResponse | InternalServerErrorResponse | ResponseTimeoutResponse | ServerTimeoutErrorResponse>(taskId: number,
    params?: GetTaskNotificationPolicyParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getTaskNotificationPolicy>>, TError, TData>>, request?: SecondParameter<typeof lp5AxiosClient>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetTaskNotificationPolicyQueryKey(taskId,params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getTaskNotificationPolicy>>> = ({ signal }) => getTaskNotificationPolicy(taskId,params, requestOptions, signal);





   return  { queryKey, queryFn, enabled: taskId !== null && taskId !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getTaskNotificationPolicy>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetTaskNotificationPolicyQueryResult = NonNullable<Awaited<ReturnType<typeof getTaskNotificationPolicy>>>
export type GetTaskNotificationPolicyQueryError = Error | AuthorizationErrorResponse | ForbiddenErrorResponse | RequestTimeoutResponse | InternalServerErrorResponse | ResponseTimeoutResponse | ServerTimeoutErrorResponse


export function useGetTaskNotificationPolicy<TData = Awaited<ReturnType<typeof getTaskNotificationPolicy>>, TError = Error | AuthorizationErrorResponse | ForbiddenErrorResponse | RequestTimeoutResponse | InternalServerErrorResponse | ResponseTimeoutResponse | ServerTimeoutErrorResponse>(
 taskId: number,
    params: undefined |  GetTaskNotificationPolicyParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getTaskNotificationPolicy>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getTaskNotificationPolicy>>,
          TError,
          Awaited<ReturnType<typeof getTaskNotificationPolicy>>
        > , 'initialData'
      >, request?: SecondParameter<typeof lp5AxiosClient>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetTaskNotificationPolicy<TData = Awaited<ReturnType<typeof getTaskNotificationPolicy>>, TError = Error | AuthorizationErrorResponse | ForbiddenErrorResponse | RequestTimeoutResponse | InternalServerErrorResponse | ResponseTimeoutResponse | ServerTimeoutErrorResponse>(
 taskId: number,
    params?: GetTaskNotificationPolicyParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getTaskNotificationPolicy>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getTaskNotificationPolicy>>,
          TError,
          Awaited<ReturnType<typeof getTaskNotificationPolicy>>
        > , 'initialData'
      >, request?: SecondParameter<typeof lp5AxiosClient>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetTaskNotificationPolicy<TData = Awaited<ReturnType<typeof getTaskNotificationPolicy>>, TError = Error | AuthorizationErrorResponse | ForbiddenErrorResponse | RequestTimeoutResponse | InternalServerErrorResponse | ResponseTimeoutResponse | ServerTimeoutErrorResponse>(
 taskId: number,
    params?: GetTaskNotificationPolicyParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getTaskNotificationPolicy>>, TError, TData>>, request?: SecondParameter<typeof lp5AxiosClient>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary get task notification policy
 */

export function useGetTaskNotificationPolicy<TData = Awaited<ReturnType<typeof getTaskNotificationPolicy>>, TError = Error | AuthorizationErrorResponse | ForbiddenErrorResponse | RequestTimeoutResponse | InternalServerErrorResponse | ResponseTimeoutResponse | ServerTimeoutErrorResponse>(
 taskId: number,
    params?: GetTaskNotificationPolicyParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getTaskNotificationPolicy>>, TError, TData>>, request?: SecondParameter<typeof lp5AxiosClient>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetTaskNotificationPolicyQueryOptions(taskId,params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}







/**
 * Replace task notification policy by task ID.
 * @summary replace task notification policy
 */
export const putTaskNotificationPolicy = (
    taskId: number,
    notificationPolicy: NotificationPolicy,
 options?: SecondParameter<typeof lp5AxiosClient>,signal?: AbortSignal
) => {


      return lp5AxiosClient<void>(
      {url: `/6/tasks/${taskId}/notification_policy`, method: 'PUT',
      headers: {'Content-Type': 'application/json', },
      data: notificationPolicy, signal
    },
      options);
    }




export const getPutTaskNotificationPolicyMutationOptions = <TError = Error | AuthorizationErrorResponse | ForbiddenErrorResponse | RequestTimeoutResponse | PayloadToLargeResponse | InternalServerErrorResponse | ResponseTimeoutResponse | ServerTimeoutErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof putTaskNotificationPolicy>>, TError,{taskId: number;data: NotificationPolicy}, TContext>, request?: SecondParameter<typeof lp5AxiosClient>}
): UseMutationOptions<Awaited<ReturnType<typeof putTaskNotificationPolicy>>, TError,{taskId: number;data: NotificationPolicy}, TContext> => {

const mutationKey = ['putTaskNotificationPolicy'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof putTaskNotificationPolicy>>, {taskId: number;data: NotificationPolicy}> = (props) => {
          const {taskId,data} = props ?? {};

          return  putTaskNotificationPolicy(taskId,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type PutTaskNotificationPolicyMutationResult = NonNullable<Awaited<ReturnType<typeof putTaskNotificationPolicy>>>
    export type PutTaskNotificationPolicyMutationBody = NotificationPolicy
    export type PutTaskNotificationPolicyMutationError = Error | AuthorizationErrorResponse | ForbiddenErrorResponse | RequestTimeoutResponse | PayloadToLargeResponse | InternalServerErrorResponse | ResponseTimeoutResponse | ServerTimeoutErrorResponse

    /**
 * @summary replace task notification policy
 */
export const usePutTaskNotificationPolicy = <TError = Error | AuthorizationErrorResponse | ForbiddenErrorResponse | RequestTimeoutResponse | PayloadToLargeResponse | InternalServerErrorResponse | ResponseTimeoutResponse | ServerTimeoutErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof putTaskNotificationPolicy>>, TError,{taskId: number;data: NotificationPolicy}, TContext>, request?: SecondParameter<typeof lp5AxiosClient>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof putTaskNotificationPolicy>>,
        TError,
        {taskId: number;data: NotificationPolicy},
        TContext
      > => {
      return useMutation(getPutTaskNotificationPolicyMutationOptions(options), queryClient);
    }

/**
 * Get options for the resource.
 * @summary tasks notification policy options
 */
export const getTaskNotificationPolicyOptions = (
    taskId: number,
 options?: SecondParameter<typeof lp5AxiosClient>,signal?: AbortSignal
) => {


      return lp5AxiosClient<void>(
      {url: `/6/tasks/${taskId}/notification_policy`, method: 'OPTIONS', signal
    },
      options);
    }




export const getGetTaskNotificationPolicyOptionsMutationOptions = <TError = RequestTimeoutResponse | InternalServerErrorResponse | ResponseTimeoutResponse | ServerTimeoutErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof getTaskNotificationPolicyOptions>>, TError,{taskId: number}, TContext>, request?: SecondParameter<typeof lp5AxiosClient>}
): UseMutationOptions<Awaited<ReturnType<typeof getTaskNotificationPolicyOptions>>, TError,{taskId: number}, TContext> => {

const mutationKey = ['getTaskNotificationPolicyOptions'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof getTaskNotificationPolicyOptions>>, {taskId: number}> = (props) => {
          const {taskId} = props ?? {};

          return  getTaskNotificationPolicyOptions(taskId,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type GetTaskNotificationPolicyOptionsMutationResult = NonNullable<Awaited<ReturnType<typeof getTaskNotificationPolicyOptions>>>

    export type GetTaskNotificationPolicyOptionsMutationError = RequestTimeoutResponse | InternalServerErrorResponse | ResponseTimeoutResponse | ServerTimeoutErrorResponse

    /**
 * @summary tasks notification policy options
 */
export const useGetTaskNotificationPolicyOptions = <TError = RequestTimeoutResponse | InternalServerErrorResponse | ResponseTimeoutResponse | ServerTimeoutErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof getTaskNotificationPolicyOptions>>, TError,{taskId: number}, TContext>, request?: SecondParameter<typeof lp5AxiosClient>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof getTaskNotificationPolicyOptions>>,
        TError,
        {taskId: number},
        TContext
      > => {
      return useMutation(getGetTaskNotificationPolicyOptionsMutationOptions(options), queryClient);
    }

/**
 * Get task result by the task ID.
 *
 * In addition to the result of the task, the occurred errors can be returned in the response.
 * @summary get task result
 */
export const getTaskResult = (
    taskId: number,
 options?: SecondParameter<typeof lp5AxiosClient>,signal?: AbortSignal
) => {


      return lp5AxiosClient<TaskResults | Blob>(
      {url: `/6/tasks/${taskId}/result`, method: 'GET',
        responseType: 'blob', signal
    },
      options);
    }




export const getGetTaskResultQueryKey = (taskId: number,) => {
    return [
    `/6/tasks/${taskId}/result`
    ] as const;
    }


export const getGetTaskResultQueryOptions = <TData = Awaited<ReturnType<typeof getTaskResult>>, TError = AuthorizationErrorResponse | ForbiddenErrorWithLisResponse | Error | RequestTimeoutResponse | InternalServerErrorResponse | ResponseTimeoutResponse | ServerTimeoutErrorResponse>(taskId: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getTaskResult>>, TError, TData>>, request?: SecondParameter<typeof lp5AxiosClient>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetTaskResultQueryKey(taskId);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getTaskResult>>> = ({ signal }) => getTaskResult(taskId, requestOptions, signal);





   return  { queryKey, queryFn, enabled: taskId !== null && taskId !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getTaskResult>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetTaskResultQueryResult = NonNullable<Awaited<ReturnType<typeof getTaskResult>>>
export type GetTaskResultQueryError = AuthorizationErrorResponse | ForbiddenErrorWithLisResponse | Error | RequestTimeoutResponse | InternalServerErrorResponse | ResponseTimeoutResponse | ServerTimeoutErrorResponse


export function useGetTaskResult<TData = Awaited<ReturnType<typeof getTaskResult>>, TError = AuthorizationErrorResponse | ForbiddenErrorWithLisResponse | Error | RequestTimeoutResponse | InternalServerErrorResponse | ResponseTimeoutResponse | ServerTimeoutErrorResponse>(
 taskId: number, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getTaskResult>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getTaskResult>>,
          TError,
          Awaited<ReturnType<typeof getTaskResult>>
        > , 'initialData'
      >, request?: SecondParameter<typeof lp5AxiosClient>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetTaskResult<TData = Awaited<ReturnType<typeof getTaskResult>>, TError = AuthorizationErrorResponse | ForbiddenErrorWithLisResponse | Error | RequestTimeoutResponse | InternalServerErrorResponse | ResponseTimeoutResponse | ServerTimeoutErrorResponse>(
 taskId: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getTaskResult>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getTaskResult>>,
          TError,
          Awaited<ReturnType<typeof getTaskResult>>
        > , 'initialData'
      >, request?: SecondParameter<typeof lp5AxiosClient>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetTaskResult<TData = Awaited<ReturnType<typeof getTaskResult>>, TError = AuthorizationErrorResponse | ForbiddenErrorWithLisResponse | Error | RequestTimeoutResponse | InternalServerErrorResponse | ResponseTimeoutResponse | ServerTimeoutErrorResponse>(
 taskId: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getTaskResult>>, TError, TData>>, request?: SecondParameter<typeof lp5AxiosClient>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary get task result
 */

export function useGetTaskResult<TData = Awaited<ReturnType<typeof getTaskResult>>, TError = AuthorizationErrorResponse | ForbiddenErrorWithLisResponse | Error | RequestTimeoutResponse | InternalServerErrorResponse | ResponseTimeoutResponse | ServerTimeoutErrorResponse>(
 taskId: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getTaskResult>>, TError, TData>>, request?: SecondParameter<typeof lp5AxiosClient>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetTaskResultQueryOptions(taskId,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}







/**
 * Get options for the resource.
 * @summary task result options
 */
export const getTaskResultOptions = (
    taskId: number,
 options?: SecondParameter<typeof lp5AxiosClient>,signal?: AbortSignal
) => {


      return lp5AxiosClient<void>(
      {url: `/6/tasks/${taskId}/result`, method: 'OPTIONS', signal
    },
      options);
    }




export const getGetTaskResultOptionsMutationOptions = <TError = RequestTimeoutResponse | InternalServerErrorResponse | ResponseTimeoutResponse | ServerTimeoutErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof getTaskResultOptions>>, TError,{taskId: number}, TContext>, request?: SecondParameter<typeof lp5AxiosClient>}
): UseMutationOptions<Awaited<ReturnType<typeof getTaskResultOptions>>, TError,{taskId: number}, TContext> => {

const mutationKey = ['getTaskResultOptions'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof getTaskResultOptions>>, {taskId: number}> = (props) => {
          const {taskId} = props ?? {};

          return  getTaskResultOptions(taskId,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type GetTaskResultOptionsMutationResult = NonNullable<Awaited<ReturnType<typeof getTaskResultOptions>>>

    export type GetTaskResultOptionsMutationError = RequestTimeoutResponse | InternalServerErrorResponse | ResponseTimeoutResponse | ServerTimeoutErrorResponse

    /**
 * @summary task result options
 */
export const useGetTaskResultOptions = <TError = RequestTimeoutResponse | InternalServerErrorResponse | ResponseTimeoutResponse | ServerTimeoutErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof getTaskResultOptions>>, TError,{taskId: number}, TContext>, request?: SecondParameter<typeof lp5AxiosClient>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof getTaskResultOptions>>,
        TError,
        {taskId: number},
        TContext
      > => {
      return useMutation(getGetTaskResultOptionsMutationOptions(options), queryClient);
    }

/**
 * Get subtasks of a task by ID.
 * @summary get subtasks
 */
export const getSubTasks = (
    taskId: number,
    params?: GetSubTasksParams,
 options?: SecondParameter<typeof lp5AxiosClient>,signal?: AbortSignal
) => {


      return lp5AxiosClient<SubTasks>(
      {url: `/6/tasks/${taskId}/subtasks`, method: 'GET',
        params, signal
    },
      options);
    }




export const getGetSubTasksQueryKey = (taskId: number,
    params?: GetSubTasksParams,) => {
    return [
    `/6/tasks/${taskId}/subtasks`, ...(params ? [params] : [])
    ] as const;
    }


export const getGetSubTasksQueryOptions = <TData = Awaited<ReturnType<typeof getSubTasks>>, TError = Error | AuthorizationErrorResponse | ForbiddenTasksErrorResponse | RequestTimeoutResponse | InternalServerErrorResponse | ResponseTimeoutResponse | ServerTimeoutErrorResponse>(taskId: number,
    params?: GetSubTasksParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getSubTasks>>, TError, TData>>, request?: SecondParameter<typeof lp5AxiosClient>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetSubTasksQueryKey(taskId,params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getSubTasks>>> = ({ signal }) => getSubTasks(taskId,params, requestOptions, signal);





   return  { queryKey, queryFn, enabled: taskId !== null && taskId !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getSubTasks>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetSubTasksQueryResult = NonNullable<Awaited<ReturnType<typeof getSubTasks>>>
export type GetSubTasksQueryError = Error | AuthorizationErrorResponse | ForbiddenTasksErrorResponse | RequestTimeoutResponse | InternalServerErrorResponse | ResponseTimeoutResponse | ServerTimeoutErrorResponse


export function useGetSubTasks<TData = Awaited<ReturnType<typeof getSubTasks>>, TError = Error | AuthorizationErrorResponse | ForbiddenTasksErrorResponse | RequestTimeoutResponse | InternalServerErrorResponse | ResponseTimeoutResponse | ServerTimeoutErrorResponse>(
 taskId: number,
    params: undefined |  GetSubTasksParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getSubTasks>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getSubTasks>>,
          TError,
          Awaited<ReturnType<typeof getSubTasks>>
        > , 'initialData'
      >, request?: SecondParameter<typeof lp5AxiosClient>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetSubTasks<TData = Awaited<ReturnType<typeof getSubTasks>>, TError = Error | AuthorizationErrorResponse | ForbiddenTasksErrorResponse | RequestTimeoutResponse | InternalServerErrorResponse | ResponseTimeoutResponse | ServerTimeoutErrorResponse>(
 taskId: number,
    params?: GetSubTasksParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getSubTasks>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getSubTasks>>,
          TError,
          Awaited<ReturnType<typeof getSubTasks>>
        > , 'initialData'
      >, request?: SecondParameter<typeof lp5AxiosClient>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetSubTasks<TData = Awaited<ReturnType<typeof getSubTasks>>, TError = Error | AuthorizationErrorResponse | ForbiddenTasksErrorResponse | RequestTimeoutResponse | InternalServerErrorResponse | ResponseTimeoutResponse | ServerTimeoutErrorResponse>(
 taskId: number,
    params?: GetSubTasksParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getSubTasks>>, TError, TData>>, request?: SecondParameter<typeof lp5AxiosClient>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary get subtasks
 */

export function useGetSubTasks<TData = Awaited<ReturnType<typeof getSubTasks>>, TError = Error | AuthorizationErrorResponse | ForbiddenTasksErrorResponse | RequestTimeoutResponse | InternalServerErrorResponse | ResponseTimeoutResponse | ServerTimeoutErrorResponse>(
 taskId: number,
    params?: GetSubTasksParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getSubTasks>>, TError, TData>>, request?: SecondParameter<typeof lp5AxiosClient>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetSubTasksQueryOptions(taskId,params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}







/**
 * Get options for the resource.
 * @summary subtasks options
 */
export const getSubTasksOptions = (
    taskId: number,
 options?: SecondParameter<typeof lp5AxiosClient>,signal?: AbortSignal
) => {


      return lp5AxiosClient<void>(
      {url: `/6/tasks/${taskId}/subtasks`, method: 'OPTIONS', signal
    },
      options);
    }




export const getGetSubTasksOptionsMutationOptions = <TError = RequestTimeoutResponse | InternalServerErrorResponse | ResponseTimeoutResponse | ServerTimeoutErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof getSubTasksOptions>>, TError,{taskId: number}, TContext>, request?: SecondParameter<typeof lp5AxiosClient>}
): UseMutationOptions<Awaited<ReturnType<typeof getSubTasksOptions>>, TError,{taskId: number}, TContext> => {

const mutationKey = ['getSubTasksOptions'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof getSubTasksOptions>>, {taskId: number}> = (props) => {
          const {taskId} = props ?? {};

          return  getSubTasksOptions(taskId,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type GetSubTasksOptionsMutationResult = NonNullable<Awaited<ReturnType<typeof getSubTasksOptions>>>

    export type GetSubTasksOptionsMutationError = RequestTimeoutResponse | InternalServerErrorResponse | ResponseTimeoutResponse | ServerTimeoutErrorResponse

    /**
 * @summary subtasks options
 */
export const useGetSubTasksOptions = <TError = RequestTimeoutResponse | InternalServerErrorResponse | ResponseTimeoutResponse | ServerTimeoutErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof getSubTasksOptions>>, TError,{taskId: number}, TContext>, request?: SecondParameter<typeof lp5AxiosClient>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof getSubTasksOptions>>,
        TError,
        {taskId: number},
        TContext
      > => {
      return useMutation(getGetSubTasksOptionsMutationOptions(options), queryClient);
    }

/**
 * Get errors of a task by the task ID.
 * @summary get task errors
 */
export const getErrors = (
    taskId: number,
    params?: GetErrorsParams,
 options?: SecondParameter<typeof lp5AxiosClient>,signal?: AbortSignal
) => {


      return lp5AxiosClient<TaskErrors>(
      {url: `/6/tasks/${taskId}/errors`, method: 'GET',
        params, signal
    },
      options);
    }




export const getGetErrorsQueryKey = (taskId: number,
    params?: GetErrorsParams,) => {
    return [
    `/6/tasks/${taskId}/errors`, ...(params ? [params] : [])
    ] as const;
    }


export const getGetErrorsQueryOptions = <TData = Awaited<ReturnType<typeof getErrors>>, TError = Error | AuthorizationErrorResponse | ForbiddenTasksErrorResponse | RequestTimeoutResponse | InternalServerErrorResponse | ResponseTimeoutResponse | ServerTimeoutErrorResponse>(taskId: number,
    params?: GetErrorsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getErrors>>, TError, TData>>, request?: SecondParameter<typeof lp5AxiosClient>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetErrorsQueryKey(taskId,params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getErrors>>> = ({ signal }) => getErrors(taskId,params, requestOptions, signal);





   return  { queryKey, queryFn, enabled: taskId !== null && taskId !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getErrors>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetErrorsQueryResult = NonNullable<Awaited<ReturnType<typeof getErrors>>>
export type GetErrorsQueryError = Error | AuthorizationErrorResponse | ForbiddenTasksErrorResponse | RequestTimeoutResponse | InternalServerErrorResponse | ResponseTimeoutResponse | ServerTimeoutErrorResponse


export function useGetErrors<TData = Awaited<ReturnType<typeof getErrors>>, TError = Error | AuthorizationErrorResponse | ForbiddenTasksErrorResponse | RequestTimeoutResponse | InternalServerErrorResponse | ResponseTimeoutResponse | ServerTimeoutErrorResponse>(
 taskId: number,
    params: undefined |  GetErrorsParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getErrors>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getErrors>>,
          TError,
          Awaited<ReturnType<typeof getErrors>>
        > , 'initialData'
      >, request?: SecondParameter<typeof lp5AxiosClient>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetErrors<TData = Awaited<ReturnType<typeof getErrors>>, TError = Error | AuthorizationErrorResponse | ForbiddenTasksErrorResponse | RequestTimeoutResponse | InternalServerErrorResponse | ResponseTimeoutResponse | ServerTimeoutErrorResponse>(
 taskId: number,
    params?: GetErrorsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getErrors>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getErrors>>,
          TError,
          Awaited<ReturnType<typeof getErrors>>
        > , 'initialData'
      >, request?: SecondParameter<typeof lp5AxiosClient>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetErrors<TData = Awaited<ReturnType<typeof getErrors>>, TError = Error | AuthorizationErrorResponse | ForbiddenTasksErrorResponse | RequestTimeoutResponse | InternalServerErrorResponse | ResponseTimeoutResponse | ServerTimeoutErrorResponse>(
 taskId: number,
    params?: GetErrorsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getErrors>>, TError, TData>>, request?: SecondParameter<typeof lp5AxiosClient>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary get task errors
 */

export function useGetErrors<TData = Awaited<ReturnType<typeof getErrors>>, TError = Error | AuthorizationErrorResponse | ForbiddenTasksErrorResponse | RequestTimeoutResponse | InternalServerErrorResponse | ResponseTimeoutResponse | ServerTimeoutErrorResponse>(
 taskId: number,
    params?: GetErrorsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getErrors>>, TError, TData>>, request?: SecondParameter<typeof lp5AxiosClient>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetErrorsQueryOptions(taskId,params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}







/**
 * Get options for the resource.
 * @summary task errors options
 */
export const getTaskErrorsOptions = (
    taskId: number,
 options?: SecondParameter<typeof lp5AxiosClient>,signal?: AbortSignal
) => {


      return lp5AxiosClient<void>(
      {url: `/6/tasks/${taskId}/errors`, method: 'OPTIONS', signal
    },
      options);
    }




export const getGetTaskErrorsOptionsMutationOptions = <TError = RequestTimeoutResponse | InternalServerErrorResponse | ResponseTimeoutResponse | ServerTimeoutErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof getTaskErrorsOptions>>, TError,{taskId: number}, TContext>, request?: SecondParameter<typeof lp5AxiosClient>}
): UseMutationOptions<Awaited<ReturnType<typeof getTaskErrorsOptions>>, TError,{taskId: number}, TContext> => {

const mutationKey = ['getTaskErrorsOptions'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof getTaskErrorsOptions>>, {taskId: number}> = (props) => {
          const {taskId} = props ?? {};

          return  getTaskErrorsOptions(taskId,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type GetTaskErrorsOptionsMutationResult = NonNullable<Awaited<ReturnType<typeof getTaskErrorsOptions>>>

    export type GetTaskErrorsOptionsMutationError = RequestTimeoutResponse | InternalServerErrorResponse | ResponseTimeoutResponse | ServerTimeoutErrorResponse

    /**
 * @summary task errors options
 */
export const useGetTaskErrorsOptions = <TError = RequestTimeoutResponse | InternalServerErrorResponse | ResponseTimeoutResponse | ServerTimeoutErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof getTaskErrorsOptions>>, TError,{taskId: number}, TContext>, request?: SecondParameter<typeof lp5AxiosClient>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof getTaskErrorsOptions>>,
        TError,
        {taskId: number},
        TContext
      > => {
      return useMutation(getGetTaskErrorsOptionsMutationOptions(options), queryClient);
    }

/**
 * Get errors according to the filters.
 * @summary get errors
 */
export const getTasksErrors = (
    params?: GetTasksErrorsParams,
 options?: SecondParameter<typeof lp5AxiosClient>,signal?: AbortSignal
) => {


      return lp5AxiosClient<TaskErrors>(
      {url: `/6/tasks/errors`, method: 'GET',
        params, signal
    },
      options);
    }




export const getGetTasksErrorsQueryKey = (params?: GetTasksErrorsParams,) => {
    return [
    `/6/tasks/errors`, ...(params ? [params] : [])
    ] as const;
    }


export const getGetTasksErrorsQueryOptions = <TData = Awaited<ReturnType<typeof getTasksErrors>>, TError = Error | AuthorizationErrorResponse | ForbiddenTasksErrorResponse | RequestTimeoutResponse | InternalServerErrorResponse | ResponseTimeoutResponse | ServerTimeoutErrorResponse>(params?: GetTasksErrorsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getTasksErrors>>, TError, TData>>, request?: SecondParameter<typeof lp5AxiosClient>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetTasksErrorsQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getTasksErrors>>> = ({ signal }) => getTasksErrors(params, requestOptions, signal);





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getTasksErrors>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetTasksErrorsQueryResult = NonNullable<Awaited<ReturnType<typeof getTasksErrors>>>
export type GetTasksErrorsQueryError = Error | AuthorizationErrorResponse | ForbiddenTasksErrorResponse | RequestTimeoutResponse | InternalServerErrorResponse | ResponseTimeoutResponse | ServerTimeoutErrorResponse


export function useGetTasksErrors<TData = Awaited<ReturnType<typeof getTasksErrors>>, TError = Error | AuthorizationErrorResponse | ForbiddenTasksErrorResponse | RequestTimeoutResponse | InternalServerErrorResponse | ResponseTimeoutResponse | ServerTimeoutErrorResponse>(
 params: undefined |  GetTasksErrorsParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getTasksErrors>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getTasksErrors>>,
          TError,
          Awaited<ReturnType<typeof getTasksErrors>>
        > , 'initialData'
      >, request?: SecondParameter<typeof lp5AxiosClient>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetTasksErrors<TData = Awaited<ReturnType<typeof getTasksErrors>>, TError = Error | AuthorizationErrorResponse | ForbiddenTasksErrorResponse | RequestTimeoutResponse | InternalServerErrorResponse | ResponseTimeoutResponse | ServerTimeoutErrorResponse>(
 params?: GetTasksErrorsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getTasksErrors>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getTasksErrors>>,
          TError,
          Awaited<ReturnType<typeof getTasksErrors>>
        > , 'initialData'
      >, request?: SecondParameter<typeof lp5AxiosClient>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetTasksErrors<TData = Awaited<ReturnType<typeof getTasksErrors>>, TError = Error | AuthorizationErrorResponse | ForbiddenTasksErrorResponse | RequestTimeoutResponse | InternalServerErrorResponse | ResponseTimeoutResponse | ServerTimeoutErrorResponse>(
 params?: GetTasksErrorsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getTasksErrors>>, TError, TData>>, request?: SecondParameter<typeof lp5AxiosClient>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary get errors
 */

export function useGetTasksErrors<TData = Awaited<ReturnType<typeof getTasksErrors>>, TError = Error | AuthorizationErrorResponse | ForbiddenTasksErrorResponse | RequestTimeoutResponse | InternalServerErrorResponse | ResponseTimeoutResponse | ServerTimeoutErrorResponse>(
 params?: GetTasksErrorsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getTasksErrors>>, TError, TData>>, request?: SecondParameter<typeof lp5AxiosClient>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetTasksErrorsQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}







/**
 * Get options for the resource.
 * @summary errors options
 */
export const getErrorsOptions = (

 options?: SecondParameter<typeof lp5AxiosClient>,signal?: AbortSignal
) => {


      return lp5AxiosClient<void>(
      {url: `/6/tasks/errors`, method: 'OPTIONS', signal
    },
      options);
    }




export const getGetErrorsOptionsMutationOptions = <TError = RequestTimeoutResponse | InternalServerErrorResponse | ResponseTimeoutResponse | ServerTimeoutErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof getErrorsOptions>>, TError,void, TContext>, request?: SecondParameter<typeof lp5AxiosClient>}
): UseMutationOptions<Awaited<ReturnType<typeof getErrorsOptions>>, TError,void, TContext> => {

const mutationKey = ['getErrorsOptions'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof getErrorsOptions>>, void> = () => {


          return  getErrorsOptions(requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type GetErrorsOptionsMutationResult = NonNullable<Awaited<ReturnType<typeof getErrorsOptions>>>

    export type GetErrorsOptionsMutationError = RequestTimeoutResponse | InternalServerErrorResponse | ResponseTimeoutResponse | ServerTimeoutErrorResponse

    /**
 * @summary errors options
 */
export const useGetErrorsOptions = <TError = RequestTimeoutResponse | InternalServerErrorResponse | ResponseTimeoutResponse | ServerTimeoutErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof getErrorsOptions>>, TError,void, TContext>, request?: SecondParameter<typeof lp5AxiosClient>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof getErrorsOptions>>,
        TError,
        void,
        TContext
      > => {
      return useMutation(getGetErrorsOptionsMutationOptions(options), queryClient);
    }

/**
 * Count errors according to the filters.
 * @summary get errors count
 */
export const getTasksErrorsCount = (
    params?: GetTasksErrorsCountParams,
 options?: SecondParameter<typeof lp5AxiosClient>,signal?: AbortSignal
) => {


      return lp5AxiosClient<ErrorCount>(
      {url: `/6/tasks/errors/count`, method: 'GET',
        params, signal
    },
      options);
    }




export const getGetTasksErrorsCountQueryKey = (params?: GetTasksErrorsCountParams,) => {
    return [
    `/6/tasks/errors/count`, ...(params ? [params] : [])
    ] as const;
    }


export const getGetTasksErrorsCountQueryOptions = <TData = Awaited<ReturnType<typeof getTasksErrorsCount>>, TError = Error | AuthorizationErrorResponse | ForbiddenTasksErrorResponse | RequestTimeoutResponse | InternalServerErrorResponse | ResponseTimeoutResponse | ServerTimeoutErrorResponse>(params?: GetTasksErrorsCountParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getTasksErrorsCount>>, TError, TData>>, request?: SecondParameter<typeof lp5AxiosClient>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetTasksErrorsCountQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getTasksErrorsCount>>> = ({ signal }) => getTasksErrorsCount(params, requestOptions, signal);





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getTasksErrorsCount>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetTasksErrorsCountQueryResult = NonNullable<Awaited<ReturnType<typeof getTasksErrorsCount>>>
export type GetTasksErrorsCountQueryError = Error | AuthorizationErrorResponse | ForbiddenTasksErrorResponse | RequestTimeoutResponse | InternalServerErrorResponse | ResponseTimeoutResponse | ServerTimeoutErrorResponse


export function useGetTasksErrorsCount<TData = Awaited<ReturnType<typeof getTasksErrorsCount>>, TError = Error | AuthorizationErrorResponse | ForbiddenTasksErrorResponse | RequestTimeoutResponse | InternalServerErrorResponse | ResponseTimeoutResponse | ServerTimeoutErrorResponse>(
 params: undefined |  GetTasksErrorsCountParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getTasksErrorsCount>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getTasksErrorsCount>>,
          TError,
          Awaited<ReturnType<typeof getTasksErrorsCount>>
        > , 'initialData'
      >, request?: SecondParameter<typeof lp5AxiosClient>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetTasksErrorsCount<TData = Awaited<ReturnType<typeof getTasksErrorsCount>>, TError = Error | AuthorizationErrorResponse | ForbiddenTasksErrorResponse | RequestTimeoutResponse | InternalServerErrorResponse | ResponseTimeoutResponse | ServerTimeoutErrorResponse>(
 params?: GetTasksErrorsCountParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getTasksErrorsCount>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getTasksErrorsCount>>,
          TError,
          Awaited<ReturnType<typeof getTasksErrorsCount>>
        > , 'initialData'
      >, request?: SecondParameter<typeof lp5AxiosClient>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetTasksErrorsCount<TData = Awaited<ReturnType<typeof getTasksErrorsCount>>, TError = Error | AuthorizationErrorResponse | ForbiddenTasksErrorResponse | RequestTimeoutResponse | InternalServerErrorResponse | ResponseTimeoutResponse | ServerTimeoutErrorResponse>(
 params?: GetTasksErrorsCountParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getTasksErrorsCount>>, TError, TData>>, request?: SecondParameter<typeof lp5AxiosClient>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary get errors count
 */

export function useGetTasksErrorsCount<TData = Awaited<ReturnType<typeof getTasksErrorsCount>>, TError = Error | AuthorizationErrorResponse | ForbiddenTasksErrorResponse | RequestTimeoutResponse | InternalServerErrorResponse | ResponseTimeoutResponse | ServerTimeoutErrorResponse>(
 params?: GetTasksErrorsCountParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getTasksErrorsCount>>, TError, TData>>, request?: SecondParameter<typeof lp5AxiosClient>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetTasksErrorsCountQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}







/**
 * Get options for the resource.
 * @summary task errors count options
 */
export const getTasksErrorsCountOptions = (

 options?: SecondParameter<typeof lp5AxiosClient>,signal?: AbortSignal
) => {


      return lp5AxiosClient<void>(
      {url: `/6/tasks/errors/count`, method: 'OPTIONS', signal
    },
      options);
    }




export const getGetTasksErrorsCountOptionsMutationOptions = <TError = RequestTimeoutResponse | InternalServerErrorResponse | ResponseTimeoutResponse | ServerTimeoutErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof getTasksErrorsCountOptions>>, TError,void, TContext>, request?: SecondParameter<typeof lp5AxiosClient>}
): UseMutationOptions<Awaited<ReturnType<typeof getTasksErrorsCountOptions>>, TError,void, TContext> => {

const mutationKey = ['getTasksErrorsCountOptions'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof getTasksErrorsCountOptions>>, void> = () => {


          return  getTasksErrorsCountOptions(requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type GetTasksErrorsCountOptionsMutationResult = NonNullable<Awaited<ReturnType<typeof getTasksErrorsCountOptions>>>

    export type GetTasksErrorsCountOptionsMutationError = RequestTimeoutResponse | InternalServerErrorResponse | ResponseTimeoutResponse | ServerTimeoutErrorResponse

    /**
 * @summary task errors count options
 */
export const useGetTasksErrorsCountOptions = <TError = RequestTimeoutResponse | InternalServerErrorResponse | ResponseTimeoutResponse | ServerTimeoutErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof getTasksErrorsCountOptions>>, TError,void, TContext>, request?: SecondParameter<typeof lp5AxiosClient>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof getTasksErrorsCountOptions>>,
        TError,
        void,
        TContext
      > => {
      return useMutation(getGetTasksErrorsCountOptionsMutationOptions(options), queryClient);
    }

/**
 * Get error by ID.
 * @summary get error
 */
export const getTaskError = (
    errorId: number,
    params?: GetTaskErrorParams,
 options?: SecondParameter<typeof lp5AxiosClient>,signal?: AbortSignal
) => {


      return lp5AxiosClient<TaskError>(
      {url: `/6/tasks/errors/${errorId}`, method: 'GET',
        params, signal
    },
      options);
    }




export const getGetTaskErrorQueryKey = (errorId: number,
    params?: GetTaskErrorParams,) => {
    return [
    `/6/tasks/errors/${errorId}`, ...(params ? [params] : [])
    ] as const;
    }


export const getGetTaskErrorQueryOptions = <TData = Awaited<ReturnType<typeof getTaskError>>, TError = Error | AuthorizationErrorResponse | ForbiddenTasksErrorResponse | RequestTimeoutResponse | InternalServerErrorResponse | ResponseTimeoutResponse | ServerTimeoutErrorResponse>(errorId: number,
    params?: GetTaskErrorParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getTaskError>>, TError, TData>>, request?: SecondParameter<typeof lp5AxiosClient>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetTaskErrorQueryKey(errorId,params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getTaskError>>> = ({ signal }) => getTaskError(errorId,params, requestOptions, signal);





   return  { queryKey, queryFn, enabled: errorId !== null && errorId !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getTaskError>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetTaskErrorQueryResult = NonNullable<Awaited<ReturnType<typeof getTaskError>>>
export type GetTaskErrorQueryError = Error | AuthorizationErrorResponse | ForbiddenTasksErrorResponse | RequestTimeoutResponse | InternalServerErrorResponse | ResponseTimeoutResponse | ServerTimeoutErrorResponse


export function useGetTaskError<TData = Awaited<ReturnType<typeof getTaskError>>, TError = Error | AuthorizationErrorResponse | ForbiddenTasksErrorResponse | RequestTimeoutResponse | InternalServerErrorResponse | ResponseTimeoutResponse | ServerTimeoutErrorResponse>(
 errorId: number,
    params: undefined |  GetTaskErrorParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getTaskError>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getTaskError>>,
          TError,
          Awaited<ReturnType<typeof getTaskError>>
        > , 'initialData'
      >, request?: SecondParameter<typeof lp5AxiosClient>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetTaskError<TData = Awaited<ReturnType<typeof getTaskError>>, TError = Error | AuthorizationErrorResponse | ForbiddenTasksErrorResponse | RequestTimeoutResponse | InternalServerErrorResponse | ResponseTimeoutResponse | ServerTimeoutErrorResponse>(
 errorId: number,
    params?: GetTaskErrorParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getTaskError>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getTaskError>>,
          TError,
          Awaited<ReturnType<typeof getTaskError>>
        > , 'initialData'
      >, request?: SecondParameter<typeof lp5AxiosClient>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetTaskError<TData = Awaited<ReturnType<typeof getTaskError>>, TError = Error | AuthorizationErrorResponse | ForbiddenTasksErrorResponse | RequestTimeoutResponse | InternalServerErrorResponse | ResponseTimeoutResponse | ServerTimeoutErrorResponse>(
 errorId: number,
    params?: GetTaskErrorParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getTaskError>>, TError, TData>>, request?: SecondParameter<typeof lp5AxiosClient>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary get error
 */

export function useGetTaskError<TData = Awaited<ReturnType<typeof getTaskError>>, TError = Error | AuthorizationErrorResponse | ForbiddenTasksErrorResponse | RequestTimeoutResponse | InternalServerErrorResponse | ResponseTimeoutResponse | ServerTimeoutErrorResponse>(
 errorId: number,
    params?: GetTaskErrorParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getTaskError>>, TError, TData>>, request?: SecondParameter<typeof lp5AxiosClient>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetTaskErrorQueryOptions(errorId,params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}







/**
 * Get options for the resource.
 * @summary error options
 */
export const getTasksErrorsOptions = (
    errorId: number,
 options?: SecondParameter<typeof lp5AxiosClient>,signal?: AbortSignal
) => {


      return lp5AxiosClient<void>(
      {url: `/6/tasks/errors/${errorId}`, method: 'OPTIONS', signal
    },
      options);
    }




export const getGetTasksErrorsOptionsMutationOptions = <TError = RequestTimeoutResponse | InternalServerErrorResponse | ResponseTimeoutResponse | ServerTimeoutErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof getTasksErrorsOptions>>, TError,{errorId: number}, TContext>, request?: SecondParameter<typeof lp5AxiosClient>}
): UseMutationOptions<Awaited<ReturnType<typeof getTasksErrorsOptions>>, TError,{errorId: number}, TContext> => {

const mutationKey = ['getTasksErrorsOptions'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof getTasksErrorsOptions>>, {errorId: number}> = (props) => {
          const {errorId} = props ?? {};

          return  getTasksErrorsOptions(errorId,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type GetTasksErrorsOptionsMutationResult = NonNullable<Awaited<ReturnType<typeof getTasksErrorsOptions>>>

    export type GetTasksErrorsOptionsMutationError = RequestTimeoutResponse | InternalServerErrorResponse | ResponseTimeoutResponse | ServerTimeoutErrorResponse

    /**
 * @summary error options
 */
export const useGetTasksErrorsOptions = <TError = RequestTimeoutResponse | InternalServerErrorResponse | ResponseTimeoutResponse | ServerTimeoutErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof getTasksErrorsOptions>>, TError,{errorId: number}, TContext>, request?: SecondParameter<typeof lp5AxiosClient>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof getTasksErrorsOptions>>,
        TError,
        {errorId: number},
        TContext
      > => {
      return useMutation(getGetTasksErrorsOptionsMutationOptions(options), queryClient);
    }

/**
 * Create a new task schedule.
 *
 * Execution of scheduled tasks will be regulated according to the trigger and optionally starts one task
 * immediately (see *start_immediately* parameter in *behavior* section).
 *
 * No task from the schedule will be executed if the previous task has not yet been completed.
 *
 * Permissions for task objects.
 * @summary create tasks schedule
 */
export const createSchedule = (
    schedule: Schedule,
 options?: SecondParameter<typeof lp5AxiosClient>,signal?: AbortSignal
) => {


      return lp5AxiosClient<CreateSchedule201>(
      {url: `/6/tasks/schedules`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: schedule, signal
    },
      options);
    }




export const getCreateScheduleMutationOptions = <TError = Error | ForbiddenTasksErrorResponse | RequestTimeoutResponse | PayloadToLargeResponse | InternalServerErrorResponse | ResponseTimeoutResponse | ServerTimeoutErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createSchedule>>, TError,{data: Schedule}, TContext>, request?: SecondParameter<typeof lp5AxiosClient>}
): UseMutationOptions<Awaited<ReturnType<typeof createSchedule>>, TError,{data: Schedule}, TContext> => {

const mutationKey = ['createSchedule'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof createSchedule>>, {data: Schedule}> = (props) => {
          const {data} = props ?? {};

          return  createSchedule(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type CreateScheduleMutationResult = NonNullable<Awaited<ReturnType<typeof createSchedule>>>
    export type CreateScheduleMutationBody = Schedule
    export type CreateScheduleMutationError = Error | ForbiddenTasksErrorResponse | RequestTimeoutResponse | PayloadToLargeResponse | InternalServerErrorResponse | ResponseTimeoutResponse | ServerTimeoutErrorResponse

    /**
 * @summary create tasks schedule
 */
export const useCreateSchedule = <TError = Error | ForbiddenTasksErrorResponse | RequestTimeoutResponse | PayloadToLargeResponse | InternalServerErrorResponse | ResponseTimeoutResponse | ServerTimeoutErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createSchedule>>, TError,{data: Schedule}, TContext>, request?: SecondParameter<typeof lp5AxiosClient>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof createSchedule>>,
        TError,
        {data: Schedule},
        TContext
      > => {
      return useMutation(getCreateScheduleMutationOptions(options), queryClient);
    }

/**
 * Get tasks schedules with filters.
 * @summary get tasks schedules
 */
export const getTasksSchedules = (
    params?: GetTasksSchedulesParams,
 options?: SecondParameter<typeof lp5AxiosClient>,signal?: AbortSignal
) => {


      return lp5AxiosClient<SchedulesReply>(
      {url: `/6/tasks/schedules`, method: 'GET',
        params, signal
    },
      options);
    }




export const getGetTasksSchedulesQueryKey = (params?: GetTasksSchedulesParams,) => {
    return [
    `/6/tasks/schedules`, ...(params ? [params] : [])
    ] as const;
    }


export const getGetTasksSchedulesQueryOptions = <TData = Awaited<ReturnType<typeof getTasksSchedules>>, TError = Error | ForbiddenTasksErrorResponse | RequestTimeoutResponse | InternalServerErrorResponse | ResponseTimeoutResponse | ServerTimeoutErrorResponse>(params?: GetTasksSchedulesParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getTasksSchedules>>, TError, TData>>, request?: SecondParameter<typeof lp5AxiosClient>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetTasksSchedulesQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getTasksSchedules>>> = ({ signal }) => getTasksSchedules(params, requestOptions, signal);





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getTasksSchedules>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetTasksSchedulesQueryResult = NonNullable<Awaited<ReturnType<typeof getTasksSchedules>>>
export type GetTasksSchedulesQueryError = Error | ForbiddenTasksErrorResponse | RequestTimeoutResponse | InternalServerErrorResponse | ResponseTimeoutResponse | ServerTimeoutErrorResponse


export function useGetTasksSchedules<TData = Awaited<ReturnType<typeof getTasksSchedules>>, TError = Error | ForbiddenTasksErrorResponse | RequestTimeoutResponse | InternalServerErrorResponse | ResponseTimeoutResponse | ServerTimeoutErrorResponse>(
 params: undefined |  GetTasksSchedulesParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getTasksSchedules>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getTasksSchedules>>,
          TError,
          Awaited<ReturnType<typeof getTasksSchedules>>
        > , 'initialData'
      >, request?: SecondParameter<typeof lp5AxiosClient>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetTasksSchedules<TData = Awaited<ReturnType<typeof getTasksSchedules>>, TError = Error | ForbiddenTasksErrorResponse | RequestTimeoutResponse | InternalServerErrorResponse | ResponseTimeoutResponse | ServerTimeoutErrorResponse>(
 params?: GetTasksSchedulesParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getTasksSchedules>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getTasksSchedules>>,
          TError,
          Awaited<ReturnType<typeof getTasksSchedules>>
        > , 'initialData'
      >, request?: SecondParameter<typeof lp5AxiosClient>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetTasksSchedules<TData = Awaited<ReturnType<typeof getTasksSchedules>>, TError = Error | ForbiddenTasksErrorResponse | RequestTimeoutResponse | InternalServerErrorResponse | ResponseTimeoutResponse | ServerTimeoutErrorResponse>(
 params?: GetTasksSchedulesParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getTasksSchedules>>, TError, TData>>, request?: SecondParameter<typeof lp5AxiosClient>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary get tasks schedules
 */

export function useGetTasksSchedules<TData = Awaited<ReturnType<typeof getTasksSchedules>>, TError = Error | ForbiddenTasksErrorResponse | RequestTimeoutResponse | InternalServerErrorResponse | ResponseTimeoutResponse | ServerTimeoutErrorResponse>(
 params?: GetTasksSchedulesParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getTasksSchedules>>, TError, TData>>, request?: SecondParameter<typeof lp5AxiosClient>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetTasksSchedulesQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}







/**
 * Get options for the resource.
 * @summary schedules options
 */
export const getSchedulesOptions = (

 options?: SecondParameter<typeof lp5AxiosClient>,signal?: AbortSignal
) => {


      return lp5AxiosClient<void>(
      {url: `/6/tasks/schedules`, method: 'OPTIONS', signal
    },
      options);
    }




export const getGetSchedulesOptionsMutationOptions = <TError = RequestTimeoutResponse | InternalServerErrorResponse | ResponseTimeoutResponse | ServerTimeoutErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof getSchedulesOptions>>, TError,void, TContext>, request?: SecondParameter<typeof lp5AxiosClient>}
): UseMutationOptions<Awaited<ReturnType<typeof getSchedulesOptions>>, TError,void, TContext> => {

const mutationKey = ['getSchedulesOptions'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof getSchedulesOptions>>, void> = () => {


          return  getSchedulesOptions(requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type GetSchedulesOptionsMutationResult = NonNullable<Awaited<ReturnType<typeof getSchedulesOptions>>>

    export type GetSchedulesOptionsMutationError = RequestTimeoutResponse | InternalServerErrorResponse | ResponseTimeoutResponse | ServerTimeoutErrorResponse

    /**
 * @summary schedules options
 */
export const useGetSchedulesOptions = <TError = RequestTimeoutResponse | InternalServerErrorResponse | ResponseTimeoutResponse | ServerTimeoutErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof getSchedulesOptions>>, TError,void, TContext>, request?: SecondParameter<typeof lp5AxiosClient>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof getSchedulesOptions>>,
        TError,
        void,
        TContext
      > => {
      return useMutation(getGetSchedulesOptionsMutationOptions(options), queryClient);
    }

/**
 * Get tasks schedule by ID.
 * @summary get tasks schedule
 */
export const getTasksSchedule = (
    scheduleId: number,
    params?: GetTasksScheduleParams,
 options?: SecondParameter<typeof lp5AxiosClient>,signal?: AbortSignal
) => {


      return lp5AxiosClient<ScheduleReply>(
      {url: `/6/tasks/schedules/${scheduleId}`, method: 'GET',
        params, signal
    },
      options);
    }




export const getGetTasksScheduleQueryKey = (scheduleId: number,
    params?: GetTasksScheduleParams,) => {
    return [
    `/6/tasks/schedules/${scheduleId}`, ...(params ? [params] : [])
    ] as const;
    }


export const getGetTasksScheduleQueryOptions = <TData = Awaited<ReturnType<typeof getTasksSchedule>>, TError = Error | ForbiddenTasksErrorResponse | RequestTimeoutResponse | InternalServerErrorResponse | ResponseTimeoutResponse | ServerTimeoutErrorResponse>(scheduleId: number,
    params?: GetTasksScheduleParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getTasksSchedule>>, TError, TData>>, request?: SecondParameter<typeof lp5AxiosClient>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetTasksScheduleQueryKey(scheduleId,params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getTasksSchedule>>> = ({ signal }) => getTasksSchedule(scheduleId,params, requestOptions, signal);





   return  { queryKey, queryFn, enabled: scheduleId !== null && scheduleId !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getTasksSchedule>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetTasksScheduleQueryResult = NonNullable<Awaited<ReturnType<typeof getTasksSchedule>>>
export type GetTasksScheduleQueryError = Error | ForbiddenTasksErrorResponse | RequestTimeoutResponse | InternalServerErrorResponse | ResponseTimeoutResponse | ServerTimeoutErrorResponse


export function useGetTasksSchedule<TData = Awaited<ReturnType<typeof getTasksSchedule>>, TError = Error | ForbiddenTasksErrorResponse | RequestTimeoutResponse | InternalServerErrorResponse | ResponseTimeoutResponse | ServerTimeoutErrorResponse>(
 scheduleId: number,
    params: undefined |  GetTasksScheduleParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getTasksSchedule>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getTasksSchedule>>,
          TError,
          Awaited<ReturnType<typeof getTasksSchedule>>
        > , 'initialData'
      >, request?: SecondParameter<typeof lp5AxiosClient>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetTasksSchedule<TData = Awaited<ReturnType<typeof getTasksSchedule>>, TError = Error | ForbiddenTasksErrorResponse | RequestTimeoutResponse | InternalServerErrorResponse | ResponseTimeoutResponse | ServerTimeoutErrorResponse>(
 scheduleId: number,
    params?: GetTasksScheduleParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getTasksSchedule>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getTasksSchedule>>,
          TError,
          Awaited<ReturnType<typeof getTasksSchedule>>
        > , 'initialData'
      >, request?: SecondParameter<typeof lp5AxiosClient>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetTasksSchedule<TData = Awaited<ReturnType<typeof getTasksSchedule>>, TError = Error | ForbiddenTasksErrorResponse | RequestTimeoutResponse | InternalServerErrorResponse | ResponseTimeoutResponse | ServerTimeoutErrorResponse>(
 scheduleId: number,
    params?: GetTasksScheduleParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getTasksSchedule>>, TError, TData>>, request?: SecondParameter<typeof lp5AxiosClient>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary get tasks schedule
 */

export function useGetTasksSchedule<TData = Awaited<ReturnType<typeof getTasksSchedule>>, TError = Error | ForbiddenTasksErrorResponse | RequestTimeoutResponse | InternalServerErrorResponse | ResponseTimeoutResponse | ServerTimeoutErrorResponse>(
 scheduleId: number,
    params?: GetTasksScheduleParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getTasksSchedule>>, TError, TData>>, request?: SecondParameter<typeof lp5AxiosClient>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetTasksScheduleQueryOptions(scheduleId,params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}







/**
 * Replace tasks schedule:
 *
 * - if any task created by old schedule is running, it will be cancelled
 *
 * - schedule parameters will be replaced with the new ones
 *
 * - tasks will be executed according to the new schedule
 * @summary replace tasks schedule
 */
export const putTasksSchedule = (
    scheduleId: number,
    schedule: Schedule,
 options?: SecondParameter<typeof lp5AxiosClient>,signal?: AbortSignal
) => {


      return lp5AxiosClient<PutTasksSchedule200>(
      {url: `/6/tasks/schedules/${scheduleId}`, method: 'PUT',
      headers: {'Content-Type': 'application/json', },
      data: schedule, signal
    },
      options);
    }




export const getPutTasksScheduleMutationOptions = <TError = Error | ForbiddenTasksErrorResponse | RequestTimeoutResponse | PayloadToLargeResponse | InternalServerErrorResponse | ResponseTimeoutResponse | ServerTimeoutErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof putTasksSchedule>>, TError,{scheduleId: number;data: Schedule}, TContext>, request?: SecondParameter<typeof lp5AxiosClient>}
): UseMutationOptions<Awaited<ReturnType<typeof putTasksSchedule>>, TError,{scheduleId: number;data: Schedule}, TContext> => {

const mutationKey = ['putTasksSchedule'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof putTasksSchedule>>, {scheduleId: number;data: Schedule}> = (props) => {
          const {scheduleId,data} = props ?? {};

          return  putTasksSchedule(scheduleId,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type PutTasksScheduleMutationResult = NonNullable<Awaited<ReturnType<typeof putTasksSchedule>>>
    export type PutTasksScheduleMutationBody = Schedule
    export type PutTasksScheduleMutationError = Error | ForbiddenTasksErrorResponse | RequestTimeoutResponse | PayloadToLargeResponse | InternalServerErrorResponse | ResponseTimeoutResponse | ServerTimeoutErrorResponse

    /**
 * @summary replace tasks schedule
 */
export const usePutTasksSchedule = <TError = Error | ForbiddenTasksErrorResponse | RequestTimeoutResponse | PayloadToLargeResponse | InternalServerErrorResponse | ResponseTimeoutResponse | ServerTimeoutErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof putTasksSchedule>>, TError,{scheduleId: number;data: Schedule}, TContext>, request?: SecondParameter<typeof lp5AxiosClient>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof putTasksSchedule>>,
        TError,
        {scheduleId: number;data: Schedule},
        TContext
      > => {
      return useMutation(getPutTasksScheduleMutationOptions(options), queryClient);
    }

/**
 * Pause/start tasks schedule.
 * @summary patch tasks schedule
 */
export const patchTasksSchedule = (
    scheduleId: number,
    params: PatchTasksScheduleParams,
 options?: SecondParameter<typeof lp5AxiosClient>,signal?: AbortSignal
) => {


      return lp5AxiosClient<void>(
      {url: `/6/tasks/schedules/${scheduleId}`, method: 'PATCH',
        params, signal
    },
      options);
    }




export const getPatchTasksScheduleMutationOptions = <TError = Error | ForbiddenTasksErrorResponse | RequestTimeoutResponse | InternalServerErrorResponse | ResponseTimeoutResponse | ServerTimeoutErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof patchTasksSchedule>>, TError,{scheduleId: number;params: PatchTasksScheduleParams}, TContext>, request?: SecondParameter<typeof lp5AxiosClient>}
): UseMutationOptions<Awaited<ReturnType<typeof patchTasksSchedule>>, TError,{scheduleId: number;params: PatchTasksScheduleParams}, TContext> => {

const mutationKey = ['patchTasksSchedule'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof patchTasksSchedule>>, {scheduleId: number;params: PatchTasksScheduleParams}> = (props) => {
          const {scheduleId,params} = props ?? {};

          return  patchTasksSchedule(scheduleId,params,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type PatchTasksScheduleMutationResult = NonNullable<Awaited<ReturnType<typeof patchTasksSchedule>>>

    export type PatchTasksScheduleMutationError = Error | ForbiddenTasksErrorResponse | RequestTimeoutResponse | InternalServerErrorResponse | ResponseTimeoutResponse | ServerTimeoutErrorResponse

    /**
 * @summary patch tasks schedule
 */
export const usePatchTasksSchedule = <TError = Error | ForbiddenTasksErrorResponse | RequestTimeoutResponse | InternalServerErrorResponse | ResponseTimeoutResponse | ServerTimeoutErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof patchTasksSchedule>>, TError,{scheduleId: number;params: PatchTasksScheduleParams}, TContext>, request?: SecondParameter<typeof lp5AxiosClient>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof patchTasksSchedule>>,
        TError,
        {scheduleId: number;params: PatchTasksScheduleParams},
        TContext
      > => {
      return useMutation(getPatchTasksScheduleMutationOptions(options), queryClient);
    }

/**
 * Delete tasks schedule.
 * @summary delete tasks schedule
 */
export const deleteTasksSchedule = (
    scheduleId: number,
    params?: DeleteTasksScheduleParams,
 options?: SecondParameter<typeof lp5AxiosClient>,signal?: AbortSignal
) => {


      return lp5AxiosClient<void>(
      {url: `/6/tasks/schedules/${scheduleId}`, method: 'DELETE',
        params, signal
    },
      options);
    }




export const getDeleteTasksScheduleMutationOptions = <TError = Error | ForbiddenTasksErrorResponse | RequestTimeoutResponse | InternalServerErrorResponse | ResponseTimeoutResponse | ServerTimeoutErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteTasksSchedule>>, TError,{scheduleId: number;params?: DeleteTasksScheduleParams}, TContext>, request?: SecondParameter<typeof lp5AxiosClient>}
): UseMutationOptions<Awaited<ReturnType<typeof deleteTasksSchedule>>, TError,{scheduleId: number;params?: DeleteTasksScheduleParams}, TContext> => {

const mutationKey = ['deleteTasksSchedule'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof deleteTasksSchedule>>, {scheduleId: number;params?: DeleteTasksScheduleParams}> = (props) => {
          const {scheduleId,params} = props ?? {};

          return  deleteTasksSchedule(scheduleId,params,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type DeleteTasksScheduleMutationResult = NonNullable<Awaited<ReturnType<typeof deleteTasksSchedule>>>

    export type DeleteTasksScheduleMutationError = Error | ForbiddenTasksErrorResponse | RequestTimeoutResponse | InternalServerErrorResponse | ResponseTimeoutResponse | ServerTimeoutErrorResponse

    /**
 * @summary delete tasks schedule
 */
export const useDeleteTasksSchedule = <TError = Error | ForbiddenTasksErrorResponse | RequestTimeoutResponse | InternalServerErrorResponse | ResponseTimeoutResponse | ServerTimeoutErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteTasksSchedule>>, TError,{scheduleId: number;params?: DeleteTasksScheduleParams}, TContext>, request?: SecondParameter<typeof lp5AxiosClient>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof deleteTasksSchedule>>,
        TError,
        {scheduleId: number;params?: DeleteTasksScheduleParams},
        TContext
      > => {
      return useMutation(getDeleteTasksScheduleMutationOptions(options), queryClient);
    }

/**
 * Get options for the resource.
 * @summary schedule options
 */
export const getScheduleOptions = (
    scheduleId: number,
 options?: SecondParameter<typeof lp5AxiosClient>,signal?: AbortSignal
) => {


      return lp5AxiosClient<void>(
      {url: `/6/tasks/schedules/${scheduleId}`, method: 'OPTIONS', signal
    },
      options);
    }




export const getGetScheduleOptionsMutationOptions = <TError = RequestTimeoutResponse | InternalServerErrorResponse | ResponseTimeoutResponse | ServerTimeoutErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof getScheduleOptions>>, TError,{scheduleId: number}, TContext>, request?: SecondParameter<typeof lp5AxiosClient>}
): UseMutationOptions<Awaited<ReturnType<typeof getScheduleOptions>>, TError,{scheduleId: number}, TContext> => {

const mutationKey = ['getScheduleOptions'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof getScheduleOptions>>, {scheduleId: number}> = (props) => {
          const {scheduleId} = props ?? {};

          return  getScheduleOptions(scheduleId,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type GetScheduleOptionsMutationResult = NonNullable<Awaited<ReturnType<typeof getScheduleOptions>>>

    export type GetScheduleOptionsMutationError = RequestTimeoutResponse | InternalServerErrorResponse | ResponseTimeoutResponse | ServerTimeoutErrorResponse

    /**
 * @summary schedule options
 */
export const useGetScheduleOptions = <TError = RequestTimeoutResponse | InternalServerErrorResponse | ResponseTimeoutResponse | ServerTimeoutErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof getScheduleOptions>>, TError,{scheduleId: number}, TContext>, request?: SecondParameter<typeof lp5AxiosClient>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof getScheduleOptions>>,
        TError,
        {scheduleId: number},
        TContext
      > => {
      return useMutation(getGetScheduleOptionsMutationOptions(options), queryClient);
    }

/**
 * Create a verifier.
 *
 * The verifier determines a list of rules for
 * processing and verification of input images.
 *
 * You can set:
 *
 *   - verification_threshold
 *   - detect_policy
 *   - extract_policy
 *   - storage_policy for attributes and face samples.
 *
 * The created handler can be used in "raw verification" and "perform verification" requests.
 * @summary create verifier
 */
export const createVerifier = (
    newVerifier: NewVerifier,
 options?: SecondParameter<typeof lp5AxiosClient>,signal?: AbortSignal
) => {


      return lp5AxiosClient<CreateVerifier201>(
      {url: `/6/verifiers`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: newVerifier, signal
    },
      options);
    }




export const getCreateVerifierMutationOptions = <TError = Error | AuthorizationErrorResponse | ForbiddenErrorWithServicesResponse | RequestTimeoutResponse | PayloadToLargeResponse | InternalServerErrorResponse | ResponseTimeoutResponse | ServerTimeoutErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createVerifier>>, TError,{data: NewVerifier}, TContext>, request?: SecondParameter<typeof lp5AxiosClient>}
): UseMutationOptions<Awaited<ReturnType<typeof createVerifier>>, TError,{data: NewVerifier}, TContext> => {

const mutationKey = ['createVerifier'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof createVerifier>>, {data: NewVerifier}> = (props) => {
          const {data} = props ?? {};

          return  createVerifier(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type CreateVerifierMutationResult = NonNullable<Awaited<ReturnType<typeof createVerifier>>>
    export type CreateVerifierMutationBody = NewVerifier
    export type CreateVerifierMutationError = Error | AuthorizationErrorResponse | ForbiddenErrorWithServicesResponse | RequestTimeoutResponse | PayloadToLargeResponse | InternalServerErrorResponse | ResponseTimeoutResponse | ServerTimeoutErrorResponse

    /**
 * @summary create verifier
 */
export const useCreateVerifier = <TError = Error | AuthorizationErrorResponse | ForbiddenErrorWithServicesResponse | RequestTimeoutResponse | PayloadToLargeResponse | InternalServerErrorResponse | ResponseTimeoutResponse | ServerTimeoutErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createVerifier>>, TError,{data: NewVerifier}, TContext>, request?: SecondParameter<typeof lp5AxiosClient>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof createVerifier>>,
        TError,
        {data: NewVerifier},
        TContext
      > => {
      return useMutation(getCreateVerifierMutationOptions(options), queryClient);
    }

/**
 * Get verifiers by filters.
 * @summary get verifiers
 */
export const getVerifiers = (
    params?: GetVerifiersParams,
 options?: SecondParameter<typeof lp5AxiosClient>,signal?: AbortSignal
) => {


      return lp5AxiosClient<VerifierResponse[]>(
      {url: `/6/verifiers`, method: 'GET',
        params, signal
    },
      options);
    }




export const getGetVerifiersQueryKey = (params?: GetVerifiersParams,) => {
    return [
    `/6/verifiers`, ...(params ? [params] : [])
    ] as const;
    }


export const getGetVerifiersQueryOptions = <TData = Awaited<ReturnType<typeof getVerifiers>>, TError = Error | AuthorizationErrorResponse | ForbiddenErrorWithServicesResponse | RequestTimeoutResponse | InternalServerErrorResponse | ResponseTimeoutResponse | ServerTimeoutErrorResponse>(params?: GetVerifiersParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getVerifiers>>, TError, TData>>, request?: SecondParameter<typeof lp5AxiosClient>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetVerifiersQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getVerifiers>>> = ({ signal }) => getVerifiers(params, requestOptions, signal);





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getVerifiers>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetVerifiersQueryResult = NonNullable<Awaited<ReturnType<typeof getVerifiers>>>
export type GetVerifiersQueryError = Error | AuthorizationErrorResponse | ForbiddenErrorWithServicesResponse | RequestTimeoutResponse | InternalServerErrorResponse | ResponseTimeoutResponse | ServerTimeoutErrorResponse


export function useGetVerifiers<TData = Awaited<ReturnType<typeof getVerifiers>>, TError = Error | AuthorizationErrorResponse | ForbiddenErrorWithServicesResponse | RequestTimeoutResponse | InternalServerErrorResponse | ResponseTimeoutResponse | ServerTimeoutErrorResponse>(
 params: undefined |  GetVerifiersParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getVerifiers>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getVerifiers>>,
          TError,
          Awaited<ReturnType<typeof getVerifiers>>
        > , 'initialData'
      >, request?: SecondParameter<typeof lp5AxiosClient>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetVerifiers<TData = Awaited<ReturnType<typeof getVerifiers>>, TError = Error | AuthorizationErrorResponse | ForbiddenErrorWithServicesResponse | RequestTimeoutResponse | InternalServerErrorResponse | ResponseTimeoutResponse | ServerTimeoutErrorResponse>(
 params?: GetVerifiersParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getVerifiers>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getVerifiers>>,
          TError,
          Awaited<ReturnType<typeof getVerifiers>>
        > , 'initialData'
      >, request?: SecondParameter<typeof lp5AxiosClient>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetVerifiers<TData = Awaited<ReturnType<typeof getVerifiers>>, TError = Error | AuthorizationErrorResponse | ForbiddenErrorWithServicesResponse | RequestTimeoutResponse | InternalServerErrorResponse | ResponseTimeoutResponse | ServerTimeoutErrorResponse>(
 params?: GetVerifiersParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getVerifiers>>, TError, TData>>, request?: SecondParameter<typeof lp5AxiosClient>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary get verifiers
 */

export function useGetVerifiers<TData = Awaited<ReturnType<typeof getVerifiers>>, TError = Error | AuthorizationErrorResponse | ForbiddenErrorWithServicesResponse | RequestTimeoutResponse | InternalServerErrorResponse | ResponseTimeoutResponse | ServerTimeoutErrorResponse>(
 params?: GetVerifiersParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getVerifiers>>, TError, TData>>, request?: SecondParameter<typeof lp5AxiosClient>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetVerifiersQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}







/**
 * Get options for the resource.
 * @summary verifiers options
 */
export const getVerifiersOptions = (

 options?: SecondParameter<typeof lp5AxiosClient>,signal?: AbortSignal
) => {


      return lp5AxiosClient<void>(
      {url: `/6/verifiers`, method: 'OPTIONS', signal
    },
      options);
    }




export const getGetVerifiersOptionsMutationOptions = <TError = RequestTimeoutResponse | InternalServerErrorResponse | ResponseTimeoutResponse | ServerTimeoutErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof getVerifiersOptions>>, TError,void, TContext>, request?: SecondParameter<typeof lp5AxiosClient>}
): UseMutationOptions<Awaited<ReturnType<typeof getVerifiersOptions>>, TError,void, TContext> => {

const mutationKey = ['getVerifiersOptions'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof getVerifiersOptions>>, void> = () => {


          return  getVerifiersOptions(requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type GetVerifiersOptionsMutationResult = NonNullable<Awaited<ReturnType<typeof getVerifiersOptions>>>

    export type GetVerifiersOptionsMutationError = RequestTimeoutResponse | InternalServerErrorResponse | ResponseTimeoutResponse | ServerTimeoutErrorResponse

    /**
 * @summary verifiers options
 */
export const useGetVerifiersOptions = <TError = RequestTimeoutResponse | InternalServerErrorResponse | ResponseTimeoutResponse | ServerTimeoutErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof getVerifiersOptions>>, TError,void, TContext>, request?: SecondParameter<typeof lp5AxiosClient>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof getVerifiersOptions>>,
        TError,
        void,
        TContext
      > => {
      return useMutation(getGetVerifiersOptionsMutationOptions(options), queryClient);
    }

/**
 * This request performs verification of input descriptors.
 *
 * "Similarity" and "verification status" are returned for each candidate.
 *
 * "Verification status" is "True" if the received similarity is greater than the
 * verification_threshold (specified in the verifier handler). Hence, the reference and the candidate are considered
 * the same person.
 *
 * You should specify descriptors as references and candidates for this request.
 * @summary raw verification
 */
export const rawVerification = (
    verifierId: Uuid,
    rawVerificationBody: RawVerificationRequestJson | RawVerificationRequestMsgpack,
 options?: SecondParameter<typeof lp5AxiosClient>,signal?: AbortSignal
) => {


      return lp5AxiosClient<RawVerificationResponse>(
      {url: `/6/verifiers/${verifierId}/raw`, method: 'POST',
      data: rawVerificationBody, signal
    },
      options);
    }




export const getRawVerificationMutationOptions = <TError = Error | AuthorizationErrorResponse | ForbiddenErrorWithServicesResponse | VerifierNotFoundResponse | RequestTimeoutResponse | PayloadToLargeResponse | InternalServerErrorResponse | ResponseTimeoutResponse | ServerTimeoutErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof rawVerification>>, TError,{verifierId: Uuid;data: RawVerificationRequestJson | RawVerificationRequestMsgpack}, TContext>, request?: SecondParameter<typeof lp5AxiosClient>}
): UseMutationOptions<Awaited<ReturnType<typeof rawVerification>>, TError,{verifierId: Uuid;data: RawVerificationRequestJson | RawVerificationRequestMsgpack}, TContext> => {

const mutationKey = ['rawVerification'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof rawVerification>>, {verifierId: Uuid;data: RawVerificationRequestJson | RawVerificationRequestMsgpack}> = (props) => {
          const {verifierId,data} = props ?? {};

          return  rawVerification(verifierId,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type RawVerificationMutationResult = NonNullable<Awaited<ReturnType<typeof rawVerification>>>
    export type RawVerificationMutationBody = RawVerificationRequestJson | RawVerificationRequestMsgpack
    export type RawVerificationMutationError = Error | AuthorizationErrorResponse | ForbiddenErrorWithServicesResponse | VerifierNotFoundResponse | RequestTimeoutResponse | PayloadToLargeResponse | InternalServerErrorResponse | ResponseTimeoutResponse | ServerTimeoutErrorResponse

    /**
 * @summary raw verification
 */
export const useRawVerification = <TError = Error | AuthorizationErrorResponse | ForbiddenErrorWithServicesResponse | VerifierNotFoundResponse | RequestTimeoutResponse | PayloadToLargeResponse | InternalServerErrorResponse | ResponseTimeoutResponse | ServerTimeoutErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof rawVerification>>, TError,{verifierId: Uuid;data: RawVerificationRequestJson | RawVerificationRequestMsgpack}, TContext>, request?: SecondParameter<typeof lp5AxiosClient>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof rawVerification>>,
        TError,
        {verifierId: Uuid;data: RawVerificationRequestJson | RawVerificationRequestMsgpack},
        TContext
      > => {
      return useMutation(getRawVerificationMutationOptions(options), queryClient);
    }

/**
 * Get options for the resource.
 * @summary raw verification options
 */
export const getVerifierRawOptions = (
    verifierId: Uuid,
 options?: SecondParameter<typeof lp5AxiosClient>,signal?: AbortSignal
) => {


      return lp5AxiosClient<void>(
      {url: `/6/verifiers/${verifierId}/raw`, method: 'OPTIONS', signal
    },
      options);
    }




export const getGetVerifierRawOptionsMutationOptions = <TError = RequestTimeoutResponse | InternalServerErrorResponse | ResponseTimeoutResponse | ServerTimeoutErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof getVerifierRawOptions>>, TError,{verifierId: Uuid}, TContext>, request?: SecondParameter<typeof lp5AxiosClient>}
): UseMutationOptions<Awaited<ReturnType<typeof getVerifierRawOptions>>, TError,{verifierId: Uuid}, TContext> => {

const mutationKey = ['getVerifierRawOptions'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof getVerifierRawOptions>>, {verifierId: Uuid}> = (props) => {
          const {verifierId} = props ?? {};

          return  getVerifierRawOptions(verifierId,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type GetVerifierRawOptionsMutationResult = NonNullable<Awaited<ReturnType<typeof getVerifierRawOptions>>>

    export type GetVerifierRawOptionsMutationError = RequestTimeoutResponse | InternalServerErrorResponse | ResponseTimeoutResponse | ServerTimeoutErrorResponse

    /**
 * @summary raw verification options
 */
export const useGetVerifierRawOptions = <TError = RequestTimeoutResponse | InternalServerErrorResponse | ResponseTimeoutResponse | ServerTimeoutErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof getVerifierRawOptions>>, TError,{verifierId: Uuid}, TContext>, request?: SecondParameter<typeof lp5AxiosClient>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof getVerifierRawOptions>>,
        TError,
        {verifierId: Uuid},
        TContext
      > => {
      return useMutation(getGetVerifierRawOptionsMutationOptions(options), queryClient);
    }

/**
 * Verify given images and/or descriptors against specified objects set: faces IDs, events IDs, external IDs.
 *
 * "Similarity" and "verification status" are returned for each candidate.
 *
 * "Verification status" is "True" if the received similarity is greater than the
 * verification_threshold (specified in the verifier handler). Hence, the reference and the candidate are considered
 * the same person.
 *
 * The input images are processed according to the specified policies and the received information is returned in the response.
 *
 * Objects to be processed must belong to the user account making the request.
 *
 * Notes for incoming data:
 *   - face or body *bounding boxes* passed with face or body warped image will be ignored.
 * @summary perform verification
 */
export const postVerifier = (
    verifierId: Uuid,
    postVerifierBody?: Blob | SdkDescriptor | XpkFile | string & SdkDescriptor | string & XpkFile | MultipartVerifierPayload | VerifyJsonRequestBody,
    params?: PostVerifierParams,
 options?: SecondParameter<typeof lp5AxiosClient>,signal?: AbortSignal
) => {


      return lp5AxiosClient<VerifierIdVerificationResponse>(
      {url: `/6/verifiers/${verifierId}/verifications`, method: 'POST',
      data: postVerifierBody,
        params, signal
    },
      options);
    }




export const getPostVerifierMutationOptions = <TError = Error | AuthorizationErrorResponse | VerifierNotFoundResponse | RequestTimeoutResponse | PayloadToLargeResponse | InternalServerErrorResponse | ResponseTimeoutResponse | ServerTimeoutErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postVerifier>>, TError,{verifierId: Uuid;data?: Blob | SdkDescriptor | XpkFile | string & SdkDescriptor | string & XpkFile | MultipartVerifierPayload | VerifyJsonRequestBody;params?: PostVerifierParams}, TContext>, request?: SecondParameter<typeof lp5AxiosClient>}
): UseMutationOptions<Awaited<ReturnType<typeof postVerifier>>, TError,{verifierId: Uuid;data?: Blob | SdkDescriptor | XpkFile | string & SdkDescriptor | string & XpkFile | MultipartVerifierPayload | VerifyJsonRequestBody;params?: PostVerifierParams}, TContext> => {

const mutationKey = ['postVerifier'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postVerifier>>, {verifierId: Uuid;data?: Blob | SdkDescriptor | XpkFile | string & SdkDescriptor | string & XpkFile | MultipartVerifierPayload | VerifyJsonRequestBody;params?: PostVerifierParams}> = (props) => {
          const {verifierId,data,params} = props ?? {};

          return  postVerifier(verifierId,data,params,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type PostVerifierMutationResult = NonNullable<Awaited<ReturnType<typeof postVerifier>>>
    export type PostVerifierMutationBody = Blob | SdkDescriptor | XpkFile | string & SdkDescriptor | string & XpkFile | MultipartVerifierPayload | VerifyJsonRequestBody | undefined
    export type PostVerifierMutationError = Error | AuthorizationErrorResponse | VerifierNotFoundResponse | RequestTimeoutResponse | PayloadToLargeResponse | InternalServerErrorResponse | ResponseTimeoutResponse | ServerTimeoutErrorResponse

    /**
 * @summary perform verification
 */
export const usePostVerifier = <TError = Error | AuthorizationErrorResponse | VerifierNotFoundResponse | RequestTimeoutResponse | PayloadToLargeResponse | InternalServerErrorResponse | ResponseTimeoutResponse | ServerTimeoutErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postVerifier>>, TError,{verifierId: Uuid;data?: Blob | SdkDescriptor | XpkFile | string & SdkDescriptor | string & XpkFile | MultipartVerifierPayload | VerifyJsonRequestBody;params?: PostVerifierParams}, TContext>, request?: SecondParameter<typeof lp5AxiosClient>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof postVerifier>>,
        TError,
        {verifierId: Uuid;data?: Blob | SdkDescriptor | XpkFile | string & SdkDescriptor | string & XpkFile | MultipartVerifierPayload | VerifyJsonRequestBody;params?: PostVerifierParams},
        TContext
      > => {
      return useMutation(getPostVerifierMutationOptions(options), queryClient);
    }

/**
 * Get options for the resource.
 * @summary verification options
 */
export const getVerificationOptions = (
    verifierId: Uuid,
 options?: SecondParameter<typeof lp5AxiosClient>,signal?: AbortSignal
) => {


      return lp5AxiosClient<void>(
      {url: `/6/verifiers/${verifierId}/verifications`, method: 'OPTIONS', signal
    },
      options);
    }




export const getGetVerificationOptionsMutationOptions = <TError = RequestTimeoutResponse | InternalServerErrorResponse | ResponseTimeoutResponse | ServerTimeoutErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof getVerificationOptions>>, TError,{verifierId: Uuid}, TContext>, request?: SecondParameter<typeof lp5AxiosClient>}
): UseMutationOptions<Awaited<ReturnType<typeof getVerificationOptions>>, TError,{verifierId: Uuid}, TContext> => {

const mutationKey = ['getVerificationOptions'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof getVerificationOptions>>, {verifierId: Uuid}> = (props) => {
          const {verifierId} = props ?? {};

          return  getVerificationOptions(verifierId,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type GetVerificationOptionsMutationResult = NonNullable<Awaited<ReturnType<typeof getVerificationOptions>>>

    export type GetVerificationOptionsMutationError = RequestTimeoutResponse | InternalServerErrorResponse | ResponseTimeoutResponse | ServerTimeoutErrorResponse

    /**
 * @summary verification options
 */
export const useGetVerificationOptions = <TError = RequestTimeoutResponse | InternalServerErrorResponse | ResponseTimeoutResponse | ServerTimeoutErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof getVerificationOptions>>, TError,{verifierId: Uuid}, TContext>, request?: SecondParameter<typeof lp5AxiosClient>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof getVerificationOptions>>,
        TError,
        {verifierId: Uuid},
        TContext
      > => {
      return useMutation(getGetVerificationOptionsMutationOptions(options), queryClient);
    }

/**
 * Count verifiers that satisfy the filters.
 * @summary count verifiers
 */
export const countVerifiers = (
    params?: CountVerifiersParams,
 options?: SecondParameter<typeof lp5AxiosClient>,signal?: AbortSignal
) => {


      return lp5AxiosClient<VerifiersCount>(
      {url: `/6/verifiers/count`, method: 'GET',
        params, signal
    },
      options);
    }




export const getCountVerifiersQueryKey = (params?: CountVerifiersParams,) => {
    return [
    `/6/verifiers/count`, ...(params ? [params] : [])
    ] as const;
    }


export const getCountVerifiersQueryOptions = <TData = Awaited<ReturnType<typeof countVerifiers>>, TError = Error | AuthorizationErrorResponse | ForbiddenErrorWithServicesResponse | RequestTimeoutResponse | InternalServerErrorResponse | ResponseTimeoutResponse | ServerTimeoutErrorResponse>(params?: CountVerifiersParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof countVerifiers>>, TError, TData>>, request?: SecondParameter<typeof lp5AxiosClient>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getCountVerifiersQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof countVerifiers>>> = ({ signal }) => countVerifiers(params, requestOptions, signal);





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof countVerifiers>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type CountVerifiersQueryResult = NonNullable<Awaited<ReturnType<typeof countVerifiers>>>
export type CountVerifiersQueryError = Error | AuthorizationErrorResponse | ForbiddenErrorWithServicesResponse | RequestTimeoutResponse | InternalServerErrorResponse | ResponseTimeoutResponse | ServerTimeoutErrorResponse


export function useCountVerifiers<TData = Awaited<ReturnType<typeof countVerifiers>>, TError = Error | AuthorizationErrorResponse | ForbiddenErrorWithServicesResponse | RequestTimeoutResponse | InternalServerErrorResponse | ResponseTimeoutResponse | ServerTimeoutErrorResponse>(
 params: undefined |  CountVerifiersParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof countVerifiers>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof countVerifiers>>,
          TError,
          Awaited<ReturnType<typeof countVerifiers>>
        > , 'initialData'
      >, request?: SecondParameter<typeof lp5AxiosClient>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useCountVerifiers<TData = Awaited<ReturnType<typeof countVerifiers>>, TError = Error | AuthorizationErrorResponse | ForbiddenErrorWithServicesResponse | RequestTimeoutResponse | InternalServerErrorResponse | ResponseTimeoutResponse | ServerTimeoutErrorResponse>(
 params?: CountVerifiersParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof countVerifiers>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof countVerifiers>>,
          TError,
          Awaited<ReturnType<typeof countVerifiers>>
        > , 'initialData'
      >, request?: SecondParameter<typeof lp5AxiosClient>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useCountVerifiers<TData = Awaited<ReturnType<typeof countVerifiers>>, TError = Error | AuthorizationErrorResponse | ForbiddenErrorWithServicesResponse | RequestTimeoutResponse | InternalServerErrorResponse | ResponseTimeoutResponse | ServerTimeoutErrorResponse>(
 params?: CountVerifiersParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof countVerifiers>>, TError, TData>>, request?: SecondParameter<typeof lp5AxiosClient>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary count verifiers
 */

export function useCountVerifiers<TData = Awaited<ReturnType<typeof countVerifiers>>, TError = Error | AuthorizationErrorResponse | ForbiddenErrorWithServicesResponse | RequestTimeoutResponse | InternalServerErrorResponse | ResponseTimeoutResponse | ServerTimeoutErrorResponse>(
 params?: CountVerifiersParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof countVerifiers>>, TError, TData>>, request?: SecondParameter<typeof lp5AxiosClient>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getCountVerifiersQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}







/**
 * Get options for the resource.
 * @summary count verifiers options
 */
export const getCountVerifiersOptions = (

 options?: SecondParameter<typeof lp5AxiosClient>,signal?: AbortSignal
) => {


      return lp5AxiosClient<void>(
      {url: `/6/verifiers/count`, method: 'OPTIONS', signal
    },
      options);
    }




export const getGetCountVerifiersOptionsMutationOptions = <TError = RequestTimeoutResponse | InternalServerErrorResponse | ResponseTimeoutResponse | ServerTimeoutErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof getCountVerifiersOptions>>, TError,void, TContext>, request?: SecondParameter<typeof lp5AxiosClient>}
): UseMutationOptions<Awaited<ReturnType<typeof getCountVerifiersOptions>>, TError,void, TContext> => {

const mutationKey = ['getCountVerifiersOptions'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof getCountVerifiersOptions>>, void> = () => {


          return  getCountVerifiersOptions(requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type GetCountVerifiersOptionsMutationResult = NonNullable<Awaited<ReturnType<typeof getCountVerifiersOptions>>>

    export type GetCountVerifiersOptionsMutationError = RequestTimeoutResponse | InternalServerErrorResponse | ResponseTimeoutResponse | ServerTimeoutErrorResponse

    /**
 * @summary count verifiers options
 */
export const useGetCountVerifiersOptions = <TError = RequestTimeoutResponse | InternalServerErrorResponse | ResponseTimeoutResponse | ServerTimeoutErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof getCountVerifiersOptions>>, TError,void, TContext>, request?: SecondParameter<typeof lp5AxiosClient>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof getCountVerifiersOptions>>,
        TError,
        void,
        TContext
      > => {
      return useMutation(getGetCountVerifiersOptionsMutationOptions(options), queryClient);
    }

/**
 * Get verifier by ID.
 * @summary get verifier
 */
export const getVerifier = (
    verifierId: Uuid,
 options?: SecondParameter<typeof lp5AxiosClient>,signal?: AbortSignal
) => {


      return lp5AxiosClient<VerifierResponse>(
      {url: `/6/verifiers/${verifierId}`, method: 'GET', signal
    },
      options);
    }




export const getGetVerifierQueryKey = (verifierId: Uuid,) => {
    return [
    `/6/verifiers/${verifierId}`
    ] as const;
    }


export const getGetVerifierQueryOptions = <TData = Awaited<ReturnType<typeof getVerifier>>, TError = Error | AuthorizationErrorResponse | ForbiddenErrorWithServicesResponse | VerifierNotFoundResponse | RequestTimeoutResponse | InternalServerErrorResponse | ResponseTimeoutResponse | ServerTimeoutErrorResponse>(verifierId: Uuid, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getVerifier>>, TError, TData>>, request?: SecondParameter<typeof lp5AxiosClient>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetVerifierQueryKey(verifierId);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getVerifier>>> = ({ signal }) => getVerifier(verifierId, requestOptions, signal);





   return  { queryKey, queryFn, enabled: verifierId !== null && verifierId !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getVerifier>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetVerifierQueryResult = NonNullable<Awaited<ReturnType<typeof getVerifier>>>
export type GetVerifierQueryError = Error | AuthorizationErrorResponse | ForbiddenErrorWithServicesResponse | VerifierNotFoundResponse | RequestTimeoutResponse | InternalServerErrorResponse | ResponseTimeoutResponse | ServerTimeoutErrorResponse


export function useGetVerifier<TData = Awaited<ReturnType<typeof getVerifier>>, TError = Error | AuthorizationErrorResponse | ForbiddenErrorWithServicesResponse | VerifierNotFoundResponse | RequestTimeoutResponse | InternalServerErrorResponse | ResponseTimeoutResponse | ServerTimeoutErrorResponse>(
 verifierId: Uuid, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getVerifier>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getVerifier>>,
          TError,
          Awaited<ReturnType<typeof getVerifier>>
        > , 'initialData'
      >, request?: SecondParameter<typeof lp5AxiosClient>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetVerifier<TData = Awaited<ReturnType<typeof getVerifier>>, TError = Error | AuthorizationErrorResponse | ForbiddenErrorWithServicesResponse | VerifierNotFoundResponse | RequestTimeoutResponse | InternalServerErrorResponse | ResponseTimeoutResponse | ServerTimeoutErrorResponse>(
 verifierId: Uuid, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getVerifier>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getVerifier>>,
          TError,
          Awaited<ReturnType<typeof getVerifier>>
        > , 'initialData'
      >, request?: SecondParameter<typeof lp5AxiosClient>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetVerifier<TData = Awaited<ReturnType<typeof getVerifier>>, TError = Error | AuthorizationErrorResponse | ForbiddenErrorWithServicesResponse | VerifierNotFoundResponse | RequestTimeoutResponse | InternalServerErrorResponse | ResponseTimeoutResponse | ServerTimeoutErrorResponse>(
 verifierId: Uuid, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getVerifier>>, TError, TData>>, request?: SecondParameter<typeof lp5AxiosClient>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary get verifier
 */

export function useGetVerifier<TData = Awaited<ReturnType<typeof getVerifier>>, TError = Error | AuthorizationErrorResponse | ForbiddenErrorWithServicesResponse | VerifierNotFoundResponse | RequestTimeoutResponse | InternalServerErrorResponse | ResponseTimeoutResponse | ServerTimeoutErrorResponse>(
 verifierId: Uuid, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getVerifier>>, TError, TData>>, request?: SecondParameter<typeof lp5AxiosClient>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetVerifierQueryOptions(verifierId,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}







/**
 * Update the verifier. You can not update a part of verifier, so you should specify all the fields for your handler.
 * @summary replace verifier
 */
export const putVerifier = (
    verifierId: Uuid,
    newVerifier: NewVerifier,
 options?: SecondParameter<typeof lp5AxiosClient>,signal?: AbortSignal
) => {


      return lp5AxiosClient<PutVerifier200>(
      {url: `/6/verifiers/${verifierId}`, method: 'PUT',
      headers: {'Content-Type': 'application/json', },
      data: newVerifier, signal
    },
      options);
    }




export const getPutVerifierMutationOptions = <TError = Error | AuthorizationErrorResponse | ForbiddenErrorWithServicesResponse | VerifierNotFoundResponse | RequestTimeoutResponse | PayloadToLargeResponse | InternalServerErrorResponse | ResponseTimeoutResponse | ServerTimeoutErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof putVerifier>>, TError,{verifierId: Uuid;data: NewVerifier}, TContext>, request?: SecondParameter<typeof lp5AxiosClient>}
): UseMutationOptions<Awaited<ReturnType<typeof putVerifier>>, TError,{verifierId: Uuid;data: NewVerifier}, TContext> => {

const mutationKey = ['putVerifier'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof putVerifier>>, {verifierId: Uuid;data: NewVerifier}> = (props) => {
          const {verifierId,data} = props ?? {};

          return  putVerifier(verifierId,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type PutVerifierMutationResult = NonNullable<Awaited<ReturnType<typeof putVerifier>>>
    export type PutVerifierMutationBody = NewVerifier
    export type PutVerifierMutationError = Error | AuthorizationErrorResponse | ForbiddenErrorWithServicesResponse | VerifierNotFoundResponse | RequestTimeoutResponse | PayloadToLargeResponse | InternalServerErrorResponse | ResponseTimeoutResponse | ServerTimeoutErrorResponse

    /**
 * @summary replace verifier
 */
export const usePutVerifier = <TError = Error | AuthorizationErrorResponse | ForbiddenErrorWithServicesResponse | VerifierNotFoundResponse | RequestTimeoutResponse | PayloadToLargeResponse | InternalServerErrorResponse | ResponseTimeoutResponse | ServerTimeoutErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof putVerifier>>, TError,{verifierId: Uuid;data: NewVerifier}, TContext>, request?: SecondParameter<typeof lp5AxiosClient>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof putVerifier>>,
        TError,
        {verifierId: Uuid;data: NewVerifier},
        TContext
      > => {
      return useMutation(getPutVerifierMutationOptions(options), queryClient);
    }

/**
 * Check if verifier with `verifier_id` exists.
 * @summary check if verifier exists
 */
export const checkVerifier = (
    verifierId: Uuid,
 options?: SecondParameter<typeof lp5AxiosClient>,signal?: AbortSignal
) => {


      return lp5AxiosClient<void>(
      {url: `/6/verifiers/${verifierId}`, method: 'HEAD', signal
    },
      options);
    }




export const getCheckVerifierMutationOptions = <TError = void | AuthorizationErrorWithoutBodyResponse | ForbiddenErrorWithoutBodyResponse | RequestTimeoutWithoutBodyResponse | InternalServerErrorWithoutBodyResponse | ResponseTimeoutWithoutBodyResponse | ServerTimeoutErrorWithoutBodyResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof checkVerifier>>, TError,{verifierId: Uuid}, TContext>, request?: SecondParameter<typeof lp5AxiosClient>}
): UseMutationOptions<Awaited<ReturnType<typeof checkVerifier>>, TError,{verifierId: Uuid}, TContext> => {

const mutationKey = ['checkVerifier'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof checkVerifier>>, {verifierId: Uuid}> = (props) => {
          const {verifierId} = props ?? {};

          return  checkVerifier(verifierId,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type CheckVerifierMutationResult = NonNullable<Awaited<ReturnType<typeof checkVerifier>>>

    export type CheckVerifierMutationError = void | AuthorizationErrorWithoutBodyResponse | ForbiddenErrorWithoutBodyResponse | RequestTimeoutWithoutBodyResponse | InternalServerErrorWithoutBodyResponse | ResponseTimeoutWithoutBodyResponse | ServerTimeoutErrorWithoutBodyResponse

    /**
 * @summary check if verifier exists
 */
export const useCheckVerifier = <TError = void | AuthorizationErrorWithoutBodyResponse | ForbiddenErrorWithoutBodyResponse | RequestTimeoutWithoutBodyResponse | InternalServerErrorWithoutBodyResponse | ResponseTimeoutWithoutBodyResponse | ServerTimeoutErrorWithoutBodyResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof checkVerifier>>, TError,{verifierId: Uuid}, TContext>, request?: SecondParameter<typeof lp5AxiosClient>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof checkVerifier>>,
        TError,
        {verifierId: Uuid},
        TContext
      > => {
      return useMutation(getCheckVerifierMutationOptions(options), queryClient);
    }

/**
 * Remove verifier by ID.
 * @summary remove verifier
 */
export const removeVerifier = (
    verifierId: Uuid,
 options?: SecondParameter<typeof lp5AxiosClient>,signal?: AbortSignal
) => {


      return lp5AxiosClient<void>(
      {url: `/6/verifiers/${verifierId}`, method: 'DELETE', signal
    },
      options);
    }




export const getRemoveVerifierMutationOptions = <TError = Error | AuthorizationErrorResponse | ForbiddenErrorWithServicesResponse | VerifierNotFoundResponse | RequestTimeoutResponse | InternalServerErrorResponse | ResponseTimeoutResponse | ServerTimeoutErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof removeVerifier>>, TError,{verifierId: Uuid}, TContext>, request?: SecondParameter<typeof lp5AxiosClient>}
): UseMutationOptions<Awaited<ReturnType<typeof removeVerifier>>, TError,{verifierId: Uuid}, TContext> => {

const mutationKey = ['removeVerifier'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof removeVerifier>>, {verifierId: Uuid}> = (props) => {
          const {verifierId} = props ?? {};

          return  removeVerifier(verifierId,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type RemoveVerifierMutationResult = NonNullable<Awaited<ReturnType<typeof removeVerifier>>>

    export type RemoveVerifierMutationError = Error | AuthorizationErrorResponse | ForbiddenErrorWithServicesResponse | VerifierNotFoundResponse | RequestTimeoutResponse | InternalServerErrorResponse | ResponseTimeoutResponse | ServerTimeoutErrorResponse

    /**
 * @summary remove verifier
 */
export const useRemoveVerifier = <TError = Error | AuthorizationErrorResponse | ForbiddenErrorWithServicesResponse | VerifierNotFoundResponse | RequestTimeoutResponse | InternalServerErrorResponse | ResponseTimeoutResponse | ServerTimeoutErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof removeVerifier>>, TError,{verifierId: Uuid}, TContext>, request?: SecondParameter<typeof lp5AxiosClient>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof removeVerifier>>,
        TError,
        {verifierId: Uuid},
        TContext
      > => {
      return useMutation(getRemoveVerifierMutationOptions(options), queryClient);
    }

/**
 * Get options for the resource.
 * @summary verifier options
 */
export const getVerifierOptions = (
    verifierId: Uuid,
 options?: SecondParameter<typeof lp5AxiosClient>,signal?: AbortSignal
) => {


      return lp5AxiosClient<void>(
      {url: `/6/verifiers/${verifierId}`, method: 'OPTIONS', signal
    },
      options);
    }




export const getGetVerifierOptionsMutationOptions = <TError = RequestTimeoutResponse | InternalServerErrorResponse | ResponseTimeoutResponse | ServerTimeoutErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof getVerifierOptions>>, TError,{verifierId: Uuid}, TContext>, request?: SecondParameter<typeof lp5AxiosClient>}
): UseMutationOptions<Awaited<ReturnType<typeof getVerifierOptions>>, TError,{verifierId: Uuid}, TContext> => {

const mutationKey = ['getVerifierOptions'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof getVerifierOptions>>, {verifierId: Uuid}> = (props) => {
          const {verifierId} = props ?? {};

          return  getVerifierOptions(verifierId,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type GetVerifierOptionsMutationResult = NonNullable<Awaited<ReturnType<typeof getVerifierOptions>>>

    export type GetVerifierOptionsMutationError = RequestTimeoutResponse | InternalServerErrorResponse | ResponseTimeoutResponse | ServerTimeoutErrorResponse

    /**
 * @summary verifier options
 */
export const useGetVerifierOptions = <TError = RequestTimeoutResponse | InternalServerErrorResponse | ResponseTimeoutResponse | ServerTimeoutErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof getVerifierOptions>>, TError,{verifierId: Uuid}, TContext>, request?: SecondParameter<typeof lp5AxiosClient>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof getVerifierOptions>>,
        TError,
        {verifierId: Uuid},
        TContext
      > => {
      return useMutation(getGetVerifierOptionsMutationOptions(options), queryClient);
    }

/**
 * Ws handshake.
 * > ### Attention!
 * > **Subscription to events occurs via [WebSocket](https://en.wikipedia.org/wiki/WebSocket).**
 * > Messages sent by ws you can view in callback section.
 * > Connection supports [autoping](https://tools.ietf.org/html/rfc6455#section-5.5.2).
 * @summary ws handshake
 */
export const wsHandshake = (
    params?: WsHandshakeParams,
 options?: SecondParameter<typeof lp5AxiosClient>,signal?: AbortSignal
) => {


      return lp5AxiosClient<unknown>(
      {url: `/6/ws`, method: 'GET',
        params, signal
    },
      options);
    }




export const getWsHandshakeQueryKey = (params?: WsHandshakeParams,) => {
    return [
    `/6/ws`, ...(params ? [params] : [])
    ] as const;
    }


export const getWsHandshakeQueryOptions = <TData = Awaited<ReturnType<typeof wsHandshake>>, TError = MessageFromWs | Error | AuthorizationErrorResponse | ForbiddenErrorResponse | RequestTimeoutResponse | InternalServerErrorResponse | ResponseTimeoutResponse | ServerTimeoutErrorResponse>(params?: WsHandshakeParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof wsHandshake>>, TError, TData>>, request?: SecondParameter<typeof lp5AxiosClient>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getWsHandshakeQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof wsHandshake>>> = ({ signal }) => wsHandshake(params, requestOptions, signal);





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof wsHandshake>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type WsHandshakeQueryResult = NonNullable<Awaited<ReturnType<typeof wsHandshake>>>
export type WsHandshakeQueryError = MessageFromWs | Error | AuthorizationErrorResponse | ForbiddenErrorResponse | RequestTimeoutResponse | InternalServerErrorResponse | ResponseTimeoutResponse | ServerTimeoutErrorResponse


export function useWsHandshake<TData = Awaited<ReturnType<typeof wsHandshake>>, TError = MessageFromWs | Error | AuthorizationErrorResponse | ForbiddenErrorResponse | RequestTimeoutResponse | InternalServerErrorResponse | ResponseTimeoutResponse | ServerTimeoutErrorResponse>(
 params: undefined |  WsHandshakeParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof wsHandshake>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof wsHandshake>>,
          TError,
          Awaited<ReturnType<typeof wsHandshake>>
        > , 'initialData'
      >, request?: SecondParameter<typeof lp5AxiosClient>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useWsHandshake<TData = Awaited<ReturnType<typeof wsHandshake>>, TError = MessageFromWs | Error | AuthorizationErrorResponse | ForbiddenErrorResponse | RequestTimeoutResponse | InternalServerErrorResponse | ResponseTimeoutResponse | ServerTimeoutErrorResponse>(
 params?: WsHandshakeParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof wsHandshake>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof wsHandshake>>,
          TError,
          Awaited<ReturnType<typeof wsHandshake>>
        > , 'initialData'
      >, request?: SecondParameter<typeof lp5AxiosClient>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useWsHandshake<TData = Awaited<ReturnType<typeof wsHandshake>>, TError = MessageFromWs | Error | AuthorizationErrorResponse | ForbiddenErrorResponse | RequestTimeoutResponse | InternalServerErrorResponse | ResponseTimeoutResponse | ServerTimeoutErrorResponse>(
 params?: WsHandshakeParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof wsHandshake>>, TError, TData>>, request?: SecondParameter<typeof lp5AxiosClient>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary ws handshake
 */

export function useWsHandshake<TData = Awaited<ReturnType<typeof wsHandshake>>, TError = MessageFromWs | Error | AuthorizationErrorResponse | ForbiddenErrorResponse | RequestTimeoutResponse | InternalServerErrorResponse | ResponseTimeoutResponse | ServerTimeoutErrorResponse>(
 params?: WsHandshakeParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof wsHandshake>>, TError, TData>>, request?: SecondParameter<typeof lp5AxiosClient>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getWsHandshakeQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}







/**
 * Ws handshake.
 * > ### Attention!
 * > **Subscription to events occurs via [WebSocket](https://en.wikipedia.org/wiki/WebSocket).**
 * > Messages sent by ws you can view in callback section.
 * > Connection supports [autoping](https://tools.ietf.org/html/rfc6455#section-5.5.2).
 * @summary ws handshake for general events [beta]
 */
export const wsHandshakeForGeneralEvents = (
    params?: WsHandshakeForGeneralEventsParams,
 options?: SecondParameter<typeof lp5AxiosClient>,signal?: AbortSignal
) => {


      return lp5AxiosClient<unknown>(
      {url: `/6/general/ws`, method: 'GET',
        params, signal
    },
      options);
    }




export const getWsHandshakeForGeneralEventsQueryKey = (params?: WsHandshakeForGeneralEventsParams,) => {
    return [
    `/6/general/ws`, ...(params ? [params] : [])
    ] as const;
    }


export const getWsHandshakeForGeneralEventsQueryOptions = <TData = Awaited<ReturnType<typeof wsHandshakeForGeneralEvents>>, TError = MessageFromGeneralWs | Error | AuthorizationErrorResponse | ForbiddenErrorResponse | RequestTimeoutResponse | InternalServerErrorResponse | ResponseTimeoutResponse | ServerTimeoutErrorResponse>(params?: WsHandshakeForGeneralEventsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof wsHandshakeForGeneralEvents>>, TError, TData>>, request?: SecondParameter<typeof lp5AxiosClient>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getWsHandshakeForGeneralEventsQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof wsHandshakeForGeneralEvents>>> = ({ signal }) => wsHandshakeForGeneralEvents(params, requestOptions, signal);





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof wsHandshakeForGeneralEvents>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type WsHandshakeForGeneralEventsQueryResult = NonNullable<Awaited<ReturnType<typeof wsHandshakeForGeneralEvents>>>
export type WsHandshakeForGeneralEventsQueryError = MessageFromGeneralWs | Error | AuthorizationErrorResponse | ForbiddenErrorResponse | RequestTimeoutResponse | InternalServerErrorResponse | ResponseTimeoutResponse | ServerTimeoutErrorResponse


export function useWsHandshakeForGeneralEvents<TData = Awaited<ReturnType<typeof wsHandshakeForGeneralEvents>>, TError = MessageFromGeneralWs | Error | AuthorizationErrorResponse | ForbiddenErrorResponse | RequestTimeoutResponse | InternalServerErrorResponse | ResponseTimeoutResponse | ServerTimeoutErrorResponse>(
 params: undefined |  WsHandshakeForGeneralEventsParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof wsHandshakeForGeneralEvents>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof wsHandshakeForGeneralEvents>>,
          TError,
          Awaited<ReturnType<typeof wsHandshakeForGeneralEvents>>
        > , 'initialData'
      >, request?: SecondParameter<typeof lp5AxiosClient>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useWsHandshakeForGeneralEvents<TData = Awaited<ReturnType<typeof wsHandshakeForGeneralEvents>>, TError = MessageFromGeneralWs | Error | AuthorizationErrorResponse | ForbiddenErrorResponse | RequestTimeoutResponse | InternalServerErrorResponse | ResponseTimeoutResponse | ServerTimeoutErrorResponse>(
 params?: WsHandshakeForGeneralEventsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof wsHandshakeForGeneralEvents>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof wsHandshakeForGeneralEvents>>,
          TError,
          Awaited<ReturnType<typeof wsHandshakeForGeneralEvents>>
        > , 'initialData'
      >, request?: SecondParameter<typeof lp5AxiosClient>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useWsHandshakeForGeneralEvents<TData = Awaited<ReturnType<typeof wsHandshakeForGeneralEvents>>, TError = MessageFromGeneralWs | Error | AuthorizationErrorResponse | ForbiddenErrorResponse | RequestTimeoutResponse | InternalServerErrorResponse | ResponseTimeoutResponse | ServerTimeoutErrorResponse>(
 params?: WsHandshakeForGeneralEventsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof wsHandshakeForGeneralEvents>>, TError, TData>>, request?: SecondParameter<typeof lp5AxiosClient>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary ws handshake for general events [beta]
 */

export function useWsHandshakeForGeneralEvents<TData = Awaited<ReturnType<typeof wsHandshakeForGeneralEvents>>, TError = MessageFromGeneralWs | Error | AuthorizationErrorResponse | ForbiddenErrorResponse | RequestTimeoutResponse | InternalServerErrorResponse | ResponseTimeoutResponse | ServerTimeoutErrorResponse>(
 params?: WsHandshakeForGeneralEventsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof wsHandshakeForGeneralEvents>>, TError, TData>>, request?: SecondParameter<typeof lp5AxiosClient>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getWsHandshakeForGeneralEventsQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}







/**
 * **Warning: only for service use**
 *
 * Publish events generated by the user.
 * @summary publish general events
 */
export const publishGeneralEvents = (
    generalEventInput: GeneralEventInput,
 options?: SecondParameter<typeof lp5AxiosClient>,signal?: AbortSignal
) => {


      return lp5AxiosClient<void>(
      {url: `/6/ws/general/events`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: generalEventInput, signal
    },
      options);
    }




export const getPublishGeneralEventsMutationOptions = <TError = Error | AuthorizationErrorResponse | ForbiddenErrorResponse | RequestTimeoutResponse | PayloadToLargeResponse | InternalServerErrorResponse | ResponseTimeoutResponse | ServerTimeoutErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof publishGeneralEvents>>, TError,{data: GeneralEventInput}, TContext>, request?: SecondParameter<typeof lp5AxiosClient>}
): UseMutationOptions<Awaited<ReturnType<typeof publishGeneralEvents>>, TError,{data: GeneralEventInput}, TContext> => {

const mutationKey = ['publishGeneralEvents'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof publishGeneralEvents>>, {data: GeneralEventInput}> = (props) => {
          const {data} = props ?? {};

          return  publishGeneralEvents(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type PublishGeneralEventsMutationResult = NonNullable<Awaited<ReturnType<typeof publishGeneralEvents>>>
    export type PublishGeneralEventsMutationBody = GeneralEventInput
    export type PublishGeneralEventsMutationError = Error | AuthorizationErrorResponse | ForbiddenErrorResponse | RequestTimeoutResponse | PayloadToLargeResponse | InternalServerErrorResponse | ResponseTimeoutResponse | ServerTimeoutErrorResponse

    /**
 * @summary publish general events
 */
export const usePublishGeneralEvents = <TError = Error | AuthorizationErrorResponse | ForbiddenErrorResponse | RequestTimeoutResponse | PayloadToLargeResponse | InternalServerErrorResponse | ResponseTimeoutResponse | ServerTimeoutErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof publishGeneralEvents>>, TError,{data: GeneralEventInput}, TContext>, request?: SecondParameter<typeof lp5AxiosClient>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof publishGeneralEvents>>,
        TError,
        {data: GeneralEventInput},
        TContext
      > => {
      return useMutation(getPublishGeneralEventsMutationOptions(options), queryClient);
    }

/**
 * Get options for the resource.
 * @summary ws general events options
 */
export const getWsGeneralEventsOptions = (

 options?: SecondParameter<typeof lp5AxiosClient>,signal?: AbortSignal
) => {


      return lp5AxiosClient<void>(
      {url: `/6/ws/general/events`, method: 'OPTIONS', signal
    },
      options);
    }




export const getGetWsGeneralEventsOptionsMutationOptions = <TError = RequestTimeoutResponse | InternalServerErrorResponse | ResponseTimeoutResponse | ServerTimeoutErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof getWsGeneralEventsOptions>>, TError,void, TContext>, request?: SecondParameter<typeof lp5AxiosClient>}
): UseMutationOptions<Awaited<ReturnType<typeof getWsGeneralEventsOptions>>, TError,void, TContext> => {

const mutationKey = ['getWsGeneralEventsOptions'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof getWsGeneralEventsOptions>>, void> = () => {


          return  getWsGeneralEventsOptions(requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type GetWsGeneralEventsOptionsMutationResult = NonNullable<Awaited<ReturnType<typeof getWsGeneralEventsOptions>>>

    export type GetWsGeneralEventsOptionsMutationError = RequestTimeoutResponse | InternalServerErrorResponse | ResponseTimeoutResponse | ServerTimeoutErrorResponse

    /**
 * @summary ws general events options
 */
export const useGetWsGeneralEventsOptions = <TError = RequestTimeoutResponse | InternalServerErrorResponse | ResponseTimeoutResponse | ServerTimeoutErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof getWsGeneralEventsOptions>>, TError,void, TContext>, request?: SecondParameter<typeof lp5AxiosClient>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof getWsGeneralEventsOptions>>,
        TError,
        void,
        TContext
      > => {
      return useMutation(getGetWsGeneralEventsOptionsMutationOptions(options), queryClient);
    }

/**
 * Set login cookie.
 * @summary set login cookie
 */
export const setLoginCookie = (

 options?: SecondParameter<typeof lp5AxiosClient>,signal?: AbortSignal
) => {


      return lp5AxiosClient<void>(
      {url: `/6/login`, method: 'POST', signal
    },
      options);
    }




export const getSetLoginCookieMutationOptions = <TError = AuthorizationErrorResponse | RequestTimeoutResponse | InternalServerErrorResponse | ResponseTimeoutResponse | ServerTimeoutErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof setLoginCookie>>, TError,void, TContext>, request?: SecondParameter<typeof lp5AxiosClient>}
): UseMutationOptions<Awaited<ReturnType<typeof setLoginCookie>>, TError,void, TContext> => {

const mutationKey = ['setLoginCookie'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof setLoginCookie>>, void> = () => {


          return  setLoginCookie(requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type SetLoginCookieMutationResult = NonNullable<Awaited<ReturnType<typeof setLoginCookie>>>

    export type SetLoginCookieMutationError = AuthorizationErrorResponse | RequestTimeoutResponse | InternalServerErrorResponse | ResponseTimeoutResponse | ServerTimeoutErrorResponse

    /**
 * @summary set login cookie
 */
export const useSetLoginCookie = <TError = AuthorizationErrorResponse | RequestTimeoutResponse | InternalServerErrorResponse | ResponseTimeoutResponse | ServerTimeoutErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof setLoginCookie>>, TError,void, TContext>, request?: SecondParameter<typeof lp5AxiosClient>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof setLoginCookie>>,
        TError,
        void,
        TContext
      > => {
      return useMutation(getSetLoginCookieMutationOptions(options), queryClient);
    }

/**
 * Clear login cookie.
 * @summary clear login cookie
 */
export const deleteLoginCookie = (

 options?: SecondParameter<typeof lp5AxiosClient>,signal?: AbortSignal
) => {


      return lp5AxiosClient<void>(
      {url: `/6/login`, method: 'DELETE', signal
    },
      options);
    }




export const getDeleteLoginCookieMutationOptions = <TError = RequestTimeoutResponse | InternalServerErrorResponse | ResponseTimeoutResponse | ServerTimeoutErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteLoginCookie>>, TError,void, TContext>, request?: SecondParameter<typeof lp5AxiosClient>}
): UseMutationOptions<Awaited<ReturnType<typeof deleteLoginCookie>>, TError,void, TContext> => {

const mutationKey = ['deleteLoginCookie'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof deleteLoginCookie>>, void> = () => {


          return  deleteLoginCookie(requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type DeleteLoginCookieMutationResult = NonNullable<Awaited<ReturnType<typeof deleteLoginCookie>>>

    export type DeleteLoginCookieMutationError = RequestTimeoutResponse | InternalServerErrorResponse | ResponseTimeoutResponse | ServerTimeoutErrorResponse

    /**
 * @summary clear login cookie
 */
export const useDeleteLoginCookie = <TError = RequestTimeoutResponse | InternalServerErrorResponse | ResponseTimeoutResponse | ServerTimeoutErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteLoginCookie>>, TError,void, TContext>, request?: SecondParameter<typeof lp5AxiosClient>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof deleteLoginCookie>>,
        TError,
        void,
        TContext
      > => {
      return useMutation(getDeleteLoginCookieMutationOptions(options), queryClient);
    }

/**
 * Get options for the resource.
 * @summary login cookie options
 */
export const getLoginCookieOptions = (

 options?: SecondParameter<typeof lp5AxiosClient>,signal?: AbortSignal
) => {


      return lp5AxiosClient<void>(
      {url: `/6/login`, method: 'OPTIONS', signal
    },
      options);
    }




export const getGetLoginCookieOptionsMutationOptions = <TError = RequestTimeoutResponse | InternalServerErrorResponse | ResponseTimeoutResponse | ServerTimeoutErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof getLoginCookieOptions>>, TError,void, TContext>, request?: SecondParameter<typeof lp5AxiosClient>}
): UseMutationOptions<Awaited<ReturnType<typeof getLoginCookieOptions>>, TError,void, TContext> => {

const mutationKey = ['getLoginCookieOptions'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof getLoginCookieOptions>>, void> = () => {


          return  getLoginCookieOptions(requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type GetLoginCookieOptionsMutationResult = NonNullable<Awaited<ReturnType<typeof getLoginCookieOptions>>>

    export type GetLoginCookieOptionsMutationError = RequestTimeoutResponse | InternalServerErrorResponse | ResponseTimeoutResponse | ServerTimeoutErrorResponse

    /**
 * @summary login cookie options
 */
export const useGetLoginCookieOptions = <TError = RequestTimeoutResponse | InternalServerErrorResponse | ResponseTimeoutResponse | ServerTimeoutErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof getLoginCookieOptions>>, TError,void, TContext>, request?: SecondParameter<typeof lp5AxiosClient>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof getLoginCookieOptions>>,
        TError,
        void,
        TContext
      > => {
      return useMutation(getGetLoginCookieOptionsMutationOptions(options), queryClient);
    }

/**
 *
 * Predict liveness probability in input images.
 *
 * The response contains the probability that there is a real person in the image, and it is not a presentation attack.
 *
 * "meta" and "x_meta" sections of the request are used for backward compatibility and are deprecated now.
 *
 * The incoming images should correspond the requirements of the utilized Liveness version. See "Administrator’s manual" for details.
 *
 * *Liveness estimation is not supported for samples (warped images).*
 * @summary predict liveness
 */
export const predictLiveness = (
    predictLivenessBody: PredictLivenessBodyOne | PredictLivenessBodyTwo | Blob,
    params?: PredictLivenessParams,
 options?: SecondParameter<typeof lp5AxiosClient>,signal?: AbortSignal
) => {


      return lp5AxiosClient<LivenessResponse>(
      {url: `/6/liveness`, method: 'POST',
      data: predictLivenessBody,
        params, signal
    },
      options);
    }




export const getPredictLivenessMutationOptions = <TError = Error | AuthorizationErrorResponse | RequestTimeoutResponse | PayloadToLargeResponse | InternalServerErrorResponse | ResponseTimeoutResponse | ServerTimeoutErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof predictLiveness>>, TError,{data: PredictLivenessBodyOne | PredictLivenessBodyTwo | Blob;params?: PredictLivenessParams}, TContext>, request?: SecondParameter<typeof lp5AxiosClient>}
): UseMutationOptions<Awaited<ReturnType<typeof predictLiveness>>, TError,{data: PredictLivenessBodyOne | PredictLivenessBodyTwo | Blob;params?: PredictLivenessParams}, TContext> => {

const mutationKey = ['predictLiveness'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof predictLiveness>>, {data: PredictLivenessBodyOne | PredictLivenessBodyTwo | Blob;params?: PredictLivenessParams}> = (props) => {
          const {data,params} = props ?? {};

          return  predictLiveness(data,params,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type PredictLivenessMutationResult = NonNullable<Awaited<ReturnType<typeof predictLiveness>>>
    export type PredictLivenessMutationBody = PredictLivenessBodyOne | PredictLivenessBodyTwo | Blob
    export type PredictLivenessMutationError = Error | AuthorizationErrorResponse | RequestTimeoutResponse | PayloadToLargeResponse | InternalServerErrorResponse | ResponseTimeoutResponse | ServerTimeoutErrorResponse

    /**
 * @summary predict liveness
 */
export const usePredictLiveness = <TError = Error | AuthorizationErrorResponse | RequestTimeoutResponse | PayloadToLargeResponse | InternalServerErrorResponse | ResponseTimeoutResponse | ServerTimeoutErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof predictLiveness>>, TError,{data: PredictLivenessBodyOne | PredictLivenessBodyTwo | Blob;params?: PredictLivenessParams}, TContext>, request?: SecondParameter<typeof lp5AxiosClient>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof predictLiveness>>,
        TError,
        {data: PredictLivenessBodyOne | PredictLivenessBodyTwo | Blob;params?: PredictLivenessParams},
        TContext
      > => {
      return useMutation(getPredictLivenessMutationOptions(options), queryClient);
    }

/**
 * Get options for the resource.
 * @summary liveness options
 */
export const getLivenessOptions = (

 options?: SecondParameter<typeof lp5AxiosClient>,signal?: AbortSignal
) => {


      return lp5AxiosClient<void>(
      {url: `/6/liveness`, method: 'OPTIONS', signal
    },
      options);
    }




export const getGetLivenessOptionsMutationOptions = <TError = RequestTimeoutResponse | InternalServerErrorResponse | ResponseTimeoutResponse | ServerTimeoutErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof getLivenessOptions>>, TError,void, TContext>, request?: SecondParameter<typeof lp5AxiosClient>}
): UseMutationOptions<Awaited<ReturnType<typeof getLivenessOptions>>, TError,void, TContext> => {

const mutationKey = ['getLivenessOptions'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof getLivenessOptions>>, void> = () => {


          return  getLivenessOptions(requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type GetLivenessOptionsMutationResult = NonNullable<Awaited<ReturnType<typeof getLivenessOptions>>>

    export type GetLivenessOptionsMutationError = RequestTimeoutResponse | InternalServerErrorResponse | ResponseTimeoutResponse | ServerTimeoutErrorResponse

    /**
 * @summary liveness options
 */
export const useGetLivenessOptions = <TError = RequestTimeoutResponse | InternalServerErrorResponse | ResponseTimeoutResponse | ServerTimeoutErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof getLivenessOptions>>, TError,void, TContext>, request?: SecondParameter<typeof lp5AxiosClient>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof getLivenessOptions>>,
        TError,
        void,
        TContext
      > => {
      return useMutation(getGetLivenessOptionsMutationOptions(options), queryClient);
    }

/**
 * Get service OpenApi documentation. If *Accept* request header is of type `application/x-yaml`,
 * returns documentation in `yaml` format or returns `html` documentation, if *Accept* is `text/html`.
 * @summary get openapi documentation
 */
export const getSpec = (

 options?: SecondParameter<typeof lp5AxiosClient>,signal?: AbortSignal
) => {


      return lp5AxiosClient<string>(
      {url: `/6/docs/spec`, method: 'GET', signal
    },
      options);
    }




export const getGetSpecQueryKey = () => {
    return [
    `/6/docs/spec`
    ] as const;
    }


export const getGetSpecQueryOptions = <TData = Awaited<ReturnType<typeof getSpec>>, TError = RequestTimeoutResponse | Error | InternalServerErrorResponse | ResponseTimeoutResponse | ServerTimeoutErrorResponse>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getSpec>>, TError, TData>>, request?: SecondParameter<typeof lp5AxiosClient>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetSpecQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getSpec>>> = ({ signal }) => getSpec(requestOptions, signal);





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getSpec>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetSpecQueryResult = NonNullable<Awaited<ReturnType<typeof getSpec>>>
export type GetSpecQueryError = RequestTimeoutResponse | Error | InternalServerErrorResponse | ResponseTimeoutResponse | ServerTimeoutErrorResponse


export function useGetSpec<TData = Awaited<ReturnType<typeof getSpec>>, TError = RequestTimeoutResponse | Error | InternalServerErrorResponse | ResponseTimeoutResponse | ServerTimeoutErrorResponse>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getSpec>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getSpec>>,
          TError,
          Awaited<ReturnType<typeof getSpec>>
        > , 'initialData'
      >, request?: SecondParameter<typeof lp5AxiosClient>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetSpec<TData = Awaited<ReturnType<typeof getSpec>>, TError = RequestTimeoutResponse | Error | InternalServerErrorResponse | ResponseTimeoutResponse | ServerTimeoutErrorResponse>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getSpec>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getSpec>>,
          TError,
          Awaited<ReturnType<typeof getSpec>>
        > , 'initialData'
      >, request?: SecondParameter<typeof lp5AxiosClient>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetSpec<TData = Awaited<ReturnType<typeof getSpec>>, TError = RequestTimeoutResponse | Error | InternalServerErrorResponse | ResponseTimeoutResponse | ServerTimeoutErrorResponse>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getSpec>>, TError, TData>>, request?: SecondParameter<typeof lp5AxiosClient>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary get openapi documentation
 */

export function useGetSpec<TData = Awaited<ReturnType<typeof getSpec>>, TError = RequestTimeoutResponse | Error | InternalServerErrorResponse | ResponseTimeoutResponse | ServerTimeoutErrorResponse>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getSpec>>, TError, TData>>, request?: SecondParameter<typeof lp5AxiosClient>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetSpecQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}







/**
 * Get options for the resource.
 * @summary get openapi documentation options
 */
export const getSpecOptions = (

 options?: SecondParameter<typeof lp5AxiosClient>,signal?: AbortSignal
) => {


      return lp5AxiosClient<void>(
      {url: `/6/docs/spec`, method: 'OPTIONS', signal
    },
      options);
    }




export const getGetSpecOptionsMutationOptions = <TError = RequestTimeoutResponse | InternalServerErrorResponse | ResponseTimeoutResponse | ServerTimeoutErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof getSpecOptions>>, TError,void, TContext>, request?: SecondParameter<typeof lp5AxiosClient>}
): UseMutationOptions<Awaited<ReturnType<typeof getSpecOptions>>, TError,void, TContext> => {

const mutationKey = ['getSpecOptions'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof getSpecOptions>>, void> = () => {


          return  getSpecOptions(requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type GetSpecOptionsMutationResult = NonNullable<Awaited<ReturnType<typeof getSpecOptions>>>

    export type GetSpecOptionsMutationError = RequestTimeoutResponse | InternalServerErrorResponse | ResponseTimeoutResponse | ServerTimeoutErrorResponse

    /**
 * @summary get openapi documentation options
 */
export const useGetSpecOptions = <TError = RequestTimeoutResponse | InternalServerErrorResponse | ResponseTimeoutResponse | ServerTimeoutErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof getSpecOptions>>, TError,void, TContext>, request?: SecondParameter<typeof lp5AxiosClient>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof getSpecOptions>>,
        TError,
        void,
        TContext
      > => {
      return useMutation(getGetSpecOptionsMutationOptions(options), queryClient);
    }

/**
 * Get sphinx documentation - *Development Manual*. After the request you will be redirected to the page `/docs/dev/index.html`
 * @summary get development manual
 */
export const getDevManual = (

 options?: SecondParameter<typeof lp5AxiosClient>,signal?: AbortSignal
) => {


      return lp5AxiosClient<string>(
      {url: `/6/docs/dev`, method: 'GET', signal
    },
      options);
    }




export const getGetDevManualQueryKey = () => {
    return [
    `/6/docs/dev`
    ] as const;
    }


export const getGetDevManualQueryOptions = <TData = Awaited<ReturnType<typeof getDevManual>>, TError = RequestTimeoutResponse | InternalServerErrorResponse | ResponseTimeoutResponse | ServerTimeoutErrorResponse>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getDevManual>>, TError, TData>>, request?: SecondParameter<typeof lp5AxiosClient>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetDevManualQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getDevManual>>> = ({ signal }) => getDevManual(requestOptions, signal);





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getDevManual>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetDevManualQueryResult = NonNullable<Awaited<ReturnType<typeof getDevManual>>>
export type GetDevManualQueryError = RequestTimeoutResponse | InternalServerErrorResponse | ResponseTimeoutResponse | ServerTimeoutErrorResponse


export function useGetDevManual<TData = Awaited<ReturnType<typeof getDevManual>>, TError = RequestTimeoutResponse | InternalServerErrorResponse | ResponseTimeoutResponse | ServerTimeoutErrorResponse>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getDevManual>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getDevManual>>,
          TError,
          Awaited<ReturnType<typeof getDevManual>>
        > , 'initialData'
      >, request?: SecondParameter<typeof lp5AxiosClient>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetDevManual<TData = Awaited<ReturnType<typeof getDevManual>>, TError = RequestTimeoutResponse | InternalServerErrorResponse | ResponseTimeoutResponse | ServerTimeoutErrorResponse>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getDevManual>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getDevManual>>,
          TError,
          Awaited<ReturnType<typeof getDevManual>>
        > , 'initialData'
      >, request?: SecondParameter<typeof lp5AxiosClient>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetDevManual<TData = Awaited<ReturnType<typeof getDevManual>>, TError = RequestTimeoutResponse | InternalServerErrorResponse | ResponseTimeoutResponse | ServerTimeoutErrorResponse>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getDevManual>>, TError, TData>>, request?: SecondParameter<typeof lp5AxiosClient>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary get development manual
 */

export function useGetDevManual<TData = Awaited<ReturnType<typeof getDevManual>>, TError = RequestTimeoutResponse | InternalServerErrorResponse | ResponseTimeoutResponse | ServerTimeoutErrorResponse>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getDevManual>>, TError, TData>>, request?: SecondParameter<typeof lp5AxiosClient>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetDevManualQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}







/**
 * Get options for the resource.
 * @summary get development documentation options
 */
export const getDevOptions = (

 options?: SecondParameter<typeof lp5AxiosClient>,signal?: AbortSignal
) => {


      return lp5AxiosClient<void>(
      {url: `/6/docs/dev`, method: 'OPTIONS', signal
    },
      options);
    }




export const getGetDevOptionsMutationOptions = <TError = RequestTimeoutResponse | InternalServerErrorResponse | ResponseTimeoutResponse | ServerTimeoutErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof getDevOptions>>, TError,void, TContext>, request?: SecondParameter<typeof lp5AxiosClient>}
): UseMutationOptions<Awaited<ReturnType<typeof getDevOptions>>, TError,void, TContext> => {

const mutationKey = ['getDevOptions'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof getDevOptions>>, void> = () => {


          return  getDevOptions(requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type GetDevOptionsMutationResult = NonNullable<Awaited<ReturnType<typeof getDevOptions>>>

    export type GetDevOptionsMutationError = RequestTimeoutResponse | InternalServerErrorResponse | ResponseTimeoutResponse | ServerTimeoutErrorResponse

    /**
 * @summary get development documentation options
 */
export const useGetDevOptions = <TError = RequestTimeoutResponse | InternalServerErrorResponse | ResponseTimeoutResponse | ServerTimeoutErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof getDevOptions>>, TError,void, TContext>, request?: SecondParameter<typeof lp5AxiosClient>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof getDevOptions>>,
        TError,
        void,
        TContext
      > => {
      return useMutation(getGetDevOptionsMutationOptions(options), queryClient);
    }

/**
 * Get service configuration. Passwords and tokens will be hidden in the response.
 * @summary get service configuration
 */
export const getConfig = (

 options?: SecondParameter<typeof lp5AxiosClient>,signal?: AbortSignal
) => {


      return lp5AxiosClient<GetConfig200One | string>(
      {url: `/6/config`, method: 'GET', signal
    },
      options);
    }




export const getGetConfigQueryKey = () => {
    return [
    `/6/config`
    ] as const;
    }


export const getGetConfigQueryOptions = <TData = Awaited<ReturnType<typeof getConfig>>, TError = RequestTimeoutResponse | Error | InternalServerErrorResponse | ResponseTimeoutResponse | ServerTimeoutErrorResponse>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getConfig>>, TError, TData>>, request?: SecondParameter<typeof lp5AxiosClient>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetConfigQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getConfig>>> = ({ signal }) => getConfig(requestOptions, signal);





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getConfig>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetConfigQueryResult = NonNullable<Awaited<ReturnType<typeof getConfig>>>
export type GetConfigQueryError = RequestTimeoutResponse | Error | InternalServerErrorResponse | ResponseTimeoutResponse | ServerTimeoutErrorResponse


export function useGetConfig<TData = Awaited<ReturnType<typeof getConfig>>, TError = RequestTimeoutResponse | Error | InternalServerErrorResponse | ResponseTimeoutResponse | ServerTimeoutErrorResponse>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getConfig>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getConfig>>,
          TError,
          Awaited<ReturnType<typeof getConfig>>
        > , 'initialData'
      >, request?: SecondParameter<typeof lp5AxiosClient>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetConfig<TData = Awaited<ReturnType<typeof getConfig>>, TError = RequestTimeoutResponse | Error | InternalServerErrorResponse | ResponseTimeoutResponse | ServerTimeoutErrorResponse>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getConfig>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getConfig>>,
          TError,
          Awaited<ReturnType<typeof getConfig>>
        > , 'initialData'
      >, request?: SecondParameter<typeof lp5AxiosClient>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetConfig<TData = Awaited<ReturnType<typeof getConfig>>, TError = RequestTimeoutResponse | Error | InternalServerErrorResponse | ResponseTimeoutResponse | ServerTimeoutErrorResponse>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getConfig>>, TError, TData>>, request?: SecondParameter<typeof lp5AxiosClient>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary get service configuration
 */

export function useGetConfig<TData = Awaited<ReturnType<typeof getConfig>>, TError = RequestTimeoutResponse | Error | InternalServerErrorResponse | ResponseTimeoutResponse | ServerTimeoutErrorResponse>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getConfig>>, TError, TData>>, request?: SecondParameter<typeof lp5AxiosClient>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetConfigQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}







/**
 * Get options for the resource.
 * @summary get config options
 */
export const getConfigOptions = (

 options?: SecondParameter<typeof lp5AxiosClient>,signal?: AbortSignal
) => {


      return lp5AxiosClient<void>(
      {url: `/6/config`, method: 'OPTIONS', signal
    },
      options);
    }




export const getGetConfigOptionsMutationOptions = <TError = RequestTimeoutResponse | InternalServerErrorResponse | ResponseTimeoutResponse | ServerTimeoutErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof getConfigOptions>>, TError,void, TContext>, request?: SecondParameter<typeof lp5AxiosClient>}
): UseMutationOptions<Awaited<ReturnType<typeof getConfigOptions>>, TError,void, TContext> => {

const mutationKey = ['getConfigOptions'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof getConfigOptions>>, void> = () => {


          return  getConfigOptions(requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type GetConfigOptionsMutationResult = NonNullable<Awaited<ReturnType<typeof getConfigOptions>>>

    export type GetConfigOptionsMutationError = RequestTimeoutResponse | InternalServerErrorResponse | ResponseTimeoutResponse | ServerTimeoutErrorResponse

    /**
 * @summary get config options
 */
export const useGetConfigOptions = <TError = RequestTimeoutResponse | InternalServerErrorResponse | ResponseTimeoutResponse | ServerTimeoutErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof getConfigOptions>>, TError,void, TContext>, request?: SecondParameter<typeof lp5AxiosClient>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof getConfigOptions>>,
        TError,
        void,
        TContext
      > => {
      return useMutation(getGetConfigOptionsMutationOptions(options), queryClient);
    }

/**
 * Get information about platform features:
 *
 *   - relevance of the license (`license`)
 *   - enabled estimations (`estimations`)
 *   - enabled modules (`components`)
 * @summary get platform features
 */
export const getFeatures = (

 options?: SecondParameter<typeof lp5AxiosClient>,signal?: AbortSignal
) => {


      return lp5AxiosClient<GetFeatures200>(
      {url: `/6/features`, method: 'GET', signal
    },
      options);
    }




export const getGetFeaturesQueryKey = () => {
    return [
    `/6/features`
    ] as const;
    }


export const getGetFeaturesQueryOptions = <TData = Awaited<ReturnType<typeof getFeatures>>, TError = RequestTimeoutResponse | InternalServerErrorResponse | ResponseTimeoutResponse | ServerTimeoutErrorResponse>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getFeatures>>, TError, TData>>, request?: SecondParameter<typeof lp5AxiosClient>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetFeaturesQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getFeatures>>> = ({ signal }) => getFeatures(requestOptions, signal);





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getFeatures>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetFeaturesQueryResult = NonNullable<Awaited<ReturnType<typeof getFeatures>>>
export type GetFeaturesQueryError = RequestTimeoutResponse | InternalServerErrorResponse | ResponseTimeoutResponse | ServerTimeoutErrorResponse


export function useGetFeatures<TData = Awaited<ReturnType<typeof getFeatures>>, TError = RequestTimeoutResponse | InternalServerErrorResponse | ResponseTimeoutResponse | ServerTimeoutErrorResponse>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getFeatures>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getFeatures>>,
          TError,
          Awaited<ReturnType<typeof getFeatures>>
        > , 'initialData'
      >, request?: SecondParameter<typeof lp5AxiosClient>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetFeatures<TData = Awaited<ReturnType<typeof getFeatures>>, TError = RequestTimeoutResponse | InternalServerErrorResponse | ResponseTimeoutResponse | ServerTimeoutErrorResponse>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getFeatures>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getFeatures>>,
          TError,
          Awaited<ReturnType<typeof getFeatures>>
        > , 'initialData'
      >, request?: SecondParameter<typeof lp5AxiosClient>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetFeatures<TData = Awaited<ReturnType<typeof getFeatures>>, TError = RequestTimeoutResponse | InternalServerErrorResponse | ResponseTimeoutResponse | ServerTimeoutErrorResponse>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getFeatures>>, TError, TData>>, request?: SecondParameter<typeof lp5AxiosClient>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary get platform features
 */

export function useGetFeatures<TData = Awaited<ReturnType<typeof getFeatures>>, TError = RequestTimeoutResponse | InternalServerErrorResponse | ResponseTimeoutResponse | ServerTimeoutErrorResponse>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getFeatures>>, TError, TData>>, request?: SecondParameter<typeof lp5AxiosClient>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetFeaturesQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}







/**
 * Get options for the resource.
 * @summary features options
 */
export const getFeaturesOptions = (

 options?: SecondParameter<typeof lp5AxiosClient>,signal?: AbortSignal
) => {


      return lp5AxiosClient<void>(
      {url: `/6/features`, method: 'OPTIONS', signal
    },
      options);
    }




export const getGetFeaturesOptionsMutationOptions = <TError = RequestTimeoutResponse | InternalServerErrorResponse | ResponseTimeoutResponse | ServerTimeoutErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof getFeaturesOptions>>, TError,void, TContext>, request?: SecondParameter<typeof lp5AxiosClient>}
): UseMutationOptions<Awaited<ReturnType<typeof getFeaturesOptions>>, TError,void, TContext> => {

const mutationKey = ['getFeaturesOptions'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof getFeaturesOptions>>, void> = () => {


          return  getFeaturesOptions(requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type GetFeaturesOptionsMutationResult = NonNullable<Awaited<ReturnType<typeof getFeaturesOptions>>>

    export type GetFeaturesOptionsMutationError = RequestTimeoutResponse | InternalServerErrorResponse | ResponseTimeoutResponse | ServerTimeoutErrorResponse

    /**
 * @summary features options
 */
export const useGetFeaturesOptions = <TError = RequestTimeoutResponse | InternalServerErrorResponse | ResponseTimeoutResponse | ServerTimeoutErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof getFeaturesOptions>>, TError,void, TContext>, request?: SecondParameter<typeof lp5AxiosClient>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof getFeaturesOptions>>,
        TError,
        void,
        TContext
      > => {
      return useMutation(getGetFeaturesOptionsMutationOptions(options), queryClient);
    }

/**
 * Get list of service plugins:
 * @summary get list of plugins
 */
export const getPlugins = (

 options?: SecondParameter<typeof lp5AxiosClient>,signal?: AbortSignal
) => {


      return lp5AxiosClient<Plugins>(
      {url: `/6/plugins`, method: 'GET', signal
    },
      options);
    }




export const getGetPluginsQueryKey = () => {
    return [
    `/6/plugins`
    ] as const;
    }


export const getGetPluginsQueryOptions = <TData = Awaited<ReturnType<typeof getPlugins>>, TError = RequestTimeoutResponse | InternalServerErrorResponse | ResponseTimeoutResponse | ServerTimeoutErrorResponse>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPlugins>>, TError, TData>>, request?: SecondParameter<typeof lp5AxiosClient>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetPluginsQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getPlugins>>> = ({ signal }) => getPlugins(requestOptions, signal);





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getPlugins>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetPluginsQueryResult = NonNullable<Awaited<ReturnType<typeof getPlugins>>>
export type GetPluginsQueryError = RequestTimeoutResponse | InternalServerErrorResponse | ResponseTimeoutResponse | ServerTimeoutErrorResponse


export function useGetPlugins<TData = Awaited<ReturnType<typeof getPlugins>>, TError = RequestTimeoutResponse | InternalServerErrorResponse | ResponseTimeoutResponse | ServerTimeoutErrorResponse>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPlugins>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getPlugins>>,
          TError,
          Awaited<ReturnType<typeof getPlugins>>
        > , 'initialData'
      >, request?: SecondParameter<typeof lp5AxiosClient>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetPlugins<TData = Awaited<ReturnType<typeof getPlugins>>, TError = RequestTimeoutResponse | InternalServerErrorResponse | ResponseTimeoutResponse | ServerTimeoutErrorResponse>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPlugins>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getPlugins>>,
          TError,
          Awaited<ReturnType<typeof getPlugins>>
        > , 'initialData'
      >, request?: SecondParameter<typeof lp5AxiosClient>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetPlugins<TData = Awaited<ReturnType<typeof getPlugins>>, TError = RequestTimeoutResponse | InternalServerErrorResponse | ResponseTimeoutResponse | ServerTimeoutErrorResponse>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPlugins>>, TError, TData>>, request?: SecondParameter<typeof lp5AxiosClient>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary get list of plugins
 */

export function useGetPlugins<TData = Awaited<ReturnType<typeof getPlugins>>, TError = RequestTimeoutResponse | InternalServerErrorResponse | ResponseTimeoutResponse | ServerTimeoutErrorResponse>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPlugins>>, TError, TData>>, request?: SecondParameter<typeof lp5AxiosClient>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetPluginsQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}







/**
 * Get options for the resource.
 * @summary plugins options
 */
export const getPluginsOptions = (

 options?: SecondParameter<typeof lp5AxiosClient>,signal?: AbortSignal
) => {


      return lp5AxiosClient<void>(
      {url: `/6/plugins`, method: 'OPTIONS', signal
    },
      options);
    }




export const getGetPluginsOptionsMutationOptions = <TError = RequestTimeoutResponse | InternalServerErrorResponse | ResponseTimeoutResponse | ServerTimeoutErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof getPluginsOptions>>, TError,void, TContext>, request?: SecondParameter<typeof lp5AxiosClient>}
): UseMutationOptions<Awaited<ReturnType<typeof getPluginsOptions>>, TError,void, TContext> => {

const mutationKey = ['getPluginsOptions'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof getPluginsOptions>>, void> = () => {


          return  getPluginsOptions(requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type GetPluginsOptionsMutationResult = NonNullable<Awaited<ReturnType<typeof getPluginsOptions>>>

    export type GetPluginsOptionsMutationError = RequestTimeoutResponse | InternalServerErrorResponse | ResponseTimeoutResponse | ServerTimeoutErrorResponse

    /**
 * @summary plugins options
 */
export const useGetPluginsOptions = <TError = RequestTimeoutResponse | InternalServerErrorResponse | ResponseTimeoutResponse | ServerTimeoutErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof getPluginsOptions>>, TError,void, TContext>, request?: SecondParameter<typeof lp5AxiosClient>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof getPluginsOptions>>,
        TError,
        void,
        TContext
      > => {
      return useMutation(getGetPluginsOptionsMutationOptions(options), queryClient);
    }

/**
 * Create a new lambda.
 * @summary create lambda
 */
export const createLambda = (
    createLambdaBody: LambdaMultipartContentArchiveFile | LambdaImportJson,
 options?: SecondParameter<typeof lp5AxiosClient>,signal?: AbortSignal
) => {


      return lp5AxiosClient<LambdaIdResponse>(
      {url: `/6/lambdas`, method: 'POST',
      data: createLambdaBody, signal
    },
      options);
    }




export const getCreateLambdaMutationOptions = <TError = Error | ForbiddenLambdaErrorWithLicenseResponse | InternalServerErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createLambda>>, TError,{data: LambdaMultipartContentArchiveFile | LambdaImportJson}, TContext>, request?: SecondParameter<typeof lp5AxiosClient>}
): UseMutationOptions<Awaited<ReturnType<typeof createLambda>>, TError,{data: LambdaMultipartContentArchiveFile | LambdaImportJson}, TContext> => {

const mutationKey = ['createLambda'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof createLambda>>, {data: LambdaMultipartContentArchiveFile | LambdaImportJson}> = (props) => {
          const {data} = props ?? {};

          return  createLambda(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type CreateLambdaMutationResult = NonNullable<Awaited<ReturnType<typeof createLambda>>>
    export type CreateLambdaMutationBody = LambdaMultipartContentArchiveFile | LambdaImportJson
    export type CreateLambdaMutationError = Error | ForbiddenLambdaErrorWithLicenseResponse | InternalServerErrorResponse

    /**
 * @summary create lambda
 */
export const useCreateLambda = <TError = Error | ForbiddenLambdaErrorWithLicenseResponse | InternalServerErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createLambda>>, TError,{data: LambdaMultipartContentArchiveFile | LambdaImportJson}, TContext>, request?: SecondParameter<typeof lp5AxiosClient>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof createLambda>>,
        TError,
        {data: LambdaMultipartContentArchiveFile | LambdaImportJson},
        TContext
      > => {
      return useMutation(getCreateLambdaMutationOptions(options), queryClient);
    }

/**
 * Get lambdas according to filters.
 * @summary get lambdas
 */
export const getLambdas = (
    params?: GetLambdasParams,
 options?: SecondParameter<typeof lp5AxiosClient>,signal?: AbortSignal
) => {


      return lp5AxiosClient<GetLambdas200>(
      {url: `/6/lambdas`, method: 'GET',
        params, signal
    },
      options);
    }




export const getGetLambdasQueryKey = (params?: GetLambdasParams,) => {
    return [
    `/6/lambdas`, ...(params ? [params] : [])
    ] as const;
    }


export const getGetLambdasQueryOptions = <TData = Awaited<ReturnType<typeof getLambdas>>, TError = Error | ForbiddenLambdaErrorResponse | RequestTimeoutResponse | InternalServerErrorResponse | ResponseTimeoutResponse | ServerTimeoutErrorResponse>(params?: GetLambdasParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getLambdas>>, TError, TData>>, request?: SecondParameter<typeof lp5AxiosClient>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetLambdasQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getLambdas>>> = ({ signal }) => getLambdas(params, requestOptions, signal);





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getLambdas>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetLambdasQueryResult = NonNullable<Awaited<ReturnType<typeof getLambdas>>>
export type GetLambdasQueryError = Error | ForbiddenLambdaErrorResponse | RequestTimeoutResponse | InternalServerErrorResponse | ResponseTimeoutResponse | ServerTimeoutErrorResponse


export function useGetLambdas<TData = Awaited<ReturnType<typeof getLambdas>>, TError = Error | ForbiddenLambdaErrorResponse | RequestTimeoutResponse | InternalServerErrorResponse | ResponseTimeoutResponse | ServerTimeoutErrorResponse>(
 params: undefined |  GetLambdasParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getLambdas>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getLambdas>>,
          TError,
          Awaited<ReturnType<typeof getLambdas>>
        > , 'initialData'
      >, request?: SecondParameter<typeof lp5AxiosClient>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetLambdas<TData = Awaited<ReturnType<typeof getLambdas>>, TError = Error | ForbiddenLambdaErrorResponse | RequestTimeoutResponse | InternalServerErrorResponse | ResponseTimeoutResponse | ServerTimeoutErrorResponse>(
 params?: GetLambdasParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getLambdas>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getLambdas>>,
          TError,
          Awaited<ReturnType<typeof getLambdas>>
        > , 'initialData'
      >, request?: SecondParameter<typeof lp5AxiosClient>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetLambdas<TData = Awaited<ReturnType<typeof getLambdas>>, TError = Error | ForbiddenLambdaErrorResponse | RequestTimeoutResponse | InternalServerErrorResponse | ResponseTimeoutResponse | ServerTimeoutErrorResponse>(
 params?: GetLambdasParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getLambdas>>, TError, TData>>, request?: SecondParameter<typeof lp5AxiosClient>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary get lambdas
 */

export function useGetLambdas<TData = Awaited<ReturnType<typeof getLambdas>>, TError = Error | ForbiddenLambdaErrorResponse | RequestTimeoutResponse | InternalServerErrorResponse | ResponseTimeoutResponse | ServerTimeoutErrorResponse>(
 params?: GetLambdasParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getLambdas>>, TError, TData>>, request?: SecondParameter<typeof lp5AxiosClient>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetLambdasQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}







/**
 * Validate lambda.
 * @summary validation lambda
 */
export const validationLambda = (
    validationLambdaBody: Blob,
 options?: SecondParameter<typeof lp5AxiosClient>,signal?: AbortSignal
) => {


      return lp5AxiosClient<void>(
      {url: `/6/lambdas/validator`, method: 'POST',
      headers: {'Content-Type': 'application/zip', },
      data: validationLambdaBody, signal
    },
      options);
    }




export const getValidationLambdaMutationOptions = <TError = LambdaValidationErrorResponse | RequestTimeoutResponse | InternalServerErrorResponse | ResponseTimeoutResponse | ServerTimeoutErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof validationLambda>>, TError,{data: Blob}, TContext>, request?: SecondParameter<typeof lp5AxiosClient>}
): UseMutationOptions<Awaited<ReturnType<typeof validationLambda>>, TError,{data: Blob}, TContext> => {

const mutationKey = ['validationLambda'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof validationLambda>>, {data: Blob}> = (props) => {
          const {data} = props ?? {};

          return  validationLambda(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type ValidationLambdaMutationResult = NonNullable<Awaited<ReturnType<typeof validationLambda>>>
    export type ValidationLambdaMutationBody = Blob
    export type ValidationLambdaMutationError = LambdaValidationErrorResponse | RequestTimeoutResponse | InternalServerErrorResponse | ResponseTimeoutResponse | ServerTimeoutErrorResponse

    /**
 * @summary validation lambda
 */
export const useValidationLambda = <TError = LambdaValidationErrorResponse | RequestTimeoutResponse | InternalServerErrorResponse | ResponseTimeoutResponse | ServerTimeoutErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof validationLambda>>, TError,{data: Blob}, TContext>, request?: SecondParameter<typeof lp5AxiosClient>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof validationLambda>>,
        TError,
        {data: Blob},
        TContext
      > => {
      return useMutation(getValidationLambdaMutationOptions(options), queryClient);
    }

/**
 * Update lambda. You cannot update a part of the lambda, so you should specify all the fields for your lambda.
 * @summary put lambda
 */
export const putLambda = (
    lambdaId: Uuid,
    putLambdaBody: LambdaMultipartContentArchiveFile | LambdaImportJson,
 options?: SecondParameter<typeof lp5AxiosClient>,signal?: AbortSignal
) => {


      return lp5AxiosClient<LambdaVersionResponse>(
      {url: `/6/lambdas/${lambdaId}`, method: 'PUT',
      data: putLambdaBody, signal
    },
      options);
    }




export const getPutLambdaMutationOptions = <TError = Error | ForbiddenLambdaErrorWithLicenseResponse | RequestTimeoutResponse | InternalServerErrorResponse | ResponseTimeoutResponse | ServerTimeoutErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof putLambda>>, TError,{lambdaId: Uuid;data: LambdaMultipartContentArchiveFile | LambdaImportJson}, TContext>, request?: SecondParameter<typeof lp5AxiosClient>}
): UseMutationOptions<Awaited<ReturnType<typeof putLambda>>, TError,{lambdaId: Uuid;data: LambdaMultipartContentArchiveFile | LambdaImportJson}, TContext> => {

const mutationKey = ['putLambda'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof putLambda>>, {lambdaId: Uuid;data: LambdaMultipartContentArchiveFile | LambdaImportJson}> = (props) => {
          const {lambdaId,data} = props ?? {};

          return  putLambda(lambdaId,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type PutLambdaMutationResult = NonNullable<Awaited<ReturnType<typeof putLambda>>>
    export type PutLambdaMutationBody = LambdaMultipartContentArchiveFile | LambdaImportJson
    export type PutLambdaMutationError = Error | ForbiddenLambdaErrorWithLicenseResponse | RequestTimeoutResponse | InternalServerErrorResponse | ResponseTimeoutResponse | ServerTimeoutErrorResponse

    /**
 * @summary put lambda
 */
export const usePutLambda = <TError = Error | ForbiddenLambdaErrorWithLicenseResponse | RequestTimeoutResponse | InternalServerErrorResponse | ResponseTimeoutResponse | ServerTimeoutErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof putLambda>>, TError,{lambdaId: Uuid;data: LambdaMultipartContentArchiveFile | LambdaImportJson}, TContext>, request?: SecondParameter<typeof lp5AxiosClient>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof putLambda>>,
        TError,
        {lambdaId: Uuid;data: LambdaMultipartContentArchiveFile | LambdaImportJson},
        TContext
      > => {
      return useMutation(getPutLambdaMutationOptions(options), queryClient);
    }

/**
 * Patch lambda.
 * @summary patch lambda
 */
export const patchLambda = (
    lambdaId: Uuid,
    lambdaPatch: LambdaPatch,
 options?: SecondParameter<typeof lp5AxiosClient>,signal?: AbortSignal
) => {


      return lp5AxiosClient<void>(
      {url: `/6/lambdas/${lambdaId}`, method: 'PATCH',
      headers: {'Content-Type': 'application/json', },
      data: lambdaPatch, signal
    },
      options);
    }




export const getPatchLambdaMutationOptions = <TError = Error | ForbiddenLambdaErrorResponse | RequestTimeoutResponse | InternalServerErrorResponse | ResponseTimeoutResponse | ServerTimeoutErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof patchLambda>>, TError,{lambdaId: Uuid;data: LambdaPatch}, TContext>, request?: SecondParameter<typeof lp5AxiosClient>}
): UseMutationOptions<Awaited<ReturnType<typeof patchLambda>>, TError,{lambdaId: Uuid;data: LambdaPatch}, TContext> => {

const mutationKey = ['patchLambda'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof patchLambda>>, {lambdaId: Uuid;data: LambdaPatch}> = (props) => {
          const {lambdaId,data} = props ?? {};

          return  patchLambda(lambdaId,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type PatchLambdaMutationResult = NonNullable<Awaited<ReturnType<typeof patchLambda>>>
    export type PatchLambdaMutationBody = LambdaPatch
    export type PatchLambdaMutationError = Error | ForbiddenLambdaErrorResponse | RequestTimeoutResponse | InternalServerErrorResponse | ResponseTimeoutResponse | ServerTimeoutErrorResponse

    /**
 * @summary patch lambda
 */
export const usePatchLambda = <TError = Error | ForbiddenLambdaErrorResponse | RequestTimeoutResponse | InternalServerErrorResponse | ResponseTimeoutResponse | ServerTimeoutErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof patchLambda>>, TError,{lambdaId: Uuid;data: LambdaPatch}, TContext>, request?: SecondParameter<typeof lp5AxiosClient>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof patchLambda>>,
        TError,
        {lambdaId: Uuid;data: LambdaPatch},
        TContext
      > => {
      return useMutation(getPatchLambdaMutationOptions(options), queryClient);
    }

/**
 * Get lambda by ID.
 * @summary get lambda
 */
export const getLambda = (
    lambdaId: Uuid,
    params?: GetLambdaParams,
 options?: SecondParameter<typeof lp5AxiosClient>,signal?: AbortSignal
) => {


      return lp5AxiosClient<Lambda>(
      {url: `/6/lambdas/${lambdaId}`, method: 'GET',
        params, signal
    },
      options);
    }




export const getGetLambdaQueryKey = (lambdaId: Uuid,
    params?: GetLambdaParams,) => {
    return [
    `/6/lambdas/${lambdaId}`, ...(params ? [params] : [])
    ] as const;
    }


export const getGetLambdaQueryOptions = <TData = Awaited<ReturnType<typeof getLambda>>, TError = Error | ForbiddenLambdaErrorResponse | RequestTimeoutResponse | InternalServerErrorResponse | ResponseTimeoutResponse | ServerTimeoutErrorResponse>(lambdaId: Uuid,
    params?: GetLambdaParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getLambda>>, TError, TData>>, request?: SecondParameter<typeof lp5AxiosClient>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetLambdaQueryKey(lambdaId,params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getLambda>>> = ({ signal }) => getLambda(lambdaId,params, requestOptions, signal);





   return  { queryKey, queryFn, enabled: lambdaId !== null && lambdaId !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getLambda>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetLambdaQueryResult = NonNullable<Awaited<ReturnType<typeof getLambda>>>
export type GetLambdaQueryError = Error | ForbiddenLambdaErrorResponse | RequestTimeoutResponse | InternalServerErrorResponse | ResponseTimeoutResponse | ServerTimeoutErrorResponse


export function useGetLambda<TData = Awaited<ReturnType<typeof getLambda>>, TError = Error | ForbiddenLambdaErrorResponse | RequestTimeoutResponse | InternalServerErrorResponse | ResponseTimeoutResponse | ServerTimeoutErrorResponse>(
 lambdaId: Uuid,
    params: undefined |  GetLambdaParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getLambda>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getLambda>>,
          TError,
          Awaited<ReturnType<typeof getLambda>>
        > , 'initialData'
      >, request?: SecondParameter<typeof lp5AxiosClient>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetLambda<TData = Awaited<ReturnType<typeof getLambda>>, TError = Error | ForbiddenLambdaErrorResponse | RequestTimeoutResponse | InternalServerErrorResponse | ResponseTimeoutResponse | ServerTimeoutErrorResponse>(
 lambdaId: Uuid,
    params?: GetLambdaParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getLambda>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getLambda>>,
          TError,
          Awaited<ReturnType<typeof getLambda>>
        > , 'initialData'
      >, request?: SecondParameter<typeof lp5AxiosClient>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetLambda<TData = Awaited<ReturnType<typeof getLambda>>, TError = Error | ForbiddenLambdaErrorResponse | RequestTimeoutResponse | InternalServerErrorResponse | ResponseTimeoutResponse | ServerTimeoutErrorResponse>(
 lambdaId: Uuid,
    params?: GetLambdaParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getLambda>>, TError, TData>>, request?: SecondParameter<typeof lp5AxiosClient>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary get lambda
 */

export function useGetLambda<TData = Awaited<ReturnType<typeof getLambda>>, TError = Error | ForbiddenLambdaErrorResponse | RequestTimeoutResponse | InternalServerErrorResponse | ResponseTimeoutResponse | ServerTimeoutErrorResponse>(
 lambdaId: Uuid,
    params?: GetLambdaParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getLambda>>, TError, TData>>, request?: SecondParameter<typeof lp5AxiosClient>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetLambdaQueryOptions(lambdaId,params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}







/**
 * Check existence of the lambda by ID.
 * @summary check lambda existence
 */
export const checkLambda = (
    lambdaId: Uuid,
    params?: CheckLambdaParams,
 options?: SecondParameter<typeof lp5AxiosClient>,signal?: AbortSignal
) => {


      return lp5AxiosClient<void>(
      {url: `/6/lambdas/${lambdaId}`, method: 'HEAD',
        params, signal
    },
      options);
    }




export const getCheckLambdaMutationOptions = <TError = Error | ForbiddenLambdaErrorResponse | RequestTimeoutResponse | InternalServerErrorResponse | ResponseTimeoutResponse | ServerTimeoutErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof checkLambda>>, TError,{lambdaId: Uuid;params?: CheckLambdaParams}, TContext>, request?: SecondParameter<typeof lp5AxiosClient>}
): UseMutationOptions<Awaited<ReturnType<typeof checkLambda>>, TError,{lambdaId: Uuid;params?: CheckLambdaParams}, TContext> => {

const mutationKey = ['checkLambda'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof checkLambda>>, {lambdaId: Uuid;params?: CheckLambdaParams}> = (props) => {
          const {lambdaId,params} = props ?? {};

          return  checkLambda(lambdaId,params,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type CheckLambdaMutationResult = NonNullable<Awaited<ReturnType<typeof checkLambda>>>

    export type CheckLambdaMutationError = Error | ForbiddenLambdaErrorResponse | RequestTimeoutResponse | InternalServerErrorResponse | ResponseTimeoutResponse | ServerTimeoutErrorResponse

    /**
 * @summary check lambda existence
 */
export const useCheckLambda = <TError = Error | ForbiddenLambdaErrorResponse | RequestTimeoutResponse | InternalServerErrorResponse | ResponseTimeoutResponse | ServerTimeoutErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof checkLambda>>, TError,{lambdaId: Uuid;params?: CheckLambdaParams}, TContext>, request?: SecondParameter<typeof lp5AxiosClient>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof checkLambda>>,
        TError,
        {lambdaId: Uuid;params?: CheckLambdaParams},
        TContext
      > => {
      return useMutation(getCheckLambdaMutationOptions(options), queryClient);
    }

/**
 * Remove lambda by ID.
 * Stops and removes lambda pod, deletes lambda archive from S3. There is also will be an attempt to remove lambda image from registry in background. Note, that image can be deleted only if this feature enabled in registry.
 * Failed or successful deletion attempt will be logged and saved to monitoring.
 * @summary delete lambda
 */
export const deleteLambda = (
    lambdaId: Uuid,
    params?: DeleteLambdaParams,
 options?: SecondParameter<typeof lp5AxiosClient>,signal?: AbortSignal
) => {


      return lp5AxiosClient<void>(
      {url: `/6/lambdas/${lambdaId}`, method: 'DELETE',
        params, signal
    },
      options);
    }




export const getDeleteLambdaMutationOptions = <TError = Error | ForbiddenLambdaErrorResponse | RequestTimeoutResponse | InternalServerErrorResponse | ResponseTimeoutResponse | ServerTimeoutErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteLambda>>, TError,{lambdaId: Uuid;params?: DeleteLambdaParams}, TContext>, request?: SecondParameter<typeof lp5AxiosClient>}
): UseMutationOptions<Awaited<ReturnType<typeof deleteLambda>>, TError,{lambdaId: Uuid;params?: DeleteLambdaParams}, TContext> => {

const mutationKey = ['deleteLambda'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof deleteLambda>>, {lambdaId: Uuid;params?: DeleteLambdaParams}> = (props) => {
          const {lambdaId,params} = props ?? {};

          return  deleteLambda(lambdaId,params,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type DeleteLambdaMutationResult = NonNullable<Awaited<ReturnType<typeof deleteLambda>>>

    export type DeleteLambdaMutationError = Error | ForbiddenLambdaErrorResponse | RequestTimeoutResponse | InternalServerErrorResponse | ResponseTimeoutResponse | ServerTimeoutErrorResponse

    /**
 * @summary delete lambda
 */
export const useDeleteLambda = <TError = Error | ForbiddenLambdaErrorResponse | RequestTimeoutResponse | InternalServerErrorResponse | ResponseTimeoutResponse | ServerTimeoutErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteLambda>>, TError,{lambdaId: Uuid;params?: DeleteLambdaParams}, TContext>, request?: SecondParameter<typeof lp5AxiosClient>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof deleteLambda>>,
        TError,
        {lambdaId: Uuid;params?: DeleteLambdaParams},
        TContext
      > => {
      return useMutation(getDeleteLambdaMutationOptions(options), queryClient);
    }

/**
 * Update lambda using latest base image.
 * @summary update lambda
 */
export const updateLambda = (
    lambdaId: Uuid,
 options?: SecondParameter<typeof lp5AxiosClient>,signal?: AbortSignal
) => {


      return lp5AxiosClient<LambdaVersionResponse>(
      {url: `/6/lambdas/${lambdaId}/update`, method: 'POST', signal
    },
      options);
    }




export const getUpdateLambdaMutationOptions = <TError = Error | ForbiddenLambdaErrorWithLicenseResponse | RequestTimeoutResponse | InternalServerErrorResponse | ResponseTimeoutResponse | ServerTimeoutErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateLambda>>, TError,{lambdaId: Uuid}, TContext>, request?: SecondParameter<typeof lp5AxiosClient>}
): UseMutationOptions<Awaited<ReturnType<typeof updateLambda>>, TError,{lambdaId: Uuid}, TContext> => {

const mutationKey = ['updateLambda'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof updateLambda>>, {lambdaId: Uuid}> = (props) => {
          const {lambdaId} = props ?? {};

          return  updateLambda(lambdaId,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type UpdateLambdaMutationResult = NonNullable<Awaited<ReturnType<typeof updateLambda>>>

    export type UpdateLambdaMutationError = Error | ForbiddenLambdaErrorWithLicenseResponse | RequestTimeoutResponse | InternalServerErrorResponse | ResponseTimeoutResponse | ServerTimeoutErrorResponse

    /**
 * @summary update lambda
 */
export const useUpdateLambda = <TError = Error | ForbiddenLambdaErrorWithLicenseResponse | RequestTimeoutResponse | InternalServerErrorResponse | ResponseTimeoutResponse | ServerTimeoutErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateLambda>>, TError,{lambdaId: Uuid}, TContext>, request?: SecondParameter<typeof lp5AxiosClient>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof updateLambda>>,
        TError,
        {lambdaId: Uuid},
        TContext
      > => {
      return useMutation(getUpdateLambdaMutationOptions(options), queryClient);
    }

/**
 * Get lambda image creation status by lambda ID.
 *
 * If lambda image creation is in progress, lambda status will be `waiting`.
 *
 * After lambda image creation will end, the lambda image creation job will be removed and status will be `not_found`.
 *
 * For more information about lambda and lambda images statuses see development manual.
 * @summary get lambda image creation status
 */
export const getLambdaImageStatus = (
    lambdaId: Uuid,
    params?: GetLambdaImageStatusParams,
 options?: SecondParameter<typeof lp5AxiosClient>,signal?: AbortSignal
) => {


      return lp5AxiosClient<ImageCreationStatus>(
      {url: `/6/lambdas/${lambdaId}/image/status`, method: 'GET',
        params, signal
    },
      options);
    }




export const getGetLambdaImageStatusQueryKey = (lambdaId: Uuid,
    params?: GetLambdaImageStatusParams,) => {
    return [
    `/6/lambdas/${lambdaId}/image/status`, ...(params ? [params] : [])
    ] as const;
    }


export const getGetLambdaImageStatusQueryOptions = <TData = Awaited<ReturnType<typeof getLambdaImageStatus>>, TError = Error | ForbiddenLambdaErrorResponse | RequestTimeoutResponse | InternalServerErrorResponse | ResponseTimeoutResponse | ServerTimeoutErrorResponse>(lambdaId: Uuid,
    params?: GetLambdaImageStatusParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getLambdaImageStatus>>, TError, TData>>, request?: SecondParameter<typeof lp5AxiosClient>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetLambdaImageStatusQueryKey(lambdaId,params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getLambdaImageStatus>>> = ({ signal }) => getLambdaImageStatus(lambdaId,params, requestOptions, signal);





   return  { queryKey, queryFn, enabled: lambdaId !== null && lambdaId !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getLambdaImageStatus>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetLambdaImageStatusQueryResult = NonNullable<Awaited<ReturnType<typeof getLambdaImageStatus>>>
export type GetLambdaImageStatusQueryError = Error | ForbiddenLambdaErrorResponse | RequestTimeoutResponse | InternalServerErrorResponse | ResponseTimeoutResponse | ServerTimeoutErrorResponse


export function useGetLambdaImageStatus<TData = Awaited<ReturnType<typeof getLambdaImageStatus>>, TError = Error | ForbiddenLambdaErrorResponse | RequestTimeoutResponse | InternalServerErrorResponse | ResponseTimeoutResponse | ServerTimeoutErrorResponse>(
 lambdaId: Uuid,
    params: undefined |  GetLambdaImageStatusParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getLambdaImageStatus>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getLambdaImageStatus>>,
          TError,
          Awaited<ReturnType<typeof getLambdaImageStatus>>
        > , 'initialData'
      >, request?: SecondParameter<typeof lp5AxiosClient>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetLambdaImageStatus<TData = Awaited<ReturnType<typeof getLambdaImageStatus>>, TError = Error | ForbiddenLambdaErrorResponse | RequestTimeoutResponse | InternalServerErrorResponse | ResponseTimeoutResponse | ServerTimeoutErrorResponse>(
 lambdaId: Uuid,
    params?: GetLambdaImageStatusParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getLambdaImageStatus>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getLambdaImageStatus>>,
          TError,
          Awaited<ReturnType<typeof getLambdaImageStatus>>
        > , 'initialData'
      >, request?: SecondParameter<typeof lp5AxiosClient>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetLambdaImageStatus<TData = Awaited<ReturnType<typeof getLambdaImageStatus>>, TError = Error | ForbiddenLambdaErrorResponse | RequestTimeoutResponse | InternalServerErrorResponse | ResponseTimeoutResponse | ServerTimeoutErrorResponse>(
 lambdaId: Uuid,
    params?: GetLambdaImageStatusParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getLambdaImageStatus>>, TError, TData>>, request?: SecondParameter<typeof lp5AxiosClient>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary get lambda image creation status
 */

export function useGetLambdaImageStatus<TData = Awaited<ReturnType<typeof getLambdaImageStatus>>, TError = Error | ForbiddenLambdaErrorResponse | RequestTimeoutResponse | InternalServerErrorResponse | ResponseTimeoutResponse | ServerTimeoutErrorResponse>(
 lambdaId: Uuid,
    params?: GetLambdaImageStatusParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getLambdaImageStatus>>, TError, TData>>, request?: SecondParameter<typeof lp5AxiosClient>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetLambdaImageStatusQueryOptions(lambdaId,params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}







/**
 * Get lambda image creation logs by lambda ID.
 *
 * During the creation of the lambda image, it is possible to get logs to monitor the progress.
 *
 * For more information about lambda and lambda images logs see development manual.
 * @summary get lambda image creation logs
 */
export const getLambdaImageCreationLogs = (
    lambdaId: Uuid,
    params?: GetLambdaImageCreationLogsParams,
 options?: SecondParameter<typeof lp5AxiosClient>,signal?: AbortSignal
) => {


      return lp5AxiosClient<LambdaImageLogs>(
      {url: `/6/lambdas/${lambdaId}/image/logs`, method: 'GET',
        params, signal
    },
      options);
    }




export const getGetLambdaImageCreationLogsQueryKey = (lambdaId: Uuid,
    params?: GetLambdaImageCreationLogsParams,) => {
    return [
    `/6/lambdas/${lambdaId}/image/logs`, ...(params ? [params] : [])
    ] as const;
    }


export const getGetLambdaImageCreationLogsQueryOptions = <TData = Awaited<ReturnType<typeof getLambdaImageCreationLogs>>, TError = Error | ForbiddenLambdaErrorResponse | RequestTimeoutResponse | InternalServerErrorResponse | ResponseTimeoutResponse | ServerTimeoutErrorResponse>(lambdaId: Uuid,
    params?: GetLambdaImageCreationLogsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getLambdaImageCreationLogs>>, TError, TData>>, request?: SecondParameter<typeof lp5AxiosClient>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetLambdaImageCreationLogsQueryKey(lambdaId,params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getLambdaImageCreationLogs>>> = ({ signal }) => getLambdaImageCreationLogs(lambdaId,params, requestOptions, signal);





   return  { queryKey, queryFn, enabled: lambdaId !== null && lambdaId !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getLambdaImageCreationLogs>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetLambdaImageCreationLogsQueryResult = NonNullable<Awaited<ReturnType<typeof getLambdaImageCreationLogs>>>
export type GetLambdaImageCreationLogsQueryError = Error | ForbiddenLambdaErrorResponse | RequestTimeoutResponse | InternalServerErrorResponse | ResponseTimeoutResponse | ServerTimeoutErrorResponse


export function useGetLambdaImageCreationLogs<TData = Awaited<ReturnType<typeof getLambdaImageCreationLogs>>, TError = Error | ForbiddenLambdaErrorResponse | RequestTimeoutResponse | InternalServerErrorResponse | ResponseTimeoutResponse | ServerTimeoutErrorResponse>(
 lambdaId: Uuid,
    params: undefined |  GetLambdaImageCreationLogsParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getLambdaImageCreationLogs>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getLambdaImageCreationLogs>>,
          TError,
          Awaited<ReturnType<typeof getLambdaImageCreationLogs>>
        > , 'initialData'
      >, request?: SecondParameter<typeof lp5AxiosClient>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetLambdaImageCreationLogs<TData = Awaited<ReturnType<typeof getLambdaImageCreationLogs>>, TError = Error | ForbiddenLambdaErrorResponse | RequestTimeoutResponse | InternalServerErrorResponse | ResponseTimeoutResponse | ServerTimeoutErrorResponse>(
 lambdaId: Uuid,
    params?: GetLambdaImageCreationLogsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getLambdaImageCreationLogs>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getLambdaImageCreationLogs>>,
          TError,
          Awaited<ReturnType<typeof getLambdaImageCreationLogs>>
        > , 'initialData'
      >, request?: SecondParameter<typeof lp5AxiosClient>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetLambdaImageCreationLogs<TData = Awaited<ReturnType<typeof getLambdaImageCreationLogs>>, TError = Error | ForbiddenLambdaErrorResponse | RequestTimeoutResponse | InternalServerErrorResponse | ResponseTimeoutResponse | ServerTimeoutErrorResponse>(
 lambdaId: Uuid,
    params?: GetLambdaImageCreationLogsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getLambdaImageCreationLogs>>, TError, TData>>, request?: SecondParameter<typeof lp5AxiosClient>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary get lambda image creation logs
 */

export function useGetLambdaImageCreationLogs<TData = Awaited<ReturnType<typeof getLambdaImageCreationLogs>>, TError = Error | ForbiddenLambdaErrorResponse | RequestTimeoutResponse | InternalServerErrorResponse | ResponseTimeoutResponse | ServerTimeoutErrorResponse>(
 lambdaId: Uuid,
    params?: GetLambdaImageCreationLogsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getLambdaImageCreationLogs>>, TError, TData>>, request?: SecondParameter<typeof lp5AxiosClient>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetLambdaImageCreationLogsQueryOptions(lambdaId,params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}







/**
 * Get lambda status by ID.
 *
 * If lambda image creation is in progress, lambda status will be `waiting`.
 *
 * For more information about lambda and lambda images statuses see development manual.
 * @summary get lambda status
 */
export const getLambdaStatus = (
    lambdaId: Uuid,
    params?: GetLambdaStatusParams,
 options?: SecondParameter<typeof lp5AxiosClient>,signal?: AbortSignal
) => {


      return lp5AxiosClient<LambdaStatusResponse>(
      {url: `/6/lambdas/${lambdaId}/status`, method: 'GET',
        params, signal
    },
      options);
    }




export const getGetLambdaStatusQueryKey = (lambdaId: Uuid,
    params?: GetLambdaStatusParams,) => {
    return [
    `/6/lambdas/${lambdaId}/status`, ...(params ? [params] : [])
    ] as const;
    }


export const getGetLambdaStatusQueryOptions = <TData = Awaited<ReturnType<typeof getLambdaStatus>>, TError = Error | ForbiddenLambdaErrorResponse | RequestTimeoutResponse | InternalServerErrorResponse | ResponseTimeoutResponse | ServerTimeoutErrorResponse>(lambdaId: Uuid,
    params?: GetLambdaStatusParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getLambdaStatus>>, TError, TData>>, request?: SecondParameter<typeof lp5AxiosClient>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetLambdaStatusQueryKey(lambdaId,params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getLambdaStatus>>> = ({ signal }) => getLambdaStatus(lambdaId,params, requestOptions, signal);





   return  { queryKey, queryFn, enabled: lambdaId !== null && lambdaId !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getLambdaStatus>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetLambdaStatusQueryResult = NonNullable<Awaited<ReturnType<typeof getLambdaStatus>>>
export type GetLambdaStatusQueryError = Error | ForbiddenLambdaErrorResponse | RequestTimeoutResponse | InternalServerErrorResponse | ResponseTimeoutResponse | ServerTimeoutErrorResponse


export function useGetLambdaStatus<TData = Awaited<ReturnType<typeof getLambdaStatus>>, TError = Error | ForbiddenLambdaErrorResponse | RequestTimeoutResponse | InternalServerErrorResponse | ResponseTimeoutResponse | ServerTimeoutErrorResponse>(
 lambdaId: Uuid,
    params: undefined |  GetLambdaStatusParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getLambdaStatus>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getLambdaStatus>>,
          TError,
          Awaited<ReturnType<typeof getLambdaStatus>>
        > , 'initialData'
      >, request?: SecondParameter<typeof lp5AxiosClient>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetLambdaStatus<TData = Awaited<ReturnType<typeof getLambdaStatus>>, TError = Error | ForbiddenLambdaErrorResponse | RequestTimeoutResponse | InternalServerErrorResponse | ResponseTimeoutResponse | ServerTimeoutErrorResponse>(
 lambdaId: Uuid,
    params?: GetLambdaStatusParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getLambdaStatus>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getLambdaStatus>>,
          TError,
          Awaited<ReturnType<typeof getLambdaStatus>>
        > , 'initialData'
      >, request?: SecondParameter<typeof lp5AxiosClient>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetLambdaStatus<TData = Awaited<ReturnType<typeof getLambdaStatus>>, TError = Error | ForbiddenLambdaErrorResponse | RequestTimeoutResponse | InternalServerErrorResponse | ResponseTimeoutResponse | ServerTimeoutErrorResponse>(
 lambdaId: Uuid,
    params?: GetLambdaStatusParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getLambdaStatus>>, TError, TData>>, request?: SecondParameter<typeof lp5AxiosClient>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary get lambda status
 */

export function useGetLambdaStatus<TData = Awaited<ReturnType<typeof getLambdaStatus>>, TError = Error | ForbiddenLambdaErrorResponse | RequestTimeoutResponse | InternalServerErrorResponse | ResponseTimeoutResponse | ServerTimeoutErrorResponse>(
 lambdaId: Uuid,
    params?: GetLambdaStatusParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getLambdaStatus>>, TError, TData>>, request?: SecondParameter<typeof lp5AxiosClient>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetLambdaStatusQueryOptions(lambdaId,params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}







/**
 * Get lambda logs by ID.
 *
 * After lambda creation has been executed, there is possibility to get lambda logs.
 *
 * For more information about lambda and lambda images logs see development manual.
 * @summary get lambda logs
 */
export const getLambdaLogs = (
    lambdaId: Uuid,
    params?: GetLambdaLogsParams,
 options?: SecondParameter<typeof lp5AxiosClient>,signal?: AbortSignal
) => {


      return lp5AxiosClient<LambdaLogs>(
      {url: `/6/lambdas/${lambdaId}/logs`, method: 'GET',
        params, signal
    },
      options);
    }




export const getGetLambdaLogsQueryKey = (lambdaId: Uuid,
    params?: GetLambdaLogsParams,) => {
    return [
    `/6/lambdas/${lambdaId}/logs`, ...(params ? [params] : [])
    ] as const;
    }


export const getGetLambdaLogsQueryOptions = <TData = Awaited<ReturnType<typeof getLambdaLogs>>, TError = Error | ForbiddenLambdaErrorResponse | RequestTimeoutResponse | InternalServerErrorResponse | ResponseTimeoutResponse | ServerTimeoutErrorResponse>(lambdaId: Uuid,
    params?: GetLambdaLogsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getLambdaLogs>>, TError, TData>>, request?: SecondParameter<typeof lp5AxiosClient>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetLambdaLogsQueryKey(lambdaId,params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getLambdaLogs>>> = ({ signal }) => getLambdaLogs(lambdaId,params, requestOptions, signal);





   return  { queryKey, queryFn, enabled: lambdaId !== null && lambdaId !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getLambdaLogs>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetLambdaLogsQueryResult = NonNullable<Awaited<ReturnType<typeof getLambdaLogs>>>
export type GetLambdaLogsQueryError = Error | ForbiddenLambdaErrorResponse | RequestTimeoutResponse | InternalServerErrorResponse | ResponseTimeoutResponse | ServerTimeoutErrorResponse


export function useGetLambdaLogs<TData = Awaited<ReturnType<typeof getLambdaLogs>>, TError = Error | ForbiddenLambdaErrorResponse | RequestTimeoutResponse | InternalServerErrorResponse | ResponseTimeoutResponse | ServerTimeoutErrorResponse>(
 lambdaId: Uuid,
    params: undefined |  GetLambdaLogsParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getLambdaLogs>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getLambdaLogs>>,
          TError,
          Awaited<ReturnType<typeof getLambdaLogs>>
        > , 'initialData'
      >, request?: SecondParameter<typeof lp5AxiosClient>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetLambdaLogs<TData = Awaited<ReturnType<typeof getLambdaLogs>>, TError = Error | ForbiddenLambdaErrorResponse | RequestTimeoutResponse | InternalServerErrorResponse | ResponseTimeoutResponse | ServerTimeoutErrorResponse>(
 lambdaId: Uuid,
    params?: GetLambdaLogsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getLambdaLogs>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getLambdaLogs>>,
          TError,
          Awaited<ReturnType<typeof getLambdaLogs>>
        > , 'initialData'
      >, request?: SecondParameter<typeof lp5AxiosClient>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetLambdaLogs<TData = Awaited<ReturnType<typeof getLambdaLogs>>, TError = Error | ForbiddenLambdaErrorResponse | RequestTimeoutResponse | InternalServerErrorResponse | ResponseTimeoutResponse | ServerTimeoutErrorResponse>(
 lambdaId: Uuid,
    params?: GetLambdaLogsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getLambdaLogs>>, TError, TData>>, request?: SecondParameter<typeof lp5AxiosClient>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary get lambda logs
 */

export function useGetLambdaLogs<TData = Awaited<ReturnType<typeof getLambdaLogs>>, TError = Error | ForbiddenLambdaErrorResponse | RequestTimeoutResponse | InternalServerErrorResponse | ResponseTimeoutResponse | ServerTimeoutErrorResponse>(
 lambdaId: Uuid,
    params?: GetLambdaLogsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getLambdaLogs>>, TError, TData>>, request?: SecondParameter<typeof lp5AxiosClient>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetLambdaLogsQueryOptions(lambdaId,params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}







/**
 * Get lambda OpenApi documentation. If *Accept* request header is of type `application/x-yaml`,
 * returns documentation in `yaml` format or returns `html` documentation, if *Accept-Type* is `text/html`
 * @summary get lambda openapi documentation
 */
export const getLambdaSpec = (
    lambdaId: Uuid,
    params?: GetLambdaSpecParams,
 options?: SecondParameter<typeof lp5AxiosClient>,signal?: AbortSignal
) => {


      return lp5AxiosClient<string>(
      {url: `/6/lambdas/${lambdaId}/docs/spec`, method: 'GET',
        params, signal
    },
      options);
    }




export const getGetLambdaSpecQueryKey = (lambdaId: Uuid,
    params?: GetLambdaSpecParams,) => {
    return [
    `/6/lambdas/${lambdaId}/docs/spec`, ...(params ? [params] : [])
    ] as const;
    }


export const getGetLambdaSpecQueryOptions = <TData = Awaited<ReturnType<typeof getLambdaSpec>>, TError = LambdaNotFoundResponse | RequestTimeoutResponse | Error | InternalServerErrorResponse | ResponseTimeoutResponse | ServerTimeoutErrorResponse>(lambdaId: Uuid,
    params?: GetLambdaSpecParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getLambdaSpec>>, TError, TData>>, request?: SecondParameter<typeof lp5AxiosClient>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetLambdaSpecQueryKey(lambdaId,params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getLambdaSpec>>> = ({ signal }) => getLambdaSpec(lambdaId,params, requestOptions, signal);





   return  { queryKey, queryFn, enabled: lambdaId !== null && lambdaId !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getLambdaSpec>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetLambdaSpecQueryResult = NonNullable<Awaited<ReturnType<typeof getLambdaSpec>>>
export type GetLambdaSpecQueryError = LambdaNotFoundResponse | RequestTimeoutResponse | Error | InternalServerErrorResponse | ResponseTimeoutResponse | ServerTimeoutErrorResponse


export function useGetLambdaSpec<TData = Awaited<ReturnType<typeof getLambdaSpec>>, TError = LambdaNotFoundResponse | RequestTimeoutResponse | Error | InternalServerErrorResponse | ResponseTimeoutResponse | ServerTimeoutErrorResponse>(
 lambdaId: Uuid,
    params: undefined |  GetLambdaSpecParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getLambdaSpec>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getLambdaSpec>>,
          TError,
          Awaited<ReturnType<typeof getLambdaSpec>>
        > , 'initialData'
      >, request?: SecondParameter<typeof lp5AxiosClient>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetLambdaSpec<TData = Awaited<ReturnType<typeof getLambdaSpec>>, TError = LambdaNotFoundResponse | RequestTimeoutResponse | Error | InternalServerErrorResponse | ResponseTimeoutResponse | ServerTimeoutErrorResponse>(
 lambdaId: Uuid,
    params?: GetLambdaSpecParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getLambdaSpec>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getLambdaSpec>>,
          TError,
          Awaited<ReturnType<typeof getLambdaSpec>>
        > , 'initialData'
      >, request?: SecondParameter<typeof lp5AxiosClient>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetLambdaSpec<TData = Awaited<ReturnType<typeof getLambdaSpec>>, TError = LambdaNotFoundResponse | RequestTimeoutResponse | Error | InternalServerErrorResponse | ResponseTimeoutResponse | ServerTimeoutErrorResponse>(
 lambdaId: Uuid,
    params?: GetLambdaSpecParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getLambdaSpec>>, TError, TData>>, request?: SecondParameter<typeof lp5AxiosClient>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary get lambda openapi documentation
 */

export function useGetLambdaSpec<TData = Awaited<ReturnType<typeof getLambdaSpec>>, TError = LambdaNotFoundResponse | RequestTimeoutResponse | Error | InternalServerErrorResponse | ResponseTimeoutResponse | ServerTimeoutErrorResponse>(
 lambdaId: Uuid,
    params?: GetLambdaSpecParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getLambdaSpec>>, TError, TData>>, request?: SecondParameter<typeof lp5AxiosClient>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetLambdaSpecQueryOptions(lambdaId,params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}







/**
 * Proxy POST request to lambda.
 *
 * Request and response headers, query parameters and body description
 * [must be provided](#operation/getLambdaSpec) by lambda documentation.
 *
 * Described headers will be processed and received independently of lambda behavior.
 * In case of `bearer` authorization, the token must include `view` permissions for `lambdas` to process request.
 * @summary proxy post request to lambda
 */
export const proxyLambdaPost = (
    lambdaId: Uuid,
    lambdaProxyPathParameter: Uuid,
 options?: SecondParameter<typeof lp5AxiosClient>,signal?: AbortSignal
) => {


      return lp5AxiosClient<void>(
      {url: `/6/lambdas/${lambdaId}/proxy/${lambdaProxyPathParameter}`, method: 'POST', signal
    },
      options);
    }




export const getProxyLambdaPostMutationOptions = <TError = ForbiddenLambdaErrorWithLicenseResponse | LambdaOrPageNotFoundResponse | RequestTimeoutResponse | MethodNotAllowedResponse | InternalServerErrorResponse | ResponseTimeoutResponse | ServerTimeoutErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof proxyLambdaPost>>, TError,{lambdaId: Uuid;lambdaProxyPathParameter: Uuid}, TContext>, request?: SecondParameter<typeof lp5AxiosClient>}
): UseMutationOptions<Awaited<ReturnType<typeof proxyLambdaPost>>, TError,{lambdaId: Uuid;lambdaProxyPathParameter: Uuid}, TContext> => {

const mutationKey = ['proxyLambdaPost'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof proxyLambdaPost>>, {lambdaId: Uuid;lambdaProxyPathParameter: Uuid}> = (props) => {
          const {lambdaId,lambdaProxyPathParameter} = props ?? {};

          return  proxyLambdaPost(lambdaId,lambdaProxyPathParameter,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type ProxyLambdaPostMutationResult = NonNullable<Awaited<ReturnType<typeof proxyLambdaPost>>>

    export type ProxyLambdaPostMutationError = ForbiddenLambdaErrorWithLicenseResponse | LambdaOrPageNotFoundResponse | RequestTimeoutResponse | MethodNotAllowedResponse | InternalServerErrorResponse | ResponseTimeoutResponse | ServerTimeoutErrorResponse

    /**
 * @summary proxy post request to lambda
 */
export const useProxyLambdaPost = <TError = ForbiddenLambdaErrorWithLicenseResponse | LambdaOrPageNotFoundResponse | RequestTimeoutResponse | MethodNotAllowedResponse | InternalServerErrorResponse | ResponseTimeoutResponse | ServerTimeoutErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof proxyLambdaPost>>, TError,{lambdaId: Uuid;lambdaProxyPathParameter: Uuid}, TContext>, request?: SecondParameter<typeof lp5AxiosClient>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof proxyLambdaPost>>,
        TError,
        {lambdaId: Uuid;lambdaProxyPathParameter: Uuid},
        TContext
      > => {
      return useMutation(getProxyLambdaPostMutationOptions(options), queryClient);
    }

/**
 * Proxy GET request to lambda.
 *
 * Request and response headers and query parameters
 * [must be provided](#operation/getLambdaSpec) by lambda documentation.
 *
 * Described headers will be processed and received independently of lambda behavior.
 * In case of `bearer` authorization, the token must include `view` permissions for `lambdas` to process request.
 * @summary proxy get request to lambda
 */
export const proxyLambdaGet = (
    lambdaId: Uuid,
    lambdaProxyPathParameter: Uuid,
 options?: SecondParameter<typeof lp5AxiosClient>,signal?: AbortSignal
) => {


      return lp5AxiosClient<void>(
      {url: `/6/lambdas/${lambdaId}/proxy/${lambdaProxyPathParameter}`, method: 'GET', signal
    },
      options);
    }




export const getProxyLambdaGetQueryKey = (lambdaId: Uuid,
    lambdaProxyPathParameter: Uuid,) => {
    return [
    `/6/lambdas/${lambdaId}/proxy/${lambdaProxyPathParameter}`
    ] as const;
    }


export const getProxyLambdaGetQueryOptions = <TData = Awaited<ReturnType<typeof proxyLambdaGet>>, TError = ForbiddenLambdaErrorWithLicenseResponse | LambdaOrPageNotFoundResponse | RequestTimeoutResponse | MethodNotAllowedResponse | InternalServerErrorResponse | ResponseTimeoutResponse | ServerTimeoutErrorResponse>(lambdaId: Uuid,
    lambdaProxyPathParameter: Uuid, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof proxyLambdaGet>>, TError, TData>>, request?: SecondParameter<typeof lp5AxiosClient>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getProxyLambdaGetQueryKey(lambdaId,lambdaProxyPathParameter);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof proxyLambdaGet>>> = ({ signal }) => proxyLambdaGet(lambdaId,lambdaProxyPathParameter, requestOptions, signal);





   return  { queryKey, queryFn, enabled: lambdaId !== null && lambdaId !== undefined && lambdaProxyPathParameter !== null && lambdaProxyPathParameter !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof proxyLambdaGet>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ProxyLambdaGetQueryResult = NonNullable<Awaited<ReturnType<typeof proxyLambdaGet>>>
export type ProxyLambdaGetQueryError = ForbiddenLambdaErrorWithLicenseResponse | LambdaOrPageNotFoundResponse | RequestTimeoutResponse | MethodNotAllowedResponse | InternalServerErrorResponse | ResponseTimeoutResponse | ServerTimeoutErrorResponse


export function useProxyLambdaGet<TData = Awaited<ReturnType<typeof proxyLambdaGet>>, TError = ForbiddenLambdaErrorWithLicenseResponse | LambdaOrPageNotFoundResponse | RequestTimeoutResponse | MethodNotAllowedResponse | InternalServerErrorResponse | ResponseTimeoutResponse | ServerTimeoutErrorResponse>(
 lambdaId: Uuid,
    lambdaProxyPathParameter: Uuid, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof proxyLambdaGet>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof proxyLambdaGet>>,
          TError,
          Awaited<ReturnType<typeof proxyLambdaGet>>
        > , 'initialData'
      >, request?: SecondParameter<typeof lp5AxiosClient>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useProxyLambdaGet<TData = Awaited<ReturnType<typeof proxyLambdaGet>>, TError = ForbiddenLambdaErrorWithLicenseResponse | LambdaOrPageNotFoundResponse | RequestTimeoutResponse | MethodNotAllowedResponse | InternalServerErrorResponse | ResponseTimeoutResponse | ServerTimeoutErrorResponse>(
 lambdaId: Uuid,
    lambdaProxyPathParameter: Uuid, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof proxyLambdaGet>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof proxyLambdaGet>>,
          TError,
          Awaited<ReturnType<typeof proxyLambdaGet>>
        > , 'initialData'
      >, request?: SecondParameter<typeof lp5AxiosClient>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useProxyLambdaGet<TData = Awaited<ReturnType<typeof proxyLambdaGet>>, TError = ForbiddenLambdaErrorWithLicenseResponse | LambdaOrPageNotFoundResponse | RequestTimeoutResponse | MethodNotAllowedResponse | InternalServerErrorResponse | ResponseTimeoutResponse | ServerTimeoutErrorResponse>(
 lambdaId: Uuid,
    lambdaProxyPathParameter: Uuid, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof proxyLambdaGet>>, TError, TData>>, request?: SecondParameter<typeof lp5AxiosClient>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary proxy get request to lambda
 */

export function useProxyLambdaGet<TData = Awaited<ReturnType<typeof proxyLambdaGet>>, TError = ForbiddenLambdaErrorWithLicenseResponse | LambdaOrPageNotFoundResponse | RequestTimeoutResponse | MethodNotAllowedResponse | InternalServerErrorResponse | ResponseTimeoutResponse | ServerTimeoutErrorResponse>(
 lambdaId: Uuid,
    lambdaProxyPathParameter: Uuid, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof proxyLambdaGet>>, TError, TData>>, request?: SecondParameter<typeof lp5AxiosClient>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getProxyLambdaGetQueryOptions(lambdaId,lambdaProxyPathParameter,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}







/**
 * Proxy OPTIONS request to lambda.
 *
 * The response to options contains all the possible methods that can be proxyed to a lambda,
 * but does not say which of them are implemented and which are not.
 * @summary proxy options request to lambda
 */
export const proxyLambdaOptions = (
    lambdaId: Uuid,
    lambdaProxyPathParameter: Uuid,
    params?: ProxyLambdaOptionsParams,
 options?: SecondParameter<typeof lp5AxiosClient>,signal?: AbortSignal
) => {


      return lp5AxiosClient<void>(
      {url: `/6/lambdas/${lambdaId}/proxy/${lambdaProxyPathParameter}`, method: 'OPTIONS',
        params, signal
    },
      options);
    }




export const getProxyLambdaOptionsMutationOptions = <TError = ForbiddenLambdaErrorResponse | LambdaOrPageNotFoundResponse | MethodNotAllowedResponse | RequestTimeoutResponse | InternalServerErrorResponse | ResponseTimeoutResponse | ServerTimeoutErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof proxyLambdaOptions>>, TError,{lambdaId: Uuid;lambdaProxyPathParameter: Uuid;params?: ProxyLambdaOptionsParams}, TContext>, request?: SecondParameter<typeof lp5AxiosClient>}
): UseMutationOptions<Awaited<ReturnType<typeof proxyLambdaOptions>>, TError,{lambdaId: Uuid;lambdaProxyPathParameter: Uuid;params?: ProxyLambdaOptionsParams}, TContext> => {

const mutationKey = ['proxyLambdaOptions'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof proxyLambdaOptions>>, {lambdaId: Uuid;lambdaProxyPathParameter: Uuid;params?: ProxyLambdaOptionsParams}> = (props) => {
          const {lambdaId,lambdaProxyPathParameter,params} = props ?? {};

          return  proxyLambdaOptions(lambdaId,lambdaProxyPathParameter,params,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type ProxyLambdaOptionsMutationResult = NonNullable<Awaited<ReturnType<typeof proxyLambdaOptions>>>

    export type ProxyLambdaOptionsMutationError = ForbiddenLambdaErrorResponse | LambdaOrPageNotFoundResponse | MethodNotAllowedResponse | RequestTimeoutResponse | InternalServerErrorResponse | ResponseTimeoutResponse | ServerTimeoutErrorResponse

    /**
 * @summary proxy options request to lambda
 */
export const useProxyLambdaOptions = <TError = ForbiddenLambdaErrorResponse | LambdaOrPageNotFoundResponse | MethodNotAllowedResponse | RequestTimeoutResponse | InternalServerErrorResponse | ResponseTimeoutResponse | ServerTimeoutErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof proxyLambdaOptions>>, TError,{lambdaId: Uuid;lambdaProxyPathParameter: Uuid;params?: ProxyLambdaOptionsParams}, TContext>, request?: SecondParameter<typeof lp5AxiosClient>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof proxyLambdaOptions>>,
        TError,
        {lambdaId: Uuid;lambdaProxyPathParameter: Uuid;params?: ProxyLambdaOptionsParams},
        TContext
      > => {
      return useMutation(getProxyLambdaOptionsMutationOptions(options), queryClient);
    }

/**
 * Get lambda image.
 * @summary get lambda image
 */
export const getLambdaImage = (
    lambdaId: Uuid,
 options?: SecondParameter<typeof lp5AxiosClient>,signal?: AbortSignal
) => {


      return lp5AxiosClient<GetLambdaImage200>(
      {url: `/6/lambdas/${lambdaId}/image`, method: 'GET', signal
    },
      options);
    }




export const getGetLambdaImageQueryKey = (lambdaId: Uuid,) => {
    return [
    `/6/lambdas/${lambdaId}/image`
    ] as const;
    }


export const getGetLambdaImageQueryOptions = <TData = Awaited<ReturnType<typeof getLambdaImage>>, TError = Error | ForbiddenLambdaErrorResponse | RequestTimeoutResponse | InternalServerErrorResponse | ResponseTimeoutResponse | ServerTimeoutErrorResponse>(lambdaId: Uuid, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getLambdaImage>>, TError, TData>>, request?: SecondParameter<typeof lp5AxiosClient>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetLambdaImageQueryKey(lambdaId);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getLambdaImage>>> = ({ signal }) => getLambdaImage(lambdaId, requestOptions, signal);





   return  { queryKey, queryFn, enabled: lambdaId !== null && lambdaId !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getLambdaImage>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetLambdaImageQueryResult = NonNullable<Awaited<ReturnType<typeof getLambdaImage>>>
export type GetLambdaImageQueryError = Error | ForbiddenLambdaErrorResponse | RequestTimeoutResponse | InternalServerErrorResponse | ResponseTimeoutResponse | ServerTimeoutErrorResponse


export function useGetLambdaImage<TData = Awaited<ReturnType<typeof getLambdaImage>>, TError = Error | ForbiddenLambdaErrorResponse | RequestTimeoutResponse | InternalServerErrorResponse | ResponseTimeoutResponse | ServerTimeoutErrorResponse>(
 lambdaId: Uuid, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getLambdaImage>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getLambdaImage>>,
          TError,
          Awaited<ReturnType<typeof getLambdaImage>>
        > , 'initialData'
      >, request?: SecondParameter<typeof lp5AxiosClient>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetLambdaImage<TData = Awaited<ReturnType<typeof getLambdaImage>>, TError = Error | ForbiddenLambdaErrorResponse | RequestTimeoutResponse | InternalServerErrorResponse | ResponseTimeoutResponse | ServerTimeoutErrorResponse>(
 lambdaId: Uuid, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getLambdaImage>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getLambdaImage>>,
          TError,
          Awaited<ReturnType<typeof getLambdaImage>>
        > , 'initialData'
      >, request?: SecondParameter<typeof lp5AxiosClient>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetLambdaImage<TData = Awaited<ReturnType<typeof getLambdaImage>>, TError = Error | ForbiddenLambdaErrorResponse | RequestTimeoutResponse | InternalServerErrorResponse | ResponseTimeoutResponse | ServerTimeoutErrorResponse>(
 lambdaId: Uuid, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getLambdaImage>>, TError, TData>>, request?: SecondParameter<typeof lp5AxiosClient>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary get lambda image
 */

export function useGetLambdaImage<TData = Awaited<ReturnType<typeof getLambdaImage>>, TError = Error | ForbiddenLambdaErrorResponse | RequestTimeoutResponse | InternalServerErrorResponse | ResponseTimeoutResponse | ServerTimeoutErrorResponse>(
 lambdaId: Uuid, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getLambdaImage>>, TError, TData>>, request?: SecondParameter<typeof lp5AxiosClient>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetLambdaImageQueryOptions(lambdaId,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}







/**
 * Export archive with lambda and parameters.
 * @summary export lambda archive
 */
export const exportLambda = (
    lambdaId: Uuid,
 options?: SecondParameter<typeof lp5AxiosClient>,signal?: AbortSignal
) => {


      return lp5AxiosClient<Blob>(
      {url: `/6/lambdas/${lambdaId}/export`, method: 'GET',
        responseType: 'blob', signal
    },
      options);
    }




export const getExportLambdaQueryKey = (lambdaId: Uuid,) => {
    return [
    `/6/lambdas/${lambdaId}/export`
    ] as const;
    }


export const getExportLambdaQueryOptions = <TData = Awaited<ReturnType<typeof exportLambda>>, TError = LambdaNotFoundResponse | LambdaNoArchiveResponse | MethodNotAllowedResponse | LambdaNotRunningResponse | InternalServerErrorResponse>(lambdaId: Uuid, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof exportLambda>>, TError, TData>>, request?: SecondParameter<typeof lp5AxiosClient>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getExportLambdaQueryKey(lambdaId);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof exportLambda>>> = ({ signal }) => exportLambda(lambdaId, requestOptions, signal);





   return  { queryKey, queryFn, enabled: lambdaId !== null && lambdaId !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof exportLambda>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ExportLambdaQueryResult = NonNullable<Awaited<ReturnType<typeof exportLambda>>>
export type ExportLambdaQueryError = LambdaNotFoundResponse | LambdaNoArchiveResponse | MethodNotAllowedResponse | LambdaNotRunningResponse | InternalServerErrorResponse


export function useExportLambda<TData = Awaited<ReturnType<typeof exportLambda>>, TError = LambdaNotFoundResponse | LambdaNoArchiveResponse | MethodNotAllowedResponse | LambdaNotRunningResponse | InternalServerErrorResponse>(
 lambdaId: Uuid, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof exportLambda>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof exportLambda>>,
          TError,
          Awaited<ReturnType<typeof exportLambda>>
        > , 'initialData'
      >, request?: SecondParameter<typeof lp5AxiosClient>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useExportLambda<TData = Awaited<ReturnType<typeof exportLambda>>, TError = LambdaNotFoundResponse | LambdaNoArchiveResponse | MethodNotAllowedResponse | LambdaNotRunningResponse | InternalServerErrorResponse>(
 lambdaId: Uuid, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof exportLambda>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof exportLambda>>,
          TError,
          Awaited<ReturnType<typeof exportLambda>>
        > , 'initialData'
      >, request?: SecondParameter<typeof lp5AxiosClient>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useExportLambda<TData = Awaited<ReturnType<typeof exportLambda>>, TError = LambdaNotFoundResponse | LambdaNoArchiveResponse | MethodNotAllowedResponse | LambdaNotRunningResponse | InternalServerErrorResponse>(
 lambdaId: Uuid, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof exportLambda>>, TError, TData>>, request?: SecondParameter<typeof lp5AxiosClient>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary export lambda archive
 */

export function useExportLambda<TData = Awaited<ReturnType<typeof exportLambda>>, TError = LambdaNotFoundResponse | LambdaNoArchiveResponse | MethodNotAllowedResponse | LambdaNotRunningResponse | InternalServerErrorResponse>(
 lambdaId: Uuid, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof exportLambda>>, TError, TData>>, request?: SecondParameter<typeof lp5AxiosClient>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getExportLambdaQueryOptions(lambdaId,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}







/**
 * import archive with lambda and parameters.
 * @summary import lambda archive
 */
export const importLambda = (
    lambdaMultipartImport?: LambdaMultipartImport,
 options?: SecondParameter<typeof lp5AxiosClient>,signal?: AbortSignal
) => {

      const formData = new FormData();
if(lambdaMultipartImport?.archive !== undefined) {
 formData.append(`archive`, lambdaMultipartImport.archive);
 }
if(lambdaMultipartImport?.credentials !== undefined) {
 formData.append(`credentials`, JSON.stringify(lambdaMultipartImport.credentials));
 }
if(lambdaMultipartImport?.parameters !== undefined) {
 formData.append(`parameters`, JSON.stringify(lambdaMultipartImport.parameters));
 }
if(lambdaMultipartImport?.deploy_parameters !== undefined) {
 formData.append(`deploy_parameters`, lambdaMultipartImport.deploy_parameters);
 }

      return lp5AxiosClient<LambdaIdResponse>(
      {url: `/6/lambdas/import`, method: 'POST',
      headers: {'Content-Type': 'multipart/form-data', },
       data: formData, signal
    },
      options);
    }




export const getImportLambdaMutationOptions = <TError = LambdaFailedImportMultipartResponse | LambdaNotFoundResponse | LambdaAlreadyExistsByNameResponse | MethodNotAllowedResponse | InternalServerErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof importLambda>>, TError,{data?: LambdaMultipartImport}, TContext>, request?: SecondParameter<typeof lp5AxiosClient>}
): UseMutationOptions<Awaited<ReturnType<typeof importLambda>>, TError,{data?: LambdaMultipartImport}, TContext> => {

const mutationKey = ['importLambda'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof importLambda>>, {data?: LambdaMultipartImport}> = (props) => {
          const {data} = props ?? {};

          return  importLambda(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type ImportLambdaMutationResult = NonNullable<Awaited<ReturnType<typeof importLambda>>>
    export type ImportLambdaMutationBody = LambdaMultipartImport | undefined
    export type ImportLambdaMutationError = LambdaFailedImportMultipartResponse | LambdaNotFoundResponse | LambdaAlreadyExistsByNameResponse | MethodNotAllowedResponse | InternalServerErrorResponse

    /**
 * @summary import lambda archive
 */
export const useImportLambda = <TError = LambdaFailedImportMultipartResponse | LambdaNotFoundResponse | LambdaAlreadyExistsByNameResponse | MethodNotAllowedResponse | InternalServerErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof importLambda>>, TError,{data?: LambdaMultipartImport}, TContext>, request?: SecondParameter<typeof lp5AxiosClient>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof importLambda>>,
        TError,
        {data?: LambdaMultipartImport},
        TContext
      > => {
      return useMutation(getImportLambdaMutationOptions(options), queryClient);
    }

/**
 * Get lambda user configuration
 * @summary get lambda config
 */
export const getLambdaConfig = (
    lambdaId: Uuid,
    params?: GetLambdaConfigParams,
 options?: SecondParameter<typeof lp5AxiosClient>,signal?: AbortSignal
) => {


      return lp5AxiosClient<ConfigWithVersion>(
      {url: `/6/lambdas/${lambdaId}/config`, method: 'GET',
        params, signal
    },
      options);
    }




export const getGetLambdaConfigQueryKey = (lambdaId: Uuid,
    params?: GetLambdaConfigParams,) => {
    return [
    `/6/lambdas/${lambdaId}/config`, ...(params ? [params] : [])
    ] as const;
    }


export const getGetLambdaConfigQueryOptions = <TData = Awaited<ReturnType<typeof getLambdaConfig>>, TError = LambdaNotFoundResponse | RequestTimeoutResponse | MethodNotAllowedResponse | LambdaNotRunningResponse | InternalServerErrorResponse>(lambdaId: Uuid,
    params?: GetLambdaConfigParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getLambdaConfig>>, TError, TData>>, request?: SecondParameter<typeof lp5AxiosClient>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetLambdaConfigQueryKey(lambdaId,params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getLambdaConfig>>> = ({ signal }) => getLambdaConfig(lambdaId,params, requestOptions, signal);





   return  { queryKey, queryFn, enabled: lambdaId !== null && lambdaId !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getLambdaConfig>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetLambdaConfigQueryResult = NonNullable<Awaited<ReturnType<typeof getLambdaConfig>>>
export type GetLambdaConfigQueryError = LambdaNotFoundResponse | RequestTimeoutResponse | MethodNotAllowedResponse | LambdaNotRunningResponse | InternalServerErrorResponse


export function useGetLambdaConfig<TData = Awaited<ReturnType<typeof getLambdaConfig>>, TError = LambdaNotFoundResponse | RequestTimeoutResponse | MethodNotAllowedResponse | LambdaNotRunningResponse | InternalServerErrorResponse>(
 lambdaId: Uuid,
    params: undefined |  GetLambdaConfigParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getLambdaConfig>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getLambdaConfig>>,
          TError,
          Awaited<ReturnType<typeof getLambdaConfig>>
        > , 'initialData'
      >, request?: SecondParameter<typeof lp5AxiosClient>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetLambdaConfig<TData = Awaited<ReturnType<typeof getLambdaConfig>>, TError = LambdaNotFoundResponse | RequestTimeoutResponse | MethodNotAllowedResponse | LambdaNotRunningResponse | InternalServerErrorResponse>(
 lambdaId: Uuid,
    params?: GetLambdaConfigParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getLambdaConfig>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getLambdaConfig>>,
          TError,
          Awaited<ReturnType<typeof getLambdaConfig>>
        > , 'initialData'
      >, request?: SecondParameter<typeof lp5AxiosClient>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetLambdaConfig<TData = Awaited<ReturnType<typeof getLambdaConfig>>, TError = LambdaNotFoundResponse | RequestTimeoutResponse | MethodNotAllowedResponse | LambdaNotRunningResponse | InternalServerErrorResponse>(
 lambdaId: Uuid,
    params?: GetLambdaConfigParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getLambdaConfig>>, TError, TData>>, request?: SecondParameter<typeof lp5AxiosClient>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary get lambda config
 */

export function useGetLambdaConfig<TData = Awaited<ReturnType<typeof getLambdaConfig>>, TError = LambdaNotFoundResponse | RequestTimeoutResponse | MethodNotAllowedResponse | LambdaNotRunningResponse | InternalServerErrorResponse>(
 lambdaId: Uuid,
    params?: GetLambdaConfigParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getLambdaConfig>>, TError, TData>>, request?: SecondParameter<typeof lp5AxiosClient>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetLambdaConfigQueryOptions(lambdaId,params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}







/**
 * Update lambda user configuration
 * @summary update lambda config
 */
export const putLambdaConfig = (
    lambdaId: Uuid,
    userConfigRequest: UserConfigRequest,
 options?: SecondParameter<typeof lp5AxiosClient>,signal?: AbortSignal
) => {


      return lp5AxiosClient<ConfigVersionResponse>(
      {url: `/6/lambdas/${lambdaId}/config`, method: 'PUT',
      headers: {'Content-Type': 'application/json', },
      data: userConfigRequest, signal
    },
      options);
    }




export const getPutLambdaConfigMutationOptions = <TError = Error | RequestTimeoutResponse | InternalServerErrorResponse | ResponseTimeoutResponse | ServerTimeoutErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof putLambdaConfig>>, TError,{lambdaId: Uuid;data: UserConfigRequest}, TContext>, request?: SecondParameter<typeof lp5AxiosClient>}
): UseMutationOptions<Awaited<ReturnType<typeof putLambdaConfig>>, TError,{lambdaId: Uuid;data: UserConfigRequest}, TContext> => {

const mutationKey = ['putLambdaConfig'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof putLambdaConfig>>, {lambdaId: Uuid;data: UserConfigRequest}> = (props) => {
          const {lambdaId,data} = props ?? {};

          return  putLambdaConfig(lambdaId,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type PutLambdaConfigMutationResult = NonNullable<Awaited<ReturnType<typeof putLambdaConfig>>>
    export type PutLambdaConfigMutationBody = UserConfigRequest
    export type PutLambdaConfigMutationError = Error | RequestTimeoutResponse | InternalServerErrorResponse | ResponseTimeoutResponse | ServerTimeoutErrorResponse

    /**
 * @summary update lambda config
 */
export const usePutLambdaConfig = <TError = Error | RequestTimeoutResponse | InternalServerErrorResponse | ResponseTimeoutResponse | ServerTimeoutErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof putLambdaConfig>>, TError,{lambdaId: Uuid;data: UserConfigRequest}, TContext>, request?: SecondParameter<typeof lp5AxiosClient>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof putLambdaConfig>>,
        TError,
        {lambdaId: Uuid;data: UserConfigRequest},
        TContext
      > => {
      return useMutation(getPutLambdaConfigMutationOptions(options), queryClient);
    }

/**
 * Get lambda metrics
 * @summary get lambda metrics
 */
export const getLambdaMetrics = (
    lambdaId: Uuid,
    params: GetLambdaMetricsParams,
 options?: SecondParameter<typeof lp5AxiosClient>,signal?: AbortSignal
) => {


      return lp5AxiosClient<LambdaMetrics>(
      {url: `/6/lambdas/${lambdaId}/metrics`, method: 'GET',
        params, signal
    },
      options);
    }




export const getGetLambdaMetricsQueryKey = (lambdaId: Uuid,
    params?: GetLambdaMetricsParams,) => {
    return [
    `/6/lambdas/${lambdaId}/metrics`, ...(params ? [params] : [])
    ] as const;
    }


export const getGetLambdaMetricsQueryOptions = <TData = Awaited<ReturnType<typeof getLambdaMetrics>>, TError = Error | RequestTimeoutResponse | InternalServerErrorResponse | ResponseTimeoutResponse | ServerTimeoutErrorResponse>(lambdaId: Uuid,
    params: GetLambdaMetricsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getLambdaMetrics>>, TError, TData>>, request?: SecondParameter<typeof lp5AxiosClient>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetLambdaMetricsQueryKey(lambdaId,params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getLambdaMetrics>>> = ({ signal }) => getLambdaMetrics(lambdaId,params, requestOptions, signal);





   return  { queryKey, queryFn, enabled: lambdaId !== null && lambdaId !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getLambdaMetrics>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetLambdaMetricsQueryResult = NonNullable<Awaited<ReturnType<typeof getLambdaMetrics>>>
export type GetLambdaMetricsQueryError = Error | RequestTimeoutResponse | InternalServerErrorResponse | ResponseTimeoutResponse | ServerTimeoutErrorResponse


export function useGetLambdaMetrics<TData = Awaited<ReturnType<typeof getLambdaMetrics>>, TError = Error | RequestTimeoutResponse | InternalServerErrorResponse | ResponseTimeoutResponse | ServerTimeoutErrorResponse>(
 lambdaId: Uuid,
    params: GetLambdaMetricsParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getLambdaMetrics>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getLambdaMetrics>>,
          TError,
          Awaited<ReturnType<typeof getLambdaMetrics>>
        > , 'initialData'
      >, request?: SecondParameter<typeof lp5AxiosClient>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetLambdaMetrics<TData = Awaited<ReturnType<typeof getLambdaMetrics>>, TError = Error | RequestTimeoutResponse | InternalServerErrorResponse | ResponseTimeoutResponse | ServerTimeoutErrorResponse>(
 lambdaId: Uuid,
    params: GetLambdaMetricsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getLambdaMetrics>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getLambdaMetrics>>,
          TError,
          Awaited<ReturnType<typeof getLambdaMetrics>>
        > , 'initialData'
      >, request?: SecondParameter<typeof lp5AxiosClient>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetLambdaMetrics<TData = Awaited<ReturnType<typeof getLambdaMetrics>>, TError = Error | RequestTimeoutResponse | InternalServerErrorResponse | ResponseTimeoutResponse | ServerTimeoutErrorResponse>(
 lambdaId: Uuid,
    params: GetLambdaMetricsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getLambdaMetrics>>, TError, TData>>, request?: SecondParameter<typeof lp5AxiosClient>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary get lambda metrics
 */

export function useGetLambdaMetrics<TData = Awaited<ReturnType<typeof getLambdaMetrics>>, TError = Error | RequestTimeoutResponse | InternalServerErrorResponse | ResponseTimeoutResponse | ServerTimeoutErrorResponse>(
 lambdaId: Uuid,
    params: GetLambdaMetricsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getLambdaMetrics>>, TError, TData>>, request?: SecondParameter<typeof lp5AxiosClient>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetLambdaMetricsQueryOptions(lambdaId,params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}







/**
 * Enable/disable lambda.
 * @summary switch lambda
 */
export const switchLambda = (
    lambdaId: Uuid,
    lambdaSwitch?: LambdaSwitch,
 options?: SecondParameter<typeof lp5AxiosClient>,signal?: AbortSignal
) => {


      return lp5AxiosClient<void | LambdaIdResponse>(
      {url: `/6/lambdas/${lambdaId}/switch`, method: 'PATCH',
      headers: {'Content-Type': 'application/json', },
      data: lambdaSwitch, signal
    },
      options);
    }




export const getSwitchLambdaMutationOptions = <TError = Error | LambdaNotFoundResponse | InternalServerErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof switchLambda>>, TError,{lambdaId: Uuid;data?: LambdaSwitch}, TContext>, request?: SecondParameter<typeof lp5AxiosClient>}
): UseMutationOptions<Awaited<ReturnType<typeof switchLambda>>, TError,{lambdaId: Uuid;data?: LambdaSwitch}, TContext> => {

const mutationKey = ['switchLambda'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof switchLambda>>, {lambdaId: Uuid;data?: LambdaSwitch}> = (props) => {
          const {lambdaId,data} = props ?? {};

          return  switchLambda(lambdaId,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type SwitchLambdaMutationResult = NonNullable<Awaited<ReturnType<typeof switchLambda>>>
    export type SwitchLambdaMutationBody = LambdaSwitch | undefined
    export type SwitchLambdaMutationError = Error | LambdaNotFoundResponse | InternalServerErrorResponse

    /**
 * @summary switch lambda
 */
export const useSwitchLambda = <TError = Error | LambdaNotFoundResponse | InternalServerErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof switchLambda>>, TError,{lambdaId: Uuid;data?: LambdaSwitch}, TContext>, request?: SecondParameter<typeof lp5AxiosClient>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof switchLambda>>,
        TError,
        {lambdaId: Uuid;data?: LambdaSwitch},
        TContext
      > => {
      return useMutation(getSwitchLambdaMutationOptions(options), queryClient);
    }

/**
 * Start retranslation.
 * @summary create restream
 */
export const createRestream = (
    restreamCreate?: RestreamCreate,
 options?: SecondParameter<typeof lp5AxiosClient>,signal?: AbortSignal
) => {


      return lp5AxiosClient<StreamInfoRequired>(
      {url: `/6/restream`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: restreamCreate, signal
    },
      options);
    }




export const getCreateRestreamMutationOptions = <TError = Error | RequestTimeoutResponse | PayloadToLargeResponse | InternalServerErrorResponse | ResponseTimeoutResponse | ServerTimeoutErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createRestream>>, TError,{data?: RestreamCreate}, TContext>, request?: SecondParameter<typeof lp5AxiosClient>}
): UseMutationOptions<Awaited<ReturnType<typeof createRestream>>, TError,{data?: RestreamCreate}, TContext> => {

const mutationKey = ['createRestream'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof createRestream>>, {data?: RestreamCreate}> = (props) => {
          const {data} = props ?? {};

          return  createRestream(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type CreateRestreamMutationResult = NonNullable<Awaited<ReturnType<typeof createRestream>>>
    export type CreateRestreamMutationBody = RestreamCreate | undefined
    export type CreateRestreamMutationError = Error | RequestTimeoutResponse | PayloadToLargeResponse | InternalServerErrorResponse | ResponseTimeoutResponse | ServerTimeoutErrorResponse

    /**
 * @summary create restream
 */
export const useCreateRestream = <TError = Error | RequestTimeoutResponse | PayloadToLargeResponse | InternalServerErrorResponse | ResponseTimeoutResponse | ServerTimeoutErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createRestream>>, TError,{data?: RestreamCreate}, TContext>, request?: SecondParameter<typeof lp5AxiosClient>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof createRestream>>,
        TError,
        {data?: RestreamCreate},
        TContext
      > => {
      return useMutation(getCreateRestreamMutationOptions(options), queryClient);
    }

/**
 * Get health of service.
 * @summary get health
 */
export const healthcheck = (
    params?: HealthcheckParams,
 options?: SecondParameter<typeof lp5AxiosClient>,signal?: AbortSignal
) => {


      return lp5AxiosClient<HealthOk>(
      {url: `/6/healthcheck`, method: 'GET',
        params, signal
    },
      options);
    }




export const getHealthcheckQueryKey = (params?: HealthcheckParams,) => {
    return [
    `/6/healthcheck`, ...(params ? [params] : [])
    ] as const;
    }


export const getHealthcheckQueryOptions = <TData = Awaited<ReturnType<typeof healthcheck>>, TError = RequestTimeoutResponse | InternalServerErrorResponse | HealthErrors | ResponseTimeoutResponse | ServerTimeoutErrorResponse>(params?: HealthcheckParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof healthcheck>>, TError, TData>>, request?: SecondParameter<typeof lp5AxiosClient>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getHealthcheckQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof healthcheck>>> = ({ signal }) => healthcheck(params, requestOptions, signal);





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof healthcheck>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type HealthcheckQueryResult = NonNullable<Awaited<ReturnType<typeof healthcheck>>>
export type HealthcheckQueryError = RequestTimeoutResponse | InternalServerErrorResponse | HealthErrors | ResponseTimeoutResponse | ServerTimeoutErrorResponse


export function useHealthcheck<TData = Awaited<ReturnType<typeof healthcheck>>, TError = RequestTimeoutResponse | InternalServerErrorResponse | HealthErrors | ResponseTimeoutResponse | ServerTimeoutErrorResponse>(
 params: undefined |  HealthcheckParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof healthcheck>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof healthcheck>>,
          TError,
          Awaited<ReturnType<typeof healthcheck>>
        > , 'initialData'
      >, request?: SecondParameter<typeof lp5AxiosClient>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useHealthcheck<TData = Awaited<ReturnType<typeof healthcheck>>, TError = RequestTimeoutResponse | InternalServerErrorResponse | HealthErrors | ResponseTimeoutResponse | ServerTimeoutErrorResponse>(
 params?: HealthcheckParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof healthcheck>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof healthcheck>>,
          TError,
          Awaited<ReturnType<typeof healthcheck>>
        > , 'initialData'
      >, request?: SecondParameter<typeof lp5AxiosClient>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useHealthcheck<TData = Awaited<ReturnType<typeof healthcheck>>, TError = RequestTimeoutResponse | InternalServerErrorResponse | HealthErrors | ResponseTimeoutResponse | ServerTimeoutErrorResponse>(
 params?: HealthcheckParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof healthcheck>>, TError, TData>>, request?: SecondParameter<typeof lp5AxiosClient>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary get health
 */

export function useHealthcheck<TData = Awaited<ReturnType<typeof healthcheck>>, TError = RequestTimeoutResponse | InternalServerErrorResponse | HealthErrors | ResponseTimeoutResponse | ServerTimeoutErrorResponse>(
 params?: HealthcheckParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof healthcheck>>, TError, TData>>, request?: SecondParameter<typeof lp5AxiosClient>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getHealthcheckQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}







/**
 * Get options for the resource.
 * @summary healthcheck options
 */
export const getHealthcheckOptions = (

 options?: SecondParameter<typeof lp5AxiosClient>,signal?: AbortSignal
) => {


      return lp5AxiosClient<void>(
      {url: `/6/healthcheck`, method: 'OPTIONS', signal
    },
      options);
    }




export const getGetHealthcheckOptionsMutationOptions = <TError = RequestTimeoutResponse | InternalServerErrorResponse | ResponseTimeoutResponse | ServerTimeoutErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof getHealthcheckOptions>>, TError,void, TContext>, request?: SecondParameter<typeof lp5AxiosClient>}
): UseMutationOptions<Awaited<ReturnType<typeof getHealthcheckOptions>>, TError,void, TContext> => {

const mutationKey = ['getHealthcheckOptions'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof getHealthcheckOptions>>, void> = () => {


          return  getHealthcheckOptions(requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type GetHealthcheckOptionsMutationResult = NonNullable<Awaited<ReturnType<typeof getHealthcheckOptions>>>

    export type GetHealthcheckOptionsMutationError = RequestTimeoutResponse | InternalServerErrorResponse | ResponseTimeoutResponse | ServerTimeoutErrorResponse

    /**
 * @summary healthcheck options
 */
export const useGetHealthcheckOptions = <TError = RequestTimeoutResponse | InternalServerErrorResponse | ResponseTimeoutResponse | ServerTimeoutErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof getHealthcheckOptions>>, TError,void, TContext>, request?: SecondParameter<typeof lp5AxiosClient>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof getHealthcheckOptions>>,
        TError,
        void,
        TContext
      > => {
      return useMutation(getGetHealthcheckOptionsMutationOptions(options), queryClient);
    }

/**
 * Create stream.
 *
 * See `Group settings` chapter in *Luna-Video-Manager* developers documentation for stream and groups settings and analytics
 * sharing features.
 * @summary create stream
 */
export const createStream = (
    streamToBeCreated: StreamToBeCreated,
    params?: CreateStreamParams,
 options?: SecondParameter<typeof lp5AxiosClient>,signal?: AbortSignal
) => {


      return lp5AxiosClient<CreateStream201>(
      {url: `/6/streams`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: streamToBeCreated,
        params, signal
    },
      options);
    }




export const getCreateStreamMutationOptions = <TError = Error | ForbiddenErrorResponse | RequestTimeoutResponse | PayloadToLargeResponse | StreamCreationUnprocessableResponse | InternalServerErrorResponse | ResponseTimeoutResponse | ServerTimeoutErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createStream>>, TError,{data: StreamToBeCreated;params?: CreateStreamParams}, TContext>, request?: SecondParameter<typeof lp5AxiosClient>}
): UseMutationOptions<Awaited<ReturnType<typeof createStream>>, TError,{data: StreamToBeCreated;params?: CreateStreamParams}, TContext> => {

const mutationKey = ['createStream'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof createStream>>, {data: StreamToBeCreated;params?: CreateStreamParams}> = (props) => {
          const {data,params} = props ?? {};

          return  createStream(data,params,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type CreateStreamMutationResult = NonNullable<Awaited<ReturnType<typeof createStream>>>
    export type CreateStreamMutationBody = StreamToBeCreated
    export type CreateStreamMutationError = Error | ForbiddenErrorResponse | RequestTimeoutResponse | PayloadToLargeResponse | StreamCreationUnprocessableResponse | InternalServerErrorResponse | ResponseTimeoutResponse | ServerTimeoutErrorResponse

    /**
 * @summary create stream
 */
export const useCreateStream = <TError = Error | ForbiddenErrorResponse | RequestTimeoutResponse | PayloadToLargeResponse | StreamCreationUnprocessableResponse | InternalServerErrorResponse | ResponseTimeoutResponse | ServerTimeoutErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createStream>>, TError,{data: StreamToBeCreated;params?: CreateStreamParams}, TContext>, request?: SecondParameter<typeof lp5AxiosClient>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof createStream>>,
        TError,
        {data: StreamToBeCreated;params?: CreateStreamParams},
        TContext
      > => {
      return useMutation(getCreateStreamMutationOptions(options), queryClient);
    }

/**
 * Get streams according to filters. The results are sorted by stream creation order, the oldest streams shown first.
 * @summary get streams
 */
export const getStreams = (
    params?: GetStreamsParams,
 options?: SecondParameter<typeof lp5AxiosClient>,signal?: AbortSignal
) => {


      return lp5AxiosClient<GetStreams200>(
      {url: `/6/streams`, method: 'GET',
        params, signal
    },
      options);
    }




export const getGetStreamsQueryKey = (params?: GetStreamsParams,) => {
    return [
    `/6/streams`, ...(params ? [params] : [])
    ] as const;
    }


export const getGetStreamsQueryOptions = <TData = Awaited<ReturnType<typeof getStreams>>, TError = Error | ForbiddenErrorResponse | RequestTimeoutResponse | InternalServerErrorResponse | ResponseTimeoutResponse | ServerTimeoutErrorResponse>(params?: GetStreamsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getStreams>>, TError, TData>>, request?: SecondParameter<typeof lp5AxiosClient>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetStreamsQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getStreams>>> = ({ signal }) => getStreams(params, requestOptions, signal);





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getStreams>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetStreamsQueryResult = NonNullable<Awaited<ReturnType<typeof getStreams>>>
export type GetStreamsQueryError = Error | ForbiddenErrorResponse | RequestTimeoutResponse | InternalServerErrorResponse | ResponseTimeoutResponse | ServerTimeoutErrorResponse


export function useGetStreams<TData = Awaited<ReturnType<typeof getStreams>>, TError = Error | ForbiddenErrorResponse | RequestTimeoutResponse | InternalServerErrorResponse | ResponseTimeoutResponse | ServerTimeoutErrorResponse>(
 params: undefined |  GetStreamsParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getStreams>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getStreams>>,
          TError,
          Awaited<ReturnType<typeof getStreams>>
        > , 'initialData'
      >, request?: SecondParameter<typeof lp5AxiosClient>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetStreams<TData = Awaited<ReturnType<typeof getStreams>>, TError = Error | ForbiddenErrorResponse | RequestTimeoutResponse | InternalServerErrorResponse | ResponseTimeoutResponse | ServerTimeoutErrorResponse>(
 params?: GetStreamsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getStreams>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getStreams>>,
          TError,
          Awaited<ReturnType<typeof getStreams>>
        > , 'initialData'
      >, request?: SecondParameter<typeof lp5AxiosClient>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetStreams<TData = Awaited<ReturnType<typeof getStreams>>, TError = Error | ForbiddenErrorResponse | RequestTimeoutResponse | InternalServerErrorResponse | ResponseTimeoutResponse | ServerTimeoutErrorResponse>(
 params?: GetStreamsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getStreams>>, TError, TData>>, request?: SecondParameter<typeof lp5AxiosClient>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary get streams
 */

export function useGetStreams<TData = Awaited<ReturnType<typeof getStreams>>, TError = Error | ForbiddenErrorResponse | RequestTimeoutResponse | InternalServerErrorResponse | ResponseTimeoutResponse | ServerTimeoutErrorResponse>(
 params?: GetStreamsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getStreams>>, TError, TData>>, request?: SecondParameter<typeof lp5AxiosClient>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetStreamsQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}







/**
 * Delete streams matching specified filters.
 * @summary delete streams
 */
export const deleteStreams = (
    streamsToBeDeleted: StreamsToBeDeleted,
    params?: DeleteStreamsParams,
 options?: SecondParameter<typeof lp5AxiosClient>,signal?: AbortSignal
) => {


      return lp5AxiosClient<void>(
      {url: `/6/streams`, method: 'DELETE',
      headers: {'Content-Type': 'application/json', },
      data: streamsToBeDeleted,
        params, signal
    },
      options);
    }




export const getDeleteStreamsMutationOptions = <TError = Error | ForbiddenErrorResponse | RequestTimeoutResponse | PayloadToLargeResponse | InternalServerErrorResponse | ResponseTimeoutResponse | ServerTimeoutErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteStreams>>, TError,{data: StreamsToBeDeleted;params?: DeleteStreamsParams}, TContext>, request?: SecondParameter<typeof lp5AxiosClient>}
): UseMutationOptions<Awaited<ReturnType<typeof deleteStreams>>, TError,{data: StreamsToBeDeleted;params?: DeleteStreamsParams}, TContext> => {

const mutationKey = ['deleteStreams'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof deleteStreams>>, {data: StreamsToBeDeleted;params?: DeleteStreamsParams}> = (props) => {
          const {data,params} = props ?? {};

          return  deleteStreams(data,params,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type DeleteStreamsMutationResult = NonNullable<Awaited<ReturnType<typeof deleteStreams>>>
    export type DeleteStreamsMutationBody = StreamsToBeDeleted
    export type DeleteStreamsMutationError = Error | ForbiddenErrorResponse | RequestTimeoutResponse | PayloadToLargeResponse | InternalServerErrorResponse | ResponseTimeoutResponse | ServerTimeoutErrorResponse

    /**
 * @summary delete streams
 */
export const useDeleteStreams = <TError = Error | ForbiddenErrorResponse | RequestTimeoutResponse | PayloadToLargeResponse | InternalServerErrorResponse | ResponseTimeoutResponse | ServerTimeoutErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteStreams>>, TError,{data: StreamsToBeDeleted;params?: DeleteStreamsParams}, TContext>, request?: SecondParameter<typeof lp5AxiosClient>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof deleteStreams>>,
        TError,
        {data: StreamsToBeDeleted;params?: DeleteStreamsParams},
        TContext
      > => {
      return useMutation(getDeleteStreamsMutationOptions(options), queryClient);
    }

/**
 * Get options for the resource.
 * @summary streams options
 */
export const getStreamsOptions = (

 options?: SecondParameter<typeof lp5AxiosClient>,signal?: AbortSignal
) => {


      return lp5AxiosClient<void>(
      {url: `/6/streams`, method: 'OPTIONS', signal
    },
      options);
    }




export const getGetStreamsOptionsMutationOptions = <TError = RequestTimeoutResponse | InternalServerErrorResponse | ResponseTimeoutResponse | ServerTimeoutErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof getStreamsOptions>>, TError,void, TContext>, request?: SecondParameter<typeof lp5AxiosClient>}
): UseMutationOptions<Awaited<ReturnType<typeof getStreamsOptions>>, TError,void, TContext> => {

const mutationKey = ['getStreamsOptions'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof getStreamsOptions>>, void> = () => {


          return  getStreamsOptions(requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type GetStreamsOptionsMutationResult = NonNullable<Awaited<ReturnType<typeof getStreamsOptions>>>

    export type GetStreamsOptionsMutationError = RequestTimeoutResponse | InternalServerErrorResponse | ResponseTimeoutResponse | ServerTimeoutErrorResponse

    /**
 * @summary streams options
 */
export const useGetStreamsOptions = <TError = RequestTimeoutResponse | InternalServerErrorResponse | ResponseTimeoutResponse | ServerTimeoutErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof getStreamsOptions>>, TError,void, TContext>, request?: SecondParameter<typeof lp5AxiosClient>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof getStreamsOptions>>,
        TError,
        void,
        TContext
      > => {
      return useMutation(getGetStreamsOptionsMutationOptions(options), queryClient);
    }

/**
 * Get streams logs according to filters. The results are sorted by log creation order, the new streams logs shown first.
 * @summary get streams logs
 */
export const getStreamsLogs = (
    params?: GetStreamsLogsParams,
 options?: SecondParameter<typeof lp5AxiosClient>,signal?: AbortSignal
) => {


      return lp5AxiosClient<StreamsLogs>(
      {url: `/6/streams/logs`, method: 'GET',
        params, signal
    },
      options);
    }




export const getGetStreamsLogsQueryKey = (params?: GetStreamsLogsParams,) => {
    return [
    `/6/streams/logs`, ...(params ? [params] : [])
    ] as const;
    }


export const getGetStreamsLogsQueryOptions = <TData = Awaited<ReturnType<typeof getStreamsLogs>>, TError = Error | ForbiddenErrorResponse | RequestTimeoutResponse | InternalServerErrorResponse | ResponseTimeoutResponse | ServerTimeoutErrorResponse>(params?: GetStreamsLogsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getStreamsLogs>>, TError, TData>>, request?: SecondParameter<typeof lp5AxiosClient>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetStreamsLogsQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getStreamsLogs>>> = ({ signal }) => getStreamsLogs(params, requestOptions, signal);





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getStreamsLogs>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetStreamsLogsQueryResult = NonNullable<Awaited<ReturnType<typeof getStreamsLogs>>>
export type GetStreamsLogsQueryError = Error | ForbiddenErrorResponse | RequestTimeoutResponse | InternalServerErrorResponse | ResponseTimeoutResponse | ServerTimeoutErrorResponse


export function useGetStreamsLogs<TData = Awaited<ReturnType<typeof getStreamsLogs>>, TError = Error | ForbiddenErrorResponse | RequestTimeoutResponse | InternalServerErrorResponse | ResponseTimeoutResponse | ServerTimeoutErrorResponse>(
 params: undefined |  GetStreamsLogsParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getStreamsLogs>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getStreamsLogs>>,
          TError,
          Awaited<ReturnType<typeof getStreamsLogs>>
        > , 'initialData'
      >, request?: SecondParameter<typeof lp5AxiosClient>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetStreamsLogs<TData = Awaited<ReturnType<typeof getStreamsLogs>>, TError = Error | ForbiddenErrorResponse | RequestTimeoutResponse | InternalServerErrorResponse | ResponseTimeoutResponse | ServerTimeoutErrorResponse>(
 params?: GetStreamsLogsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getStreamsLogs>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getStreamsLogs>>,
          TError,
          Awaited<ReturnType<typeof getStreamsLogs>>
        > , 'initialData'
      >, request?: SecondParameter<typeof lp5AxiosClient>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetStreamsLogs<TData = Awaited<ReturnType<typeof getStreamsLogs>>, TError = Error | ForbiddenErrorResponse | RequestTimeoutResponse | InternalServerErrorResponse | ResponseTimeoutResponse | ServerTimeoutErrorResponse>(
 params?: GetStreamsLogsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getStreamsLogs>>, TError, TData>>, request?: SecondParameter<typeof lp5AxiosClient>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary get streams logs
 */

export function useGetStreamsLogs<TData = Awaited<ReturnType<typeof getStreamsLogs>>, TError = Error | ForbiddenErrorResponse | RequestTimeoutResponse | InternalServerErrorResponse | ResponseTimeoutResponse | ServerTimeoutErrorResponse>(
 params?: GetStreamsLogsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getStreamsLogs>>, TError, TData>>, request?: SecondParameter<typeof lp5AxiosClient>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetStreamsLogsQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}







/**
 * Delete streams logs older than specified date excluding last log entry.
 * @summary delete stream logs
 */
export const deleteStreamsLogs = (
    params?: DeleteStreamsLogsParams,
 options?: SecondParameter<typeof lp5AxiosClient>,signal?: AbortSignal
) => {


      return lp5AxiosClient<StreamsLogsDeletedCount>(
      {url: `/6/streams/logs`, method: 'DELETE',
        params, signal
    },
      options);
    }




export const getDeleteStreamsLogsMutationOptions = <TError = Error | ForbiddenErrorResponse | RequestTimeoutResponse | InternalServerErrorResponse | ResponseTimeoutResponse | ServerTimeoutErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteStreamsLogs>>, TError,{params?: DeleteStreamsLogsParams}, TContext>, request?: SecondParameter<typeof lp5AxiosClient>}
): UseMutationOptions<Awaited<ReturnType<typeof deleteStreamsLogs>>, TError,{params?: DeleteStreamsLogsParams}, TContext> => {

const mutationKey = ['deleteStreamsLogs'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof deleteStreamsLogs>>, {params?: DeleteStreamsLogsParams}> = (props) => {
          const {params} = props ?? {};

          return  deleteStreamsLogs(params,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type DeleteStreamsLogsMutationResult = NonNullable<Awaited<ReturnType<typeof deleteStreamsLogs>>>

    export type DeleteStreamsLogsMutationError = Error | ForbiddenErrorResponse | RequestTimeoutResponse | InternalServerErrorResponse | ResponseTimeoutResponse | ServerTimeoutErrorResponse

    /**
 * @summary delete stream logs
 */
export const useDeleteStreamsLogs = <TError = Error | ForbiddenErrorResponse | RequestTimeoutResponse | InternalServerErrorResponse | ResponseTimeoutResponse | ServerTimeoutErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteStreamsLogs>>, TError,{params?: DeleteStreamsLogsParams}, TContext>, request?: SecondParameter<typeof lp5AxiosClient>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof deleteStreamsLogs>>,
        TError,
        {params?: DeleteStreamsLogsParams},
        TContext
      > => {
      return useMutation(getDeleteStreamsLogsMutationOptions(options), queryClient);
    }

/**
 * Get options for the resource.
 * @summary streams logs options
 */
export const getStreamsLogsOptions = (

 options?: SecondParameter<typeof lp5AxiosClient>,signal?: AbortSignal
) => {


      return lp5AxiosClient<void>(
      {url: `/6/streams/logs`, method: 'OPTIONS', signal
    },
      options);
    }




export const getGetStreamsLogsOptionsMutationOptions = <TError = RequestTimeoutResponse | InternalServerErrorResponse | ResponseTimeoutResponse | ServerTimeoutErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof getStreamsLogsOptions>>, TError,void, TContext>, request?: SecondParameter<typeof lp5AxiosClient>}
): UseMutationOptions<Awaited<ReturnType<typeof getStreamsLogsOptions>>, TError,void, TContext> => {

const mutationKey = ['getStreamsLogsOptions'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof getStreamsLogsOptions>>, void> = () => {


          return  getStreamsLogsOptions(requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type GetStreamsLogsOptionsMutationResult = NonNullable<Awaited<ReturnType<typeof getStreamsLogsOptions>>>

    export type GetStreamsLogsOptionsMutationError = RequestTimeoutResponse | InternalServerErrorResponse | ResponseTimeoutResponse | ServerTimeoutErrorResponse

    /**
 * @summary streams logs options
 */
export const useGetStreamsLogsOptions = <TError = RequestTimeoutResponse | InternalServerErrorResponse | ResponseTimeoutResponse | ServerTimeoutErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof getStreamsLogsOptions>>, TError,void, TContext>, request?: SecondParameter<typeof lp5AxiosClient>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof getStreamsLogsOptions>>,
        TError,
        void,
        TContext
      > => {
      return useMutation(getGetStreamsLogsOptionsMutationOptions(options), queryClient);
    }

/**
 * Count streams according to the filters.
 * @summary count streams
 */
export const countStreams = (
    params?: CountStreamsParams,
 options?: SecondParameter<typeof lp5AxiosClient>,signal?: AbortSignal
) => {


      return lp5AxiosClient<CountStreams200>(
      {url: `/6/streams/count`, method: 'GET',
        params, signal
    },
      options);
    }




export const getCountStreamsQueryKey = (params?: CountStreamsParams,) => {
    return [
    `/6/streams/count`, ...(params ? [params] : [])
    ] as const;
    }


export const getCountStreamsQueryOptions = <TData = Awaited<ReturnType<typeof countStreams>>, TError = Error | ForbiddenErrorResponse | RequestTimeoutResponse | InternalServerErrorResponse | ResponseTimeoutResponse | ServerTimeoutErrorResponse>(params?: CountStreamsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof countStreams>>, TError, TData>>, request?: SecondParameter<typeof lp5AxiosClient>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getCountStreamsQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof countStreams>>> = ({ signal }) => countStreams(params, requestOptions, signal);





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof countStreams>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type CountStreamsQueryResult = NonNullable<Awaited<ReturnType<typeof countStreams>>>
export type CountStreamsQueryError = Error | ForbiddenErrorResponse | RequestTimeoutResponse | InternalServerErrorResponse | ResponseTimeoutResponse | ServerTimeoutErrorResponse


export function useCountStreams<TData = Awaited<ReturnType<typeof countStreams>>, TError = Error | ForbiddenErrorResponse | RequestTimeoutResponse | InternalServerErrorResponse | ResponseTimeoutResponse | ServerTimeoutErrorResponse>(
 params: undefined |  CountStreamsParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof countStreams>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof countStreams>>,
          TError,
          Awaited<ReturnType<typeof countStreams>>
        > , 'initialData'
      >, request?: SecondParameter<typeof lp5AxiosClient>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useCountStreams<TData = Awaited<ReturnType<typeof countStreams>>, TError = Error | ForbiddenErrorResponse | RequestTimeoutResponse | InternalServerErrorResponse | ResponseTimeoutResponse | ServerTimeoutErrorResponse>(
 params?: CountStreamsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof countStreams>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof countStreams>>,
          TError,
          Awaited<ReturnType<typeof countStreams>>
        > , 'initialData'
      >, request?: SecondParameter<typeof lp5AxiosClient>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useCountStreams<TData = Awaited<ReturnType<typeof countStreams>>, TError = Error | ForbiddenErrorResponse | RequestTimeoutResponse | InternalServerErrorResponse | ResponseTimeoutResponse | ServerTimeoutErrorResponse>(
 params?: CountStreamsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof countStreams>>, TError, TData>>, request?: SecondParameter<typeof lp5AxiosClient>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary count streams
 */

export function useCountStreams<TData = Awaited<ReturnType<typeof countStreams>>, TError = Error | ForbiddenErrorResponse | RequestTimeoutResponse | InternalServerErrorResponse | ResponseTimeoutResponse | ServerTimeoutErrorResponse>(
 params?: CountStreamsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof countStreams>>, TError, TData>>, request?: SecondParameter<typeof lp5AxiosClient>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getCountStreamsQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}







/**
 * Get options for the resource.
 * @summary streams count options
 */
export const getStreamsCountOptions = (

 options?: SecondParameter<typeof lp5AxiosClient>,signal?: AbortSignal
) => {


      return lp5AxiosClient<void>(
      {url: `/6/streams/count`, method: 'OPTIONS', signal
    },
      options);
    }




export const getGetStreamsCountOptionsMutationOptions = <TError = RequestTimeoutResponse | InternalServerErrorResponse | ResponseTimeoutResponse | ServerTimeoutErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof getStreamsCountOptions>>, TError,void, TContext>, request?: SecondParameter<typeof lp5AxiosClient>}
): UseMutationOptions<Awaited<ReturnType<typeof getStreamsCountOptions>>, TError,void, TContext> => {

const mutationKey = ['getStreamsCountOptions'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof getStreamsCountOptions>>, void> = () => {


          return  getStreamsCountOptions(requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type GetStreamsCountOptionsMutationResult = NonNullable<Awaited<ReturnType<typeof getStreamsCountOptions>>>

    export type GetStreamsCountOptionsMutationError = RequestTimeoutResponse | InternalServerErrorResponse | ResponseTimeoutResponse | ServerTimeoutErrorResponse

    /**
 * @summary streams count options
 */
export const useGetStreamsCountOptions = <TError = RequestTimeoutResponse | InternalServerErrorResponse | ResponseTimeoutResponse | ServerTimeoutErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof getStreamsCountOptions>>, TError,void, TContext>, request?: SecondParameter<typeof lp5AxiosClient>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof getStreamsCountOptions>>,
        TError,
        void,
        TContext
      > => {
      return useMutation(getGetStreamsCountOptionsMutationOptions(options), queryClient);
    }

/**
 * Get the stream by ID.
 * @summary get stream
 */
export const getStream = (
    streamId: string,
    params?: GetStreamParams,
 options?: SecondParameter<typeof lp5AxiosClient>,signal?: AbortSignal
) => {


      return lp5AxiosClient<StreamResponse>(
      {url: `/6/streams/${streamId}`, method: 'GET',
        params, signal
    },
      options);
    }




export const getGetStreamQueryKey = (streamId: string,
    params?: GetStreamParams,) => {
    return [
    `/6/streams/${streamId}`, ...(params ? [params] : [])
    ] as const;
    }


export const getGetStreamQueryOptions = <TData = Awaited<ReturnType<typeof getStream>>, TError = StreamInvalidTargetsResponse | ForbiddenErrorResponse | StreamNotFoundResponse | RequestTimeoutResponse | StreamCreationUnprocessableResponse | InternalServerErrorResponse | ResponseTimeoutResponse | ServerTimeoutErrorResponse>(streamId: string,
    params?: GetStreamParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getStream>>, TError, TData>>, request?: SecondParameter<typeof lp5AxiosClient>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetStreamQueryKey(streamId,params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getStream>>> = ({ signal }) => getStream(streamId,params, requestOptions, signal);





   return  { queryKey, queryFn, enabled: streamId !== null && streamId !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getStream>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetStreamQueryResult = NonNullable<Awaited<ReturnType<typeof getStream>>>
export type GetStreamQueryError = StreamInvalidTargetsResponse | ForbiddenErrorResponse | StreamNotFoundResponse | RequestTimeoutResponse | StreamCreationUnprocessableResponse | InternalServerErrorResponse | ResponseTimeoutResponse | ServerTimeoutErrorResponse


export function useGetStream<TData = Awaited<ReturnType<typeof getStream>>, TError = StreamInvalidTargetsResponse | ForbiddenErrorResponse | StreamNotFoundResponse | RequestTimeoutResponse | StreamCreationUnprocessableResponse | InternalServerErrorResponse | ResponseTimeoutResponse | ServerTimeoutErrorResponse>(
 streamId: string,
    params: undefined |  GetStreamParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getStream>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getStream>>,
          TError,
          Awaited<ReturnType<typeof getStream>>
        > , 'initialData'
      >, request?: SecondParameter<typeof lp5AxiosClient>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetStream<TData = Awaited<ReturnType<typeof getStream>>, TError = StreamInvalidTargetsResponse | ForbiddenErrorResponse | StreamNotFoundResponse | RequestTimeoutResponse | StreamCreationUnprocessableResponse | InternalServerErrorResponse | ResponseTimeoutResponse | ServerTimeoutErrorResponse>(
 streamId: string,
    params?: GetStreamParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getStream>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getStream>>,
          TError,
          Awaited<ReturnType<typeof getStream>>
        > , 'initialData'
      >, request?: SecondParameter<typeof lp5AxiosClient>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetStream<TData = Awaited<ReturnType<typeof getStream>>, TError = StreamInvalidTargetsResponse | ForbiddenErrorResponse | StreamNotFoundResponse | RequestTimeoutResponse | StreamCreationUnprocessableResponse | InternalServerErrorResponse | ResponseTimeoutResponse | ServerTimeoutErrorResponse>(
 streamId: string,
    params?: GetStreamParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getStream>>, TError, TData>>, request?: SecondParameter<typeof lp5AxiosClient>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary get stream
 */

export function useGetStream<TData = Awaited<ReturnType<typeof getStream>>, TError = StreamInvalidTargetsResponse | ForbiddenErrorResponse | StreamNotFoundResponse | RequestTimeoutResponse | StreamCreationUnprocessableResponse | InternalServerErrorResponse | ResponseTimeoutResponse | ServerTimeoutErrorResponse>(
 streamId: string,
    params?: GetStreamParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getStream>>, TError, TData>>, request?: SecondParameter<typeof lp5AxiosClient>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetStreamQueryOptions(streamId,params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}







/**
 * Check if stream exists.
 * @summary head stream
 */
export const checkStream = (
    streamId: string,
    params?: CheckStreamParams,
 options?: SecondParameter<typeof lp5AxiosClient>,signal?: AbortSignal
) => {


      return lp5AxiosClient<void>(
      {url: `/6/streams/${streamId}`, method: 'HEAD',
        params, signal
    },
      options);
    }




export const getCheckStreamMutationOptions = <TError = ForbiddenErrorResponse | void | RequestTimeoutResponse | InternalServerErrorResponse | ResponseTimeoutResponse | ServerTimeoutErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof checkStream>>, TError,{streamId: string;params?: CheckStreamParams}, TContext>, request?: SecondParameter<typeof lp5AxiosClient>}
): UseMutationOptions<Awaited<ReturnType<typeof checkStream>>, TError,{streamId: string;params?: CheckStreamParams}, TContext> => {

const mutationKey = ['checkStream'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof checkStream>>, {streamId: string;params?: CheckStreamParams}> = (props) => {
          const {streamId,params} = props ?? {};

          return  checkStream(streamId,params,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type CheckStreamMutationResult = NonNullable<Awaited<ReturnType<typeof checkStream>>>

    export type CheckStreamMutationError = ForbiddenErrorResponse | void | RequestTimeoutResponse | InternalServerErrorResponse | ResponseTimeoutResponse | ServerTimeoutErrorResponse

    /**
 * @summary head stream
 */
export const useCheckStream = <TError = ForbiddenErrorResponse | void | RequestTimeoutResponse | InternalServerErrorResponse | ResponseTimeoutResponse | ServerTimeoutErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof checkStream>>, TError,{streamId: string;params?: CheckStreamParams}, TContext>, request?: SecondParameter<typeof lp5AxiosClient>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof checkStream>>,
        TError,
        {streamId: string;params?: CheckStreamParams},
        TContext
      > => {
      return useMutation(getCheckStreamMutationOptions(options), queryClient);
    }

/**
 * Update existing stream. You should specify all the fields required for the stream in the request.
 *
 * See `Group settings` chapter in *Luna-Video-Manager* developers documentation for stream and groups settings and analytics
 * sharing features.
 * @summary put stream
 */
export const putStream = (
    streamId: string,
    streamToBeCreated: StreamToBeCreated,
    params?: PutStreamParams,
 options?: SecondParameter<typeof lp5AxiosClient>,signal?: AbortSignal
) => {


      return lp5AxiosClient<PutStream200>(
      {url: `/6/streams/${streamId}`, method: 'PUT',
      headers: {'Content-Type': 'application/json', },
      data: streamToBeCreated,
        params, signal
    },
      options);
    }




export const getPutStreamMutationOptions = <TError = Error | ForbiddenErrorResponse | RequestTimeoutResponse | PayloadToLargeResponse | InternalServerErrorResponse | ResponseTimeoutResponse | ServerTimeoutErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof putStream>>, TError,{streamId: string;data: StreamToBeCreated;params?: PutStreamParams}, TContext>, request?: SecondParameter<typeof lp5AxiosClient>}
): UseMutationOptions<Awaited<ReturnType<typeof putStream>>, TError,{streamId: string;data: StreamToBeCreated;params?: PutStreamParams}, TContext> => {

const mutationKey = ['putStream'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof putStream>>, {streamId: string;data: StreamToBeCreated;params?: PutStreamParams}> = (props) => {
          const {streamId,data,params} = props ?? {};

          return  putStream(streamId,data,params,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type PutStreamMutationResult = NonNullable<Awaited<ReturnType<typeof putStream>>>
    export type PutStreamMutationBody = StreamToBeCreated
    export type PutStreamMutationError = Error | ForbiddenErrorResponse | RequestTimeoutResponse | PayloadToLargeResponse | InternalServerErrorResponse | ResponseTimeoutResponse | ServerTimeoutErrorResponse

    /**
 * @summary put stream
 */
export const usePutStream = <TError = Error | ForbiddenErrorResponse | RequestTimeoutResponse | PayloadToLargeResponse | InternalServerErrorResponse | ResponseTimeoutResponse | ServerTimeoutErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof putStream>>, TError,{streamId: string;data: StreamToBeCreated;params?: PutStreamParams}, TContext>, request?: SecondParameter<typeof lp5AxiosClient>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof putStream>>,
        TError,
        {streamId: string;data: StreamToBeCreated;params?: PutStreamParams},
        TContext
      > => {
      return useMutation(getPutStreamMutationOptions(options), queryClient);
    }

/**
 * Pause/unpause stream.
 *
 * Due to peculiarities of patching implementation it is possible that stream patching can not be performed immediately and 0 patched count will be returned. In this case, repeat the request after a short time.
 * @summary patch stream
 */
export const patchStream = (
    streamId: string,
    params: PatchStreamParams,
 options?: SecondParameter<typeof lp5AxiosClient>,signal?: AbortSignal
) => {


      return lp5AxiosClient<PatchStream200>(
      {url: `/6/streams/${streamId}`, method: 'PATCH',
        params, signal
    },
      options);
    }




export const getPatchStreamMutationOptions = <TError = Error | ForbiddenErrorResponse | RequestTimeoutResponse | InternalServerErrorResponse | ResponseTimeoutResponse | ServerTimeoutErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof patchStream>>, TError,{streamId: string;params: PatchStreamParams}, TContext>, request?: SecondParameter<typeof lp5AxiosClient>}
): UseMutationOptions<Awaited<ReturnType<typeof patchStream>>, TError,{streamId: string;params: PatchStreamParams}, TContext> => {

const mutationKey = ['patchStream'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof patchStream>>, {streamId: string;params: PatchStreamParams}> = (props) => {
          const {streamId,params} = props ?? {};

          return  patchStream(streamId,params,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type PatchStreamMutationResult = NonNullable<Awaited<ReturnType<typeof patchStream>>>

    export type PatchStreamMutationError = Error | ForbiddenErrorResponse | RequestTimeoutResponse | InternalServerErrorResponse | ResponseTimeoutResponse | ServerTimeoutErrorResponse

    /**
 * @summary patch stream
 */
export const usePatchStream = <TError = Error | ForbiddenErrorResponse | RequestTimeoutResponse | InternalServerErrorResponse | ResponseTimeoutResponse | ServerTimeoutErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof patchStream>>, TError,{streamId: string;params: PatchStreamParams}, TContext>, request?: SecondParameter<typeof lp5AxiosClient>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof patchStream>>,
        TError,
        {streamId: string;params: PatchStreamParams},
        TContext
      > => {
      return useMutation(getPatchStreamMutationOptions(options), queryClient);
    }

/**
 * Remove the stream by ID.
 * @summary remove stream
 */
export const removeStream = (
    streamId: string,
 options?: SecondParameter<typeof lp5AxiosClient>,signal?: AbortSignal
) => {


      return lp5AxiosClient<void>(
      {url: `/6/streams/${streamId}`, method: 'DELETE', signal
    },
      options);
    }




export const getRemoveStreamMutationOptions = <TError = ForbiddenErrorResponse | Error | RequestTimeoutResponse | InternalServerErrorResponse | ResponseTimeoutResponse | ServerTimeoutErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof removeStream>>, TError,{streamId: string}, TContext>, request?: SecondParameter<typeof lp5AxiosClient>}
): UseMutationOptions<Awaited<ReturnType<typeof removeStream>>, TError,{streamId: string}, TContext> => {

const mutationKey = ['removeStream'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof removeStream>>, {streamId: string}> = (props) => {
          const {streamId} = props ?? {};

          return  removeStream(streamId,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type RemoveStreamMutationResult = NonNullable<Awaited<ReturnType<typeof removeStream>>>

    export type RemoveStreamMutationError = ForbiddenErrorResponse | Error | RequestTimeoutResponse | InternalServerErrorResponse | ResponseTimeoutResponse | ServerTimeoutErrorResponse

    /**
 * @summary remove stream
 */
export const useRemoveStream = <TError = ForbiddenErrorResponse | Error | RequestTimeoutResponse | InternalServerErrorResponse | ResponseTimeoutResponse | ServerTimeoutErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof removeStream>>, TError,{streamId: string}, TContext>, request?: SecondParameter<typeof lp5AxiosClient>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof removeStream>>,
        TError,
        {streamId: string},
        TContext
      > => {
      return useMutation(getRemoveStreamMutationOptions(options), queryClient);
    }

/**
 * Get options for the resource.
 * @summary stream options
 */
export const getStreamOptions = (
    streamId: string,
 options?: SecondParameter<typeof lp5AxiosClient>,signal?: AbortSignal
) => {


      return lp5AxiosClient<void>(
      {url: `/6/streams/${streamId}`, method: 'OPTIONS', signal
    },
      options);
    }




export const getGetStreamOptionsMutationOptions = <TError = RequestTimeoutResponse | InternalServerErrorResponse | ResponseTimeoutResponse | ServerTimeoutErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof getStreamOptions>>, TError,{streamId: string}, TContext>, request?: SecondParameter<typeof lp5AxiosClient>}
): UseMutationOptions<Awaited<ReturnType<typeof getStreamOptions>>, TError,{streamId: string}, TContext> => {

const mutationKey = ['getStreamOptions'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof getStreamOptions>>, {streamId: string}> = (props) => {
          const {streamId} = props ?? {};

          return  getStreamOptions(streamId,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type GetStreamOptionsMutationResult = NonNullable<Awaited<ReturnType<typeof getStreamOptions>>>

    export type GetStreamOptionsMutationError = RequestTimeoutResponse | InternalServerErrorResponse | ResponseTimeoutResponse | ServerTimeoutErrorResponse

    /**
 * @summary stream options
 */
export const useGetStreamOptions = <TError = RequestTimeoutResponse | InternalServerErrorResponse | ResponseTimeoutResponse | ServerTimeoutErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof getStreamOptions>>, TError,{streamId: string}, TContext>, request?: SecondParameter<typeof lp5AxiosClient>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof getStreamOptions>>,
        TError,
        {streamId: string},
        TContext
      > => {
      return useMutation(getGetStreamOptionsMutationOptions(options), queryClient);
    }

/**
 * Get stream retransmission (HLS).
 *
 * It is intended for display stream in GUI. To get access to HLS stream it is required to use JWT token from response of this request.
 *
 * It is required bearer authorization what does mean that headers must be presented in the next way:
 *
 * ```Authorization: 'Bearer <token>'```
 * @summary get stream retransmission
 */
export const retransmission = (
    streamId: string,
    params?: RetransmissionParams,
 options?: SecondParameter<typeof lp5AxiosClient>,signal?: AbortSignal
) => {


      return lp5AxiosClient<StreamInfoRequired>(
      {url: `/6/streams/${streamId}/restream`, method: 'GET',
        params, signal
    },
      options);
    }




export const getRetransmissionQueryKey = (streamId: string,
    params?: RetransmissionParams,) => {
    return [
    `/6/streams/${streamId}/restream`, ...(params ? [params] : [])
    ] as const;
    }


export const getRetransmissionQueryOptions = <TData = Awaited<ReturnType<typeof retransmission>>, TError = Error | RequestTimeoutResponse | InternalServerErrorResponse | ResponseTimeoutResponse | ServerTimeoutErrorResponse>(streamId: string,
    params?: RetransmissionParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof retransmission>>, TError, TData>>, request?: SecondParameter<typeof lp5AxiosClient>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getRetransmissionQueryKey(streamId,params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof retransmission>>> = ({ signal }) => retransmission(streamId,params, requestOptions, signal);





   return  { queryKey, queryFn, enabled: streamId !== null && streamId !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof retransmission>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type RetransmissionQueryResult = NonNullable<Awaited<ReturnType<typeof retransmission>>>
export type RetransmissionQueryError = Error | RequestTimeoutResponse | InternalServerErrorResponse | ResponseTimeoutResponse | ServerTimeoutErrorResponse


export function useRetransmission<TData = Awaited<ReturnType<typeof retransmission>>, TError = Error | RequestTimeoutResponse | InternalServerErrorResponse | ResponseTimeoutResponse | ServerTimeoutErrorResponse>(
 streamId: string,
    params: undefined |  RetransmissionParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof retransmission>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof retransmission>>,
          TError,
          Awaited<ReturnType<typeof retransmission>>
        > , 'initialData'
      >, request?: SecondParameter<typeof lp5AxiosClient>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useRetransmission<TData = Awaited<ReturnType<typeof retransmission>>, TError = Error | RequestTimeoutResponse | InternalServerErrorResponse | ResponseTimeoutResponse | ServerTimeoutErrorResponse>(
 streamId: string,
    params?: RetransmissionParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof retransmission>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof retransmission>>,
          TError,
          Awaited<ReturnType<typeof retransmission>>
        > , 'initialData'
      >, request?: SecondParameter<typeof lp5AxiosClient>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useRetransmission<TData = Awaited<ReturnType<typeof retransmission>>, TError = Error | RequestTimeoutResponse | InternalServerErrorResponse | ResponseTimeoutResponse | ServerTimeoutErrorResponse>(
 streamId: string,
    params?: RetransmissionParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof retransmission>>, TError, TData>>, request?: SecondParameter<typeof lp5AxiosClient>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary get stream retransmission
 */

export function useRetransmission<TData = Awaited<ReturnType<typeof retransmission>>, TError = Error | RequestTimeoutResponse | InternalServerErrorResponse | ResponseTimeoutResponse | ServerTimeoutErrorResponse>(
 streamId: string,
    params?: RetransmissionParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof retransmission>>, TError, TData>>, request?: SecondParameter<typeof lp5AxiosClient>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getRetransmissionQueryOptions(streamId,params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}







/**
 * Get options for the resource.
 * @summary stream retransmission options
 */
export const getStreamRetransmissionOptions = (
    streamId: string,
 options?: SecondParameter<typeof lp5AxiosClient>,signal?: AbortSignal
) => {


      return lp5AxiosClient<void>(
      {url: `/6/streams/${streamId}/restream`, method: 'OPTIONS', signal
    },
      options);
    }




export const getGetStreamRetransmissionOptionsMutationOptions = <TError = RequestTimeoutResponse | InternalServerErrorResponse | ResponseTimeoutResponse | ServerTimeoutErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof getStreamRetransmissionOptions>>, TError,{streamId: string}, TContext>, request?: SecondParameter<typeof lp5AxiosClient>}
): UseMutationOptions<Awaited<ReturnType<typeof getStreamRetransmissionOptions>>, TError,{streamId: string}, TContext> => {

const mutationKey = ['getStreamRetransmissionOptions'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof getStreamRetransmissionOptions>>, {streamId: string}> = (props) => {
          const {streamId} = props ?? {};

          return  getStreamRetransmissionOptions(streamId,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type GetStreamRetransmissionOptionsMutationResult = NonNullable<Awaited<ReturnType<typeof getStreamRetransmissionOptions>>>

    export type GetStreamRetransmissionOptionsMutationError = RequestTimeoutResponse | InternalServerErrorResponse | ResponseTimeoutResponse | ServerTimeoutErrorResponse

    /**
 * @summary stream retransmission options
 */
export const useGetStreamRetransmissionOptions = <TError = RequestTimeoutResponse | InternalServerErrorResponse | ResponseTimeoutResponse | ServerTimeoutErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof getStreamRetransmissionOptions>>, TError,{streamId: string}, TContext>, request?: SecondParameter<typeof lp5AxiosClient>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof getStreamRetransmissionOptions>>,
        TError,
        {streamId: string},
        TContext
      > => {
      return useMutation(getGetStreamRetransmissionOptionsMutationOptions(options), queryClient);
    }

/**
 * Stream ws events handshake. The resource is designed to receive realtime events from one analytics.
 * > ### Attention!
 * > **Subscription to events occurs via [WebSocket](https://en.wikipedia.org/wiki/WebSocket).**
 * > Messages sent by ws you can view in callback section.
 * > Connection supports [autoping](https://tools.ietf.org/html/rfc6455#section-5.5.2).
 * @summary stream events ws handshake
 */
export const wsHandshakeForStreams = (
    streamId: string,
    params?: WsHandshakeForStreamsParams,
 options?: SecondParameter<typeof lp5AxiosClient>,signal?: AbortSignal
) => {


      return lp5AxiosClient<unknown>(
      {url: `/6/streams/${streamId}/ws`, method: 'GET',
        params, signal
    },
      options);
    }




export const getWsHandshakeForStreamsQueryKey = (streamId: string,
    params?: WsHandshakeForStreamsParams,) => {
    return [
    `/6/streams/${streamId}/ws`, ...(params ? [params] : [])
    ] as const;
    }


export const getWsHandshakeForStreamsQueryOptions = <TData = Awaited<ReturnType<typeof wsHandshakeForStreams>>, TError = StreamMessageFromWs | Error | AuthorizationErrorResponse | ForbiddenErrorResponse | StreamNotFoundResponse | RequestTimeoutResponse | InternalServerErrorResponse | ResponseTimeoutResponse | ServerTimeoutErrorResponse>(streamId: string,
    params?: WsHandshakeForStreamsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof wsHandshakeForStreams>>, TError, TData>>, request?: SecondParameter<typeof lp5AxiosClient>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getWsHandshakeForStreamsQueryKey(streamId,params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof wsHandshakeForStreams>>> = ({ signal }) => wsHandshakeForStreams(streamId,params, requestOptions, signal);





   return  { queryKey, queryFn, enabled: streamId !== null && streamId !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof wsHandshakeForStreams>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type WsHandshakeForStreamsQueryResult = NonNullable<Awaited<ReturnType<typeof wsHandshakeForStreams>>>
export type WsHandshakeForStreamsQueryError = StreamMessageFromWs | Error | AuthorizationErrorResponse | ForbiddenErrorResponse | StreamNotFoundResponse | RequestTimeoutResponse | InternalServerErrorResponse | ResponseTimeoutResponse | ServerTimeoutErrorResponse


export function useWsHandshakeForStreams<TData = Awaited<ReturnType<typeof wsHandshakeForStreams>>, TError = StreamMessageFromWs | Error | AuthorizationErrorResponse | ForbiddenErrorResponse | StreamNotFoundResponse | RequestTimeoutResponse | InternalServerErrorResponse | ResponseTimeoutResponse | ServerTimeoutErrorResponse>(
 streamId: string,
    params: undefined |  WsHandshakeForStreamsParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof wsHandshakeForStreams>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof wsHandshakeForStreams>>,
          TError,
          Awaited<ReturnType<typeof wsHandshakeForStreams>>
        > , 'initialData'
      >, request?: SecondParameter<typeof lp5AxiosClient>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useWsHandshakeForStreams<TData = Awaited<ReturnType<typeof wsHandshakeForStreams>>, TError = StreamMessageFromWs | Error | AuthorizationErrorResponse | ForbiddenErrorResponse | StreamNotFoundResponse | RequestTimeoutResponse | InternalServerErrorResponse | ResponseTimeoutResponse | ServerTimeoutErrorResponse>(
 streamId: string,
    params?: WsHandshakeForStreamsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof wsHandshakeForStreams>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof wsHandshakeForStreams>>,
          TError,
          Awaited<ReturnType<typeof wsHandshakeForStreams>>
        > , 'initialData'
      >, request?: SecondParameter<typeof lp5AxiosClient>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useWsHandshakeForStreams<TData = Awaited<ReturnType<typeof wsHandshakeForStreams>>, TError = StreamMessageFromWs | Error | AuthorizationErrorResponse | ForbiddenErrorResponse | StreamNotFoundResponse | RequestTimeoutResponse | InternalServerErrorResponse | ResponseTimeoutResponse | ServerTimeoutErrorResponse>(
 streamId: string,
    params?: WsHandshakeForStreamsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof wsHandshakeForStreams>>, TError, TData>>, request?: SecondParameter<typeof lp5AxiosClient>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary stream events ws handshake
 */

export function useWsHandshakeForStreams<TData = Awaited<ReturnType<typeof wsHandshakeForStreams>>, TError = StreamMessageFromWs | Error | AuthorizationErrorResponse | ForbiddenErrorResponse | StreamNotFoundResponse | RequestTimeoutResponse | InternalServerErrorResponse | ResponseTimeoutResponse | ServerTimeoutErrorResponse>(
 streamId: string,
    params?: WsHandshakeForStreamsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof wsHandshakeForStreams>>, TError, TData>>, request?: SecondParameter<typeof lp5AxiosClient>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getWsHandshakeForStreamsQueryOptions(streamId,params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}







/**
 * **Warning: only for service use**
 *
 * Get agents streams by agent ID and send information about streams processing.
 * @summary get streams which processing must be started.
 */
export const postAgentStreams = (
    agentId: Uuid,
    params?: PostAgentStreamsParams,
 options?: SecondParameter<typeof lp5AxiosClient>,signal?: AbortSignal
) => {


      return lp5AxiosClient<AgentsStreamsResponse>(
      {url: `/6/agents/${agentId}/streams`, method: 'POST',
        params, signal
    },
      options);
    }




export const getPostAgentStreamsMutationOptions = <TError = Error | AuthorizationErrorResponse | ForbiddenErrorResponse | AgentNotFoundResponse | RequestTimeoutResponse | InternalServerErrorResponse | ResponseTimeoutResponse | ServerTimeoutErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postAgentStreams>>, TError,{agentId: Uuid;params?: PostAgentStreamsParams}, TContext>, request?: SecondParameter<typeof lp5AxiosClient>}
): UseMutationOptions<Awaited<ReturnType<typeof postAgentStreams>>, TError,{agentId: Uuid;params?: PostAgentStreamsParams}, TContext> => {

const mutationKey = ['postAgentStreams'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postAgentStreams>>, {agentId: Uuid;params?: PostAgentStreamsParams}> = (props) => {
          const {agentId,params} = props ?? {};

          return  postAgentStreams(agentId,params,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type PostAgentStreamsMutationResult = NonNullable<Awaited<ReturnType<typeof postAgentStreams>>>

    export type PostAgentStreamsMutationError = Error | AuthorizationErrorResponse | ForbiddenErrorResponse | AgentNotFoundResponse | RequestTimeoutResponse | InternalServerErrorResponse | ResponseTimeoutResponse | ServerTimeoutErrorResponse

    /**
 * @summary get streams which processing must be started.
 */
export const usePostAgentStreams = <TError = Error | AuthorizationErrorResponse | ForbiddenErrorResponse | AgentNotFoundResponse | RequestTimeoutResponse | InternalServerErrorResponse | ResponseTimeoutResponse | ServerTimeoutErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postAgentStreams>>, TError,{agentId: Uuid;params?: PostAgentStreamsParams}, TContext>, request?: SecondParameter<typeof lp5AxiosClient>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof postAgentStreams>>,
        TError,
        {agentId: Uuid;params?: PostAgentStreamsParams},
        TContext
      > => {
      return useMutation(getPostAgentStreamsMutationOptions(options), queryClient);
    }

/**
 * Get options for the resource.
 * @summary agent streams options.
 */
export const getAgentStreamsOptions = (
    agentId: Uuid,
 options?: SecondParameter<typeof lp5AxiosClient>,signal?: AbortSignal
) => {


      return lp5AxiosClient<void>(
      {url: `/6/agents/${agentId}/streams`, method: 'OPTIONS', signal
    },
      options);
    }




export const getGetAgentStreamsOptionsMutationOptions = <TError = RequestTimeoutResponse | InternalServerErrorResponse | ResponseTimeoutResponse | ServerTimeoutErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof getAgentStreamsOptions>>, TError,{agentId: Uuid}, TContext>, request?: SecondParameter<typeof lp5AxiosClient>}
): UseMutationOptions<Awaited<ReturnType<typeof getAgentStreamsOptions>>, TError,{agentId: Uuid}, TContext> => {

const mutationKey = ['getAgentStreamsOptions'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof getAgentStreamsOptions>>, {agentId: Uuid}> = (props) => {
          const {agentId} = props ?? {};

          return  getAgentStreamsOptions(agentId,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type GetAgentStreamsOptionsMutationResult = NonNullable<Awaited<ReturnType<typeof getAgentStreamsOptions>>>

    export type GetAgentStreamsOptionsMutationError = RequestTimeoutResponse | InternalServerErrorResponse | ResponseTimeoutResponse | ServerTimeoutErrorResponse

    /**
 * @summary agent streams options.
 */
export const useGetAgentStreamsOptions = <TError = RequestTimeoutResponse | InternalServerErrorResponse | ResponseTimeoutResponse | ServerTimeoutErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof getAgentStreamsOptions>>, TError,{agentId: Uuid}, TContext>, request?: SecondParameter<typeof lp5AxiosClient>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof getAgentStreamsOptions>>,
        TError,
        {agentId: Uuid},
        TContext
      > => {
      return useMutation(getGetAgentStreamsOptionsMutationOptions(options), queryClient);
    }

/**
 * **Warning: only for service use**
 *
 * Post information about streams processing.
 * @summary post feedback on streams
 */
export const postStreamsFeedBack = (
    agentId: string,
    postStreamsProcessingFeedbackRequest?: PostStreamsProcessingFeedbackRequest,
 options?: SecondParameter<typeof lp5AxiosClient>,signal?: AbortSignal
) => {


      return lp5AxiosClient<StreamsFeedbackResponse>(
      {url: `/6/agents/${agentId}/streams/feedback`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: postStreamsProcessingFeedbackRequest, signal
    },
      options);
    }




export const getPostStreamsFeedBackMutationOptions = <TError = Error | AuthorizationErrorResponse | ForbiddenErrorResponse | AgentNotFoundResponse | RequestTimeoutResponse | PayloadToLargeResponse | InternalServerErrorResponse | ResponseTimeoutResponse | ServerTimeoutErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postStreamsFeedBack>>, TError,{agentId: string;data?: PostStreamsProcessingFeedbackRequest}, TContext>, request?: SecondParameter<typeof lp5AxiosClient>}
): UseMutationOptions<Awaited<ReturnType<typeof postStreamsFeedBack>>, TError,{agentId: string;data?: PostStreamsProcessingFeedbackRequest}, TContext> => {

const mutationKey = ['postStreamsFeedBack'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postStreamsFeedBack>>, {agentId: string;data?: PostStreamsProcessingFeedbackRequest}> = (props) => {
          const {agentId,data} = props ?? {};

          return  postStreamsFeedBack(agentId,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type PostStreamsFeedBackMutationResult = NonNullable<Awaited<ReturnType<typeof postStreamsFeedBack>>>
    export type PostStreamsFeedBackMutationBody = PostStreamsProcessingFeedbackRequest | undefined
    export type PostStreamsFeedBackMutationError = Error | AuthorizationErrorResponse | ForbiddenErrorResponse | AgentNotFoundResponse | RequestTimeoutResponse | PayloadToLargeResponse | InternalServerErrorResponse | ResponseTimeoutResponse | ServerTimeoutErrorResponse

    /**
 * @summary post feedback on streams
 */
export const usePostStreamsFeedBack = <TError = Error | AuthorizationErrorResponse | ForbiddenErrorResponse | AgentNotFoundResponse | RequestTimeoutResponse | PayloadToLargeResponse | InternalServerErrorResponse | ResponseTimeoutResponse | ServerTimeoutErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postStreamsFeedBack>>, TError,{agentId: string;data?: PostStreamsProcessingFeedbackRequest}, TContext>, request?: SecondParameter<typeof lp5AxiosClient>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof postStreamsFeedBack>>,
        TError,
        {agentId: string;data?: PostStreamsProcessingFeedbackRequest},
        TContext
      > => {
      return useMutation(getPostStreamsFeedBackMutationOptions(options), queryClient);
    }

/**
 * Get options for the resource.
 * @summary post streams feedback options.
 */
export const getStreamsFeedbackOptions = (
    agentId: string,
 options?: SecondParameter<typeof lp5AxiosClient>,signal?: AbortSignal
) => {


      return lp5AxiosClient<void>(
      {url: `/6/agents/${agentId}/streams/feedback`, method: 'OPTIONS', signal
    },
      options);
    }




export const getGetStreamsFeedbackOptionsMutationOptions = <TError = RequestTimeoutResponse | InternalServerErrorResponse | ResponseTimeoutResponse | ServerTimeoutErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof getStreamsFeedbackOptions>>, TError,{agentId: string}, TContext>, request?: SecondParameter<typeof lp5AxiosClient>}
): UseMutationOptions<Awaited<ReturnType<typeof getStreamsFeedbackOptions>>, TError,{agentId: string}, TContext> => {

const mutationKey = ['getStreamsFeedbackOptions'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof getStreamsFeedbackOptions>>, {agentId: string}> = (props) => {
          const {agentId} = props ?? {};

          return  getStreamsFeedbackOptions(agentId,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type GetStreamsFeedbackOptionsMutationResult = NonNullable<Awaited<ReturnType<typeof getStreamsFeedbackOptions>>>

    export type GetStreamsFeedbackOptionsMutationError = RequestTimeoutResponse | InternalServerErrorResponse | ResponseTimeoutResponse | ServerTimeoutErrorResponse

    /**
 * @summary post streams feedback options.
 */
export const useGetStreamsFeedbackOptions = <TError = RequestTimeoutResponse | InternalServerErrorResponse | ResponseTimeoutResponse | ServerTimeoutErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof getStreamsFeedbackOptions>>, TError,{agentId: string}, TContext>, request?: SecondParameter<typeof lp5AxiosClient>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof getStreamsFeedbackOptions>>,
        TError,
        {agentId: string},
        TContext
      > => {
      return useMutation(getGetStreamsFeedbackOptionsMutationOptions(options), queryClient);
    }

/**
 * Get stream working intervals by stream ID and analytics index.
 * @summary get all stream analytics working intervals
 */
export const getAnalyticsIntervals = (
    streamId: string,
    analyticIdx: number,
    params?: GetAnalyticsIntervalsParams,
 options?: SecondParameter<typeof lp5AxiosClient>,signal?: AbortSignal
) => {


      return lp5AxiosClient<IntervalsNestedResponse>(
      {url: `/6/streams/${streamId}/${analyticIdx}/intervals`, method: 'GET',
        params, signal
    },
      options);
    }




export const getGetAnalyticsIntervalsQueryKey = (streamId: string,
    analyticIdx: number,
    params?: GetAnalyticsIntervalsParams,) => {
    return [
    `/6/streams/${streamId}/${analyticIdx}/intervals`, ...(params ? [params] : [])
    ] as const;
    }


export const getGetAnalyticsIntervalsQueryOptions = <TData = Awaited<ReturnType<typeof getAnalyticsIntervals>>, TError = Error | AuthorizationErrorResponse | ForbiddenErrorWithServicesResponse | RequestTimeoutResponse | StreamNoSuitableAgentResponse | InternalServerErrorResponse | ResponseTimeoutResponse | ServerTimeoutErrorResponse>(streamId: string,
    analyticIdx: number,
    params?: GetAnalyticsIntervalsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAnalyticsIntervals>>, TError, TData>>, request?: SecondParameter<typeof lp5AxiosClient>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetAnalyticsIntervalsQueryKey(streamId,analyticIdx,params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getAnalyticsIntervals>>> = ({ signal }) => getAnalyticsIntervals(streamId,analyticIdx,params, requestOptions, signal);





   return  { queryKey, queryFn, enabled: streamId !== null && streamId !== undefined && analyticIdx !== null && analyticIdx !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getAnalyticsIntervals>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetAnalyticsIntervalsQueryResult = NonNullable<Awaited<ReturnType<typeof getAnalyticsIntervals>>>
export type GetAnalyticsIntervalsQueryError = Error | AuthorizationErrorResponse | ForbiddenErrorWithServicesResponse | RequestTimeoutResponse | StreamNoSuitableAgentResponse | InternalServerErrorResponse | ResponseTimeoutResponse | ServerTimeoutErrorResponse


export function useGetAnalyticsIntervals<TData = Awaited<ReturnType<typeof getAnalyticsIntervals>>, TError = Error | AuthorizationErrorResponse | ForbiddenErrorWithServicesResponse | RequestTimeoutResponse | StreamNoSuitableAgentResponse | InternalServerErrorResponse | ResponseTimeoutResponse | ServerTimeoutErrorResponse>(
 streamId: string,
    analyticIdx: number,
    params: undefined |  GetAnalyticsIntervalsParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAnalyticsIntervals>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getAnalyticsIntervals>>,
          TError,
          Awaited<ReturnType<typeof getAnalyticsIntervals>>
        > , 'initialData'
      >, request?: SecondParameter<typeof lp5AxiosClient>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetAnalyticsIntervals<TData = Awaited<ReturnType<typeof getAnalyticsIntervals>>, TError = Error | AuthorizationErrorResponse | ForbiddenErrorWithServicesResponse | RequestTimeoutResponse | StreamNoSuitableAgentResponse | InternalServerErrorResponse | ResponseTimeoutResponse | ServerTimeoutErrorResponse>(
 streamId: string,
    analyticIdx: number,
    params?: GetAnalyticsIntervalsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAnalyticsIntervals>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getAnalyticsIntervals>>,
          TError,
          Awaited<ReturnType<typeof getAnalyticsIntervals>>
        > , 'initialData'
      >, request?: SecondParameter<typeof lp5AxiosClient>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetAnalyticsIntervals<TData = Awaited<ReturnType<typeof getAnalyticsIntervals>>, TError = Error | AuthorizationErrorResponse | ForbiddenErrorWithServicesResponse | RequestTimeoutResponse | StreamNoSuitableAgentResponse | InternalServerErrorResponse | ResponseTimeoutResponse | ServerTimeoutErrorResponse>(
 streamId: string,
    analyticIdx: number,
    params?: GetAnalyticsIntervalsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAnalyticsIntervals>>, TError, TData>>, request?: SecondParameter<typeof lp5AxiosClient>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary get all stream analytics working intervals
 */

export function useGetAnalyticsIntervals<TData = Awaited<ReturnType<typeof getAnalyticsIntervals>>, TError = Error | AuthorizationErrorResponse | ForbiddenErrorWithServicesResponse | RequestTimeoutResponse | StreamNoSuitableAgentResponse | InternalServerErrorResponse | ResponseTimeoutResponse | ServerTimeoutErrorResponse>(
 streamId: string,
    analyticIdx: number,
    params?: GetAnalyticsIntervalsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAnalyticsIntervals>>, TError, TData>>, request?: SecondParameter<typeof lp5AxiosClient>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetAnalyticsIntervalsQueryOptions(streamId,analyticIdx,params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}







/**
 * Get options for the resource.
 * @summary streams schedules options
 */
export const getStreamsScheduleIntervalsOptions = (
    streamId: string,
    analyticIdx: number,
 options?: SecondParameter<typeof lp5AxiosClient>,signal?: AbortSignal
) => {


      return lp5AxiosClient<void>(
      {url: `/6/streams/${streamId}/${analyticIdx}/intervals`, method: 'OPTIONS', signal
    },
      options);
    }




export const getGetStreamsScheduleIntervalsOptionsMutationOptions = <TError = RequestTimeoutResponse | InternalServerErrorResponse | ResponseTimeoutResponse | ServerTimeoutErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof getStreamsScheduleIntervalsOptions>>, TError,{streamId: string;analyticIdx: number}, TContext>, request?: SecondParameter<typeof lp5AxiosClient>}
): UseMutationOptions<Awaited<ReturnType<typeof getStreamsScheduleIntervalsOptions>>, TError,{streamId: string;analyticIdx: number}, TContext> => {

const mutationKey = ['getStreamsScheduleIntervalsOptions'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof getStreamsScheduleIntervalsOptions>>, {streamId: string;analyticIdx: number}> = (props) => {
          const {streamId,analyticIdx} = props ?? {};

          return  getStreamsScheduleIntervalsOptions(streamId,analyticIdx,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type GetStreamsScheduleIntervalsOptionsMutationResult = NonNullable<Awaited<ReturnType<typeof getStreamsScheduleIntervalsOptions>>>

    export type GetStreamsScheduleIntervalsOptionsMutationError = RequestTimeoutResponse | InternalServerErrorResponse | ResponseTimeoutResponse | ServerTimeoutErrorResponse

    /**
 * @summary streams schedules options
 */
export const useGetStreamsScheduleIntervalsOptions = <TError = RequestTimeoutResponse | InternalServerErrorResponse | ResponseTimeoutResponse | ServerTimeoutErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof getStreamsScheduleIntervalsOptions>>, TError,{streamId: string;analyticIdx: number}, TContext>, request?: SecondParameter<typeof lp5AxiosClient>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof getStreamsScheduleIntervalsOptions>>,
        TError,
        {streamId: string;analyticIdx: number},
        TContext
      > => {
      return useMutation(getGetStreamsScheduleIntervalsOptionsMutationOptions(options), queryClient);
    }

/**
 * Replace or create stream analytics schedule. After this operation, final stream analytics working
 * intervals will be recalculated.
 *
 * Analytics working intervals can be specified in two ways or their combinations:
 *
 * - using [previously created *schedule*](#tag/schedule-template/operation/createScheduleTemplate) by specifying it's id
 * - specifying intervals (can be calculated using [intervals calculation request](#tag/schedule-template/operation/calcIntervals))
 *
 * If more than one working intervals lists specified, it will be merged into one final intervals group, to
 * see non merged and merged final working intervals, us [get stream analytics working intervals request](#tag/streams-schedules/operation/getStreamSchedules)
 * with specifying *merged* query parameter.
 * @summary replace or create stream analytics working intervals
 */
export const putAnalyticsIntervals = (
    streamId: string,
    analyticIdx: number,
    intervalsIdx: number,
    scheduleToReplace: ScheduleToReplace,
 options?: SecondParameter<typeof lp5AxiosClient>,signal?: AbortSignal
) => {


      return lp5AxiosClient<void>(
      {url: `/6/streams/${streamId}/${analyticIdx}/intervals/${intervalsIdx}`, method: 'PUT',
      headers: {'Content-Type': 'application/json', },
      data: scheduleToReplace, signal
    },
      options);
    }




export const getPutAnalyticsIntervalsMutationOptions = <TError = Error | AuthorizationErrorResponse | ForbiddenErrorWithServicesResponse | RequestTimeoutResponse | PayloadToLargeResponse | StreamNoSuitableAgentResponse | InternalServerErrorResponse | ResponseTimeoutResponse | ServerTimeoutErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof putAnalyticsIntervals>>, TError,{streamId: string;analyticIdx: number;intervalsIdx: number;data: ScheduleToReplace}, TContext>, request?: SecondParameter<typeof lp5AxiosClient>}
): UseMutationOptions<Awaited<ReturnType<typeof putAnalyticsIntervals>>, TError,{streamId: string;analyticIdx: number;intervalsIdx: number;data: ScheduleToReplace}, TContext> => {

const mutationKey = ['putAnalyticsIntervals'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof putAnalyticsIntervals>>, {streamId: string;analyticIdx: number;intervalsIdx: number;data: ScheduleToReplace}> = (props) => {
          const {streamId,analyticIdx,intervalsIdx,data} = props ?? {};

          return  putAnalyticsIntervals(streamId,analyticIdx,intervalsIdx,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type PutAnalyticsIntervalsMutationResult = NonNullable<Awaited<ReturnType<typeof putAnalyticsIntervals>>>
    export type PutAnalyticsIntervalsMutationBody = ScheduleToReplace
    export type PutAnalyticsIntervalsMutationError = Error | AuthorizationErrorResponse | ForbiddenErrorWithServicesResponse | RequestTimeoutResponse | PayloadToLargeResponse | StreamNoSuitableAgentResponse | InternalServerErrorResponse | ResponseTimeoutResponse | ServerTimeoutErrorResponse

    /**
 * @summary replace or create stream analytics working intervals
 */
export const usePutAnalyticsIntervals = <TError = Error | AuthorizationErrorResponse | ForbiddenErrorWithServicesResponse | RequestTimeoutResponse | PayloadToLargeResponse | StreamNoSuitableAgentResponse | InternalServerErrorResponse | ResponseTimeoutResponse | ServerTimeoutErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof putAnalyticsIntervals>>, TError,{streamId: string;analyticIdx: number;intervalsIdx: number;data: ScheduleToReplace}, TContext>, request?: SecondParameter<typeof lp5AxiosClient>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof putAnalyticsIntervals>>,
        TError,
        {streamId: string;analyticIdx: number;intervalsIdx: number;data: ScheduleToReplace},
        TContext
      > => {
      return useMutation(getPutAnalyticsIntervalsMutationOptions(options), queryClient);
    }

/**
 * Get stream analytics intervals by stream ID, analytics index and intervals index.
 * @summary get stream analytics working intervals
 */
export const getAnalyticsIntervalsIntervals = (
    streamId: string,
    analyticIdx: number,
    intervalsIdx: number,
    params?: GetAnalyticsIntervalsIntervalsParams,
 options?: SecondParameter<typeof lp5AxiosClient>,signal?: AbortSignal
) => {


      return lp5AxiosClient<IntervalsResponse>(
      {url: `/6/streams/${streamId}/${analyticIdx}/intervals/${intervalsIdx}`, method: 'GET',
        params, signal
    },
      options);
    }




export const getGetAnalyticsIntervalsIntervalsQueryKey = (streamId: string,
    analyticIdx: number,
    intervalsIdx: number,
    params?: GetAnalyticsIntervalsIntervalsParams,) => {
    return [
    `/6/streams/${streamId}/${analyticIdx}/intervals/${intervalsIdx}`, ...(params ? [params] : [])
    ] as const;
    }


export const getGetAnalyticsIntervalsIntervalsQueryOptions = <TData = Awaited<ReturnType<typeof getAnalyticsIntervalsIntervals>>, TError = Error | AuthorizationErrorResponse | ForbiddenErrorWithServicesResponse | RequestTimeoutResponse | StreamNoSuitableAgentResponse | InternalServerErrorResponse | ResponseTimeoutResponse | ServerTimeoutErrorResponse>(streamId: string,
    analyticIdx: number,
    intervalsIdx: number,
    params?: GetAnalyticsIntervalsIntervalsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAnalyticsIntervalsIntervals>>, TError, TData>>, request?: SecondParameter<typeof lp5AxiosClient>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetAnalyticsIntervalsIntervalsQueryKey(streamId,analyticIdx,intervalsIdx,params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getAnalyticsIntervalsIntervals>>> = ({ signal }) => getAnalyticsIntervalsIntervals(streamId,analyticIdx,intervalsIdx,params, requestOptions, signal);





   return  { queryKey, queryFn, enabled: streamId !== null && streamId !== undefined && analyticIdx !== null && analyticIdx !== undefined && intervalsIdx !== null && intervalsIdx !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getAnalyticsIntervalsIntervals>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetAnalyticsIntervalsIntervalsQueryResult = NonNullable<Awaited<ReturnType<typeof getAnalyticsIntervalsIntervals>>>
export type GetAnalyticsIntervalsIntervalsQueryError = Error | AuthorizationErrorResponse | ForbiddenErrorWithServicesResponse | RequestTimeoutResponse | StreamNoSuitableAgentResponse | InternalServerErrorResponse | ResponseTimeoutResponse | ServerTimeoutErrorResponse


export function useGetAnalyticsIntervalsIntervals<TData = Awaited<ReturnType<typeof getAnalyticsIntervalsIntervals>>, TError = Error | AuthorizationErrorResponse | ForbiddenErrorWithServicesResponse | RequestTimeoutResponse | StreamNoSuitableAgentResponse | InternalServerErrorResponse | ResponseTimeoutResponse | ServerTimeoutErrorResponse>(
 streamId: string,
    analyticIdx: number,
    intervalsIdx: number,
    params: undefined |  GetAnalyticsIntervalsIntervalsParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAnalyticsIntervalsIntervals>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getAnalyticsIntervalsIntervals>>,
          TError,
          Awaited<ReturnType<typeof getAnalyticsIntervalsIntervals>>
        > , 'initialData'
      >, request?: SecondParameter<typeof lp5AxiosClient>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetAnalyticsIntervalsIntervals<TData = Awaited<ReturnType<typeof getAnalyticsIntervalsIntervals>>, TError = Error | AuthorizationErrorResponse | ForbiddenErrorWithServicesResponse | RequestTimeoutResponse | StreamNoSuitableAgentResponse | InternalServerErrorResponse | ResponseTimeoutResponse | ServerTimeoutErrorResponse>(
 streamId: string,
    analyticIdx: number,
    intervalsIdx: number,
    params?: GetAnalyticsIntervalsIntervalsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAnalyticsIntervalsIntervals>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getAnalyticsIntervalsIntervals>>,
          TError,
          Awaited<ReturnType<typeof getAnalyticsIntervalsIntervals>>
        > , 'initialData'
      >, request?: SecondParameter<typeof lp5AxiosClient>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetAnalyticsIntervalsIntervals<TData = Awaited<ReturnType<typeof getAnalyticsIntervalsIntervals>>, TError = Error | AuthorizationErrorResponse | ForbiddenErrorWithServicesResponse | RequestTimeoutResponse | StreamNoSuitableAgentResponse | InternalServerErrorResponse | ResponseTimeoutResponse | ServerTimeoutErrorResponse>(
 streamId: string,
    analyticIdx: number,
    intervalsIdx: number,
    params?: GetAnalyticsIntervalsIntervalsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAnalyticsIntervalsIntervals>>, TError, TData>>, request?: SecondParameter<typeof lp5AxiosClient>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary get stream analytics working intervals
 */

export function useGetAnalyticsIntervalsIntervals<TData = Awaited<ReturnType<typeof getAnalyticsIntervalsIntervals>>, TError = Error | AuthorizationErrorResponse | ForbiddenErrorWithServicesResponse | RequestTimeoutResponse | StreamNoSuitableAgentResponse | InternalServerErrorResponse | ResponseTimeoutResponse | ServerTimeoutErrorResponse>(
 streamId: string,
    analyticIdx: number,
    intervalsIdx: number,
    params?: GetAnalyticsIntervalsIntervalsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAnalyticsIntervalsIntervals>>, TError, TData>>, request?: SecondParameter<typeof lp5AxiosClient>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetAnalyticsIntervalsIntervalsQueryOptions(streamId,analyticIdx,intervalsIdx,params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}







/**
 * Delete stream analytics schedule. After this operation, final stream analytics working
 * intervals will be recalculated. If last stream analytics schedule
 * removed, stream analytics processing will become permanent.
 * @summary delete stream analytics working intervals
 */
export const deleteAnalyticsIntervals = (
    streamId: string,
    analyticIdx: number,
    intervalsIdx: number,
 options?: SecondParameter<typeof lp5AxiosClient>,signal?: AbortSignal
) => {


      return lp5AxiosClient<void>(
      {url: `/6/streams/${streamId}/${analyticIdx}/intervals/${intervalsIdx}`, method: 'DELETE', signal
    },
      options);
    }




export const getDeleteAnalyticsIntervalsMutationOptions = <TError = Error | AuthorizationErrorResponse | ForbiddenErrorWithServicesResponse | RequestTimeoutResponse | StreamNoSuitableAgentResponse | InternalServerErrorResponse | ResponseTimeoutResponse | ServerTimeoutErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteAnalyticsIntervals>>, TError,{streamId: string;analyticIdx: number;intervalsIdx: number}, TContext>, request?: SecondParameter<typeof lp5AxiosClient>}
): UseMutationOptions<Awaited<ReturnType<typeof deleteAnalyticsIntervals>>, TError,{streamId: string;analyticIdx: number;intervalsIdx: number}, TContext> => {

const mutationKey = ['deleteAnalyticsIntervals'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof deleteAnalyticsIntervals>>, {streamId: string;analyticIdx: number;intervalsIdx: number}> = (props) => {
          const {streamId,analyticIdx,intervalsIdx} = props ?? {};

          return  deleteAnalyticsIntervals(streamId,analyticIdx,intervalsIdx,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type DeleteAnalyticsIntervalsMutationResult = NonNullable<Awaited<ReturnType<typeof deleteAnalyticsIntervals>>>

    export type DeleteAnalyticsIntervalsMutationError = Error | AuthorizationErrorResponse | ForbiddenErrorWithServicesResponse | RequestTimeoutResponse | StreamNoSuitableAgentResponse | InternalServerErrorResponse | ResponseTimeoutResponse | ServerTimeoutErrorResponse

    /**
 * @summary delete stream analytics working intervals
 */
export const useDeleteAnalyticsIntervals = <TError = Error | AuthorizationErrorResponse | ForbiddenErrorWithServicesResponse | RequestTimeoutResponse | StreamNoSuitableAgentResponse | InternalServerErrorResponse | ResponseTimeoutResponse | ServerTimeoutErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteAnalyticsIntervals>>, TError,{streamId: string;analyticIdx: number;intervalsIdx: number}, TContext>, request?: SecondParameter<typeof lp5AxiosClient>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof deleteAnalyticsIntervals>>,
        TError,
        {streamId: string;analyticIdx: number;intervalsIdx: number},
        TContext
      > => {
      return useMutation(getDeleteAnalyticsIntervalsMutationOptions(options), queryClient);
    }

/**
 * Get options for the resource.
 * @summary streams schedules options
 */
export const getStreamsSchedulesOptions = (
    streamId: string,
    analyticIdx: number,
    intervalsIdx: number,
 options?: SecondParameter<typeof lp5AxiosClient>,signal?: AbortSignal
) => {


      return lp5AxiosClient<void>(
      {url: `/6/streams/${streamId}/${analyticIdx}/intervals/${intervalsIdx}`, method: 'OPTIONS', signal
    },
      options);
    }




export const getGetStreamsSchedulesOptionsMutationOptions = <TError = RequestTimeoutResponse | InternalServerErrorResponse | ResponseTimeoutResponse | ServerTimeoutErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof getStreamsSchedulesOptions>>, TError,{streamId: string;analyticIdx: number;intervalsIdx: number}, TContext>, request?: SecondParameter<typeof lp5AxiosClient>}
): UseMutationOptions<Awaited<ReturnType<typeof getStreamsSchedulesOptions>>, TError,{streamId: string;analyticIdx: number;intervalsIdx: number}, TContext> => {

const mutationKey = ['getStreamsSchedulesOptions'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof getStreamsSchedulesOptions>>, {streamId: string;analyticIdx: number;intervalsIdx: number}> = (props) => {
          const {streamId,analyticIdx,intervalsIdx} = props ?? {};

          return  getStreamsSchedulesOptions(streamId,analyticIdx,intervalsIdx,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type GetStreamsSchedulesOptionsMutationResult = NonNullable<Awaited<ReturnType<typeof getStreamsSchedulesOptions>>>

    export type GetStreamsSchedulesOptionsMutationError = RequestTimeoutResponse | InternalServerErrorResponse | ResponseTimeoutResponse | ServerTimeoutErrorResponse

    /**
 * @summary streams schedules options
 */
export const useGetStreamsSchedulesOptions = <TError = RequestTimeoutResponse | InternalServerErrorResponse | ResponseTimeoutResponse | ServerTimeoutErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof getStreamsSchedulesOptions>>, TError,{streamId: string;analyticIdx: number;intervalsIdx: number}, TContext>, request?: SecondParameter<typeof lp5AxiosClient>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof getStreamsSchedulesOptions>>,
        TError,
        {streamId: string;analyticIdx: number;intervalsIdx: number},
        TContext
      > => {
      return useMutation(getGetStreamsSchedulesOptionsMutationOptions(options), queryClient);
    }

/**
 * Create schedule template.
 *
 * It will calculate working intervals based on specified parameters for future usage in analytics working according
 * to these intervals.
 *
 * Calculated intervals are available in response of this request and in response of
 * ["get schedule templates"](#operation/getScheduleTemplates)/["get schedule template"](#operation/getScheduleTemplate)
 * @summary create schedule template
 */
export const createScheduleTemplate = (
    schTemplateToCreate: SchTemplateToCreate,
 options?: SecondParameter<typeof lp5AxiosClient>,signal?: AbortSignal
) => {


      return lp5AxiosClient<SchCreationResponse>(
      {url: `/6/streams/templates/schedules`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: schTemplateToCreate, signal
    },
      options);
    }




export const getCreateScheduleTemplateMutationOptions = <TError = Error | AuthorizationErrorResponse | ForbiddenErrorWithServicesResponse | RequestTimeoutResponse | PayloadToLargeResponse | StreamNoSuitableAgentResponse | InternalServerErrorResponse | ResponseTimeoutResponse | ServerTimeoutErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createScheduleTemplate>>, TError,{data: SchTemplateToCreate}, TContext>, request?: SecondParameter<typeof lp5AxiosClient>}
): UseMutationOptions<Awaited<ReturnType<typeof createScheduleTemplate>>, TError,{data: SchTemplateToCreate}, TContext> => {

const mutationKey = ['createScheduleTemplate'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof createScheduleTemplate>>, {data: SchTemplateToCreate}> = (props) => {
          const {data} = props ?? {};

          return  createScheduleTemplate(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type CreateScheduleTemplateMutationResult = NonNullable<Awaited<ReturnType<typeof createScheduleTemplate>>>
    export type CreateScheduleTemplateMutationBody = SchTemplateToCreate
    export type CreateScheduleTemplateMutationError = Error | AuthorizationErrorResponse | ForbiddenErrorWithServicesResponse | RequestTimeoutResponse | PayloadToLargeResponse | StreamNoSuitableAgentResponse | InternalServerErrorResponse | ResponseTimeoutResponse | ServerTimeoutErrorResponse

    /**
 * @summary create schedule template
 */
export const useCreateScheduleTemplate = <TError = Error | AuthorizationErrorResponse | ForbiddenErrorWithServicesResponse | RequestTimeoutResponse | PayloadToLargeResponse | StreamNoSuitableAgentResponse | InternalServerErrorResponse | ResponseTimeoutResponse | ServerTimeoutErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createScheduleTemplate>>, TError,{data: SchTemplateToCreate}, TContext>, request?: SecondParameter<typeof lp5AxiosClient>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof createScheduleTemplate>>,
        TError,
        {data: SchTemplateToCreate},
        TContext
      > => {
      return useMutation(getCreateScheduleTemplateMutationOptions(options), queryClient);
    }

/**
 * Get schedule templates according to filters.
 * The results are sorted by templates creation order, the oldest streams shown first.
 * @summary get schedule templates
 */
export const getScheduleTemplates = (
    params?: GetScheduleTemplatesParams,
 options?: SecondParameter<typeof lp5AxiosClient>,signal?: AbortSignal
) => {


      return lp5AxiosClient<SchTemplateResponseArray>(
      {url: `/6/streams/templates/schedules`, method: 'GET',
        params, signal
    },
      options);
    }




export const getGetScheduleTemplatesQueryKey = (params?: GetScheduleTemplatesParams,) => {
    return [
    `/6/streams/templates/schedules`, ...(params ? [params] : [])
    ] as const;
    }


export const getGetScheduleTemplatesQueryOptions = <TData = Awaited<ReturnType<typeof getScheduleTemplates>>, TError = Error | AuthorizationErrorResponse | ForbiddenErrorWithServicesResponse | RequestTimeoutResponse | StreamNoSuitableAgentResponse | InternalServerErrorResponse | ResponseTimeoutResponse | ServerTimeoutErrorResponse>(params?: GetScheduleTemplatesParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getScheduleTemplates>>, TError, TData>>, request?: SecondParameter<typeof lp5AxiosClient>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetScheduleTemplatesQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getScheduleTemplates>>> = ({ signal }) => getScheduleTemplates(params, requestOptions, signal);





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getScheduleTemplates>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetScheduleTemplatesQueryResult = NonNullable<Awaited<ReturnType<typeof getScheduleTemplates>>>
export type GetScheduleTemplatesQueryError = Error | AuthorizationErrorResponse | ForbiddenErrorWithServicesResponse | RequestTimeoutResponse | StreamNoSuitableAgentResponse | InternalServerErrorResponse | ResponseTimeoutResponse | ServerTimeoutErrorResponse


export function useGetScheduleTemplates<TData = Awaited<ReturnType<typeof getScheduleTemplates>>, TError = Error | AuthorizationErrorResponse | ForbiddenErrorWithServicesResponse | RequestTimeoutResponse | StreamNoSuitableAgentResponse | InternalServerErrorResponse | ResponseTimeoutResponse | ServerTimeoutErrorResponse>(
 params: undefined |  GetScheduleTemplatesParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getScheduleTemplates>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getScheduleTemplates>>,
          TError,
          Awaited<ReturnType<typeof getScheduleTemplates>>
        > , 'initialData'
      >, request?: SecondParameter<typeof lp5AxiosClient>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetScheduleTemplates<TData = Awaited<ReturnType<typeof getScheduleTemplates>>, TError = Error | AuthorizationErrorResponse | ForbiddenErrorWithServicesResponse | RequestTimeoutResponse | StreamNoSuitableAgentResponse | InternalServerErrorResponse | ResponseTimeoutResponse | ServerTimeoutErrorResponse>(
 params?: GetScheduleTemplatesParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getScheduleTemplates>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getScheduleTemplates>>,
          TError,
          Awaited<ReturnType<typeof getScheduleTemplates>>
        > , 'initialData'
      >, request?: SecondParameter<typeof lp5AxiosClient>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetScheduleTemplates<TData = Awaited<ReturnType<typeof getScheduleTemplates>>, TError = Error | AuthorizationErrorResponse | ForbiddenErrorWithServicesResponse | RequestTimeoutResponse | StreamNoSuitableAgentResponse | InternalServerErrorResponse | ResponseTimeoutResponse | ServerTimeoutErrorResponse>(
 params?: GetScheduleTemplatesParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getScheduleTemplates>>, TError, TData>>, request?: SecondParameter<typeof lp5AxiosClient>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary get schedule templates
 */

export function useGetScheduleTemplates<TData = Awaited<ReturnType<typeof getScheduleTemplates>>, TError = Error | AuthorizationErrorResponse | ForbiddenErrorWithServicesResponse | RequestTimeoutResponse | StreamNoSuitableAgentResponse | InternalServerErrorResponse | ResponseTimeoutResponse | ServerTimeoutErrorResponse>(
 params?: GetScheduleTemplatesParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getScheduleTemplates>>, TError, TData>>, request?: SecondParameter<typeof lp5AxiosClient>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetScheduleTemplatesQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}







/**
 * Get options for the resource.
 * @summary schedules template options
 */
export const getSchedulesTemplateOptions = (

 options?: SecondParameter<typeof lp5AxiosClient>,signal?: AbortSignal
) => {


      return lp5AxiosClient<void>(
      {url: `/6/streams/templates/schedules`, method: 'OPTIONS', signal
    },
      options);
    }




export const getGetSchedulesTemplateOptionsMutationOptions = <TError = RequestTimeoutResponse | InternalServerErrorResponse | ResponseTimeoutResponse | ServerTimeoutErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof getSchedulesTemplateOptions>>, TError,void, TContext>, request?: SecondParameter<typeof lp5AxiosClient>}
): UseMutationOptions<Awaited<ReturnType<typeof getSchedulesTemplateOptions>>, TError,void, TContext> => {

const mutationKey = ['getSchedulesTemplateOptions'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof getSchedulesTemplateOptions>>, void> = () => {


          return  getSchedulesTemplateOptions(requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type GetSchedulesTemplateOptionsMutationResult = NonNullable<Awaited<ReturnType<typeof getSchedulesTemplateOptions>>>

    export type GetSchedulesTemplateOptionsMutationError = RequestTimeoutResponse | InternalServerErrorResponse | ResponseTimeoutResponse | ServerTimeoutErrorResponse

    /**
 * @summary schedules template options
 */
export const useGetSchedulesTemplateOptions = <TError = RequestTimeoutResponse | InternalServerErrorResponse | ResponseTimeoutResponse | ServerTimeoutErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof getSchedulesTemplateOptions>>, TError,void, TContext>, request?: SecondParameter<typeof lp5AxiosClient>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof getSchedulesTemplateOptions>>,
        TError,
        void,
        TContext
      > => {
      return useMutation(getGetSchedulesTemplateOptionsMutationOptions(options), queryClient);
    }

/**
 * (Re)Create schedule template.
 *
 * It will calculate working intervals based on specified parameters for future usage in analytics working according
 * to these intervals.
 *
 * Calculated intervals are available in response of this request and in response of
 * ["get schedule templates"](#operation/getScheduleTemplates)/["get schedule template"](#operation/getScheduleTemplate)
 * requests
 * @summary replace schedule template
 */
export const replaceSchedule = (
    scheduleId: Uuid & unknown & unknown,
    schTemplateToCreate: SchTemplateToCreate,
 options?: SecondParameter<typeof lp5AxiosClient>,signal?: AbortSignal
) => {


      return lp5AxiosClient<SchCreationResponse>(
      {url: `/6/streams/templates/schedules/${scheduleId}`, method: 'PUT',
      headers: {'Content-Type': 'application/json', },
      data: schTemplateToCreate, signal
    },
      options);
    }




export const getReplaceScheduleMutationOptions = <TError = Error | AuthorizationErrorResponse | ForbiddenErrorWithServicesResponse | RequestTimeoutResponse | PayloadToLargeResponse | StreamNoSuitableAgentResponse | InternalServerErrorResponse | ResponseTimeoutResponse | ServerTimeoutErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof replaceSchedule>>, TError,{scheduleId: Uuid & unknown & unknown;data: SchTemplateToCreate}, TContext>, request?: SecondParameter<typeof lp5AxiosClient>}
): UseMutationOptions<Awaited<ReturnType<typeof replaceSchedule>>, TError,{scheduleId: Uuid & unknown & unknown;data: SchTemplateToCreate}, TContext> => {

const mutationKey = ['replaceSchedule'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof replaceSchedule>>, {scheduleId: Uuid & unknown & unknown;data: SchTemplateToCreate}> = (props) => {
          const {scheduleId,data} = props ?? {};

          return  replaceSchedule(scheduleId,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type ReplaceScheduleMutationResult = NonNullable<Awaited<ReturnType<typeof replaceSchedule>>>
    export type ReplaceScheduleMutationBody = SchTemplateToCreate
    export type ReplaceScheduleMutationError = Error | AuthorizationErrorResponse | ForbiddenErrorWithServicesResponse | RequestTimeoutResponse | PayloadToLargeResponse | StreamNoSuitableAgentResponse | InternalServerErrorResponse | ResponseTimeoutResponse | ServerTimeoutErrorResponse

    /**
 * @summary replace schedule template
 */
export const useReplaceSchedule = <TError = Error | AuthorizationErrorResponse | ForbiddenErrorWithServicesResponse | RequestTimeoutResponse | PayloadToLargeResponse | StreamNoSuitableAgentResponse | InternalServerErrorResponse | ResponseTimeoutResponse | ServerTimeoutErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof replaceSchedule>>, TError,{scheduleId: Uuid & unknown & unknown;data: SchTemplateToCreate}, TContext>, request?: SecondParameter<typeof lp5AxiosClient>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof replaceSchedule>>,
        TError,
        {scheduleId: Uuid & unknown & unknown;data: SchTemplateToCreate},
        TContext
      > => {
      return useMutation(getReplaceScheduleMutationOptions(options), queryClient);
    }

/**
 * Get schedule template by ID.
 * @summary get schedule template
 */
export const getScheduleTemplate = (
    scheduleId: Uuid & unknown & unknown,
    params?: GetScheduleTemplateParams,
 options?: SecondParameter<typeof lp5AxiosClient>,signal?: AbortSignal
) => {


      return lp5AxiosClient<SchTemplateResponse>(
      {url: `/6/streams/templates/schedules/${scheduleId}`, method: 'GET',
        params, signal
    },
      options);
    }




export const getGetScheduleTemplateQueryKey = (scheduleId: Uuid & unknown & unknown,
    params?: GetScheduleTemplateParams,) => {
    return [
    `/6/streams/templates/schedules/${scheduleId}`, ...(params ? [params] : [])
    ] as const;
    }


export const getGetScheduleTemplateQueryOptions = <TData = Awaited<ReturnType<typeof getScheduleTemplate>>, TError = Error | AuthorizationErrorResponse | ForbiddenErrorWithServicesResponse | RequestTimeoutResponse | StreamNoSuitableAgentResponse | InternalServerErrorResponse | ResponseTimeoutResponse | ServerTimeoutErrorResponse>(scheduleId: Uuid & unknown & unknown,
    params?: GetScheduleTemplateParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getScheduleTemplate>>, TError, TData>>, request?: SecondParameter<typeof lp5AxiosClient>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetScheduleTemplateQueryKey(scheduleId,params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getScheduleTemplate>>> = ({ signal }) => getScheduleTemplate(scheduleId,params, requestOptions, signal);





   return  { queryKey, queryFn, enabled: scheduleId !== null && scheduleId !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getScheduleTemplate>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetScheduleTemplateQueryResult = NonNullable<Awaited<ReturnType<typeof getScheduleTemplate>>>
export type GetScheduleTemplateQueryError = Error | AuthorizationErrorResponse | ForbiddenErrorWithServicesResponse | RequestTimeoutResponse | StreamNoSuitableAgentResponse | InternalServerErrorResponse | ResponseTimeoutResponse | ServerTimeoutErrorResponse


export function useGetScheduleTemplate<TData = Awaited<ReturnType<typeof getScheduleTemplate>>, TError = Error | AuthorizationErrorResponse | ForbiddenErrorWithServicesResponse | RequestTimeoutResponse | StreamNoSuitableAgentResponse | InternalServerErrorResponse | ResponseTimeoutResponse | ServerTimeoutErrorResponse>(
 scheduleId: Uuid & unknown & unknown,
    params: undefined |  GetScheduleTemplateParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getScheduleTemplate>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getScheduleTemplate>>,
          TError,
          Awaited<ReturnType<typeof getScheduleTemplate>>
        > , 'initialData'
      >, request?: SecondParameter<typeof lp5AxiosClient>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetScheduleTemplate<TData = Awaited<ReturnType<typeof getScheduleTemplate>>, TError = Error | AuthorizationErrorResponse | ForbiddenErrorWithServicesResponse | RequestTimeoutResponse | StreamNoSuitableAgentResponse | InternalServerErrorResponse | ResponseTimeoutResponse | ServerTimeoutErrorResponse>(
 scheduleId: Uuid & unknown & unknown,
    params?: GetScheduleTemplateParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getScheduleTemplate>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getScheduleTemplate>>,
          TError,
          Awaited<ReturnType<typeof getScheduleTemplate>>
        > , 'initialData'
      >, request?: SecondParameter<typeof lp5AxiosClient>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetScheduleTemplate<TData = Awaited<ReturnType<typeof getScheduleTemplate>>, TError = Error | AuthorizationErrorResponse | ForbiddenErrorWithServicesResponse | RequestTimeoutResponse | StreamNoSuitableAgentResponse | InternalServerErrorResponse | ResponseTimeoutResponse | ServerTimeoutErrorResponse>(
 scheduleId: Uuid & unknown & unknown,
    params?: GetScheduleTemplateParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getScheduleTemplate>>, TError, TData>>, request?: SecondParameter<typeof lp5AxiosClient>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary get schedule template
 */

export function useGetScheduleTemplate<TData = Awaited<ReturnType<typeof getScheduleTemplate>>, TError = Error | AuthorizationErrorResponse | ForbiddenErrorWithServicesResponse | RequestTimeoutResponse | StreamNoSuitableAgentResponse | InternalServerErrorResponse | ResponseTimeoutResponse | ServerTimeoutErrorResponse>(
 scheduleId: Uuid & unknown & unknown,
    params?: GetScheduleTemplateParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getScheduleTemplate>>, TError, TData>>, request?: SecondParameter<typeof lp5AxiosClient>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetScheduleTemplateQueryOptions(scheduleId,params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}







/**
 * Delete schedule template by ID.
 * @summary delete schedule template
 */
export const deleteScheduleTemplate = (
    scheduleId: Uuid & unknown & unknown,
 options?: SecondParameter<typeof lp5AxiosClient>,signal?: AbortSignal
) => {


      return lp5AxiosClient<void>(
      {url: `/6/streams/templates/schedules/${scheduleId}`, method: 'DELETE', signal
    },
      options);
    }




export const getDeleteScheduleTemplateMutationOptions = <TError = Error | AuthorizationErrorResponse | ForbiddenErrorWithServicesResponse | RequestTimeoutResponse | StreamNoSuitableAgentResponse | InternalServerErrorResponse | ResponseTimeoutResponse | ServerTimeoutErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteScheduleTemplate>>, TError,{scheduleId: Uuid & unknown & unknown}, TContext>, request?: SecondParameter<typeof lp5AxiosClient>}
): UseMutationOptions<Awaited<ReturnType<typeof deleteScheduleTemplate>>, TError,{scheduleId: Uuid & unknown & unknown}, TContext> => {

const mutationKey = ['deleteScheduleTemplate'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof deleteScheduleTemplate>>, {scheduleId: Uuid & unknown & unknown}> = (props) => {
          const {scheduleId} = props ?? {};

          return  deleteScheduleTemplate(scheduleId,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type DeleteScheduleTemplateMutationResult = NonNullable<Awaited<ReturnType<typeof deleteScheduleTemplate>>>

    export type DeleteScheduleTemplateMutationError = Error | AuthorizationErrorResponse | ForbiddenErrorWithServicesResponse | RequestTimeoutResponse | StreamNoSuitableAgentResponse | InternalServerErrorResponse | ResponseTimeoutResponse | ServerTimeoutErrorResponse

    /**
 * @summary delete schedule template
 */
export const useDeleteScheduleTemplate = <TError = Error | AuthorizationErrorResponse | ForbiddenErrorWithServicesResponse | RequestTimeoutResponse | StreamNoSuitableAgentResponse | InternalServerErrorResponse | ResponseTimeoutResponse | ServerTimeoutErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteScheduleTemplate>>, TError,{scheduleId: Uuid & unknown & unknown}, TContext>, request?: SecondParameter<typeof lp5AxiosClient>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof deleteScheduleTemplate>>,
        TError,
        {scheduleId: Uuid & unknown & unknown},
        TContext
      > => {
      return useMutation(getDeleteScheduleTemplateMutationOptions(options), queryClient);
    }

/**
 * Get options for the resource.
 * @summary schedule template options
 */
export const getScheduleTemplateOptions = (
    scheduleId: Uuid & unknown & unknown,
 options?: SecondParameter<typeof lp5AxiosClient>,signal?: AbortSignal
) => {


      return lp5AxiosClient<void>(
      {url: `/6/streams/templates/schedules/${scheduleId}`, method: 'OPTIONS', signal
    },
      options);
    }




export const getGetScheduleTemplateOptionsMutationOptions = <TError = RequestTimeoutResponse | InternalServerErrorResponse | ResponseTimeoutResponse | ServerTimeoutErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof getScheduleTemplateOptions>>, TError,{scheduleId: Uuid & unknown & unknown}, TContext>, request?: SecondParameter<typeof lp5AxiosClient>}
): UseMutationOptions<Awaited<ReturnType<typeof getScheduleTemplateOptions>>, TError,{scheduleId: Uuid & unknown & unknown}, TContext> => {

const mutationKey = ['getScheduleTemplateOptions'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof getScheduleTemplateOptions>>, {scheduleId: Uuid & unknown & unknown}> = (props) => {
          const {scheduleId} = props ?? {};

          return  getScheduleTemplateOptions(scheduleId,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type GetScheduleTemplateOptionsMutationResult = NonNullable<Awaited<ReturnType<typeof getScheduleTemplateOptions>>>

    export type GetScheduleTemplateOptionsMutationError = RequestTimeoutResponse | InternalServerErrorResponse | ResponseTimeoutResponse | ServerTimeoutErrorResponse

    /**
 * @summary schedule template options
 */
export const useGetScheduleTemplateOptions = <TError = RequestTimeoutResponse | InternalServerErrorResponse | ResponseTimeoutResponse | ServerTimeoutErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof getScheduleTemplateOptions>>, TError,{scheduleId: Uuid & unknown & unknown}, TContext>, request?: SecondParameter<typeof lp5AxiosClient>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof getScheduleTemplateOptions>>,
        TError,
        {scheduleId: Uuid & unknown & unknown},
        TContext
      > => {
      return useMutation(getGetScheduleTemplateOptionsMutationOptions(options), queryClient);
    }

/**
 * Get schedule template generated working intervals by schedule ID.
 * @summary get schedule template intervals
 */
export const getScheduleTemplateIntervals = (
    scheduleId: Uuid & unknown & unknown,
    params?: GetScheduleTemplateIntervalsParams,
 options?: SecondParameter<typeof lp5AxiosClient>,signal?: AbortSignal
) => {


      return lp5AxiosClient<IntervalsResponse>(
      {url: `/6/streams/templates/schedules/${scheduleId}/intervals`, method: 'GET',
        params, signal
    },
      options);
    }




export const getGetScheduleTemplateIntervalsQueryKey = (scheduleId: Uuid & unknown & unknown,
    params?: GetScheduleTemplateIntervalsParams,) => {
    return [
    `/6/streams/templates/schedules/${scheduleId}/intervals`, ...(params ? [params] : [])
    ] as const;
    }


export const getGetScheduleTemplateIntervalsQueryOptions = <TData = Awaited<ReturnType<typeof getScheduleTemplateIntervals>>, TError = Error | AuthorizationErrorResponse | ForbiddenErrorWithServicesResponse | RequestTimeoutResponse | StreamNoSuitableAgentResponse | InternalServerErrorResponse | ResponseTimeoutResponse | ServerTimeoutErrorResponse>(scheduleId: Uuid & unknown & unknown,
    params?: GetScheduleTemplateIntervalsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getScheduleTemplateIntervals>>, TError, TData>>, request?: SecondParameter<typeof lp5AxiosClient>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetScheduleTemplateIntervalsQueryKey(scheduleId,params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getScheduleTemplateIntervals>>> = ({ signal }) => getScheduleTemplateIntervals(scheduleId,params, requestOptions, signal);





   return  { queryKey, queryFn, enabled: scheduleId !== null && scheduleId !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getScheduleTemplateIntervals>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetScheduleTemplateIntervalsQueryResult = NonNullable<Awaited<ReturnType<typeof getScheduleTemplateIntervals>>>
export type GetScheduleTemplateIntervalsQueryError = Error | AuthorizationErrorResponse | ForbiddenErrorWithServicesResponse | RequestTimeoutResponse | StreamNoSuitableAgentResponse | InternalServerErrorResponse | ResponseTimeoutResponse | ServerTimeoutErrorResponse


export function useGetScheduleTemplateIntervals<TData = Awaited<ReturnType<typeof getScheduleTemplateIntervals>>, TError = Error | AuthorizationErrorResponse | ForbiddenErrorWithServicesResponse | RequestTimeoutResponse | StreamNoSuitableAgentResponse | InternalServerErrorResponse | ResponseTimeoutResponse | ServerTimeoutErrorResponse>(
 scheduleId: Uuid & unknown & unknown,
    params: undefined |  GetScheduleTemplateIntervalsParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getScheduleTemplateIntervals>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getScheduleTemplateIntervals>>,
          TError,
          Awaited<ReturnType<typeof getScheduleTemplateIntervals>>
        > , 'initialData'
      >, request?: SecondParameter<typeof lp5AxiosClient>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetScheduleTemplateIntervals<TData = Awaited<ReturnType<typeof getScheduleTemplateIntervals>>, TError = Error | AuthorizationErrorResponse | ForbiddenErrorWithServicesResponse | RequestTimeoutResponse | StreamNoSuitableAgentResponse | InternalServerErrorResponse | ResponseTimeoutResponse | ServerTimeoutErrorResponse>(
 scheduleId: Uuid & unknown & unknown,
    params?: GetScheduleTemplateIntervalsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getScheduleTemplateIntervals>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getScheduleTemplateIntervals>>,
          TError,
          Awaited<ReturnType<typeof getScheduleTemplateIntervals>>
        > , 'initialData'
      >, request?: SecondParameter<typeof lp5AxiosClient>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetScheduleTemplateIntervals<TData = Awaited<ReturnType<typeof getScheduleTemplateIntervals>>, TError = Error | AuthorizationErrorResponse | ForbiddenErrorWithServicesResponse | RequestTimeoutResponse | StreamNoSuitableAgentResponse | InternalServerErrorResponse | ResponseTimeoutResponse | ServerTimeoutErrorResponse>(
 scheduleId: Uuid & unknown & unknown,
    params?: GetScheduleTemplateIntervalsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getScheduleTemplateIntervals>>, TError, TData>>, request?: SecondParameter<typeof lp5AxiosClient>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary get schedule template intervals
 */

export function useGetScheduleTemplateIntervals<TData = Awaited<ReturnType<typeof getScheduleTemplateIntervals>>, TError = Error | AuthorizationErrorResponse | ForbiddenErrorWithServicesResponse | RequestTimeoutResponse | StreamNoSuitableAgentResponse | InternalServerErrorResponse | ResponseTimeoutResponse | ServerTimeoutErrorResponse>(
 scheduleId: Uuid & unknown & unknown,
    params?: GetScheduleTemplateIntervalsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getScheduleTemplateIntervals>>, TError, TData>>, request?: SecondParameter<typeof lp5AxiosClient>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetScheduleTemplateIntervalsQueryOptions(scheduleId,params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}







/**
 * Get options for the resource.
 * @summary schedule template options
 */
export const getScheduleTemplateIntervalsOptions = (
    scheduleId: Uuid & unknown & unknown,
 options?: SecondParameter<typeof lp5AxiosClient>,signal?: AbortSignal
) => {


      return lp5AxiosClient<void>(
      {url: `/6/streams/templates/schedules/${scheduleId}/intervals`, method: 'OPTIONS', signal
    },
      options);
    }




export const getGetScheduleTemplateIntervalsOptionsMutationOptions = <TError = RequestTimeoutResponse | InternalServerErrorResponse | ResponseTimeoutResponse | ServerTimeoutErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof getScheduleTemplateIntervalsOptions>>, TError,{scheduleId: Uuid & unknown & unknown}, TContext>, request?: SecondParameter<typeof lp5AxiosClient>}
): UseMutationOptions<Awaited<ReturnType<typeof getScheduleTemplateIntervalsOptions>>, TError,{scheduleId: Uuid & unknown & unknown}, TContext> => {

const mutationKey = ['getScheduleTemplateIntervalsOptions'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof getScheduleTemplateIntervalsOptions>>, {scheduleId: Uuid & unknown & unknown}> = (props) => {
          const {scheduleId} = props ?? {};

          return  getScheduleTemplateIntervalsOptions(scheduleId,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type GetScheduleTemplateIntervalsOptionsMutationResult = NonNullable<Awaited<ReturnType<typeof getScheduleTemplateIntervalsOptions>>>

    export type GetScheduleTemplateIntervalsOptionsMutationError = RequestTimeoutResponse | InternalServerErrorResponse | ResponseTimeoutResponse | ServerTimeoutErrorResponse

    /**
 * @summary schedule template options
 */
export const useGetScheduleTemplateIntervalsOptions = <TError = RequestTimeoutResponse | InternalServerErrorResponse | ResponseTimeoutResponse | ServerTimeoutErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof getScheduleTemplateIntervalsOptions>>, TError,{scheduleId: Uuid & unknown & unknown}, TContext>, request?: SecondParameter<typeof lp5AxiosClient>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof getScheduleTemplateIntervalsOptions>>,
        TError,
        {scheduleId: Uuid & unknown & unknown},
        TContext
      > => {
      return useMutation(getGetScheduleTemplateIntervalsOptionsMutationOptions(options), queryClient);
    }

/**
 * Calculate intervals which can be used for schedules.
 *
 * This request can be used for schedule template parameters check, it will calculate working intervals in the
 * same way as ["create schedule template"](#operation/createScheduleTemplate)/
 * ["(re)create schedule template"](#operation/replaceSchedule) requests, but no data will be saved for future
 * usage.
 * @summary calculate intervals
 */
export const calcIntervals = (
    helpersRequest: HelpersRequest,
 options?: SecondParameter<typeof lp5AxiosClient>,signal?: AbortSignal
) => {


      return lp5AxiosClient<IntervalsResponse>(
      {url: `/6/streams/intervals/calculate`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: helpersRequest, signal
    },
      options);
    }




export const getCalcIntervalsMutationOptions = <TError = Error | ForbiddenErrorWithServicesResponse | RequestTimeoutResponse | PayloadToLargeResponse | StreamNoSuitableAgentResponse | InternalServerErrorResponse | ResponseTimeoutResponse | ServerTimeoutErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof calcIntervals>>, TError,{data: HelpersRequest}, TContext>, request?: SecondParameter<typeof lp5AxiosClient>}
): UseMutationOptions<Awaited<ReturnType<typeof calcIntervals>>, TError,{data: HelpersRequest}, TContext> => {

const mutationKey = ['calcIntervals'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof calcIntervals>>, {data: HelpersRequest}> = (props) => {
          const {data} = props ?? {};

          return  calcIntervals(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type CalcIntervalsMutationResult = NonNullable<Awaited<ReturnType<typeof calcIntervals>>>
    export type CalcIntervalsMutationBody = HelpersRequest
    export type CalcIntervalsMutationError = Error | ForbiddenErrorWithServicesResponse | RequestTimeoutResponse | PayloadToLargeResponse | StreamNoSuitableAgentResponse | InternalServerErrorResponse | ResponseTimeoutResponse | ServerTimeoutErrorResponse

    /**
 * @summary calculate intervals
 */
export const useCalcIntervals = <TError = Error | ForbiddenErrorWithServicesResponse | RequestTimeoutResponse | PayloadToLargeResponse | StreamNoSuitableAgentResponse | InternalServerErrorResponse | ResponseTimeoutResponse | ServerTimeoutErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof calcIntervals>>, TError,{data: HelpersRequest}, TContext>, request?: SecondParameter<typeof lp5AxiosClient>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof calcIntervals>>,
        TError,
        {data: HelpersRequest},
        TContext
      > => {
      return useMutation(getCalcIntervalsMutationOptions(options), queryClient);
    }

/**
 * Get options for the resource.
 * @summary intervals calculate options
 */
export const getIntervalsCalculateOptions = (

 options?: SecondParameter<typeof lp5AxiosClient>,signal?: AbortSignal
) => {


      return lp5AxiosClient<void>(
      {url: `/6/streams/intervals/calculate`, method: 'OPTIONS', signal
    },
      options);
    }




export const getGetIntervalsCalculateOptionsMutationOptions = <TError = RequestTimeoutResponse | InternalServerErrorResponse | ResponseTimeoutResponse | ServerTimeoutErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof getIntervalsCalculateOptions>>, TError,void, TContext>, request?: SecondParameter<typeof lp5AxiosClient>}
): UseMutationOptions<Awaited<ReturnType<typeof getIntervalsCalculateOptions>>, TError,void, TContext> => {

const mutationKey = ['getIntervalsCalculateOptions'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof getIntervalsCalculateOptions>>, void> = () => {


          return  getIntervalsCalculateOptions(requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type GetIntervalsCalculateOptionsMutationResult = NonNullable<Awaited<ReturnType<typeof getIntervalsCalculateOptions>>>

    export type GetIntervalsCalculateOptionsMutationError = RequestTimeoutResponse | InternalServerErrorResponse | ResponseTimeoutResponse | ServerTimeoutErrorResponse

    /**
 * @summary intervals calculate options
 */
export const useGetIntervalsCalculateOptions = <TError = RequestTimeoutResponse | InternalServerErrorResponse | ResponseTimeoutResponse | ServerTimeoutErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof getIntervalsCalculateOptions>>, TError,void, TContext>, request?: SecondParameter<typeof lp5AxiosClient>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof getIntervalsCalculateOptions>>,
        TError,
        void,
        TContext
      > => {
      return useMutation(getGetIntervalsCalculateOptionsMutationOptions(options), queryClient);
    }

/**
 * **Warning: only for service use**
 *
 * register agent.
 * @summary register agent
 */
export const registerAgent = (
    agentToBeCreated: AgentToBeCreated,
 options?: SecondParameter<typeof lp5AxiosClient>,signal?: AbortSignal
) => {


      return lp5AxiosClient<RegisterAgent201>(
      {url: `/6/agents`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: agentToBeCreated, signal
    },
      options);
    }




export const getRegisterAgentMutationOptions = <TError = Error | AuthorizationErrorResponse | ForbiddenErrorResponse | RequestTimeoutResponse | PayloadToLargeResponse | InternalServerErrorResponse | ResponseTimeoutResponse | ServerTimeoutErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof registerAgent>>, TError,{data: AgentToBeCreated}, TContext>, request?: SecondParameter<typeof lp5AxiosClient>}
): UseMutationOptions<Awaited<ReturnType<typeof registerAgent>>, TError,{data: AgentToBeCreated}, TContext> => {

const mutationKey = ['registerAgent'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof registerAgent>>, {data: AgentToBeCreated}> = (props) => {
          const {data} = props ?? {};

          return  registerAgent(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type RegisterAgentMutationResult = NonNullable<Awaited<ReturnType<typeof registerAgent>>>
    export type RegisterAgentMutationBody = AgentToBeCreated
    export type RegisterAgentMutationError = Error | AuthorizationErrorResponse | ForbiddenErrorResponse | RequestTimeoutResponse | PayloadToLargeResponse | InternalServerErrorResponse | ResponseTimeoutResponse | ServerTimeoutErrorResponse

    /**
 * @summary register agent
 */
export const useRegisterAgent = <TError = Error | AuthorizationErrorResponse | ForbiddenErrorResponse | RequestTimeoutResponse | PayloadToLargeResponse | InternalServerErrorResponse | ResponseTimeoutResponse | ServerTimeoutErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof registerAgent>>, TError,{data: AgentToBeCreated}, TContext>, request?: SecondParameter<typeof lp5AxiosClient>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof registerAgent>>,
        TError,
        {data: AgentToBeCreated},
        TContext
      > => {
      return useMutation(getRegisterAgentMutationOptions(options), queryClient);
    }

/**
 * Get options for the resource .
 * @summary agents options
 */
export const getAgentsOptions = (

 options?: SecondParameter<typeof lp5AxiosClient>,signal?: AbortSignal
) => {


      return lp5AxiosClient<void>(
      {url: `/6/agents`, method: 'OPTIONS', signal
    },
      options);
    }




export const getGetAgentsOptionsMutationOptions = <TError = RequestTimeoutResponse | InternalServerErrorResponse | ResponseTimeoutResponse | ServerTimeoutErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof getAgentsOptions>>, TError,void, TContext>, request?: SecondParameter<typeof lp5AxiosClient>}
): UseMutationOptions<Awaited<ReturnType<typeof getAgentsOptions>>, TError,void, TContext> => {

const mutationKey = ['getAgentsOptions'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof getAgentsOptions>>, void> = () => {


          return  getAgentsOptions(requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type GetAgentsOptionsMutationResult = NonNullable<Awaited<ReturnType<typeof getAgentsOptions>>>

    export type GetAgentsOptionsMutationError = RequestTimeoutResponse | InternalServerErrorResponse | ResponseTimeoutResponse | ServerTimeoutErrorResponse

    /**
 * @summary agents options
 */
export const useGetAgentsOptions = <TError = RequestTimeoutResponse | InternalServerErrorResponse | ResponseTimeoutResponse | ServerTimeoutErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof getAgentsOptions>>, TError,void, TContext>, request?: SecondParameter<typeof lp5AxiosClient>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof getAgentsOptions>>,
        TError,
        void,
        TContext
      > => {
      return useMutation(getGetAgentsOptionsMutationOptions(options), queryClient);
    }

/**
 * **Warning: only for service use**
 *
 * Remove the agent by ID.
 * @summary remove agent
 */
export const removeAgent = (
    agentId: string,
    params?: RemoveAgentParams,
 options?: SecondParameter<typeof lp5AxiosClient>,signal?: AbortSignal
) => {


      return lp5AxiosClient<void>(
      {url: `/6/agents/${agentId}`, method: 'DELETE',
        params, signal
    },
      options);
    }




export const getRemoveAgentMutationOptions = <TError = AuthorizationErrorResponse | ForbiddenErrorResponse | Error | RequestTimeoutResponse | InternalServerErrorResponse | ResponseTimeoutResponse | ServerTimeoutErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof removeAgent>>, TError,{agentId: string;params?: RemoveAgentParams}, TContext>, request?: SecondParameter<typeof lp5AxiosClient>}
): UseMutationOptions<Awaited<ReturnType<typeof removeAgent>>, TError,{agentId: string;params?: RemoveAgentParams}, TContext> => {

const mutationKey = ['removeAgent'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof removeAgent>>, {agentId: string;params?: RemoveAgentParams}> = (props) => {
          const {agentId,params} = props ?? {};

          return  removeAgent(agentId,params,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type RemoveAgentMutationResult = NonNullable<Awaited<ReturnType<typeof removeAgent>>>

    export type RemoveAgentMutationError = AuthorizationErrorResponse | ForbiddenErrorResponse | Error | RequestTimeoutResponse | InternalServerErrorResponse | ResponseTimeoutResponse | ServerTimeoutErrorResponse

    /**
 * @summary remove agent
 */
export const useRemoveAgent = <TError = AuthorizationErrorResponse | ForbiddenErrorResponse | Error | RequestTimeoutResponse | InternalServerErrorResponse | ResponseTimeoutResponse | ServerTimeoutErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof removeAgent>>, TError,{agentId: string;params?: RemoveAgentParams}, TContext>, request?: SecondParameter<typeof lp5AxiosClient>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof removeAgent>>,
        TError,
        {agentId: string;params?: RemoveAgentParams},
        TContext
      > => {
      return useMutation(getRemoveAgentMutationOptions(options), queryClient);
    }

/**
 * Get options for the resource .
 * @summary agent options
 */
export const getAgentOptions = (
    agentId: string,
 options?: SecondParameter<typeof lp5AxiosClient>,signal?: AbortSignal
) => {


      return lp5AxiosClient<void>(
      {url: `/6/agents/${agentId}`, method: 'OPTIONS', signal
    },
      options);
    }




export const getGetAgentOptionsMutationOptions = <TError = RequestTimeoutResponse | InternalServerErrorResponse | ResponseTimeoutResponse | ServerTimeoutErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof getAgentOptions>>, TError,{agentId: string}, TContext>, request?: SecondParameter<typeof lp5AxiosClient>}
): UseMutationOptions<Awaited<ReturnType<typeof getAgentOptions>>, TError,{agentId: string}, TContext> => {

const mutationKey = ['getAgentOptions'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof getAgentOptions>>, {agentId: string}> = (props) => {
          const {agentId} = props ?? {};

          return  getAgentOptions(agentId,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type GetAgentOptionsMutationResult = NonNullable<Awaited<ReturnType<typeof getAgentOptions>>>

    export type GetAgentOptionsMutationError = RequestTimeoutResponse | InternalServerErrorResponse | ResponseTimeoutResponse | ServerTimeoutErrorResponse

    /**
 * @summary agent options
 */
export const useGetAgentOptions = <TError = RequestTimeoutResponse | InternalServerErrorResponse | ResponseTimeoutResponse | ServerTimeoutErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof getAgentOptions>>, TError,{agentId: string}, TContext>, request?: SecondParameter<typeof lp5AxiosClient>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof getAgentOptions>>,
        TError,
        {agentId: string},
        TContext
      > => {
      return useMutation(getGetAgentOptionsMutationOptions(options), queryClient);
    }

/**
 * Attach (or detach) streams to a group.
 *
 * See `Group settings` chapter in *Luna-Video-Manager* developers documentation for stream and groups settings and analytics
 * sharing features.
 * @summary attach (or detach) streams to a group
 */
export const streamsGroupLinker = (
    linker?: Linker,
    params?: StreamsGroupLinkerParams,
 options?: SecondParameter<typeof lp5AxiosClient>,signal?: AbortSignal
) => {


      return lp5AxiosClient<UpdatedStreams | void>(
      {url: `/6/linker`, method: 'PATCH',
      headers: {'Content-Type': 'application/json', },
      data: linker,
        params, signal
    },
      options);
    }




export const getStreamsGroupLinkerMutationOptions = <TError = Error | ForbiddenErrorResponse | RequestTimeoutResponse | PayloadToLargeResponse | InternalServerErrorResponse | ResponseTimeoutResponse | ServerTimeoutErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof streamsGroupLinker>>, TError,{data?: Linker;params?: StreamsGroupLinkerParams}, TContext>, request?: SecondParameter<typeof lp5AxiosClient>}
): UseMutationOptions<Awaited<ReturnType<typeof streamsGroupLinker>>, TError,{data?: Linker;params?: StreamsGroupLinkerParams}, TContext> => {

const mutationKey = ['streamsGroupLinker'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof streamsGroupLinker>>, {data?: Linker;params?: StreamsGroupLinkerParams}> = (props) => {
          const {data,params} = props ?? {};

          return  streamsGroupLinker(data,params,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type StreamsGroupLinkerMutationResult = NonNullable<Awaited<ReturnType<typeof streamsGroupLinker>>>
    export type StreamsGroupLinkerMutationBody = Linker | undefined
    export type StreamsGroupLinkerMutationError = Error | ForbiddenErrorResponse | RequestTimeoutResponse | PayloadToLargeResponse | InternalServerErrorResponse | ResponseTimeoutResponse | ServerTimeoutErrorResponse

    /**
 * @summary attach (or detach) streams to a group
 */
export const useStreamsGroupLinker = <TError = Error | ForbiddenErrorResponse | RequestTimeoutResponse | PayloadToLargeResponse | InternalServerErrorResponse | ResponseTimeoutResponse | ServerTimeoutErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof streamsGroupLinker>>, TError,{data?: Linker;params?: StreamsGroupLinkerParams}, TContext>, request?: SecondParameter<typeof lp5AxiosClient>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof streamsGroupLinker>>,
        TError,
        {data?: Linker;params?: StreamsGroupLinkerParams},
        TContext
      > => {
      return useMutation(getStreamsGroupLinkerMutationOptions(options), queryClient);
    }

/**
 * Get options for the resource.
 * @summary linker options
 */
export const getStreamsGroupLinkerOptions = (

 options?: SecondParameter<typeof lp5AxiosClient>,signal?: AbortSignal
) => {


      return lp5AxiosClient<void>(
      {url: `/6/linker`, method: 'OPTIONS', signal
    },
      options);
    }




export const getGetStreamsGroupLinkerOptionsMutationOptions = <TError = RequestTimeoutResponse | InternalServerErrorResponse | ResponseTimeoutResponse | ServerTimeoutErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof getStreamsGroupLinkerOptions>>, TError,void, TContext>, request?: SecondParameter<typeof lp5AxiosClient>}
): UseMutationOptions<Awaited<ReturnType<typeof getStreamsGroupLinkerOptions>>, TError,void, TContext> => {

const mutationKey = ['getStreamsGroupLinkerOptions'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof getStreamsGroupLinkerOptions>>, void> = () => {


          return  getStreamsGroupLinkerOptions(requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type GetStreamsGroupLinkerOptionsMutationResult = NonNullable<Awaited<ReturnType<typeof getStreamsGroupLinkerOptions>>>

    export type GetStreamsGroupLinkerOptionsMutationError = RequestTimeoutResponse | InternalServerErrorResponse | ResponseTimeoutResponse | ServerTimeoutErrorResponse

    /**
 * @summary linker options
 */
export const useGetStreamsGroupLinkerOptions = <TError = RequestTimeoutResponse | InternalServerErrorResponse | ResponseTimeoutResponse | ServerTimeoutErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof getStreamsGroupLinkerOptions>>, TError,void, TContext>, request?: SecondParameter<typeof lp5AxiosClient>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof getStreamsGroupLinkerOptions>>,
        TError,
        void,
        TContext
      > => {
      return useMutation(getGetStreamsGroupLinkerOptionsMutationOptions(options), queryClient);
    }

/**
 * Create group.
 * @summary create group
 */
export const createGroup = (
    createGroup: CreateGroup,
 options?: SecondParameter<typeof lp5AxiosClient>,signal?: AbortSignal
) => {


      return lp5AxiosClient<CreateGroupResponse>(
      {url: `/6/groups`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: createGroup, signal
    },
      options);
    }




export const getCreateGroupMutationOptions = <TError = Error | ForbiddenErrorResponse | RequestTimeoutResponse | PayloadToLargeResponse | InternalServerErrorResponse | ResponseTimeoutResponse | ServerTimeoutErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createGroup>>, TError,{data: CreateGroup}, TContext>, request?: SecondParameter<typeof lp5AxiosClient>}
): UseMutationOptions<Awaited<ReturnType<typeof createGroup>>, TError,{data: CreateGroup}, TContext> => {

const mutationKey = ['createGroup'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof createGroup>>, {data: CreateGroup}> = (props) => {
          const {data} = props ?? {};

          return  createGroup(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type CreateGroupMutationResult = NonNullable<Awaited<ReturnType<typeof createGroup>>>
    export type CreateGroupMutationBody = CreateGroup
    export type CreateGroupMutationError = Error | ForbiddenErrorResponse | RequestTimeoutResponse | PayloadToLargeResponse | InternalServerErrorResponse | ResponseTimeoutResponse | ServerTimeoutErrorResponse

    /**
 * @summary create group
 */
export const useCreateGroup = <TError = Error | ForbiddenErrorResponse | RequestTimeoutResponse | PayloadToLargeResponse | InternalServerErrorResponse | ResponseTimeoutResponse | ServerTimeoutErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createGroup>>, TError,{data: CreateGroup}, TContext>, request?: SecondParameter<typeof lp5AxiosClient>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof createGroup>>,
        TError,
        {data: CreateGroup},
        TContext
      > => {
      return useMutation(getCreateGroupMutationOptions(options), queryClient);
    }

/**
 * Get groups according to filters. The results are sorted by group creation order, the oldest group shown first.
 * @summary get groups
 */
export const getGroups = (
    params?: GetGroupsParams,
 options?: SecondParameter<typeof lp5AxiosClient>,signal?: AbortSignal
) => {


      return lp5AxiosClient<GetGroups200>(
      {url: `/6/groups`, method: 'GET',
        params, signal
    },
      options);
    }




export const getGetGroupsQueryKey = (params?: GetGroupsParams,) => {
    return [
    `/6/groups`, ...(params ? [params] : [])
    ] as const;
    }


export const getGetGroupsQueryOptions = <TData = Awaited<ReturnType<typeof getGroups>>, TError = Error | ForbiddenErrorResponse | RequestTimeoutResponse | InternalServerErrorResponse | ResponseTimeoutResponse | ServerTimeoutErrorResponse>(params?: GetGroupsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getGroups>>, TError, TData>>, request?: SecondParameter<typeof lp5AxiosClient>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetGroupsQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getGroups>>> = ({ signal }) => getGroups(params, requestOptions, signal);





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getGroups>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetGroupsQueryResult = NonNullable<Awaited<ReturnType<typeof getGroups>>>
export type GetGroupsQueryError = Error | ForbiddenErrorResponse | RequestTimeoutResponse | InternalServerErrorResponse | ResponseTimeoutResponse | ServerTimeoutErrorResponse


export function useGetGroups<TData = Awaited<ReturnType<typeof getGroups>>, TError = Error | ForbiddenErrorResponse | RequestTimeoutResponse | InternalServerErrorResponse | ResponseTimeoutResponse | ServerTimeoutErrorResponse>(
 params: undefined |  GetGroupsParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getGroups>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getGroups>>,
          TError,
          Awaited<ReturnType<typeof getGroups>>
        > , 'initialData'
      >, request?: SecondParameter<typeof lp5AxiosClient>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetGroups<TData = Awaited<ReturnType<typeof getGroups>>, TError = Error | ForbiddenErrorResponse | RequestTimeoutResponse | InternalServerErrorResponse | ResponseTimeoutResponse | ServerTimeoutErrorResponse>(
 params?: GetGroupsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getGroups>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getGroups>>,
          TError,
          Awaited<ReturnType<typeof getGroups>>
        > , 'initialData'
      >, request?: SecondParameter<typeof lp5AxiosClient>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetGroups<TData = Awaited<ReturnType<typeof getGroups>>, TError = Error | ForbiddenErrorResponse | RequestTimeoutResponse | InternalServerErrorResponse | ResponseTimeoutResponse | ServerTimeoutErrorResponse>(
 params?: GetGroupsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getGroups>>, TError, TData>>, request?: SecondParameter<typeof lp5AxiosClient>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary get groups
 */

export function useGetGroups<TData = Awaited<ReturnType<typeof getGroups>>, TError = Error | ForbiddenErrorResponse | RequestTimeoutResponse | InternalServerErrorResponse | ResponseTimeoutResponse | ServerTimeoutErrorResponse>(
 params?: GetGroupsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getGroups>>, TError, TData>>, request?: SecondParameter<typeof lp5AxiosClient>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetGroupsQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}







/**
 * Get options for the resource.
 * @summary groups options
 */
export const getGroupsOptions = (

 options?: SecondParameter<typeof lp5AxiosClient>,signal?: AbortSignal
) => {


      return lp5AxiosClient<void>(
      {url: `/6/groups`, method: 'OPTIONS', signal
    },
      options);
    }




export const getGetGroupsOptionsMutationOptions = <TError = RequestTimeoutResponse | InternalServerErrorResponse | ResponseTimeoutResponse | ServerTimeoutErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof getGroupsOptions>>, TError,void, TContext>, request?: SecondParameter<typeof lp5AxiosClient>}
): UseMutationOptions<Awaited<ReturnType<typeof getGroupsOptions>>, TError,void, TContext> => {

const mutationKey = ['getGroupsOptions'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof getGroupsOptions>>, void> = () => {


          return  getGroupsOptions(requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type GetGroupsOptionsMutationResult = NonNullable<Awaited<ReturnType<typeof getGroupsOptions>>>

    export type GetGroupsOptionsMutationError = RequestTimeoutResponse | InternalServerErrorResponse | ResponseTimeoutResponse | ServerTimeoutErrorResponse

    /**
 * @summary groups options
 */
export const useGetGroupsOptions = <TError = RequestTimeoutResponse | InternalServerErrorResponse | ResponseTimeoutResponse | ServerTimeoutErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof getGroupsOptions>>, TError,void, TContext>, request?: SecondParameter<typeof lp5AxiosClient>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof getGroupsOptions>>,
        TError,
        void,
        TContext
      > => {
      return useMutation(getGetGroupsOptionsMutationOptions(options), queryClient);
    }

/**
 * Count of groups according to the filters.
 * @summary get group count
 */
export const countGroups = (
    params?: CountGroupsParams,
 options?: SecondParameter<typeof lp5AxiosClient>,signal?: AbortSignal
) => {


      return lp5AxiosClient<GroupsCount>(
      {url: `/6/groups/count`, method: 'GET',
        params, signal
    },
      options);
    }




export const getCountGroupsQueryKey = (params?: CountGroupsParams,) => {
    return [
    `/6/groups/count`, ...(params ? [params] : [])
    ] as const;
    }


export const getCountGroupsQueryOptions = <TData = Awaited<ReturnType<typeof countGroups>>, TError = Error | ForbiddenErrorResponse | RequestTimeoutResponse | InternalServerErrorResponse | ResponseTimeoutResponse | ServerTimeoutErrorResponse>(params?: CountGroupsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof countGroups>>, TError, TData>>, request?: SecondParameter<typeof lp5AxiosClient>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getCountGroupsQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof countGroups>>> = ({ signal }) => countGroups(params, requestOptions, signal);





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof countGroups>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type CountGroupsQueryResult = NonNullable<Awaited<ReturnType<typeof countGroups>>>
export type CountGroupsQueryError = Error | ForbiddenErrorResponse | RequestTimeoutResponse | InternalServerErrorResponse | ResponseTimeoutResponse | ServerTimeoutErrorResponse


export function useCountGroups<TData = Awaited<ReturnType<typeof countGroups>>, TError = Error | ForbiddenErrorResponse | RequestTimeoutResponse | InternalServerErrorResponse | ResponseTimeoutResponse | ServerTimeoutErrorResponse>(
 params: undefined |  CountGroupsParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof countGroups>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof countGroups>>,
          TError,
          Awaited<ReturnType<typeof countGroups>>
        > , 'initialData'
      >, request?: SecondParameter<typeof lp5AxiosClient>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useCountGroups<TData = Awaited<ReturnType<typeof countGroups>>, TError = Error | ForbiddenErrorResponse | RequestTimeoutResponse | InternalServerErrorResponse | ResponseTimeoutResponse | ServerTimeoutErrorResponse>(
 params?: CountGroupsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof countGroups>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof countGroups>>,
          TError,
          Awaited<ReturnType<typeof countGroups>>
        > , 'initialData'
      >, request?: SecondParameter<typeof lp5AxiosClient>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useCountGroups<TData = Awaited<ReturnType<typeof countGroups>>, TError = Error | ForbiddenErrorResponse | RequestTimeoutResponse | InternalServerErrorResponse | ResponseTimeoutResponse | ServerTimeoutErrorResponse>(
 params?: CountGroupsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof countGroups>>, TError, TData>>, request?: SecondParameter<typeof lp5AxiosClient>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary get group count
 */

export function useCountGroups<TData = Awaited<ReturnType<typeof countGroups>>, TError = Error | ForbiddenErrorResponse | RequestTimeoutResponse | InternalServerErrorResponse | ResponseTimeoutResponse | ServerTimeoutErrorResponse>(
 params?: CountGroupsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof countGroups>>, TError, TData>>, request?: SecondParameter<typeof lp5AxiosClient>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getCountGroupsQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}







/**
 * Get options for the resource.
 * @summary groups count options
 */
export const getGroupsCountOptions = (

 options?: SecondParameter<typeof lp5AxiosClient>,signal?: AbortSignal
) => {


      return lp5AxiosClient<void>(
      {url: `/6/groups/count`, method: 'OPTIONS', signal
    },
      options);
    }




export const getGetGroupsCountOptionsMutationOptions = <TError = RequestTimeoutResponse | InternalServerErrorResponse | ResponseTimeoutResponse | ServerTimeoutErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof getGroupsCountOptions>>, TError,void, TContext>, request?: SecondParameter<typeof lp5AxiosClient>}
): UseMutationOptions<Awaited<ReturnType<typeof getGroupsCountOptions>>, TError,void, TContext> => {

const mutationKey = ['getGroupsCountOptions'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof getGroupsCountOptions>>, void> = () => {


          return  getGroupsCountOptions(requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type GetGroupsCountOptionsMutationResult = NonNullable<Awaited<ReturnType<typeof getGroupsCountOptions>>>

    export type GetGroupsCountOptionsMutationError = RequestTimeoutResponse | InternalServerErrorResponse | ResponseTimeoutResponse | ServerTimeoutErrorResponse

    /**
 * @summary groups count options
 */
export const useGetGroupsCountOptions = <TError = RequestTimeoutResponse | InternalServerErrorResponse | ResponseTimeoutResponse | ServerTimeoutErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof getGroupsCountOptions>>, TError,void, TContext>, request?: SecondParameter<typeof lp5AxiosClient>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof getGroupsCountOptions>>,
        TError,
        void,
        TContext
      > => {
      return useMutation(getGetGroupsCountOptionsMutationOptions(options), queryClient);
    }

/**
 * Get the group by name.
 * @summary get group
 */
export const getGroup = (
    groupId: Uuid,
    params?: GetGroupParams,
 options?: SecondParameter<typeof lp5AxiosClient>,signal?: AbortSignal
) => {


      return lp5AxiosClient<GroupResponse>(
      {url: `/6/groups/${groupId}`, method: 'GET',
        params, signal
    },
      options);
    }




export const getGetGroupQueryKey = (groupId: Uuid,
    params?: GetGroupParams,) => {
    return [
    `/6/groups/${groupId}`, ...(params ? [params] : [])
    ] as const;
    }


export const getGetGroupQueryOptions = <TData = Awaited<ReturnType<typeof getGroup>>, TError = Error | ForbiddenErrorResponse | RequestTimeoutResponse | InternalServerErrorResponse | ResponseTimeoutResponse | ServerTimeoutErrorResponse>(groupId: Uuid,
    params?: GetGroupParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getGroup>>, TError, TData>>, request?: SecondParameter<typeof lp5AxiosClient>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetGroupQueryKey(groupId,params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getGroup>>> = ({ signal }) => getGroup(groupId,params, requestOptions, signal);





   return  { queryKey, queryFn, enabled: groupId !== null && groupId !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getGroup>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetGroupQueryResult = NonNullable<Awaited<ReturnType<typeof getGroup>>>
export type GetGroupQueryError = Error | ForbiddenErrorResponse | RequestTimeoutResponse | InternalServerErrorResponse | ResponseTimeoutResponse | ServerTimeoutErrorResponse


export function useGetGroup<TData = Awaited<ReturnType<typeof getGroup>>, TError = Error | ForbiddenErrorResponse | RequestTimeoutResponse | InternalServerErrorResponse | ResponseTimeoutResponse | ServerTimeoutErrorResponse>(
 groupId: Uuid,
    params: undefined |  GetGroupParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getGroup>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getGroup>>,
          TError,
          Awaited<ReturnType<typeof getGroup>>
        > , 'initialData'
      >, request?: SecondParameter<typeof lp5AxiosClient>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetGroup<TData = Awaited<ReturnType<typeof getGroup>>, TError = Error | ForbiddenErrorResponse | RequestTimeoutResponse | InternalServerErrorResponse | ResponseTimeoutResponse | ServerTimeoutErrorResponse>(
 groupId: Uuid,
    params?: GetGroupParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getGroup>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getGroup>>,
          TError,
          Awaited<ReturnType<typeof getGroup>>
        > , 'initialData'
      >, request?: SecondParameter<typeof lp5AxiosClient>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetGroup<TData = Awaited<ReturnType<typeof getGroup>>, TError = Error | ForbiddenErrorResponse | RequestTimeoutResponse | InternalServerErrorResponse | ResponseTimeoutResponse | ServerTimeoutErrorResponse>(
 groupId: Uuid,
    params?: GetGroupParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getGroup>>, TError, TData>>, request?: SecondParameter<typeof lp5AxiosClient>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary get group
 */

export function useGetGroup<TData = Awaited<ReturnType<typeof getGroup>>, TError = Error | ForbiddenErrorResponse | RequestTimeoutResponse | InternalServerErrorResponse | ResponseTimeoutResponse | ServerTimeoutErrorResponse>(
 groupId: Uuid,
    params?: GetGroupParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getGroup>>, TError, TData>>, request?: SecondParameter<typeof lp5AxiosClient>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetGroupQueryOptions(groupId,params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}







/**
 * Update group fields: *description*
 * @summary update group
 */
export const patchGroup = (
    groupId: Uuid,
    updateGroup: UpdateGroup,
    params?: PatchGroupParams,
 options?: SecondParameter<typeof lp5AxiosClient>,signal?: AbortSignal
) => {


      return lp5AxiosClient<void>(
      {url: `/6/groups/${groupId}`, method: 'PATCH',
      headers: {'Content-Type': 'application/json', },
      data: updateGroup,
        params, signal
    },
      options);
    }




export const getPatchGroupMutationOptions = <TError = Error | ForbiddenErrorResponse | RequestTimeoutResponse | PayloadToLargeResponse | InternalServerErrorResponse | ResponseTimeoutResponse | ServerTimeoutErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof patchGroup>>, TError,{groupId: Uuid;data: UpdateGroup;params?: PatchGroupParams}, TContext>, request?: SecondParameter<typeof lp5AxiosClient>}
): UseMutationOptions<Awaited<ReturnType<typeof patchGroup>>, TError,{groupId: Uuid;data: UpdateGroup;params?: PatchGroupParams}, TContext> => {

const mutationKey = ['patchGroup'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof patchGroup>>, {groupId: Uuid;data: UpdateGroup;params?: PatchGroupParams}> = (props) => {
          const {groupId,data,params} = props ?? {};

          return  patchGroup(groupId,data,params,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type PatchGroupMutationResult = NonNullable<Awaited<ReturnType<typeof patchGroup>>>
    export type PatchGroupMutationBody = UpdateGroup
    export type PatchGroupMutationError = Error | ForbiddenErrorResponse | RequestTimeoutResponse | PayloadToLargeResponse | InternalServerErrorResponse | ResponseTimeoutResponse | ServerTimeoutErrorResponse

    /**
 * @summary update group
 */
export const usePatchGroup = <TError = Error | ForbiddenErrorResponse | RequestTimeoutResponse | PayloadToLargeResponse | InternalServerErrorResponse | ResponseTimeoutResponse | ServerTimeoutErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof patchGroup>>, TError,{groupId: Uuid;data: UpdateGroup;params?: PatchGroupParams}, TContext>, request?: SecondParameter<typeof lp5AxiosClient>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof patchGroup>>,
        TError,
        {groupId: Uuid;data: UpdateGroup;params?: PatchGroupParams},
        TContext
      > => {
      return useMutation(getPatchGroupMutationOptions(options), queryClient);
    }

/**
 * Remove the group by name.
 * @summary remove group
 */
export const deleteGroup = (
    groupId: Uuid,
    params?: DeleteGroupParams,
 options?: SecondParameter<typeof lp5AxiosClient>,signal?: AbortSignal
) => {


      return lp5AxiosClient<void>(
      {url: `/6/groups/${groupId}`, method: 'DELETE',
        params, signal
    },
      options);
    }




export const getDeleteGroupMutationOptions = <TError = Error | ForbiddenErrorResponse | RequestTimeoutResponse | InternalServerErrorResponse | ResponseTimeoutResponse | ServerTimeoutErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteGroup>>, TError,{groupId: Uuid;params?: DeleteGroupParams}, TContext>, request?: SecondParameter<typeof lp5AxiosClient>}
): UseMutationOptions<Awaited<ReturnType<typeof deleteGroup>>, TError,{groupId: Uuid;params?: DeleteGroupParams}, TContext> => {

const mutationKey = ['deleteGroup'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof deleteGroup>>, {groupId: Uuid;params?: DeleteGroupParams}> = (props) => {
          const {groupId,params} = props ?? {};

          return  deleteGroup(groupId,params,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type DeleteGroupMutationResult = NonNullable<Awaited<ReturnType<typeof deleteGroup>>>

    export type DeleteGroupMutationError = Error | ForbiddenErrorResponse | RequestTimeoutResponse | InternalServerErrorResponse | ResponseTimeoutResponse | ServerTimeoutErrorResponse

    /**
 * @summary remove group
 */
export const useDeleteGroup = <TError = Error | ForbiddenErrorResponse | RequestTimeoutResponse | InternalServerErrorResponse | ResponseTimeoutResponse | ServerTimeoutErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteGroup>>, TError,{groupId: Uuid;params?: DeleteGroupParams}, TContext>, request?: SecondParameter<typeof lp5AxiosClient>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof deleteGroup>>,
        TError,
        {groupId: Uuid;params?: DeleteGroupParams},
        TContext
      > => {
      return useMutation(getDeleteGroupMutationOptions(options), queryClient);
    }

/**
 * Get options for the resource.
 * @summary group options
 */
export const getGroupOptions = (
    groupId: Uuid,
    params?: GetGroupOptionsParams,
 options?: SecondParameter<typeof lp5AxiosClient>,signal?: AbortSignal
) => {


      return lp5AxiosClient<void>(
      {url: `/6/groups/${groupId}`, method: 'OPTIONS',
        params, signal
    },
      options);
    }




export const getGetGroupOptionsMutationOptions = <TError = RequestTimeoutResponse | InternalServerErrorResponse | ResponseTimeoutResponse | ServerTimeoutErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof getGroupOptions>>, TError,{groupId: Uuid;params?: GetGroupOptionsParams}, TContext>, request?: SecondParameter<typeof lp5AxiosClient>}
): UseMutationOptions<Awaited<ReturnType<typeof getGroupOptions>>, TError,{groupId: Uuid;params?: GetGroupOptionsParams}, TContext> => {

const mutationKey = ['getGroupOptions'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof getGroupOptions>>, {groupId: Uuid;params?: GetGroupOptionsParams}> = (props) => {
          const {groupId,params} = props ?? {};

          return  getGroupOptions(groupId,params,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type GetGroupOptionsMutationResult = NonNullable<Awaited<ReturnType<typeof getGroupOptions>>>

    export type GetGroupOptionsMutationError = RequestTimeoutResponse | InternalServerErrorResponse | ResponseTimeoutResponse | ServerTimeoutErrorResponse

    /**
 * @summary group options
 */
export const useGetGroupOptions = <TError = RequestTimeoutResponse | InternalServerErrorResponse | ResponseTimeoutResponse | ServerTimeoutErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof getGroupOptions>>, TError,{groupId: Uuid;params?: GetGroupOptionsParams}, TContext>, request?: SecondParameter<typeof lp5AxiosClient>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof getGroupOptions>>,
        TError,
        {groupId: Uuid;params?: GetGroupOptionsParams},
        TContext
      > => {
      return useMutation(getGetGroupOptionsMutationOptions(options), queryClient);
    }

/**
 * Update existing or create new group.
 * @summary put group
 */
export const putGroup = (
    groupId: Uuid,
    createGroup: CreateGroup,
    params?: PutGroupParams,
 options?: SecondParameter<typeof lp5AxiosClient>,signal?: AbortSignal
) => {


      return lp5AxiosClient<ReplaceGroupResponse>(
      {url: `/6/groups/${groupId}`, method: 'PUT',
      headers: {'Content-Type': 'application/json', },
      data: createGroup,
        params, signal
    },
      options);
    }




export const getPutGroupMutationOptions = <TError = Error | ForbiddenErrorResponse | RequestTimeoutResponse | PayloadToLargeResponse | InternalServerErrorResponse | ResponseTimeoutResponse | ServerTimeoutErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof putGroup>>, TError,{groupId: Uuid;data: CreateGroup;params?: PutGroupParams}, TContext>, request?: SecondParameter<typeof lp5AxiosClient>}
): UseMutationOptions<Awaited<ReturnType<typeof putGroup>>, TError,{groupId: Uuid;data: CreateGroup;params?: PutGroupParams}, TContext> => {

const mutationKey = ['putGroup'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof putGroup>>, {groupId: Uuid;data: CreateGroup;params?: PutGroupParams}> = (props) => {
          const {groupId,data,params} = props ?? {};

          return  putGroup(groupId,data,params,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type PutGroupMutationResult = NonNullable<Awaited<ReturnType<typeof putGroup>>>
    export type PutGroupMutationBody = CreateGroup
    export type PutGroupMutationError = Error | ForbiddenErrorResponse | RequestTimeoutResponse | PayloadToLargeResponse | InternalServerErrorResponse | ResponseTimeoutResponse | ServerTimeoutErrorResponse

    /**
 * @summary put group
 */
export const usePutGroup = <TError = Error | ForbiddenErrorResponse | RequestTimeoutResponse | PayloadToLargeResponse | InternalServerErrorResponse | ResponseTimeoutResponse | ServerTimeoutErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof putGroup>>, TError,{groupId: Uuid;data: CreateGroup;params?: PutGroupParams}, TContext>, request?: SecondParameter<typeof lp5AxiosClient>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof putGroup>>,
        TError,
        {groupId: Uuid;data: CreateGroup;params?: PutGroupParams},
        TContext
      > => {
      return useMutation(getPutGroupMutationOptions(options), queryClient);
    }

/**
 * Pause/unpause all streams in a group.
 *
 * The operation will be applied to all streams that can be switched to a different state, if at least one stream can be modified.
 *
 * If no streams can be changed, an `Unable to patch streams` error will be returned.
 * @summary patch streams in group
 */
export const patchGroupStreams = (
    groupId: Uuid,
    params: PatchGroupStreamsParams,
 options?: SecondParameter<typeof lp5AxiosClient>,signal?: AbortSignal
) => {


      return lp5AxiosClient<PatchGroupStreams200>(
      {url: `/6/groups/${groupId}/streams`, method: 'PATCH',
        params, signal
    },
      options);
    }




export const getPatchGroupStreamsMutationOptions = <TError = Error | ForbiddenErrorResponse | RequestTimeoutResponse | InternalServerErrorResponse | ResponseTimeoutResponse | ServerTimeoutErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof patchGroupStreams>>, TError,{groupId: Uuid;params: PatchGroupStreamsParams}, TContext>, request?: SecondParameter<typeof lp5AxiosClient>}
): UseMutationOptions<Awaited<ReturnType<typeof patchGroupStreams>>, TError,{groupId: Uuid;params: PatchGroupStreamsParams}, TContext> => {

const mutationKey = ['patchGroupStreams'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof patchGroupStreams>>, {groupId: Uuid;params: PatchGroupStreamsParams}> = (props) => {
          const {groupId,params} = props ?? {};

          return  patchGroupStreams(groupId,params,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type PatchGroupStreamsMutationResult = NonNullable<Awaited<ReturnType<typeof patchGroupStreams>>>

    export type PatchGroupStreamsMutationError = Error | ForbiddenErrorResponse | RequestTimeoutResponse | InternalServerErrorResponse | ResponseTimeoutResponse | ServerTimeoutErrorResponse

    /**
 * @summary patch streams in group
 */
export const usePatchGroupStreams = <TError = Error | ForbiddenErrorResponse | RequestTimeoutResponse | InternalServerErrorResponse | ResponseTimeoutResponse | ServerTimeoutErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof patchGroupStreams>>, TError,{groupId: Uuid;params: PatchGroupStreamsParams}, TContext>, request?: SecondParameter<typeof lp5AxiosClient>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof patchGroupStreams>>,
        TError,
        {groupId: Uuid;params: PatchGroupStreamsParams},
        TContext
      > => {
      return useMutation(getPatchGroupStreamsMutationOptions(options), queryClient);
    }

/**
 * Remove all streams in the group without removing the group itself.
 * @summary remove all streams in the group
 */
export const removeGroupStreams = (
    groupId: Uuid,
    params?: RemoveGroupStreamsParams,
 options?: SecondParameter<typeof lp5AxiosClient>,signal?: AbortSignal
) => {


      return lp5AxiosClient<void>(
      {url: `/6/groups/${groupId}/streams`, method: 'DELETE',
        params, signal
    },
      options);
    }




export const getRemoveGroupStreamsMutationOptions = <TError = Error | ForbiddenErrorResponse | RequestTimeoutResponse | InternalServerErrorResponse | ResponseTimeoutResponse | ServerTimeoutErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof removeGroupStreams>>, TError,{groupId: Uuid;params?: RemoveGroupStreamsParams}, TContext>, request?: SecondParameter<typeof lp5AxiosClient>}
): UseMutationOptions<Awaited<ReturnType<typeof removeGroupStreams>>, TError,{groupId: Uuid;params?: RemoveGroupStreamsParams}, TContext> => {

const mutationKey = ['removeGroupStreams'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof removeGroupStreams>>, {groupId: Uuid;params?: RemoveGroupStreamsParams}> = (props) => {
          const {groupId,params} = props ?? {};

          return  removeGroupStreams(groupId,params,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type RemoveGroupStreamsMutationResult = NonNullable<Awaited<ReturnType<typeof removeGroupStreams>>>

    export type RemoveGroupStreamsMutationError = Error | ForbiddenErrorResponse | RequestTimeoutResponse | InternalServerErrorResponse | ResponseTimeoutResponse | ServerTimeoutErrorResponse

    /**
 * @summary remove all streams in the group
 */
export const useRemoveGroupStreams = <TError = Error | ForbiddenErrorResponse | RequestTimeoutResponse | InternalServerErrorResponse | ResponseTimeoutResponse | ServerTimeoutErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof removeGroupStreams>>, TError,{groupId: Uuid;params?: RemoveGroupStreamsParams}, TContext>, request?: SecondParameter<typeof lp5AxiosClient>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof removeGroupStreams>>,
        TError,
        {groupId: Uuid;params?: RemoveGroupStreamsParams},
        TContext
      > => {
      return useMutation(getRemoveGroupStreamsMutationOptions(options), queryClient);
    }

/**
 * Get options for the resource.
 * @summary group's streams options
 */
export const getGroupStreamsOptions = (
    groupId: Uuid,
    params?: GetGroupStreamsOptionsParams,
 options?: SecondParameter<typeof lp5AxiosClient>,signal?: AbortSignal
) => {


      return lp5AxiosClient<void>(
      {url: `/6/groups/${groupId}/streams`, method: 'OPTIONS',
        params, signal
    },
      options);
    }




export const getGetGroupStreamsOptionsMutationOptions = <TError = RequestTimeoutResponse | InternalServerErrorResponse | ResponseTimeoutResponse | ServerTimeoutErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof getGroupStreamsOptions>>, TError,{groupId: Uuid;params?: GetGroupStreamsOptionsParams}, TContext>, request?: SecondParameter<typeof lp5AxiosClient>}
): UseMutationOptions<Awaited<ReturnType<typeof getGroupStreamsOptions>>, TError,{groupId: Uuid;params?: GetGroupStreamsOptionsParams}, TContext> => {

const mutationKey = ['getGroupStreamsOptions'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof getGroupStreamsOptions>>, {groupId: Uuid;params?: GetGroupStreamsOptionsParams}> = (props) => {
          const {groupId,params} = props ?? {};

          return  getGroupStreamsOptions(groupId,params,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type GetGroupStreamsOptionsMutationResult = NonNullable<Awaited<ReturnType<typeof getGroupStreamsOptions>>>

    export type GetGroupStreamsOptionsMutationError = RequestTimeoutResponse | InternalServerErrorResponse | ResponseTimeoutResponse | ServerTimeoutErrorResponse

    /**
 * @summary group's streams options
 */
export const useGetGroupStreamsOptions = <TError = RequestTimeoutResponse | InternalServerErrorResponse | ResponseTimeoutResponse | ServerTimeoutErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof getGroupStreamsOptions>>, TError,{groupId: Uuid;params?: GetGroupStreamsOptionsParams}, TContext>, request?: SecondParameter<typeof lp5AxiosClient>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof getGroupStreamsOptions>>,
        TError,
        {groupId: Uuid;params?: GetGroupStreamsOptionsParams},
        TContext
      > => {
      return useMutation(getGetGroupStreamsOptionsMutationOptions(options), queryClient);
    }

/**
 * **Warning: only for service use**
 *
 * Create analytic.
 * @summary create analytic
 */
export const createAnalytic = (
    analyticToBeCreated: AnalyticToBeCreated,
 options?: SecondParameter<typeof lp5AxiosClient>,signal?: AbortSignal
) => {


      return lp5AxiosClient<CreateAnalytic201>(
      {url: `/6/analytics`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: analyticToBeCreated, signal
    },
      options);
    }




export const getCreateAnalyticMutationOptions = <TError = Error | AuthorizationErrorResponse | ForbiddenErrorResponse | AgentNotFoundResponse | RequestTimeoutResponse | PayloadToLargeResponse | InternalServerErrorResponse | ResponseTimeoutResponse | ServerTimeoutErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createAnalytic>>, TError,{data: AnalyticToBeCreated}, TContext>, request?: SecondParameter<typeof lp5AxiosClient>}
): UseMutationOptions<Awaited<ReturnType<typeof createAnalytic>>, TError,{data: AnalyticToBeCreated}, TContext> => {

const mutationKey = ['createAnalytic'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof createAnalytic>>, {data: AnalyticToBeCreated}> = (props) => {
          const {data} = props ?? {};

          return  createAnalytic(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type CreateAnalyticMutationResult = NonNullable<Awaited<ReturnType<typeof createAnalytic>>>
    export type CreateAnalyticMutationBody = AnalyticToBeCreated
    export type CreateAnalyticMutationError = Error | AuthorizationErrorResponse | ForbiddenErrorResponse | AgentNotFoundResponse | RequestTimeoutResponse | PayloadToLargeResponse | InternalServerErrorResponse | ResponseTimeoutResponse | ServerTimeoutErrorResponse

    /**
 * @summary create analytic
 */
export const useCreateAnalytic = <TError = Error | AuthorizationErrorResponse | ForbiddenErrorResponse | AgentNotFoundResponse | RequestTimeoutResponse | PayloadToLargeResponse | InternalServerErrorResponse | ResponseTimeoutResponse | ServerTimeoutErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createAnalytic>>, TError,{data: AnalyticToBeCreated}, TContext>, request?: SecondParameter<typeof lp5AxiosClient>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof createAnalytic>>,
        TError,
        {data: AnalyticToBeCreated},
        TContext
      > => {
      return useMutation(getCreateAnalyticMutationOptions(options), queryClient);
    }

/**
 * Get analytics according to filters. The results are sorted by analytic creation order, the oldest analytics shown first.
 * @summary get analytics
 */
export const getAnalytics = (
    params?: GetAnalyticsParams,
 options?: SecondParameter<typeof lp5AxiosClient>,signal?: AbortSignal
) => {


      return lp5AxiosClient<GetAnalytics200>(
      {url: `/6/analytics`, method: 'GET',
        params, signal
    },
      options);
    }




export const getGetAnalyticsQueryKey = (params?: GetAnalyticsParams,) => {
    return [
    `/6/analytics`, ...(params ? [params] : [])
    ] as const;
    }


export const getGetAnalyticsQueryOptions = <TData = Awaited<ReturnType<typeof getAnalytics>>, TError = Error | ForbiddenErrorResponse | RequestTimeoutResponse | InternalServerErrorResponse | ResponseTimeoutResponse | ServerTimeoutErrorResponse>(params?: GetAnalyticsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAnalytics>>, TError, TData>>, request?: SecondParameter<typeof lp5AxiosClient>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetAnalyticsQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getAnalytics>>> = ({ signal }) => getAnalytics(params, requestOptions, signal);





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getAnalytics>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetAnalyticsQueryResult = NonNullable<Awaited<ReturnType<typeof getAnalytics>>>
export type GetAnalyticsQueryError = Error | ForbiddenErrorResponse | RequestTimeoutResponse | InternalServerErrorResponse | ResponseTimeoutResponse | ServerTimeoutErrorResponse


export function useGetAnalytics<TData = Awaited<ReturnType<typeof getAnalytics>>, TError = Error | ForbiddenErrorResponse | RequestTimeoutResponse | InternalServerErrorResponse | ResponseTimeoutResponse | ServerTimeoutErrorResponse>(
 params: undefined |  GetAnalyticsParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAnalytics>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getAnalytics>>,
          TError,
          Awaited<ReturnType<typeof getAnalytics>>
        > , 'initialData'
      >, request?: SecondParameter<typeof lp5AxiosClient>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetAnalytics<TData = Awaited<ReturnType<typeof getAnalytics>>, TError = Error | ForbiddenErrorResponse | RequestTimeoutResponse | InternalServerErrorResponse | ResponseTimeoutResponse | ServerTimeoutErrorResponse>(
 params?: GetAnalyticsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAnalytics>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getAnalytics>>,
          TError,
          Awaited<ReturnType<typeof getAnalytics>>
        > , 'initialData'
      >, request?: SecondParameter<typeof lp5AxiosClient>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetAnalytics<TData = Awaited<ReturnType<typeof getAnalytics>>, TError = Error | ForbiddenErrorResponse | RequestTimeoutResponse | InternalServerErrorResponse | ResponseTimeoutResponse | ServerTimeoutErrorResponse>(
 params?: GetAnalyticsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAnalytics>>, TError, TData>>, request?: SecondParameter<typeof lp5AxiosClient>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary get analytics
 */

export function useGetAnalytics<TData = Awaited<ReturnType<typeof getAnalytics>>, TError = Error | ForbiddenErrorResponse | RequestTimeoutResponse | InternalServerErrorResponse | ResponseTimeoutResponse | ServerTimeoutErrorResponse>(
 params?: GetAnalyticsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAnalytics>>, TError, TData>>, request?: SecondParameter<typeof lp5AxiosClient>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetAnalyticsQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}







/**
 * Delete analytics matching specified filters.
 * @summary delete analytics
 */
export const deleteAnalytics = (
    analyticsToBeDeleted: AnalyticsToBeDeleted,
    params?: DeleteAnalyticsParams,
 options?: SecondParameter<typeof lp5AxiosClient>,signal?: AbortSignal
) => {


      return lp5AxiosClient<void>(
      {url: `/6/analytics`, method: 'DELETE',
      headers: {'Content-Type': 'application/json', },
      data: analyticsToBeDeleted,
        params, signal
    },
      options);
    }




export const getDeleteAnalyticsMutationOptions = <TError = Error | ForbiddenErrorResponse | RequestTimeoutResponse | PayloadToLargeResponse | InternalServerErrorResponse | ResponseTimeoutResponse | ServerTimeoutErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteAnalytics>>, TError,{data: AnalyticsToBeDeleted;params?: DeleteAnalyticsParams}, TContext>, request?: SecondParameter<typeof lp5AxiosClient>}
): UseMutationOptions<Awaited<ReturnType<typeof deleteAnalytics>>, TError,{data: AnalyticsToBeDeleted;params?: DeleteAnalyticsParams}, TContext> => {

const mutationKey = ['deleteAnalytics'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof deleteAnalytics>>, {data: AnalyticsToBeDeleted;params?: DeleteAnalyticsParams}> = (props) => {
          const {data,params} = props ?? {};

          return  deleteAnalytics(data,params,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type DeleteAnalyticsMutationResult = NonNullable<Awaited<ReturnType<typeof deleteAnalytics>>>
    export type DeleteAnalyticsMutationBody = AnalyticsToBeDeleted
    export type DeleteAnalyticsMutationError = Error | ForbiddenErrorResponse | RequestTimeoutResponse | PayloadToLargeResponse | InternalServerErrorResponse | ResponseTimeoutResponse | ServerTimeoutErrorResponse

    /**
 * @summary delete analytics
 */
export const useDeleteAnalytics = <TError = Error | ForbiddenErrorResponse | RequestTimeoutResponse | PayloadToLargeResponse | InternalServerErrorResponse | ResponseTimeoutResponse | ServerTimeoutErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteAnalytics>>, TError,{data: AnalyticsToBeDeleted;params?: DeleteAnalyticsParams}, TContext>, request?: SecondParameter<typeof lp5AxiosClient>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof deleteAnalytics>>,
        TError,
        {data: AnalyticsToBeDeleted;params?: DeleteAnalyticsParams},
        TContext
      > => {
      return useMutation(getDeleteAnalyticsMutationOptions(options), queryClient);
    }

/**
 * Get options for the resource.
 * @summary analytics options
 */
export const getAnalyticsOptions = (

 options?: SecondParameter<typeof lp5AxiosClient>,signal?: AbortSignal
) => {


      return lp5AxiosClient<void>(
      {url: `/6/analytics`, method: 'OPTIONS', signal
    },
      options);
    }




export const getGetAnalyticsOptionsMutationOptions = <TError = RequestTimeoutResponse | InternalServerErrorResponse | ResponseTimeoutResponse | ServerTimeoutErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof getAnalyticsOptions>>, TError,void, TContext>, request?: SecondParameter<typeof lp5AxiosClient>}
): UseMutationOptions<Awaited<ReturnType<typeof getAnalyticsOptions>>, TError,void, TContext> => {

const mutationKey = ['getAnalyticsOptions'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof getAnalyticsOptions>>, void> = () => {


          return  getAnalyticsOptions(requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type GetAnalyticsOptionsMutationResult = NonNullable<Awaited<ReturnType<typeof getAnalyticsOptions>>>

    export type GetAnalyticsOptionsMutationError = RequestTimeoutResponse | InternalServerErrorResponse | ResponseTimeoutResponse | ServerTimeoutErrorResponse

    /**
 * @summary analytics options
 */
export const useGetAnalyticsOptions = <TError = RequestTimeoutResponse | InternalServerErrorResponse | ResponseTimeoutResponse | ServerTimeoutErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof getAnalyticsOptions>>, TError,void, TContext>, request?: SecondParameter<typeof lp5AxiosClient>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof getAnalyticsOptions>>,
        TError,
        void,
        TContext
      > => {
      return useMutation(getGetAnalyticsOptionsMutationOptions(options), queryClient);
    }

/**
 * Get the analytic by ID.
 * @summary get analytic
 */
export const getAnalytic = (
    analyticId: Uuid,
    params?: GetAnalyticParams,
 options?: SecondParameter<typeof lp5AxiosClient>,signal?: AbortSignal
) => {


      return lp5AxiosClient<AnalyticResponse>(
      {url: `/6/analytics/${analyticId}`, method: 'GET',
        params, signal
    },
      options);
    }




export const getGetAnalyticQueryKey = (analyticId: Uuid,
    params?: GetAnalyticParams,) => {
    return [
    `/6/analytics/${analyticId}`, ...(params ? [params] : [])
    ] as const;
    }


export const getGetAnalyticQueryOptions = <TData = Awaited<ReturnType<typeof getAnalytic>>, TError = ForbiddenErrorResponse | AnalyticNotFoundResponse | RequestTimeoutResponse | InternalServerErrorResponse | ResponseTimeoutResponse | ServerTimeoutErrorResponse>(analyticId: Uuid,
    params?: GetAnalyticParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAnalytic>>, TError, TData>>, request?: SecondParameter<typeof lp5AxiosClient>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetAnalyticQueryKey(analyticId,params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getAnalytic>>> = ({ signal }) => getAnalytic(analyticId,params, requestOptions, signal);





   return  { queryKey, queryFn, enabled: analyticId !== null && analyticId !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getAnalytic>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetAnalyticQueryResult = NonNullable<Awaited<ReturnType<typeof getAnalytic>>>
export type GetAnalyticQueryError = ForbiddenErrorResponse | AnalyticNotFoundResponse | RequestTimeoutResponse | InternalServerErrorResponse | ResponseTimeoutResponse | ServerTimeoutErrorResponse


export function useGetAnalytic<TData = Awaited<ReturnType<typeof getAnalytic>>, TError = ForbiddenErrorResponse | AnalyticNotFoundResponse | RequestTimeoutResponse | InternalServerErrorResponse | ResponseTimeoutResponse | ServerTimeoutErrorResponse>(
 analyticId: Uuid,
    params: undefined |  GetAnalyticParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAnalytic>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getAnalytic>>,
          TError,
          Awaited<ReturnType<typeof getAnalytic>>
        > , 'initialData'
      >, request?: SecondParameter<typeof lp5AxiosClient>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetAnalytic<TData = Awaited<ReturnType<typeof getAnalytic>>, TError = ForbiddenErrorResponse | AnalyticNotFoundResponse | RequestTimeoutResponse | InternalServerErrorResponse | ResponseTimeoutResponse | ServerTimeoutErrorResponse>(
 analyticId: Uuid,
    params?: GetAnalyticParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAnalytic>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getAnalytic>>,
          TError,
          Awaited<ReturnType<typeof getAnalytic>>
        > , 'initialData'
      >, request?: SecondParameter<typeof lp5AxiosClient>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetAnalytic<TData = Awaited<ReturnType<typeof getAnalytic>>, TError = ForbiddenErrorResponse | AnalyticNotFoundResponse | RequestTimeoutResponse | InternalServerErrorResponse | ResponseTimeoutResponse | ServerTimeoutErrorResponse>(
 analyticId: Uuid,
    params?: GetAnalyticParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAnalytic>>, TError, TData>>, request?: SecondParameter<typeof lp5AxiosClient>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary get analytic
 */

export function useGetAnalytic<TData = Awaited<ReturnType<typeof getAnalytic>>, TError = ForbiddenErrorResponse | AnalyticNotFoundResponse | RequestTimeoutResponse | InternalServerErrorResponse | ResponseTimeoutResponse | ServerTimeoutErrorResponse>(
 analyticId: Uuid,
    params?: GetAnalyticParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAnalytic>>, TError, TData>>, request?: SecondParameter<typeof lp5AxiosClient>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetAnalyticQueryOptions(analyticId,params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}







/**
 * Get options for the resource.
 * @summary analytic options
 */
export const getAnalyticOptions = (
    analyticId: Uuid,
 options?: SecondParameter<typeof lp5AxiosClient>,signal?: AbortSignal
) => {


      return lp5AxiosClient<void>(
      {url: `/6/analytics/${analyticId}`, method: 'OPTIONS', signal
    },
      options);
    }




export const getGetAnalyticOptionsMutationOptions = <TError = RequestTimeoutResponse | InternalServerErrorResponse | ResponseTimeoutResponse | ServerTimeoutErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof getAnalyticOptions>>, TError,{analyticId: Uuid}, TContext>, request?: SecondParameter<typeof lp5AxiosClient>}
): UseMutationOptions<Awaited<ReturnType<typeof getAnalyticOptions>>, TError,{analyticId: Uuid}, TContext> => {

const mutationKey = ['getAnalyticOptions'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof getAnalyticOptions>>, {analyticId: Uuid}> = (props) => {
          const {analyticId} = props ?? {};

          return  getAnalyticOptions(analyticId,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type GetAnalyticOptionsMutationResult = NonNullable<Awaited<ReturnType<typeof getAnalyticOptions>>>

    export type GetAnalyticOptionsMutationError = RequestTimeoutResponse | InternalServerErrorResponse | ResponseTimeoutResponse | ServerTimeoutErrorResponse

    /**
 * @summary analytic options
 */
export const useGetAnalyticOptions = <TError = RequestTimeoutResponse | InternalServerErrorResponse | ResponseTimeoutResponse | ServerTimeoutErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof getAnalyticOptions>>, TError,{analyticId: Uuid}, TContext>, request?: SecondParameter<typeof lp5AxiosClient>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof getAnalyticOptions>>,
        TError,
        {analyticId: Uuid},
        TContext
      > => {
      return useMutation(getGetAnalyticOptionsMutationOptions(options), queryClient);
    }

/**
 * **Warning: only for service use**
 *
 * Update existing analytic. You should specify all the fields required for the stream in the request.
 * @summary put analytic
 */
export const putAnalytic = (
    analyticId: Uuid,
    analyticToBeCreated: AnalyticToBeCreated,
 options?: SecondParameter<typeof lp5AxiosClient>,signal?: AbortSignal
) => {


      return lp5AxiosClient<void>(
      {url: `/6/analytics/${analyticId}`, method: 'PUT',
      headers: {'Content-Type': 'application/json', },
      data: analyticToBeCreated, signal
    },
      options);
    }




export const getPutAnalyticMutationOptions = <TError = Error | AuthorizationErrorResponse | ForbiddenErrorResponse | AnalyticNotFoundResponse | RequestTimeoutResponse | PayloadToLargeResponse | InternalServerErrorResponse | ResponseTimeoutResponse | ServerTimeoutErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof putAnalytic>>, TError,{analyticId: Uuid;data: AnalyticToBeCreated}, TContext>, request?: SecondParameter<typeof lp5AxiosClient>}
): UseMutationOptions<Awaited<ReturnType<typeof putAnalytic>>, TError,{analyticId: Uuid;data: AnalyticToBeCreated}, TContext> => {

const mutationKey = ['putAnalytic'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof putAnalytic>>, {analyticId: Uuid;data: AnalyticToBeCreated}> = (props) => {
          const {analyticId,data} = props ?? {};

          return  putAnalytic(analyticId,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type PutAnalyticMutationResult = NonNullable<Awaited<ReturnType<typeof putAnalytic>>>
    export type PutAnalyticMutationBody = AnalyticToBeCreated
    export type PutAnalyticMutationError = Error | AuthorizationErrorResponse | ForbiddenErrorResponse | AnalyticNotFoundResponse | RequestTimeoutResponse | PayloadToLargeResponse | InternalServerErrorResponse | ResponseTimeoutResponse | ServerTimeoutErrorResponse

    /**
 * @summary put analytic
 */
export const usePutAnalytic = <TError = Error | AuthorizationErrorResponse | ForbiddenErrorResponse | AnalyticNotFoundResponse | RequestTimeoutResponse | PayloadToLargeResponse | InternalServerErrorResponse | ResponseTimeoutResponse | ServerTimeoutErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof putAnalytic>>, TError,{analyticId: Uuid;data: AnalyticToBeCreated}, TContext>, request?: SecondParameter<typeof lp5AxiosClient>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof putAnalytic>>,
        TError,
        {analyticId: Uuid;data: AnalyticToBeCreated},
        TContext
      > => {
      return useMutation(getPutAnalyticMutationOptions(options), queryClient);
    }

/**
 * Get the analytic documentation by ID.
 * @summary get analytic documentation
 */
export const getAnalyticDoc = (
    analyticId: Uuid,
    params?: GetAnalyticDocParams,
 options?: SecondParameter<typeof lp5AxiosClient>,signal?: AbortSignal
) => {


      return lp5AxiosClient<string>(
      {url: `/6/analytics/${analyticId}/docs`, method: 'GET',
        params, signal
    },
      options);
    }




export const getGetAnalyticDocQueryKey = (analyticId: Uuid,
    params?: GetAnalyticDocParams,) => {
    return [
    `/6/analytics/${analyticId}/docs`, ...(params ? [params] : [])
    ] as const;
    }


export const getGetAnalyticDocQueryOptions = <TData = Awaited<ReturnType<typeof getAnalyticDoc>>, TError = ForbiddenErrorResponse | AnalyticNotFoundResponse | RequestTimeoutResponse | InternalServerErrorResponse | ResponseTimeoutResponse | ServerTimeoutErrorResponse>(analyticId: Uuid,
    params?: GetAnalyticDocParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAnalyticDoc>>, TError, TData>>, request?: SecondParameter<typeof lp5AxiosClient>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetAnalyticDocQueryKey(analyticId,params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getAnalyticDoc>>> = ({ signal }) => getAnalyticDoc(analyticId,params, requestOptions, signal);





   return  { queryKey, queryFn, enabled: analyticId !== null && analyticId !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getAnalyticDoc>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetAnalyticDocQueryResult = NonNullable<Awaited<ReturnType<typeof getAnalyticDoc>>>
export type GetAnalyticDocQueryError = ForbiddenErrorResponse | AnalyticNotFoundResponse | RequestTimeoutResponse | InternalServerErrorResponse | ResponseTimeoutResponse | ServerTimeoutErrorResponse


export function useGetAnalyticDoc<TData = Awaited<ReturnType<typeof getAnalyticDoc>>, TError = ForbiddenErrorResponse | AnalyticNotFoundResponse | RequestTimeoutResponse | InternalServerErrorResponse | ResponseTimeoutResponse | ServerTimeoutErrorResponse>(
 analyticId: Uuid,
    params: undefined |  GetAnalyticDocParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAnalyticDoc>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getAnalyticDoc>>,
          TError,
          Awaited<ReturnType<typeof getAnalyticDoc>>
        > , 'initialData'
      >, request?: SecondParameter<typeof lp5AxiosClient>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetAnalyticDoc<TData = Awaited<ReturnType<typeof getAnalyticDoc>>, TError = ForbiddenErrorResponse | AnalyticNotFoundResponse | RequestTimeoutResponse | InternalServerErrorResponse | ResponseTimeoutResponse | ServerTimeoutErrorResponse>(
 analyticId: Uuid,
    params?: GetAnalyticDocParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAnalyticDoc>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getAnalyticDoc>>,
          TError,
          Awaited<ReturnType<typeof getAnalyticDoc>>
        > , 'initialData'
      >, request?: SecondParameter<typeof lp5AxiosClient>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetAnalyticDoc<TData = Awaited<ReturnType<typeof getAnalyticDoc>>, TError = ForbiddenErrorResponse | AnalyticNotFoundResponse | RequestTimeoutResponse | InternalServerErrorResponse | ResponseTimeoutResponse | ServerTimeoutErrorResponse>(
 analyticId: Uuid,
    params?: GetAnalyticDocParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAnalyticDoc>>, TError, TData>>, request?: SecondParameter<typeof lp5AxiosClient>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary get analytic documentation
 */

export function useGetAnalyticDoc<TData = Awaited<ReturnType<typeof getAnalyticDoc>>, TError = ForbiddenErrorResponse | AnalyticNotFoundResponse | RequestTimeoutResponse | InternalServerErrorResponse | ResponseTimeoutResponse | ServerTimeoutErrorResponse>(
 analyticId: Uuid,
    params?: GetAnalyticDocParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAnalyticDoc>>, TError, TData>>, request?: SecondParameter<typeof lp5AxiosClient>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetAnalyticDocQueryOptions(analyticId,params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}







/**
 * Get options for the resource.
 * @summary analytic docs options
 */
export const getAnalyticDocOptions = (
    analyticId: Uuid,
 options?: SecondParameter<typeof lp5AxiosClient>,signal?: AbortSignal
) => {


      return lp5AxiosClient<void>(
      {url: `/6/analytics/${analyticId}/docs`, method: 'OPTIONS', signal
    },
      options);
    }




export const getGetAnalyticDocOptionsMutationOptions = <TError = RequestTimeoutResponse | InternalServerErrorResponse | ResponseTimeoutResponse | ServerTimeoutErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof getAnalyticDocOptions>>, TError,{analyticId: Uuid}, TContext>, request?: SecondParameter<typeof lp5AxiosClient>}
): UseMutationOptions<Awaited<ReturnType<typeof getAnalyticDocOptions>>, TError,{analyticId: Uuid}, TContext> => {

const mutationKey = ['getAnalyticDocOptions'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof getAnalyticDocOptions>>, {analyticId: Uuid}> = (props) => {
          const {analyticId} = props ?? {};

          return  getAnalyticDocOptions(analyticId,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type GetAnalyticDocOptionsMutationResult = NonNullable<Awaited<ReturnType<typeof getAnalyticDocOptions>>>

    export type GetAnalyticDocOptionsMutationError = RequestTimeoutResponse | InternalServerErrorResponse | ResponseTimeoutResponse | ServerTimeoutErrorResponse

    /**
 * @summary analytic docs options
 */
export const useGetAnalyticDocOptions = <TError = RequestTimeoutResponse | InternalServerErrorResponse | ResponseTimeoutResponse | ServerTimeoutErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof getAnalyticDocOptions>>, TError,{analyticId: Uuid}, TContext>, request?: SecondParameter<typeof lp5AxiosClient>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof getAnalyticDocOptions>>,
        TError,
        {analyticId: Uuid},
        TContext
      > => {
      return useMutation(getGetAnalyticDocOptionsMutationOptions(options), queryClient);
    }

/**
 * Get services.
 * @summary get services
 */
export const getServices = (
    params?: GetServicesParams,
 options?: SecondParameter<typeof lp5AxiosClient>,signal?: AbortSignal
) => {


      return lp5AxiosClient<ServicesResponse>(
      {url: `/6/service`, method: 'GET',
        params, signal
    },
      options);
    }




export const getGetServicesQueryKey = (params?: GetServicesParams,) => {
    return [
    `/6/service`, ...(params ? [params] : [])
    ] as const;
    }


export const getGetServicesQueryOptions = <TData = Awaited<ReturnType<typeof getServices>>, TError = Error | ForbiddenServingServiceResponse | RequestTimeoutResponse | InternalServerErrorResponse | ResponseTimeoutResponse | ServerTimeoutErrorResponse>(params?: GetServicesParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getServices>>, TError, TData>>, request?: SecondParameter<typeof lp5AxiosClient>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetServicesQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getServices>>> = ({ signal }) => getServices(params, requestOptions, signal);





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getServices>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetServicesQueryResult = NonNullable<Awaited<ReturnType<typeof getServices>>>
export type GetServicesQueryError = Error | ForbiddenServingServiceResponse | RequestTimeoutResponse | InternalServerErrorResponse | ResponseTimeoutResponse | ServerTimeoutErrorResponse


export function useGetServices<TData = Awaited<ReturnType<typeof getServices>>, TError = Error | ForbiddenServingServiceResponse | RequestTimeoutResponse | InternalServerErrorResponse | ResponseTimeoutResponse | ServerTimeoutErrorResponse>(
 params: undefined |  GetServicesParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getServices>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getServices>>,
          TError,
          Awaited<ReturnType<typeof getServices>>
        > , 'initialData'
      >, request?: SecondParameter<typeof lp5AxiosClient>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetServices<TData = Awaited<ReturnType<typeof getServices>>, TError = Error | ForbiddenServingServiceResponse | RequestTimeoutResponse | InternalServerErrorResponse | ResponseTimeoutResponse | ServerTimeoutErrorResponse>(
 params?: GetServicesParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getServices>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getServices>>,
          TError,
          Awaited<ReturnType<typeof getServices>>
        > , 'initialData'
      >, request?: SecondParameter<typeof lp5AxiosClient>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetServices<TData = Awaited<ReturnType<typeof getServices>>, TError = Error | ForbiddenServingServiceResponse | RequestTimeoutResponse | InternalServerErrorResponse | ResponseTimeoutResponse | ServerTimeoutErrorResponse>(
 params?: GetServicesParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getServices>>, TError, TData>>, request?: SecondParameter<typeof lp5AxiosClient>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary get services
 */

export function useGetServices<TData = Awaited<ReturnType<typeof getServices>>, TError = Error | ForbiddenServingServiceResponse | RequestTimeoutResponse | InternalServerErrorResponse | ResponseTimeoutResponse | ServerTimeoutErrorResponse>(
 params?: GetServicesParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getServices>>, TError, TData>>, request?: SecondParameter<typeof lp5AxiosClient>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetServicesQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}







/**
 * Get options for the resource.
 * @summary services options
 */
export const getServicesOptions = (

 options?: SecondParameter<typeof lp5AxiosClient>,signal?: AbortSignal
) => {


      return lp5AxiosClient<void>(
      {url: `/6/service`, method: 'OPTIONS', signal
    },
      options);
    }




export const getGetServicesOptionsMutationOptions = <TError = RequestTimeoutResponse | InternalServerErrorResponse | ResponseTimeoutResponse | ServerTimeoutErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof getServicesOptions>>, TError,void, TContext>, request?: SecondParameter<typeof lp5AxiosClient>}
): UseMutationOptions<Awaited<ReturnType<typeof getServicesOptions>>, TError,void, TContext> => {

const mutationKey = ['getServicesOptions'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof getServicesOptions>>, void> = () => {


          return  getServicesOptions(requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type GetServicesOptionsMutationResult = NonNullable<Awaited<ReturnType<typeof getServicesOptions>>>

    export type GetServicesOptionsMutationError = RequestTimeoutResponse | InternalServerErrorResponse | ResponseTimeoutResponse | ServerTimeoutErrorResponse

    /**
 * @summary services options
 */
export const useGetServicesOptions = <TError = RequestTimeoutResponse | InternalServerErrorResponse | ResponseTimeoutResponse | ServerTimeoutErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof getServicesOptions>>, TError,void, TContext>, request?: SecondParameter<typeof lp5AxiosClient>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof getServicesOptions>>,
        TError,
        void,
        TContext
      > => {
      return useMutation(getGetServicesOptionsMutationOptions(options), queryClient);
    }

/**
 * Proxy POST request to service.
 *
 * Described headers will be processed and received independently of service behavior.
 * In case of `bearer` authorization, the token must include permissions for service usage. White list and black list must be specified accordingly
 *
 * For example request to `/6/service/<service_name>/proxy/main` will be proxied to service endpoint `/main`.
 * @summary proxy post request to service
 */
export const serviceProxyPost = (
    serviceName: string,
    serviceProxyPathParameter: string,
 options?: SecondParameter<typeof lp5AxiosClient>,signal?: AbortSignal
) => {


      return lp5AxiosClient<void>(
      {url: `/6/service/${serviceName}/proxy/${serviceProxyPathParameter}`, method: 'POST', signal
    },
      options);
    }




export const getServiceProxyPostMutationOptions = <TError = ForbiddenServingServiceResponse | RequestTimeoutResponse | MethodNotAllowedResponse | InternalServerErrorResponse | ResponseTimeoutResponse | ServerTimeoutErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof serviceProxyPost>>, TError,{serviceName: string;serviceProxyPathParameter: string}, TContext>, request?: SecondParameter<typeof lp5AxiosClient>}
): UseMutationOptions<Awaited<ReturnType<typeof serviceProxyPost>>, TError,{serviceName: string;serviceProxyPathParameter: string}, TContext> => {

const mutationKey = ['serviceProxyPost'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof serviceProxyPost>>, {serviceName: string;serviceProxyPathParameter: string}> = (props) => {
          const {serviceName,serviceProxyPathParameter} = props ?? {};

          return  serviceProxyPost(serviceName,serviceProxyPathParameter,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type ServiceProxyPostMutationResult = NonNullable<Awaited<ReturnType<typeof serviceProxyPost>>>

    export type ServiceProxyPostMutationError = ForbiddenServingServiceResponse | RequestTimeoutResponse | MethodNotAllowedResponse | InternalServerErrorResponse | ResponseTimeoutResponse | ServerTimeoutErrorResponse

    /**
 * @summary proxy post request to service
 */
export const useServiceProxyPost = <TError = ForbiddenServingServiceResponse | RequestTimeoutResponse | MethodNotAllowedResponse | InternalServerErrorResponse | ResponseTimeoutResponse | ServerTimeoutErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof serviceProxyPost>>, TError,{serviceName: string;serviceProxyPathParameter: string}, TContext>, request?: SecondParameter<typeof lp5AxiosClient>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof serviceProxyPost>>,
        TError,
        {serviceName: string;serviceProxyPathParameter: string},
        TContext
      > => {
      return useMutation(getServiceProxyPostMutationOptions(options), queryClient);
    }

/**
 * Proxy GET request to service.
 *
 * Described headers will be processed and received independently of service behavior.
 * In case of `bearer` authorization, the token must include permissions for service usage. White list and black list must be specified accordingly
 *
 * For example request to `/6/service/<service_name>/proxy/main` will be proxied to service endpoint `/main`.
 * @summary proxy get request to service
 */
export const serviceProxyGet = (
    serviceName: string,
    serviceProxyPathParameter: string,
 options?: SecondParameter<typeof lp5AxiosClient>,signal?: AbortSignal
) => {


      return lp5AxiosClient<void>(
      {url: `/6/service/${serviceName}/proxy/${serviceProxyPathParameter}`, method: 'GET', signal
    },
      options);
    }




export const getServiceProxyGetQueryKey = (serviceName: string,
    serviceProxyPathParameter: string,) => {
    return [
    `/6/service/${serviceName}/proxy/${serviceProxyPathParameter}`
    ] as const;
    }


export const getServiceProxyGetQueryOptions = <TData = Awaited<ReturnType<typeof serviceProxyGet>>, TError = ForbiddenServingServiceResponse | RequestTimeoutResponse | MethodNotAllowedResponse | InternalServerErrorResponse | ResponseTimeoutResponse | ServerTimeoutErrorResponse>(serviceName: string,
    serviceProxyPathParameter: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof serviceProxyGet>>, TError, TData>>, request?: SecondParameter<typeof lp5AxiosClient>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getServiceProxyGetQueryKey(serviceName,serviceProxyPathParameter);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof serviceProxyGet>>> = ({ signal }) => serviceProxyGet(serviceName,serviceProxyPathParameter, requestOptions, signal);





   return  { queryKey, queryFn, enabled: serviceName !== null && serviceName !== undefined && serviceProxyPathParameter !== null && serviceProxyPathParameter !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof serviceProxyGet>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ServiceProxyGetQueryResult = NonNullable<Awaited<ReturnType<typeof serviceProxyGet>>>
export type ServiceProxyGetQueryError = ForbiddenServingServiceResponse | RequestTimeoutResponse | MethodNotAllowedResponse | InternalServerErrorResponse | ResponseTimeoutResponse | ServerTimeoutErrorResponse


export function useServiceProxyGet<TData = Awaited<ReturnType<typeof serviceProxyGet>>, TError = ForbiddenServingServiceResponse | RequestTimeoutResponse | MethodNotAllowedResponse | InternalServerErrorResponse | ResponseTimeoutResponse | ServerTimeoutErrorResponse>(
 serviceName: string,
    serviceProxyPathParameter: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof serviceProxyGet>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof serviceProxyGet>>,
          TError,
          Awaited<ReturnType<typeof serviceProxyGet>>
        > , 'initialData'
      >, request?: SecondParameter<typeof lp5AxiosClient>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useServiceProxyGet<TData = Awaited<ReturnType<typeof serviceProxyGet>>, TError = ForbiddenServingServiceResponse | RequestTimeoutResponse | MethodNotAllowedResponse | InternalServerErrorResponse | ResponseTimeoutResponse | ServerTimeoutErrorResponse>(
 serviceName: string,
    serviceProxyPathParameter: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof serviceProxyGet>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof serviceProxyGet>>,
          TError,
          Awaited<ReturnType<typeof serviceProxyGet>>
        > , 'initialData'
      >, request?: SecondParameter<typeof lp5AxiosClient>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useServiceProxyGet<TData = Awaited<ReturnType<typeof serviceProxyGet>>, TError = ForbiddenServingServiceResponse | RequestTimeoutResponse | MethodNotAllowedResponse | InternalServerErrorResponse | ResponseTimeoutResponse | ServerTimeoutErrorResponse>(
 serviceName: string,
    serviceProxyPathParameter: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof serviceProxyGet>>, TError, TData>>, request?: SecondParameter<typeof lp5AxiosClient>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary proxy get request to service
 */

export function useServiceProxyGet<TData = Awaited<ReturnType<typeof serviceProxyGet>>, TError = ForbiddenServingServiceResponse | RequestTimeoutResponse | MethodNotAllowedResponse | InternalServerErrorResponse | ResponseTimeoutResponse | ServerTimeoutErrorResponse>(
 serviceName: string,
    serviceProxyPathParameter: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof serviceProxyGet>>, TError, TData>>, request?: SecondParameter<typeof lp5AxiosClient>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getServiceProxyGetQueryOptions(serviceName,serviceProxyPathParameter,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}







/**
 * Proxy OPTIONS request to service.
 *
 * Described headers will be processed and received independently of service behavior.
 * In case of `bearer` authorization, the token must include permissions for service usage. White list and black list must be specified accordingly
 *
 * For example request to `/6/service/<service_name>/proxy/main` will be proxied to service endpoint `/main`.
 * @summary proxy options request to service
 */
export const serviceProxyOptions = (
    serviceName: string,
    serviceProxyPathParameter: string,
 options?: SecondParameter<typeof lp5AxiosClient>,signal?: AbortSignal
) => {


      return lp5AxiosClient<void>(
      {url: `/6/service/${serviceName}/proxy/${serviceProxyPathParameter}`, method: 'OPTIONS', signal
    },
      options);
    }




export const getServiceProxyOptionsMutationOptions = <TError = ForbiddenServingServiceResponse | RequestTimeoutResponse | MethodNotAllowedResponse | InternalServerErrorResponse | ResponseTimeoutResponse | ServerTimeoutErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof serviceProxyOptions>>, TError,{serviceName: string;serviceProxyPathParameter: string}, TContext>, request?: SecondParameter<typeof lp5AxiosClient>}
): UseMutationOptions<Awaited<ReturnType<typeof serviceProxyOptions>>, TError,{serviceName: string;serviceProxyPathParameter: string}, TContext> => {

const mutationKey = ['serviceProxyOptions'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof serviceProxyOptions>>, {serviceName: string;serviceProxyPathParameter: string}> = (props) => {
          const {serviceName,serviceProxyPathParameter} = props ?? {};

          return  serviceProxyOptions(serviceName,serviceProxyPathParameter,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type ServiceProxyOptionsMutationResult = NonNullable<Awaited<ReturnType<typeof serviceProxyOptions>>>

    export type ServiceProxyOptionsMutationError = ForbiddenServingServiceResponse | RequestTimeoutResponse | MethodNotAllowedResponse | InternalServerErrorResponse | ResponseTimeoutResponse | ServerTimeoutErrorResponse

    /**
 * @summary proxy options request to service
 */
export const useServiceProxyOptions = <TError = ForbiddenServingServiceResponse | RequestTimeoutResponse | MethodNotAllowedResponse | InternalServerErrorResponse | ResponseTimeoutResponse | ServerTimeoutErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof serviceProxyOptions>>, TError,{serviceName: string;serviceProxyPathParameter: string}, TContext>, request?: SecondParameter<typeof lp5AxiosClient>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof serviceProxyOptions>>,
        TError,
        {serviceName: string;serviceProxyPathParameter: string},
        TContext
      > => {
      return useMutation(getServiceProxyOptionsMutationOptions(options), queryClient);
    }

/**
 * Proxy HEAD request to service.
 *
 * Described headers will be processed and received independently of service behavior.
 * In case of `bearer` authorization, the token must include permissions for service usage. White list and black list must be specified accordingly
 *
 * For example request to `/6/service/<service_name>/proxy/main` will be proxied to service endpoint `/main`.
 * @summary proxy head request to service
 */
export const serviceProxyHead = (
    serviceName: string,
    serviceProxyPathParameter: string,
 options?: SecondParameter<typeof lp5AxiosClient>,signal?: AbortSignal
) => {


      return lp5AxiosClient<void>(
      {url: `/6/service/${serviceName}/proxy/${serviceProxyPathParameter}`, method: 'HEAD', signal
    },
      options);
    }




export const getServiceProxyHeadMutationOptions = <TError = ForbiddenServingServiceResponse | RequestTimeoutResponse | MethodNotAllowedResponse | InternalServerErrorResponse | ResponseTimeoutResponse | ServerTimeoutErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof serviceProxyHead>>, TError,{serviceName: string;serviceProxyPathParameter: string}, TContext>, request?: SecondParameter<typeof lp5AxiosClient>}
): UseMutationOptions<Awaited<ReturnType<typeof serviceProxyHead>>, TError,{serviceName: string;serviceProxyPathParameter: string}, TContext> => {

const mutationKey = ['serviceProxyHead'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof serviceProxyHead>>, {serviceName: string;serviceProxyPathParameter: string}> = (props) => {
          const {serviceName,serviceProxyPathParameter} = props ?? {};

          return  serviceProxyHead(serviceName,serviceProxyPathParameter,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type ServiceProxyHeadMutationResult = NonNullable<Awaited<ReturnType<typeof serviceProxyHead>>>

    export type ServiceProxyHeadMutationError = ForbiddenServingServiceResponse | RequestTimeoutResponse | MethodNotAllowedResponse | InternalServerErrorResponse | ResponseTimeoutResponse | ServerTimeoutErrorResponse

    /**
 * @summary proxy head request to service
 */
export const useServiceProxyHead = <TError = ForbiddenServingServiceResponse | RequestTimeoutResponse | MethodNotAllowedResponse | InternalServerErrorResponse | ResponseTimeoutResponse | ServerTimeoutErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof serviceProxyHead>>, TError,{serviceName: string;serviceProxyPathParameter: string}, TContext>, request?: SecondParameter<typeof lp5AxiosClient>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof serviceProxyHead>>,
        TError,
        {serviceName: string;serviceProxyPathParameter: string},
        TContext
      > => {
      return useMutation(getServiceProxyHeadMutationOptions(options), queryClient);
    }

/**
 * Proxy PUT request to service.
 *
 * Described headers will be processed and received independently of service behavior.
 * In case of `bearer` authorization, the token must include permissions for service usage. White list and black list must be specified accordingly
 *
 * For example request to `/6/service/<service_name>/proxy/main` will be proxied to service endpoint `/main`.
 * @summary proxy put request to service
 */
export const serviceProxyPut = (
    serviceName: string,
    serviceProxyPathParameter: string,
 options?: SecondParameter<typeof lp5AxiosClient>,signal?: AbortSignal
) => {


      return lp5AxiosClient<void>(
      {url: `/6/service/${serviceName}/proxy/${serviceProxyPathParameter}`, method: 'PUT', signal
    },
      options);
    }




export const getServiceProxyPutMutationOptions = <TError = ForbiddenServingServiceResponse | RequestTimeoutResponse | MethodNotAllowedResponse | InternalServerErrorResponse | ResponseTimeoutResponse | ServerTimeoutErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof serviceProxyPut>>, TError,{serviceName: string;serviceProxyPathParameter: string}, TContext>, request?: SecondParameter<typeof lp5AxiosClient>}
): UseMutationOptions<Awaited<ReturnType<typeof serviceProxyPut>>, TError,{serviceName: string;serviceProxyPathParameter: string}, TContext> => {

const mutationKey = ['serviceProxyPut'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof serviceProxyPut>>, {serviceName: string;serviceProxyPathParameter: string}> = (props) => {
          const {serviceName,serviceProxyPathParameter} = props ?? {};

          return  serviceProxyPut(serviceName,serviceProxyPathParameter,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type ServiceProxyPutMutationResult = NonNullable<Awaited<ReturnType<typeof serviceProxyPut>>>

    export type ServiceProxyPutMutationError = ForbiddenServingServiceResponse | RequestTimeoutResponse | MethodNotAllowedResponse | InternalServerErrorResponse | ResponseTimeoutResponse | ServerTimeoutErrorResponse

    /**
 * @summary proxy put request to service
 */
export const useServiceProxyPut = <TError = ForbiddenServingServiceResponse | RequestTimeoutResponse | MethodNotAllowedResponse | InternalServerErrorResponse | ResponseTimeoutResponse | ServerTimeoutErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof serviceProxyPut>>, TError,{serviceName: string;serviceProxyPathParameter: string}, TContext>, request?: SecondParameter<typeof lp5AxiosClient>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof serviceProxyPut>>,
        TError,
        {serviceName: string;serviceProxyPathParameter: string},
        TContext
      > => {
      return useMutation(getServiceProxyPutMutationOptions(options), queryClient);
    }

/**
 * Proxy PATCH request to service.
 *
 * Described headers will be processed and received independently of service behavior.
 * In case of `bearer` authorization, the token must include permissions for service usage. White list and black list must be specified accordingly
 *
 * For example request to `/6/service/<service_name>/proxy/main` will be proxied to service endpoint `/main`.
 * @summary proxy patch request to service
 */
export const serviceProxyPatch = (
    serviceName: string,
    serviceProxyPathParameter: string,
 options?: SecondParameter<typeof lp5AxiosClient>,signal?: AbortSignal
) => {


      return lp5AxiosClient<void>(
      {url: `/6/service/${serviceName}/proxy/${serviceProxyPathParameter}`, method: 'PATCH', signal
    },
      options);
    }




export const getServiceProxyPatchMutationOptions = <TError = ForbiddenServingServiceResponse | RequestTimeoutResponse | MethodNotAllowedResponse | InternalServerErrorResponse | ResponseTimeoutResponse | ServerTimeoutErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof serviceProxyPatch>>, TError,{serviceName: string;serviceProxyPathParameter: string}, TContext>, request?: SecondParameter<typeof lp5AxiosClient>}
): UseMutationOptions<Awaited<ReturnType<typeof serviceProxyPatch>>, TError,{serviceName: string;serviceProxyPathParameter: string}, TContext> => {

const mutationKey = ['serviceProxyPatch'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof serviceProxyPatch>>, {serviceName: string;serviceProxyPathParameter: string}> = (props) => {
          const {serviceName,serviceProxyPathParameter} = props ?? {};

          return  serviceProxyPatch(serviceName,serviceProxyPathParameter,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type ServiceProxyPatchMutationResult = NonNullable<Awaited<ReturnType<typeof serviceProxyPatch>>>

    export type ServiceProxyPatchMutationError = ForbiddenServingServiceResponse | RequestTimeoutResponse | MethodNotAllowedResponse | InternalServerErrorResponse | ResponseTimeoutResponse | ServerTimeoutErrorResponse

    /**
 * @summary proxy patch request to service
 */
export const useServiceProxyPatch = <TError = ForbiddenServingServiceResponse | RequestTimeoutResponse | MethodNotAllowedResponse | InternalServerErrorResponse | ResponseTimeoutResponse | ServerTimeoutErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof serviceProxyPatch>>, TError,{serviceName: string;serviceProxyPathParameter: string}, TContext>, request?: SecondParameter<typeof lp5AxiosClient>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof serviceProxyPatch>>,
        TError,
        {serviceName: string;serviceProxyPathParameter: string},
        TContext
      > => {
      return useMutation(getServiceProxyPatchMutationOptions(options), queryClient);
    }

/**
 * Proxy DELETE request to service.
 *
 * Described headers will be processed and received independently of service behavior.
 * In case of `bearer` authorization, the token must include permissions for service usage. White list and black list must be specified accordingly
 *
 * For example request to `/6/service/<service_name>/proxy/main` will be proxied to service endpoint `/main`.
 * @summary proxy delete request to service
 */
export const serviceProxyDelete = (
    serviceName: string,
    serviceProxyPathParameter: string,
 options?: SecondParameter<typeof lp5AxiosClient>,signal?: AbortSignal
) => {


      return lp5AxiosClient<void>(
      {url: `/6/service/${serviceName}/proxy/${serviceProxyPathParameter}`, method: 'DELETE', signal
    },
      options);
    }




export const getServiceProxyDeleteMutationOptions = <TError = ForbiddenServingServiceResponse | RequestTimeoutResponse | MethodNotAllowedResponse | InternalServerErrorResponse | ResponseTimeoutResponse | ServerTimeoutErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof serviceProxyDelete>>, TError,{serviceName: string;serviceProxyPathParameter: string}, TContext>, request?: SecondParameter<typeof lp5AxiosClient>}
): UseMutationOptions<Awaited<ReturnType<typeof serviceProxyDelete>>, TError,{serviceName: string;serviceProxyPathParameter: string}, TContext> => {

const mutationKey = ['serviceProxyDelete'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof serviceProxyDelete>>, {serviceName: string;serviceProxyPathParameter: string}> = (props) => {
          const {serviceName,serviceProxyPathParameter} = props ?? {};

          return  serviceProxyDelete(serviceName,serviceProxyPathParameter,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type ServiceProxyDeleteMutationResult = NonNullable<Awaited<ReturnType<typeof serviceProxyDelete>>>

    export type ServiceProxyDeleteMutationError = ForbiddenServingServiceResponse | RequestTimeoutResponse | MethodNotAllowedResponse | InternalServerErrorResponse | ResponseTimeoutResponse | ServerTimeoutErrorResponse

    /**
 * @summary proxy delete request to service
 */
export const useServiceProxyDelete = <TError = ForbiddenServingServiceResponse | RequestTimeoutResponse | MethodNotAllowedResponse | InternalServerErrorResponse | ResponseTimeoutResponse | ServerTimeoutErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof serviceProxyDelete>>, TError,{serviceName: string;serviceProxyPathParameter: string}, TContext>, request?: SecondParameter<typeof lp5AxiosClient>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof serviceProxyDelete>>,
        TError,
        {serviceName: string;serviceProxyPathParameter: string},
        TContext
      > => {
      return useMutation(getServiceProxyDeleteMutationOptions(options), queryClient);
    }

/**
 * Get statistics of success and failed requests to the service in prometheus format.
 * @summary get service requests statistics
 */
export const metrics = (

 options?: SecondParameter<typeof lp5AxiosClient>,signal?: AbortSignal
) => {


      return lp5AxiosClient<string>(
      {url: `/metrics`, method: 'GET', signal
    },
      options);
    }




export const getMetricsQueryKey = () => {
    return [
    `/metrics`
    ] as const;
    }


export const getMetricsQueryOptions = <TData = Awaited<ReturnType<typeof metrics>>, TError = ForbiddenResourceErrorResponse | RequestTimeoutResponse | InternalServerErrorResponse | ResponseTimeoutResponse | ServerTimeoutErrorResponse>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof metrics>>, TError, TData>>, request?: SecondParameter<typeof lp5AxiosClient>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getMetricsQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof metrics>>> = ({ signal }) => metrics(requestOptions, signal);





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof metrics>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type MetricsQueryResult = NonNullable<Awaited<ReturnType<typeof metrics>>>
export type MetricsQueryError = ForbiddenResourceErrorResponse | RequestTimeoutResponse | InternalServerErrorResponse | ResponseTimeoutResponse | ServerTimeoutErrorResponse


export function useMetrics<TData = Awaited<ReturnType<typeof metrics>>, TError = ForbiddenResourceErrorResponse | RequestTimeoutResponse | InternalServerErrorResponse | ResponseTimeoutResponse | ServerTimeoutErrorResponse>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof metrics>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof metrics>>,
          TError,
          Awaited<ReturnType<typeof metrics>>
        > , 'initialData'
      >, request?: SecondParameter<typeof lp5AxiosClient>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useMetrics<TData = Awaited<ReturnType<typeof metrics>>, TError = ForbiddenResourceErrorResponse | RequestTimeoutResponse | InternalServerErrorResponse | ResponseTimeoutResponse | ServerTimeoutErrorResponse>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof metrics>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof metrics>>,
          TError,
          Awaited<ReturnType<typeof metrics>>
        > , 'initialData'
      >, request?: SecondParameter<typeof lp5AxiosClient>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useMetrics<TData = Awaited<ReturnType<typeof metrics>>, TError = ForbiddenResourceErrorResponse | RequestTimeoutResponse | InternalServerErrorResponse | ResponseTimeoutResponse | ServerTimeoutErrorResponse>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof metrics>>, TError, TData>>, request?: SecondParameter<typeof lp5AxiosClient>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary get service requests statistics
 */

export function useMetrics<TData = Awaited<ReturnType<typeof metrics>>, TError = ForbiddenResourceErrorResponse | RequestTimeoutResponse | InternalServerErrorResponse | ResponseTimeoutResponse | ServerTimeoutErrorResponse>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof metrics>>, TError, TData>>, request?: SecondParameter<typeof lp5AxiosClient>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getMetricsQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}







/**
 * Get health of service (redirect).
 * @summary get health (redirect)
 */
export const healthcheckRedirect = (
    params?: HealthcheckRedirectParams,
 options?: SecondParameter<typeof lp5AxiosClient>,signal?: AbortSignal
) => {


      return lp5AxiosClient<HealthOk>(
      {url: `/healthcheck`, method: 'GET',
        params, signal
    },
      options);
    }




export const getHealthcheckRedirectQueryKey = (params?: HealthcheckRedirectParams,) => {
    return [
    `/healthcheck`, ...(params ? [params] : [])
    ] as const;
    }


export const getHealthcheckRedirectQueryOptions = <TData = Awaited<ReturnType<typeof healthcheckRedirect>>, TError = void | RequestTimeoutResponse | InternalServerErrorResponse | HealthErrors | ResponseTimeoutResponse | ServerTimeoutErrorResponse>(params?: HealthcheckRedirectParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof healthcheckRedirect>>, TError, TData>>, request?: SecondParameter<typeof lp5AxiosClient>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getHealthcheckRedirectQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof healthcheckRedirect>>> = ({ signal }) => healthcheckRedirect(params, requestOptions, signal);





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof healthcheckRedirect>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type HealthcheckRedirectQueryResult = NonNullable<Awaited<ReturnType<typeof healthcheckRedirect>>>
export type HealthcheckRedirectQueryError = void | RequestTimeoutResponse | InternalServerErrorResponse | HealthErrors | ResponseTimeoutResponse | ServerTimeoutErrorResponse


export function useHealthcheckRedirect<TData = Awaited<ReturnType<typeof healthcheckRedirect>>, TError = void | RequestTimeoutResponse | InternalServerErrorResponse | HealthErrors | ResponseTimeoutResponse | ServerTimeoutErrorResponse>(
 params: undefined |  HealthcheckRedirectParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof healthcheckRedirect>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof healthcheckRedirect>>,
          TError,
          Awaited<ReturnType<typeof healthcheckRedirect>>
        > , 'initialData'
      >, request?: SecondParameter<typeof lp5AxiosClient>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useHealthcheckRedirect<TData = Awaited<ReturnType<typeof healthcheckRedirect>>, TError = void | RequestTimeoutResponse | InternalServerErrorResponse | HealthErrors | ResponseTimeoutResponse | ServerTimeoutErrorResponse>(
 params?: HealthcheckRedirectParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof healthcheckRedirect>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof healthcheckRedirect>>,
          TError,
          Awaited<ReturnType<typeof healthcheckRedirect>>
        > , 'initialData'
      >, request?: SecondParameter<typeof lp5AxiosClient>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useHealthcheckRedirect<TData = Awaited<ReturnType<typeof healthcheckRedirect>>, TError = void | RequestTimeoutResponse | InternalServerErrorResponse | HealthErrors | ResponseTimeoutResponse | ServerTimeoutErrorResponse>(
 params?: HealthcheckRedirectParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof healthcheckRedirect>>, TError, TData>>, request?: SecondParameter<typeof lp5AxiosClient>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary get health (redirect)
 */

export function useHealthcheckRedirect<TData = Awaited<ReturnType<typeof healthcheckRedirect>>, TError = void | RequestTimeoutResponse | InternalServerErrorResponse | HealthErrors | ResponseTimeoutResponse | ServerTimeoutErrorResponse>(
 params?: HealthcheckRedirectParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof healthcheckRedirect>>, TError, TData>>, request?: SecondParameter<typeof lp5AxiosClient>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getHealthcheckRedirectQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}







/**
 * Get options for the resource (redirect).
 * @summary healthcheck options (redirect)
 */
export const getHealthcheckOptionsRedirect = (

 options?: SecondParameter<typeof lp5AxiosClient>,signal?: AbortSignal
) => {


      return lp5AxiosClient<void>(
      {url: `/healthcheck`, method: 'OPTIONS', signal
    },
      options);
    }




export const getGetHealthcheckOptionsRedirectMutationOptions = <TError = RequestTimeoutResponse | InternalServerErrorResponse | ResponseTimeoutResponse | ServerTimeoutErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof getHealthcheckOptionsRedirect>>, TError,void, TContext>, request?: SecondParameter<typeof lp5AxiosClient>}
): UseMutationOptions<Awaited<ReturnType<typeof getHealthcheckOptionsRedirect>>, TError,void, TContext> => {

const mutationKey = ['getHealthcheckOptionsRedirect'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof getHealthcheckOptionsRedirect>>, void> = () => {


          return  getHealthcheckOptionsRedirect(requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type GetHealthcheckOptionsRedirectMutationResult = NonNullable<Awaited<ReturnType<typeof getHealthcheckOptionsRedirect>>>

    export type GetHealthcheckOptionsRedirectMutationError = RequestTimeoutResponse | InternalServerErrorResponse | ResponseTimeoutResponse | ServerTimeoutErrorResponse

    /**
 * @summary healthcheck options (redirect)
 */
export const useGetHealthcheckOptionsRedirect = <TError = RequestTimeoutResponse | InternalServerErrorResponse | ResponseTimeoutResponse | ServerTimeoutErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof getHealthcheckOptionsRedirect>>, TError,void, TContext>, request?: SecondParameter<typeof lp5AxiosClient>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof getHealthcheckOptionsRedirect>>,
        TError,
        void,
        TContext
      > => {
      return useMutation(getGetHealthcheckOptionsRedirectMutationOptions(options), queryClient);
    }

